var pr = Object.defineProperty;
var br = (e, t, n) => t in e ? pr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var le = (e, t, n) => (br(e, typeof t != "symbol" ? t + "" : t, n), n);
import { FormBubbleStyle as Er, CardBubbleStyle as hr, CalendarStyle as vr, TimeSlotStyle as mr, SchedulerBubbleStyle as Or, CometChatMentionsFormatter as yo, CometChatUIKitLoginListener as Ct, CometChatUrlsFormatter as Co, ConversationUtils as zo, DetailsUtils as wa, UserMentionStyle as Bo, CallingConfiguration as xr, StorageUtils as an, CometChatUIKitCalls as Ft, CallingDetailsUtils as Go, CallingExtensionDataSource as kr, CollaborativeDocumentConstants as zn, CometChatUIKitUtility as Ce, ExtensionsId as Vn, CollaborativeWhiteboardConstants as Sn, LinkPreviewStyle as fr, LinkPreviewConstants as Ao, MessageTranslationStyle as di, PollsConstants as Io, SmartRepliesConstants as Xi, StickersConstants as On, CometChatSoundManager as Ot, CometChatUIKitSharedSettings as qi, InteractiveMessageUtils as To, OutgoingCallStyle as Ii, CallButtonsStyle as _i, IncomingCallStyle as Ur, UsersStyle as Ci, AddMembersStyle as Br, GroupMemberUtils as Qo, BannedMembersStyle as Qr, ConversationsStyle as Rr, MessageReceiptUtils as ja, MessageInformationStyle as Yr, ReactionsConfiguration as Vr, ListStyle as So, ReactionListStyle as Gr, ReactionListConfiguration as Pr, ReactionInfoStyle as Fr, ReactionInfoConfiguration as Hr, ReactionsStyle as Zr, MessageListStyle as Wr, GroupMembersStyle as Aa, MessageComposerStyle as ea, MessageListConfiguration as La, MessageComposerConfiguration as za, ThreadedMessagesStyle as ta, MessageHeaderStyle as Ni, TransferOwnershipStyle as $r, AddMembersConfiguration as Jr, BannedMembersConfiguration as Kr, GroupMembersConfiguration as Xr, TransferOwnershipConfiguration as qr, DetailsStyle as _r, AIAssistBotConfiguration as el, MessageHeaderConfiguration as tl, ThreadedMessagesConfiguration as nl, DetailsConfiguration as ol, MessagesStyle as il, GroupsStyle as Sa, BaseStyle as al, TabItemStyle as rl, MessagesConfiguration as wi, ConversationsConfiguration as ll, ContactsConfiguration as sl, WithMessagesStyle as ji, UsersConfiguration as pa, GroupsConfiguration as ba, CreateGroupConfiguration as Ml, JoinGroupConfiguration as ul, CallLogDetailsConfiguration as gl, CallLogsConfiguration as cl } from "@cometchat/uikit-shared";
export * from "@cometchat/uikit-shared";
import { CometChatTheme as Ke, CometChatActionsIcon as go, CometChatUIKitConstants as I, localize as Y, fontHelper as w, CometChatMessageTemplate as Mn, MessageBubbleAlignment as gt, CometChatMessageComposerAction as xn, MentionsTargetElement as Ai, CometChatActionsView as Ea, CometChatUIEvents as it, PanelAlignment as qn, CometChatMessageEvents as ae, DocumentIconAlignment as Li, CallWorkflow as Ro, MessageStatus as Xe, Placement as No, CometChatLocalize as dl, ChatSdkEventInitializer as Il, CometChatCallEvents as Jt, IconButtonAlignment as ha, TitleAlignment as kn, States as ge, SelectionMode as xt, UserPresencePlacement as zi, CometChatUserEvents as En, CometChatGroupEvents as He, DatePatterns as yn, FormMessage as va, CardMessage as ma, SchedulerMessage as Oa, CustomInteractiveMessage as xa, CometChatConversationEvents as ka, Receipts as Fo, MessageListAlignment as fo, TimestampAlignment as na, UserMemberListType as Zo, AuxiliaryButtonAlignment as Nl, RecordingType as Tl, PreviewMessageMode as ci, TabAlignment as Lo, TabsVisibility as Po, CometChatCallDetailsTemplate as oa, CometChatCallDetailsOption as Uo } from "@cometchat/uikit-resources";
export * from "@cometchat/uikit-resources";
import { InputStyle as Dl, LabelStyle as fa, RadioButtonStyle as Ua, CheckboxStyle as yl, DropdownStyle as Cl, SingleSelectStyle as wl, QuickViewStyle as ia, AvatarStyle as Kt, ListItemStyle as _t, FileBubbleStyle as jl, CallscreenStyle as $o, PopoverStyle as Al, MenuListStyle as Si, BadgeStyle as Ll, ConfirmDialogStyle as Ti, DateStyle as po, ReceiptStyle as Jo, BackdropStyle as Di, PanelStyle as zl, ContextMenuStyle as Sl, EmojiKeyboardStyle as pl, ChangeScopeStyle as bl, ActionSheetStyle as El, CometChatTextBubble as hl, CreateGroupStyle as vl, JoinGroupStyle as ml } from "@cometchat/uikit-elements";
import { ActionSheetStyle as iS, AvatarStyle as aS, BackdropStyle as rS, BadgeStyle as lS, ButtonGroupStyle as sS, CallscreenStyle as MS, CardStyle as uS, ChangeScopeStyle as gS, CheckboxStyle as cS, CometChatActionItem as dS, CometChatActionSheet as IS, CometChatAvatar as NS, CometChatBackdrop as TS, CometChatBadge as DS, CometChatButton as yS, CometChatButtonGroup as CS, CometChatCallscreenWrapper as wS, CometChatCard as jS, CometChatChangeScope as AS, CometChatCheckbox as LS, CometChatConfirmDialog as zS, CometChatContextMenu as SS, CometChatCreateGroup as pS, CometChatDate as bS, CometChatDivider as ES, CometChatDocumentBubble as hS, CometChatDraggable as vS, CometChatDropdown as mS, CometChatEmoji as OS, CometChatEmojiKeyboard as xS, CometChatFullScreenViewer as kS, CometChatIcon as fS, CometChatIconButton as US, CometChatInput as BS, CometChatJoinGroup as QS, CometChatLabel as RS, CometChatListItem as YS, CometChatLiveReaction as VS, CometChatLoader as GS, CometChatMediaRecorder as PS, CometChatMenuList as FS, CometChatMessageInput as HS, CometChatModal as ZS, CometChatPopover as WS, CometChatPreview as $S, CometChatQuickView as JS, CometChatRadioButton as KS, CometChatReceipt as XS, CometChatSearchInput as qS, CometChatSingleSelect as _S, CometChatStatusIndicator as ep, ConfirmDialogStyle as tp, ContextMenuStyle as np, CreateGroupStyle as op, DateStyle as ip, DocumentBubbleStyle as ap, DropdownStyle as rp, EmojiKeyboardStyle as lp, Emojis as sp, FileBubbleStyle as Mp, FullScreenViewerStyle as up, IconStyle as gp, ImageBubbleStyle as cp, InputStyle as dp, JoinGroupStyle as Ip, LabelStyle as Np, ListItemStyle as Tp, LoaderStyle as Dp, MediaRecorderStyle as yp, MenuListStyle as Cp, MessageInputStyle as wp, ModalStyle as jp, PopoverStyle as Ap, PreviewStyle as Lp, QuickViewStyle as zp, RadioButtonStyle as Sp, ReceiptStyle as pp, SearchInputStyle as bp, SingleSelectStyle as Ep, TextBubbleStyle as hp, TextInputStyle as vp, auxiliaryButtonAlignmentEnum as mp, layoutType as Op } from "@cometchat/uikit-elements";
import { CometChat as y } from "@cometchat/chat-sdk-javascript";
import { defineComponent as We, ref as j, onBeforeMount as Zt, watch as bn, openBlock as M, createElementBlock as g, createElementVNode as p, createCommentVNode as $, inject as dt, onMounted as tn, onUpdated as Ko, onBeforeUnmount as un, normalizeStyle as ce, createBlock as je, resolveDynamicComponent as fe, mergeProps as me, toHandlers as xe, withCtx as be, Fragment as we, renderList as pe, resolveComponent as Je, createVNode as Nt, nextTick as pn, computed as Ht, toDisplayString as kt, withDirectives as Kn, vShow as Xn, createTextVNode as pi, renderSlot as Ol, createSlots as Ho, normalizeProps as aa, normalizeClass as _n, reactive as bi, onUnmounted as Xo, onBeforeUpdate as eo, getCurrentInstance as xl, KeepAlive as kl } from "vue";
const mz = "data:image/svg+xml;base64,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", fl = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgdmVyc2lvbj0iMS4wIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAuMDAwMDAwcHQiIGhlaWdodD0iMTAwLjAwMDAwMHB0IiB2aWV3Qm94PSIwIDAgMTAwLjAwMDAwMCAxMDAuMDAwMDAwIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCBtZWV0Ij4KICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwxMDAuMDAwMDAwKSBzY2FsZSgwLjEwMDAwMCwtMC4xMDAwMDApIiBmaWxsPSIjMDAwMDAwIiBzdHJva2U9Im5vbmUiPgogICAgPHBhdGggZD0iTTcyNyA4NTQgYy00IC00IC03IC0xNSAtNyAtMjQgMCAtMjEgLTI4IC00NyAtNTUgLTUyIC0xNCAtMiAtMjAgLTExIC0yMCAtMjggMCAtMTcgNiAtMjYgMjAgLTI4IDI4IC02IDUzIC0zMCA1NyAtNTYgMiAtMTUgMTAgLTIxIDI4IC0yMSAxOCAwIDI2IDYgMjggMjEgNCAyNiAyOSA1MCA1NyA1NiAyOSA1IDI4IDUyIC0xIDU2IC0yNiA0IC01MSAyOSAtNTYgNTcgLTMgMjAgLTM3IDMyIC01MSAxOXoiLz4KICAgIDxwYXRoIGQ9Ik0zNTAgNzYxIGMtNSAtMTEgLTEwIC0zMiAtMTAgLTQ4IC0xIC03NCAtODYgLTE2MCAtMTc4IC0xNzggLTUwIC0xMCAtNTcgLTE0IC01NyAtMzYgMCAtMjAgNiAtMjUgNDIgLTMxIDExNyAtMjAgMTcwIC03NiAxOTggLTIxMSAxMiAtNTggNjUgLTM4IDY1IDI1IDAgODQgODggMTY4IDE5MyAxODYgMzYgNiA0MiAxMSA0MiAzMSAwIDIyIC03IDI2IC01NiAzNiAtOTEgMTggLTE2MiA4NCAtMTc1IDE2NSAtMTIgNzYgLTQxIDEwNCAtNjQgNjF6IG04MCAtMjEyIGMxNCAtMTQgMzMgLTMwIDQzIC0zNSAxNSAtOSAxMCAtMTcgLTQwIC02OSBsLTU4IC02MCAtNTcgNTkgYy01NyA1OSAtNTcgNjAgLTM1IDc1IDMwIDIwIDg3IDgyIDg4IDk1IDAgNiA4IDAgMTcgLTE0IDkgLTE0IDI4IC0zNyA0MiAtNTF6Ii8+CiAgICA8cGF0aCBkPSJNNzI3IDM1NCBjLTQgLTQgLTcgLTE1IC03IC0yNCAwIC0yMSAtMjggLTQ3IC01NSAtNTIgLTE0IC0yIC0yMCAtMTEgLTIwIC0yOCAwIC0xNyA2IC0yNiAyMCAtMjggMjggLTYgNTMgLTMwIDU3IC01NiA0IC0zMCA1MiAtMzAgNTYgMCA0IDI2IDI5IDUwIDU3IDU2IDI5IDUgMjggNTIgLTEgNTYgLTI2IDQgLTUxIDI5IC01NiA1NyAtMyAyMCAtMzcgMzIgLTUxIDE5eiIvPgogIDwvZz4KPC9zdmc+Cg==", bo = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDIwMDEwOTA0Ly9FTiIKICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiB3aWR0aD0iMTAwLjAwMDAwMHB0IiBoZWlnaHQ9IjEwMC4wMDAwMDBwdCIgdmlld0JveD0iMCAwIDEwMC4wMDAwMDAgMTAwLjAwMDAwMCIKIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiPgoKPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsMTAwLjAwMDAwMCkgc2NhbGUoMC4xMDAwMDAsLTAuMTAwMDAwKSIKZmlsbD0iIzAwMDAwMCIgc3Ryb2tlPSJub25lIj4KPHBhdGggZD0iTTM3NSA4NDcgYy0yMjEgLTczIC0zMjYgLTI2OSAtMjU0IC00NzIgbDIyIC02MiAtMjUgLTc0IGMtMTQgLTQxCi0yMyAtODAgLTIxIC04NiA2IC0xNyA0MiAtMTUgMTM4IDYgNzcgMTcgODIgMTcgMTM4IC0xIDkxIC0yOCAyNTcgLTIwIDI3OCAxMwoxMiAyMCAtOSA1MiAtMjkgNDQgLTkgLTQgLTUxIC0xMCAtOTQgLTEyIC01OSAtNCAtOTIgLTEgLTE0NSAxNSAtNjMgMTkgLTcyCjIwIC0xMjggNyAtODggLTIxIC04NyAtMjMgLTY0IDQyIGwyMCA1OCAtMjYgNTYgYy01MiAxMTYgLTI1IDI0MCA2OSAzMjcgNzcKNzEgMTIzIDg3IDI0NiA4NyA4NyAwIDExMyAtNCAxNTIgLTIyIDEwMSAtNDcgMTg4IC0xNjAgMTg4IC0yNDYgMCAtNjkgMzYKLTEwMiA2MSAtNTYgOCAxNiA4IDM3IC0xIDgzIC0yNCAxMjIgLTk2IDIxMiAtMjE4IDI2OSAtNTkgMjggLTc5IDMyIC0xNjcgMzQKLTYzIDIgLTExNSAtMiAtMTQwIC0xMHoiLz4KPHBhdGggZD0iTTc2NCAzNDcgYy0yIC04IC00IC00NyAtMiAtODggMyAtNzEgNCAtNzQgMjggLTc0IDI1IDAgMjUgMSAyNSA4NSAwCjgxIC0xIDg1IC0yMyA4OCAtMTIgMiAtMjQgLTMgLTI4IC0xMXoiLz4KPHBhdGggZD0iTTc2NCA5NSBjLTQgLTkgMCAtMjMgOCAtMzEgMjAgLTIwIDUwIC03IDQ2IDIwIC00IDI2IC00NSAzNSAtNTQgMTF6Ii8+CjwvZz4KPC9zdmc+Cg==", Oz = "data:image/svg+xml;base64,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", Ul = "data:image/svg+xml;base64,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", Ba = "data:image/svg+xml;base64,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", Bl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0xIDVDMSAzLjg5NTQzIDEuODk1NDMgMyAzIDNIMjEuNUMyMi42MDQ2IDMgMjMuNSAzLjg5NTQzIDIzLjUgNVYxOUMyMy41IDIwLjEwNDYgMjIuNjA0NiAyMSAyMS41IDIxSDNDMS44OTU0MyAyMSAxIDIwLjEwNDYgMSAxOVY1WiIgc3Ryb2tlPSIjODA4MDgwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05IDE1LjVDOSAxNS44OTc4IDkuMTU4MDMgMTYuMjc5NCA5LjQzOTM0IDE2LjU2MDdDOS43MjA2NCAxNi44NDIgMTAuMTAyMiAxNyAxMC41IDE3QzEwLjg5NzggMTcgMTEuMjc5NCAxNi44NDIgMTEuNTYwNyAxNi41NjA3QzExLjg0MiAxNi4yNzk0IDEyIDE1Ljg5NzggMTIgMTUuNUMxMiAxNS4xMDIyIDExLjg0MiAxNC43MjA2IDExLjU2MDcgMTQuNDM5M0MxMS4yNzk0IDE0LjE1OCAxMC44OTc4IDE0IDEwLjUgMTRDMTAuMTAyMiAxNCA5LjcyMDY0IDE0LjE1OCA5LjQzOTM0IDE0LjQzOTNDOS4xNTgwMyAxNC43MjA2IDkgMTUuMTAyMiA5IDE1LjVaIiBzdHJva2U9IiM4MDgwODAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyIDE1VjdMMTQuNzE0MSA5LjI3NTY2QzE1LjM2NTcgOS44MjEzMyAxNS43OTU3IDEwLjUyNTEgMTUuOTQzMyAxMS4yODcxQzE2LjA5MDkgMTIuMDQ5MSAxNS45NDg2IDEyLjgzMDcgMTUuNTM2NSAxMy41MjExIiBzdHJva2U9IiM4MDgwODAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", fn = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvYmFja2J1dHRvbjwvdGl0bGU+CiAgICA8ZyBpZD0iSWNvbnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9Ikljb25zLzI0L0JhY2siIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMuMDAwMDAwLCAzLjI1MDAwMCkiPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjE4Ljc1IiB5MT0iOC43NSIgeDI9IjAiIHkyPSI4Ljc1IiBpZD0iUGF0aCI+PC9saW5lPgogICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJQYXRoIiBwb2ludHM9IjguNzUgMCAwIDguNzUgOC43NSAxNy41Ij48L3BvbHlsaW5lPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=", xz = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+IDxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNjQgNjQiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMzUzNTNkO308L3N0eWxlPjwvZGVmcz48dGl0bGU+QXNzZXQgNzQ8L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNTYsMEg4QTgsOCwwLDAsMCwwLDhWNjEuMzNhMi42OCwyLjY4LDAsMCwwLDEuNTUsMi40M0EyLjc1LDIuNzUsMCwwLDAsMi42Nyw2NGEyLjY3LDIuNjcsMCwwLDAsMS43My0uNjRMMjAuMDcsNDkuOTNBOCw4LDAsMCwxLDI1LjI4LDQ4SDU2YTgsOCwwLDAsMCw4LThWOEE4LDgsMCwwLDAsNTYsMFptMi42Nyw0MEEyLjY4LDIuNjgsMCwwLDEsNTYsNDIuNjdIMjUuMjhhMTMuMzYsMTMuMzYsMCwwLDAtOC42OCwzLjIxTDUuMzMsNTUuNTRWOEEyLjY4LDIuNjgsMCwwLDEsOCw1LjMzSDU2QTIuNjgsMi42OCwwLDAsMSw1OC42Nyw4WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTQ1LjMzLDE1LjY5SDE4LjY3YTIuNjcsMi42NywwLDEsMCwwLDUuMzNINDUuMzNhMi42NywyLjY3LDAsMSwwLDAtNS4zM1oiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik00NS4zMywyNi4zNkgxOC42N2EyLjY3LDIuNjcsMCwxLDAsMCw1LjMzSDQ1LjMzYTIuNjcsMi42NywwLDEsMCwwLTUuMzNaIi8+PC9nPjwvZz48L3N2Zz4=", kz = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvQ2hlY2ttYXJrIEVtcHR5QDJ4PC90aXRsZT4KICAgIDxnIGlkPSJJY29ucyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8ZyBpZD0iSWNvbnMvMjQvQ2hlY2ttYXJrLUVtcHR5IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41Ij4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzLjAwMDAwMCwgMy4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLDkgQzAsMTMuOTcwNTYyNyA0LjAyOTQzNzI1LDE4IDksMTggQzEzLjk3MDU2MjcsMTggMTgsMTMuOTcwNTYyNyAxOCw5IEMxOCw0LjAyOTQzNzI1IDEzLjk3MDU2MjcsMCA5LDAgQzQuMDI5NDM3MjUsMCAwLDQuMDI5NDM3MjUgMCw5IFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==", Cn = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvQ2xvc2U8L3RpdGxlPgogICAgPGcgaWQ9Ikljb25zIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSJJY29ucy8yNC9DbG9zZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS4wMDAwMDAsIDUuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iMCIgeTE9IjAiIHgyPSIxNCIgeTI9IjE0IiBpZD0iUGF0aC05Ij48L2xpbmU+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iMCIgeTE9IjAiIHgyPSIxNCIgeTI9IjE0IiBpZD0iUGF0aC05IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjAwMDAwMCwgNy4wMDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTcuMDAwMDAwLCAtNy4wMDAwMDApICI+PC9saW5lPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=", Ql = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvQ2xvc2U8L3RpdGxlPgogICAgPGcgaWQ9Ikljb25zIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSJJY29ucy8yNC9DbG9zZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS4wMDAwMDAsIDUuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iMCIgeTE9IjAiIHgyPSIxNCIgeTI9IjE0IiBpZD0iUGF0aC05Ij48L2xpbmU+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iMCIgeTE9IjAiIHgyPSIxNCIgeTI9IjE0IiBpZD0iUGF0aC05IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjAwMDAwMCwgNy4wMDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTcuMDAwMDAwLCAtNy4wMDAwMDApICI+PC9saW5lPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=", Rl = "data:image/svg+xml;base64,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", ra = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvUGx1czwvdGl0bGU+CiAgICA8ZyBpZD0iSWNvbnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9Ikljb25zLzI0L1BsdXMiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMuMDAwMDAwLCAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjkiIHkxPSIwIiB4Mj0iOSIgeTI9IjE4IiBpZD0iUGF0aC0xMCI+PC9saW5lPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjAiIHkxPSI5IiB4Mj0iMTgiIHkyPSI5IiBpZD0iUGF0aC0xMSI+PC9saW5lPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=", Qa = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvZGVsZXRlaWNvbjwvdGl0bGU+CiAgICA8ZyBpZD0iSWNvbnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9Ikljb25zLzI0L0RlbGV0ZSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4wMDAwMDAsIDIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iMCIgeTE9IjMuNjM2MzYyNyIgeDI9IjIwIiB5Mj0iMy42MzYzNjI3IiBpZD0iUGF0aCI+PC9saW5lPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTEyLjA0NTQ1NDUsMCBMNy45NTQ1NDU0NSwwIEM3LjIwMTQyOTg5LDAgNi41OTA5MDkwOSwwLjYxMDUyMDYzOSA2LjU5MDkwOTA5LDEuMzYzNjM2MDEgTDYuNTkwOTA5MDksMy42MzYzNjI3IEwxMy40MDkwOTA5LDMuNjM2MzYyNyBMMTMuNDA5MDkwOSwxLjM2MzYzNjAxIEMxMy40MDkwOTA5LDAuNjEwNTIwNjM5IDEyLjc5ODU3MDEsMCAxMi4wNDU0NTQ1LDAgWiIgaWQ9IlBhdGgiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxsaW5lIHgxPSI3Ljk1NDU0NTQ1IiB5MT0iMTUuMjI3MjY4OCIgeDI9IjcuOTU0NTQ1NDUiIHkyPSI4LjQwOTA4ODc1IiBpZD0iUGF0aCI+PC9saW5lPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjEyLjA0NTQ1NDUiIHkxPSIxNS4yMjcyNjg4IiB4Mj0iMTIuMDQ1NDU0NSIgeTI9IjguNDA5MDg4NzUiIGlkPSJQYXRoIj48L2xpbmU+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTYuMjM2MzYzNiwxOC43NDU0NDk3IEMxNi4xODM4OTY4LDE5LjQ1NDIzMzkgMTUuNTkyNTM5MSwyMC4wMDE5MzQxIDE0Ljg4MTgxODIsMjAgTDUuMTE4MTgxODIsMjAgQzQuNDA3NDYwODgsMjAuMDAxOTM0MSAzLjgxNjEwMzI0LDE5LjQ1NDIzMzkgMy43NjM2MzYzNiwxOC43NDU0NDk3IEwyLjUsMy42MzYzNjI3IEwxNy41LDMuNjM2MzYyNyBMMTYuMjM2MzYzNiwxOC43NDU0NDk3IFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==", Ei = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC44Ij4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjE1MTQ3IDMuMTUyNjJDOS4zMjUyOCAyLjkzODA0IDkuMjkyMjQgMi42MjMxOSA5LjA3NzY2IDIuNDQ5MzhDOC44NjMwOCAyLjI3NTU3IDguNTQ4MjIgMi4zMDg2MSA4LjM3NDQxIDIuNTIzMTlMMy42MTQxNCA4LjM5OTk4TDEuNjI2IDYuNDI0OTRDMS40MzAxIDYuMjMwMzIgMS4xMTM1MiA2LjIzMTM3IDAuOTE4OTAxIDYuNDI3MjdDMC43MjQyODUgNi42MjMxOCAwLjcyNTMzMSA2LjkzOTc2IDAuOTIxMjM4IDcuMTM0MzhMMy4zMDE5NyA5LjQ5OTQyQzMuNDAyMjkgOS41OTkwOCAzLjU0MDEyIDkuNjUxNiAzLjY4MTMxIDkuNjQzOThDMy44MjI1MSA5LjYzNjM1IDMuOTUzODggOS41NjkzIDQuMDQyODkgOS40NTk0Mkw5LjE1MTQ3IDMuMTUyNjJaTTEzLjA4MTQgMy4xNjY2M0MxMy4yNjMgMi45NTg1NSAxMy4yNDE1IDIuNjQyNyAxMy4wMzM0IDIuNDYxMTVDMTIuODI1MyAyLjI3OTYxIDEyLjUwOTUgMi4zMDExMSAxMi4zMjc5IDIuNTA5MTlMNy4xNzM1OCA4LjQxNjY3TDYuNzQ3OTQgNy45OTkzNEM2LjU1MDc3IDcuODA2MDEgNi4yMzQyIDcuODA5MTIgNi4wNDA4NyA4LjAwNjNDNS44NDc1NCA4LjIwMzQ4IDUuODUwNjYgOC41MjAwNCA2LjA0NzgzIDguNzEzMzdMNi44NTE4NyA5LjUwMTcyQzYuOTUwMTYgOS41OTgwOSA3LjA4MzgzIDkuNjQ5NjggNy4yMjEzOCA5LjY0NDMzQzcuMzU4OTIgOS42Mzg5NyA3LjQ4ODE4IDkuNTc3MTUgNy41Nzg2OCA5LjQ3MzQzTDEzLjA4MTQgMy4xNjY2M1oiIGZpbGw9IiM5QzlDQTMiLz4KPC9nPgo8L3N2Zz4K", Ra = "data:image/svg+xml;base64,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", Yl = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMyIDMyIiAgaWQ9ItCh0LvQvtC5XzEiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDMyIDMyIiAgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PHBhdGggZD0iTTI0LjI4NSwxMS4yODRMMTYsMTkuNTcxbC04LjI4NS04LjI4OGMtMC4zOTUtMC4zOTUtMS4wMzQtMC4zOTUtMS40MjksMCAgYy0wLjM5NCwwLjM5NS0wLjM5NCwxLjAzNSwwLDEuNDNsOC45OTksOS4wMDJsMCwwbDAsMGMwLjM5NCwwLjM5NSwxLjAzNCwwLjM5NSwxLjQyOCwwbDguOTk5LTkuMDAyICBjMC4zOTQtMC4zOTUsMC4zOTQtMS4wMzYsMC0xLjQzMUMyNS4zMTksMTAuODg5LDI0LjY3OSwxMC44ODksMjQuMjg1LDExLjI4NHoiIGZpbGw9IiMxMjEzMTMiIGlkPSJFeHBhbmRfTW9yZSIvPjxnLz48Zy8+PGcvPjxnLz48Zy8+PGcvPjwvc3ZnPg==", Ya = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvRG93bmxvYWQ8L3RpdGxlPgogICAgPGcgaWQ9Ikljb25zIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSJJY29ucy8yNC9Eb3dubG9hZCIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wMDAwMDAsIDEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlBhdGgiIHBvaW50cz0iNy4zMzMzMzMzMyAxMy4yIDExIDE2Ljg2NjY2NjcgMTQuNjY2NjY2NyAxMy4yIj48L3BvbHlsaW5lPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjExIiB5MT0iNS44NjY2NjY2NyIgeDI9IjExIiB5Mj0iMTYuODY2NjY2NyIgaWQ9IlBhdGgiPjwvbGluZT4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLDExIEMwLDE3LjA3NTEzMjIgNC45MjQ4Njc3NSwyMiAxMSwyMiBDMTcuMDc1MTMyMiwyMiAyMiwxNy4wNzUxMzIyIDIyLDExIEMyMiw0LjkyNDg2Nzc1IDE3LjA3NTEzMjIsMCAxMSwwIEM0LjkyNDg2Nzc1LDAgMCw0LjkyNDg2Nzc1IDAsMTEgWiIgaWQ9IlBhdGgiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+", Vl = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvZWRpdGljb248L3RpdGxlPgogICAgPGcgaWQ9Ikljb25zIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSJJY29ucy8yNC9FZGl0IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41Ij4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzLjAwMDAwMCwgMy4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNy44NjY2NjY3LDAuODgzNTU1Mjg3IEMxNy4yOTM0NDAzLDAuMzEyNjc5MzI5IDE2LjUxNTgyMTQsLTAuMDA1NDA4MTU3NTYgMTUuNzA2ODM1NywwIEMxNC44OTc4NTAxLDAuMDA1NTQ3MzQ1NzUgMTQuMTI0NjA5OSwwLjMzNDEzNTkwOSAxMy41NTkxNjY3LDAuOTEyNzIxOTU0IEwxLjQ3NTgzMzMzLDEyLjk5NjA1NTMgTDAsMTguNzUwMjIyIEw1Ljc1NDE2NjY3LDE3LjI3NDM4ODYgTDE3LjgzNzUsNS4xOTEwNTUyOSBDMTguNDE2MDg2LDQuNjI1NjEyMSAxOC43NDQ2NzQ2LDMuODUyMzcxOSAxOC43NTAyMjIsMy4wNDMzODYyMyBDMTguNzU1NjMwMSwyLjIzNDQwMDU3IDE4LjQzNzU0MjYsMS40NTY3ODE2NCAxNy44NjY2NjY3LDAuODgzNTU1Mjg3IFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iMTMuMjEzMzMzMyIgeTE9IjEuMjU4NTU1MjkiIHgyPSIxNy40OTE2NjY3IiB5Mj0iNS41MzY4ODg2MiIgaWQ9IlBhdGgiPjwvbGluZT4KICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIxMS40NjgzMzMzIiB5MT0iMy4wMDM1NTUyOSIgeDI9IjE1Ljc0NjY2NjciIHkyPSI3LjI4MTg4ODYyIiBpZD0iUGF0aCI+PC9saW5lPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjEuNDc1ODMzMzMiIHkxPSIxMi45OTYwNTUzIiB4Mj0iNS43NTgzMzMzMyIgeTI9IjE3LjI3MDIyMiIgaWQ9IlBhdGgiPjwvbGluZT4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+", Gl = "data:image/svg+xml;base64,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", Pl = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvQXR0YWNobWVudCBGaWxlPC90aXRsZT4KICAgIDxnIGlkPSJJY29ucyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8ZyBpZD0iSWNvbnMvMjQvQXR0YWNobWVudC1GaWxlIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41Ij4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjAwMDAwMCwgMy4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik05LjMzMzMzMzMzLDE0LjY2NjY2NjcgQzkuMzMzMzMzMzMsMTcuNjEyMTg1MyAxMS43MjExNDgsMjAgMTQuNjY2NjY2NywyMCBDMTcuNjEyMTg1MywyMCAyMCwxNy42MTIxODUzIDIwLDE0LjY2NjY2NjcgQzIwLDExLjcyMTE0OCAxNy42MTIxODUzLDkuMzMzMzMzMzMgMTQuNjY2NjY2Nyw5LjMzMzMzMzMzIEMxMS43MjExNDgsOS4zMzMzMzMzMyA5LjMzMzMzMzMzLDExLjcyMTE0OCA5LjMzMzMzMzMzLDE0LjY2NjY2NjcgWiIgaWQ9IlBhdGgiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIxNC42NjY2NjY3IiB5MT0iMTIiIHgyPSIxNC42NjY2NjY3IiB5Mj0iMTcuMzMzMzMzMyIgaWQ9IlBhdGgiPjwvbGluZT4KICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIxMiIgeTE9IjE0LjY2NjY2NjciIHgyPSIxNy4zMzMzMzMzIiB5Mj0iMTQuNjY2NjY2NyIgaWQ9IlBhdGgiPjwvbGluZT4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik02LDE3LjMzMzMzMzMgTDEuMzMzMzMzMzMsMTcuMzMzMzMzMyBDMC41OTY5NTM2NjcsMTcuMzMzMzMzMyAwLDE2LjczNjM3OTcgMCwxNiBMMCwxLjMzMzMzMzMzIEMwLDAuNTk2OTUzNjY3IDAuNTk2OTUzNjY3LDAgMS4zMzMzMzMzMywwIEwxMC43ODEzMzMzLDAgQzExLjEzNDcwODYsMCAxMS40NzM2MDE0LDAuMTQwNDI4MjI0IDExLjcyMzU1NTYsMC4zOTAyMjIyMjIgTDE0LjI3NjQ0NDQsMi45NDMxMTExMSBDMTQuNTI2MjM4NCwzLjE5MzA2NTIzIDE0LjY2NjY2NjcsMy41MzE5NTgwNCAxNC42NjY2NjY3LDMuODg1MzMzMzMgTDE0LjY2NjY2NjcsNiIgaWQ9IlBhdGgiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+", fz = "data:image/svg+xml;base64,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", Uz = "data:image/svg+xml;base64,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", Bz = "data:image/svg+xml;base64,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", Qz = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMjIuMS4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNTAgNTAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUwIDUwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnIGlkPSJMYXllcl8xIj4KCTxwYXRoIGQ9Ik0zNS44MzUsMjAuNTc5QzM4LjMzNSwxOC45NzgsNDAsMTYuMTgzLDQwLDEzYzAtNC45NjMtNC4wMzgtOS05LTljLTAuODU3LDAtMS43MDUsMC4xMjgtMi41MzEsMC4zNzMKCQlDMjYuNjM1LDIuMzEsMjMuOTcxLDEsMjEsMWMtNS41MTQsMC0xMCw0LjQ4Ni0xMCwxMGMwLDMuNDMxLDEuNzM5LDYuNDY0LDQuMzgsOC4yNjVDOS40NjMsMjAuNDgxLDUsMjUuNzI5LDUsMzJ2MTdoMzJ2LTRoOFYzMwoJCUM0NSwyNy4xNjYsNDEuMTM3LDIyLjIxOSwzNS44MzUsMjAuNTc5eiBNMjkuNzIyLDYuMTJDMzAuMTQ0LDYuMDQsMzAuNTcxLDYsMzEsNmMzLjg2LDAsNywzLjE0MSw3LDdzLTMuMTQsNy03LDcKCQljLTEuMzczLDAtMi42OTUtMC40LTMuODI2LTEuMTQ0YzAuMDE1LTAuMDEyLDAuMDI3LTAuMDI1LDAuMDQyLTAuMDM3YzAuODU4LTAuNjg0LDEuNTk5LTEuNTA1LDIuMTk1LTIuNDMxCgkJYzAuMDIzLTAuMDM2LDAuMDQ0LTAuMDc0LDAuMDY3LTAuMTFjMC4xNjgtMC4yNjksMC4zMjQtMC41NDYsMC40NjYtMC44MzJjMC4wMjYtMC4wNTMsMC4wNTItMC4xMDcsMC4wNzctMC4xNgoJCWMwLjEzLTAuMjcyLDAuMjQ3LTAuNTUxLDAuMzUzLTAuODM2YzAuMDI0LTAuMDY0LDAuMDQ4LTAuMTI4LDAuMDcxLTAuMTkzYzAuMDk2LTAuMjc2LDAuMTc3LTAuNTU3LDAuMjQ5LTAuODQ0CgkJYzAuMDE5LTAuMDc0LDAuMDQtMC4xNDgsMC4wNTctMC4yMjJjMC4wNjMtMC4yODIsMC4xMTItMC41NjksMC4xNS0wLjg2YzAuMDExLTAuMDc4LDAuMDI3LTAuMTU0LDAuMDM1LTAuMjMyCgkJQzMwLjk3NiwxMS43MzksMzEsMTEuMzcyLDMxLDExYzAtMC4zOTYtMC4wMjktMC43ODUtMC4wNzQtMS4xNjljLTAuMDE0LTAuMTIxLTAuMDM3LTAuMjQtMC4wNTUtMC4zNjEKCQljLTAuMDQyLTAuMjctMC4wOTItMC41MzYtMC4xNTUtMC43OThjLTAuMDMtMC4xMjYtMC4wNjItMC4yNTEtMC4wOTctMC4zNzVjLTAuMDgyLTAuMjkxLTAuMTc3LTAuNTc1LTAuMjg0LTAuODU1CgkJYy0wLjAyOS0wLjA3NS0wLjA1Mi0wLjE1Mi0wLjA4My0wLjIyN2MtMC4xNTItMC4zNzEtMC4zMjYtMC43My0wLjUyLTEuMDc3QzI5LjcyOCw2LjEzMiwyOS43MjUsNi4xMjYsMjkuNzIyLDYuMTJ6IE0xMywxMQoJCWMwLTQuNDExLDMuNTg5LTgsOC04YzIuNDc3LDAsNC42OTMsMS4xMzIsNi4xNjIsMi45MDRsMC4wNjQsMC4wODNjMC4wNDksMC4wNiwwLjA5MiwwLjEyNSwwLjEzOSwwLjE4NgoJCWMwLjUwOCwwLjY2OSwwLjg5NywxLjM5OCwxLjE3MSwyLjE2N2MwLjAxOSwwLjA1MywwLjA0LDAuMTA0LDAuMDU3LDAuMTU3YzAuMTE5LDAuMzU3LDAuMjA4LDAuNzI0LDAuMjc1LDEuMDk2CgkJYzAuMDE0LDAuMDc5LDAuMDI1LDAuMTU5LDAuMDM3LDAuMjM5QzI4Ljk2MSwxMC4yMTcsMjksMTAuNjA1LDI5LDExYzAsMC4zMjgtMC4wMjUsMC42NTItMC4wNjUsMC45NzMKCQljLTAuMDA5LDAuMDc2LTAuMDIzLDAuMTUtMC4wMzQsMC4yMjVjLTAuMDQxLDAuMjY0LTAuMDkyLDAuNTI1LTAuMTU5LDAuNzgyYy0wLjAxNCwwLjA1NS0wLjAyNywwLjExLTAuMDQyLDAuMTY1CgkJYy0wLjE4MSwwLjY0My0wLjQzOSwxLjI2LTAuNzcxLDEuODM2Yy0wLjAwNywwLjAxMS0wLjAxNCwwLjAyMi0wLjAyLDAuMDMzYy0wLjE2MSwwLjI3Ni0wLjMzOSwwLjU0MS0wLjUzMiwwLjc5NwoJCWMtMC4wMTgsMC4wMjQtMC4wMzYsMC4wNDktMC4wNTQsMC4wNzNjLTAuNDA4LDAuNTI4LTAuODgzLDEuMDA2LTEuNDE3LDEuNDIyYy0wLjAyOCwwLjAyMi0wLjA1NywwLjA0Mi0wLjA4NSwwLjA2NAoJCWMtMC4yNTQsMC4xOTItMC41MTksMC4zNzItMC43OTcsMC41MzRjLTAuMDMyLDAuMDE5LTAuMDYzLDAuMDM5LTAuMDk1LDAuMDU4bC0wLjE1NSwwLjA5QzIzLjY0OCwxOC42NTUsMjIuMzY0LDE5LDIxLDE5CgkJQzE2LjU4OSwxOSwxMywxNS40MTEsMTMsMTF6IE0zNSw0N0g3VjMyYzAtNi4wNjUsNC45MzUtMTEsMTEtMTFoNmMxLjQ5NSwwLDIuOTIxLDAuMzAyLDQuMjIyLDAuODQ1bDAuMTkyLDAuMDg2CgkJYzAuMTExLDAuMDQ5LDAuMjE4LDAuMTA1LDAuMzI3LDAuMTU4YzAuMjk3LDAuMTQyLDAuNTg0LDAuMjk3LDAuODY0LDAuNDYzYzAuMTI3LDAuMDc2LDAuMjU2LDAuMTUsMC4zOCwwLjIzMQoJCWMwLjEzMywwLjA4NiwwLjI2MSwwLjE3NywwLjM5LDAuMjY5YzAuMTMzLDAuMDk1LDAuMjY0LDAuMTkzLDAuMzkzLDAuMjk0YzAuMTE1LDAuMDksMC4yMjksMC4xNzksMC4zNCwwLjI3MwoJCWMwLjE2OSwwLjE0NCwwLjMzMiwwLjI5NCwwLjQ5MiwwLjQ0OGMwLjEyNiwwLjEyMSwwLjI0OSwwLjI0NSwwLjM2OSwwLjM3MmMwLjEzNSwwLjE0MywwLjI2OSwwLjI4NywwLjM5NywwLjQzNgoJCWMwLjA5NSwwLjExMiwwLjE4NiwwLjIyNiwwLjI3NiwwLjM0MWMwLjEwMiwwLjEzLDAuMiwwLjI2MiwwLjI5NywwLjM5N2MwLjA4OCwwLjEyMiwwLjE3NiwwLjI0NCwwLjI1OSwwLjM3CgkJYzAuMTE0LDAuMTczLDAuMjE5LDAuMzUyLDAuMzIzLDAuNTMxYzAuMTA5LDAuMTg4LDAuMjEsMC4zNzksMC4zMDgsMC41NzNjMC4wNzIsMC4xNDIsMC4xNDIsMC4yODUsMC4yMDgsMC40MzEKCQljMC4wNjUsMC4xNDQsMC4xMjYsMC4yOTEsMC4xODQsMC40MzhjMC4wNjIsMC4xNTcsMC4xMTksMC4zMTYsMC4xNzUsMC40NzZjMC4wNDYsMC4xMzQsMC4wOTYsMC4yNjcsMC4xMzcsMC40MDMKCQljMC4wODQsMC4yNzksMC4xNTcsMC41NjIsMC4yMTksMC44NDljMC4wMjQsMC4xMSwwLjA0MSwwLjIyMywwLjA2MiwwLjMzNGMwLjA0MSwwLjIyMiwwLjA3NiwwLjQ0NiwwLjEwMywwLjY3MgoJCWMwLjAxMywwLjEwNiwwLjAyNiwwLjIxMiwwLjAzNSwwLjMxOUMzNC45NzksMzEuMzM2LDM1LDMxLjY2NiwzNSwzMnYxM1Y0N3ogTTQzLDQzaC02VjMyYzAtMC40NzUtMC4wMjktMC45NDMtMC4wNzktMS40MDUKCQljLTAuMDEyLTAuMTExLTAuMDM1LTAuMjE5LTAuMDUtMC4zMjljLTAuMDQ4LTAuMzU1LTAuMTAzLTAuNzA3LTAuMTc5LTEuMDUyYy0wLjAyNi0wLjExNi0wLjA2LTAuMjI5LTAuMDg5LTAuMzQ0CgkJYy0wLjA4NC0wLjMzNi0wLjE3Ni0wLjY2OS0wLjI4NS0wLjk5NGMtMC4wMzgtMC4xMTMtMC4wODItMC4yMjQtMC4xMjMtMC4zMzZjLTAuMTE3LTAuMzItMC4yNDQtMC42MzQtMC4zODUtMC45NDIKCQljLTAuMDUyLTAuMTEyLTAuMTA2LTAuMjIyLTAuMTYxLTAuMzMzYy0wLjE0OC0wLjI5OS0wLjMwNi0wLjU5Mi0wLjQ3Ni0wLjg3OGMtMC4wNjUtMC4xMDktMC4xMy0wLjIxNy0wLjE5Ny0wLjMyNQoJCWMtMC4xNzgtMC4yOC0wLjM2Ny0wLjU1MS0wLjU2NS0wLjgxN2MtMC4wNzUtMC4xLTAuMTQ3LTAuMjAyLTAuMjI0LTAuM2MtMC4yMTgtMC4yNzUtMC40NDktMC41MzctMC42ODctMC43OTMKCQljLTAuMDctMC4wNzUtMC4xMzQtMC4xNTMtMC4yMDYtMC4yMjdjLTAuMzE2LTAuMzIzLTAuNjQ1LTAuNjMzLTAuOTkzLTAuOTIyQzM4LjIyNywyMi4xNjMsNDMsMjcuMDM1LDQzLDMzVjQzeiIvPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=", Fl = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvSGVhcnQ8L3RpdGxlPgogICAgPGcgaWQ9Ikljb25zIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSJJY29ucy8yNC9IZWFydCIgZmlsbD0iIzAwMDAwMCIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuMzc1Ij4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjAwMDAwMCwgMy4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMC4zMTM0Mzk1LDE4LjA0NTkwNDkgTDEuNTI0NDM5NTQsOC44NzkyMzgyNCBDLTAuMDU5NzUwOTI3Miw3LjI5NjI5MzU4IC0wLjQ1MjM0OTMzNSw0Ljg3NjgwODk1IDAuNTUwMDIyODcyLDIuODc0MTU0OTEgTDAuNTUwMDIyODcyLDIuODc0MTU0OTEgQzEuMjk3NjgyNDEsMS4zNzkyNjYxIDIuNzE4MzE0NzcsMC4zMzQ4NjcyNjkgNC4zNjgxNzM0NCwwLjA2NzE4NTE5MDEgQzYuMDE4MDMyMTIsLTAuMjAwNDk2ODg5IDcuNjk1OTk2MjMsMC4zNDExNjg3MzcgOC44Nzc5Mzk1NCwxLjUyMjk4ODI0IEwxMC4zMTM0Mzk1LDIuOTU3NTcxNTggTDExLjc0ODkzOTUsMS41MjI5ODgyNCBDMTIuOTMwODgyOSwwLjM0MTE2ODczNyAxNC42MDg4NDcsLTAuMjAwNDk2ODg5IDE2LjI1ODcwNTYsMC4wNjcxODUxOTAxIEMxNy45MDg1NjQzLDAuMzM0ODY3MjY5IDE5LjMyOTE5NjcsMS4zNzkyNjYxIDIwLjA3Njg1NjIsMi44NzQxNTQ5MSBMMjAuMDc2ODU2MiwyLjg3NDE1NDkxIEMyMS4wNzc4MjU2LDQuODc1OTU2MTIgMjAuNjg1NzA0NSw3LjI5MzY2NzM5IDE5LjEwMzM1NjIsOC44NzY0ODgyNCBMMTAuMzEzNDM5NSwxOC4wNDU5MDQ5IFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==", Hl = "data:image/svg+xml;base64,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", Rz = "data:image/svg+xml;base64,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", Zl = "data:image/svg+xml;base64,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", Wl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNDMwMTggMTUuODU4M0MyLjU2NzIzIDE1Ljg1ODMgMS44Njc2OCAxNS4xNTg4IDEuODY3NjggMTQuMjk1OFY1LjcwNDM1QzEuODY3NjggNC44NDE0IDIuNTY3MjMgNC4xNDE4NSAzLjQzMDE4IDQuMTQxODVIMTIuMTg4NEMxMy4wNTEzIDQuMTQxODUgMTMuNzUwOSA0Ljg0MTQgMTMuNzUwOSA1LjcwNDM1VjE0LjI5NThDMTMuNzUwOSAxNS4xNTg4IDEzLjA1MTMgMTUuODU4MyAxMi4xODg0IDE1Ljg1ODNIMy40MzAxOFoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQuMTU3MSAxMS45NTQxQzEzLjkwNjggMTEuODE3IDEzLjc1MTIgMTEuNTU0MyAxMy43NTEyIDExLjI2ODlWOC43MzI0NkMxMy43NTEyIDguNDQ3MDcgMTMuOTA2OCA4LjE4NDM3IDE0LjE1NzEgOC4wNDcyNkwxNi45NzU0IDYuNTAzNDNDMTcuNDk2MSA2LjIxODIyIDE4LjEzMiA2LjU5NDk3IDE4LjEzMiA3LjE4ODYxVjEyLjgxMjhDMTguMTMyIDEzLjQwNjQgMTcuNDk2MSAxMy43ODMyIDE2Ljk3NTQgMTMuNDk3OUwxNC4xNTcxIDExLjk1NDFaIiBzdHJva2U9ImJsYWNrIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguNDEzODQgMTIuNTE4Nkg1LjE4NzVWOS4yOTIyNCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC4zNzc2IDcuMzEzOTZMNS4yODE0OSAxMi40MSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", $l = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjIgMTMuOEwzIDIxIiBzdHJva2U9IiM4MDgwODAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIxIDguNFYzSDE1LjYiIHN0cm9rZT0iIzgwODA4MCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMyAxNS42VjIxSDguNCIgc3Ryb2tlPSIjODA4MDgwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMSAzTDEzLjggMTAuMiIgc3Ryb2tlPSIjODA4MDgwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", hi = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvSW5mbzwvdGl0bGU+CiAgICA8ZyBpZD0iSWNvbnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9Ikljb25zLzI0L0luZm8iIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiPgogICAgICAgICAgICA8ZyBpZD0ic3RyZWFtbGluZS1pY29uLWluZm9ybWF0aW9uLWNpcmNsZUAyNHgyNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4wMDAwMDAsIDIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTIsMTQgTDExLjMzMzMzMzMsMTQgQzEwLjU5Njk1MzcsMTQgMTAsMTMuNDAzMDQ2MyAxMCwxMi42NjY2NjY3IEwxMCw5LjMzMzMzMzMzIEMxMCw4Ljk2NTE0MzUgOS43MDE1MjMxNyw4LjY2NjY2NjY3IDkuMzMzMzMzMzMsOC42NjY2NjY2NyBMOC42NjY2NjY2Nyw4LjY2NjY2NjY3IiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTkuNjY2NjY2NjcsNS4zMzMzMzMzMyBDOS40ODI1NzE3NSw1LjMzMzMzMzMzIDkuMzMzMzMzMzMsNS40ODI1NzE3NSA5LjMzMzMzMzMzLDUuNjY2NjY2NjcgQzkuMzMzMzMzMzMsNS44NTA3NjE1OCA5LjQ4MjU3MTc1LDYgOS42NjY2NjY2Nyw2IEM5Ljg1MDc2MTU4LDYgMTAsNS44NTA3NjE1OCAxMCw1LjY2NjY2NjY3IEMxMCw1LjQ4MjU3MTc1IDkuODUwNzYxNTgsNS4zMzMzMzMzMyA5LjY2NjY2NjY3LDUuMzMzMzMzMzMgTDkuNjY2NjY2NjcsNS4zMzMzMzMzMyIgaWQ9IlBhdGgiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLDEwIEMwLDE1LjUyMjg0NzUgNC40NzcxNTI1LDIwIDEwLDIwIEMxNS41MjI4NDc1LDIwIDIwLDE1LjUyMjg0NzUgMjAsMTAgQzIwLDQuNDc3MTUyNSAxNS41MjI4NDc1LDAgMTAsMCBDNC40NzcxNTI1LDAgMCw0LjQ3NzE1MjUgMCwxMCBaIiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=", Va = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAFAAAAAAnxZisAAACpElEQVQ4Ea1VzUsVURQ/5868UrEg/AMy0NTMRQRBJfIQszKxgh5ByzbVIooiiDbZBwUtXAWJtGgRJW0MQsxnxfhRIbgpsqcQtajoA8uITGfu3Hs6Z+zJU3pq+n4wc+fee87vd+bcM2cQ5mB0Z+0WMuERQNiNgO+UgtYAgs7K7uffM01fVlevyc9391iAo5bsOkT1gPdvlvd4Q5l2mJ68bahdG2rTwvMmB9HV1gKP0WWA3oSWzlc86rsj9qm6mkOuwgsKsMQSgeErxpEYS5oQOpSLp0u7vA9iGwmkdsWLlaGuPKXKJw3TyU4GYizEYG+OFglXAt7gOWomzoRY5TsO+Na+8pEaqpJ97/FeIuFUjX++X+C4jb+ZPBsUi3C0Wvb5OSaRZ0MBi0xY01GxvfYApuprtjkE/ZZAZXeZpkrnczF2Ek9oaKtCi2c4ogXJRUKIFyJP2zmolHLUSZeAGjWXQq4RcpHwMTVxIeCwVEuuIWfGSPGIl/9OcqohnA7QVWUCeMg1PyJ1nCsIl7ZmVIcqqSo97xen6aK8UC4SleZB5VwS7ijs8p7e9sDQLflIlos8R4FPdLs9Gb8rXJEAq5K7YurEpLHeckTEd8rYp77G483QHNXmTOJLuwZ/ukof9I0dWIqI+PjWDFqHEps870c6EzMCslCSfPYVQtzvG9MpDos5E7GZJrc9gfX3buju/5Qml3GWgCyUed7YtwmdYJHrLqqom8r6vyDfT0whsG3bqrzV+6oeD36ZazdvkCN1NYe5nq8xSRHndpYvd14Igca5dZxdn+xtm7WZMZlXQOxe18c3ukQtLLJDc0cUSPsOiJ6AMqfKugdeRItZbgsKiN/Q5s2xwqLCYw7hOWl3/FO5oj+OtVYODwdZeJe2LD+mVDxe/D/efwCuAQs2cnkFkQAAAABJRU5ErkJggg==", nn = "data:image/svg+xml;base64,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", Jl = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvTWljQDJ4PC90aXRsZT4KICAgIDxnIGlkPSJJY29ucy8yNC9NaWMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0LCAxKSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSI+CiAgICAgICAgICAgIDxsaW5lIHgxPSI4IiB5MT0iMTguMzMzMzMzMyIgeDI9IjgiIHkyPSIyMiIgaWQ9IlBhdGgiPjwvbGluZT4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgeD0iMy41IiB5PSIwIiB3aWR0aD0iOSIgaGVpZ2h0PSIxNC45MTExMTExIiByeD0iMy45MTExMTExMSI+PC9yZWN0PgogICAgICAgICAgICA8cGF0aCBkPSJNMCw4LjggTDAsMTEgQzAsMTUuMDUwMDg4MiAzLjM1Nzg2NDM4LDE4LjMzMzMzMzMgNy41LDE4LjMzMzMzMzMgTDguNSwxOC4zMzMzMzMzIEMxMi42NDIxMzU2LDE4LjMzMzMzMzMgMTYsMTUuMDUwMDg4MiAxNiwxMSBMMTYsOC44IiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+", Kl = "data:image/svg+xml;base64,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", Xl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjE1NzMgMTEuOTUzOUMxMy45MDcgMTEuODE2NyAxMy43NTE1IDExLjU1NDEgMTMuNzUxNSAxMS4yNjg3VjguNzMyMjFDMTMuNzUxNSA4LjQ0NjgyIDEzLjkwNyA4LjE4NDEzIDE0LjE1NzMgOC4wNDcwMUwxNi45NzU3IDYuNTAzMThDMTcuNDk2MyA2LjIxNzk4IDE4LjEzMjIgNi41OTQ3MyAxOC4xMzIyIDcuMTg4MzZWMTIuODEyNUMxOC4xMzIyIDEzLjQwNjEgMTcuNDk2MyAxMy43ODI5IDE2Ljk3NTcgMTMuNDk3N0wxNC4xNTczIDExLjk1MzlaIiBzdHJva2U9ImJsYWNrIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTExLjM4MzQgOS4xMzUxTDguMTc2MDEgMTIuMzQyNUw0LjE2Njc1IDguMzMzMjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNC4xNjY3NSAxMC43Mzg4VjguMzMzMjVINi41NzIzIiBzdHJva2U9ImJsYWNrIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMuMjI5MjUgMTUuODgzQzIuMzY2MyAxNS44ODMgMS42NjY3NSAxNS4xODM0IDEuNjY2NzUgMTQuMzIwNVY1LjcyOUMxLjY2Njc1IDQuODY2MDYgMi4zNjYzIDQuMTY2NSAzLjIyOTI1IDQuMTY2NUgxMS45ODc0QzEyLjg1MDMgNC4xNjY1IDEzLjU0OTkgNC44NjYwNiAxMy41NDk5IDUuNzI5VjE0LjMyMDVDMTMuNTQ5OSAxNS4xODM0IDEyLjg1MDMgMTUuODgzIDExLjk4NzQgMTUuODgzSDMuMjI5MjVaIiBzdHJva2U9ImJsYWNrIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", Ga = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvTW9yZUAyeDwvdGl0bGU+CiAgICA8ZyBpZD0iSWNvbnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJJY29ucy8yNC9Nb3JlIiBmaWxsPSIjMDAwMDAwIj4KICAgICAgICAgICAgPHBhdGggZD0iTTQuNSwxMCBDNS44ODA3MTE4NywxMCA3LDExLjExOTI4ODEgNywxMi41IEM3LDEzLjg4MDcxMTkgNS44ODA3MTE4NywxNSA0LjUsMTUgQzMuMTE5Mjg4MTMsMTUgMiwxMy44ODA3MTE5IDIsMTIuNSBDMiwxMS4xMTkyODgxIDMuMTE5Mjg4MTMsMTAgNC41LDEwIFogTTEyLDEwIEMxMy4zODA3MTE5LDEwIDE0LjUsMTEuMTE5Mjg4MSAxNC41LDEyLjUgQzE0LjUsMTMuODgwNzExOSAxMy4zODA3MTE5LDE1IDEyLDE1IEMxMC42MTkyODgxLDE1IDkuNSwxMy44ODA3MTE5IDkuNSwxMi41IEM5LjUsMTEuMTE5Mjg4MSAxMC42MTkyODgxLDEwIDEyLDEwIFogTTE5LjUsMTAgQzIwLjg4MDcxMTksMTAgMjIsMTEuMTE5Mjg4MSAyMiwxMi41IEMyMiwxMy44ODA3MTE5IDIwLjg4MDcxMTksMTUgMTkuNSwxNSBDMTguMTE5Mjg4MSwxNSAxNywxMy44ODA3MTE5IDE3LDEyLjUgQzE3LDExLjExOTI4ODEgMTguMTE5Mjg4MSwxMCAxOS41LDEwIFoiIGlkPSJSZWN0YW5nbGUtMiI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+", Yz = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvbW9yZWljb248L3RpdGxlPgogICAgPGcgaWQ9Ikljb25zIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iSWNvbnMvMjQvTW9yZSIgZmlsbD0iIzAwMDAwMCI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik00LjUsMTAgQzUuODgwNzExODcsMTAgNywxMS4xMTkyODgxIDcsMTIuNSBDNywxMy44ODA3MTE5IDUuODgwNzExODcsMTUgNC41LDE1IEMzLjExOTI4ODEzLDE1IDIsMTMuODgwNzExOSAyLDEyLjUgQzIsMTEuMTE5Mjg4MSAzLjExOTI4ODEzLDEwIDQuNSwxMCBaIE0xMiwxMCBDMTMuMzgwNzExOSwxMCAxNC41LDExLjExOTI4ODEgMTQuNSwxMi41IEMxNC41LDEzLjg4MDcxMTkgMTMuMzgwNzExOSwxNSAxMiwxNSBDMTAuNjE5Mjg4MSwxNSA5LjUsMTMuODgwNzExOSA5LjUsMTIuNSBDOS41LDExLjExOTI4ODEgMTAuNjE5Mjg4MSwxMCAxMiwxMCBaIE0xOS41LDEwIEMyMC44ODA3MTE5LDEwIDIyLDExLjExOTI4ODEgMjIsMTIuNSBDMjIsMTMuODgwNzExOSAyMC44ODA3MTE5LDE1IDE5LjUsMTUgQzE4LjExOTI4ODEsMTUgMTcsMTMuODgwNzExOSAxNywxMi41IEMxNywxMS4xMTkyODgxIDE4LjExOTI4ODEsMTAgMTkuNSwxMCBaIiBpZD0iUmVjdGFuZ2xlLTIiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==", Vz = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQgRW1vamkvT2JqZWN0czwvdGl0bGU+CiAgICA8ZyBpZD0iSWNvbnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJJY29ucy8yNC1FbW9qaS9PYmplY3RzIiBmaWxsPSIjMDAwMDAwIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQuMDAwMDAwLCAyLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTguMjUsLTAuNzUgQzcuNzgzOTA3NjksLTAuNzUgNy4zNDE3NTI0LC0wLjU0MzU1ODg1MiA3LjA0MjUsLTAuMTg2MjIxNDE1IEwtMC4yODI4MzUwMSw4Ljk5NDIwOTA1IEMtMC45MDcyOTU4NDQsOS43NTg2Nzg5OCAtMC45MDcyOTU4NDQsMTAuODY2NjEyOSAtMC4yNzc0NTI0NTYsMTEuNjM3NzUwMiBMNy4wMzEyNDgzMiwyMC43OTc3NDk1IEM3LjM0MTc1MjQsMjEuMTY4ODUwNyA3Ljc4MzkwNzY5LDIxLjM3NTI5MTkgOC4yNSwyMS4zNzUyOTE5IEM4LjcxNjA5MjMxLDIxLjM3NTI5MTkgOS4xNTgyNDc2LDIxLjE2ODg1MDcgOS40NTc1LDIwLjgxMTUxMzMgTDE2Ljc4MjgzNSwxMS42MzEwODI4IEMxNy40MDcyOTU4LDEwLjg2NjYxMjkgMTcuNDA3Mjk1OCw5Ljc1ODY3ODk4IDE2Ljc3NzQ1MjUsOC45ODc1NDE2MyBMOS40Njg3NTE2OCwtMC4xNzI0NTc2MiBDOS4xNTgyNDc2LC0wLjU0MzU1ODg1MiA4LjcxNjA5MjMxLC0wLjc1IDguMjUsLTAuNzUgWiBNOC4yNSwwLjc1IEM4LjI3MjE5NDg3LDAuNzUgOC4yOTMyNDk4OSwwLjc1OTgzMDUzMSA4LjMwNzUsMC43NzY4NDY1OTkgTDE1LjYxMDMzMTcsOS45Mjk3NDk0NyBDMTUuNzk0NTQxOSwxMC4xNTUzNjE0IDE1Ljc5NDU0MTksMTAuNDY5OTMwNSAxNS42MTU3MTQyLDEwLjY4ODg3NSBMOC4yOTYyNDgzMiwxOS44NjIyMDkgTDguMjcxMTg4MzcsMTkuODcyNjIyNyBDOC4yNjQ2Njk5MywxOS44NzQxOTk2IDguMjU3Mzk4MjksMTkuODc1MjkxOSA4LjI1LDE5Ljg3NTI5MTkgQzguMjI3ODA1MTMsMTkuODc1MjkxOSA4LjIwNjc1MDExLDE5Ljg2NTQ2MTMgOC4xOTI1LDE5Ljg0ODQ0NTMgTDAuODg5NjY4MzQzLDEwLjY5NTU0MjQgQzAuNzA1NDU4MDc0LDEwLjQ2OTkzMDUgMC43MDU0NTgwNzQsMTAuMTU1MzYxNCAwLjg4NDI4NTc4OSw5LjkzNjQxNjg5IEw4LjIwMzc1MTY4LDAuNzYzMDgyODA1IEw4LjIyODgxMTYzLDAuNzUyNjY5MTExIEM4LjIzNTMzMDA3LDAuNzUxMDkyMjgxIDguMjQyNjAxNzEsMC43NSA4LjI1LDAuNzUgWiIgaWQ9IlBhdGgiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNi4zNTY4MjUyLDkuNTc4MjcyMSBDMTYuNzYzNDIxMiw5LjQ5OTE5ODg2IDE3LjE1NzEzMzksOS43NjQ3MDg1MSAxNy4yMzYyMDcyLDEwLjE3MTMwNDUgQzE3LjMwODY5MSwxMC41NDQwMTc1IDE3LjA5MTYyOTQsMTAuOTA1OTA0OSAxNi43NDE3NjY3LDExLjAyNDUzNzggTDE2LjY0MzE3NDgsMTEuMDUwNjg2NCBMMTEuODMwNjc0OCwxMS45ODY2MDMxIEwxMS42ODc1LDEyLjAwMDM5NTkgTDQuODEyNSwxMi4wMDAzOTU5IEw0LjY2OTMyNTI0LDExLjk4NjYwMzEgTC0wLjE0MzE3NDc2NCwxMS4wNTA2ODY0IEMtMC41NDk3NzA3NTMsMTAuOTcxNjEzMiAtMC44MTUyODA0MDIsMTAuNTc3OTAwNSAtMC43MzYyMDcxNjMsMTAuMTcxMzA0NSBDLTAuNjYzNzIzMzYxLDkuNzk4NTkxNSAtMC4zMjY4NTUwMTEsOS41NDQ0MzAyMyAwLjA0MTk2ODc5NjUsOS41NjU1NjQ4MyBMMC4xNDMxNzQ3NjQsOS41NzgyNzIxIEw0Ljg4MywxMC41IEwxMS42MTYsMTAuNSBMMTYuMzU2ODI1Miw5LjU3ODI3MjEgWiIgaWQ9IlBhdGgiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik03LjUzMjc1OTkzLC0wLjIxNDUxMTg3OSBMNC4wOTUyNTk5MywxMS4wMzExNTQ4IEM0LjA0NzQ4MTg5LDExLjE4NzQ1OSA0LjA1MjA3MDg5LDExLjM1NTA5MjIgNC4xMDgzMjg2NywxMS41MDg1NDg1IEw3LjU0NTgyODY3LDIwLjg4NTEzMTggQzcuNzg2MjQ2ODIsMjEuNTQwOTI4NCA4LjcxMzc1MzE4LDIxLjU0MDkyODQgOC45NTQxNzEzMywyMC44ODUxMzE4IEwxMi4zOTE2NzEzLDExLjUwODU0ODUgQzEyLjQ0NzkyOTEsMTEuMzU1MDkyMiAxMi40NTI1MTgxLDExLjE4NzQ1OSAxMi40MDQ3NDAxLDExLjAzMTE1NDggTDguOTY3MjQwMDcsLTAuMjE0NTExODc5IEM4Ljc1MDkyMTY2LC0wLjkyMjE5MDM2MiA3Ljc0OTA3ODM0LC0wLjkyMjE5MDM2MiA3LjUzMjc1OTkzLC0wLjIxNDUxMTg3OSBaIE04LjI1LDIuNTcgTDEwLjg5NiwxMS4yMjggTDguMjUsMTguNDQ3IEw1LjYwMywxMS4yMjggTDguMjUsMi41NyBaIiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=", ql = "data:image/svg+xml;base64,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", _l = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNDMwMTggMTUuODU4M0MyLjU2NzIzIDE1Ljg1ODMgMS44Njc2OCAxNS4xNTg4IDEuODY3NjggMTQuMjk1OFY1LjcwNDM1QzEuODY3NjggNC44NDE0IDIuNTY3MjMgNC4xNDE4NSAzLjQzMDE4IDQuMTQxODVIMTIuMTg4NEMxMy4wNTEzIDQuMTQxODUgMTMuNzUwOSA0Ljg0MTQgMTMuNzUwOSA1LjcwNDM1VjE0LjI5NThDMTMuNzUwOSAxNS4xNTg4IDEzLjA1MTMgMTUuODU4MyAxMi4xODg0IDE1Ljg1ODNIMy40MzAxOFoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQuMTU3MSAxMS45NTQxQzEzLjkwNjggMTEuODE3IDEzLjc1MTIgMTEuNTU0MyAxMy43NTEyIDExLjI2ODlWOC43MzI0NkMxMy43NTEyIDguNDQ3MDcgMTMuOTA2OCA4LjE4NDM3IDE0LjE1NzEgOC4wNDcyNkwxNi45NzU0IDYuNTAzNDNDMTcuNDk2MSA2LjIxODIyIDE4LjEzMiA2LjU5NDk3IDE4LjEzMiA3LjE4ODYxVjEyLjgxMjhDMTguMTMyIDEzLjQwNjQgMTcuNDk2MSAxMy43ODMyIDE2Ljk3NTQgMTMuNDk3OUwxNC4xNTcxIDExLjk1NDFaIiBzdHJva2U9ImJsYWNrIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuMTUxMTEgNy4zMTM5NUgxMC4zNzc0VjEwLjU0MDMiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS4xODczOCAxMi41MTg2TDEwLjI4MzQgNy40MjI0OCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", Yo = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+TG9ja2VkPC90aXRsZT4KICAgIDxnIGlkPSJTeW1ib2xzLXYyIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTG9ja2VkIj4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgZmlsbD0iI0Y3QTUwMCIgeD0iMCIgeT0iMCIgd2lkdGg9IjE0IiBoZWlnaHQ9IjE0IiByeD0iNyI+PC9yZWN0PgogICAgICAgICAgICA8cGF0aCBkPSJNNywzIEM4LjEwNDU2OTUsMyA5LDMuODk1NDMwNSA5LDUgTDkuMDAwNzk4NTEsNi4wMDg0MTg2MyBDOS4yNDM3OTM1LDYuMDI1NDI5IDkuMzY1NzM0MTMsNi4wNjc5NTE3MSA5LjQ4ODQyMjg1LDYuMTMzNTY2MzUgQzkuNjUxMzg1ODEsNi4yMjA3MTk5IDkuNzc5MjgwMSw2LjM0ODYxNDE5IDkuODY2NDMzNjUsNi41MTE1NzcxNSBDOS45NTM1ODcxOSw2LjY3NDU0MDExIDEwLDYuODM2MTgzMjMgMTAsNy4yODE5NDI2IEwxMCw5LjcxODA1NzQgQzEwLDEwLjE2MzgxNjggOS45NTM1ODcxOSwxMC4zMjU0NTk5IDkuODY2NDMzNjUsMTAuNDg4NDIyOSBDOS43NzkyODAxLDEwLjY1MTM4NTggOS42NTEzODU4MSwxMC43NzkyODAxIDkuNDg4NDIyODUsMTAuODY2NDMzNiBDOS4zMjU0NTk4OSwxMC45NTM1ODcyIDkuMTYzODE2NzcsMTEgOC43MTgwNTc0LDExIEw1LjI4MTk0MjYsMTEgQzQuODM2MTgzMjMsMTEgNC42NzQ1NDAxMSwxMC45NTM1ODcyIDQuNTExNTc3MTUsMTAuODY2NDMzNiBDNC4zNDg2MTQxOSwxMC43NzkyODAxIDQuMjIwNzE5OSwxMC42NTEzODU4IDQuMTMzNTY2MzUsMTAuNDg4NDIyOSBDNC4wNDY0MTI4MSwxMC4zMjU0NTk5IDQsMTAuMTYzODE2OCA0LDkuNzE4MDU3NCBMNCw3LjI4MTk0MjYgQzQsNi44MzYxODMyMyA0LjA0NjQxMjgxLDYuNjc0NTQwMTEgNC4xMzM1NjYzNSw2LjUxMTU3NzE1IEM0LjIyMDcxOTksNi4zNDg2MTQxOSA0LjM0ODYxNDE5LDYuMjIwNzE5OSA0LjUxMTU3NzE1LDYuMTMzNTY2MzUgQzQuNjM0NDIxMzcsNi4wNjc4Njg1NSA0Ljc1NjUxNTYsNi4wMjUzMjEyNSA1LjAwMDEyNjAxLDYuMDA4MzU0MDggTDUsNSBDNSwzLjg5NTQzMDUgNS44OTU0MzA1LDMgNywzIFogTTcsNCBDNi40ODcxNjQxNiw0IDYuMDY0NDkyODQsNC4zODYwNDAxOSA2LjAwNjcyNzczLDQuODgzMzc4ODcgTDYsNSBMNiw2IEw4LDYgTDgsNSBDOCw0LjQ0NzcxNTI1IDcuNTUyMjg0NzUsNCA3LDQgWiIgaWQ9IlJlY3RhbmdsZS0zIiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=", vi = "data:image/png;base64,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", Pa = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvUGx1czwvdGl0bGU+CiAgICA8ZyBpZD0iSWNvbnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9Ikljb25zLzI0L1BsdXMiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuMDAwMDAwLCAyLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjEwIiB5MT0iNiIgeDI9IjEwIiB5Mj0iMTQiIGlkPSJQYXRoIj48L2xpbmU+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iNiIgeTE9IjEwIiB4Mj0iMTQiIHkyPSIxMCIgaWQ9IlBhdGgiPjwvbGluZT4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLDEwIEMwLDE1LjUyMjg0NzUgNC40NzcxNTI1LDIwIDEwLDIwIEMxNS41MjI4NDc1LDIwIDIwLDE1LjUyMjg0NzUgMjAsMTAgQzIwLDQuNDc3MTUyNSAxNS41MjI4NDc1LDAgMTAsMCBDNC40NzcxNTI1LDAgMCw0LjQ3NzE1MjUgMCwxMCBaIiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=", Fa = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvUGx1cyBSb3RhdGVkPC90aXRsZT4KICAgIDxnIGlkPSJJY29ucyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8ZyBpZD0iSWNvbnMvMjQvUGx1cy1Sb3RhdGVkIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41Ij4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMi4wMDAwMDAsIDEyLjAwMDAwMCkgcm90YXRlKDQ1LjAwMDAwMCkgdHJhbnNsYXRlKC0xMi4wMDAwMDAsIC0xMi4wMDAwMDApIHRyYW5zbGF0ZSgyLjAwMDAwMCwgMi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIxMCIgeTE9IjYiIHgyPSIxMCIgeTI9IjE0IiBpZD0iUGF0aCI+PC9saW5lPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjYiIHkxPSIxMCIgeDI9IjE0IiB5Mj0iMTAiIGlkPSJQYXRoIj48L2xpbmU+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCwxMCBDMCwxNS41MjI4NDc1IDQuNDc3MTUyNSwyMCAxMCwyMCBDMTUuNTIyODQ3NSwyMCAyMCwxNS41MjI4NDc1IDIwLDEwIEMyMCw0LjQ3NzE1MjUgMTUuNTIyODQ3NSwwIDEwLDAgQzQuNDc3MTUyNSwwIDAsNC40NzcxNTI1IDAsMTAgWiIgaWQ9IlBhdGgiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+", es = "data:image/svg+xml;base64,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", Vo = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+UHJpdmF0ZTwvdGl0bGU+CiAgICA8ZyBpZD0iU3ltYm9scy12MiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlByaXZhdGUiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBmaWxsPSIjMDBDODZGIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHJ4PSI3Ij48L3JlY3Q+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik00LDUgQzUuMzMzMzMzMzMsNC42NjY2NjY2NyA2LjMzMzMzMzMzLDQgNywzIEM3LjY2NjY2NjY3LDQgOC42NjY2NjY2Nyw0LjY2NjY2NjY3IDEwLDUgTDEwLDYuMTQ1ODk4MDMgQzEwLDguMjAxNTEzMzEgOC44Mzg1OTgxOSwxMC4wODA3MDA5IDcsMTEgTDcsMTEgTDcsMTEgQzUuMTYxNDAxODEsMTAuMDgwNzAwOSA0LDguMjAxNTEzMzEgNCw2LjE0NTg5ODAzIEw0LDUgTDQsNSBaIiBpZD0iUmVjdGFuZ2xlIiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=", ts = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQgRXh0ZW5zaW9ucy9SZWFjdGlvbnMgQWRkPC90aXRsZT4KICAgIDxnIGlkPSJJY29ucyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ikljb25zLzI0LUV4dGVuc2lvbnMvUmVhY3Rpb25zLUFkZCIgZmlsbD0iIzAwMDAwMCIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTEyLDEuMjUgQzEzLjI1NDc1MTUsMS4yNSAxNC40ODEwOTU1LDEuNDY1MzQ1MTUgMTUuNjM4Mzk0MywxLjg4MTU0MzY2IEMxNi4wMjgxNjg2LDIuMDIxNzE3OTQgMTYuMjMwNTA5NSwyLjQ1MTMyNjE5IDE2LjA5MDMzNTIsMi44NDExMDA1NCBDMTUuOTUwMTYwOSwzLjIzMDg3NDkgMTUuNTIwNTUyNywzLjQzMzIxNTc0IDE1LjEzMDc3ODMsMy4yOTMwNDE0NiBDMTQuMTM1NzM3OSwyLjkzNTE5NTggMTMuMDgxMDg3OSwyLjc1IDEyLDIuNzUgQzYuODkxMzY2MDYsMi43NSAyLjc1LDYuODkxMzY2MDYgMi43NSwxMiBDMi43NSwxNy4xMDg2MzM5IDYuODkxMzY2MDYsMjEuMjUgMTIsMjEuMjUgQzE3LjEwODYzMzksMjEuMjUgMjEuMjUsMTcuMTA4NjMzOSAyMS4yNSwxMiBDMjEuMjUsMTEuMjcyOTI2NiAyMS4xNjYyNTc2LDEwLjU1NzM2OTUgMjEuMDAyMDg3NSw5Ljg2Mjk3OTUgQzIwLjkwNjc4NSw5LjQ1OTg3ODYzIDIxLjE1NjMwNDksOS4wNTU4NDI4NyAyMS41NTk0MDU4LDguOTYwNTQwMzYgQzIxLjk2MjUwNjYsOC44NjUyMzc4NCAyMi4zNjY1NDI0LDkuMTE0NzU3NzEgMjIuNDYxODQ0OSw5LjUxNzg1ODU3IEMyMi42NTI3MDQzLDEwLjMyNTEzNjIgMjIuNzUsMTEuMTU2NTAzMiAyMi43NSwxMiBDMjIuNzUsMTcuOTM3MDYxMSAxNy45MzcwNjExLDIyLjc1IDEyLDIyLjc1IEM2LjA2MjkzODk0LDIyLjc1IDEuMjUsMTcuOTM3MDYxMSAxLjI1LDEyIEMxLjI1LDYuMDYyOTM4OTQgNi4wNjI5Mzg5NCwxLjI1IDEyLDEuMjUgWiBNMTcuNjU4NjY2NywxMy4yNSBDMTguMTE4NTc1NCwxMy4yNSAxOC41NDk4NDAyLDEzLjQ3MzMxNTMgMTguODE1MzMzNSwxMy44NDg4MzYxIEMxOS4wODA4MDkyLDE0LjIyNDMzMjIgMTkuMTQ3NTA1OCwxNC43MDUzMjUzIDE4Ljk5NDQxMTEsMTUuMTM4MzQxNyBDMTcuOTQ4MzE3OSwxOC4xMDQ0NDA1IDE1LjE0NTE2MzQsMjAuMDg4MTk3MSAxMiwyMC4wODgxOTcxIEM4Ljg1NDgzNjYyLDIwLjA4ODE5NzEgNi4wNTE2ODIwNiwxOC4xMDQ0NDA1IDUuMDA1NzgyMTEsMTUuMTM4ODg4OSBDNC44NTI0OTQyMSwxNC43MDUzMjUzIDQuOTE5MTkwODQsMTQuMjI0MzMyMiA1LjE4NDY2NjUzLDEzLjg0ODgzNjEgQzUuNDUwMTU5NzcsMTMuNDczMzE1MyA1Ljg4MTQyNDYxLDEzLjI1IDYuMzQxMzMzMzMsMTMuMjUgTDYuMzQxMzMzMzMsMTMuMjUgWiBNMTcuNTU4LDE0LjY5NSBMMTcuNTM4LDE0Ljc0OSBMNi40NjEsMTQuNzQ5IEw2LjUwODI3MTc5LDE0Ljg3MzQxNTYgQzcuMzczMjA2OSwxNy4wMzIyOTE3IDkuNDI2NDAwMjEsMTguNDg1MzEwNCAxMS43NTAwNDUsMTguNTgyOTUxNiBMMTEuNzUwMDQ1LDE4LjU4Mjk1MTYgTDEyLDE4LjU4ODE5NzEgQzE0LjUwOTA2MjksMTguNTg4MTk3MSAxNi43NDUyODczLDE3LjAwNTY0OTcgMTcuNTgwMDA0MywxNC42Mzg4ODg5IEwxNy41NTgsMTQuNjk1IFogTTguMTE0MjIyMjIsOC41ODI4ODE0OCBDOS4yNzk4NjczLDguNTgyODgxNDggMTAuMzE4ODgxNyw5LjMxNzc2MjMyIDEwLjcwNzE2NjcsMTAuNDE2ODM2MSBDMTAuODQ1MTQ0MywxMC44MDczOTM1IDEwLjY0MDM4NzksMTEuMjM1ODU1NyAxMC4yNDk4MzA2LDExLjM3MzgzMzMgQzkuODkxODE5NjQsMTEuNTAwMzEyOCA5LjUwMTk1ODA4LDExLjMzODgwMDUgOS4zMzMxODk0NiwxMS4wMTAxNzQ5IEw5LjI5MjgzMzMzLDEwLjkxNjQ5NzIgQzkuMTE2MzQwMTUsMTAuNDE2OTE4MiA4LjY0NDA2MDksMTAuMDgyODgxNSA4LjExNDIyMjIyLDEwLjA4Mjg4MTUgQzcuNjI4NTM2NzcsMTAuMDgyODgxNSA3LjE5MTIxNzIyLDEwLjM2MzU2NTEgNi45ODU3NTg3NSwxMC43OTUxNDg4IEw2LjkzNTYxMTExLDEwLjkxNjQ5NzIgQzYuNzk3NjMzNTEsMTEuMzA3MDU0NiA2LjM2OTE3MTI2LDExLjUxMTgxMDkgNS45Nzg2MTM4OSwxMS4zNzM4MzMzIEM1LjU4ODA1NjUzLDExLjIzNTg1NTcgNS4zODMzMDAxNywxMC44MDczOTM1IDUuNTIxMjc3NzgsMTAuNDE2ODM2MSBDNS45MDk1NjI3OSw5LjMxNzc2MjMyIDYuOTQ4NTc3MTQsOC41ODI4ODE0OCA4LjExNDIyMjIyLDguNTgyODgxNDggWiBNMTUuODg1Nzc3OCw4LjU4Mjg4MTQ4IEMxNy4wNTE0MjI5LDguNTgyODgxNDggMTguMDkwNDM3Miw5LjMxNzc2MjMyIDE4LjQ3ODcyMjIsMTAuNDE2ODM2MSBDMTguNjE2Njk5OCwxMC44MDczOTM1IDE4LjQxMTk0MzUsMTEuMjM1ODU1NyAxOC4wMjEzODYxLDExLjM3MzgzMzMgQzE3LjY2MzM3NTIsMTEuNTAwMzEyOCAxNy4yNzM1MTM2LDExLjMzODgwMDUgMTcuMTA0NzQ1LDExLjAxMDE3NDkgTDE3LjA2NDM4ODksMTAuOTE2NDk3MiBDMTYuODg3ODk1NywxMC40MTY5MTgyIDE2LjQxNTYxNjUsMTAuMDgyODgxNSAxNS44ODU3Nzc4LDEwLjA4Mjg4MTUgQzE1LjQwMDA5MjMsMTAuMDgyODgxNSAxNC45NjI3NzI4LDEwLjM2MzU2NTEgMTQuNzU3MzE0MywxMC43OTUxNDg4IEwxNC43MDcxNjY3LDEwLjkxNjQ5NzIgQzE0LjU2OTE4OTEsMTEuMzA3MDU0NiAxNC4xNDA3MjY4LDExLjUxMTgxMDkgMTMuNzUwMTY5NCwxMS4zNzM4MzMzIEMxMy4zNTk2MTIxLDExLjIzNTg1NTcgMTMuMTU0ODU1NywxMC44MDczOTM1IDEzLjI5MjgzMzMsMTAuNDE2ODM2MSBDMTMuNjgxMTE4Myw5LjMxNzc2MjMyIDE0LjcyMDEzMjcsOC41ODI4ODE0OCAxNS44ODU3Nzc4LDguNTgyODgxNDggWiBNMTkuNSwwLjI1IEMxOS44Nzk2OTU4LDAuMjUgMjAuMTkzNDkxLDAuNTMyMTUzODgyIDIwLjI0MzE1MzQsMC44OTgyMjk0NDMgTDIwLjI1LDEgTDIwLjI1LDQuMjUgTDIzLDQuMjUgQzIzLjQxNDIxMzYsNC4yNSAyMy43NSw0LjU4NTc4NjQ0IDIzLjc1LDUgQzIzLjc1LDUuMzc5Njk1NzcgMjMuNDY3ODQ2MSw1LjY5MzQ5MDk2IDIzLjEwMTc3MDYsNS43NDMxNTMzOCBMMjMsNS43NSBMMjAuMjUsNS43NSBMMjAuMjUsOSBDMjAuMjUsOS40MTQyMTM1NiAxOS45MTQyMTM2LDkuNzUgMTkuNSw5Ljc1IEMxOS4xMjAzMDQyLDkuNzUgMTguODA2NTA5LDkuNDY3ODQ2MTIgMTguNzU2ODQ2Niw5LjEwMTc3MDU2IEwxOC43NSw5IEwxOC43NSw1Ljc1IEwxNiw1Ljc1IEMxNS41ODU3ODY0LDUuNzUgMTUuMjUsNS40MTQyMTM1NiAxNS4yNSw1IEMxNS4yNSw0LjYyMDMwNDIzIDE1LjUzMjE1MzksNC4zMDY1MDkwNCAxNS44OTgyMjk0LDQuMjU2ODQ2NjIgTDE2LDQuMjUgTDE4Ljc1LDQuMjUgTDE4Ljc1LDEgQzE4Ljc1LDAuNTg1Nzg2NDM4IDE5LjA4NTc4NjQsMC4yNSAxOS41LDAuMjUgWiIgaWQ9IlBhdGgiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==", Gz = "data:image/svg+xml;base64,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", mi = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC44Ij4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjE1MTQ3IDMuMTUyNjJDOS4zMjUyOCAyLjkzODA0IDkuMjkyMjQgMi42MjMxOSA5LjA3NzY2IDIuNDQ5MzhDOC44NjMwOCAyLjI3NTU3IDguNTQ4MjIgMi4zMDg2MSA4LjM3NDQxIDIuNTIzMTlMMy42MTQxNCA4LjM5OTk4TDEuNjI2IDYuNDI0OTRDMS40MzAxIDYuMjMwMzIgMS4xMTM1MiA2LjIzMTM3IDAuOTE4OTAxIDYuNDI3MjdDMC43MjQyODUgNi42MjMxOCAwLjcyNTMzMSA2LjkzOTc2IDAuOTIxMjM4IDcuMTM0MzhMMy4zMDE5NyA5LjQ5OTQyQzMuNDAyMjkgOS41OTkwOCAzLjU0MDEyIDkuNjUxNiAzLjY4MTMxIDkuNjQzOThDMy44MjI1MSA5LjYzNjM1IDMuOTUzODggOS41NjkzIDQuMDQyODkgOS40NTk0Mkw5LjE1MTQ3IDMuMTUyNjJaTTEzLjA4MTQgMy4xNjY2M0MxMy4yNjMgMi45NTg1NSAxMy4yNDE1IDIuNjQyNyAxMy4wMzM0IDIuNDYxMTVDMTIuODI1MyAyLjI3OTYxIDEyLjUwOTUgMi4zMDExMSAxMi4zMjc5IDIuNTA5MTlMNy4xNzM1OCA4LjQxNjY3TDYuNzQ3OTQgNy45OTkzNEM2LjU1MDc3IDcuODA2MDEgNi4yMzQyIDcuODA5MTIgNi4wNDA4NyA4LjAwNjNDNS44NDc1NCA4LjIwMzQ4IDUuODUwNjYgOC41MjAwNCA2LjA0NzgzIDguNzEzMzdMNi44NTE4NyA5LjUwMTcyQzYuOTUwMTYgOS41OTgwOSA3LjA4MzgzIDkuNjQ5NjggNy4yMjEzOCA5LjY0NDMzQzcuMzU4OTIgOS42Mzg5NyA3LjQ4ODE4IDkuNTc3MTUgNy41Nzg2OCA5LjQ3MzQzTDEzLjA4MTQgMy4xNjY2M1oiIGZpbGw9IiM5QzlDQTMiLz4KPC9nPgo8L3N2Zz4K", ns = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxIDNMMTMuOCAxMC4yIiBzdHJva2U9IiM4MDgwODAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjIgMTkuMlYxMy44SDQuODAwMDUiIHN0cm9rZT0iIzgwODA4MCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMuOCA0LjhWMTAuMkgxOS4yIiBzdHJva2U9IiM4MDgwODAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjIgMTMuOEwzIDIxIiBzdHJva2U9IiM4MDgwODAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", Ha = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgaGVpZ2h0PSIyNHB4IiB3aWR0aD0iMjRweCI+PGcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgLTEgMjQgMjQpIj48ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHRyYW5zZm9ybT0ibWF0cml4KDAgMSAtMSAwIDI0IC0wKSI+PHRpdGxlPkljb25zLzI0L0Nsb3NlIENoYXQ8L3RpdGxlPjxnIGlkPSJJY29ucyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48ZyBpZD0iSWNvbnMvMjQvQ2xvc2UtQ2hhdCIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSI+PGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjcwMDAwMCwgOC4wMDAwMDApIj48cGF0aCBkPSJNMjAuNjI1LDAgTDEwLjc5ODMzMzMsOS44MjU3NSBDMTAuNjY5NTQ2LDkuOTU0NzIwOSAxMC40OTQ3NjI3LDEwLjAyNzE5MTUgMTAuMzEyNSwxMC4wMjcxOTE1IEMxMC4xMzAyMzczLDEwLjAyNzE5MTUgOS45NTU0NTQwMSw5Ljk1NDcyMDkgOS44MjY2NjY2Nyw5LjgyNTc1IEwwLDAiIGlkPSJQYXRoIj48L3BhdGg+PC9nPjwvZz48L2c+PC9nPjwvZz48L3N2Zz4=", Yn = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuOTU5OCAxMS41MzFDNS40Nzk1OCAxMi43NTQxIDYuNDYzOSAxMy43MjA1IDcuNjk2MjUgMTQuMjE3OEM4LjkyODU5IDE0LjcxNTEgMTAuMzA4IDE0LjcwMjQgMTEuNTMxIDE0LjE4MjZDMTIuNzU0IDEzLjY2MjkgMTMuNzIwNSAxMi42Nzg1IDE0LjIxNzggMTEuNDQ2MkMxNC43MTUgMTAuMjEzOSAxNC43MDI0IDguODM0NDUgMTQuMTgyNiA3LjYxMTQyQzEzLjY2MjkgNi4zODg0IDEyLjY3ODUgNS40MjE5NSAxMS40NDYyIDQuOTI0NjdDMTAuMjEzOCA0LjQyNzQgOC44MzQ0NCA0LjQ0MDA0IDcuNjExNDEgNC45NTk4MUM2LjM4ODM5IDUuNDc5NTkgNS40MjE5NCA2LjQ2MzkxIDQuOTI0NjcgNy42OTYyNkM0LjQyNzM5IDguOTI4NiA0LjQ0MDAzIDEwLjMwOCA0Ljk1OTggMTEuNTMxVjExLjUzMVoiIHN0cm9rZT0iIzgwODA4MCIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEzLjExNCAxMy4xMTM5TDE3LjAwMDEgMTcuMDAwNSIgc3Ryb2tlPSIjODA4MDgwIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", yi = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvU2VuZDwvdGl0bGU+CiAgICA8ZyBpZD0iSWNvbnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9Ikljb25zLzI0L1NlbmQiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjUiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMuMDAwMDAwLCAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTAuMTU4ODY1OTIxLDEuODU5ODU4NTkgQy0wLjEwODE4MjY5OCwxLjM4MjAyMTk3IC0wLjAzMzI2MjI1NjcsMC43ODYwMTcwNzUgMC4zNDM3NDE2MzcsMC4zODkxNDA3MDEgQzAuNzIwNzQ1NTMsLTAuMDA3NzM1NjczNjYgMS4zMTIxMTk2OSwtMC4xMTMxNDY4MzYgMS44MDMwMzI1OSwwLjEyOTAyNTI1MiBMMTcuNjQ4MDMyNiw4LjE3ODE5MTkyIEMxNy44NTc2NjIsOC4yODQ4MTMyOSAxNy45ODk2ODk4LDguNTAwMDg4OTIgMTcuOTg5Njg5OCw4LjczNTI3NTI1IEMxNy45ODk2ODk4LDguOTcwNDYxNTggMTcuODU3NjYyLDkuMTg1NzM3MjEgMTcuNjQ4MDMyNiw5LjI5MjM1ODU5IEwxLjgwMzAzMjU5LDE3LjM1MjM1ODYgQzEuMzEyMTE5NjksMTcuNTk0NTMwNyAwLjcyMDc0NTUzLDE3LjQ4OTExOTUgMC4zNDM3NDE2MzcsMTcuMDkyMjQzMSBDLTAuMDMzMjYyMjU2NywxNi42OTUzNjY4IC0wLjEwODE4MjY5OCwxNi4wOTkzNjE5IDAuMTU4ODY1OTIxLDE1LjYyMTUyNTMgTDQuMzczODY1OTIsOC43MzQ4NTg1OSBMMC4xNTg4NjU5MjEsMS44NTk4NTg1OSBaIiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjE3Ljk4OTY5OTMiIHkxPSI4LjczNDg1ODU5IiB4Mj0iNC4zNjk2OTkyNSIgeTI9IjguNzM0ODU4NTkiIGlkPSJQYXRoIj48L2xpbmU+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==", os = "data:image/svg+xml;base64,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", Za = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMSAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzUzOF8zNTAzKSI+CjxwYXRoIGQ9Ik0yLjI5MTc1IDYuMDAwNjVMNC41ODM0MSA4LjI5MjMyTDkuMTY2NzUgMy43MDg5OCIgc3Ryb2tlPSIjQTZBNkE2IiBzdHJva2Utd2lkdGg9IjAuOCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNTM4XzM1MDMiPgo8cmVjdCB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuNSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", Pz = "data:image/svg+xml;base64,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", is = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvTmV3PC90aXRsZT4KICAgIDxnIGlkPSJJY29ucyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8ZyBpZD0iSWNvbnMvMjQvTmV3IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41Ij4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjAwMDAwMCwgMS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMC45Mjg4ODIyLDExLjg5OTAzMTcgTDcuNjI5MzI4NjYsMTIuMzcxMDEwNCBMOC4xMDA0Mzk0OCw5LjA3MDcxNDY2IEwxNi41ODU3Njc2LDAuNTg1NzYzNjMyIEMxNy4zNjY4MjA1LC0wLjE5NTI1NDU0NCAxOC42MzMxNTc0LC0wLjE5NTI1NDU0NCAxOS40MTQyMTAzLDAuNTg1NzYzNjMyIEMyMC4xOTUyNjMyLDEuMzY2NzgxODEgMjAuMTk1MjYzMiwyLjYzMzA2MjQ3IDE5LjQxNDIxMDMsMy40MTQwODA2NCBMMTAuOTI4ODgyMiwxMS44OTkwMzE3IFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iMTUuNjQyNjU3MSIgeTE9IjEuNTI4ODMyMjUiIHgyPSIxOC40NzEwOTk4IiB5Mj0iNC4zNTcxNDkyNiIgaWQ9IlBhdGgiPjwvbGluZT4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNiwxMi4wMDAzNjA0IEwxNiwxOC42NjY3MjY3IEMxNiwxOS40MDMwNzMyIDE1LjQwMzAzNjksMjAgMTQuNjY2NjU3NywyMCBMMS4zMzMzMzI1MiwyMCBDMC41OTY5NTMzMDEsMjAgMCwxOS40MDMwNzMyIDAsMTguNjY2NzI2NyBMMCw1LjMzMzk5NDE0IEMwLDQuNTk3NjQ3NjUgMC41OTY5NTMzMDEsNC4wMDA3MjA4OCAxLjMzMzMzMjUyLDQuMDAwNzIwODggTDgsNC4wMDA3MjA4OCIgaWQ9IlBhdGgiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+", Wa = "data:image/svg+xml;base64,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", as = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCI+PHBhdGggZD0iTSAxMiAyIEMgNi40NzcgMiAyIDYuNDc3IDIgMTIgQyAyIDE3LjUyMyA2LjQ3NyAyMiAxMiAyMiBDIDE3LjUyMyAyMiAyMiAxNy41MjMgMjIgMTIgQyAyMiA2LjQ3NyAxNy41MjMgMiAxMiAyIHogTSAxMiA0IEMgMTYuNDExIDQgMjAgNy41ODkgMjAgMTIgQyAyMCAxNi40MTEgMTYuNDExIDIwIDEyIDIwIEMgNy41ODkgMjAgNCAxNi40MTEgNCAxMiBDIDQgNy41ODkgNy41ODkgNCAxMiA0IHogTSA4IDggTCA4IDE2IEwgMTYgMTYgTCAxNiA4IEwgOCA4IHoiLz48L3N2Zz4=", Fz = "data:image/svg+xml;base64,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", $a = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+SWNvbnMvMjQvdGhyZWFkaWNvbjwvdGl0bGU+CiAgICA8ZyBpZD0iSWNvbnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9Ikljb25zLzI0L1RocmVhZCIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjEuNSI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi4wMDAwMDAsIDIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTAuNjU3ODIzNiwwIEM3LjI3MzM2ODIsLTAuMDA0ODcwMDE3OTkgNC4xNTI3MTY2OSwxLjgyODQwMDQxIDIuNTA3MDcyODIsNC43ODgyODY2NSBDMC44NjE0Mjg5NTIsNy43NDgxNzI4OSAwLjk0OTkwOTM0MywxMS4zNjg2MjI5IDIuNzM4MTcyNTIsMTQuMjQ0NDQ4NSBMMCwyMCBMNS43NDk4OTU4NCwxNy4yNTk1NTc1IEM5LjExMjU5NzI1LDE5LjM1MjAyMjYgMTMuNDI4OTY5OSwxOS4wOTEwMzI1IDE2LjUxNTUwODMsMTYuNjA4NjEzMiBDMTkuNjAyMDQ2OCwxNC4xMjYxOTM5IDIwLjc4NTcwNjksOS45NjM2NTY1IDE5LjQ2NzcxNTQsNi4yMjY2ODY0OSBDMTguMTQ5NzIzOSwyLjQ4OTcxNjQ3IDE0LjYxNzQ3OTQsLTAuMDA2ODEwMjA4NzQgMTAuNjU3ODIzNiwwIFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iNi42NTkzNjM0NiIgeTE9IjYuNjY2Njc1OTciIHgyPSIxNC42NTI3MzEyIiB5Mj0iNi42NjY2NzU5NyIgaWQ9IlBhdGgiPjwvbGluZT4KICAgICAgICAgICAgICAgIDxsaW5lIHgxPSI1LjMyNzEzNTUiIHkxPSI5LjMzMzM0MDc4IiB4Mj0iMTUuOTg0OTU5MSIgeTI9IjkuMzMzMzQwNzgiIGlkPSJQYXRoIj48L2xpbmU+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iNi42NTkzNjM0NiIgeTE9IjEyLjAwMDAwNTYiIHgyPSIxNC42NTI3MzEyIiB5Mj0iMTIuMDAwMDA1NiIgaWQ9IlBhdGgiPjwvbGluZT4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+", rs = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwODAwXzMzMTA0KSI+CjxwYXRoIGQ9Ik0xMy45OTA2IDEuNjk2MTdDMTMuODI0IDQuMTIzNTggMTIuNzQwMSA2LjM5NjY3IDEwLjk1OSA4LjA1NDIzQzkuMTc3NzYgOS43MTE3OSA2LjgzMjY2IDEwLjYyOTYgNC4zOTk1NSAxMC42MjE1QzQuMjM3NDggMTAuNjIxNSAzLjg0OTY1IDEwLjYyOTcgMy42ODc5OSAxMC42MjE1SDEuMDM2NDUiIHN0cm9rZT0iI0ExQTVBQyIgc3Ryb2tlLXdpZHRoPSIxLjg3NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00LjIwNDEgNy40MzA0MkwxLjAwOTQgMTAuNjI1MUw0LjIwNDEgMTMuODE5OCIgc3Ryb2tlPSIjQTFBNUFDIiBzdHJva2Utd2lkdGg9IjEuODc1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMDgwMF8zMzEwNCI+CjxyZWN0IHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDE1IDApIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==", ls = "data:image/svg+xml;base64,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", Hz = "data:image/svg+xml;base64,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", Zz = "data:image/svg+xml;base64,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", Wz = "data:image/svg+xml;base64,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", Ja = "data:image/svg+xml;base64,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", Ka = "data:image/svg+xml;base64,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", ss = "data:image/svg+xml;base64,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", Xa = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMDEwNTcgOC4wNDcyOEM4LjM0NzUzIDkuOTkyMTMgOS41MzE3NyAxMS4zMjQyIDExLjYyMzkgMTJDMTMuNzE2IDExLjMyNDIgMTQuOTAwMiA5Ljk5MjEzIDE1LjIzNzIgOC4wNDcyOEMxNS4yNTcyIDcuOTE3MzEgMTUuMjQ4OCA3Ljc4NDU1IDE1LjIxMjUgNy42NTgxNkMxNS4xNzYyIDcuNTMxNzcgMTUuMTEyOSA3LjQxNDc2IDE1LjAyNyA3LjMxNTJDMTQuOTQxMSA3LjIxNTY0IDE0LjgzNDYgNy4xMzU5IDE0LjcxNDkgNy4wODE0OUMxNC41OTUyIDcuMDI3MDcgMTQuNDY1MSA2Ljk5OTI4IDE0LjMzMzYgNy4wMDAwMUg4LjkxNDJDOC43ODI3IDYuOTk5MjggOC42NTI2MSA3LjAyNzA3IDguNTMyOSA3LjA4MTQ5QzguNDEzMTkgNy4xMzU5IDguMzA2NzEgNy4yMTU2NCA4LjIyMDggNy4zMTUyQzguMTM0OSA3LjQxNDc2IDguMDcxNjEgNy41MzE3NyA4LjAzNTMyIDcuNjU4MTZDNy45OTkwMiA3Ljc4NDU1IDcuOTkwNTggNy45MTczMSA4LjAxMDU3IDguMDQ3MjhaIiBmaWxsPSIjODA4MDgwIiBzdHJva2U9IiM4MDgwODAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguOTE0MjMgMTdDOC43ODI3OSAxNy4wMDA3IDguNjUyNzYgMTYuOTcyOSA4LjUzMzEgMTYuOTE4NUM4LjQxMzQzIDE2Ljg2NDIgOC4zMDY5OSAxNi43ODQ1IDguMjIxMDkgMTYuNjg1QzguMTM1MiAxNi41ODU1IDguMDcxOSAxNi40Njg2IDguMDM1NTYgMTYuMzQyM0M3Ljk5OTIyIDE2LjIxNTkgNy45OTA3IDE2LjA4MzIgOC4wMTA1OSAxNS45NTMzQzguMzQ3NTYgMTQuMDA4NSA5LjUzMTggMTIuNjc2NCAxMS42MjM5IDEyQzEzLjcxNiAxMi42NzY0IDE0LjkwMDMgMTQuMDA4NSAxNS4yMzcyIDE1Ljk1MzNDMTUuMjU3MSAxNi4wODMyIDE1LjI0ODYgMTYuMjE1OSAxNS4yMTIzIDE2LjM0MjNDMTUuMTc1OSAxNi40Njg2IDE1LjExMjYgMTYuNTg1NSAxNS4wMjY3IDE2LjY4NUMxNC45NDA4IDE2Ljc4NDUgMTQuODM0NCAxNi44NjQyIDE0LjcxNDcgMTYuOTE4NUMxNC41OTUxIDE2Ljk3MjkgMTQuNDY1IDE3LjAwMDcgMTQuMzMzNiAxN0g4LjkxNDIzWiIgc3Ryb2tlPSIjODA4MDgwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", Oi = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxOCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguOTk5OTIgMTFDOC45NjY5NSAxMSA4LjkzNDczIDExLjAwOTggOC45MDczMiAxMS4wMjgxQzguODc5OTIgMTEuMDQ2NCA4Ljg1ODU1IDExLjA3MjQgOC44NDU5NCAxMS4xMDI5QzguODMzMzIgMTEuMTMzMyA4LjgzMDAyIDExLjE2NjkgOC44MzY0NSAxMS4xOTkyQzguODQyODkgMTEuMjMxNSA4Ljg1ODc2IDExLjI2MTIgOC44ODIwNyAxMS4yODQ1QzguOTA1MzggMTEuMzA3OCA4LjkzNTA3IDExLjMyMzcgOC45Njc0IDExLjMzMDFDOC45OTk3MyAxMS4zMzY2IDkuMDMzMjQgMTEuMzMzMyA5LjA2MzcgMTEuMzIwNkM5LjA5NDE1IDExLjMwOCA5LjEyMDE4IDExLjI4NjcgOS4xMzg1IDExLjI1OTNDOS4xNTY4MSAxMS4yMzE5IDkuMTY2NTkgMTEuMTk5NiA5LjE2NjU5IDExLjE2NjdDOS4xNjY1OSAxMS4xMjI1IDkuMTQ5MDMgMTEuMDgwMSA5LjExNzc3IDExLjA0ODhDOS4wODY1MSAxMS4wMTc2IDkuMDQ0MTIgMTEgOC45OTk5MiAxMVoiIHN0cm9rZT0iI2ZmM2IzMCIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOSA5LjY2NjY3VjYiIHN0cm9rZT0iI2ZmM2IzMCIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNNCA5QzQgMTAuMzI2MSA0LjUyNjc4IDExLjU5NzkgNS40NjQ0NyAxMi41MzU1QzYuNDAyMTUgMTMuNDczMiA3LjY3MzkyIDE0IDkgMTRDMTAuMzI2MSAxNCAxMS41OTc5IDEzLjQ3MzIgMTIuNTM1NSAxMi41MzU1QzEzLjQ3MzIgMTEuNTk3OSAxNCAxMC4zMjYxIDE0IDlDMTQgNy42NzM5MiAxMy40NzMyIDYuNDAyMTUgMTIuNTM1NSA1LjQ2NDQ3QzExLjU5NzkgNC41MjY3OCAxMC4zMjYxIDQgOSA0QzcuNjczOTIgNCA2LjQwMjE1IDQuNTI2NzggNS40NjQ0NyA1LjQ2NDQ3QzQuNTI2NzggNi40MDIxNSA0IDcuNjczOTIgNCA5VjlaIiBzdHJva2U9IiNmZjNiMzAiIHN0cm9rZS13aWR0aD0iMS4yIi8+Cjwvc3ZnPgo=", la = "data:image/svg+xml;base64,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", Ms = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICAgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJmZWF0aGVyIGZlYXRoZXItY29ybmVyLXJpZ2h0LWRvd24iPjxwb2x5bGluZSBwb2ludHM9IjEwIDE1IDE1IDIwIDIwIDE1Ij48L3BvbHlsaW5lPjxwYXRoIGQ9Ik00IDRoN2E0IDQgMCAwIDEgNCA0djEyIj48L3BhdGg+PC9zdmc+", us = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkZyYW1lIiBjbGlwLXBhdGg9InVybCgjY2xpcDBfODkwNF83MjM3NykiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNNi42NjY3NSA5Ljk5OTg0QzYuNjY2NzUgMTAuODgzOSA3LjAxNzk0IDExLjczMTcgNy42NDMwNiAxMi4zNTY5QzguMjY4MTggMTIuOTgyIDkuMTE2MDMgMTMuMzMzMiAxMC4wMDAxIDEzLjMzMzJDMTAuODg0MSAxMy4zMzMyIDExLjczMiAxMi45ODIgMTIuMzU3MSAxMi4zNTY5QzEyLjk4MjIgMTEuNzMxNyAxMy4zMzM0IDEwLjg4MzkgMTMuMzMzNCA5Ljk5OTg0QzEzLjMzMzQgOS4xMTU3OCAxMi45ODIyIDguMjY3OTQgMTIuMzU3MSA3LjY0MjgxQzExLjczMiA3LjAxNzY5IDEwLjg4NDEgNi42NjY1IDEwLjAwMDEgNi42NjY1QzkuMTE2MDMgNi42NjY1IDguMjY4MTggNy4wMTc2OSA3LjY0MzA2IDcuNjQyODFDNy4wMTc5NCA4LjI2Nzk0IDYuNjY2NzUgOS4xMTU3OCA2LjY2Njc1IDkuOTk5ODRaIiBzdHJva2U9IiMzMzk5RkYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlZlY3Rvcl8yIiBkPSJNMTMuMzMzMyA5Ljk5OTg3VjExLjI0OTlDMTMuMzMzMyAxMS44MDI0IDEzLjU1MjggMTIuMzMyMyAxMy45NDM1IDEyLjcyM0MxNC4zMzQyIDEzLjExMzcgMTQuODY0MSAxMy4zMzMyIDE1LjQxNjcgMTMuMzMzMkMxNS45NjkyIDEzLjMzMzIgMTYuNDk5MSAxMy4xMTM3IDE2Ljg4OTggMTIuNzIzQzE3LjI4MDUgMTIuMzMyMyAxNy41IDExLjgwMjQgMTcuNSAxMS4yNDk5VjkuOTk5ODdDMTcuNTAyMSA4LjM4ODI5IDE2Ljk4NSA2LjgxODkxIDE2LjAyNTMgNS41MjQyQzE1LjA2NTcgNC4yMjk0OSAxMy43MTQ1IDMuMjc4MzMgMTIuMTcyIDIuODExNjJDMTAuNjI5NSAyLjM0NDkxIDguOTc3NjQgMi4zODc0NyA3LjQ2MTIgMi45MzMwMUM1Ljk0NDc2IDMuNDc4NTQgNC42NDQzNyA0LjQ5ODAyIDMuNzUyNjcgNS44NDA0NEMyLjg2MDk3IDcuMTgyODUgMi40MjUzOSA4Ljc3Njc4IDIuNTEwNDYgMTAuMzg2MUMyLjU5NTUzIDExLjk5NTUgMy4xOTY3MSAxMy41MzQ2IDQuMjI0OTYgMTQuNzc1NUM1LjI1MzIxIDE2LjAxNjQgNi42NTM4MyAxNi44OTMyIDguMjE5MzMgMTcuMjc1OEM5Ljc4NDgzIDE3LjY1ODQgMTEuNDMxOSAxNy41MjY2IDEyLjkxNjcgMTYuODk5OSIgc3Ryb2tlPSIjMzM5OUZGIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfODkwNF83MjM3NyI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", gs = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMC4wMDAxIDAuNjY2NjI2QzQ2LjIwMDQgMC42NjY2MjYgNTkuMzMzNCAxMy43OTk2IDU5LjMzMzQgMzBDNTkuMzMzNCA0Ni4yMDAzIDQ2LjIwMDQgNTkuMzMzMyAzMC4wMDAxIDU5LjMzMzNDMTMuNzk5NyA1OS4zMzMzIDAuNjY2NzQ4IDQ2LjIwMDMgMC42NjY3NDggMzBDMC42NjY3NDggMTMuNzk5NiAxMy43OTk3IDAuNjY2NjI2IDMwLjAwMDEgMC42NjY2MjZaTTMwLjAwMDEgNS45OTk5NkMxNi43NDUyIDUuOTk5OTYgNi4wMDAwOCAxNi43NDUxIDYuMDAwMDggMzBDNi4wMDAwOCA0My4yNTQ4IDE2Ljc0NTIgNTQgMzAuMDAwMSA1NEM0My4yNTQ5IDU0IDU0LjAwMDEgNDMuMjU0OCA1NC4wMDAxIDMwQzU0LjAwMDEgMTYuNzQ1MSA0My4yNTQ5IDUuOTk5OTYgMzAuMDAwMSA1Ljk5OTk2Wk0zMS42NjY3IDI3LjMzMzNDMzIuMjE5IDI3LjMzMzMgMzIuNjY2NyAyNy43ODEgMzIuNjY2NyAyOC4zMzMzVjQyLjMzMzNDMzIuNjY2NyA0Mi44ODU2IDMyLjIxOSA0My4zMzMzIDMxLjY2NjcgNDMuMzMzM0gyOC4zMzM0QzI3Ljc4MTEgNDMuMzMzMyAyNy4zMzM0IDQyLjg4NTYgMjcuMzMzNCA0Mi4zMzMzVjI4LjMzMzNDMjcuMzMzNCAyNy43ODEgMjcuNzgxMSAyNy4zMzMzIDI4LjMzMzQgMjcuMzMzM0gzMS42NjY3Wk0zMC4wMDAxIDE5LjMzMzNDMzEuNDcyOCAxOS4zMzMzIDMyLjY2NjcgMjAuNTI3MiAzMi42NjY3IDIyQzMyLjY2NjcgMjMuNDcyNyAzMS40NzI4IDI0LjY2NjYgMzAuMDAwMSAyNC42NjY2QzI4LjUyNzMgMjQuNjY2NiAyNy4zMzM0IDIzLjQ3MjcgMjcuMzMzNCAyMkMyNy4zMzM0IDIwLjUyNzIgMjguNTI3MyAxOS4zMzMzIDMwLjAwMDEgMTkuMzMzM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgoK", sa = new Ke({});
class qe {
  getEditOption(t) {
    return new go({
      id: I.MessageOption.editMessage,
      title: Y("EDIT"),
      iconURL: Vl,
      onClick: void 0,
      iconTint: t.palette.getAccent600(),
      backgroundColor: "transparent",
      titleFont: w(t.typography.subtitle1),
      titleColor: t.palette.getAccent600()
    });
  }
  getDeleteOption(t) {
    return new go({
      id: I.MessageOption.deleteMessage,
      title: Y("DELETE"),
      iconURL: Qa,
      onClick: void 0,
      iconTint: t.palette.getAccent600(),
      backgroundColor: "transparent",
      titleFont: w(t.typography.subtitle1),
      titleColor: t.palette.getAccent600()
    });
  }
  getReactionOption(t) {
    return new go({
      id: I.MessageOption.reactToMessage,
      title: Y("REACT"),
      iconURL: ts,
      onClick: void 0,
      iconTint: t.palette.getAccent600(),
      backgroundColor: "transparent",
      titleFont: w(t.typography.subtitle1),
      titleColor: t.palette.getAccent600()
    });
  }
  getReplyInThreadOption(t) {
    return new go({
      id: I.MessageOption.replyInThread,
      title: Y("REPLY"),
      iconURL: $a,
      onClick: void 0,
      iconTint: t.palette.getAccent600(),
      backgroundColor: "transparent",
      titleFont: w(t.typography.subtitle1),
      titleColor: t.palette.getAccent600()
    });
  }
  getSendMessagePrivatelyOption(t) {
    return new go({
      id: I.MessageOption.sendMessagePrivately,
      title: Y("MESSAGE_PRIVATELY"),
      iconURL: os,
      onClick: void 0,
      iconTint: t.palette.getAccent600(),
      backgroundColor: "transparent",
      titleFont: w(t.typography.subtitle1),
      titleColor: t.palette.getAccent600()
    });
  }
  getMessageInformationOption(t) {
    return new go({
      id: I.MessageOption.messageInformation,
      title: Y("INFO"),
      iconURL: hi,
      onClick: void 0,
      iconTint: t.palette.getAccent600(),
      backgroundColor: "transparent",
      titleFont: w(t.typography.subtitle1),
      titleColor: t.palette.getAccent600()
    });
  }
  getCopyOption(t) {
    return new go({
      id: I.MessageOption.copyMessage,
      title: Y("COPY"),
      iconURL: Rl,
      onClick: void 0,
      iconTint: t.palette.getAccent600(),
      backgroundColor: "transparent",
      titleFont: w(t.typography.subtitle1),
      titleColor: t.palette.getAccent600()
    });
  }
  isSentByMe(t, n) {
    return !n.getSender() || t.getUid() === n.getSender().getUid();
  }
  getTextMessageOptions(t, n, o, i) {
    const l = this.isSentByMe(t, n);
    let r = !1;
    (i == null ? void 0 : i.getScope()) === I.groupMemberScope.participant && (r = !0);
    const u = [];
    return u.push(this.getReactionOption(o)), n.getParentMessageId() || u.push(this.getReplyInThreadOption(o)), u.push(this.getCopyOption(o)), (l || !r && i) && u.push(this.getEditOption(o)), l && u.push(this.getMessageInformationOption(o)), (l || !r && i) && u.push(this.getDeleteOption(o)), i && !l && u.push(this.getSendMessagePrivatelyOption(o)), u;
  }
  getImageMessageOptions(t, n, o, i) {
    let l = [];
    return l = Ne.getDataSource().getCommonOptions(
      t,
      n,
      o,
      i
    ), l;
  }
  getVideoMessageOptions(t, n, o, i) {
    let l = [];
    return l = Ne.getDataSource().getCommonOptions(
      t,
      n,
      o,
      i
    ), l;
  }
  getAudioMessageOptions(t, n, o, i) {
    let l = [];
    return l = Ne.getDataSource().getCommonOptions(
      t,
      n,
      o,
      i
    ), l;
  }
  getFileMessageOptions(t, n, o, i) {
    let l = [];
    return l = Ne.getDataSource().getCommonOptions(
      t,
      n,
      o,
      i
    ), l;
  }
  getBottomView(t, n) {
    return null;
  }
  getTextMessageTemplate(t, n) {
    return new Mn({
      type: I.MessageTypes.text,
      category: I.MessageCategory.message,
      contentView: (o, i) => {
        const l = o;
        return l.getDeletedAt() != null ? this.getDeleteMessageBubble(l, t) : Ne.getDataSource().getTextMessageContentView(
          l,
          i,
          t,
          n
        );
      },
      options: Ne.getDataSource().getMessageOptions,
      bottomView: (o, i) => Ne.getDataSource().getBottomView(
        o,
        i
      )
    });
  }
  getAudioMessageTemplate(t) {
    return new Mn({
      type: I.MessageTypes.audio,
      category: I.MessageCategory.message,
      contentView: (n, o) => {
        const i = n;
        return i.getDeletedAt() != null ? this.getDeleteMessageBubble(n, t) : Ne.getDataSource().getAudioMessageContentView(
          i,
          o,
          t
        );
      },
      options: Ne.getDataSource().getMessageOptions,
      bottomView: (n, o) => Ne.getDataSource().getBottomView(
        n,
        o
      )
    });
  }
  getVideoMessageTemplate(t) {
    return new Mn({
      type: I.MessageTypes.video,
      category: I.MessageCategory.message,
      contentView: (n, o) => {
        const i = n;
        return i.getDeletedAt() != null ? this.getDeleteMessageBubble(n, t) : Ne.getDataSource().getVideoMessageContentView(
          i,
          o,
          t
        );
      },
      options: Ne.getDataSource().getMessageOptions,
      bottomView: (n, o) => Ne.getDataSource().getBottomView(
        n,
        o
      )
    });
  }
  getImageMessageTemplate(t) {
    return new Mn({
      type: I.MessageTypes.image,
      category: I.MessageCategory.message,
      contentView: (n, o) => {
        const i = n;
        return i.getDeletedAt() != null ? this.getDeleteMessageBubble(n, t) : Ne.getDataSource().getImageMessageContentView(
          i,
          o,
          t
        );
      },
      options: Ne.getDataSource().getMessageOptions,
      bottomView: (n, o) => Ne.getDataSource().getBottomView(
        n,
        o
      )
    });
  }
  getGroupActionTemplate(t) {
    return new Mn({
      type: I.MessageTypes.groupMember,
      category: I.MessageCategory.action,
      contentView: (n, o) => this.getGroupActionBubble(n, t)
    });
  }
  getFileMessageTemplate(t) {
    return new Mn({
      type: I.MessageTypes.file,
      category: I.MessageCategory.message,
      contentView: (n, o) => {
        const i = n;
        return i.getDeletedAt() != null ? this.getDeleteMessageBubble(n, t) : Ne.getDataSource().getFileMessageContentView(
          i,
          o,
          t
        );
      },
      options: Ne.getDataSource().getMessageOptions,
      bottomView: (n, o) => Ne.getDataSource().getBottomView(
        n,
        o
      )
    });
  }
  getFormMessageTemplate(t) {
    return new Mn({
      type: I.MessageTypes.form,
      category: I.MessageCategory.interactive,
      contentView: (n, o) => {
        const i = n;
        return i.getDeletedAt() != null ? this.getDeleteMessageBubble(n, t) : Ne.getDataSource().getFormMessageContentView(
          i,
          o,
          t
        );
      },
      options: Ne.getDataSource().getMessageOptions,
      bottomView: (n, o) => Ne.getDataSource().getBottomView(
        n,
        o
      )
    });
  }
  getCardMessageTemplate(t) {
    return new Mn({
      type: I.MessageTypes.card,
      category: I.MessageCategory.interactive,
      contentView: (n, o) => {
        const i = n;
        return i.getDeletedAt() != null ? this.getDeleteMessageBubble(n, t) : Ne.getDataSource().getCardMessageContentView(
          i,
          o,
          t
        );
      },
      options: Ne.getDataSource().getMessageOptions,
      bottomView: (n, o) => Ne.getDataSource().getBottomView(
        n,
        o
      )
    });
  }
  getSchedulerMessageTemplate(t) {
    return new Mn({
      type: I.MessageTypes.scheduler,
      category: I.MessageCategory.interactive,
      contentView: (n, o) => {
        const i = n;
        return i.getDeletedAt() != null ? this.getDeleteMessageBubble(n, t) : Ne.getDataSource().getSchedulerMessageContentView(
          i,
          o,
          t
        );
      },
      options: Ne.getDataSource().getMessageOptions,
      bottomView: (n, o) => Ne.getDataSource().getBottomView(
        n,
        o
      )
    });
  }
  getAllMessageTemplates(t, n) {
    const o = t ?? sa;
    return n || (n = {
      disableMentions: !1
    }), [
      Ne.getDataSource().getTextMessageTemplate(
        o,
        n
      ),
      Ne.getDataSource().getImageMessageTemplate(o),
      Ne.getDataSource().getVideoMessageTemplate(o),
      Ne.getDataSource().getAudioMessageTemplate(o),
      Ne.getDataSource().getFileMessageTemplate(o),
      Ne.getDataSource().getGroupActionTemplate(o),
      Ne.getDataSource().getFormMessageTemplate(o),
      Ne.getDataSource().getCardMessageTemplate(o),
      Ne.getDataSource().getSchedulerMessageTemplate(o)
    ];
  }
  getMessageTemplate(t, n, o, i) {
    const l = o ?? sa;
    i || (i = {
      disableMentions: !1
    });
    let r = null;
    if (n != I.MessageCategory.call)
      switch (t) {
        case I.MessageTypes.text:
          r = Ne.getDataSource().getTextMessageTemplate(l, i);
          break;
        case I.MessageTypes.image:
          r = Ne.getDataSource().getImageMessageTemplate(l);
          break;
        case I.MessageTypes.video:
          r = Ne.getDataSource().getVideoMessageTemplate(l);
          break;
        case I.MessageTypes.groupMember:
          r = Ne.getDataSource().getGroupActionTemplate(l);
          break;
        case I.MessageTypes.file:
          r = Ne.getDataSource().getFileMessageTemplate(l);
          break;
        case I.MessageTypes.form:
          r = Ne.getDataSource().getFormMessageTemplate(l);
          break;
        case I.MessageTypes.card:
          r = Ne.getDataSource().getCardMessageTemplate(l);
          break;
        case I.MessageTypes.scheduler:
          r = Ne.getDataSource().getSchedulerMessageTemplate(
            l
          );
          break;
        case I.MessageTypes.audio:
          r = Ne.getDataSource().getAudioMessageTemplate(l);
          break;
      }
    return r;
  }
  getMessageOptions(t, n, o, i) {
    let l = [];
    if (n.getCategory() === I.MessageCategory.message)
      switch (n.getType()) {
        case I.MessageTypes.text:
          l = Ne.getDataSource().getTextMessageOptions(
            t,
            n,
            o,
            i
          );
          break;
        case I.MessageTypes.image:
          l = Ne.getDataSource().getImageMessageOptions(
            t,
            n,
            o,
            i
          );
          break;
        case I.MessageTypes.video:
          l = Ne.getDataSource().getVideoMessageOptions(
            t,
            n,
            o,
            i
          );
          break;
        case I.MessageTypes.groupMember:
          l = [];
          break;
        case I.MessageTypes.file:
          l = Ne.getDataSource().getFileMessageOptions(
            t,
            n,
            o,
            i
          );
          break;
        case I.MessageTypes.audio:
          l = Ne.getDataSource().getAudioMessageOptions(
            t,
            n,
            o,
            i
          );
          break;
        default:
          l = Ne.getDataSource().getCommonOptions(
            t,
            n,
            o,
            i
          );
          break;
      }
    return l;
  }
  getCommonOptions(t, n, o, i) {
    const l = this.isSentByMe(t, n);
    let r = !1;
    (i == null ? void 0 : i.getScope()) === I.groupMemberScope.participant && (r = !0);
    const u = [];
    return u.push(this.getReactionOption(o)), n != null && n.getParentMessageId() || u.push(this.getReplyInThreadOption(o)), l && u.push(this.getMessageInformationOption(o)), (l || !r && i) && u.push(this.getDeleteOption(o)), i != null && i.getGuid() && !l && u.push(this.getSendMessagePrivatelyOption(o)), u;
  }
  getAllMessageTypes() {
    return [
      I.MessageTypes.text,
      I.MessageTypes.image,
      I.MessageTypes.audio,
      I.MessageTypes.video,
      I.MessageTypes.file,
      I.MessageTypes.groupMember,
      I.MessageTypes.form,
      I.MessageTypes.card,
      I.MessageTypes.scheduler
    ];
  }
  addList() {
    return "<Message Utils>";
  }
  getAllMessageCategories() {
    return [
      I.MessageCategory.message,
      I.MessageCategory.action,
      I.MessageCategory.interactive
    ];
  }
  getAuxiliaryOptions(t, n, o, i) {
    return [];
  }
  getId() {
    return "messageUtils";
  }
  getTextMessageContentView(t, n, o, i) {
    return Ne.getDataSource().getTextMessageBubble(
      t.getText(),
      t,
      n,
      o,
      null,
      i
    );
  }
  getAudioMessageContentView(t, n, o) {
    var i, l;
    return Ne.getDataSource().getAudioMessageBubble(
      (i = t == null ? void 0 : t.getAttachments()[0]) == null ? void 0 : i.getUrl(),
      t,
      o,
      (l = t == null ? void 0 : t.getAttachments()[0]) == null ? void 0 : l.getName()
    );
  }
  getFileMessageContentView(t, n, o) {
    var i, l;
    return Ne.getDataSource().getFileMessageBubble(
      (i = t == null ? void 0 : t.getAttachments()[0]) == null ? void 0 : i.getUrl(),
      t,
      o,
      (l = t == null ? void 0 : t.getAttachments()[0]) == null ? void 0 : l.getName()
    );
  }
  getFormMessageContentView(t, n, o) {
    return Ne.getDataSource().getFormMessageBubble(
      t,
      o
    );
  }
  getCardMessageContentView(t, n, o) {
    return Ne.getDataSource().getCardMessageBubble(
      t,
      o
    );
  }
  getSchedulerMessageContentView(t, n, o) {
    return Ne.getDataSource().getSchedulerMessageBubble(
      t,
      o
    );
  }
  getImageMessageContentView(t, n, o) {
    var i;
    return Ne.getDataSource().getImageMessageBubble(
      (i = t == null ? void 0 : t.getAttachments()[0]) == null ? void 0 : i.getUrl(),
      vi,
      t,
      o
    );
  }
  getVideoMessageContentView(t, n, o) {
    var i;
    return Ne.getDataSource().getVideoMessageBubble(
      (i = t == null ? void 0 : t.getAttachments()[0]) == null ? void 0 : i.getUrl(),
      t,
      o
    );
  }
  getActionMessage(t) {
    let n = "";
    if (Object.prototype.hasOwnProperty.call(t, "actionBy") == !1 || Object.prototype.hasOwnProperty.call(t, "actionOn") == !1 || t.action !== I.groupMemberAction.JOINED && t.action !== I.groupMemberAction.LEFT && (Object.prototype.hasOwnProperty.call(t.actionBy, "name") == !1 || Object.prototype.hasOwnProperty.call(t.actionOn, "name") == !1))
      return n;
    if (t.action === I.groupMemberAction.SCOPE_CHANGE)
      if (Object.prototype.hasOwnProperty.call(t, "data") && Object.prototype.hasOwnProperty.call(t.data, "extras"))
        if (Object.prototype.hasOwnProperty.call(t.data.extras, "scope")) {
          if (Object.prototype.hasOwnProperty.call(
            t.data.extras.scope,
            "new"
          ) === !1)
            return n;
        } else
          return n;
      else
        return n;
    if (t.action === I.groupMemberAction.SCOPE_CHANGE && Object.prototype.hasOwnProperty.call(t.data.extras, "scope") === !1 || t.action === I.groupMemberAction.SCOPE_CHANGE && Object.prototype.hasOwnProperty.call(t.data.extras.scope, "new") === !1)
      return n;
    const o = t.actionBy, i = t.actionOn, l = o.name, r = t.action !== I.groupMemberAction.JOINED && t.action !== I.groupMemberAction.LEFT ? i.name : "";
    switch (t.action) {
      case I.groupMemberAction.ADDED:
        n = `${l} ${Y("ADDED")} ${r}`;
        break;
      case I.groupMemberAction.JOINED:
        n = `${l} ${Y("JOINED")}`;
        break;
      case I.groupMemberAction.LEFT:
        n = `${l} ${Y("LEFT")}`;
        break;
      case I.groupMemberAction.KICKED:
        n = `${l} ${Y("KICKED")} ${r}`;
        break;
      case I.groupMemberAction.BANNED:
        n = `${l} ${Y("BANNED")} ${r}`;
        break;
      case I.groupMemberAction.UNBANNED:
        n = `${l} ${Y("UNBANNED")} ${r}`;
        break;
      case I.groupMemberAction.SCOPE_CHANGE: {
        const u = t.data.extras.scope.new;
        n = `${l} ${Y(
          "MADE"
        )} ${r} ${u}`;
        break;
      }
    }
    return n;
  }
  getDeleteMessageBubble(t, n, o) {
    let i;
    const l = Y("MESSAGE_IS_DELETED");
    return o || (i = {
      textFont: w(n.typography.text2),
      textColor: n.palette.getAccent400()
    }), {
      componentName: "CometChatTextBubble",
      props: {
        text: l,
        textStyle: o || i
      }
    };
  }
  getGroupActionBubble(t, n, o) {
    let i;
    const l = this.getActionMessage(t);
    return o || (i = {
      textFont: w(n.typography.subtitle2),
      textColor: n.palette.getAccent()
    }), {
      componentName: "CometChatTextBubble",
      props: {
        text: l,
        textStyle: o || i
      }
    };
  }
  getTextMessageBubbleStyle(t, n) {
    return t !== gt.left ? {
      textFont: w(n.typography.text3),
      textColor: n.palette.getAccent900("light")
    } : {
      textFont: w(n.typography.text3),
      textColor: n.palette.getAccent()
    };
  }
  getFormMessageBubbleStyle(t) {
    const n = new Dl({
      width: "100%",
      height: "30px",
      border: `1px solid ${t.palette.getAccent100()}`,
      borderRadius: "6px",
      padding: "0px 0px 0px 5px",
      placeholderTextColor: t.palette.getAccent400(),
      placeholderTextFont: w(t.typography.subtitle2),
      textFont: w(t.typography.subtitle2),
      textColor: t.palette.getAccent(),
      background: t.palette.getBackground()
    }), o = new fa({
      textFont: w(t.typography.subtitle1),
      textColor: t.palette.getAccent(),
      background: "transparent"
    }), i = new Ua({
      height: "16px",
      width: "16px",
      border: "none",
      labelTextFont: w(t.typography.subtitle2),
      labelTextColor: t.palette.getAccent600(),
      borderRadius: "4px",
      background: ""
    }), l = new yl({
      height: "16px",
      width: "16px",
      border: "none",
      borderRadius: "4px",
      background: "",
      labelTextFont: w(t.typography.subtitle2),
      labelTextColor: t.palette.getAccent()
    }), r = new Cl({
      height: "35px",
      width: "100%",
      background: t.palette.getBackground(),
      border: `1px solid ${t.palette.getAccent100()}`,
      borderRadius: "6px",
      activeTextFont: w(t.typography.subtitle2),
      activeTextColor: t.palette.getAccent(),
      arrowIconTint: t.palette.getAccent700(),
      textFont: w(t.typography.subtitle2),
      textColor: t.palette.getAccent(),
      optionBackground: t.palette.getBackground(),
      optionBorder: `1px solid ${t.palette.getAccent100()}`,
      optionHoverBorder: `1px solid ${t.palette.getAccent100()}`,
      hoverTextFont: w(t.typography.subtitle2),
      hoverTextColor: t.palette.getAccent(),
      hoverTextBackground: t.palette.getAccent100()
    }), u = {
      height: "40px",
      width: "100%",
      background: t.palette.getPrimary(),
      border: "none",
      borderRadius: "6px",
      buttonTextFont: w(t.typography.subtitle2),
      buttonTextColor: t.palette.getBackground(),
      justifyContent: "center"
    }, s = new wl({
      height: "100%",
      width: "100%",
      background: t.palette.getBackground(),
      border: "none",
      borderRadius: "12px",
      activeTextFont: w(t.typography.subtitle2),
      activeTextColor: t.palette.getAccent(),
      activeTextBackground: t.palette.getAccent100(),
      textFont: w(t.typography.subtitle2),
      textColor: t.palette.getAccent(),
      optionBackground: t.palette.getBackground(),
      optionBorder: `1px solid ${t.palette.getAccent100()}`,
      optionBorderRadius: "3px",
      hoverTextFont: w(t.typography.subtitle2),
      hoverTextColor: t.palette.getAccent(),
      hoverTextBackground: t.palette.getAccent100()
    }), c = new ia({
      background: "transparent",
      height: "fit-content",
      width: "100%",
      titleFont: w(t.typography.subtitle2),
      titleColor: t.palette.getPrimary(),
      subtitleFont: w(t.typography.subtitle2),
      subtitleColor: t.palette.getAccent600(),
      leadingBarTint: t.palette.getPrimary(),
      leadingBarWidth: "4px",
      borderRadius: "8px"
    });
    return new Er({
      width: "300px",
      height: "fit-content",
      border: "none",
      background: "transparent",
      wrapperBackground: t.palette.getBackground(),
      borderRadius: "8px",
      wrapperBorderRadius: "8px",
      textInputStyle: n,
      labelStyle: o,
      radioButtonStyle: i,
      checkboxStyle: l,
      dropdownStyle: r,
      buttonStyle: u,
      singleSelectStyle: s,
      quickViewStyle: c,
      titleColor: t.palette.getAccent(),
      titleFont: w(t.typography.title1),
      goalCompletionTextColor: t.palette.getAccent(),
      goalCompletionTextFont: w(t.typography.subtitle1),
      wrapperPadding: "2px",
      datePickerBorder: `1px solid ${t.palette.getAccent100()}`,
      datePickerBorderRadius: "6px",
      datePickerFont: w(t.typography.subtitle2),
      datePickerFontColor: t.palette.getAccent()
    });
  }
  getCardMessageBubbleStyle(t) {
    const n = {
      height: "40px",
      width: "100%",
      background: "transparent",
      border: "none",
      borderRadius: "0px",
      buttonTextFont: w(t.typography.subtitle2),
      buttonTextColor: `${t.palette.getPrimary()}`,
      justifyContent: "center"
    };
    return new hr({
      background: "transparent",
      borderRadius: "8px",
      height: "fit-content",
      width: "300px",
      imageHeight: "auto",
      imageWidth: "100%",
      imageRadius: "8px",
      imageBackgroundColor: "transparent",
      descriptionFontColor: t.palette.getAccent(),
      descriptionFont: w(t.typography.subtitle2),
      buttonStyle: n,
      dividerTintColor: t.palette.getAccent100(),
      wrapperBackground: t.palette.getBackground(),
      wrapperBorderRadius: "8px",
      wrapperPadding: "2px",
      disabledButtonColor: t.palette.getAccent600()
    });
  }
  getSchedulerMessageBubbleStyle(t) {
    const n = new Kt({
      borderRadius: "50%",
      width: "48px",
      height: "48px",
      border: "none",
      backgroundColor: t.palette.getAccent700(),
      nameTextColor: t.palette.getAccent900(),
      backgroundSize: "cover",
      nameTextFont: w(t.typography.subtitle1)
    }), o = new _t({
      height: "auto",
      width: "100%",
      background: "inherit",
      activeBackground: "transparent",
      borderRadius: "0",
      titleFont: w(t.typography.text1),
      titleColor: t.palette.getAccent(),
      border: "none",
      separatorColor: "",
      hoverBackground: "transparent"
    }), i = new vr({
      height: "100%",
      width: "100%",
      border: "none",
      borderRadius: "0",
      background: "transparent",
      dateTextFont: w(t.typography.subtitle2),
      dateTextColor: t.palette.getAccent(),
      dayTextFont: w(t.typography.text2),
      dayTextColor: t.palette.getAccent(),
      monthYearTextFont: w(t.typography.text2),
      monthYearTextColor: t.palette.getAccent(),
      defaultDateTextBackground: "transparent",
      disabledDateTextColor: t.palette.getAccent400(),
      disabledDateTextFont: w(t.typography.subtitle2),
      disabledDateTextBackground: "transparent",
      titleTextFont: w(t.typography.text1),
      titleTextColor: t.palette.getAccent(),
      timezoneTextFont: w(t.typography.caption2),
      timezoneTextColor: t.palette.getAccent(),
      arrowButtonTextColor: t.palette.getAccent(),
      arrowButtonTextFont: w(t.typography.title2)
    }), l = new mr({
      background: "transparent",
      height: "fit-content",
      width: "100%",
      border: "none",
      borderRadius: "0",
      calendarIconTint: t.palette.getAccent(),
      timezoneIconTint: t.palette.getAccent(),
      emptySlotIconTint: t.palette.getAccent500(),
      emptySlotTextColor: t.palette.getAccent500(),
      emptySlotTextFont: w(t.typography.subtitle1),
      dateTextColor: t.palette.getAccent(),
      dateTextFont: w(t.typography.subtitle1),
      seperatorTint: t.palette.getAccent100(),
      slotBackground: t.palette.getAccent900(),
      slotBorder: "none",
      slotBorderRadius: "8px",
      slotTextColor: t.palette.getAccent(),
      slotTextFont: w(t.typography.caption2),
      timezoneTextColor: t.palette.getAccent(),
      timezoneTextFont: w(t.typography.caption2),
      titleTextColor: t.palette.getAccent(),
      titleTextFont: w(t.typography.text1)
    }), r = new ia({
      background: t.palette.getAccent50(),
      height: "fit-content",
      width: "100%",
      titleFont: w(t.typography.subtitle2),
      titleColor: t.palette.getAccent(),
      subtitleFont: w(t.typography.subtitle2),
      subtitleColor: t.palette.getAccent600(),
      leadingBarTint: t.palette.getPrimary(),
      leadingBarWidth: "4px",
      borderRadius: "8px"
    });
    return new Or({
      avatarStyle: n,
      listItemStyle: o,
      quickViewStyle: r,
      dateSelectorStyle: i,
      timeSlotSelectorStyle: l,
      backButtonIconTint: t.palette.getPrimary(),
      background: "transparent",
      height: "100%",
      width: "100%",
      border: `1px solid ${t.palette.getAccent100()}`,
      borderRadius: "8px",
      loadingIconTint: t.palette.getAccent600(),
      suggestedTimeBackground: t.palette.getAccent900(),
      suggestedTimeBorder: `1px solid ${t.palette.getPrimary()}`,
      suggestedTimeBorderRadius: "8px",
      suggestedTimeDisabledBackground: t.palette.getAccent50(),
      suggestedTimeDisabledBorder: `1px solid ${t.palette.getAccent200()}`,
      suggestedTimeDisabledBorderRadius: "8px",
      suggestedTimeDisabledTextColor: t.palette.getAccent700(),
      suggestedTimeDisabledTextFont: w(t.typography.text3),
      suggestedTimeTextColor: t.palette.getPrimary(),
      suggestedTimeTextFont: w(t.typography.text3),
      moreButtonDisabledTextBackground: "transparent",
      moreButtonDisabledTextBorder: "none",
      moreButtonDisabledTextBorderRadius: "0",
      moreButtonDisabledTextColor: t.palette.getAccent600(),
      moreButtonDisabledTextFont: w(t.typography.caption2),
      moreButtonTextBackground: "transparent",
      moreButtonTextBorder: "none",
      moreButtonTextBorderRadius: "0",
      moreButtonTextColor: t.palette.getPrimary(),
      moreButtonTextFont: w(t.typography.caption2),
      goalCompletionTextColor: t.palette.getAccent(),
      goalCompletionTextFont: w(t.typography.text3),
      errorTextColor: t.palette.getError(),
      errorTextFont: w(t.typography.text3),
      scheduleButtonStyle: {
        iconHeight: "16px",
        iconWidth: "16px",
        buttonIconTint: t.palette.getAccent(),
        buttonTextFont: w(t.typography.name),
        buttonTextColor: t.palette.getAccent("dark"),
        border: "none",
        borderRadius: "8px",
        background: t.palette.getPrimary(),
        width: "100%",
        display: "flex",
        justifyContent: "center",
        padding: "8px"
      },
      seperatorTint: t.palette.getAccent200(),
      subtitleTextColor: t.palette.getAccent400(),
      subtitleTextFont: w(t.typography.name),
      summaryTextColor: t.palette.getAccent(),
      summaryTextFont: w(t.typography.subtitle1),
      timezoneTextColor: t.palette.getAccent600(),
      timezoneTextFont: w(t.typography.caption2),
      titleTextColor: t.palette.getAccent(),
      titleTextFont: w(t.typography.title1),
      timezoneIconTint: t.palette.getAccent(),
      calendarIconTint: t.palette.getAccent(),
      clockIconTint: t.palette.getAccent()
    });
  }
  getTextMessageBubble(t, n, o, i, l, r) {
    const u = {
      ...r,
      textFormatters: r != null && r.textFormatters && (r != null && r.textFormatters.length) ? [...r.textFormatters] : this.getAllTextFormatters({ theme: i, alignment: o, disableMentions: r.disableMentions })
    }, s = u.textFormatters;
    let c;
    if (u && !u.disableMentions) {
      let N;
      for (let T = 0; T < s.length && !(s[T] instanceof yo && (N = s[T], N.setMessage(n), n != null && n.getMentionedUsers().length && N.setCometChatUserGroupMembers(
        n == null ? void 0 : n.getMentionedUsers()
      ), N.setLoggedInUser(
        Ct.getLoggedInUser()
      ), c) || s[T] instanceof Co && (c = s[T], N)); T++)
        ;
      N || (N = Ne.getDataSource().getMentionsTextFormatter({
        message: n,
        ...u,
        alignment: o,
        theme: i
      }), s.push(N));
    } else
      for (let N = 0; N < s.length; N++)
        if (s[N] instanceof Co) {
          c = s[N];
          break;
        }
    c || (c = Ne.getDataSource().getUrlTextFormatter({
      theme: i,
      alignment: o
    }), s.push(c));
    let d = l;
    d || (d = this.getTextMessageBubbleStyle(o, i));
    for (let N = 0; N < s.length; N++)
      s[N].setMessageBubbleAlignment(o), s[N].setMessage(n);
    return {
      componentName: "CometChatTextBubble",
      props: {
        text: t,
        textStyle: d,
        textFormatters: s
      }
    };
  }
  getAudioMessageBubble(t, n, o, i, l) {
    return {
      componentName: "CometChatAudioBubble",
      props: {
        src: t,
        audioStyle: l
      }
    };
  }
  getFileMessageBubble(t, n, o, i, l) {
    return l || (l = new jl({
      background: "transparent",
      iconTint: o.palette.getPrimary(),
      titleColor: o.palette.getAccent(),
      titleFont: w(o.typography.subtitle1),
      subtitleColor: o.palette.getAccent600(),
      subtitleFont: w(o.typography.subtitle1),
      height: "fit-content",
      width: "fit-content"
    })), {
      componentName: "CometChatFileBubble",
      props: {
        downloadIconURL: Ya,
        subtitle: Y("SHARED_FILE"),
        title: i,
        fileURL: t,
        fileStyle: l
      }
    };
  }
  getFormMessageBubble(t, n, o, i) {
    let l = o;
    return l || (l = this.getFormMessageBubbleStyle(n)), {
      componentName: "CometChatFormBubble",
      props: {
        message: t,
        formBubbleStyle: l,
        hasCustomCallback: !!i,
        submitClicked: (u) => {
          i(u.detail);
        }
      }
    };
  }
  getCardMessageBubble(t, n, o) {
    let i = o;
    return i || (i = this.getCardMessageBubbleStyle(n)), {
      componentName: "CometChatCardBubble",
      props: {
        message: t,
        cardBubbleStyle: i
      }
    };
  }
  getSchedulerMessageBubble(t, n, o) {
    let i = o;
    return i || (i = this.getSchedulerMessageBubbleStyle(n)), {
      componentName: "CometChatSchedulerBubble",
      props: {
        schedulerMessage: t,
        schedulerBubbleStyle: i
      }
    };
  }
  getImageMessageBubble(t, n, o, i, l, r) {
    return {
      componentName: "CometChatImageBubble",
      props: {
        src: t,
        placeholderImage: n,
        message: o
      }
    };
  }
  getVideoMessageBubble(t, n, o, i, l, r) {
    return r || (r = {
      height: "130px",
      width: "230px",
      border: "none",
      borderRadius: "8px",
      background: "transparent"
    }), {
      componentName: "CometChatVideoBubble",
      props: {
        src: t,
        videoStyle: r,
        poster: i
      }
    };
  }
  imageAttachmentOption(t) {
    return new xn({
      id: I.MessageTypes.image,
      title: Y("ATTACH_IMAGE"),
      iconURL: Hl,
      onClick: void 0,
      iconTint: t.palette.getAccent700(),
      titleFont: w(t.typography.subtitle1),
      titleColor: t.palette.getAccent700(),
      borderRadius: "8px",
      background: t.palette.getAccent100()
    });
  }
  videoAttachmentOption(t) {
    return new xn({
      id: I.MessageTypes.video,
      title: Y("ATTACH_VIDEO"),
      iconURL: ss,
      onClick: void 0,
      iconTint: t.palette.getAccent700(),
      titleFont: w(t.typography.subtitle1),
      titleColor: t.palette.getAccent700(),
      borderRadius: "8px",
      background: t.palette.getAccent100()
    });
  }
  audioAttachmentOption(t) {
    return new xn({
      id: I.MessageTypes.audio,
      title: Y("ATTACH_AUDIO"),
      iconURL: Bl,
      onClick: void 0,
      iconTint: t.palette.getAccent700(),
      titleFont: w(t.typography.subtitle1),
      titleColor: t.palette.getAccent700(),
      borderRadius: "8px",
      background: t.palette.getAccent100()
    });
  }
  fileAttachmentOption(t) {
    return new xn({
      id: I.MessageTypes.file,
      title: Y("ATTACH_FILE"),
      iconURL: Pl,
      onClick: void 0,
      iconTint: t.palette.getAccent700(),
      titleFont: w(t.typography.subtitle1),
      titleColor: t.palette.getAccent700(),
      borderRadius: "8px",
      background: t.palette.getAccent100()
    });
  }
  getAttachmentOptions(t, n) {
    return [
      this.imageAttachmentOption(t),
      this.videoAttachmentOption(t),
      this.audioAttachmentOption(t),
      this.fileAttachmentOption(t)
    ];
  }
  getLastConversationMessage(t, n, o) {
    const i = {
      ...o,
      textFormatters: o != null && o.textFormatters && (o != null && o.textFormatters.length) ? [...o.textFormatters] : [this.getMentionsTextFormatter({ theme: o.theme, disableMentions: o.disableMentions })]
    };
    let l = zo.getLastConversationMessage(
      t,
      n,
      i
    );
    const r = t.getLastMessage();
    if (r) {
      const u = i.textFormatters;
      if (i && !i.disableMentions) {
        let s;
        for (let c = 0; c < u.length && (u[c] instanceof yo && (s = u[c], s.setMessage(r), r != null && r.getMentionedUsers().length && s.setCometChatUserGroupMembers(
          r == null ? void 0 : r.getMentionedUsers()
        ), s.setLoggedInUser(
          Ct.getLoggedInUser()
        )), !s); c++)
          ;
        s || (s = Ne.getDataSource().getMentionsTextFormatter({
          messageObject: r,
          ...i,
          alignment: null,
          theme: o.theme
        }), u.push(s));
      }
      if (r && r instanceof y.TextMessage)
        for (let s = 0; s < u.length; s++)
          l = u[s].getFormattedText(l, { mentionsTargetElement: Ai.conversation });
    }
    return l;
  }
  /**
   * Adds styled @ for every mention in the text by matching uid
   *
   * @param {CometChat.TextMessage} message
   * @param {string} subtitle
   * @returns {void}
   */
  getMentionsFormattedText(t, n, o) {
    const i = /<@uid:(.*?)>/g;
    let l = t.getText(), r = n, u = i.exec(l), s = [], c = t == null ? void 0 : t.getMentionedUsers();
    for (; u !== null; ) {
      let N;
      for (let T = 0; T < c.length; T++)
        u[1] == c[T].getUid() && (N = c[T]);
      N && s.push(N), u = i.exec(l);
    }
    let d = this.getMentionsTextFormatter(
      o
    );
    return d.setClasses(["cc-mentions"]), d.setCometChatUserGroupMembers(s), r = d.getFormattedText(
      r,
      o
    ), r;
  }
  getDefaultDetailsTemplate(t, n, o, i) {
    return wa.getDefaultDetailsTemplate(
      t,
      n,
      o,
      i
    );
  }
  getAuxiliaryHeaderMenu(t, n) {
    return [];
  }
  getAIOptions(t, n, o, i, l) {
    return [];
  }
  getAllTextFormatters(t) {
    let n = [];
    const o = t.disableMentions ? null : Ne.getDataSource().getMentionsTextFormatter(
      t
    ), i = Ne.getDataSource().getUrlTextFormatter(t);
    return o && n.push(o), i && n.push(i), n;
  }
  getMentionsTextFormatter(t) {
    let n = new yo();
    return t && t.theme && (n.setComposerMentionStyle(
      new Bo({
        loggedInUserTextFont: w(t.theme.typography.text2),
        loggedInUserTextColor: t.theme.palette.getPrimary(),
        loggedInUserTextBackground: "",
        mentionTextFont: w(t.theme.typography.text2),
        mentionTextColor: t.theme.palette.getPrimary(),
        mentionTextBackground: ""
      })
    ), n.setConversationMentionStyle(
      new Bo({
        loggedInUserTextFont: w(t.theme.typography.text3),
        loggedInUserTextColor: t.theme.palette.getPrimary(),
        loggedInUserTextBackground: "",
        mentionTextFont: w(t.theme.typography.text3),
        mentionTextColor: t.theme.palette.getPrimary(),
        mentionTextBackground: ""
      })
    ), n.setRightBubbleMentionStyle(
      new Bo({
        loggedInUserTextFont: w(t.theme.typography.text3),
        loggedInUserTextColor: t.theme.palette.getTertiary(),
        loggedInUserTextBackground: "",
        mentionTextFont: w(t.theme.typography.text3),
        mentionTextColor: t.theme.palette.getTertiary(),
        mentionTextBackground: ""
      })
    ), n.setLeftBubbleMentionStyle(
      new Bo({
        loggedInUserTextFont: w(t.theme.typography.text3),
        loggedInUserTextColor: t.theme.palette.getPrimary(),
        loggedInUserTextBackground: "",
        mentionTextFont: w(t.theme.typography.text3),
        mentionTextColor: t.theme.palette.getPrimary(),
        mentionTextBackground: ""
      })
    )), n;
  }
  getUrlTextFormatter(t = {}) {
    let n = new Co([
      /(https?:\/\/[^\s]+)/g
    ]);
    return t.alignment == gt.left ? n.setStyle({
      formattedTextColor: t.theme.palette.getPrimary(),
      formattedTextFont: w(t.theme.typography.text3)
    }) : n.setStyle({
      formattedTextColor: t.theme.palette.getTertiary(),
      formattedTextFont: w(t.theme.typography.text3)
    }), n;
  }
}
class Ne {
  static init(t) {
    this.dataSource = t ?? new qe(), t || (this.names = []), this.names.push(this.dataSource.getId());
  }
  static enable(t) {
    const n = this.dataSource, o = t(n);
    this.names.find((i) => i == o.getId()) || (this.dataSource = o, this.names.push(this.dataSource.getId()));
  }
  static getDataSource() {
    return this.dataSource;
  }
}
le(Ne, "dataSource"), le(Ne, "names", []);
class qo {
  enable() {
    y.isAIFeatureEnabled(this.getExtensionId()).then(
      (t) => {
        t && this.addExtension();
      }
    );
  }
}
class Nn {
  constructor(t) {
    le(this, "dataSource");
    this.dataSource = t;
  }
  getTextMessageOptions(t, n, o, i) {
    return (this.dataSource ?? new qe()).getTextMessageOptions(
      t,
      n,
      o,
      i
    );
  }
  getImageMessageOptions(t, n, o, i) {
    return (this.dataSource ?? new qe()).getImageMessageOptions(
      t,
      n,
      o,
      i
    );
  }
  getVideoMessageOptions(t, n, o, i) {
    return (this.dataSource ?? new qe()).getVideoMessageOptions(
      t,
      n,
      o,
      i
    );
  }
  getAudioMessageOptions(t, n, o, i) {
    return (this.dataSource ?? new qe()).getAudioMessageOptions(
      t,
      n,
      o,
      i
    );
  }
  getFileMessageOptions(t, n, o, i) {
    return (this.dataSource ?? new qe()).getFileMessageOptions(
      t,
      n,
      o,
      i
    );
  }
  getBottomView(t, n) {
    return (this.dataSource ?? new qe()).getBottomView(
      t,
      n
    );
  }
  getTextMessageContentView(t, n, o, i) {
    return (this.dataSource ?? new qe()).getTextMessageContentView(t, n, o, i);
  }
  getImageMessageContentView(t, n, o) {
    return (this.dataSource ?? new qe()).getImageMessageContentView(t, n, o);
  }
  getVideoMessageContentView(t, n, o) {
    return (this.dataSource ?? new qe()).getVideoMessageContentView(t, n, o);
  }
  getAudioMessageContentView(t, n, o) {
    return (this.dataSource ?? new qe()).getAudioMessageContentView(t, n, o);
  }
  getFileMessageContentView(t, n, o) {
    return (this.dataSource ?? new qe()).getFileMessageContentView(t, n, o);
  }
  getFormMessageContentView(t, n, o) {
    return (this.dataSource ?? new qe()).getFormMessageContentView(t, n, o);
  }
  getCardMessageContentView(t, n, o) {
    return (this.dataSource ?? new qe()).getCardMessageContentView(t, n, o);
  }
  getSchedulerMessageContentView(t, n, o) {
    return (this.dataSource ?? new qe()).getSchedulerMessageContentView(t, n, o);
  }
  getTextMessageTemplate(t, n) {
    return (this.dataSource ?? new qe()).getTextMessageTemplate(
      t,
      n
    );
  }
  getImageMessageTemplate(t) {
    return (this.dataSource ?? new qe()).getImageMessageTemplate(t);
  }
  getVideoMessageTemplate(t) {
    return (this.dataSource ?? new qe()).getVideoMessageTemplate(t);
  }
  getAudioMessageTemplate(t) {
    return (this.dataSource ?? new qe()).getAudioMessageTemplate(t);
  }
  getFileMessageTemplate(t) {
    return (this.dataSource ?? new qe()).getFileMessageTemplate(
      t
    );
  }
  getGroupActionTemplate(t) {
    return (this.dataSource ?? new qe()).getGroupActionTemplate(
      t
    );
  }
  getFormMessageTemplate(t) {
    return (this.dataSource ?? new qe()).getFormMessageTemplate(
      t
    );
  }
  getCardMessageTemplate(t) {
    return (this.dataSource ?? new qe()).getCardMessageTemplate(
      t
    );
  }
  getSchedulerMessageTemplate(t) {
    return (this.dataSource ?? new qe()).getSchedulerMessageTemplate(t);
  }
  getAllMessageTemplates(t, n) {
    return (this.dataSource ?? new qe()).getAllMessageTemplates(
      t,
      n
    );
  }
  getMessageTemplate(t, n, o) {
    return (this.dataSource ?? new qe()).getMessageTemplate(
      t,
      n,
      o
    );
  }
  getMessageOptions(t, n, o, i) {
    return (this.dataSource ?? new qe()).getMessageOptions(
      t,
      n,
      o,
      i
    );
  }
  getCommonOptions(t, n, o, i) {
    return (this.dataSource ?? new qe()).getCommonOptions(
      t,
      n,
      o,
      i
    );
  }
  getAttachmentOptions(t, n) {
    return (this.dataSource ?? new qe()).getAttachmentOptions(
      t,
      n
    );
  }
  getAllMessageTypes() {
    return (this.dataSource ?? new qe()).getAllMessageTypes();
  }
  getAllMessageCategories() {
    return (this.dataSource ?? new qe()).getAllMessageCategories();
  }
  getAuxiliaryOptions(t, n, o, i) {
    return (this.dataSource ?? new qe()).getAuxiliaryOptions(
      t,
      n,
      o,
      i
    );
  }
  getId() {
    return (this.dataSource ?? new qe()).getId();
  }
  getDeleteMessageBubble(t, n, o) {
    return (this.dataSource ?? new qe()).getDeleteMessageBubble(
      t,
      n,
      o
    );
  }
  getGroupActionBubble(t, n, o) {
    return (this.dataSource ?? new qe()).getGroupActionBubble(
      t,
      n,
      o
    );
  }
  getTextMessageBubble(t, n, o, i, l, r) {
    return (this.dataSource ?? new qe()).getTextMessageBubble(
      t,
      n,
      o,
      i,
      l,
      r
    );
  }
  getVideoMessageBubble(t, n, o, i, l, r) {
    return (this.dataSource ?? new qe()).getVideoMessageBubble(
      t,
      n,
      o,
      i,
      l,
      r
    );
  }
  getImageMessageBubble(t, n, o, i, l, r) {
    return (this.dataSource ?? new qe()).getImageMessageBubble(
      t,
      n,
      o,
      i,
      l,
      r
    );
  }
  getAudioMessageBubble(t, n, o, i, l) {
    return (this.dataSource ?? new qe()).getAudioMessageBubble(
      t,
      n,
      o,
      i,
      l
    );
  }
  getFileMessageBubble(t, n, o, i, l) {
    return (this.dataSource ?? new qe()).getFileMessageBubble(
      t,
      n,
      o,
      i,
      l
    );
  }
  getFormMessageBubble(t, n, o, i) {
    return (this.dataSource ?? new qe()).getFormMessageBubble(
      t,
      n,
      o,
      i
    );
  }
  getCardMessageBubble(t, n, o) {
    return (this.dataSource ?? new qe()).getCardMessageBubble(
      t,
      n,
      o
    );
  }
  getSchedulerMessageBubble(t, n, o) {
    return (this.dataSource ?? new qe()).getSchedulerMessageBubble(t, n, o);
  }
  getLastConversationMessage(t, n, o) {
    return (this.dataSource ?? new qe()).getLastConversationMessage(
      t,
      n,
      o
    );
  }
  getDefaultDetailsTemplate(t, n, o, i) {
    return (this.dataSource ?? new qe()).getDefaultDetailsTemplate(t, n, o, i);
  }
  getAuxiliaryHeaderMenu(t, n) {
    return (this.dataSource ?? new qe()).getAuxiliaryHeaderMenu(
      t,
      n
    );
  }
  getAIOptions(t, n, o, i, l) {
    return (this.dataSource ?? new qe()).getAIOptions(
      t,
      n,
      o,
      i,
      l
    );
  }
  getAllTextFormatters(t) {
    let n = [];
    const o = t.disableMentions ? null : (this.dataSource ?? new qe()).getMentionsTextFormatter(
      t
    ), i = (this.dataSource ?? new qe()).getUrlTextFormatter(
      t
    );
    return o && n.push(o), i && n.push(i), n;
  }
  getMentionsTextFormatter(t) {
    return (this.dataSource ?? new qe()).getMentionsTextFormatter(t);
  }
  getUrlTextFormatter(t = {}) {
    return (this.dataSource ?? new qe()).getUrlTextFormatter(
      t
    );
  }
  getMentionsFormattedText(t, n, o) {
    return (this.dataSource ?? new qe()).getMentionsFormattedText(t, n, o);
  }
}
class cs extends Nn {
  constructor(n, o) {
    super(n);
    le(this, "configuration");
    le(this, "newDataSource");
    le(this, "loggedInUser");
    le(this, "bots", []);
    le(this, "user");
    le(this, "group");
    le(this, "theme", new Ke({}));
    le(this, "getAllBots", async () => {
      new y.UsersRequestBuilder().setLimit(30).setTags(["aibot"]).build().fetchNext().then(
        (n) => {
          this.bots = n;
        }
      );
    });
    le(this, "onMessageSent", async (n, o) => {
      var s, c, d;
      let i;
      const l = ((s = this.group) == null ? void 0 : s.getGuid()) || ((c = this.user) == null ? void 0 : c.getUid()), r = (d = this.group) != null && d.getGuid() ? y.RECEIVER_TYPE.GROUP : y.RECEIVER_TYPE.USER;
      try {
        i = await this.configuration.apiConfiguration(o, this.user, this.group) || {};
      } catch {
        i = {};
      }
      return await y.askBot(
        l,
        r,
        o.getUid(),
        n,
        i
      );
    });
    le(this, "closeChat", () => {
      it.ccHidePanel.next(qn.messages);
    });
    le(this, "onOptionClick", (n) => {
      it.ccShowPanel.next({
        child: {
          componentName: "AIAssistBotChatView",
          props: {
            bot: n,
            sender: this.loggedInUser,
            configuration: this.configuration,
            messageSendCallBack: this.onMessageSent,
            closeCallBack: this.closeChat
          }
        },
        position: qn.messages
      });
    });
    this.newDataSource = n, this.configuration = o, setTimeout(() => {
      this.addMessageListener(), this.getAllBots();
    }, 500);
  }
  getId() {
    return "aiassistbot";
  }
  getAIOptions(n, o, i, l, r) {
    var N, T, m, A, D, z, k, R, Q;
    this.user = n, this.group = o;
    const u = Y("COMETCHAT_ASK_AI_BOT"), s = Y("COMETCHAT_ASK_BOT"), c = (N = this.bots) == null ? void 0 : N.length, d = c > 1 ? u : `${s} ${(m = (T = this.bots) == null ? void 0 : T[0]) == null ? void 0 : m.getName()}`;
    if (l != null && l.parentMessageId)
      return super.getAIOptions(n, o, i, l, r);
    {
      let h;
      r && (h = {
        titleColor: ((D = (A = this.configuration) == null ? void 0 : A.assistBotStyle) == null ? void 0 : D.buttonTextColor) || (r == null ? void 0 : r.listItemTextColor),
        titleFont: ((k = (z = this.configuration) == null ? void 0 : z.assistBotStyle) == null ? void 0 : k.buttonTextFont) || (r == null ? void 0 : r.listItemTextFont),
        background: ((Q = (R = this.configuration) == null ? void 0 : R.assistBotStyle) == null ? void 0 : Q.buttonBackground) || (r == null ? void 0 : r.listItemBackground)
      });
      const O = super.getAIOptions(n, o, i, l, r);
      if (c === 1) {
        const x = new xn({
          title: d,
          onClick: () => {
            this.onOptionClick(this.bots[0]);
          },
          id: "ai-assist-bot",
          iconURL: "",
          iconTint: "",
          titleColor: h == null ? void 0 : h.titleColor,
          titleFont: h == null ? void 0 : h.titleFont,
          background: h == null ? void 0 : h.background
        });
        O.push(x);
      } else if (c > 1) {
        const x = this.bots.map((oe) => new xn({
          title: oe.getName(),
          onClick: () => {
            this.onOptionClick(oe);
          },
          id: oe.getUid()
        })), _ = new Ea({
          title: d,
          customView: (oe) => ({
            componentName: "BotOptionView",
            props: {
              title: d,
              configuration: this.configuration,
              backCallback: oe == null ? void 0 : oe.backAIOption,
              closeCallback: oe == null ? void 0 : oe.closeAIOption,
              bots: x
            }
          }),
          id: "ai-assist-bot",
          iconURL: "",
          iconTint: "",
          titleColor: h == null ? void 0 : h.titleColor,
          titleFont: h == null ? void 0 : h.titleFont,
          background: h == null ? void 0 : h.background
        });
        O.push(_);
      }
      return O;
    }
  }
  addMessageListener() {
    y.getLoggedinUser().then((n) => {
      n && (this.loggedInUser = n);
    }), it.ccActiveChatChanged.subscribe(() => {
      this.closeChat();
    });
  }
}
class ds extends qo {
  constructor(n) {
    super();
    le(this, "configuration");
    this.configuration = n;
  }
  addExtension() {
    Ne.enable((n) => new cs(n, this.configuration));
  }
  getExtensionId() {
    return "bots";
  }
}
class Is extends Nn {
  constructor(n, o) {
    super(n);
    le(this, "configuration");
    le(this, "newDataSource");
    le(this, "currentMessage", null);
    le(this, "loggedInUser");
    le(this, "user");
    le(this, "group");
    le(this, "theme", new Ke({}));
    le(this, "closePanel", () => {
      this.currentMessage || it.ccHidePanel.next(qn.messageListFooter);
    });
    le(this, "getConversationStarter", (n) => (this.theme = n ?? new Ke({}), new Promise(async (o, i) => {
      var l, r, u, s;
      try {
        const c = this.user ? (l = this.user) == null ? void 0 : l.getUid() : (r = this.group) == null ? void 0 : r.getGuid(), d = this.user ? I.MessageReceiverType.user : I.MessageReceiverType.group;
        let N;
        (u = this.configuration) != null && u.apiConfiguration && (N = await ((s = this.configuration) == null ? void 0 : s.apiConfiguration(
          this.user,
          this.group
        )));
        const T = await y.getConversationStarter(
          c,
          d,
          N || {}
        );
        return o(T);
      } catch (c) {
        i(c);
      }
    })));
    this.newDataSource = n, this.configuration = o, setTimeout(() => {
      this.addMessageListener();
    }, 1e3);
  }
  getId() {
    return "aiconversationstarter";
  }
  editReply(n) {
    it.ccComposeMessage.next(n);
  }
  closeIfMessageReceived(n) {
    var o;
    (n == null ? void 0 : n.getReceiverId()) === ((o = this.loggedInUser) == null ? void 0 : o.getUid()) && this.closePanel();
  }
  loadConversationStarter() {
    it.ccShowPanel.next({
      configuration: this.configuration,
      message: this.currentMessage,
      child: {
        componentName: "ConversationStarterView",
        props: {
          configuration: this.configuration,
          getConversationStarterCallback: this.getConversationStarter,
          editReplyCallback: this.editReply,
          closeCallback: this.closePanel
        }
      },
      position: qn.messageListFooter
    });
  }
  addMessageListener() {
    y.getLoggedinUser().then((n) => {
      n && (this.loggedInUser = n);
    }), ae.onTextMessageReceived.subscribe((n) => {
      this.closeIfMessageReceived(n);
    }), ae.onCustomMessageReceived.subscribe((n) => {
      this.closeIfMessageReceived(n);
    }), ae.onMediaMessageReceived.subscribe((n) => {
      this.closeIfMessageReceived(n);
    }), ae.onFormMessageReceived.subscribe((n) => {
      this.closeIfMessageReceived(n);
    }), ae.onCardMessageReceived.subscribe((n) => {
      this.closeIfMessageReceived(n);
    }), ae.onSchedulerMessageReceived.subscribe((n) => {
      this.closeIfMessageReceived(n);
    }), ae.onCustomInteractiveMessageReceived.subscribe(
      (n) => {
        this.closeIfMessageReceived(n);
      }
    ), it.ccActiveChatChanged.subscribe(
      (n) => {
        this.currentMessage = n.message, this.user = n.user, this.group = n.group, this.currentMessage || this.loadConversationStarter();
      }
    ), ae.ccMessageSent.subscribe(() => {
      this.closePanel(), this.currentMessage = null;
    });
  }
}
class Ns extends qo {
  constructor(n) {
    super();
    le(this, "configuration");
    this.configuration = n;
  }
  addExtension() {
    Ne.enable((n) => new Is(n, this.configuration));
  }
  getExtensionId() {
    return "conversation-starter";
  }
}
class Ts extends Nn {
  constructor(n, o) {
    super(n);
    le(this, "configuration");
    le(this, "newDataSource");
    le(this, "currentMessage", null);
    le(this, "unreadMessageCount", 0);
    le(this, "loggedInUser");
    le(this, "user");
    le(this, "group");
    le(this, "theme", new Ke({}));
    le(this, "closePanel", () => {
      it.ccHidePanel.next(qn.messageListFooter);
    });
    le(this, "getConversationSummary", (n) => (this.theme = n ?? new Ke({}), new Promise(async (o, i) => {
      var l, r, u, s;
      try {
        const c = this.user ? (l = this.user) == null ? void 0 : l.getUid() : (r = this.group) == null ? void 0 : r.getGuid(), d = this.user ? I.MessageReceiverType.user : I.MessageReceiverType.group;
        let N;
        (u = this.configuration) != null && u.apiConfiguration && (N = await ((s = this.configuration) == null ? void 0 : s.apiConfiguration(
          this.user,
          this.group
        )));
        const T = await y.getConversationSummary(
          c,
          d,
          N || {}
        );
        return o(T);
      } catch (c) {
        i(c);
      }
    })));
    this.newDataSource = n, this.configuration = o, setTimeout(() => {
      this.addMessageListener();
    }, 1e3);
  }
  getId() {
    return "aiconversationsummary";
  }
  editReply(n) {
    it.ccComposeMessage.next(n), it.ccHidePanel.next(qn.messageListFooter);
  }
  closeIfMessageReceived(n) {
    var o;
    (n == null ? void 0 : n.getReceiverId()) === ((o = this.loggedInUser) == null ? void 0 : o.getUid()) && this.closePanel();
  }
  loadConversationSummary() {
    it.ccShowPanel.next({
      configuration: this.configuration,
      message: this.currentMessage,
      child: {
        componentName: "ConversationSummaryView",
        props: {
          configuration: this.configuration,
          getConversationSummaryCallback: this.getConversationSummary,
          closeCallback: this.closePanel
        }
      },
      position: qn.messageListFooter
    });
  }
  getAIOptions(n, o, i, l, r) {
    var u, s, c, d, N, T;
    if (this.user = n, this.group = o, l != null && l.parentMessageId)
      return super.getAIOptions(n, o, i, l, r);
    {
      let m;
      r && (m = {
        titleColor: ((s = (u = this.configuration) == null ? void 0 : u.conversationSummaryStyle) == null ? void 0 : s.buttonTextColor) || (r == null ? void 0 : r.listItemTextColor),
        titleFont: ((d = (c = this.configuration) == null ? void 0 : c.conversationSummaryStyle) == null ? void 0 : d.buttonTextFont) || (r == null ? void 0 : r.listItemTextFont),
        background: ((T = (N = this.configuration) == null ? void 0 : N.conversationSummaryStyle) == null ? void 0 : T.buttonBackground) || (r == null ? void 0 : r.listItemBackground)
      });
      const A = super.getAIOptions(n, o, i, l, r), D = new xn({
        title: Y("CONVERSATION_SUMMARY"),
        onClick: () => {
          this.loadConversationSummary();
        },
        id: "ai-conversation-summary",
        iconURL: "",
        iconTint: "",
        titleColor: m == null ? void 0 : m.titleColor,
        titleFont: m == null ? void 0 : m.titleFont,
        background: m == null ? void 0 : m.background
      });
      return A.push(D), A;
    }
  }
  addMessageListener() {
    y.getLoggedinUser().then((n) => {
      n && (this.loggedInUser = n);
    }), it.ccActiveChatChanged.subscribe(
      (n) => {
        var o;
        this.currentMessage = n.message, this.user = n.user, this.group = n.group, this.unreadMessageCount = n.unreadMessageCount ?? 0, this.unreadMessageCount >= (((o = this.configuration) == null ? void 0 : o.unreadMessageThreshold) ?? 30) && this.loadConversationSummary();
      }
    ), ae.ccMessageSent.subscribe(() => {
      this.closePanel(), this.currentMessage = null, this.unreadMessageCount = 0;
    });
  }
}
class Ds extends qo {
  constructor(n) {
    super();
    le(this, "configuration");
    this.configuration = n;
  }
  addExtension() {
    Ne.enable((n) => new Ts(n, this.configuration));
  }
  getExtensionId() {
    return "conversation-summary";
  }
}
class ys extends Nn {
  constructor(n, o) {
    super(n);
    le(this, "configuration");
    le(this, "newDataSource");
    le(this, "loggedInUser");
    le(this, "user");
    le(this, "group");
    le(this, "theme", new Ke({}));
    le(this, "closeCallback");
    le(this, "editReply", (n) => {
      it.ccComposeMessage.next(n);
    });
    le(this, "getSmartReplies", (n) => (this.theme = n ?? new Ke({}), new Promise(async (o, i) => {
      var l, r, u, s;
      try {
        const c = this.user ? (l = this.user) == null ? void 0 : l.getUid() : (r = this.group) == null ? void 0 : r.getGuid(), d = this.user ? I.MessageReceiverType.user : I.MessageReceiverType.group;
        let N;
        (u = this.configuration) != null && u.apiConfiguration && (N = await ((s = this.configuration) == null ? void 0 : s.apiConfiguration(
          this.user,
          this.group
        )));
        const T = await y.getSmartReplies(
          c,
          d,
          N || {}
        );
        return o(T);
      } catch (c) {
        i(c);
      }
    })));
    this.newDataSource = n, this.configuration = o, setTimeout(() => {
      this.addMessageListener();
    }, 500);
  }
  getId() {
    return "aismartreplies";
  }
  getAIOptions(n, o, i, l, r) {
    var u, s, c, d, N, T;
    if (this.user = n, this.group = o, l != null && l.parentMessageId)
      return super.getAIOptions(n, o, i, l, r);
    {
      let m;
      r && (m = {
        titleColor: ((s = (u = this.configuration) == null ? void 0 : u.smartRepliesStyle) == null ? void 0 : s.buttonTextColor) || (r == null ? void 0 : r.listItemTextColor),
        titleFont: ((d = (c = this.configuration) == null ? void 0 : c.smartRepliesStyle) == null ? void 0 : d.buttonTextFont) || (r == null ? void 0 : r.listItemTextFont),
        background: ((T = (N = this.configuration) == null ? void 0 : N.smartRepliesStyle) == null ? void 0 : T.buttonBackground) || (r == null ? void 0 : r.listItemBackground)
      });
      const A = super.getAIOptions(n, o, i, l, r), D = new Ea({
        title: Y("SUGGEST_A_REPLY"),
        customView: (z) => (this.closeCallback = z == null ? void 0 : z.closeAIOption, {
          componentName: "SmartRepliesView",
          props: {
            title: Y("SUGGEST_A_REPLY"),
            configuration: this.configuration,
            getSmartRepliesCallback: this.getSmartReplies,
            editReplyCallback: this.editReply.bind(this),
            backCallback: z == null ? void 0 : z.backAIOption,
            closeCallback: z == null ? void 0 : z.closeAIOption
          }
        }),
        id: "ai-smart-replies",
        iconURL: "",
        iconTint: "",
        titleColor: m == null ? void 0 : m.titleColor,
        titleFont: m == null ? void 0 : m.titleFont,
        background: m == null ? void 0 : m.background
      });
      return A.push(D), A;
    }
  }
  closeIfMessageReceived(n) {
    var o;
    (n == null ? void 0 : n.getReceiverId()) === ((o = this.loggedInUser) == null ? void 0 : o.getUid()) && this.closeCallback && this.closeCallback();
  }
  addMessageListener() {
    y.getLoggedinUser().then((n) => {
      n && (this.loggedInUser = n);
    }), ae.onTextMessageReceived.subscribe(
      (n) => {
        this.closeIfMessageReceived(n);
      }
    ), ae.onCustomMessageReceived.subscribe(
      (n) => {
        this.closeIfMessageReceived(n);
      }
    ), ae.onMediaMessageReceived.subscribe(
      (n) => {
        this.closeIfMessageReceived(n);
      }
    ), ae.onFormMessageReceived.subscribe(
      (n) => {
        this.closeIfMessageReceived(n);
      }
    ), ae.onCardMessageReceived.subscribe(
      (n) => {
        this.closeIfMessageReceived(n);
      }
    ), ae.onSchedulerMessageReceived.subscribe((n) => {
      this.closeIfMessageReceived(n);
    }), ae.onCustomInteractiveMessageReceived.subscribe(
      (n) => {
        this.closeIfMessageReceived(n);
      }
    );
  }
}
class Cs extends qo {
  constructor(n) {
    super();
    le(this, "configuration");
    this.configuration = n;
  }
  addExtension() {
    Ne.enable((n) => new ys(n, this.configuration));
  }
  getExtensionId() {
    return "smart-replies";
  }
}
const In = Object.freeze({
  meeting: "meeting",
  ongoing: "ongoing",
  ended: "ended",
  initiated: "initiated",
  cancelled: "cancelled",
  rejected: "rejected",
  unanswered: "unanswered"
});
class Ma extends Nn {
  constructor(n, o) {
    super(n);
    le(this, "theme");
    le(this, "loggedInUser");
    le(this, "configuration", new xr({}));
    this.addLoginListener(), this.getLoggedInUser(), this.configuration = o;
  }
  addLoginListener() {
    const n = "login_listener";
    y.addLoginListener(
      n,
      new y.LoginListener({
        logoutSuccess: () => {
          try {
            const o = y.getActiveCall();
            o && (y.endCall(o.getSessionId()), an.setItem(I.calls.activecall, null));
          } catch (o) {
            console.log("error in endCall on logout", o);
          }
        }
      })
    );
  }
  async getLoggedInUser() {
    this.loggedInUser = await y.getLoggedinUser();
  }
  getAllMessageTypes() {
    const n = super.getAllMessageTypes();
    return n.includes(In.meeting) || n.push(In.meeting), n.includes(I.MessageTypes.audio) || n.push(I.MessageTypes.audio), n.includes(I.MessageTypes.video) || n.push(I.MessageTypes.video), n;
  }
  getId() {
    return "calling";
  }
  getAllMessageCategories() {
    const n = super.getAllMessageCategories();
    return n.includes(I.MessageCategory.call) || n.push(I.MessageCategory.call), n.includes(I.MessageCategory.custom) || n.push(I.MessageCategory.custom), n;
  }
  checkIfTemplateTypeExist(n, o) {
    return n.some((i) => i.type === o);
  }
  checkIfTemplateCategoryExist(n, o) {
    return n.some((i) => i.category === o);
  }
  getAllMessageTemplates(n, o) {
    this.theme = n;
    const i = super.getAllMessageTemplates(
      n,
      o
    );
    return this.checkIfTemplateTypeExist(i, In.meeting) || i.push(this.getDirectCallTemplate(this.theme)), this.checkIfTemplateCategoryExist(
      i,
      I.MessageCategory.call
    ) || i.push(...this.getDefaultCallTemplate(this.theme)), i;
  }
  getDirectCallTemplate(n) {
    return new Mn({
      type: In.meeting,
      category: I.MessageCategory.custom,
      bottomView: (o, i) => super.getBottomView(o, i),
      contentView: (o, i) => o.getDeletedAt() ? super.getDeleteMessageBubble(o, n) : this.getDirectCallMessageBubble(
        o,
        i,
        n
      ),
      options: (o, i, l, r) => Ne.getDataSource().getCommonOptions(
        o,
        i,
        l,
        r
      )
    });
  }
  getDefaultCallTemplate(n) {
    return [
      new Mn({
        type: I.MessageTypes.audio,
        category: I.MessageCategory.call,
        bottomView: (i, l) => super.getBottomView(i, l),
        contentView: (i, l) => this.getDefaultAudioCallMessageBubble(
          i,
          l,
          n
        )
      }),
      new Mn({
        type: I.MessageTypes.video,
        category: I.MessageCategory.call,
        bottomView: (i, l) => super.getBottomView(i, l),
        contentView: (i, l) => this.getDefaultVideoCallMessageBubble(
          i,
          l,
          n
        )
      })
    ];
  }
  getCallBubbleStyle(n, o) {
    return n == gt.left ? {
      titleFont: w(o.typography.text2),
      titleColor: o.palette.getAccent(),
      iconTint: o.palette.getPrimary(),
      buttonTextFont: w(o.typography.text2),
      buttonTextColor: o.palette.getAccent("dark"),
      buttonBackground: o.palette.getPrimary(),
      width: "240px",
      borderRadius: "12px"
    } : {
      titleFont: w(o.typography.text2),
      titleColor: o.palette.getAccent("dark"),
      iconTint: o.palette.getAccent("dark"),
      buttonTextFont: w(o.typography.text2),
      buttonTextColor: o.palette.getPrimary(),
      buttonBackground: o.palette.getAccent("dark"),
      width: "240px",
      background: o.palette.getPrimary(),
      borderRadius: "12px"
    };
  }
  getSessionId(n) {
    var i;
    const o = n.getData();
    return (i = o == null ? void 0 : o.customData) == null ? void 0 : i.sessionID;
  }
  getCallBubbleTitle(n) {
    return !n.getSender() || n.getSender().getUid() == this.loggedInUser.getUid() ? Y("YOU_INITIATED_GROUP_CALL") : `${n.getSender().getName()}  ${Y(
      "INITIATED_GROUP_CALL"
    )}`;
  }
  getDirectCallMessageBubble(n, o, i) {
    const l = Li.left, r = this.getCallBubbleStyle(o, i), u = this.getSessionId(n), s = Ja, c = this.getCallBubbleTitle(n), d = Y("JOIN");
    return {
      componentName: "CometChatDocumentExtensionBubble",
      props: {
        hideSeparator: !0,
        iconAlignment: l,
        documentStyle: r,
        URL: u,
        iconURL: s,
        title: c,
        buttonText: d,
        ccClicked: () => this.startDirectCall(u, n)
      }
    };
  }
  startDirectCall(n, o) {
    var u, s;
    const i = ((u = o.getCustomData()) == null ? void 0 : u.callType) === I.MessageTypes.audio;
    let l;
    (s = this.configuration) != null && s.groupCallSettingsBuilder ? l = this.configuration.groupCallSettingsBuilder(o) : l = new Ft.CallSettingsBuilder().enableDefaultLayout(!0).setIsAudioOnlyCall(i), l.setCallListener(
      new Ft.OngoingCallListener({
        onCallEndButtonPressed: () => {
          try {
            it.ccShowOngoingCall.next({ child: null });
          } catch (c) {
            console.error("Error:", c);
          }
        }
      })
    );
    const r = l.build();
    it.ccShowOngoingCall.next({
      child: this.getOngoingCallUI(n, r)
    });
  }
  getOngoingCallUI(n, o) {
    return {
      componentName: "CometChatOngoingCall",
      props: {
        ongoingCallStyle: new $o({
          maxHeight: "100%",
          maxWidth: "100%",
          border: "none",
          borderRadius: "0",
          background: "#1c2226",
          minHeight: "400px",
          minWidth: "400px",
          minimizeIconTint: this.theme.palette.getAccent900(),
          maximizeIconTint: this.theme.palette.getAccent900()
        }),
        sessionID: n,
        callWorkflow: Ro.directCalling,
        callSettingsBuilder: o
      }
    };
  }
  callStatusStyle(n, o) {
    return {
      buttonTextFont: w(o.typography.subtitle2),
      buttonTextColor: Go.isMissedCall(
        n,
        this.loggedInUser
      ) ? o.palette.getError() : o.palette.getAccent600(),
      borderRadius: "10px",
      border: Go.isMissedCall(n, this.loggedInUser) ? "1px solid RGBA(255, 59, 48, 0.2)" : `1px solid ${o.palette.getAccent100()}`,
      buttonIconTint: Go.isMissedCall(
        n,
        this.loggedInUser
      ) ? o.palette.getError() : o.palette.getAccent600(),
      background: "transparent",
      iconBackground: "transparent",
      padding: "2px 12px 2px 0",
      gap: "0",
      height: "25px",
      justifyContent: "center"
    };
  }
  getCallActionMessage(n) {
    return Go.getCallStatus(n, this.loggedInUser);
  }
  getDefaultAudioCallMessageBubble(n, o, i) {
    const l = this.callStatusStyle(n, i), r = this.getCallActionMessage(n);
    return {
      componentName: "cometchat-icon-button",
      props: {
        disabled: !0,
        iconURL: Ba,
        buttonStyle: l,
        text: r
      }
    };
  }
  getDefaultVideoCallMessageBubble(n, o, i) {
    const l = this.callStatusStyle(n, i), r = this.getCallActionMessage(n);
    return {
      componentName: "cometchat-icon-button",
      props: {
        disabled: !0,
        iconURL: Ka,
        buttonStyle: l,
        text: r
      }
    };
  }
  getLastConversationMessage(n, o, i) {
    var r, u;
    let l = "";
    if (n.getLastMessage() && !((r = n.getLastMessage()) != null && r.getDeletedAt()) && n.getLastMessage().category == I.MessageCategory.call) {
      const s = n.getLastMessage();
      switch (s.getStatus()) {
        case In.initiated: {
          l = Y("CALL_INITIATED"), s.getType() === I.MessageTypes.audio ? s.getReceiverType() === I.MessageReceiverType.user ? l = s.getSender().getUid() === (o == null ? void 0 : o.getUid()) ? Y("OUTGOING_AUDIO_CALL") : Y("INCOMING_AUDIO_CALL") : s.getReceiverType() === I.MessageReceiverType.group && (s.getAction() === In.initiated ? l = s.getSender().getUid() === (o == null ? void 0 : o.getUid()) ? Y("OUTGOING_AUDIO_CALL") : Y("INCOMING_AUDIO_CALL") : s.getAction() === In.rejected && (l = s.getSender().getUid() === (o == null ? void 0 : o.getUid()) ? Y("CALL_REJECTED") : `${s.getSender().getName()} ${Y(
            "REJECTED_CALL"
          )}`)) : s.getType() === I.MessageTypes.video && (s.getReceiverType() === I.MessageReceiverType.user ? l = s.getSender().getUid() === (o == null ? void 0 : o.getUid()) ? Y("OUTGOING_VIDEO_CALL") : Y("INCOMING_VIDEO_CALL") : s.getReceiverType() === I.MessageReceiverType.group && (s.getAction() === In.initiated ? l = s.getSender().getUid() === (o == null ? void 0 : o.getUid()) ? Y("OUTGOING_VIDEO_CALL") : Y("INCOMING_VIDEO_CALL") : s.getAction() === In.rejected && (l = s.getSender().getUid() === (o == null ? void 0 : o.getUid()) ? Y("CALL_REJECTED") : `${s.getSender().getName()} ${Y(
            "REJECTED_CALL"
          )}`)));
          break;
        }
        case In.ongoing: {
          s.getReceiverType() === I.MessageReceiverType.user ? l = Y("CALL_ACCEPTED") : s.getReceiverType() === I.MessageReceiverType.group && (s.getAction() === In.ongoing ? l = s.getSender().getUid() === (o == null ? void 0 : o.getUid()) ? Y("CALL_ACCEPTED") : `${s.getSender().getName()} ${Y("JOINED")}` : s.getAction() === In.rejected ? l = s.getSender().getUid() === (o == null ? void 0 : o.getUid()) ? Y("CALL_REJECTED") : `${s.getSender().getName()}  ${Y(
            "REJECTED_CALL"
          )}` : s.getAction() === "left" && (s.getSender().getUid() === (o == null ? void 0 : o.getUid()) ? l = `${Y("YOU")} ${Y(
            "LEFT_THE_CALL"
          )}` : l = `${s.getSender().getName()} ${Y(
            "LEFT_THE_CALL"
          )}`));
          break;
        }
        case In.unanswered: {
          l = Y("CALL_UNANSWERED"), s.getType() === I.MessageTypes.audio && (s.getReceiverType() === I.MessageReceiverType.user || s.getReceiverType() === I.MessageReceiverType.group) ? l = s.getSender().getUid() === (o == null ? void 0 : o.getUid()) ? Y("UNANSWERED_AUDIO_CALL") : Y("MISSED_AUDIO_CALL") : s.getType() === I.MessageTypes.video && (s.getReceiverType() === I.MessageReceiverType.user || s.getReceiverType() === I.MessageReceiverType.group) && (l = s.getSender().getUid() === (o == null ? void 0 : o.getUid()) ? Y("UNANSWERED_VIDEO_CALL") : Y("MISSED_VIDEO_CALL"));
          break;
        }
        case In.rejected:
          l = Y("CALL_REJECTED");
          break;
        case y.CALL_STATUS.ENDED:
          l = Y("CALL_ENDED");
          break;
        case y.CALL_STATUS.CANCELLED:
          l = Y("CALL_CANCELLED");
          break;
        case y.CALL_STATUS.BUSY:
          l = Y("CALL_BUSY");
          break;
      }
    } else if (n.getLastMessage() && !((u = n.getLastMessage()) != null && u.getDeletedAt()) && n.getLastMessage().type == In.meeting) {
      const s = n.getLastMessage();
      !s.getSender() || s.getSender().getUid() == o.getUid() ? l = Y("YOU_INITIATED_GROUP_CALL") : l = `${s.getSender().getName()}  ${Y(
        "INITIATED_GROUP_CALL"
      )}`;
      let c = n.getLastMessage();
      return c && (c != null && c.getMentionedUsers().length) && c instanceof y.TextMessage && i && !i.disableMentions && (l = this.getMentionsFormattedText(
        c,
        l,
        i
      )), l;
    } else
      l = super.getLastConversationMessage(
        n,
        o,
        i
      );
    return l;
  }
  getAuxiliaryHeaderMenu(n, o) {
    const i = [], r = {
      componentName: "CometChatCallButtons",
      props: {
        user: n,
        group: o,
        callButtonsStyle: {
          width: "100%",
          height: "100%",
          border: "none",
          borderRadius: "0",
          background: "transparent",
          buttonPadding: "0px 0px 0px 2px",
          buttonBackground: "transparent",
          buttonBorder: "0 4px",
          buttonBorderRadius: "8px"
        },
        voiceCallIconText: "",
        videoCallIconText: "",
        key: "callbuttons"
      }
    };
    return i.push(r), i;
  }
}
class ws extends kr {
  constructor(n) {
    super();
    le(this, "configuration");
    this.configuration = n;
  }
  addExtension() {
    Ne.enable((n, o) => new Ma(n, o));
  }
  getExtensionId() {
    return "calling";
  }
  enable() {
    Ne.enable(
      (n) => new Ma(n, this.configuration)
    );
  }
}
class Gn {
  // Concrete implementation will be in its child class
  addExtension() {
  }
  // Concrete implementation will be in its child class
  getExtensionId() {
    return "";
  }
  enable() {
    y.isExtensionEnabled(this.getExtensionId()).then((t) => {
      t && this.addExtension();
    }).catch((t) => {
      console.error(t);
    });
  }
}
class qa {
  constructor(t) {
    le(this, "style");
    le(this, "iconURL");
    le(this, "optionIconURL");
    le(this, "optionStyle");
    this.style = t.style, this.iconURL = t.iconURL, this.optionIconURL = t.optionIconURL, this.optionStyle = t.optionStyle;
  }
  getDocumentBubbleStyle() {
    return this.style;
  }
  getIconURL() {
    return this.iconURL;
  }
  getOptionIconURL() {
    return this.optionIconURL;
  }
  getOptionStyle() {
    return this.optionStyle;
  }
}
class js extends Nn {
  constructor(n, o = new qa(
    { style: {}, iconURL: Ra, optionIconURL: "", optionStyle: {} }
  )) {
    super(n);
    le(this, "configuration");
    le(this, "newDataSource");
    le(this, "theme");
    this.newDataSource = n, this.configuration = o;
  }
  getAllMessageTypes() {
    const n = super.getAllMessageTypes();
    return n.includes(zn.extension_document) || n.push(zn.extension_document), n;
  }
  getId() {
    return "collaborativedocument";
  }
  getAllMessageCategories() {
    const n = super.getAllMessageCategories();
    return n.includes(I.MessageCategory.custom) || n.push(I.MessageCategory.custom), n;
  }
  checkIfTemplateExist(n, o) {
    return n.some((i) => i.type === o);
  }
  getAllMessageTemplates(n, o) {
    const i = n ?? new Ke({});
    this.theme = i;
    const l = super.getAllMessageTemplates(
      i,
      o
    );
    return this.checkIfTemplateExist(
      l,
      zn.extension_document
    ) || l.push(this.getDocumentTemplate(i)), l;
  }
  getDocumentTemplate(n) {
    return new Mn({
      type: zn.extension_document,
      category: I.MessageCategory.custom,
      contentView: (o, i) => {
        const l = o;
        return l.getDeletedAt() ? super.getDeleteMessageBubble(l, n) : this.getDocumentContentView(l, n);
      },
      bottomView: (o, i) => super.getBottomView(o, i),
      options: (o, i, l, r) => super.getCommonOptions(
        o,
        i,
        l,
        r
      )
    });
  }
  getDocumentContentView(n, o) {
    var d, N, T, m, A, D, z, k, R;
    const i = Li.right, l = {
      titleFont: ((d = this.configuration.getDocumentBubbleStyle()) == null ? void 0 : d.titleFont) || w(this.theme.typography.text2),
      titleColor: ((N = this.configuration.getDocumentBubbleStyle()) == null ? void 0 : N.titleColor) || this.theme.palette.getAccent(),
      subtitleFont: ((T = this.configuration.getDocumentBubbleStyle()) == null ? void 0 : T.subtitleFont) || w(this.theme.typography.subtitle2),
      subtitleColor: ((m = this.configuration.getDocumentBubbleStyle()) == null ? void 0 : m.subtitleColor) || this.theme.palette.getAccent600(),
      iconTint: ((A = this.configuration.getDocumentBubbleStyle()) == null ? void 0 : A.iconTint) || this.theme.palette.getAccent700(),
      buttonTextFont: ((D = this.configuration.getDocumentBubbleStyle()) == null ? void 0 : D.buttonTextFont) || w(this.theme.typography.text2),
      buttonTextColor: ((z = this.configuration.getDocumentBubbleStyle()) == null ? void 0 : z.buttonTextColor) || this.theme.palette.getPrimary(),
      buttonBackground: ((k = this.configuration.getDocumentBubbleStyle()) == null ? void 0 : k.buttonBackground) || "transparent",
      separatorColor: ((R = this.configuration.getDocumentBubbleStyle()) == null ? void 0 : R.separatorColor) || this.theme.palette.getAccent200()
    }, r = this.getDocumentURL(n), u = Y("COLLABORATIVE_DOCUMENT"), s = Y("OPEN_DOCUMENT"), c = Y("DRAW_DOCUMENT_TOGETHER");
    return {
      componentName: "CometChatDocumentExtensionBubble",
      props: {
        iconURL: this.configuration.getIconURL(),
        title: u,
        URL: r,
        subtitle: c,
        buttonText: s,
        documentStyle: l,
        hideSeparator: !1,
        iconAlignment: i,
        ccClicked: this.launchCollaborativeDocument
      }
    };
  }
  launchCollaborativeDocument(n) {
    window.open(n, "", "fullscreen=yes, scrollbars=auto");
  }
  getDocumentURL(n) {
    try {
      if (n != null && n.getData()) {
        const o = n.getData();
        if (o != null && o.metadata) {
          const i = o == null ? void 0 : o.metadata;
          if (Ce.checkHasOwnProperty(i, "@injected")) {
            const l = i["@injected"];
            if (l != null && l.extensions) {
              const r = l.extensions;
              return r[zn.document] ? r[zn.document].document_url : r[zn.document].board_url;
            }
          }
        }
      }
    } catch {
    }
  }
  getAttachmentOptions(n = new Ke({}), o) {
    var i, l, r, u;
    if (o != null && o.parentMessageId)
      return super.getAttachmentOptions(n, o);
    {
      const s = !!(o != null && o.user), c = s ? I.MessageReceiverType.user : I.MessageReceiverType.group, d = s ? o.user : o.group, N = super.getAttachmentOptions(n, o), T = new xn({
        id: zn.document,
        title: Y("COLLABORATIVE_DOCUMENT"),
        iconURL: this.configuration.getIconURL(),
        iconTint: ((i = this.configuration.getOptionStyle()) == null ? void 0 : i.iconTint) || n.palette.getAccent700(),
        titleColor: ((l = this.configuration.getOptionStyle()) == null ? void 0 : l.titleColor) || n.palette.getAccent600(),
        titleFont: ((r = this.configuration.getOptionStyle()) == null ? void 0 : r.titleFont) || w(n.typography.subtitle1),
        background: ((u = this.configuration.getOptionStyle()) == null ? void 0 : u.background) || n.palette.getAccent100(),
        onClick: () => {
          y.callExtension(
            zn.document,
            zn.post,
            zn.v1_create,
            { receiver: d, receiverType: c }
          ).then(
            (m) => {
            },
            (m) => {
            }
          );
        }
      });
      return N.push(T), N;
    }
  }
  getLastConversationMessage(n, o, i) {
    const l = n.getLastMessage();
    return l != null && l.getType() == zn.extension_document && l.getCategory() == I.MessageCategory.custom ? Y("CUSTOM_MESSAGE_DOCUMENT") : super.getLastConversationMessage(
      n,
      o,
      i
    );
  }
}
class As extends Gn {
  constructor({
    configuration: n
  } = {
    configuration: new qa({
      style: {},
      iconURL: Ra,
      optionIconURL: "",
      optionStyle: {}
    })
  }) {
    super();
    le(this, "configuration");
    this.configuration = n;
  }
  addExtension() {
    Ne.enable(
      (n) => new js(
        n,
        this.configuration
      )
    );
  }
  getExtensionId() {
    return Vn.document;
  }
}
class ua {
  constructor(t) {
    le(this, "style");
    le(this, "iconURL");
    le(this, "optionIconURL");
    le(this, "optionStyle");
    const { style: n, iconURL: o, optionIconURL: i, optionStyle: l } = t;
    this.style = n, this.iconURL = o, this.optionIconURL = i, this.optionStyle = l;
  }
  getWhiteboardBubbleStyle() {
    return this.style;
  }
  getIconURL() {
    return this.iconURL;
  }
  getOptionIconURL() {
    return this.optionIconURL;
  }
  getOptionStyle() {
    return this.optionStyle;
  }
}
class Ls extends Nn {
  constructor(n, { configuration: o }) {
    super(n);
    le(this, "configuration");
    le(this, "newDataSource");
    le(this, "theme", new Ke({}));
    this.newDataSource = n, this.configuration = o;
  }
  getAllMessageTypes() {
    const n = super.getAllMessageTypes();
    return n.some(
      (o) => o === Sn.extension_whiteboard
    ) || n.push(Sn.extension_whiteboard), n;
  }
  getId() {
    return "collaborativewhiteboard";
  }
  getAllMessageCategories() {
    const n = super.getAllMessageCategories();
    return n.includes(I.MessageCategory.custom) || n.push(I.MessageCategory.custom), n;
  }
  checkIfTemplateExist(n, o) {
    return n.some((i) => i.type === o);
  }
  getAllMessageTemplates(n, o) {
    const i = n ?? new Ke({});
    this.theme = i;
    const l = super.getAllMessageTemplates(
      i,
      o
    );
    return this.checkIfTemplateExist(
      l,
      Sn.extension_whiteboard
    ) || l.push(this.getWhiteBoardTemplate(i)), l;
  }
  getWhiteBoardTemplate(n) {
    return new Mn({
      type: Sn.extension_whiteboard,
      category: I.MessageCategory.custom,
      contentView: (o, i) => {
        const l = o;
        return l.getDeletedAt() ? super.getDeleteMessageBubble(l, n) : this.getWhiteboardContentView(l, n);
      },
      bottomView: (o, i) => super.getBottomView(o, i),
      options: (o, i, l, r) => super.getCommonOptions(
        o,
        i,
        l,
        r
      )
    });
  }
  getWhiteboardContentView(n, o) {
    var N, T, m;
    const i = Li.right, l = (N = this.configuration) == null ? void 0 : N.getWhiteboardBubbleStyle(), r = {
      titleFont: (l == null ? void 0 : l.titleFont) || w(this.theme.typography.text2),
      titleColor: (l == null ? void 0 : l.titleColor) || this.theme.palette.getAccent(),
      subtitleFont: (l == null ? void 0 : l.subtitleFont) || w(this.theme.typography.subtitle2),
      subtitleColor: (l == null ? void 0 : l.subtitleColor) || this.theme.palette.getAccent600(),
      iconTint: (l == null ? void 0 : l.iconTint) || this.theme.palette.getAccent700(),
      buttonTextFont: (l == null ? void 0 : l.buttonTextFont) || w(this.theme.typography.text2),
      buttonTextColor: (l == null ? void 0 : l.buttonTextColor) || this.theme.palette.getPrimary(),
      buttonBackground: (l == null ? void 0 : l.buttonBackground) || "transparent",
      separatorColor: (l == null ? void 0 : l.separatorColor) || this.theme.palette.getAccent200()
    }, u = this.getWhiteboardDocument(n), s = Y("COLLABORATIVE_WHITEBOARD"), c = Y("OPEN_WHITEBOARD"), d = Y("DRAW_WHITEBOARD_TOGETHER");
    return {
      componentName: "CometChatDocumentExtensionBubble",
      props: {
        hideSeparator: !1,
        iconAlignment: i,
        iconURL: (T = this.configuration) != null && T.getIconURL() ? (m = this.configuration) == null ? void 0 : m.getIconURL() : la,
        title: s,
        URL: u,
        subtitle: d,
        buttonText: c,
        documentStyle: r,
        ccClicked: this.launchCollaborativeWhiteboardDocument
      }
    };
  }
  async launchCollaborativeWhiteboardDocument(n) {
    const o = await An.getLoggedinUser();
    window.open(
      n + `&username=${o.getName()}`,
      "fullscreen=yes, scrollbars=auto"
    );
  }
  getWhiteboardDocument(n) {
    try {
      if (n != null && n.getData()) {
        const o = n.getData();
        if (o != null && o.metadata) {
          const i = o == null ? void 0 : o.metadata;
          if (Ce.checkHasOwnProperty(i, "@injected")) {
            const l = i["@injected"];
            if (l != null && l.extensions) {
              const r = l.extensions;
              return r[Sn.whiteboard] ? r[Sn.whiteboard].board_url : r[Sn.whiteboard].document_url;
            }
          }
        }
      }
    } catch (o) {
      console.log("error in getting whiteboard details", o);
    }
  }
  getAttachmentOptions(n = new Ke({}), o) {
    var i, l, r;
    if (o != null && o.parentMessageId)
      return super.getAttachmentOptions(n, o);
    {
      const u = (i = this.configuration) == null ? void 0 : i.getOptionStyle(), s = !!(o != null && o.user), c = s ? I.MessageReceiverType.user : I.MessageReceiverType.group, d = s ? o.user : o.group, N = super.getAttachmentOptions(n, o), T = new xn({
        id: Sn.whiteboard,
        title: Y("COLLABORATIVE_WHITEBOARD"),
        iconURL: (l = this.configuration) != null && l.getOptionIconURL() ? (r = this.configuration) == null ? void 0 : r.getOptionIconURL() : la,
        iconTint: (u == null ? void 0 : u.iconTint) || n.palette.getAccent700(),
        titleColor: (u == null ? void 0 : u.titleColor) || n.palette.getAccent600(),
        titleFont: (u == null ? void 0 : u.titleFont) || w(n.typography.subtitle1),
        background: (u == null ? void 0 : u.background) || n.palette.getAccent100(),
        onClick: () => {
          y.callExtension(
            Sn.whiteboard,
            Sn.post,
            Sn.v1_create,
            { receiver: d, receiverType: c }
          ).then(
            (m) => {
            },
            (m) => {
              console.log("error in sending whiteboard", m);
            }
          );
        }
      });
      return N.push(T), N;
    }
  }
  getLastConversationMessage(n, o, i) {
    const l = n.getLastMessage();
    return l != null && l.getType() == Sn.extension_whiteboard && l.getCategory() == I.MessageCategory.custom ? Y("CUSTOM_MESSAGE_WHITEBOARD") : super.getLastConversationMessage(
      n,
      o,
      i
    );
  }
}
class zs extends Gn {
  constructor({
    configuration: n
  } = {
    configuration: new ua({})
  }) {
    super();
    le(this, "configuration", new ua({}));
    this.configuration = n;
  }
  addExtension() {
    Ne.enable((n) => new Ls(n, {
      configuration: this.configuration
    }));
  }
  getExtensionId() {
    return Vn.whiteboard;
  }
}
class ga {
  constructor(t) {
    le(this, "style");
    le(this, "confirmDialogStyle");
    le(this, "backDropStyle");
    this.style = t.style, this.confirmDialogStyle = t.confirmDialogStyle, this.backDropStyle = t.backDropStyle;
  }
  getImageModerationStyle() {
    return this.style;
  }
  getConfirmDialogSyle() {
    return this.confirmDialogStyle;
  }
  getBackDropStyle() {
    return this.backDropStyle;
  }
}
class Ss extends Nn {
  constructor(n, { configuration: o }) {
    super(n);
    le(this, "configuration");
    le(this, "newDataSource");
    le(this, "theme");
    le(this, "onCancelClicked", () => {
      it.ccHideDialog.next();
    });
    le(this, "onConfirmClicked", (n) => {
      var o, i;
      (o = n == null ? void 0 : n.detail) != null && o.onConfirm && ((i = n == null ? void 0 : n.detail) == null || i.onConfirm()), it.ccHideDialog.next();
    });
    this.newDataSource = n, this.configuration = o;
  }
  getId() {
    return "imagemoderation";
  }
  getImageMessageContentView(n, o, i) {
    var u;
    this.theme = i;
    const l = n.getMetadata(), r = this.getImageModerationStyle(i);
    try {
      let s = (u = n.getAttachments()[0]) == null ? void 0 : u.getUrl();
      return l && Object.prototype.hasOwnProperty.call(l, "@injected") && Object.prototype.hasOwnProperty.call(
        l["@injected"],
        "extensions"
      ) && Object.prototype.hasOwnProperty.call(
        l["@injected"].extensions,
        "thumbnail-generation"
      ) && l["@injected"].extensions["thumbnail-generation"].url_small && (s = n.getMetadata()["@injected"].extensions["thumbnail-generation"].url_small), {
        componentName: "CometChatImageModerationBubble",
        props: {
          message: n,
          imageModerationStyle: r,
          src: s,
          placeholderImage: vi,
          listeners: {
            "cc-show-dialog": this.showDialog.bind(this)
          }
        }
      };
    } catch (s) {
      console.log("ERROR: ", s);
    }
  }
  showDialog(n) {
    var o;
    it.ccShowDialog.next({
      confirmCallback: (o = n == null ? void 0 : n.detail) == null ? void 0 : o.onConfirm,
      child: this.getConfirmDialogView(n)
    });
  }
  getConfirmDialogView(n) {
    var r, u, s, c, d, N, T;
    const o = (r = this.configuration) == null ? void 0 : r.getConfirmDialogSyle(), i = {
      confirmButtonBackground: (o == null ? void 0 : o.confirmButtonBackground) || this.theme.palette.getError(),
      cancelButtonBackground: (o == null ? void 0 : o.cancelButtonBackground) || this.theme.palette.getSecondary(),
      confirmButtonTextColor: (o == null ? void 0 : o.confirmButtonTextColor) || this.theme.palette.getAccent900("light"),
      confirmButtonTextFont: (o == null ? void 0 : o.confirmButtonTextFont) || w(this.theme.typography.text2),
      cancelButtonTextColor: (o == null ? void 0 : o.cancelButtonTextColor) || this.theme.palette.getAccent900("dark"),
      cancelButtonTextFont: (o == null ? void 0 : o.cancelButtonTextFont) || w(this.theme.typography.text2),
      titleFont: (o == null ? void 0 : o.titleFont) || w(this.theme.typography.title1),
      titleColor: (o == null ? void 0 : o.titleColor) || this.theme.palette.getAccent(),
      messageTextFont: (o == null ? void 0 : o.messageTextFont) || w(this.theme.typography.subtitle2),
      messageTextColor: (o == null ? void 0 : o.messageTextColor) || this.theme.palette.getAccent600(),
      background: (o == null ? void 0 : o.cancelButtonBackground) || this.theme.palette.getBackground(),
      height: (o == null ? void 0 : o.background) || "100%",
      width: (o == null ? void 0 : o.width) || "100%",
      border: (o == null ? void 0 : o.border) || `1px solid ${this.theme.palette.getAccent100()}`,
      borderRadius: (o == null ? void 0 : o.borderRadius) || "8px"
    };
    return {
      componentName: "CometChatConfirmDialogView",
      props: {
        backdropStyle: {
          height: ((s = (u = this.configuration) == null ? void 0 : u.getBackDropStyle()) == null ? void 0 : s.height) || "100%",
          width: ((d = (c = this.configuration) == null ? void 0 : c.getBackDropStyle()) == null ? void 0 : d.width) || "100%",
          background: ((T = (N = this.configuration) == null ? void 0 : N.getBackDropStyle()) == null ? void 0 : T.background) || "rgba(0, 0, 0, 0.5)"
        },
        title: "",
        warningText: "Are you sure want to see unsafe content?",
        confirmText: Y("YES"),
        cancelText: Y("NO"),
        confirmDialogStyle: i,
        listeners: {
          "cc-cancel-clicked": this.onCancelClicked,
          "cc-confirm-clicked": () => {
            this.onConfirmClicked(n);
          }
        }
      }
    };
  }
  getImageModerationStyle(n) {
    var i;
    const o = (i = this.configuration) == null ? void 0 : i.getImageModerationStyle();
    return {
      filterColor: (o == null ? void 0 : o.filterColor) || n.palette.getPrimary(),
      height: (o == null ? void 0 : o.height) || "100%",
      width: (o == null ? void 0 : o.width) || "100%",
      border: (o == null ? void 0 : o.border) || "none",
      borderRadius: (o == null ? void 0 : o.borderRadius) || "8px",
      warningTextColor: (o == null ? void 0 : o.warningTextColor) || n.palette.getAccent("dark"),
      warningTextFont: (o == null ? void 0 : o.warningTextFont) || w(n.typography.title2)
    };
  }
}
class ps extends Gn {
  constructor({ configuration: n } = {
    configuration: new ga({})
  }) {
    super();
    le(this, "configuration", new ga({}));
    this.configuration = n;
  }
  addExtension() {
    Ne.enable(
      (n) => new Ss(n, {
        configuration: this.configuration
      })
    );
  }
  getExtensionId() {
    return Vn.imageModeration;
  }
}
class ca {
  constructor(t) {
    le(this, "style");
    this.style = t.style;
  }
  getLinkPreviewStyle() {
    return this.style;
  }
}
class bs extends Nn {
  constructor(n, { configuration: o }) {
    super(n);
    le(this, "configuration");
    le(this, "newDataSource");
    this.newDataSource = n, this.configuration = o;
  }
  getId() {
    return "linkpreview";
  }
  getTextMessageContentView(n, o, i, l) {
    const r = this.getLinkPreview(n);
    if (r && !n.getDeletedAt() && n.getType() !== I.MessageTypes.groupMember) {
      let u = {
        ...l,
        textFormatters: l != null && l.textFormatters && (l != null && l.textFormatters.length) ? [...l.textFormatters] : this.getAllTextFormatters({ theme: i, alignment: o, disableMentions: l.disableMentions })
      }, s = u.textFormatters, c;
      if (u && !u.disableMentions) {
        let d;
        for (let N = 0; N < s.length && !(s[N] instanceof yo && (d = s[N], d.setMessage(n), n != null && n.getMentionedUsers().length && d.setCometChatUserGroupMembers(
          n == null ? void 0 : n.getMentionedUsers()
        ), d.setLoggedInUser(
          Ct.getLoggedInUser()
        ), c) || s[N] instanceof Co && (c = s[N], d)); N++)
          ;
        d || (d = Ne.getDataSource().getMentionsTextFormatter({
          message: n,
          ...u,
          alignment: o,
          theme: i
        }), s.push(d));
      } else
        for (let d = 0; d < s.length; d++)
          if (s[d] instanceof Co) {
            c = s[d];
            break;
          }
      c || (c = Ne.getDataSource().getUrlTextFormatter(
        {
          theme: i,
          alignment: o
        }
      ), s.push(c));
      for (let d = 0; d < s.length; d++)
        s[d].setMessageBubbleAlignment(o), s[d].setMessage(n);
      return {
        componentName: "CometChatLinkPreviewBubble",
        props: {
          title: this.getLinkPreviewDetails(r, "title"),
          description: this.getLinkPreviewDetails(
            r,
            "description"
          ),
          URL: this.getLinkPreviewDetails(r, "url"),
          image: this.getLinkPreviewDetails(r, "image"),
          favIconURL: this.getLinkPreviewDetails(r, "favicon"),
          linkPreviewStyle: this.getLinkPreviewStyle(i),
          textStyle: this.getTextMessageStyle(o, i),
          text: n.getText(),
          listeners: {
            "cc-link-clicked": this.openLink
          },
          textFormatters: s
        }
      };
    } else
      return super.getTextMessageContentView(
        n,
        o,
        i,
        l
      );
  }
  openLink(n) {
    var o;
    window.open((o = n == null ? void 0 : n.detail) == null ? void 0 : o.url, "_blank");
  }
  getLinkPreviewStyle(n) {
    var i;
    const o = (i = this.configuration) == null ? void 0 : i.getLinkPreviewStyle();
    return new fr({
      titleColor: (o == null ? void 0 : o.titleColor) || n.palette.getAccent(),
      titleFont: (o == null ? void 0 : o.titleFont) || w(n.typography.title2),
      descriptionColor: (o == null ? void 0 : o.descriptionColor) || n.palette.getAccent600(),
      descriptionFont: (o == null ? void 0 : o.descriptionFont) || w(n.typography.subtitle2),
      background: (o == null ? void 0 : o.background) || "transparent",
      height: (o == null ? void 0 : o.height) || "fit-content",
      width: (o == null ? void 0 : o.width) || "100%"
    });
  }
  getTextMessageStyle(n, o) {
    return n !== gt.left ? {
      textFont: w(o.typography.text3),
      textColor: o.palette.getAccent900()
    } : {
      textFont: w(o.typography.text3),
      textColor: o.palette.getAccent()
    };
  }
  getLinkPreview(n) {
    try {
      if (n != null && n.getMetadata()) {
        const i = n.getMetadata()[Ao.injected];
        if (i && (i != null && i.extensions)) {
          const l = i.extensions;
          if (l && Ce.checkHasOwnProperty(
            l,
            Ao.link_preview
          )) {
            const r = l[Ao.link_preview];
            return r && Ce.checkHasOwnProperty(
              r,
              Ao.links
            ) && r[Ao.links].length ? r[Ao.links][0] : null;
          } else
            return null;
        }
      } else
        return null;
    } catch (o) {
      console.log("error in getting link preview details", o);
    }
  }
  getLinkPreviewDetails(n, o) {
    return Object.keys(n).length > 0 ? n[o] : "";
  }
}
class Es extends Gn {
  constructor({ configuration: n } = {
    configuration: new ca({})
  }) {
    super();
    le(this, "configuration", new ca({}));
    this.configuration = n;
  }
  addExtension() {
    Ne.enable(
      (n) => new bs(n, {
        configuration: this.configuration
      })
    );
  }
  getExtensionId() {
    return Vn.linkPreview;
  }
}
class hs extends Nn {
  constructor(n, { configuration: o }) {
    super(n);
    le(this, "configuration");
    le(this, "newDataSource");
    le(this, "getTranslationStyle", (n, o) => {
      var r;
      const i = (r = this.configuration) == null ? void 0 : r.getMessageTranslationStyle();
      return n !== gt.left ? new di({
        translatedTextFont: (i == null ? void 0 : i.translatedTextFont) || w(o.typography.text3),
        translatedTextColor: (i == null ? void 0 : i.translatedTextColor) || o.palette.getAccent("dark"),
        helpTextColor: (i == null ? void 0 : i.helpTextColor) || o.palette.getAccent700("dark"),
        helpTextFont: (i == null ? void 0 : i.helpTextFont) || w(o.typography.caption2),
        background: (i == null ? void 0 : i.background) || "transparent"
      }) : new di({
        translatedTextFont: (i == null ? void 0 : i.translatedTextFont) || w(o.typography.text3),
        translatedTextColor: (i == null ? void 0 : i.translatedTextColor) || o.palette.getAccent("light"),
        helpTextColor: (i == null ? void 0 : i.helpTextColor) || o.palette.getAccent700(),
        helpTextFont: (i == null ? void 0 : i.helpTextFont) || w(o.typography.caption2),
        background: (i == null ? void 0 : i.background) || "transparent"
      });
    });
    this.newDataSource = n, this.configuration = o;
  }
  getTextMessageOptions(n, o, i, l) {
    var s, c, d;
    const r = (s = this.configuration) == null ? void 0 : s.getOptionStyle(), u = super.getTextMessageOptions(n, o, i, l);
    if (!this.checkIfOptionExist(
      u,
      I.MessageOption.translateMessage
    )) {
      const N = new go({
        id: I.MessageOption.translateMessage,
        title: Y("TRANSLATE"),
        iconURL: (c = this.configuration) != null && c.getOptionIconURL() ? (d = this.configuration) == null ? void 0 : d.getOptionIconURL() : ls,
        onClick: function() {
          y.callExtension(
            "message-translation",
            "POST",
            "v2/translate",
            {
              msgId: o.getId(),
              text: o.getText(),
              languages: navigator.languages
            }
          ).then((T) => {
            if (T && Object.prototype.hasOwnProperty.call(
              T,
              "translations"
            )) {
              const m = T.translations[0].message_translated;
              if (m && m.trim()) {
                const A = o.getMetadata();
                A.translated_message = m, o.setMetadata(
                  A
                ), ae.ccMessageEdited.next({
                  message: o,
                  status: Xe.success
                });
              }
            }
          }).catch((T) => {
            console.log("error", T);
          });
        },
        iconTint: (r == null ? void 0 : r.iconTint) || i.palette.getAccent600(),
        titleColor: (r == null ? void 0 : r.titleColor) || i.palette.getAccent600(),
        titleFont: (r == null ? void 0 : r.titleFont) || w(i.typography.subtitle1),
        backgroundColor: (r == null ? void 0 : r.background) || "transparent"
      });
      u.push(N);
    }
    return u;
  }
  getTextMessageStyle(n, o) {
    return n !== gt.left ? {
      textFont: w(o.typography.text3),
      textColor: o.palette.getAccent900()
    } : {
      textFont: w(o.typography.text3),
      textColor: o.palette.getAccent()
    };
  }
  getTextMessageContentView(n, o, i, l) {
    const r = n.getMetadata();
    if (r && Object.prototype.hasOwnProperty.call(r, "translated_message") && !n.getDeletedAt() && n.getType() !== I.MessageTypes.groupMember) {
      const u = r.translated_message;
      let s = {
        ...l,
        textFormatters: l != null && l.textFormatters && (l != null && l.textFormatters.length) ? [...l.textFormatters] : this.getAllTextFormatters({ theme: i, alignment: o, disableMentions: l.disableMentions })
      }, c = s.textFormatters, d;
      if (s && !s.disableMentions) {
        let N;
        for (let T = 0; T < c.length && !(c[T] instanceof yo && (N = c[T], N.setMessage(n), n != null && n.getMentionedUsers().length && N.setCometChatUserGroupMembers(
          n == null ? void 0 : n.getMentionedUsers()
        ), N.setLoggedInUser(
          Ct.getLoggedInUser()
        ), d) || c[T] instanceof Co && (d = c[T], N)); T++)
          ;
        N || (N = Ne.getDataSource().getMentionsTextFormatter({
          message: n,
          ...s,
          alignment: o,
          theme: i
        }), c.push(N));
      } else
        for (let N = 0; N < c.length; N++)
          if (c[N] instanceof Co) {
            d = c[N];
            break;
          }
      d || (d = Ne.getDataSource().getUrlTextFormatter(
        {
          theme: i,
          alignment: o
        }
      ), c.push(d));
      for (let N = 0; N < c.length; N++)
        c[N].setMessageBubbleAlignment(o), c[N].setMessage(n);
      return {
        componentName: "CometChatMessageTranslationBubble",
        props: {
          translatedText: u,
          alignment: o,
          messageTranslationStyle: this.getTranslationStyle(o, i),
          textStyle: this.getTextMessageStyle(o, i),
          text: n.getText(),
          textFormatters: c
        }
      };
    } else
      return super.getTextMessageContentView(
        n,
        o,
        i,
        l
      );
  }
  checkIfOptionExist(n, o) {
    return n.some((i) => i.id === o);
  }
  getId() {
    return "messagetranslation";
  }
}
class da {
  constructor(t) {
    le(this, "style");
    le(this, "optionIconURL");
    le(this, "optionStyle");
    const { style: n, optionIconURL: o, optionStyle: i } = t;
    this.style = n, this.optionIconURL = o, this.optionStyle = i;
  }
  getMessageTranslationStyle() {
    return this.style;
  }
  getOptionIconURL() {
    return this.optionIconURL;
  }
  getOptionStyle() {
    return this.optionStyle;
  }
}
class vs extends Gn {
  constructor({ configuration: n } = {
    configuration: new da({})
  }) {
    super();
    le(this, "configuration", new da({}));
    this.configuration = n;
  }
  addExtension() {
    Ne.enable(
      (n) => new hs(n, {
        configuration: this.configuration
      })
    );
  }
  getExtensionId() {
    return Vn.messageTranslation;
  }
}
class ms {
  constructor(t) {
    le(this, "style");
    le(this, "createPollStyle");
    le(this, "createPollIconURL");
    le(this, "deleteIconURL");
    le(this, "closeIconURL");
    le(this, "optionIconURL");
    le(this, "addAnswerIconURL");
    le(this, "optionStyle");
    const {
      style: n,
      createPollStyle: o,
      createPollIconURL: i,
      deleteIconURL: l,
      closeIconURL: r,
      optionIconURL: u,
      addAnswerIconURL: s,
      optionStyle: c
    } = t;
    this.style = n, this.createPollStyle = o, this.createPollIconURL = i, this.deleteIconURL = l, this.closeIconURL = r, this.optionIconURL = u, this.addAnswerIconURL = s, this.optionStyle = c;
  }
  getPollsBubbleStyle() {
    return this.style;
  }
  getCreatePollStyle() {
    return this.createPollStyle;
  }
  getCreatePollIconURL() {
    return this.createPollIconURL;
  }
  getDeleteIconURL() {
    return this.deleteIconURL;
  }
  getCloseIconURL() {
    return this.closeIconURL;
  }
  getOptionIconURL() {
    return this.optionIconURL;
  }
  getAddAnswerIconURL() {
    return this.addAnswerIconURL;
  }
  getOptionStyle() {
    return this.optionStyle;
  }
}
class Os extends Nn {
  constructor(n, { configuration: o }) {
    super(n);
    le(this, "theme", new Ke({}));
    le(this, "loggedInUser", null);
    le(this, "configuration");
    le(this, "newDataSource");
    this.getLoggedInUser(), this.newDataSource = n, this.configuration = o;
  }
  async getLoggedInUser() {
    this.loggedInUser = await y.getLoggedinUser();
  }
  getId() {
    return "polls";
  }
  getAllMessageTypes() {
    const n = super.getAllMessageTypes();
    return n.includes(Io.extension_poll) || n.push(Io.extension_poll), n;
  }
  getAllMessageCategories() {
    const n = super.getAllMessageCategories();
    return n.includes(I.MessageCategory.custom) || n.push(I.MessageCategory.custom), n;
  }
  checkIfTemplateExist(n, o) {
    return n.some((i) => i.type === o);
  }
  getAllMessageTemplates(n, o) {
    const i = n ?? new Ke({});
    this.theme = i;
    const l = super.getAllMessageTemplates(
      i,
      o
    );
    return this.checkIfTemplateExist(l, Io.extension_poll) || l.push(this.getPollsTemplate(i)), l;
  }
  getPollsTemplate(n) {
    return new Mn({
      type: Io.extension_poll,
      category: I.MessageCategory.custom,
      contentView: (o, i) => {
        const l = o;
        return l.getDeletedAt() ? super.getDeleteMessageBubble(l, n) : this.getPollsContentView(l, n);
      },
      bottomView: (o, i) => super.getBottomView(o, i),
      options: (o, i, l, r) => super.getCommonOptions(
        o,
        i,
        l,
        r
      )
    });
  }
  getPollsContentView(n, o) {
    var r;
    const i = (r = this.configuration) == null ? void 0 : r.getPollsBubbleStyle();
    return {
      componentName: "CometChatPollsBubble",
      props: {
        pollStyle: {
          borderRadius: (i == null ? void 0 : i.borderRadius) || "8px",
          background: (i == null ? void 0 : i.background) || "transparent",
          votePercentTextFont: (i == null ? void 0 : i.votePercentTextFont) || w(o.typography.subtitle2),
          votePercentTextColor: (i == null ? void 0 : i.votePercentTextColor) || o.palette.getAccent600(),
          pollQuestionTextFont: (i == null ? void 0 : i.pollQuestionTextFont) || w(o.typography.subtitle1),
          pollQuestionTextColor: (i == null ? void 0 : i.pollQuestionTextColor) || o.palette.getAccent(),
          pollOptionTextFont: (i == null ? void 0 : i.pollOptionTextFont) || w(o.typography.text2),
          pollOptionTextColor: (i == null ? void 0 : i.pollOptionTextColor) || o.palette.getAccent(),
          pollOptionBackground: (i == null ? void 0 : i.pollOptionBackground) || o.palette.getAccent900(),
          optionsIconTint: (i == null ? void 0 : i.optionsIconTint) || o.palette.getAccent600(),
          totalVoteCountTextFont: (i == null ? void 0 : i.totalVoteCountTextFont) || w(o.typography.subtitle2),
          totalVoteCountTextColor: (i == null ? void 0 : i.totalVoteCountTextColor) || o.palette.getAccent600(),
          selectedPollOptionBackground: (i == null ? void 0 : i.selectedPollOptionBackground) || o.palette.getAccent200(),
          userSelectedOptionBackground: (i == null ? void 0 : i.userSelectedOptionBackground) || o.palette.getPrimary(),
          pollOptionBorder: (i == null ? void 0 : i.pollOptionBorder) || `1px solid ${o.palette.getAccent100()}`,
          pollOptionBorderRadius: (i == null ? void 0 : i.pollOptionBorderRadius) || "8px"
        },
        pollQuestion: this.getPollBubbleData(n, "question"),
        pollId: this.getPollBubbleData(n, "id"),
        senderUid: this.getPollBubbleData(n),
        loggedInUser: this.loggedInUser,
        metadata: n == null ? void 0 : n.getMetadata()
      }
    };
  }
  getPollBubbleData(n, o) {
    const i = n.getCustomData();
    return o ? o === "options" ? Object.values(i[o]) : i[o] : n.getSender().getUid();
  }
  getAttachmentOptions(n = new Ke({}), o) {
    var i, l, r;
    if (o != null && o.parentMessageId)
      return super.getAttachmentOptions(n, o);
    {
      const u = (i = this.configuration) == null ? void 0 : i.getOptionStyle(), s = super.getAttachmentOptions(n, o), c = new xn({
        id: Io.extension_poll,
        title: Y("POLLS"),
        iconURL: (l = this.configuration) != null && l.getOptionIconURL() ? (r = this.configuration) == null ? void 0 : r.getOptionIconURL() : es,
        iconTint: (u == null ? void 0 : u.iconTint) || n.palette.getAccent700(),
        titleColor: (u == null ? void 0 : u.titleColor) || n.palette.getAccent600(),
        titleFont: (u == null ? void 0 : u.titleFont) || w(n.typography.subtitle1),
        background: (u == null ? void 0 : u.background) || n.palette.getAccent100(),
        onClick: this.onPollsButtonClicked.bind(this)
      });
      return s.push(c), s;
    }
  }
  onPollsButtonClicked(...n) {
    var s;
    const [o] = n, i = o[0], l = o[1], r = (s = this.configuration) == null ? void 0 : s.getCreatePollStyle(), u = {
      placeholderTextFont: (r == null ? void 0 : r.placeholderTextFont) || w(this.theme.typography.subtitle1),
      placeholderTextColor: (r == null ? void 0 : r.placeholderTextColor) || this.theme.palette.getAccent600(),
      deleteIconTint: (r == null ? void 0 : r.deleteIconTint) || this.theme.palette.getAccent600(),
      titleFont: (r == null ? void 0 : r.titleFont) || w(this.theme.typography.title1),
      titleColor: (r == null ? void 0 : r.titleColor) || this.theme.palette.getAccent(),
      closeIconTint: (r == null ? void 0 : r.closeIconTint) || this.theme.palette.getPrimary(),
      questionInputBackground: (r == null ? void 0 : r.questionInputBackground) || this.theme.palette.getAccent100(),
      optionInputBackground: (r == null ? void 0 : r.optionInputBackground) || this.theme.palette.getAccent100(),
      answerHelpTextFont: (r == null ? void 0 : r.answerHelpTextFont) || w(this.theme.typography.caption1),
      answerHelpTextColor: (r == null ? void 0 : r.answerHelpTextColor) || this.theme.palette.getAccent400(),
      addAnswerIconTint: (r == null ? void 0 : r.addAnswerIconTint) || this.theme.palette.getPrimary(),
      createPollButtonTextFont: (r == null ? void 0 : r.createPollButtonTextFont) || w(this.theme.typography.text2),
      createPollButtonTextColor: (r == null ? void 0 : r.createPollButtonTextColor) || this.theme.palette.getAccent("dark"),
      createPollButtonBackground: (r == null ? void 0 : r.createPollButtonBackground) || this.theme.palette.getPrimary(),
      addAnswerTextFont: (r == null ? void 0 : r.addAnswerTextFont) || w(this.theme.typography.text2),
      addAnswerTextColor: (r == null ? void 0 : r.addAnswerTextColor) || this.theme.palette.getPrimary(),
      errorTextFont: (r == null ? void 0 : r.errorTextFont) || w(this.theme.typography.subtitle1),
      errorTextColor: (r == null ? void 0 : r.errorTextColor) || this.theme.palette.getError(),
      optionPlaceholderTextFont: (r == null ? void 0 : r.optionPlaceholderTextFont) || w(this.theme.typography.subtitle1),
      optionPlaceholderTextColor: (r == null ? void 0 : r.optionPlaceholderTextColor) || this.theme.palette.getAccent600(),
      questionInputTextFont: (r == null ? void 0 : r.questionInputTextFont) || w(this.theme.typography.subtitle2),
      questionInputTextColor: (r == null ? void 0 : r.questionInputTextColor) || this.theme.palette.getAccent600(),
      optionInputTextFont: (r == null ? void 0 : r.optionInputTextFont) || w(this.theme.typography.subtitle2),
      optionInputTextColor: (r == null ? void 0 : r.optionInputTextColor) || this.theme.palette.getAccent600(),
      width: (r == null ? void 0 : r.width) || "360px",
      height: (r == null ? void 0 : r.height) || "620px",
      border: (r == null ? void 0 : r.border) || "",
      borderRadius: (r == null ? void 0 : r.borderRadius) || "8px",
      background: (r == null ? void 0 : r.background) || this.theme.palette.getAccent900(),
      position: "absolute",
      zIndex: 1
    };
    it.ccShowModal.next({
      child: this.getPollView(i, l, u)
    });
  }
  getPollView(n, o, i) {
    var l, r, u;
    return {
      componentName: "CometChatCreatePollView",
      props: {
        user: n,
        group: o,
        createPollStyle: i,
        deleteIconURL: ((l = this.configuration) == null ? void 0 : l.getDeleteIconURL()) || "",
        closeIconURL: ((r = this.configuration) == null ? void 0 : r.getCloseIconURL()) || "",
        addAnswerIconURL: ((u = this.configuration) == null ? void 0 : u.getAddAnswerIconURL()) || "",
        listeners: {
          "cc-close-clicked": this.triggerCloseEvent
        }
      }
    };
  }
  triggerCloseEvent() {
    it.ccHideModal.next();
  }
  getLastConversationMessage(n, o, i) {
    const l = n.getLastMessage();
    return l != null && l.getType() == Io.extension_poll && l.getCategory() == I.MessageCategory.custom ? Y("CUSTOM_MESSAGE_POLL") : super.getLastConversationMessage(
      n,
      o,
      i
    );
  }
}
class xs extends Gn {
  constructor({ configuration: n } = {
    configuration: new ms({
      closeIconURL: Cn,
      deleteIconURL: Qa,
      addAnswerIconURL: Pa
    })
  }) {
    super();
    le(this, "configuration");
    this.configuration = n;
  }
  addExtension() {
    Ne.enable(
      (n) => new Os(n, {
        configuration: this.configuration
      })
    );
  }
  getExtensionId() {
    return Vn.polls;
  }
}
class _a {
  constructor(t) {
    le(this, "style");
    this.style = t.style;
  }
  getSmartRepliesStyle() {
    return this.style;
  }
}
class ks extends Nn {
  constructor(n, o = new _a({
    style: {}
  }), i) {
    super(n);
    le(this, "configuration");
    le(this, "LISTENER_ID", "smartreply__listener");
    le(this, "activeUser");
    le(this, "activeGroup");
    le(this, "currentMessage", null);
    le(this, "loggedInUser");
    le(this, "theme");
    this.configuration = o, this.theme = i, this.addMessageListener();
  }
  getId() {
    return "smartreply";
  }
  addMessageListener() {
    y.getLoggedinUser().then((n) => {
      n && (this.loggedInUser = n);
    }), ae.onTextMessageReceived.subscribe((n) => {
      n != null && (this.currentMessage = n, n.getReceiverType() === I.MessageReceiverType.user && this.activeUser != null ? n.getSender() != null && n.getSender().getUid() != null && this.activeUser.getUid() == n.getSender().getUid() && it.ccShowPanel.next({
        configuration: this.configuration,
        message: n,
        child: this.getSmartReplyView(n)
      }) : n.getReceiverType() === I.MessageReceiverType.group && this.activeGroup != null && this.activeGroup.getGuid() != null && this.activeGroup.getGuid() == n.getReceiverId() && it.ccShowPanel.next({
        configuration: this.configuration,
        message: n,
        child: this.getSmartReplyView(n)
      }));
    }), it.ccActiveChatChanged.subscribe(
      (n) => {
        this.currentMessage = n.message, this.activeUser = n.user, this.activeGroup = n.group, this.currentMessage instanceof y.TextMessage && this.currentMessage != null && this.currentMessage.getSender() != null && this.loggedInUser != null && this.currentMessage.getSender().getUid() != null && this.currentMessage.getSender().getUid() != this.loggedInUser.getUid() && it.ccShowPanel.next({
          configuration: this.configuration,
          message: this.currentMessage,
          child: this.getSmartReplyView(this.currentMessage)
        });
      }
    ), ae.ccMessageSent.subscribe(() => {
      it.ccHidePanel.next(), this.currentMessage = null;
    });
  }
  getReplies(n) {
    var l, r, u;
    const o = n, i = (u = (r = (l = o == null ? void 0 : o.metadata) == null ? void 0 : l[Xi.injected]) == null ? void 0 : r.extensions) == null ? void 0 : u[Xi.smart_reply];
    if (i != null && i.reply_positive && (i != null && i.reply_neutral) && (i != null && i.reply_negative)) {
      const { reply_positive: s, reply_neutral: c, reply_negative: d } = i;
      return [s, c, d];
    }
    return null;
  }
  getSmartReplyStyle() {
    var n, o, i, l, r, u, s, c, d, N, T, m, A, D, z, k, R, Q;
    return {
      replyTextFont: ((o = (n = this.configuration) == null ? void 0 : n.getSmartRepliesStyle()) == null ? void 0 : o.replyTextFont) || w(this.theme.typography.caption1),
      replyTextColor: ((l = (i = this.configuration) == null ? void 0 : i.getSmartRepliesStyle()) == null ? void 0 : l.replyTextColor) || this.theme.palette.getAccent(),
      replyBackground: ((u = (r = this.configuration) == null ? void 0 : r.getSmartRepliesStyle()) == null ? void 0 : u.replyBackground) || this.theme.palette.getBackground(),
      boxShadow: ((c = (s = this.configuration) == null ? void 0 : s.getSmartRepliesStyle()) == null ? void 0 : c.boxShadow) || `0px 0px 1px ${this.theme.palette.getAccent600()}`,
      closeIconTint: ((N = (d = this.configuration) == null ? void 0 : d.getSmartRepliesStyle()) == null ? void 0 : N.closeIconTint) || this.theme.palette.getAccent600(),
      background: ((m = (T = this.configuration) == null ? void 0 : T.getSmartRepliesStyle()) == null ? void 0 : m.background) || this.theme.palette.getBackground(),
      width: (D = (A = this.configuration) == null ? void 0 : A.getSmartRepliesStyle()) == null ? void 0 : D.width,
      height: (k = (z = this.configuration) == null ? void 0 : z.getSmartRepliesStyle()) == null ? void 0 : k.height,
      border: (Q = (R = this.configuration) == null ? void 0 : R.getSmartRepliesStyle()) == null ? void 0 : Q.border,
      display: "flex",
      justifyContent: "flex-start"
    };
  }
  sendSmartReply(n) {
    var r;
    const o = this.activeUser ? I.MessageReceiverType.user : I.MessageReceiverType.group, i = (r = n == null ? void 0 : n.detail) == null ? void 0 : r.reply, l = this.currentMessage;
    if (i && i.trim().length > 0 && l) {
      let u;
      if (l.getReceiverType() === I.MessageReceiverType.user)
        u = new y.TextMessage(
          l.getSender().getUid(),
          i.trim(),
          o
        ), u.setReceiver(this.activeUser);
      else {
        const s = l.getReceiver();
        u = new y.TextMessage(
          s.getGuid(),
          i.trim(),
          o
        ), u.setReceiver(this.activeGroup);
      }
      l.getParentMessageId() > 0 && u.setParentMessageId(l.getParentMessageId()), u.setCategory(
        I.MessageCategory.message
      ), u.setSender(this.loggedInUser), u.setSentAt(Ce.getUnixTimestamp()), u.setMuid(Ce.ID()), ae.ccMessageSent.next({
        message: u,
        status: Xe.inprogress
      }), y.sendMessage(u).then(
        (s) => {
          ae.ccMessageSent.next({
            message: s,
            status: Xe.success
          });
        },
        (s) => {
          u.setMetadata({ error: !0 }), ae.ccMessageSent.next({
            message: u,
            status: Xe.error
          });
        }
      );
    }
  }
  closeSmartReply() {
    it.ccHidePanel.next(), this.currentMessage = null;
  }
  getSmartReplyView(n) {
    return this.getReplies(n) ? {
      componentName: "CometChatSmartReplyBubble",
      props: {
        smartReplyStyle: this.getSmartReplyStyle(),
        replies: this.getReplies(n),
        listeners: {
          "cc-reply-clicked": (o) => {
            o.msg = n, this.sendSmartReply(o);
          },
          "cc-close-clicked": this.closeSmartReply.bind(this)
        }
      }
    } : null;
  }
}
class fs extends Gn {
  constructor({
    configuration: n,
    theme: o
  } = {
    configuration: new _a({
      style: {}
    }),
    theme: new Ke({})
  }) {
    super();
    le(this, "configuration");
    le(this, "theme");
    this.configuration = n, this.theme = o;
  }
  addExtension() {
    Ne.enable(
      (n) => new ks(
        n,
        this.configuration,
        this.theme
      )
    );
  }
  getExtensionId() {
    return Vn.smartReply;
  }
}
class Ia {
  constructor(t) {
    le(this, "style");
    le(this, "stickerIconURL");
    le(this, "closeIconURL");
    const { style: n, stickerIconURL: o, closeIconURL: i } = t;
    this.style = n, this.stickerIconURL = o, this.closeIconURL = i;
  }
  getStickersStyle() {
    return this.style;
  }
  getStickerIconURL() {
    return this.stickerIconURL;
  }
  getCloseIconURL() {
    return this.closeIconURL;
  }
}
class Us extends Nn {
  constructor(n, { configuration: o }) {
    super(n);
    le(this, "configuration");
    le(this, "newDataSource");
    le(this, "theme", new Ke({}));
    le(this, "id");
    le(this, "user");
    le(this, "group");
    this.newDataSource = n, this.configuration = o;
  }
  getDataSource() {
    return this.newDataSource;
  }
  getAllMessageTemplates(n, o) {
    const i = n ?? new Ke({});
    this.theme = i;
    const l = super.getAllMessageTemplates(
      i,
      o
    );
    return this.checkIfTemplateExist(l, On.sticker) || l.push(this.getStickerTemplate(i)), l;
  }
  getAuxiliaryOptions(n, o, i, l) {
    this.id = n, this.user = o, this.group = i, this.theme = l;
    const r = super.getAuxiliaryOptions(n, o, i, l);
    return r.push(
      this.getStickerAuxiliaryButton(n, o, i, l)
    ), r;
  }
  getStickerAuxiliaryButton(n, o, i, l) {
    var T, m, A;
    const r = (T = this.configuration) == null ? void 0 : T.getStickersStyle(), u = {
      height: "24px",
      width: "24px",
      border: "none",
      borderRadius: "0",
      buttonIconTint: "grey",
      background: "transparent"
    }, s = new Al({
      width: "272px",
      height: "400px",
      background: l.palette.getBackground(),
      borderRadius: "12px",
      boxShadow: "0px 0px 0px 1px rgba(20, 20, 20, 0.04), 0px 16px 32px 0px rgba(20, 20, 20, 0.2)"
    }), c = {
      width: (r == null ? void 0 : r.width) || "300px",
      height: (r == null ? void 0 : r.height) || "400px",
      border: (r == null ? void 0 : r.border) || "none",
      emptyStateTextFont: (r == null ? void 0 : r.emptyStateTextFont) || w(l.typography.title1),
      emptyStateTextColor: (r == null ? void 0 : r.emptyStateTextColor) || l.palette.getAccent600(),
      errorStateTextFont: (r == null ? void 0 : r.errorStateTextFont) || w(l.typography.title1),
      errorStateTextColor: (r == null ? void 0 : r.errorStateTextColor) || l.palette.getAccent600(),
      loadingIconTint: (r == null ? void 0 : r.loadingIconTint) || l.palette.getAccent600(),
      background: (r == null ? void 0 : r.background) || l.palette.getBackground(),
      borderRadius: (r == null ? void 0 : r.borderRadius) || "12px"
    }, d = ((m = this.configuration) == null ? void 0 : m.getStickerIconURL()) || Wa, N = ((A = this.configuration) == null ? void 0 : A.getCloseIconURL()) || Fa;
    return {
      componentName: "CometChatStickersAuxiliaryButton",
      props: {
        placement: No.top,
        popoverStyle: s,
        openIconURL: d,
        closeIconURL: N,
        emojiButtonStyle: u,
        stickerKeyboardStyle: c,
        stickerKeyboardListeners: {
          "cc-sticker-clicked": (D) => this.sendSticker(D)
        }
      }
    };
  }
  sendSticker(n) {
    var o, i;
    try {
      const l = n == null ? void 0 : n.detail, r = {
        name: l == null ? void 0 : l.stickerName,
        URL: l == null ? void 0 : l.stickerURL
      }, u = ((o = this.user) == null ? void 0 : o.getUid()) || ((i = this.group) == null ? void 0 : i.getGuid()), s = this.user ? I.MessageReceiverType.user : I.MessageReceiverType.group, { parentMessageId: c } = this.id, d = {
        sticker_url: r.URL,
        sticker_name: r.name
      }, N = On.sticker, T = new y.CustomMessage(
        u,
        s,
        N,
        d
      );
      c && T.setParentMessageId(c), T.setMetadata({ incrementUnreadCount: !0 }), T.shouldUpdateConversation(!0), T.setSentAt(
        Ce.getUnixTimestamp()
      ), T.setMuid(Ce.ID()), ae.ccMessageSent.next({
        message: T,
        status: Xe.inprogress
      }), y.sendCustomMessage(T).then(
        (m) => {
          ae.ccMessageSent.next({
            message: m,
            status: Xe.success
          });
        },
        (m) => {
          T.setMetadata({ error: !0 }), ae.ccMessageSent.next({
            message: T,
            status: Xe.error
          });
        }
      );
    } catch (l) {
      console.log("error in sending sticker", l);
    }
  }
  getSticker(n) {
    let o;
    return Ce.checkHasOwnProperty(
      n,
      On.data
    ) && Ce.checkHasOwnProperty(
      n.getData(),
      On.custom_data
    ) ? (o = n.getCustomData(), Ce.checkHasOwnProperty(
      o,
      On.sticker_url
    ) ? o == null ? void 0 : o.sticker_url : "") : "";
  }
  getStickerMessageContentView(n, o) {
    const i = {
      height: "128px",
      width: "128px",
      border: "none",
      borderRadius: "0",
      background: "transparent"
    };
    return `<cometchat-image-bubble src='${this.getSticker(
      n
    )}' imageStyle='${JSON.stringify(
      i
    )}'></cometchat-image-bubble>`;
  }
  getStickerTemplate(n) {
    return new Mn({
      type: On.sticker,
      category: I.MessageCategory.custom,
      contentView: (o, i) => {
        const l = o;
        return l.getDeletedAt() ? super.getDeleteMessageBubble(l, n) : this.getStickerMessageContentView(l, n);
      },
      bottomView: (o, i) => super.getBottomView(o, i),
      options: (o, i, l, r) => super.getCommonOptions(
        o,
        i,
        l,
        r
      )
    });
  }
  checkIfTemplateExist(n, o) {
    return n.some((i) => i.type === o);
  }
  getAllMessageCategories() {
    const n = super.getAllMessageCategories();
    return n.some(
      (o) => o === I.MessageCategory.custom
    ) || n.push(I.MessageCategory.custom), n;
  }
  getAllMessageTypes() {
    const n = super.getAllMessageTypes();
    return n.some((o) => o === On.sticker) || n.push(On.sticker), n;
  }
  getId() {
    return "stickers";
  }
  getLastConversationMessage(n, o, i) {
    const l = n.getLastMessage();
    return l != null && l.getType() == On.sticker && l.getCategory() == I.MessageCategory.custom ? Y("CUSTOM_MESSAGE_STICKER") : super.getLastConversationMessage(
      n,
      o,
      i
    );
  }
}
class Bs extends Gn {
  constructor({ configuration: n } = {
    configuration: new Ia({})
  }) {
    super();
    le(this, "configuration", new Ia({}));
    this.configuration = n;
  }
  addExtension() {
    Ne.enable((n) => new Us(n, {
      configuration: this.configuration
    }));
  }
  getExtensionId() {
    return Vn.stickers;
  }
}
class Qs extends Nn {
  constructor(t) {
    super(t);
  }
  getId() {
    return "textmoderator";
  }
  getModeratedtext(t) {
    var o;
    const n = Ce.getExtensionData(t);
    return ((o = n == null ? void 0 : n.trim()) == null ? void 0 : o.length) > 0 ? n : t.getText();
  }
  getLastConversationMessage(t, n, o) {
    var l, r;
    const i = t.getLastMessage();
    if (i && !i.getDeletedAt() && i.getType() === I.MessageTypes.text && i.getCategory() === I.MessageCategory.message) {
      let u = this.getModeratedtext(i), s = t.getLastMessage(), c = {
        ...o,
        textFormatters: o != null && o.textFormatters && (o != null && o.textFormatters.length) ? [...o.textFormatters] : [this.getMentionsTextFormatter({ theme: o.theme, disableMentions: o.disableMentions })]
      }, d = c.textFormatters;
      if (c && !c.disableMentions) {
        let N;
        for (let T = 0; T < d.length && !(d[T] instanceof yo && (N = d[T], N.setMessage(s), s != null && s.getMentionedUsers().length && N.setCometChatUserGroupMembers(
          s == null ? void 0 : s.getMentionedUsers()
        ), N.setLoggedInUser(
          Ct.getLoggedInUser()
        ), N)); T++)
          ;
        N || (N = Ne.getDataSource().getMentionsTextFormatter({
          messageObj: s,
          ...c,
          alignment: null,
          theme: o.theme
        }), d.push(N));
      }
      if (s && s instanceof y.TextMessage)
        for (let N = 0; N < d.length; N++)
          u = d[N].getFormattedText(u, { mentionsTargetElement: Ai.conversation });
      return i && (t == null ? void 0 : t.getConversationType()) != y.RECEIVER_TYPE.USER && ((i == null ? void 0 : i.getSender().getUid()) == ((r = (l = Ct) == null ? void 0 : l.getLoggedInUser()) == null ? void 0 : r.getUid()) ? u = `${Y("YOU")}: ${u}` : u = `${i == null ? void 0 : i.getSender().getName()}:  ${u}`), u;
    } else
      return super.getLastConversationMessage(
        t,
        n,
        o
      );
  }
  getTextMessageContentView(t, n, o, i) {
    const l = this.getModeratedtext(t);
    return this.getModeratedtext(t) !== t.getText() && t.setText(l), super.getTextMessageContentView(
      t,
      n,
      o,
      i
    );
  }
}
class Rs extends Gn {
  addExtension() {
    Ne.enable(
      (t) => new Qs(t)
    );
  }
  getExtensionId() {
    return Vn.profanityFilter;
  }
}
class Ys extends Nn {
  constructor(t) {
    super(t);
  }
  getId() {
    return "thumbnailgeneration";
  }
  getImageMessageBubble(t, n, o, i, l, r) {
    if (Ne.names.includes("imagemoderation"))
      return super.getImageMessageBubble(
        t,
        n,
        o,
        i
      );
    try {
      let u = o.getAttachments()[0].getUrl();
      const s = o.getMetadata();
      return s && Object.prototype.hasOwnProperty.call(s, "@injected") && Object.prototype.hasOwnProperty.call(
        s["@injected"],
        "extensions"
      ) && Object.prototype.hasOwnProperty.call(
        s["@injected"].extensions,
        "thumbnail-generation"
      ) && s["@injected"].extensions["thumbnail-generation"].url_small && (u = o.getMetadata()["@injected"].extensions["thumbnail-generation"].url_small), super.getImageMessageBubble(
        u,
        vi,
        o,
        i
      );
    } catch {
    }
  }
  getVideoMessageBubble(t, n, o, i, l, r) {
    var c;
    const u = n.getMetadata();
    let s = i;
    return u && Object.prototype.hasOwnProperty.call(u, "@injected") && Object.prototype.hasOwnProperty.call(
      u["@injected"],
      "extensions"
    ) && Object.prototype.hasOwnProperty.call(
      u["@injected"].extensions,
      "thumbnail-generation"
    ) && u["@injected"].extensions["thumbnail-generation"].url_small && (s = n.getMetadata()["@injected"].extensions["thumbnail-generation"].url_small), super.getVideoMessageBubble(
      (c = n == null ? void 0 : n.getAttachments()[0]) == null ? void 0 : c.getUrl(),
      n,
      o,
      s
    );
  }
}
class Vs extends Gn {
  addExtension() {
    Ne.enable(
      (t) => new Ys(t)
    );
  }
  getExtensionId() {
    return Vn.thumbnailGeneration;
  }
}
class $z {
}
const pt = class pt {
  static init(t) {
    if (pt.uiKitSettings = t, !pt.checkAuthSettings())
      return;
    const n = new y.AppSettingsBuilder();
    t.getRoles() ? n.subscribePresenceForRoles(t.getRoles()) : t.getSubscriptionType() === "ALL_USERS" ? n.subscribePresenceForAllUsers() : t.getSubscriptionType() === "FRIENDS" && n.subscribePresenceForFriends(), n.autoEstablishSocketConnection(
      t.isAutoEstablishSocketConnection()
    ), n.setRegion(t.getRegion()), n.overrideAdminHost(t == null ? void 0 : t.getAdminHost()), n.overrideClientHost(t == null ? void 0 : t.getClientHost());
    const o = n.build();
    return y.setSource && y.setSource("uikit-v4", "web", "vuejs"), qi && (qi.uikitSettings = pt == null ? void 0 : pt.uiKitSettings), Ct.attachListener(), new Promise((i, l) => {
      window.CometChatUiKit = {
        name: "@cometchat/chat-uikit-vue",
        version: "4.3.20"
      }, y.init(t == null ? void 0 : t.appId, o).then(() => {
        y.getLoggedinUser().then((r) => (r && (Ct.setLoggedInUser(r), Ne.init(), this.initiateAfterLogin()), i(r))).catch((r) => (console.log(r), l(r)));
      }).catch((r) => l(r));
    });
  }
  static enableCalling() {
    var t, n;
    try {
      if (Ft) {
        const o = new Ft.CallAppSettingsBuilder().setAppId((t = pt.uiKitSettings) == null ? void 0 : t.appId).setRegion((n = pt.uiKitSettings) == null ? void 0 : n.region).build();
        Ft.init(o).then(
          () => {
            var i, l;
            console.log("CometChatCalls initialization success"), (i = this.uiKitSettings) != null && i.getCallingExtension() ? (l = this.uiKitSettings) == null || l.getCallingExtension().enable() : this.defaultCallingExtension.enable();
          },
          (i) => {
            console.log(
              "CometChatCalls initialization failed with error:",
              i
            );
          }
        );
      }
    } catch (o) {
      console.log(o);
    }
  }
  static initiateAfterLogin() {
    var t, n;
    if (pt.uiKitSettings != null) {
      const o = ((t = this.uiKitSettings) == null ? void 0 : t.extensions) || this.defaultExtensions;
      Il.attachListeners();
      const i = ((n = this.uiKitSettings) == null ? void 0 : n.aiFeatures) || this.defaultAIFeatures;
      o.length > 0 && o.forEach((l) => {
        l == null || l.enable();
      }), i.length > 0 && i.forEach((l) => {
        l.enable();
      }), this.enableCalling(), y.getConversationUpdateSettings().then((l) => {
        this.conversationUpdateSettings = l;
      });
    }
  }
  static login(t) {
    if (pt.checkAuthSettings())
      return new Promise((n, o) => {
        y.login(t, pt.uiKitSettings.authKey).then((i) => {
          Ct.setLoggedInUser(i), n(i), Ne.init(), this.initiateAfterLogin();
        }).catch((i) => {
          o(i);
        });
      });
  }
  static loginWithAuthToken(t) {
    if (pt.checkAuthSettings())
      return new Promise((n, o) => {
        y.login(t).then((i) => {
          Ct.setLoggedInUser(i), n(i), Ne.init(), this.initiateAfterLogin();
        }).catch((i) => {
          o(i);
        });
      });
  }
  static getLoggedinUser() {
    if (pt.checkAuthSettings())
      return new Promise((t, n) => {
        y.getLoggedinUser().then((o) => {
          Ct.setLoggedInUser(o), t(o);
        }).catch((o) => {
          n(o);
        });
      });
  }
  static createUser(t) {
    if (pt.checkAuthSettings())
      return new Promise((n, o) => {
        y.createUser(t, pt.uiKitSettings.authKey).then((i) => {
          n(i);
        }).catch((i) => {
          o(i);
        });
      });
  }
  static updateUser(t) {
    if (pt.checkAuthSettings())
      return new Promise((n, o) => {
        y.updateUser(t, pt.uiKitSettings.authKey).then((i) => {
          n(i);
        }).catch((i) => {
          o(i);
        });
      });
  }
  static logout() {
    if (pt.checkAuthSettings())
      return new Promise((t, n) => {
        y.logout().then((o) => {
          Ct.removeLoggedInUser(), t(o);
        }).catch((o) => {
          n(o);
        });
      });
  }
  static checkAuthSettings() {
    return !(pt.uiKitSettings == null || pt.uiKitSettings.appId == null);
  }
  /**
   * Sends a scheduler message and emits events based on the message status.
   * @param message - The scheduler message to be sent.
   * @param disableLocalEvents - A boolean indicating whether to disable local events or not. Default value is false.
   */
  static sendSchedulerMessage(t, n = !1) {
    t.setSentAt(Ce.getUnixTimestamp()), t != null && t.getMuid() || t.setMuid(Ce.ID()), n || ae.ccMessageSent.next({
      message: t,
      status: Xe.inprogress
    }), Ct.getLoggedInUser() && !t.getSender() && t.setSender(Ct.getLoggedInUser()), y.sendInteractiveMessage(t).then((o) => {
      const i = To.convertInteractiveMessage(o);
      n || ae.ccMessageSent.next({
        message: i,
        status: Xe.success
      });
    }).catch((o) => {
      t.setMetadata({ error: o }), n || ae.ccMessageSent.next({
        message: t,
        status: Xe.error
      });
    });
  }
  /**
   * Sends a form message and emits events based on the message status.
   * @param message - The form message to be sent.
   * @param disableLocalEvents - A boolean indicating whether to disable local events or not. Default value is false.
   */
  static sendFormMessage(t, n = !1) {
    t.setSentAt(Ce.getUnixTimestamp()), t != null && t.getMuid() || t.setMuid(Ce.ID()), n || ae.ccMessageSent.next({
      message: t,
      status: Xe.inprogress
    }), Ct.getLoggedInUser() && !t.getSender() && t.setSender(Ct.getLoggedInUser()), y.sendInteractiveMessage(t).then((o) => {
      const i = To.convertInteractiveMessage(o);
      n || ae.ccMessageSent.next({
        message: i,
        status: Xe.success
      });
    }).catch((o) => {
      t.setMetadata({ error: o }), n || ae.ccMessageSent.next({
        message: t,
        status: Xe.error
      });
    });
  }
  static sendCardMessage(t, n = !1) {
    t.setSentAt(Ce.getUnixTimestamp()), t != null && t.getMuid() || t.setMuid(Ce.ID()), n || ae.ccMessageSent.next({
      message: t,
      status: Xe.inprogress
    }), Ct.getLoggedInUser() && !t.getSender() && t.setSender(Ct.getLoggedInUser()), y.sendInteractiveMessage(t).then((o) => {
      const i = To.convertInteractiveMessage(o);
      n || ae.ccMessageSent.next({
        message: i,
        status: Xe.success
      });
    }).catch((o) => {
      t.setMetadata({ error: o }), n || ae.ccMessageSent.next({
        message: t,
        status: Xe.error
      });
    });
  }
  static sendCustomInteractiveMessage(t, n = !1) {
    t.setSentAt(Ce.getUnixTimestamp()), t != null && t.getMuid() || t.setMuid(Ce.ID()), n || ae.ccMessageSent.next({
      message: t,
      status: Xe.inprogress
    }), Ct.getLoggedInUser() && !t.getSender() && t.setSender(Ct.getLoggedInUser()), y.sendInteractiveMessage(t).then((o) => {
      const i = To.convertInteractiveMessage(o);
      n || ae.ccMessageSent.next({
        message: i,
        status: Xe.success
      });
    }).catch((o) => {
      t.setMetadata({ error: o }), n || ae.ccMessageSent.next({
        message: t,
        status: Xe.error
      });
    });
  }
  static sendCustomMessage(t) {
    t.setSentAt(Ce.getUnixTimestamp()), t != null && t.getMuid() || t.setMuid(Ce.ID()), ae.ccMessageSent.next({
      message: t,
      status: Xe.inprogress
    }), Ct.getLoggedInUser() && !t.getSender() && t.setSender(Ct.getLoggedInUser()), y.sendCustomMessage(t).then((n) => {
      ae.ccMessageSent.next({
        message: n,
        status: Xe.success
      });
    }).catch((n) => {
      t.setMetadata({ error: n }), ae.ccMessageSent.next({
        message: t,
        status: Xe.error
      });
    });
  }
  static sendTextMessage(t) {
    t.setSentAt(Ce.getUnixTimestamp()), t != null && t.getMuid() || t.setMuid(Ce.ID()), ae.ccMessageSent.next({
      message: t,
      status: Xe.inprogress
    }), Ct.getLoggedInUser() && !t.getSender() && t.setSender(Ct.getLoggedInUser()), y.sendMessage(t).then((n) => {
      ae.ccMessageSent.next({
        message: n,
        status: Xe.success
      });
    }).catch((n) => {
      t.setMetadata({ error: n }), ae.ccMessageSent.next({
        message: t,
        status: Xe.error
      });
    });
  }
  static sendMediaMessage(t) {
    t.setSentAt(Ce.getUnixTimestamp()), t != null && t.getMuid() || t.setMuid(Ce.ID()), ae.ccMessageSent.next({
      message: t,
      status: Xe.inprogress
    }), Ct.getLoggedInUser() && !t.getSender() && t.setSender(Ct.getLoggedInUser()), y.sendMediaMessage(t).then((n) => {
      ae.ccMessageSent.next({
        message: n,
        status: Xe.success
      });
    }).catch((n) => {
      t.setMetadata({ error: n }), ae.ccMessageSent.next({
        message: t,
        status: Xe.error
      });
    });
  }
  static getDataSource() {
    return Ne.getDataSource();
  }
  static getConversationSettings() {
    return this.conversationUpdateSettings;
  }
};
le(pt, "uiKitSettings"), le(pt, "SoundManager", Ot), le(pt, "Localize", dl), le(pt, "conversationUpdateSettings"), le(pt, "defaultExtensions", [
  new vs(),
  new Bs(),
  new fs(),
  new zs(),
  new As(),
  new Rs(),
  new Vs(),
  new Es(),
  new xs(),
  new ps()
]), /**
 * Default callingExtension included in the UI Kit.
 * @type {CallingExtensionDataSource}
 */
le(pt, "defaultCallingExtension", new ws()), le(pt, "defaultAIFeatures", [
  new Cs(),
  new Ns(),
  new Ds(),
  new ds()
]);
let An = pt;
var Ca;
const Gs = We({
  name: "CometChatOngoingCall",
  components: {},
  props: {
    callSettingsBuilder: { type: (Ca = Ft) == null ? void 0 : Ca.CallSettings },
    sessionID: { type: String, default: "" },
    ongoingCallStyle: {
      type: Object,
      default: () => new $o({
        maxHeight: "100%",
        maxWidth: "100%",
        border: "none",
        borderRadius: "0",
        background: "grey",
        minHeight: "400px",
        minWidth: "400px",
        minimizeIconTint: "white",
        maximizeIconTint: "white"
      })
    },
    resizeIconHoverText: { type: String, default: () => Y("RESIZE") },
    minimizeIconURL: { type: String, default: ns },
    maximizeIconURL: { type: String, default: $l },
    callWorkflow: {
      type: Number,
      default: () => Ro.directCalling
    },
    onError: {
      type: Function,
      default: (e) => {
        console.log(e);
      }
    }
  },
  setup(e) {
    const t = j();
    Zt(() => {
      An.getLoggedinUser().then((i) => {
        t.value = i;
      });
    }), bn(
      [() => e.sessionID, () => t.value],
      () => {
        e.sessionID && t.value && o();
      },
      { immediate: !0 }
    );
    const n = () => e.callSettingsBuilder ? e.callSettingsBuilder : new Ft.CallSettingsBuilder().enableDefaultLayout(!0).setIsAudioOnlyCall(!1).setCallListener(
      new Ft.OngoingCallListener({
        onCallEnded: () => {
          e.callWorkflow == Ro.defaultCalling && (Jt.ccCallEnded.next({}), Ft.endSession(), an.setItem(I.calls.activecall, null));
        },
        onCallEndButtonPressed: () => {
          e.callWorkflow == Ro.defaultCalling ? y.endCall(e.sessionID).then((l) => {
            Ft.endSession(), Jt.ccCallEnded.next(l), an.setItem(I.calls.activecall, null);
          }).catch((l) => {
            console.log(l);
          }) : (Jt.ccCallEnded.next({}), Ft.endSession(), an.setItem(I.calls.activecall, null));
        },
        onError: (l) => {
          e.onError(l);
        }
      })
    ).build();
    function o() {
      var l;
      const i = document.getElementById("callScreenRef");
      if (t.value) {
        const r = (l = t.value) == null ? void 0 : l.getAuthToken(), u = e.sessionID;
        Ft.generateToken(u, r).then(
          (s) => {
            var c;
            (c = Ft.startSession(
              s == null ? void 0 : s.token,
              n(),
              i
            )) == null || c.then(() => {
              const d = {
                sessionId: u
              };
              d && an.setItem(I.calls.activecall, d);
            });
          },
          (s) => {
            e.onError(s);
          }
        );
      }
    }
    return {};
  }
});
const $e = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
}, Ps = ["callscreenStyle", "resizeIconHoverText", "minimizeIconURL", "maximizeIconURL"];
function Fs(e, t, n, o, i, l) {
  return e.sessionID ? (M(), g("cometchat-callscreen-wrapper", {
    key: 0,
    callscreenStyle: e.ongoingCallStyle,
    resizeIconHoverText: e.resizeIconHoverText,
    minimizeIconURL: e.minimizeIconURL,
    maximizeIconURL: e.maximizeIconURL
  }, t[0] || (t[0] = [
    p("div", {
      id: "callScreenRef",
      class: "cc-callscreen__view"
    }, null, -1)
  ]), 8, Ps)) : $("", !0);
}
const _o = /* @__PURE__ */ $e(Gs, [["render", Fs], ["__scopeId", "data-v-f1d9d50c"]]), Hs = We({
  name: "CometChatOutgoingCall",
  components: {},
  props: {
    call: { type: Object },
    disableSoundForCalls: { type: Boolean, default: !1 },
    customSoundForCalls: { type: String },
    declineButtonText: { type: String, default: () => Y("CANCEL") },
    declineButtonIconURL: { type: String, default: Cn },
    customView: { type: Object },
    onError: {
      type: Function,
      default: (e) => {
        console.log("error: ", e);
      }
    },
    avatarStyle: {
      type: Object,
      default: () => ({
        borderRadius: "50%",
        width: "180px",
        height: "180px"
      })
    },
    outgoingCallStyle: {
      type: Object,
      default: () => new Ii({})
    },
    onCloseClicked: { type: Function }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    }), n = Y("CALLING"), o = {
      height: "100%",
      width: "100%",
      border: "inherite",
      borderRadius: "inherite",
      background: "transparent",
      titleFont: "700 22px Inter",
      titleColor: "black"
    }, i = ha.top, l = {
      height: "fit-content",
      width: "fit-content",
      buttonTextFont: "400 12px Inter",
      buttonTextColor: "RGBA(20, 20, 20, 0.58)",
      borderRadius: "8px",
      border: "none",
      buttonIconTint: "white",
      background: "",
      iconBackground: "red"
    }, r = {}, u = {};
    Zt(() => {
      d();
    }), tn(() => {
      e.call && N();
    }), Ko(() => {
      e.call && N();
    }), un(() => {
      Ot.pause();
    });
    const s = (Q) => {
      e.onCloseClicked && e.onCloseClicked(Q);
    }, c = () => {
      var Q, h, O, x, _;
      return ((Q = e.call) == null ? void 0 : Q.getReceiverType()) == I.MessageReceiverType.user ? (O = (h = e.call) == null ? void 0 : h.getReceiver()) == null ? void 0 : O.getAvatar() : (_ = (x = e.call) == null ? void 0 : x.getReceiver()) == null ? void 0 : _.getIcon();
    }, d = () => {
      m(), T(), o.titleColor = r.titleTextColor, o.titleFont = r.titleTextFont;
    }, N = () => {
      try {
        e.disableSoundForCalls || (e.customSoundForCalls ? Ot.play(
          Ot.Sound.incomingCall,
          e.customSoundForCalls
        ) : Ot.play(
          Ot.Sound.incomingCall
        ));
      } catch (Q) {
        if (e.onError) {
          let h = new y.CometChatException({
            message: Q.message
          });
          e.onError(h);
        }
      }
    }, T = () => {
      r = { ...new Ii({
        width: "100%",
        height: "100%",
        background: t.value.palette.getBackground(),
        border: "none",
        borderRadius: "0",
        titleTextFont: w(t.value.typography.title1),
        titleTextColor: t.value.palette.getAccent(),
        subtitleTextFont: w(t.value.typography.subtitle1),
        subtitleTextColor: t.value.palette.getAccent600(),
        declineButtonTextFont: w(t.value.typography.caption1),
        declineButtonTextColor: t.value.palette.getAccent600(),
        declineButtonIconTint: t.value.palette.getAccent("dark"),
        declineButtonIconBackground: t.value.palette.getError()
      }), ...e.outgoingCallStyle }, l = {
        height: "fit-content",
        width: "fit-content",
        buttonTextFont: r.declineButtonTextFont,
        buttonTextColor: r.declineButtonTextColor,
        borderRadius: "8px",
        border: "none",
        buttonIconTint: r.declineButtonIconTint,
        background: "",
        iconBackground: r.declineButtonIconBackground
      };
    }, m = () => {
      u = { ...new Kt({
        borderRadius: "50%",
        width: "150px",
        height: "150px",
        border: "none",
        backgroundColor: t.value.palette.getAccent700(),
        nameTextColor: t.value.palette.getAccent900(),
        backgroundSize: "cover",
        nameTextFont: w(t.value.typography.subtitle1),
        outerViewBorderWidth: "",
        outerViewBorderSpacing: ""
      }), ...e.avatarStyle };
    };
    return {
      wrapperStyle: () => ({
        height: r.height,
        width: r.width,
        background: r.background,
        border: r.border,
        borderRadius: r.borderRadius
      }),
      getCardStyle: () => o,
      getAvatarURL: c,
      getSubtitleStyle: () => ({
        textFont: r.subtitleTextFont,
        textColor: r.subtitleTextColor
      }),
      subtitleText: n,
      iconAlignment: i,
      getButtonStyle: () => l,
      getAvatarStyle: () => u,
      onClose: s
    };
  }
});
const Zs = {
  key: 0,
  class: "cc-outgoingcall__custom-view"
}, Ws = ["innerHTML"], $s = ["v-slot", "v-html"], Js = ["title", "cardStyle", "avatarName", "avatarURL", "avatarStyle"], Ks = ["labelStyle", "text"], Xs = { slot: "bottomView" }, qs = ["text", "iconURL", "alignment", "buttonStyle"];
function _s(e, t, n, o, i, l) {
  var r, u, s, c, d;
  return M(), g("div", {
    class: "cc-outgoingcall__wrapper",
    style: ce(e.wrapperStyle())
  }, [
    e.customView ? (M(), g("div", Zs, [
      e.customView.html ? (M(), g("div", {
        key: 0,
        innerHTML: e.customView.html
      }, null, 8, Ws)) : (M(), je(fe(e.customView.componentName), me({ key: 1 }, { ...e.customView.props }, xe((r = e.customView) == null ? void 0 : r.listeners)), {
        default: be(() => [
          (M(!0), g(we, null, pe(e.customView.slots, (N, T) => (M(), g("div", {
            key: T,
            "v-slot": [T],
            "v-html": N
          }, null, 8, $s))), 128))
        ]),
        _: 1
      }, 16))
    ])) : (M(), g("cometchat-card", {
      key: 1,
      title: (s = (u = e.call) == null ? void 0 : u.getReceiver()) == null ? void 0 : s.getName(),
      cardStyle: e.getCardStyle(),
      avatarName: (d = (c = e.call) == null ? void 0 : c.getReceiver()) == null ? void 0 : d.getName(),
      avatarURL: e.getAvatarURL(),
      avatarStyle: e.getAvatarStyle()
    }, [
      p("cometchat-label", {
        slot: "subtitleView",
        labelStyle: e.getSubtitleStyle(),
        text: e.subtitleText
      }, null, 8, Ks),
      p("div", Xs, [
        p("cometchat-icon-button", {
          onCcButtonClicked: t[0] || (t[0] = (N) => e.onClose(e.call)),
          text: e.declineButtonText,
          iconURL: e.declineButtonIconURL,
          alignment: e.iconAlignment,
          buttonStyle: e.getButtonStyle()
        }, null, 40, qs)
      ])
    ], 8, Js))
  ], 4);
}
const er = /* @__PURE__ */ $e(Hs, [["render", _s], ["__scopeId", "data-v-f7ff9c81"]]), eM = We({
  name: "CometChatCallButtons",
  components: { CometChatOnGoingCall: _o, CometChatOutgoingCall: er },
  props: {
    user: { type: Object },
    group: { type: Object },
    voiceCallIconURL: { type: String, default: Ul },
    voiceCallIconText: {
      type: String,
      default: () => Y("VOICE_CALL")
    },
    voiceCallIconHoverText: {
      type: String,
      default: () => Y("VOICE_CALL")
    },
    videoCallIconURL: { type: String, default: Ja },
    videoCallIconText: { type: String, default: () => Y("VIDEO_CALL") },
    videoCallIconHoverText: {
      type: String,
      default: () => Y("VIDEO_CALL")
    },
    callButtonsStyle: {
      type: Object,
      default: () => new _i({
        width: "100%",
        height: "100%",
        border: "none",
        borderRadius: "0",
        background: "transparent"
      })
    },
    onVoiceCallClick: {
      type: Function,
      default: () => {
      }
    },
    onVideoCallClick: {
      type: Function,
      default: () => {
      }
    },
    onError: {
      type: Function,
      default: (e) => {
        console.log(e);
      }
    },
    ongoingCallConfiguration: {
      type: Object,
      default: () => ({})
    },
    outgoingCallConfiguration: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    let t = j(), { theme: n } = dt("theme", {
      theme: j(new Ke({}))
    }), o = j(), i, l, r, u = j(!1), s = {}, c = j(!1), d = j(""), N = "callbuttons_" + (/* @__PURE__ */ new Date()).getTime(), T = {
      buttonIconTint: "RGB(51, 153, 255)",
      buttonTextFont: "400 12px Inter",
      buttonTextColor: "RGB(51, 153, 255)",
      padding: "8px 32px"
    }, m = {
      buttonIconTint: "RGB(51, 153, 255)",
      buttonTextFont: "400 12px Inter",
      buttonTextColor: "RGB(51, 153, 255)",
      padding: "8px 32px"
    }, A = j(!1), D = {
      width: "360px",
      height: "581px",
      titleTextFont: "700 22px Inter",
      titleTextColor: "RGB(20, 20, 20)",
      subtitleTextFont: "400 15px Inter",
      subtitleTextColor: "RGBA(20, 20, 20, 0.58)",
      borderRadius: "8px"
    }, z = {
      height: "100%",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }, k = {}, R = j(null);
    Zt(() => {
      y.getLoggedinUser().then(
        (Te) => {
          Te && (t.value = Te);
        },
        (Te) => {
          e.onError(Te);
        }
      ), O(), F(), Q();
    }), un(() => {
      h(), G();
    });
    const Q = () => {
      l = Jt.ccCallRejected.subscribe(
        (Te) => {
          u.value = !1;
        }
      ), i = Jt.ccOutgoingCall.subscribe(
        (Te) => {
          u.value = !0;
        }
      ), r = Jt.ccCallEnded.subscribe(
        (Te) => {
          ie();
        }
      );
    }, h = () => {
      l == null || l.unsubscribe(), i == null || i.unsubscribe(), r == null || r.unsubscribe();
    }, O = () => {
      _(), x();
    }, x = () => {
      s = { ...new $o({
        maxHeight: "100%",
        maxWidth: "100%",
        border: "none",
        borderRadius: "0",
        background: "#1c2226",
        minHeight: "400px",
        minWidth: "400px",
        minimizeIconTint: n.value.palette.getAccent900(),
        maximizeIconTint: n.value.palette.getAccent900()
      }), ...s };
    }, _ = () => {
      k = { ...new _i({
        width: "100%",
        height: "100%",
        background: "transparent",
        border: "none",
        borderRadius: "0",
        voiceCallIconTint: n.value.palette.getPrimary(),
        videoCallIconTint: n.value.palette.getPrimary(),
        voiceCallIconTextFont: w(n.value.typography.caption1),
        videoCallIconTextFont: w(n.value.typography.caption1),
        voiceCallIconTextColor: n.value.palette.getPrimary(),
        videoCallIconTextColor: n.value.palette.getPrimary(),
        buttonPadding: "8px 32px",
        buttonBackground: n.value.palette.getAccent100(),
        buttonBorder: "0",
        buttonBorderRadius: "8px"
      }), ...e.callButtonsStyle }, T = {
        buttonIconTint: k.voiceCallIconTint,
        buttonTextFont: k.voiceCallIconTextFont,
        buttonTextColor: k.voiceCallIconTextColor,
        padding: k.buttonPadding,
        background: k.buttonBackground,
        border: k.border,
        borderRadius: k.buttonBorderRadius,
        ...z
      }, m = {
        buttonIconTint: k.videoCallIconTint,
        buttonTextFont: k.videoCallIconTextFont,
        buttonTextColor: k.videoCallIconTextColor,
        padding: k.buttonPadding,
        background: k.buttonBackground,
        border: k.border,
        borderRadius: k.buttonBorderRadius,
        ...z
      };
    }, oe = () => {
      var Ee, L;
      let Te = ((Ee = o.value) == null ? void 0 : Ee.getType()) == I.MessageTypes.audio;
      const H = (L = e.ongoingCallConfiguration) != null && L.callSettingsBuilder ? e.ongoingCallConfiguration.callSettingsBuilder(Te, e.user, e.group) : new Ft.CallSettingsBuilder().enableDefaultLayout(!0).setIsAudioOnlyCall(Te);
      return H.setCallListener(
        new Ft.OngoingCallListener({
          onCallEnded: () => {
            var b;
            ((b = o.value) == null ? void 0 : b.getReceiverType()) === I.MessageReceiverType.user && (Ft.endSession(), Jt.ccCallEnded.next(null), ie(), an.setItem(I.calls.activecall, null));
          },
          onCallEndButtonPressed: () => {
            var b;
            ((b = o.value) == null ? void 0 : b.getReceiverType()) === I.MessageReceiverType.user ? y.endCall(d.value).then((v) => {
              Ft.endSession(), Jt.ccCallEnded.next(v), ie(), an.setItem(I.calls.activecall, null);
            }).catch((v) => {
              v && e.onError(v);
            }) : ie();
          },
          onError: (b) => {
            console.log("Error :", b);
          }
        })
      ), H.build();
    }, ie = () => {
      A.value = !1, c.value = !1, u.value = !1, o.value = null, d.value = "";
    }, re = (Te) => {
      A.value = !1, R.value = Te, d.value = Te.getSessionId(), c.value = !0;
    }, Ae = (Te) => {
      var b, v;
      const H = e.user ? I.MessageReceiverType.user : I.MessageReceiverType.group, Ee = e.user ? (b = e.user) == null ? void 0 : b.getUid() : (v = e.group) == null ? void 0 : v.getGuid(), L = new y.Call(
        Ee,
        Te,
        H
      );
      y.initiateCall(L).then((U) => {
        o.value = U, A.value = !0, ae.ccMessageSent.next({
          message: U,
          status: Xe.success
        }), Jt.ccOutgoingCall.next(U);
      }).catch((U) => {
        e.onError && e.onError(U);
      });
    }, se = () => {
      e.user && Ae(I.MessageTypes.audio);
    }, X = () => {
      e.user ? Ae(I.MessageTypes.video) : (d.value = e.group.getGuid(), B(), c.value = !0);
    }, B = () => {
      var U;
      const Te = e.user ? I.MessageReceiverType.user : I.MessageReceiverType.group, H = e.user ? (U = e.user) == null ? void 0 : U.getUid() : e.group.getGuid(), Ee = {
        sessionID: d.value,
        sessionId: d.value,
        callType: I.MessageTypes.video
      }, L = I.calls.meeting, b = `group_${d.value}`, v = new y.CustomMessage(
        H,
        Te,
        L,
        Ee
      );
      v.setMetadata({ incrementUnreadCount: !0 }), v.shouldUpdateConversation(!0), v.setSender(t.value), v.setReceiver(Te), v.setConversationId(b), v.setSentAt(Ce.getUnixTimestamp()), v.setMuid(Ce.ID()), ae.ccMessageSent.next({
        message: v,
        status: Xe.inprogress
      }), y.sendCustomMessage(v).then((Se) => {
        ae.ccMessageSent.next({
          message: Se,
          status: Xe.success
        });
      });
    }, F = () => {
      y.addCallListener(
        N,
        new y.CallListener({
          onIncomingCallReceived: (Te) => {
            const H = an.getItem(
              I.calls.activecall
            );
            H != null && H.sessionId || (o.value = Te, u.value = !0);
          },
          onIncomingCallCancelled: (Te) => {
            u.value = !1, o.value = void 0;
          },
          onOutgoingCallRejected: (Te) => {
            u.value = !1, o.value = void 0, A.value = !1;
          },
          onOutgoingCallAccepted: (Te) => {
            u.value = !0, o.value = Te, re(Te);
          },
          onCallEndedMessageReceived: (Te) => {
            u.value = !1, o.value = void 0;
          }
        })
      );
    }, G = () => {
      y.removeCallListener(N);
    };
    return {
      getVoiceCallButtonStyle: () => T,
      getVideoCallButtonStyle: () => m,
      initiateAudioCall: se,
      initiateVideoCall: X,
      getOngoingCallStyle: () => {
        var Te;
        return {
          ...s,
          ...(Te = e.ongoingCallConfiguration) == null ? void 0 : Te.ongoingCallStyle
        };
      },
      wrapperStyle: () => ({
        height: k.height,
        width: k.width,
        background: k.background,
        border: k.border,
        borderRadius: k.borderRadius
      }),
      call: o,
      showOutgoingCallscreen: A,
      showOngoingCall: c,
      cancelOutgoingCall: () => {
        y.rejectCall(
          o.value.getSessionId(),
          I.calls.cancelled
        ).then((Te) => {
          A.value = !1, u.value = !1, ae.ccMessageSent.next({
            message: o.value,
            status: Xe.success
          }), o.value = void 0;
        }).catch((Te) => {
          e.onError && e.onError(Te);
        }), A.value = !1;
      },
      getOutGoingCallStyle: () => {
        var Te;
        return {
          ...D,
          ...(Te = e.outgoingCallConfiguration) == null ? void 0 : Te.outgoingCallStyle
        };
      },
      getCallBuilder: oe,
      sessionId: d,
      disableButtons: u
    };
  }
});
const tM = { class: "cc-callbuttons-buttons" }, nM = ["disabled", "buttonStyle", "text", "hoverText", "iconURL"], oM = ["disabled", "buttonStyle", "text", "hoverText", "iconURL"], iM = { key: 1 };
function aM(e, t, n, o, i, l) {
  var s, c, d, N, T;
  const r = Je("CometChatOnGoingCall"), u = Je("CometChatOutgoingCall");
  return M(), g(we, null, [
    p("div", {
      class: "cc-callbuttons__wrapper",
      style: ce(e.wrapperStyle())
    }, [
      p("div", tM, [
        e.user ? (M(), g("cometchat-button", {
          key: 0,
          onCcButtonClicked: t[0] || (t[0] = (m) => e.initiateAudioCall()),
          disabled: e.disableButtons,
          buttonStyle: e.getVoiceCallButtonStyle(),
          text: e.voiceCallIconText,
          hoverText: e.voiceCallIconHoverText,
          iconURL: e.voiceCallIconURL
        }, null, 40, nM)) : $("", !0),
        e.user || e.group ? (M(), g("cometchat-button", {
          key: 1,
          disabled: e.disableButtons,
          onCcButtonClicked: t[1] || (t[1] = (m) => e.initiateVideoCall()),
          buttonStyle: e.getVideoCallButtonStyle(),
          text: e.videoCallIconText,
          hoverText: e.videoCallIconHoverText,
          iconURL: e.videoCallIconURL
        }, null, 40, oM)) : $("", !0)
      ])
    ], 4),
    e.showOngoingCall ? (M(), je(r, {
      key: 0,
      ongoingCallStyle: e.getOngoingCallStyle(),
      sessionID: e.sessionId,
      callSettingsBuilder: e.getCallBuilder(),
      maximizeIconURL: e.$props.ongoingCallConfiguration.maximizeIconURL,
      minimizeIconURL: e.$props.ongoingCallConfiguration.minimizeIconURL
    }, null, 8, ["ongoingCallStyle", "sessionID", "callSettingsBuilder", "maximizeIconURL", "minimizeIconURL"])) : $("", !0),
    e.showOutgoingCallscreen ? (M(), g("cometchat-backdrop", iM, [
      Nt(u, {
        onCloseClicked: ((s = e.$props.outgoingCallConfiguration) == null ? void 0 : s.onCloseClicked) ?? e.cancelOutgoingCall,
        customSoundForCalls: (c = e.$props.outgoingCallConfiguration) == null ? void 0 : c.customSoundForCalls,
        customView: (d = e.$props.outgoingCallConfiguration) == null ? void 0 : d.customView,
        disableSoundForCalls: (N = e.$props.outgoingCallConfiguration) == null ? void 0 : N.disableSoundForCalls,
        onError: (T = e.$props.outgoingCallConfiguration) == null ? void 0 : T.onError,
        outgoingCallStyle: e.getOutGoingCallStyle(),
        call: e.call
      }, null, 8, ["onCloseClicked", "customSoundForCalls", "customView", "disableSoundForCalls", "onError", "outgoingCallStyle", "call"])
    ])) : $("", !0)
  ], 64);
}
const tr = /* @__PURE__ */ $e(eM, [["render", aM], ["__scopeId", "data-v-71bb2970"]]), rM = We({
  name: "CometChatIncomingCall",
  components: { CometChatOngoingCall: _o },
  props: {
    call: { type: Object },
    disableSoundForCalls: { type: Boolean, default: !1 },
    customSoundForCalls: { type: String },
    onAccept: {
      type: Function
    },
    onDecline: {
      type: Function
    },
    acceptButtonText: { type: String, default: () => Y("ACCEPT") },
    declineButtonText: { type: String, default: () => Y("DECLINE") },
    subtitleView: {
      type: Object,
      default: void 0
    },
    onError: {
      type: Function,
      default: (e) => {
        console.log(e);
      }
    },
    listItemStyle: {
      type: Object,
      default: () => ({
        height: "100%",
        width: "100%",
        background: "",
        activeBackground: "",
        border: ""
      })
    },
    avatarStyle: {
      type: Object,
      default: () => ({
        borderRadius: "16px",
        width: "38px",
        height: "38px"
      })
    },
    incomingCallStyle: {
      type: Object,
      default: () => ({
        width: "fit-content",
        height: "fit-content"
      })
    },
    ongoingCallConfiguration: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    }), n = "incomingcall_" + (/* @__PURE__ */ new Date()).getTime(), o = Y("INCOMING_CALL"), i = {
      height: "100%",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "8px 28px"
    }, l = {}, r = {}, u = {}, s = j(!1), c = j(""), d = {}, N = {}, T = null, m = {
      height: "16px",
      width: "16px",
      iconTint: "RGBA(20, 20, 20, 0.68)"
    }, A = {}, D = j(!1), z = j(e.call);
    const k = () => {
      an.attachChangeDetection(re), y.addCallListener(
        n,
        new y.CallListener({
          onIncomingCallReceived: (L) => {
            if (Ae(L) || z.value) {
              y.rejectCall(L == null ? void 0 : L.getSessionId(), I.calls.busy).then(
                (b) => {
                  Jt.ccCallRejected.next(b);
                },
                (b) => {
                  if (e.onError) {
                    let v = new y.CometChatException({
                      message: b.message
                    });
                    e.onError(v);
                  }
                }
              );
              return;
            }
            se(L);
          },
          onIncomingCallCancelled: (L) => {
            Ot.pause(), z.value = null, D.value = !1;
          }
        })
      );
    }, R = () => {
      an.attachChangeDetection(re), y.removeCallListener(n);
    };
    Zt(() => {
      an.setItem(I.calls.activecall, null), k(), h(), Jt.ccCallEnded.subscribe(
        (L) => {
          Q();
        }
      ), z.value = e.call;
    });
    const Q = () => {
      s.value = !1, z.value = null, c.value = "";
    }, h = () => {
      x(), O(), oe(), m.iconTint = A == null ? void 0 : A.subtitleTextColor;
    }, O = () => {
      l = { ...new Kt({
        borderRadius: "16px",
        width: "38px",
        height: "38px",
        border: "none",
        backgroundColor: t.value.palette.getAccent700(),
        nameTextColor: t.value.palette.getAccent900(),
        backgroundSize: "cover",
        nameTextFont: w(t.value.typography.subtitle1),
        outerViewBorderWidth: "",
        outerViewBorderSpacing: ""
      }), ...e.avatarStyle };
    }, x = () => {
      A = { ...new Ur({
        width: "fit-content",
        height: "fit-content",
        background: t.value.palette.getAccent800("light"),
        border: "none",
        borderRadius: "8px",
        titleTextFont: w(t.value.typography.title2),
        titleTextColor: t.value.palette.getAccent("dark"),
        subtitleTextFont: w(t.value.typography.subtitle2),
        subtitleTextColor: t.value.palette.getAccent800("dark"),
        acceptButtonTextFont: w(t.value.typography.text2),
        acceptButtonTextColor: t.value.palette.getAccent("dark"),
        acceptButtonBackground: t.value.palette.getPrimary(),
        acceptButtonBorderRadius: "8px",
        acceptButtonBorder: "none",
        declineButtonTextFont: w(t.value.typography.text2),
        declineButtonTextColor: t.value.palette.getAccent("dark"),
        declineButtonBackground: t.value.palette.getError(),
        declineButtonBorderRadius: "8px",
        declineButtonBorder: "none"
      }), ...e.incomingCallStyle }, _(), d = {
        border: A == null ? void 0 : A.acceptButtonBorder,
        borderRadius: A == null ? void 0 : A.acceptButtonBorderRadius,
        background: A == null ? void 0 : A.acceptButtonBackground,
        buttonTextFont: A == null ? void 0 : A.acceptButtonTextFont,
        buttonTextColor: A == null ? void 0 : A.acceptButtonTextColor,
        ...i
      }, N = {
        border: A == null ? void 0 : A.declineButtonBorder,
        borderRadius: A == null ? void 0 : A.declineButtonBorderRadius,
        background: A == null ? void 0 : A.declineButtonBackground,
        buttonTextFont: A == null ? void 0 : A.declineButtonTextFont,
        buttonTextColor: A == null ? void 0 : A.declineButtonTextColor,
        ...i
      };
    }, _ = () => {
      r = { ...new _t({
        height: "100%",
        width: "100%",
        background: t.value.palette.getBackground(),
        activeBackground: "transparent",
        borderRadius: "0",
        titleFont: A == null ? void 0 : A.titleTextFont,
        titleColor: A == null ? void 0 : A.titleTextColor,
        border: "none",
        separatorColor: t.value.palette.getAccent200(),
        hoverBackground: "transparent"
      }), ...e.listItemStyle };
    };
    un(() => {
      R();
    });
    const oe = () => {
      u = { ...new $o({
        maxHeight: "100%",
        maxWidth: "100%",
        border: "none",
        borderRadius: "0",
        background: "#1c2226",
        minHeight: "400px",
        minWidth: "400px",
        minimizeIconTint: t.value.palette.getAccent900(),
        maximizeIconTint: t.value.palette.getAccent900()
      }), ...u };
    }, ie = () => {
      var L;
      return ((L = z == null ? void 0 : z.value) == null ? void 0 : L.getType()) == I.MessageTypes.audio ? Ba : Ka;
    }, re = (L) => {
      var b;
      if ((L == null ? void 0 : L.key) === I.calls.activecall && (L.newValue || L.oldValue)) {
        let v;
        L.newValue ? v = JSON.parse(L.newValue) : L.oldValue && (v = JSON.parse(L.oldValue)), ((b = z.value) == null ? void 0 : b.getSessionId()) === (v == null ? void 0 : v.sessionId) && (Ot.pause(), z.value = null, D.value = !0), L.newValue === null && (z.value = null);
      }
    }, Ae = (L) => {
      let b = !1;
      try {
        if (an.getItem(I.calls.activecall)) {
          let v = an.getItem(
            I.calls.activecall
          );
          v && v.sessionId == L.getSessionId() ? b = !0 : b = !1;
        } else
          b = !1;
        return b;
      } catch (v) {
        if (e.onError) {
          let U = new y.CometChatException({
            message: v.message
          });
          e.onError(U);
        }
        return b;
      }
    }, se = (L) => {
      var b;
      try {
        !Ae(L) && (T == null ? void 0 : T.getUid()) !== ((b = L == null ? void 0 : L.getSender()) == null ? void 0 : b.getUid()) ? (!e.disableSoundForCalls && !y.getActiveCall() && !s.value && X(), z.value = L, y.getActiveCall() ? y.getActiveCall() && (Ot.pause(), G(I.calls.busy), Jt.ccCallRejected.next(L)) : D.value = !0) : (Ot.pause(), G(I.calls.busy));
      } catch (v) {
        if (e.onError) {
          let U = new y.CometChatException({
            message: v.message
          });
          e.onError(U);
        }
      }
    }, X = () => {
      try {
        e.customSoundForCalls ? Ot.play(
          Ot.Sound.incomingCall,
          e.customSoundForCalls
        ) : Ot.play(Ot.Sound.incomingCall);
      } catch (L) {
        if (e.onError) {
          let b = new y.CometChatException({
            message: L.message
          });
          e.onError(b);
        }
      }
    }, B = () => {
      try {
        Ot.pause(), e.onAccept ? e.onAccept() : F().then(
          (L) => {
            y.acceptCall(z.value.getSessionId()).then(
              (b) => {
                Jt.ccCallAccepted.next(b), an.setItem(
                  I.calls.activecall,
                  b
                ), s.value = !0, z.value = b, c.value = b == null ? void 0 : b.getSessionId(), D.value = !1;
              },
              (b) => {
                if (e.onError) {
                  let v = new y.CometChatException({
                    message: b.message
                  });
                  e.onError(v);
                }
              }
            );
          },
          (L) => {
            if (e.onError) {
              let b = new y.CometChatException({
                message: L.message
              });
              e.onError(b);
            }
          }
        );
      } catch (L) {
        if (e.onError) {
          let b = new y.CometChatException({
            message: L.message
          });
          e.onError(b);
        }
      }
    }, F = () => {
      let L = y.getActiveCall();
      return new Promise((v, U) => {
        if (!L)
          return v({ success: !0 });
        let Se = L == null ? void 0 : L.getSessionId();
        y.endCall(Se).then((Ue) => (an.setItem(I.calls.activecall, null), v(Ue))).catch((Ue) => U(Ue));
      });
    }, G = (L = I.calls.rejected) => {
      var b, v;
      try {
        Ot.pause(), e.onDecline ? e.onDecline() : typeof ((b = z == null ? void 0 : z.value) == null ? void 0 : b.getSessionId()) == "string" && y.rejectCall((v = z.value) == null ? void 0 : v.getSessionId(), L).then(
          (U) => {
            Jt.ccCallRejected.next(U), D.value = !1, Ae(z.value) || (z.value = null);
          },
          (U) => {
            if (e.onError) {
              let Se = new y.CometChatException({
                message: U.message
              });
              e.onError(Se);
            }
          }
        );
      } catch (U) {
        if (e.onError) {
          let Se = new y.CometChatException({
            message: U.message
          });
          e.onError(Se);
        }
      }
    };
    function J() {
      var v, U, Se, Ue;
      let L = ((v = z.value) == null ? void 0 : v.getType()) == I.MessageTypes.audio;
      const b = (U = e.ongoingCallConfiguration) != null && U.callSettingsBuilder ? (Se = e.ongoingCallConfiguration) == null ? void 0 : Se.callSettingsBuilder(z.value) : new Ft.CallSettingsBuilder().enableDefaultLayout(!0).setIsAudioOnlyCall(L);
      if (((Ue = z.value) == null ? void 0 : Ue.getType()) != I.calls.meeting)
        return b.setCallListener(
          new Ft.OngoingCallListener({
            onCallEnded: () => {
              Ft.endSession(), Q(), an.setItem(I.calls.activecall, null);
            },
            onCallEndButtonPressed: () => {
              y.endCall(c.value).then((Re) => {
                Ft.endSession(), Jt.ccCallEnded.next(Re), an.setItem(I.calls.activecall, null);
              }).catch((Re) => {
                Re && e.onError(Re);
              });
            },
            onError: (Re) => {
              console.log("Error :", Re);
            }
          })
        ), b.build();
    }
    return {
      wrapperStyle: () => ({
        height: A.height,
        width: A.width,
        background: A.background,
        border: A.border,
        borderRadius: A.borderRadius,
        padding: "8px"
      }),
      getCallTypeIcon: ie,
      getOngoingCallStyle: () => {
        var L;
        return {
          ...u,
          ...(L = e.ongoingCallConfiguration) == null ? void 0 : L.ongoingCallStyle
        };
      },
      getAvatarStyle: () => l,
      getListItemStyle: () => r,
      getDeclineStyle: () => N,
      getAcceptButtonStyle: () => d,
      getCallBuilder: J,
      showOngoingCall: s,
      ongoingCallStyle: u,
      sessionId: c,
      rejectIncomingCall: G,
      acceptIncomingCall: B,
      getIconStyle: () => m,
      subtitleText: o,
      subtitleStyle: () => ({
        textFont: A.subtitleTextFont,
        textColor: A.subtitleTextColor
      }),
      currentCall: z,
      showIncomingCallScreen: D
    };
  }
});
const lM = { class: "cc-incomingcall__listitem" }, sM = ["title", "listItemStyle"], MM = {
  key: 0,
  slot: "subtitleView",
  class: "cc-incomingcall__subtitleview"
}, uM = ["innerHTML"], gM = ["v-slot", "v-html"], cM = {
  key: 1,
  slot: "subtitleView",
  class: "cc-incomingcall__subtitleview"
}, dM = { class: "cc-call__icon" }, IM = ["iconStyle", "URL"], NM = ["text", "labelStyle"], TM = {
  slot: "tailView",
  class: "cc-incomingcall__tailview"
}, DM = { class: "tail__view" }, yM = { class: "cc-incomingcall__avatar" }, CM = ["avatarStyle", "image", "name"], wM = { class: "cc-incomingcall-buttons" }, jM = ["buttonStyle", "text"], AM = ["buttonStyle", "text"];
function LM(e, t, n, o, i, l) {
  var u, s, c, d, N, T, m, A;
  const r = Je("CometChatOngoingCall");
  return M(), g(we, null, [
    e.currentCall && e.showIncomingCallScreen ? (M(), g("div", {
      key: 0,
      class: "cc-incomingcall__wrapper",
      style: ce(e.wrapperStyle())
    }, [
      p("div", lM, [
        p("cometchat-list-item", {
          title: (s = (u = e.currentCall) == null ? void 0 : u.getSender()) == null ? void 0 : s.getName(),
          listItemStyle: e.getListItemStyle(),
          hideSeparator: !0
        }, [
          e.subtitleView ? (M(), g("div", MM, [
            e.subtitleView && e.subtitleView.html ? (M(), g("div", {
              key: 0,
              innerHTML: e.subtitleView.html
            }, null, 8, uM)) : e.subtitleView && e.subtitleView.componentName ? (M(), je(fe(e.subtitleView.componentName), me({ key: 1 }, { ...e.subtitleView.props }, xe((c = e.subtitleView) != null && c.listeners ? (d = e.subtitleView) == null ? void 0 : d.listeners : {})), {
              default: be(() => [
                (M(!0), g(we, null, pe(e.subtitleView.slots, (D, z) => (M(), g("div", {
                  key: z,
                  "v-slot": [z],
                  "v-html": D
                }, null, 8, gM))), 128))
              ]),
              _: 1
            }, 16)) : $("", !0)
          ])) : (M(), g("div", cM, [
            p("div", dM, [
              p("cometchat-icon", {
                iconStyle: e.getIconStyle(),
                URL: e.getCallTypeIcon()
              }, null, 8, IM)
            ]),
            p("cometchat-label", {
              class: "cc-call__type",
              text: e.subtitleText,
              labelStyle: e.subtitleStyle()
            }, null, 8, NM)
          ])),
          p("div", TM, [
            p("div", DM, [
              p("div", yM, [
                p("cometchat-avatar", {
                  avatarStyle: e.getAvatarStyle(),
                  image: (T = (N = e.currentCall) == null ? void 0 : N.getSender()) == null ? void 0 : T.getAvatar(),
                  name: (A = (m = e.currentCall) == null ? void 0 : m.getSender()) == null ? void 0 : A.getName()
                }, null, 8, CM)
              ])
            ])
          ])
        ], 8, sM)
      ]),
      p("div", wM, [
        p("cometchat-button", {
          onCcButtonClicked: t[0] || (t[0] = (D) => e.rejectIncomingCall()),
          buttonStyle: e.getDeclineStyle(),
          text: e.declineButtonText
        }, null, 40, jM),
        p("cometchat-button", {
          onCcButtonClicked: t[1] || (t[1] = (D) => e.acceptIncomingCall()),
          buttonStyle: e.getAcceptButtonStyle(),
          text: e.acceptButtonText
        }, null, 40, AM)
      ])
    ], 4)) : $("", !0),
    e.showOngoingCall && e.currentCall ? (M(), je(r, {
      key: 1,
      ongoingCallStyle: e.getOngoingCallStyle(),
      sessionID: e.sessionId,
      callSettingsBuilder: e.getCallBuilder(),
      maximizeIconURL: e.$props.ongoingCallConfiguration.maximizeIconURL,
      minimizeIconURL: e.$props.ongoingCallConfiguration.minimizeIconURL
    }, null, 8, ["ongoingCallStyle", "sessionID", "callSettingsBuilder", "maximizeIconURL", "minimizeIconURL"])) : $("", !0)
  ], 64);
}
const Jz = /* @__PURE__ */ $e(rM, [["render", LM], ["__scopeId", "data-v-60f1cbb3"]]), zM = We({
  name: "CometChatList",
  props: {
    title: {
      type: String,
      default: ""
    },
    titleAlignment: {
      type: Number,
      default: () => kn.left
    },
    hideSearch: {
      type: Boolean,
      default: !1
    },
    searchText: {
      type: String,
      default: ""
    },
    onSearch: {
      type: Function,
      default: () => {
      }
    },
    searchIconURL: {
      type: String,
      default: Yn
    },
    searchPlaceholderText: {
      type: String,
      default: "Search"
    },
    list: {
      type: Array,
      default: () => []
    },
    showSectionHeader: {
      type: Boolean,
      default: !1
    },
    sectionHeaderKey: {
      type: String
    },
    listItemKey: {
      type: null,
      required: !0
    },
    onScrolledToBottom: {
      type: Function
    },
    onScrolledToTop: {
      type: Function
    },
    state: {
      type: Number,
      default: () => ge.loading
    },
    loadingIconURL: {
      type: String,
      default: nn
    },
    emptyStateText: {
      type: String,
      default: "SOMETHING_WRONG"
    },
    hideError: {
      type: Boolean,
      default: !1
    },
    scrollToBottom: {
      type: Boolean,
      default: !1
    },
    errorStateView: {
      type: Object
    },
    loadingStateView: {
      type: Object
    },
    errorStateText: {
      type: String,
      default: "Error"
    },
    onError: {
      type: Function,
      default: (e) => console.log(e)
    },
    emptyStateView: {
      type: Object
    },
    listStyle: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e, { emit: t }) {
    let n = "";
    const o = j(null);
    let i = !0, l, r, u = j({}), s = j({}), c, d = j(null), N = j(null), T = j(null), m = j(e.titleAlignment);
    const A = j(0);
    bn(d, (J, ee) => {
      J !== ee && (A.value = 0);
    });
    const D = () => {
      var J, ee, V, ne, K, Ie, Te, H;
      return {
        border: ((J = e.listStyle) == null ? void 0 : J.searchBorder) || "none",
        borderRadius: ((ee = e.listStyle) == null ? void 0 : ee.searchBorderRadius) || "8px",
        width: "100%",
        height: "100%",
        background: ((V = e.listStyle) == null ? void 0 : V.searchBackground) || "rgb(20, 20, 20, 0.04)",
        searchTextFont: ((ne = e.listStyle) == null ? void 0 : ne.searchTextFont) || "400 15px Inter",
        searchTextColor: ((K = e.listStyle) == null ? void 0 : K.searchTextColor) || "rgb(20, 20, 20)",
        placeholderTextFont: ((Ie = e.listStyle) == null ? void 0 : Ie.searchPlaceholderTextFont) || "400 15px Inter",
        placeholderTextColor: ((Te = e.listStyle) == null ? void 0 : Te.searchPlaceholderTextColor) || "rgb(20, 20, 20, 0.46)",
        searchIconTint: ((H = e.listStyle) == null ? void 0 : H.searchIconTint) || "rgb(20, 20, 20, 0.46)"
      };
    }, z = (J, ee) => {
      let V;
      return (...ne) => {
        clearTimeout(V), V = setTimeout(() => {
          J.apply(null, ne);
        }, ee);
      };
    };
    tn(async () => {
      pn(() => {
        R(), Q(), e.scrollToBottom && e.state === ge.loaded && setTimeout(() => {
          h();
        }, 100);
      });
    }), bn(
      () => e.state,
      (J, ee) => {
        pn(() => {
          e.scrollToBottom && J === ge.loaded && ee === ge.loading && setTimeout(() => {
            h();
          }, 100);
        });
      }
    ), bn(
      () => e.list,
      () => {
        pn(() => {
          e.scrollToBottom && setTimeout(() => {
            h();
          }, 100);
        });
      }
    ), bn(
      () => e.scrollToBottom,
      (J) => {
        pn(() => {
          J && e.state === ge.loaded && setTimeout(() => {
            h();
          }, 100);
        });
      }
    );
    const k = z((J) => {
      var ee, V;
      e.onSearch && ((ee = J == null ? void 0 : J.detail) == null ? void 0 : ee.searchText) != null && e.onSearch((V = J == null ? void 0 : J.detail) == null ? void 0 : V.searchText);
    }, 500), R = () => {
      const J = {
        root: d.value,
        rootMargin: "0px 0px 0px 0px",
        threshold: 0
      }, ee = async (V) => {
        var ne;
        V[0].isIntersecting && e.onScrolledToBottom && e.state !== ge.loading && (c = (ne = d.value) == null ? void 0 : ne.scrollHeight, await e.onScrolledToBottom(), pn(() => {
        }));
      };
      l = new IntersectionObserver(ee, J), l.observe(T.value);
    }, Q = () => {
      const J = {
        root: d.value,
        threshold: 0
      }, ee = async (V) => {
        V[0].isIntersecting && e.onScrolledToTop && (i ? i = !1 : (c = d.value.scrollHeight, await e.onScrolledToTop(), pn(() => {
          d.value.scrollTop = d.value.scrollHeight - c;
        })));
      };
      r = new IntersectionObserver(ee, J), r.observe(N.value);
    };
    function h() {
      d.value && d.value.scrollTo({
        top: d.value.scrollHeight
      });
    }
    function O() {
      let J = new y.CometChatException({
        code: "ERROR",
        name: "Error",
        message: "'sectionHeaderKey' prop must be provided when 'showSectionHeader' prop is set to true ('showSectionHeader' is set to be true by default)."
      });
      e.onError && e.onError(J), n = " ";
    }
    const x = () => ({
      width: e.listStyle.width || "100%",
      height: e.listStyle.height,
      border: e.listStyle.border || "10px solid red transparent",
      borderRadius: e.listStyle.borderRadius || "0",
      background: e.listStyle.background || "white",
      boxShadow: e.listStyle.boxShadow || "",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      boxSizing: "border-box"
    }), _ = () => ({
      flexShrink: "0",
      padding: "0 16px"
    }), oe = () => ({
      width: e.listStyle.width,
      height: e.listStyle.height || "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }), ie = () => ({
      textFont: e.listStyle.errorStateTextFont || "700 22px Inter",
      textColor: e.listStyle.errorStateTextColor || "rgb(20, 20, 20, 0.33)"
    }), re = () => ({
      textFont: e.listStyle.emptyStateTextFont || "700 22px Inter",
      textColor: e.listStyle.emptyStateTextColor || "rgb(20, 20, 20, 0.33)"
    }), Ae = () => {
      let J = kn.left === m.value ? { textAlign: "left" } : { textAlign: "center" };
      return {
        font: e.listStyle.titleTextFont || "600 22px Inter, sans-serif",
        color: e.listStyle.titleTextColor || "rgb(20, 20, 20)",
        margin: "8px 0px",
        ...J
      };
    }, se = () => ({
      overflow: "hidden",
      overflowY: "auto",
      flexGrow: "1",
      padding: "0 16px",
      border: "7px solid pink transparent "
    }), X = () => {
      var J, ee, V;
      return {
        font: (J = e.listStyle) == null ? void 0 : J.sectionHeaderTextFont,
        color: (ee = e.listStyle) == null ? void 0 : ee.sectionHeaderTextColor,
        padding: ((V = e.listStyle) == null ? void 0 : V.sectionHeaderTextColor) || "4px"
      };
    };
    function B(J, ee) {
      let V;
      const ne = ee[J];
      return typeof ne == "function" ? V = String(ne.call(ee)) : V = String(ne), V;
    }
    function F() {
      const J = d.value.scrollTop;
      J > A.value ? t("cc-list-scrollDown") : J < A.value && t("cc-list-scrollUp"), A.value = J;
    }
    let G = Ht(() => e.state == ge.loaded ? {
      border: "1px solid transparent"
    } : {});
    return {
      SearchIcon: Yn,
      LoadingIcon: nn,
      getKeyValue: B,
      States: ge,
      currentSectionHeader: n,
      scrollPos: o,
      listWrapperStyle: x,
      headerTitle: Ae,
      searchEvent: k,
      messageContainerStyle: oe,
      errorStyle: ie,
      emptyStyle: re,
      headerStyle: _,
      listStyles: se,
      iconStyle: s,
      sectionHeaderStyle: X,
      searchStyle: u,
      listScrollRef: d,
      topDivRef: N,
      bottomDivRef: T,
      SectionHeaderUndefined: O,
      setSearchStyles: D,
      handleScroll: F,
      bottomDivStyle: G
    };
  }
});
const SM = { class: "cc-list__search-input" }, pM = ["searchInputStyle", "searchIconURL", "searchText", "placeholderText"], bM = {
  class: "cc-list__top",
  ref: "topDivRef"
}, EM = {
  key: 0,
  class: "cc-list__loading-view"
}, hM = ["iconURL", "loaderStyle"], vM = {
  key: 1,
  class: "cc-list__custom-view-loading"
}, mM = ["innerHTML"], OM = ["v-slot", "v-html"], xM = {
  key: 1,
  class: "cc-list__error-view"
}, kM = ["labelStyle", "text"], fM = {
  key: 1,
  class: "cc-list__custom-view-error"
}, UM = ["innerHTML"], BM = ["v-slot", "v-html"], QM = {
  key: 2,
  class: "cc-list__empty-view"
}, RM = ["text", "labelStyle"], YM = {
  key: 1,
  class: "cc-list__custom-view-empty"
}, VM = ["innerHTML"], GM = ["v-slot", "v-html"], PM = {
  key: 0,
  class: "cc-list__section"
};
function FM(e, t, n, o, i, l) {
  var r, u, s;
  return M(), g("div", {
    class: "cc-list__wrapper",
    style: ce(e.listWrapperStyle())
  }, [
    p("div", {
      class: "cc-list__header",
      style: ce(e.headerStyle())
    }, [
      e.title ? (M(), g("div", {
        key: 0,
        class: "cc-list__title",
        style: ce(e.headerTitle())
      }, kt(e.title), 5)) : $("", !0),
      p("div", SM, [
        Kn(p("cometchat-search-input", {
          searchInputStyle: e.setSearchStyles(),
          searchIconURL: e.searchIconURL,
          searchText: e.searchText,
          placeholderText: e.searchPlaceholderText,
          onCcSearchChanged: t[0] || (t[0] = (...c) => e.searchEvent && e.searchEvent(...c))
        }, null, 40, pM), [
          [Xn, !e.hideSearch]
        ])
      ])
    ], 4),
    p("div", {
      class: "cc-list__list",
      ref: "listScrollRef",
      onWheel: t[1] || (t[1] = (...c) => e.handleScroll && e.handleScroll(...c)),
      style: ce(e.listStyles())
    }, [
      p("div", bM, null, 512),
      e.state == e.States.loading || e.state == e.States.error || e.state == e.States.empty ? (M(), g("div", {
        key: 0,
        class: "cc-list__decorator-message",
        style: ce(e.messageContainerStyle())
      }, [
        e.state == e.States.loading && e.list.length == 0 ? (M(), g("div", EM, [
          e.loadingStateView ? $("", !0) : (M(), g("cometchat-loader", {
            key: 0,
            iconURL: e.loadingIconURL,
            loaderStyle: e.iconStyle
          }, null, 8, hM)),
          e.loadingStateView ? (M(), g("div", vM, [
            e.loadingStateView.html ? (M(), g("div", {
              key: 0,
              innerHTML: e.loadingStateView.html
            }, null, 8, mM)) : (M(), je(fe(e.loadingStateView.componentName), me({ key: 1 }, xe((r = e.loadingStateView) == null ? void 0 : r.listeners), { ...e.loadingStateView.props }), {
              default: be(() => [
                (M(!0), g(we, null, pe(e.loadingStateView.slots, (c, d) => (M(), g("div", {
                  key: d,
                  "v-slot": [d],
                  "v-html": c
                }, null, 8, OM))), 128))
              ]),
              _: 1
            }, 16))
          ])) : $("", !0)
        ])) : e.state == e.States.error && !e.hideError ? (M(), g("div", xM, [
          e.errorStateView ? $("", !0) : (M(), g("cometchat-label", {
            key: 0,
            labelStyle: e.errorStyle(),
            text: e.errorStateText
          }, null, 8, kM)),
          e.errorStateView ? (M(), g("div", fM, [
            e.errorStateView.html ? (M(), g("div", {
              key: 0,
              innerHTML: e.errorStateView.html
            }, null, 8, UM)) : (M(), je(fe(e.errorStateView.componentName), me({ key: 1 }, xe((u = e.errorStateView) == null ? void 0 : u.listeners), { ...e.errorStateView.props }), {
              default: be(() => [
                (M(!0), g(we, null, pe(e.errorStateView.slots, (c, d) => (M(), g("div", {
                  key: d,
                  "v-slot": [d],
                  "v-html": c
                }, null, 8, BM))), 128))
              ]),
              _: 1
            }, 16))
          ])) : $("", !0)
        ])) : e.state == e.States.empty ? (M(), g("div", QM, [
          e.emptyStateView ? $("", !0) : (M(), g("cometchat-label", {
            key: 0,
            text: e.emptyStateText,
            labelStyle: e.emptyStyle()
          }, null, 8, RM)),
          e.emptyStateView ? (M(), g("div", YM, [
            e.emptyStateView.html ? (M(), g("div", {
              key: 0,
              innerHTML: e.emptyStateView.html
            }, null, 8, VM)) : (M(), je(fe(e.emptyStateView.componentName), me({ key: 1 }, xe((s = e.emptyStateView) == null ? void 0 : s.listeners), { ...e.emptyStateView.props }), {
              default: be(() => [
                (M(!0), g(we, null, pe(e.emptyStateView.slots, (c, d) => (M(), g("div", {
                  key: d,
                  "v-slot": [d],
                  "v-html": c
                }, null, 8, GM))), 128))
              ]),
              _: 1
            }, 16))
          ])) : $("", !0)
        ])) : $("", !0)
      ], 4)) : $("", !0),
      (M(!0), g(we, null, pe(e.list, (c, d) => (M(), g("div", {
        class: "cc-list__listitem-view",
        key: e.getKeyValue(e.listItemKey, c)
      }, [
        e.state == e.States.loaded || e.state == e.States.loading && e.list.length > 0 ? (M(), g("div", PM, [
          e.showSectionHeader ? (M(), g(we, { key: 0 }, [
            e.sectionHeaderKey === void 0 ? (M(), g(we, { key: 0 }, [
              pi(kt(e.SectionHeaderUndefined()), 1)
            ], 64)) : (M(), g(we, { key: 1 }, [
              e.getKeyValue(e.sectionHeaderKey, c).length > 0 && (d === 0 || e.getKeyValue(e.sectionHeaderKey, c)[0].toUpperCase() !== e.currentSectionHeader) ? (M(), g("div", {
                key: 0,
                class: "cc-list__section-header",
                style: ce(e.sectionHeaderStyle())
              }, kt(e.currentSectionHeader = e.getKeyValue(
                e.sectionHeaderKey,
                c
              )[0].toUpperCase()), 5)) : (M(), g(we, { key: 1 }, [], 64))
            ], 64))
          ], 64)) : $("", !0)
        ])) : $("", !0),
        Ol(e.$slots, "listItem", {
          item: c,
          index: d
        }, void 0, !0)
      ]))), 128)),
      p("div", {
        class: "cc-list__list-bottom",
        style: ce(e.bottomDivStyle),
        ref: "bottomDivRef"
      }, null, 4)
    ], 36)
  ], 4);
}
const hn = /* @__PURE__ */ $e(zM, [["render", FM], ["__scopeId", "data-v-2abc65da"]]);
class co {
  messageBubbleStyle(t, n, o, i) {
    return t.getDeletedAt() ? {
      background: "transparent",
      border: `1px dashed ${n.value.palette.getAccent400()}`,
      borderRadius: "12px"
    } : !t.getDeletedAt() && t.getCategory() === I.MessageCategory.message && t.getType() === I.MessageTypes.text && (!t.getSender() || (i == null ? void 0 : i.getUid()) === t.getSender().getUid()) ? {
      background: o === gt.left ? n.value.palette.getAccent100() : n.value.palette.getPrimary(),
      borderRadius: "12px"
    } : !t.getDeletedAt() && t.getCategory() === I.MessageCategory.message && t.getType() === I.MessageTypes.audio ? {
      borderRadius: "",
      background: n.value.palette.getAccent100()
    } : t.getType() === I.MessageTypes.groupMember ? {
      background: "transparent",
      borderRadius: "12px",
      border: `1px solid ${n.value.palette.getAccent100()}`
    } : (t == null ? void 0 : t.getType()) === I.calls.meeting && (!(t != null && t.getSender()) || t != null && t.getSender() && i && (t == null ? void 0 : t.getSender().getUid()) == i.getUid()) ? {
      background: n.value.palette.getPrimary(),
      border: "none",
      borderRadius: "12px"
    } : (t == null ? void 0 : t.getType()) === On.sticker ? {
      background: "transparent",
      borderRadius: "12px"
    } : t.getSender() && t.getSender().getUid() !== (i == null ? void 0 : i.getUid()) ? {
      background: n.value.palette.getAccent100(),
      borderRadius: "12px"
    } : {
      background: n.value.palette.getAccent100(),
      borderRadius: "12px"
    };
  }
  getContentView(t, n) {
    var l, r;
    let o;
    const i = {};
    return i[n.category + "_" + n.type] = n, i[(t == null ? void 0 : t.getCategory()) + "_" + (t == null ? void 0 : t.getType())] && ((l = i[(t == null ? void 0 : t.getCategory()) + "_" + (t == null ? void 0 : t.getType())]) != null && l.contentView) ? (o = (r = i[(t == null ? void 0 : t.getCategory()) + "_" + (t == null ? void 0 : t.getType())]) == null ? void 0 : r.contentView(t, gt.right), typeof o == "string" ? {
      html: o
    } : o) : null;
  }
  getBubbleWrapper(t, n) {
    let o;
    const i = {};
    return i[n.category + "_" + n.type] = n, i && i[(t == null ? void 0 : t.getCategory()) + "_" + (t == null ? void 0 : t.getType())] && i[(t == null ? void 0 : t.getCategory()) + "_" + (t == null ? void 0 : t.getType())].bubbleView ? (o = i[(t == null ? void 0 : t.getCategory()) + "_" + (t == null ? void 0 : t.getType())].bubbleView(t), o) : (o = null, o);
  }
  getMessageBubble(t, n, o, i) {
    return this.getBubbleWrapper(t, n) ? this.getBubbleWrapper(t, n) : {
      componentName: "CometChatMessageBubble",
      props: {
        id: (t == null ? void 0 : t.getId()) || (t == null ? void 0 : t.getMuid()),
        messageBubbleStyle: o,
        alignment: i,
        replyView: null,
        threadView: null,
        contentView: this.getContentView(t, n)
      }
    };
  }
  /**
  * Function to check if a user's status should be visible
  * @param {CometChat.User | CometChat.GroupMember} user - The user whose status visibility is to be checked.
  * @return {boolean} - Returns `true` if the user's status should be hidden (blocked or offline), `false` otherwise.
  */
  getUserStatusVisibility(t) {
    let n = !1;
    return t && (t.getBlockedByMe() || t.getHasBlockedMe() || t.getStatus() === I.userStatusType.offline) && (n = !0), n;
  }
}
const HM = We({
  name: "CometChatUsers",
  components: {
    CometChatList: hn
  },
  props: {
    title: {
      type: String,
      default: () => Y("USERS")
    },
    titleAlignment: {
      type: Number,
      default: () => kn.left
    },
    searchPlaceholderText: {
      type: String,
      default: () => Y("SEARCH")
    },
    subtitleView: {
      type: Function
    },
    listItemView: {
      type: Function
    },
    menus: {
      type: Object
    },
    options: {
      type: Function
    },
    usersRequestBuilder: {
      type: Object
    },
    SearchRequestBuilder: {
      type: Object
    },
    disableUsersPresence: {
      type: Boolean,
      default: !1
    },
    hideSeparator: {
      type: Boolean,
      default: !1
    },
    selectionMode: {
      type: Number,
      default: () => xt.none
    },
    onSelect: {
      type: Function
    },
    searchIconURL: {
      type: String,
      default: Yn
    },
    hideSearch: {
      type: Boolean,
      default: !1
    },
    hideError: {
      type: Boolean,
      default: !1
    },
    showSectionHeader: {
      type: Boolean,
      default: !0
    },
    emptyStateView: {
      type: Object
    },
    errorStateText: {
      type: String,
      default: () => Y("SOMETHING_WRONG")
    },
    emptyStateText: {
      type: String,
      default: () => Y("NO_USERS_FOUND")
    },
    sectionHeaderKey: {
      type: String,
      default: "getName"
    },
    activeUser: {
      type: Object
    },
    onItemClick: {
      type: Function
    },
    onError: {
      type: Function
    },
    avatarStyle: {
      type: Object,
      default: () => ({})
    },
    statusIndicatorStyle: {
      type: Object,
      default: () => ({})
    },
    listItemStyle: {
      type: Object,
      default: () => ({})
    },
    usersStyle: {
      type: Object,
      default: () => ({})
    },
    loadingIconURL: {
      type: String,
      default: nn
    },
    loadingStateView: {
      type: Object
    },
    errorStateView: {
      type: Object
    },
    userPresencePlacement: {
      type: Number,
      default: zi.bottom
    },
    searchKeyword: {
      type: String,
      default: void 0
    },
    onEmpty: {
      type: Function
    },
    disableLoadingState: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = j([]);
    let { theme: n } = dt("theme", {
      theme: j(new Ke({}))
    });
    const o = j(ge.loading), i = j(null), l = j(""), r = j(""), u = j(30), s = j("userlist_" + (/* @__PURE__ */ new Date()).getTime()), c = j(
      "connection_" + (/* @__PURE__ */ new Date()).getTime()
    ), d = j(), N = j();
    let T = j(e.avatarStyle), m = j(e.statusIndicatorStyle), A = j({}), D = j(e.listItemStyle), z = j(e.usersStyle), k, R;
    const Q = j({});
    function h() {
      let b = null;
      const v = "abort";
      return function(U) {
        return new Promise(
          (Se, Ue) => {
            b = new AbortController();
            const Re = b;
            let _e = !1;
            const Z = function ke(q) {
              Re.signal.removeEventListener(v, ke), _e = !0, Ue(q);
            };
            Re.signal.addEventListener(
              v,
              Z
            ), U.fetchNext().finally(() => {
              _e || Re.signal.removeEventListener(
                v,
                Z
              );
            }).then((ke) => {
              Se(ke);
            }).catch(Ue);
          }
        );
      };
    }
    const O = h(), x = async () => {
      var b;
      if (i.value && i.value.pagination && (i.value.pagination.current_page == 0 || i.value.pagination.current_page != i.value.pagination.total_pages)) {
        e.disableLoadingState || (o.value = ge.loading);
        try {
          const v = await O(i.value);
          v.length === 0 && e.onEmpty && (e.onEmpty(), R = void 0), v.length === 0 && t.value.length === 0 ? o.value = ge.empty : (e.disableLoadingState ? e.searchKeyword != R || [0, 1].includes(i.value.pagination.current_page) ? t.value = v : t.value = [
            ...t.value,
            ...v
          ] : t.value = [
            ...t.value,
            ...v
          ], o.value = ge.loaded), R = e.searchKeyword;
        } catch (v) {
          v instanceof Error ? e.onError && (e.onError(v), o.value = ge.error) : v instanceof Event && v.type === "abort" && console.log("Fetch request was aborted by an abort event"), t.value && ((b = t.value) == null ? void 0 : b.length) > 0 ? o.value = ge.loaded : o.value = ge.error;
        }
      } else
        o.value = ge.loaded;
    }, _ = () => {
      d.value = En.ccUserBlocked.subscribe(
        (b) => {
          e.activeUser && b.getUid() == e.activeUser.getUid() && Ae(b);
        }
      ), N.value = En.ccUserUnblocked.subscribe(
        (b) => {
          e.activeUser && b.getUid() == e.activeUser.getUid() && Ae(b);
        }
      );
    };
    function oe() {
      y.addUserListener(
        s.value,
        new y.UserListener({
          onUserOnline: (b) => {
            Ae(b);
          },
          onUserOffline: (b) => {
            Ae(b);
          }
        })
      ), y.addConnectionListener(
        c.value,
        new y.ConnectionListener({
          onConnected: () => {
            i.value = ie.value, e.disableLoadingState || (o.value = ge.loading), x().then(() => {
              o.value = ge.loaded;
            });
          }
        })
      );
    }
    const ie = Ht(() => (e.searchKeyword || (R = void 0), l.value && l.value.length == 0 ? e.usersRequestBuilder ? e.usersRequestBuilder.setSearchKeyword("").build() : new y.UsersRequestBuilder().setLimit(u.value).build() : e.SearchRequestBuilder ? e.SearchRequestBuilder.setSearchKeyword(
      l.value
    ).build() : e.usersRequestBuilder ? e.usersRequestBuilder.setSearchKeyword(l.value).build() : new y.UsersRequestBuilder().setSearchKeyword(l.value).setLimit(u.value).build())), re = (b) => {
      clearTimeout(k), k = setTimeout(() => {
        l.value = b, e.disableLoadingState || (o.value = ge.loading, t.value = []), i.value = ie.value, x().then();
      }, 500);
    };
    bn(
      () => e.searchKeyword,
      (b, v) => {
        b !== v && re(b);
      },
      { immediate: !0 }
    );
    const Ae = (b) => {
      let v = [...t.value], U = v.findIndex(
        (Se, Ue) => Se.getUid() == b.getUid()
      );
      U > -1 && (v.splice(U, 1, b), t.value = [...v]);
    };
    function se() {
      y.removeUserListener(s.value), s.value = "", y.removeConnectionListener(c.value), c.value = "";
    }
    function X() {
      var b, v;
      (b = d.value) == null || b.unsubscribe(), (v = N.value) == null || v.unsubscribe();
    }
    tn(() => {
      ne(), _(), i.value = ie.value, e.searchKeyword || x().then(() => {
        o.value = ge.loaded;
      }), oe();
    }), un(() => {
      i.value = null, se(), o.value = ge.loaded, X();
    });
    const B = (b) => {
      var v;
      return (e.selectionMode == xt.none || !e.selectionMode) && b.getUid() == ((v = e.activeUser) == null ? void 0 : v.getUid());
    }, F = (b) => {
      e.onItemClick && e.onItemClick(b);
    }, G = (b) => new co().getUserStatusVisibility(b) || e.disableUsersPresence ? null : e.usersStyle.onlineStatusColor ?? n.value.palette.getSuccess();
    function J(b) {
      return b.getUid() === r.value || Q.value[b.getUid()];
    }
    function ee(b, v) {
      r.value = v.getUid(), V(b, v);
    }
    function V(b, v) {
      var Se;
      const U = (Se = b.detail) == null ? void 0 : Se.checked;
      e.onSelect && e.onSelect(v, U), e.selectionMode === xt.single ? Q.value = { [v.getUid()]: v } : U ? Q.value[v.getUid()] = v : delete Q.value[v.getUid()];
    }
    function ne() {
      H(), K(), Ie(), Te();
    }
    function K() {
      let b = new _t({
        height: "45px",
        width: "100%",
        background: n.value.palette.getBackground(),
        activeBackground: n.value.palette.getAccent100(),
        borderRadius: "0",
        titleFont: w(n.value.typography.title2),
        titleColor: n.value.palette.getAccent(),
        border: "none",
        separatorColor: n.value.palette.getAccent200(),
        hoverBackground: n.value.palette.getAccent50()
      });
      D.value = { ...b, ...D.value };
    }
    function Ie() {
      let b = new Kt({
        borderRadius: "24px",
        width: "28px",
        height: "28px",
        border: "none",
        backgroundColor: n.value.palette.getAccent700(),
        nameTextColor: n.value.palette.getAccent900(),
        backgroundSize: "cover",
        nameTextFont: w(n.value.typography.subtitle1),
        outerViewBorderWidth: "",
        outerViewBorderSpacing: ""
      });
      T.value = { ...b, ...T.value };
    }
    function Te() {
      let b = {
        height: "12px",
        width: "12px",
        border: "none",
        borderRadius: "24px"
      };
      m.value = {
        ...b,
        ...m.value
      };
    }
    function H() {
      let b = new Ci({
        background: n.value.palette.getBackground(),
        border: `1px solid ${n.value.palette.getAccent50()}`,
        titleTextFont: w(n.value.typography.title1),
        titleTextColor: n.value.palette.getAccent(),
        emptyStateTextFont: w(n.value.typography.title1),
        emptyStateTextColor: n.value.palette.getAccent600(),
        errorStateTextFont: w(n.value.typography.title1),
        errorStateTextColor: n.value.palette.getAccent600(),
        loadingIconTint: n.value.palette.getAccent600(),
        separatorColor: n.value.palette.getAccent400(),
        onlineStatusColor: n.value.palette.getSuccess(),
        sectionHeaderTextColor: n.value.palette.getAccent600(),
        sectionHeaderTextFont: w(n.value.typography.subtitle2),
        searchIconTint: n.value.palette.getAccent600(),
        searchPlaceholderTextColor: n.value.palette.getAccent600(),
        searchBackground: n.value.palette.getAccent100(),
        searchPlaceholderTextFont: w(n.value.typography.text3),
        searchTextColor: n.value.palette.getAccent600(),
        searchTextFont: w(n.value.typography.text3)
      });
      z.value = { ...b, ...z.value }, A.value = {
        height: "100%",
        titleTextFont: z.value.titleTextFont,
        titleTextColor: z.value.titleTextColor,
        emptyStateTextFont: z.value.emptyStateTextFont,
        emptyStateTextColor: z.value.emptyStateTextColor,
        errorStateTextFont: z.value.errorStateTextFont,
        errorStateTextColor: z.value.errorStateTextColor,
        loadingIconTint: z.value.loadingIconTint,
        separatorColor: z.value.separatorColor,
        searchIconTint: z.value.searchIconTint,
        searchBorder: z.value.searchBorder,
        searchBorderRadius: z.value.searchBorderRadius,
        searchBackground: z.value.searchBackground,
        searchPlaceholderTextFont: z.value.searchPlaceholderTextFont,
        searchPlaceholderTextColor: z.value.searchPlaceholderTextColor,
        searchTextFont: z.value.searchTextFont,
        searchTextColor: z.value.searchTextColor,
        sectionHeaderTextColor: z.value.sectionHeaderTextColor,
        sectionHeaderTextFont: z.value.sectionHeaderTextFont,
        background: z.value.background
      };
    }
    return {
      Users: t,
      States: ge,
      onSearch: re,
      searchKeyword: l,
      getActiveUser: B,
      onClick: F,
      getStatusIndicatorColor: G,
      setThemeStyle: ne,
      userStyle: () => ({
        height: z.value.height || "100%",
        width: z.value.width || "100%",
        background: z.value.background,
        border: z.value.border,
        borderRadius: z.value.borderRadius || "0",
        position: "relative",
        boxSizing: "border-box"
      }),
      myavatarStyle: T,
      myStatusIndicatorStyle: m,
      myListItemStyle: D,
      myUsersStyle: z,
      fetchNextUsersList: x,
      addMembersToList: ee,
      isUserSelected: J,
      SelectionMode: xt,
      state: o,
      listStyle: A,
      SearchIcon: Yn,
      LoadingIcon: nn,
      WarningIcon: Oi,
      subtitleStyle: () => ({
        font: e.usersStyle.titleTextFont || "12px",
        color: e.usersStyle.titleTextColor || "rgba(20, 20, 20, 0.4)"
      }),
      handleSelection: V
    };
  }
});
const ZM = {
  key: 0,
  class: "cc-users__menus"
}, WM = ["innerHTML"], $M = ["innerHTML"], JM = { key: 0 }, KM = ["innerHTML"], XM = ["innerHTML"], qM = ["title", "avatarStyle", "avatarURL", "avatarName", "isActive", "statusIndicatorStyle", "hideSeparator", "onCcListitemClicked", "statusIndicatorColor", "listItemStyle", "userPresencePlacement"], _M = ["innerHTML"], eu = ["innerHTML"], tu = {
  key: 0,
  slot: "menuView",
  class: "cc-users__menu-view"
}, nu = ["data"], ou = {
  key: 1,
  slot: "tailView",
  class: "cc-users__selection-single"
}, iu = ["onCcRadioButtonChanged", "checked"], au = {
  key: 2,
  slot: "tailView",
  class: "cc-users__selection-multiple"
}, ru = ["onCcCheckboxChanged", "checked"];
function lu(e, t, n, o, i, l) {
  var u;
  const r = Je("CometChatList");
  return M(), g("div", {
    class: "cc-users",
    style: ce(e.userStyle())
  }, [
    e.menus ? (M(), g("div", ZM, [
      e.menus.componentName ? (M(), je(fe(e.menus.componentName), me({ key: 0 }, xe((u = e.menus) == null ? void 0 : u.listeners), { ...e.menus.props }), Ho({ _: 2 }, [
        pe(e.menus.slots, (s, c) => ({
          name: c,
          fn: be(() => [
            p("div", { innerHTML: s }, null, 8, WM)
          ])
        }))
      ]), 1040)) : (M(), g("div", {
        key: 1,
        innerHTML: e.menus.html
      }, null, 8, $M))
    ])) : $("", !0),
    Nt(r, {
      title: e.title,
      titleAlignment: e.titleAlignment,
      hideSearch: e.hideSearch,
      searchIconURL: e.searchIconURL,
      searchPlaceholderText: e.searchPlaceholderText,
      searchText: e.searchKeyword,
      onSearch: e.onSearch,
      list: e.Users,
      onScrolledToBottom: e.fetchNextUsersList,
      showSectionHeader: e.showSectionHeader,
      sectionHeaderKey: e.sectionHeaderKey,
      state: e.state,
      loadingIconURL: e.loadingIconURL,
      hideError: e.hideError,
      listStyle: e.listStyle,
      scrollToBottom: !1,
      onError: e.onError,
      errorStateText: e.errorStateText,
      emptyStateText: e.emptyStateText,
      errorStateView: e.errorStateView,
      emptyStateView: e.emptyStateView,
      listItemKey: "getUid",
      loadingStateView: e.loadingStateView
    }, {
      listItem: be(({ item: s }) => {
        var c, d, N, T, m, A, D, z, k, R, Q;
        return [
          e.listItemView ? (M(), g("div", JM, [
            (c = e.listItemView(s)) != null && c.html ? (M(), g("div", {
              key: 0,
              innerHTML: (d = e.listItemView(s)) == null ? void 0 : d.html
            }, null, 8, KM)) : (M(), je(fe((N = e.listItemView(s)) == null ? void 0 : N.componentName), me({ key: 1 }, xe(s == null ? void 0 : s.listeners), { ...(T = e.listItemView(s)) == null ? void 0 : T.props }), Ho({ _: 2 }, [
              pe((m = e.listItemView(s)) == null ? void 0 : m.slots, (h, O) => ({
                name: O,
                fn: be(() => [
                  p("div", { innerHTML: h }, null, 8, XM)
                ])
              }))
            ]), 1040))
          ])) : (M(), g("cometchat-list-item", {
            key: 1,
            title: s == null ? void 0 : s.name,
            avatarStyle: e.myavatarStyle,
            avatarURL: s == null ? void 0 : s.avatar,
            avatarName: s == null ? void 0 : s.name,
            isActive: e.getActiveUser(s),
            statusIndicatorStyle: e.myStatusIndicatorStyle,
            hideSeparator: e.hideSeparator,
            onCcListitemClicked: (h) => e.onClick(s),
            statusIndicatorColor: e.getStatusIndicatorColor(s),
            listItemStyle: e.myListItemStyle,
            userPresencePlacement: e.userPresencePlacement
          }, [
            p("div", {
              slot: "subtitleView",
              class: "cc-users__subtitle-view",
              style: ce(e.subtitleStyle())
            }, [
              e.subtitleView ? (M(), g(we, { key: 0 }, [
                (A = e.subtitleView(s)) != null && A.html ? (M(), g("div", {
                  key: 0,
                  innerHTML: (D = e.subtitleView(s)) == null ? void 0 : D.html
                }, null, 8, _M)) : (M(), je(fe((z = e.subtitleView(s)) == null ? void 0 : z.componentName), me({ key: 1 }, xe(s == null ? void 0 : s.listeners), { ...(k = e.subtitleView(s)) == null ? void 0 : k.props }), Ho({ _: 2 }, [
                  pe((R = e.subtitleView(s)) == null ? void 0 : R.slots, (h, O) => ({
                    name: O,
                    fn: be(() => [
                      p("div", { innerHTML: h }, null, 8, eu)
                    ])
                  }))
                ]), 1040))
              ], 64)) : $("", !0)
            ], 4),
            e.options ? (M(), g("div", tu, [
              p("cometchat-menu-list", {
                data: (Q = e.options) == null ? void 0 : Q.call(e, s)
              }, null, 8, nu)
            ])) : $("", !0),
            e.selectionMode == e.SelectionMode.single ? (M(), g("div", ou, [
              p("cometchat-radio-button", {
                onCcRadioButtonChanged: (h) => {
                  e.addMembersToList(h, s);
                },
                checked: e.isUserSelected(s)
              }, null, 40, iu)
            ])) : $("", !0),
            e.selectionMode == e.SelectionMode.multiple ? (M(), g("div", au, [
              p("cometchat-checkbox", {
                onCcCheckboxChanged: (h) => {
                  e.handleSelection(h, s);
                },
                checked: e.isUserSelected(s)
              }, null, 40, ru)
            ])) : $("", !0)
          ], 40, qM))
        ];
      }),
      _: 1
    }, 8, ["title", "titleAlignment", "hideSearch", "searchIconURL", "searchPlaceholderText", "searchText", "onSearch", "list", "onScrolledToBottom", "showSectionHeader", "sectionHeaderKey", "state", "loadingIconURL", "hideError", "listStyle", "onError", "errorStateText", "emptyStateText", "errorStateView", "emptyStateView", "loadingStateView"])
  ], 4);
}
const ei = /* @__PURE__ */ $e(HM, [["render", lu], ["__scopeId", "data-v-49a05159"]]), su = We({
  components: {
    CometChatUsers: ei
  },
  props: {
    title: {
      type: String,
      default: () => Y("ADD_MEMBERS")
    },
    buttonText: {
      type: String,
      default: () => Y("ADD_MEMBERS")
    },
    titleAlignment: {
      type: Number,
      default: () => kn.center
    },
    searchPlaceholder: {
      type: String,
      default: () => Y("SEARCH")
    },
    sectionHeaderField: {
      type: String,
      default: "getName"
    },
    subtitleView: {
      type: Function
    },
    listItemView: {
      type: Function
    },
    menus: {
      type: Object
    },
    onAddMembersButtonClick: {
      type: Function
    },
    options: {
      type: Function
    },
    usersRequestBuilder: {
      type: Object
    },
    searchRequestBuilder: {
      type: Object
    },
    disableUsersPresence: {
      type: Boolean,
      default: !1
    },
    group: {
      type: Object,
      required: !0
    },
    showSectionHeader: {
      type: Boolean,
      default: !1
    },
    hideSeparator: {
      type: Boolean,
      default: !1
    },
    showBackButton: {
      type: Boolean,
      default: !0
    },
    selectionMode: {
      type: Number,
      default: () => xt.multiple
    },
    onSelect: {
      type: Function
    },
    searchIconURL: {
      type: String,
      default: Yn
    },
    backButtonIconURL: {
      type: String,
      default: fn
    },
    closeButtonIconURL: {
      type: String,
      default: Cn
    },
    hideSearch: {
      type: Boolean,
      default: !1
    },
    hideError: {
      type: Boolean,
      default: !1
    },
    emptyStateView: {
      type: Object
    },
    errorStateText: {
      type: String,
      default: () => Y("SOMETHING_WRONG")
    },
    emptyStateText: {
      type: String,
      default: () => Y("NO_USERS_FOUND")
    },
    onError: {
      type: Function,
      default: (e) => console.log(e)
    },
    onBack: {
      type: Function
    },
    onClose: {
      type: Function
    },
    avatarStyle: {
      type: Object,
      default: () => ({})
    },
    addMembersStyle: {
      type: Object,
      default: () => ({})
    },
    statusIndicatorStyle: {
      type: null
    },
    listItemStyle: {
      type: Object,
      default: () => ({})
    },
    loadingIconURL: {
      type: String,
      default: nn
    },
    loadingStateView: {
      type: Object
    },
    errorStateView: {
      type: Object
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    });
    const n = j([]), o = j([]), i = j([]);
    let l = j(e.group), r = j(null), u = Ht(() => {
      var se;
      return ((se = n.value) == null ? void 0 : se.length) <= 0;
    }), s = {}, c = j(e.avatarStyle), d = j(e.addMembersStyle), N = j(e.listItemStyle), T = j(e.statusIndicatorStyle), m = {
      height: "100%",
      width: "100%",
      background: "rgb(51, 153, 255)",
      padding: "8px",
      buttonTextColor: "white",
      buttonTextFont: "",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border: "none",
      borderRadius: "8px"
    };
    Zt(() => {
      l.value = e.group;
    });
    function A() {
      e.onClose && e.onClose();
    }
    function D() {
      e.onBack && e.onBack();
    }
    const z = (se) => {
      const X = new y.GroupMember(
        se.getUid(),
        I.groupMemberScope.participant
      );
      return X.setName(se.getName()), X.setGuid(l.value.getGuid()), X;
    }, k = (se, X) => {
      if (e.onSelect && e.onSelect(se, X), e.selectionMode == xt.single)
        n.value = [z(se)];
      else if (e.selectionMode == xt.multiple) {
        const B = se.getUid(), F = [];
        let G = !1;
        for (let J = 0; J < n.value.length; J++) {
          const ee = n.value[J];
          B === ee.getUid() ? G = !0 : F.push(ee);
        }
        G || F.push(z(se)), n.value = F;
      }
    }, R = () => {
      if (l.value && n.value.length > 0)
        if (e.onAddMembersButtonClick) {
          e.onAddMembersButtonClick(
            l.value.getGuid(),
            n.value
          );
          return;
        } else
          y.addMembersToGroup(
            l.value.getGuid(),
            n.value,
            []
          ).then((se) => {
            var B;
            for (const F in se)
              if (Object.prototype.hasOwnProperty.call(se, F) && se[F] === "success") {
                const G = n.value.find(
                  (J) => J.getUid() === F
                );
                G && (Q(G), o.value.push(G));
              }
            let X = Ce.clone(l.value);
            X = X, X instanceof y.Group && X.setMembersCount(
              X.getMembersCount() + ((B = o.value) == null ? void 0 : B.length) || 0
            ), l.value = X, He.ccGroupMemberAdded.next({
              messages: i.value,
              usersAdded: o.value,
              userAddedIn: X,
              userAddedBy: r.value
            }), n.value = [], o.value = [], i.value = [], e.onBack && e.onBack();
          }).catch((se) => {
            console.log(se), n.value = [];
          });
      else
        return;
    };
    function Q(se) {
      var B;
      let X = new y.Action(
        l.value.getGuid(),
        I.MessageTypes.groupMember,
        I.MessageReceiverType.group,
        I.MessageCategory.action
      );
      X.setAction(I.groupMemberAction.ADDED), X.setActionBy(r.value), X.setActionFor(l.value), X.setActionOn(se), X.setReceiver(l.value), X.setSender(r.value), X.setConversationId("group_" + l.value.getGuid()), X.setMuid(Ce.ID()), X.setMessage(
        `${(B = r.value) == null ? void 0 : B.getName()} added ${se.getUid()}`
      ), X.setSentAt(Ce.getUnixTimestamp()), i.value.push(X);
    }
    tn(async () => {
      x(), h(), O(), re(), n.value = [], o.value = [], i.value = [], y.getLoggedinUser().then((se) => {
        r.value = se;
      }).catch((se) => {
        e.onError && e.onError(se);
      });
    });
    function h() {
      let se = new Br({
        background: t.value.palette.getBackground(),
        border: "none",
        titleTextFont: w(t.value.typography.title1),
        titleTextColor: t.value.palette.getAccent(),
        emptyStateTextFont: w(t.value.typography.title1),
        emptyStateTextColor: t.value.palette.getAccent600(),
        errorStateTextFont: w(t.value.typography.title1),
        errorStateTextColor: t.value.palette.getAccent600(),
        loadingIconTint: t.value.palette.getAccent600(),
        onlineStatusColor: t.value.palette.getSuccess(),
        separatorColor: t.value.palette.getAccent400(),
        width: "100%",
        height: "100%",
        borderRadius: "none",
        searchPlaceholderTextFont: w(t.value.typography.subtitle1),
        searchPlaceholderTextColor: t.value.palette.getAccent600(),
        searchTextFont: w(t.value.typography.subtitle2),
        searchTextColor: t.value.palette.getAccent400(),
        searchIconTint: t.value.palette.getAccent600(),
        searchBorder: `1px solid ${t.value.palette.getAccent100()}`,
        searchBorderRadius: "8px",
        searchBackground: t.value.palette.getAccent100(),
        closeButtonIconTint: t.value.palette.getPrimary(),
        backButtonIconTint: t.value.palette.getPrimary(),
        addMembersButtonBackground: t.value.palette.getPrimary(),
        addMembersButtonTextColor: t.value.palette.getAccent900("light"),
        addMembersButtonTextFont: w(t.value.typography.subtitle1),
        padding: "0 100px"
      });
      d.value = { ...se, ...d.value }, m.background = d.value.addMembersButtonBackground, m.buttonTextFont = d.value.addMembersButtonTextFont, m.buttonTextColor = d.value.addMembersButtonTextColor;
    }
    function O() {
      let se = new _t({
        height: "45px",
        width: "100%",
        background: t.value.palette.getBackground(),
        activeBackground: "",
        borderRadius: "0",
        titleFont: w(t.value.typography.title2),
        titleColor: t.value.palette.getAccent(),
        border: "none",
        separatorColor: t.value.palette.getAccent200(),
        hoverBackground: ""
      });
      N.value = { ...se, ...N.value };
    }
    function x() {
      var X, B, F, G, J, ee, V, ne, K, Ie, Te, H, Ee, L, b, v, U, Se, Ue;
      s = { ...new Ci({
        width: "100%",
        height: "100%",
        border: "none",
        borderRadius: "0",
        background: "inherit",
        titleTextFont: ((X = e.addMembersStyle) == null ? void 0 : X.titleTextFont) || w(t.value.typography.title1),
        titleTextColor: ((B = e.addMembersStyle) == null ? void 0 : B.titleTextColor) || t.value.palette.getAccent(),
        emptyStateTextFont: ((F = e.addMembersStyle) == null ? void 0 : F.emptyStateTextFont) || w(t.value.typography.title1),
        emptyStateTextColor: ((G = e.addMembersStyle) == null ? void 0 : G.emptyStateTextColor) || t.value.palette.getAccent600(),
        errorStateTextFont: ((J = e.addMembersStyle) == null ? void 0 : J.errorStateTextFont) || w(t.value.typography.title1),
        errorStateTextColor: ((ee = e.addMembersStyle) == null ? void 0 : ee.errorStateTextColor) || t.value.palette.getAccent600(),
        loadingIconTint: ((V = e.addMembersStyle) == null ? void 0 : V.loadingIconTint) || t.value.palette.getAccent600(),
        separatorColor: ((ne = e.addMembersStyle) == null ? void 0 : ne.separatorColor) || t.value.palette.getAccent400(),
        onlineStatusColor: ((K = e.addMembersStyle) == null ? void 0 : K.onlineStatusColor) || t.value.palette.getSuccess(),
        sectionHeaderTextColor: ((Ie = e.addMembersStyle) == null ? void 0 : Ie.sectionHeaderTextColor) || t.value.palette.getAccent600(),
        sectionHeaderTextFont: ((Te = e.addMembersStyle) == null ? void 0 : Te.sectionHeaderTextFont) || w(t.value.typography.subtitle2),
        searchIconTint: ((H = e.addMembersStyle) == null ? void 0 : H.searchIconTint) || t.value.palette.getAccent600(),
        searchPlaceholderTextColor: ((Ee = e.addMembersStyle) == null ? void 0 : Ee.searchPlaceholderTextColor) || t.value.palette.getAccent600(),
        searchBackground: ((L = e.addMembersStyle) == null ? void 0 : L.searchBackground) || t.value.palette.getAccent100(),
        searchPlaceholderTextFont: ((b = e.addMembersStyle) == null ? void 0 : b.searchPlaceholderTextFont) || w(t.value.typography.text3),
        searchTextColor: ((v = e.addMembersStyle) == null ? void 0 : v.searchTextColor) || t.value.palette.getAccent600(),
        searchTextFont: ((U = e.addMembersStyle) == null ? void 0 : U.searchTextFont) || w(t.value.typography.text3),
        searchBorder: ((Se = e.addMembersStyle) == null ? void 0 : Se.searchBorder) || `1px solid ${t.value.palette.getAccent100()}`,
        searchBorderRadius: ((Ue = e.addMembersStyle) == null ? void 0 : Ue.searchBorderRadius) || "8px"
      }), ...s };
    }
    const _ = () => ({
      height: "24px",
      width: "24px",
      borderRadius: "0",
      border: "none",
      background: "transparent",
      buttonIconTint: e.addMembersStyle.backButtonIconTint || t.value.palette.getPrimary()
    }), oe = () => ({
      height: "24px",
      width: "24px",
      border: "none",
      borderRadius: "0",
      background: "transparent",
      buttonIconTint: e.addMembersStyle.closeButtonIconTint || t.value.palette.getPrimary()
    }), ie = () => ({
      height: d.value.height || "100%",
      width: d.value.width || "100%",
      border: d.value.border || `1px solid ${t.value.palette.getAccent100()}`,
      borderRadius: d.value.borderRadius || "0",
      background: d.value.background || t.value.palette.getBackground(),
      display: "flex",
      position: "relative"
    });
    function re() {
      let se = {
        height: "12px",
        width: "12px",
        border: "none",
        borderRadius: "24px"
      };
      T.value = {
        ...se,
        ...T.value
      };
    }
    return {
      backClicked: D,
      closeClicked: A,
      backButtonStyle: _,
      closeButtonStyle: oe,
      usersStyle: s,
      isDisabled: u,
      ConversationUtils: zo,
      GroupMemberUtils: Qo,
      SelectionMode: xt,
      mylistItemStyle: N,
      myavatarStyle: c,
      mystatusIndicatorStyle: T,
      addMembersStyles: () => ({
        height: d.value.height || "100%",
        width: d.value.width || "100%",
        padding: d.value.padding,
        position: "relative"
      }),
      addMemberButtonStyle: m,
      addMembersToGroup: R,
      addRemoveUsers: k,
      myaddMembersStyle: d,
      wrapperStyle: ie
    };
  }
});
const Mu = { class: "cc-users" }, uu = { class: "cc-add-members__buttons" }, gu = ["text", "buttonStyle", "disabled"], cu = { class: "cc-add-members__back-button" }, du = ["iconURL", "buttonStyle"], Iu = { class: "cc-add-members__close-button" }, Nu = ["iconURL", "buttonStyle"];
function Tu(e, t, n, o, i, l) {
  const r = Je("CometChatUsers");
  return M(), g("div", {
    class: "cc-add-members",
    style: ce(e.wrapperStyle())
  }, [
    p("div", {
      class: "cc-add-members__wrapper",
      style: ce(e.addMembersStyles())
    }, [
      p("div", Mu, [
        Nt(r, {
          searchPlaceholder: e.searchPlaceholder,
          usersRequestBuilder: e.usersRequestBuilder,
          hideSearch: e.hideSearch,
          searchIconURL: e.searchIconURL,
          searchRequestBuilder: e.searchRequestBuilder,
          subtitleView: e.subtitleView,
          options: e.options,
          emptyStateView: e.emptyStateView,
          onSelect: e.addRemoveUsers,
          loadingIconURL: e.loadingIconURL,
          errorStateView: e.errorStateView,
          loadingStateView: e.loadingStateView,
          titleAlignment: e.titleAlignment,
          showSectionHeader: e.showSectionHeader,
          menus: e.menus,
          hideSeparator: e.hideSeparator,
          hideError: e.hideError,
          selectionMode: e.selectionMode,
          title: e.title,
          usersStyle: e.usersStyle,
          listItemView: e.listItemView,
          avatarStyle: e.avatarStyle,
          statusIndicatorStyle: e.mystatusIndicatorStyle,
          listItemStyle: e.mylistItemStyle,
          onError: e.onError,
          emptyStateText: e.emptyStateText,
          errorStateText: e.errorStateText,
          disableUsersPresence: e.disableUsersPresence,
          sectionHeaderKey: e.sectionHeaderField
        }, null, 8, ["searchPlaceholder", "usersRequestBuilder", "hideSearch", "searchIconURL", "searchRequestBuilder", "subtitleView", "options", "emptyStateView", "onSelect", "loadingIconURL", "errorStateView", "loadingStateView", "titleAlignment", "showSectionHeader", "menus", "hideSeparator", "hideError", "selectionMode", "title", "usersStyle", "listItemView", "avatarStyle", "statusIndicatorStyle", "listItemStyle", "onError", "emptyStateText", "errorStateText", "disableUsersPresence", "sectionHeaderKey"])
      ]),
      p("div", uu, [
        p("cometchat-button", {
          class: "cc-add-members__buttons-add",
          text: e.buttonText,
          buttonStyle: e.addMemberButtonStyle,
          disabled: e.isDisabled,
          onClick: t[0] || (t[0] = (u) => e.addMembersToGroup())
        }, null, 8, gu)
      ])
    ], 4),
    p("div", cu, [
      e.showBackButton ? (M(), g("cometchat-button", {
        key: 0,
        iconURL: e.backButtonIconURL,
        buttonStyle: e.backButtonStyle(),
        onCcButtonClicked: t[1] || (t[1] = (u) => e.backClicked())
      }, null, 40, du)) : $("", !0)
    ]),
    p("div", Iu, [
      p("cometchat-button", {
        iconURL: e.closeButtonIconURL,
        buttonStyle: e.closeButtonStyle(),
        onCcButtonClicked: t[2] || (t[2] = (u) => e.closeClicked())
      }, null, 40, Nu)
    ])
  ], 4);
}
const Du = /* @__PURE__ */ $e(su, [["render", Tu], ["__scopeId", "data-v-0d5d72e4"]]), yu = We({
  components: {
    CometChatList: hn
  },
  props: {
    title: {
      type: String,
      default: () => Y("BANNED_MEMBERS")
    },
    titleAlignment: {
      type: Number,
      default: () => kn.center
    },
    searchPlaceholder: {
      type: String,
      default: () => Y("SEARCH")
    },
    subtitleView: {
      type: Function
    },
    listItemView: {
      type: Function
    },
    menus: {
      type: Object
    },
    options: {
      type: Function
    },
    bannedMembersRequestBuilder: {
      type: Object
    },
    searchRequestBuilder: {
      type: Object
    },
    disableUsersPresence: {
      type: Boolean,
      default: !1
    },
    group: {
      type: Object,
      required: !0
    },
    hideSeparator: {
      type: Boolean,
      default: !1
    },
    showBackButton: {
      type: Boolean,
      default: !0
    },
    selectionMode: {
      type: Number,
      default: () => xt.none
    },
    onSelect: {
      type: Function
    },
    searchIconURL: {
      type: String,
      default: Yn
    },
    backButtonIconURL: {
      type: String,
      default: fn
    },
    closeButtonIconURL: {
      type: String,
      default: Cn
    },
    unbanIconURL: {
      type: String,
      default: Cn
    },
    hideSearch: {
      type: Boolean,
      default: !1
    },
    hideError: {
      type: Boolean,
      default: !1
    },
    showSectionHeader: {
      type: Boolean,
      default: !1
    },
    emptyStateView: {
      type: Object
    },
    errorStateText: {
      type: String,
      default: () => Y("SOMETHING_WRONG")
    },
    emptyStateText: {
      type: String,
      default: () => Y("NO_BANNED_MEMBERS_FOUND")
    },
    onItemClick: {
      type: Function
    },
    onError: {
      type: Function,
      default: (e) => console.log(e)
    },
    onBack: {
      type: Function
    },
    onClose: {
      type: Function
    },
    avatarStyle: {
      type: Object,
      default: () => ({})
    },
    bannedMembersStyle: {
      type: Object,
      default: () => ({})
    },
    statusIndicatorStyle: {
      type: null
    },
    listItemStyle: {
      type: Object,
      default: () => ({})
    },
    loadingIconURL: {
      type: String,
      default: nn
    },
    loadingStateView: {
      type: Object
    },
    errorStateView: {
      type: Object
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    });
    const n = j([]), o = j(
      "bannedMembers_" + (/* @__PURE__ */ new Date()).getTime()
    ), i = j(
      "BannedMembers_UserListener_" + (/* @__PURE__ */ new Date()).getTime()
    ), l = j(
      "BannedMembers_GroupListener_" + (/* @__PURE__ */ new Date()).getTime()
    ), r = j(null), u = j(ge.loading);
    let s = j([]);
    const c = j(30), d = j("");
    let N = j(e.avatarStyle), T = j(e.bannedMembersStyle), m = j(e.listItemStyle), A = j(e.statusIndicatorStyle), D = j({});
    const z = j(), k = j();
    let R = j({
      width: "",
      height: "",
      border: "none",
      borderRadius: "8px",
      background: "white",
      textFont: "400 15px Inter",
      textColor: "black",
      iconTint: "rgb(51, 153, 255)",
      iconBackground: "transparent",
      iconBorder: "none",
      iconBorderRadius: "0",
      submenuWidth: "100%",
      submenuHeight: "100%",
      submenuBorder: "1px solid #e8e8e8",
      submenuBorderRadius: "8px",
      submenuBackground: "white"
    }), Q = {
      border: "none",
      background: "transparent",
      buttonIconTint: e.bannedMembersStyle.unbanIconTint || t.value.palette.getPrimary()
    };
    function h() {
      e.onClose && e.onClose();
    }
    function O() {
      e.onBack && e.onBack();
    }
    const x = (v) => new co().getUserStatusVisibility(v) || e.disableUsersPresence ? null : e.bannedMembersStyle.onlineStatusColor ?? t.value.palette.getSuccess(), _ = (v) => {
      y.unbanGroupMember(e.group.getGuid(), v.getUid()).then(() => {
        oe(v);
      }).catch((U) => {
        e.onError && e.onError(U);
      });
    }, oe = (v) => {
      let U = [...n.value], Se = U.findIndex(
        (Ue, Re) => Ue.getUid() == v.getUid()
      );
      Se > -1 ? (U.splice(Se, 1), n.value = [...U]) : (U.push(v), n.value = [...U]);
    };
    function ie() {
      y.addUserListener(
        i.value,
        new y.UserListener({
          onUserOnline: (U) => {
            v(U);
          },
          onUserOffline: (U) => {
            v(U);
          }
        })
      );
      const v = (U) => {
        let Se = [...n.value], Ue = Se.findIndex(
          (Re, _e) => Re.getUid() == U.getUid()
        );
        if (Ue > -1) {
          let Re = Se[Ue];
          Re.setStatus(U.getStatus()), Se.splice(Ue, 1, Re), n.value = [...Se];
        }
      };
      y.addGroupListener(
        l.value,
        new y.GroupListener({
          onGroupMemberBanned: (U, Se, Ue, Re) => {
            e.group.getGuid() === Re.getGuid() && oe(Se);
          },
          onGroupMemberUnbanned: (U, Se, Ue, Re) => {
            e.group.getGuid() === Re.getGuid() && oe(Se);
          }
        })
      );
    }
    function re() {
      y.removeUserListener(i.value), y.removeGroupListener(l.value), o.value = "";
    }
    function Ae() {
      let v = null;
      const U = "abort";
      return function(Se) {
        return new Promise(
          (Ue, Re) => {
            v == null || v.abort(), v = new AbortController();
            const _e = v;
            let Z = !1;
            const ke = function q(ye) {
              _e.signal.removeEventListener(U, q), Z = !0, Re(ye);
            };
            _e.signal.addEventListener(
              U,
              ke
            ), Se.fetchNext().finally(() => {
              Z || _e.signal.removeEventListener(
                U,
                ke
              );
            }).then((q) => {
              Ue(q);
            }).catch(Re);
          }
        );
      };
    }
    const se = Ae(), X = async () => {
      if (r.value) {
        u.value = ge.loading;
        try {
          const v = await se(
            r.value
          );
          v.length === 0 && n.value.length === 0 ? u.value = ge.empty : (n.value = [
            ...v,
            ...n.value
          ], u.value = ge.loaded);
        } catch (v) {
          e.onError && e.onError(v), u.value = ge.error;
        }
      } else
        u.value = ge.loaded;
    }, B = Ht(() => {
      if (d.value.length == 0) {
        if (e.bannedMembersRequestBuilder)
          return e.bannedMembersRequestBuilder.build();
      } else if (d.value.length > 0)
        return e.searchRequestBuilder ? e.searchRequestBuilder.setSearchKeyword(d.value).build() : e.bannedMembersRequestBuilder ? e.bannedMembersRequestBuilder.setSearchKeyword(d.value).build() : new y.BannedMembersRequestBuilder(
          e.group.getGuid()
        ).setSearchKeyword(d.value).setLimit(c.value).build();
      return new y.BannedMembersRequestBuilder(e.group.getGuid()).setLimit(c.value).build();
    });
    function F() {
      z.value = He.ccGroupMemberBanned.subscribe((v) => {
        (v == null ? void 0 : v.bannedFrom.getGuid()) == e.group.getGuid() && oe(v == null ? void 0 : v.bannedUser);
      }), k.value = He.ccGroupMemberUnbanned.subscribe((v) => {
        (v == null ? void 0 : v.kickedFrom.getGuid()) == e.group.getGuid() && oe(v == null ? void 0 : v.kickedUser);
      });
    }
    function G() {
      var v, U;
      (v = k.value) == null || v.unsubscribe(), (U = z.value) == null || U.unsubscribe();
    }
    un(() => {
      try {
        re(), G();
      } catch (v) {
        e.onError && e.onError(v);
      }
    }), tn(async () => {
      ie(), F(), V(), r.value = B.value, X();
    });
    const J = (v) => {
      d.value = v, r.value = B.value, n.value = [], u.value = ge.loading, X();
    };
    function ee(v, U) {
      var Ue;
      const Se = (Ue = v.detail) == null ? void 0 : Ue.checked;
      e.onSelect && e.onSelect(U, Se);
    }
    function V() {
      ne(), K(), Ie(), Te(), R.value = new Si({
        border: "none",
        borderRadius: "8px",
        background: "transparent",
        submenuWidth: "100%",
        submenuHeight: "100%",
        submenuBorder: `1px solid ${t.value.palette.getAccent200()}`,
        submenuBorderRadius: "8px"
      });
    }
    function ne() {
      let v = new Qr({
        background: t.value.palette.getBackground(),
        border: `1px solid ${t.value.palette.getAccent50()}`,
        titleTextFont: w(t.value.typography.title1),
        titleTextColor: t.value.palette.getAccent(),
        emptyStateTextFont: w(t.value.typography.title1),
        emptyStateTextColor: t.value.palette.getAccent600(),
        errorStateTextFont: w(t.value.typography.title1),
        errorStateTextColor: t.value.palette.getAccent600(),
        loadingIconTint: t.value.palette.getAccent600(),
        onlineStatusColor: t.value.palette.getSuccess(),
        separatorColor: t.value.palette.getAccent400(),
        width: "100%",
        height: "100%",
        borderRadius: "none",
        searchIconTint: t.value.palette.getAccent600(),
        searchPlaceholderTextColor: t.value.palette.getAccent600(),
        searchBackground: t.value.palette.getAccent100(),
        searchPlaceholderTextFont: w(t.value.typography.text3),
        searchTextColor: t.value.palette.getAccent600(),
        searchTextFont: w(t.value.typography.text3),
        searchBorderRadius: "8px",
        closeButtonIconTint: t.value.palette.getPrimary(),
        backButtonIconTint: t.value.palette.getPrimary(),
        padding: "0",
        unbanIconTint: t.value.palette.getPrimary()
      });
      T.value = {
        ...v,
        ...T.value
      }, D.value = {
        height: "100%",
        titleTextFont: T.value.titleTextFont || w(t.value.typography.title1),
        titleTextColor: T.value.titleTextColor || t.value.palette.getAccent(),
        emptyStateTextFont: T.value.emptyStateTextFont,
        emptyStateTextColor: T.value.emptyStateTextColor,
        errorStateTextFont: T.value.errorStateTextFont,
        errorStateTextColor: T.value.errorStateTextColor,
        loadingIconTint: T.value.loadingIconTint,
        separatorColor: T.value.separatorColor,
        searchIconTint: T.value.searchIconTint,
        searchBorder: T.value.searchBorder,
        searchBorderRadius: T.value.searchBorderRadius,
        searchBackground: T.value.searchBackground,
        searchPlaceholderTextFont: T.value.searchPlaceholderTextFont,
        searchPlaceholderTextColor: T.value.searchPlaceholderTextColor,
        searchTextFont: T.value.searchTextFont,
        searchTextColor: T.value.searchTextColor,
        background: T.value.background
      };
    }
    function K() {
      let v = new _t({
        height: "45px",
        width: "100%",
        background: t.value.palette.getBackground(),
        activeBackground: "",
        borderRadius: "0",
        titleFont: w(t.value.typography.title2),
        titleColor: t.value.palette.getAccent(),
        border: "none",
        separatorColor: t.value.palette.getAccent200(),
        hoverBackground: ""
      });
      m.value = { ...v, ...m.value };
    }
    function Ie() {
      let v = new Kt({
        borderRadius: "24px",
        width: "28px",
        height: "28px",
        border: "none",
        backgroundColor: t.value.palette.getAccent700(),
        nameTextColor: t.value.palette.getAccent900(),
        backgroundSize: "cover",
        nameTextFont: w(t.value.typography.subtitle1),
        outerViewBorderWidth: "",
        outerViewBorderSpacing: ""
      });
      N.value = { ...v, ...N.value };
    }
    function Te() {
      let v = {
        height: "12px",
        width: "12px",
        border: "none",
        borderRadius: "24px"
      };
      A.value = {
        ...v,
        ...A.value
      };
    }
    return {
      BannedMembers: n,
      wrapperStyle: () => {
        var v;
        return {
          height: e.bannedMembersStyle.height || "100%",
          width: e.bannedMembersStyle.width || "100%",
          background: e.bannedMembersStyle.background || t.value.palette.getBackground(),
          border: e.bannedMembersStyle.border,
          borderRadius: e.bannedMembersStyle.borderRadius || "0",
          display: "flex",
          boxShadow: ((v = e.bannedMembersStyle) == null ? void 0 : v.boxShadow) || "",
          position: "relative"
        };
      },
      membersStyle: () => ({
        height: T.value.height || "100%",
        width: T.value.width || "100%",
        background: T.value.background,
        padding: T.value.padding,
        border: T.value.border,
        borderRadius: T.value.borderRadius || "0",
        boxShadow: T.value.boxShadow || "",
        display: "flex",
        position: "relative"
      }),
      ConversationUtils: zo,
      GroupMemberUtils: Qo,
      closeButtonStyle: () => ({
        height: "24px",
        width: "24px",
        border: "none",
        borderRadius: "0",
        background: "transparent",
        position: "relative",
        buttonIconTint: e.bannedMembersStyle.closeButtonIconTint || t.value.palette.getPrimary()
      }),
      closeClicked: h,
      backClicked: O,
      memberScope: s,
      SelectionMode: xt,
      backButtonStyle: () => ({
        height: "24px",
        width: "24px",
        border: "none",
        borderRadius: "0",
        background: "transparent",
        position: "relative",
        buttonIconTint: e.bannedMembersStyle.backButtonIconTint || t.value.palette.getPrimary()
      }),
      mylistItemStyle: m,
      myavatarStyle: N,
      menuListStyle: R,
      mystatusIndicatorStyle: A,
      getStatusIndicatorColor: x,
      unbanIconStyle: Q,
      onSearch: J,
      state: u,
      unBanMember: _,
      States: ge,
      listStyle: D,
      searchKeyword: d,
      fetchNextBannedMembers: X,
      handleSelection: ee
    };
  }
});
const Cu = { class: "cc-banned-members__back" }, wu = ["iconURL", "buttonStyle"], ju = {
  key: 0,
  class: "cc-banned-members__menus"
}, Au = ["innerHTML"], Lu = ["v-slot", "innerHTML"], zu = { key: 0 }, Su = ["innerHTML"], pu = ["v-slot", "innerHTML"], bu = ["title", "avatarURL", "avatarName", "hideSeparator", "listItemStyle", "avatarStyle", "statusIndicatorStyle", "statusIndicatorColor"], Eu = {
  key: 0,
  slot: "subtitleView",
  class: "cc-banned-members__subtitle-view"
}, hu = ["innerHTML"], vu = ["v-slot", "innerHTML"], mu = {
  key: 1,
  slot: "menuView",
  class: "cc-banned-members__options"
}, Ou = ["menuListStyle", "data"], xu = {
  key: 2,
  slot: "tailView",
  class: "cc-banned-members__tail-view"
}, ku = {
  key: 0,
  class: "cc-banned-members__selection-single"
}, fu = ["onCcRadioButtonChanged"], Uu = {
  key: 1,
  class: "cc-banned-members__selection-multiple"
}, Bu = ["onCcCheckboxChanged"], Qu = {
  key: 3,
  slot: "tailView"
}, Ru = { class: "cc-banned-members__unban" }, Yu = ["buttonStyle", "iconURL", "onClick"], Vu = { class: "cc-banned-members__close-button" }, Gu = ["iconURL", "buttonStyle"];
function Pu(e, t, n, o, i, l) {
  var u;
  const r = Je("CometChatList");
  return M(), g("div", {
    class: "cc-banned-members__wrapper",
    style: ce(e.membersStyle())
  }, [
    p("div", Cu, [
      e.showBackButton ? (M(), g("cometchat-button", {
        key: 0,
        iconURL: e.backButtonIconURL,
        buttonStyle: e.backButtonStyle(),
        onCcButtonClicked: t[0] || (t[0] = (s) => e.backClicked())
      }, null, 40, wu)) : $("", !0)
    ]),
    e.menus ? (M(), g("div", ju, [
      e.menus.html ? (M(), g("div", {
        key: 0,
        innerHTML: e.menus.html
      }, null, 8, Au)) : (M(), je(fe(e.menus.componentName), me({ key: 1 }, xe((u = e.menus) == null ? void 0 : u.listeners), { ...e.menus.props }), {
        default: be(() => [
          (M(!0), g(we, null, pe(e.menus.slots, (s, c) => (M(), g("div", {
            key: c,
            "v-slot": [c],
            innerHTML: s
          }, null, 8, Lu))), 128))
        ]),
        _: 1
      }, 16))
    ])) : $("", !0),
    Nt(r, {
      title: e.title,
      titleAlignment: e.titleAlignment,
      hideSearch: e.hideSearch,
      searchIconURL: e.searchIconURL,
      searchPlaceholderText: e.searchPlaceholder,
      list: e.BannedMembers,
      onSearch: e.onSearch,
      showSectionHeader: e.showSectionHeader,
      state: e.state,
      loadingIconURL: e.loadingIconURL,
      hideError: e.hideError,
      errorStateText: e.errorStateText,
      emptyStateText: e.emptyStateText,
      scrollToBottom: !1,
      onScrolledToBottom: e.fetchNextBannedMembers,
      listItemKey: "getUid",
      searchText: e.searchKeyword,
      loadingStateView: e.loadingStateView,
      errorStateView: e.errorStateView,
      emptyStateView: e.emptyStateView,
      listStyle: e.listStyle,
      onError: e.onError
    }, {
      listItem: be(({ item: s }) => {
        var c, d, N, T, m, A, D, z, k;
        return [
          e.listItemView ? (M(), g("div", zu, [
            (c = e.listItemView(s)) != null && c.html ? (M(), g("div", {
              key: 0,
              innerHTML: (d = e.listItemView(s)) == null ? void 0 : d.html
            }, null, 8, Su)) : (M(), je(fe((N = e.listItemView(s)) == null ? void 0 : N.componentName), aa(me({ key: 1 }, { ...(T = e.listItemView(s)) == null ? void 0 : T.props })), {
              default: be(() => {
                var R;
                return [
                  (M(!0), g(we, null, pe((R = e.listItemView(s)) == null ? void 0 : R.slots, (Q, h) => (M(), g("div", {
                    key: h,
                    "v-slot": [h],
                    innerHTML: Q
                  }, null, 8, pu))), 128))
                ];
              }),
              _: 2
            }, 1040))
          ])) : (M(), g("cometchat-list-item", {
            key: 1,
            title: s.name,
            avatarURL: s == null ? void 0 : s.avatar,
            avatarName: s == null ? void 0 : s.name,
            hideSeparator: e.hideSeparator,
            listItemStyle: e.mylistItemStyle,
            avatarStyle: e.myavatarStyle,
            statusIndicatorStyle: e.mystatusIndicatorStyle,
            statusIndicatorColor: e.getStatusIndicatorColor(s)
          }, [
            e.subtitleView ? (M(), g("div", Eu, [
              (m = e.subtitleView(s)) != null && m.html ? (M(), g("div", {
                key: 0,
                innerHTML: (A = e.subtitleView(s)) == null ? void 0 : A.html
              }, null, 8, hu)) : (M(), je(fe((D = e.subtitleView(s)) == null ? void 0 : D.componentName), aa(me({ key: 1 }, { ...(z = e.subtitleView(s)) == null ? void 0 : z.props })), {
                default: be(() => {
                  var R;
                  return [
                    (M(!0), g(we, null, pe((R = e.subtitleView(s)) == null ? void 0 : R.slots, (Q, h) => (M(), g("div", {
                      key: h,
                      "v-slot": [h],
                      innerHTML: Q
                    }, null, 8, vu))), 128))
                  ];
                }),
                _: 2
              }, 1040))
            ])) : $("", !0),
            e.options ? (M(), g("div", mu, [
              p("cometchat-menu-list", {
                menuListStyle: e.menuListStyle,
                data: (k = e.options) == null ? void 0 : k.call(e, s)
              }, null, 8, Ou)
            ])) : $("", !0),
            e.selectionMode !== e.SelectionMode.none ? (M(), g("div", xu, [
              e.selectionMode == e.SelectionMode.single ? (M(), g("div", ku, [
                p("cometchat-radio-button", {
                  onCcRadioButtonChanged: (R) => {
                    e.handleSelection(R, s);
                  }
                }, null, 40, fu)
              ])) : $("", !0),
              e.selectionMode == e.SelectionMode.multiple ? (M(), g("div", Uu, [
                p("cometchat-checkbox", {
                  onCcCheckboxChanged: (R) => {
                    e.handleSelection(R, s);
                  }
                }, null, 40, Bu)
              ])) : $("", !0)
            ])) : (M(), g("div", Qu, [
              p("div", Ru, [
                p("cometchat-button", {
                  buttonStyle: e.unbanIconStyle,
                  iconURL: e.unbanIconURL,
                  onClick: (R) => e.unBanMember(s)
                }, null, 8, Yu)
              ])
            ]))
          ], 8, bu))
        ];
      }),
      _: 1
    }, 8, ["title", "titleAlignment", "hideSearch", "searchIconURL", "searchPlaceholderText", "list", "onSearch", "showSectionHeader", "state", "loadingIconURL", "hideError", "errorStateText", "emptyStateText", "onScrolledToBottom", "searchText", "loadingStateView", "errorStateView", "emptyStateView", "listStyle", "onError"]),
    p("div", Vu, [
      p("cometchat-button", {
        iconURL: e.closeButtonIconURL,
        buttonStyle: e.closeButtonStyle(),
        onCcButtonClicked: t[1] || (t[1] = (s) => e.closeClicked())
      }, null, 40, Gu)
    ])
  ], 4);
}
const Fu = /* @__PURE__ */ $e(yu, [["render", Pu], ["__scopeId", "data-v-ba082f02"]]), Hu = We({
  components: {
    CometChatList: hn
  },
  props: {
    title: {
      type: String,
      default: () => Y("CHATS")
    },
    titleAlignment: {
      type: Number,
      default: () => kn.left
    },
    confirmDialogTitle: {
      type: String,
      default: () => Y("DELETE_CONVERSATION")
    },
    confirmDialogMessage: {
      type: String,
      default: () => Y("WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION")
    },
    cancelButtonText: {
      type: String,
      default: () => Y("CANCEL")
    },
    confirmButtonText: {
      type: String,
      default: () => Y("DELETE")
    },
    subtitleView: {
      type: Function
    },
    listItemView: {
      type: Function
    },
    menu: {
      type: Object
    },
    options: {
      type: Function
    },
    datePattern: {
      type: Number,
      default: () => yn.DayDateTime
    },
    conversationsRequestBuilder: {
      type: y.ConversationsRequestBuilder
    },
    activeConversation: {
      type: y.Conversation
    },
    disableUsersPresence: {
      type: Boolean,
      default: !1
    },
    disableSoundForMessages: {
      type: Boolean,
      default: !1
    },
    customSoundForMessages: {
      type: String,
      default: ""
    },
    /**
     * @deprecated
     * 
     * This property is deprecated as of version 4.3.16 due to newer property 'hideReceipt'. It will be removed in subsequent versions.
     */
    disableReceipt: {
      type: Boolean,
      default: !1
    },
    hideReceipt: {
      type: Boolean,
      default: !1
    },
    disableTyping: {
      type: Boolean,
      default: !1
    },
    hideSeparator: {
      type: Boolean,
      default: !1
    },
    selectionMode: {
      type: Number,
      default: () => xt.none
    },
    onSelect: {
      type: Function
    },
    deliveredIcon: {
      type: String,
      default: Ei
    },
    readIcon: {
      type: String,
      default: mi
    },
    waitIcon: {
      type: String,
      default: Xa
    },
    sentIcon: {
      type: String,
      default: Za
    },
    errorIcon: {
      type: String,
      default: Oi
    },
    protectedGroupIcon: {
      type: String,
      default: Yo
    },
    privateGroupIcon: {
      type: String,
      default: Vo
    },
    hideError: {
      type: Boolean,
      default: !1
    },
    emptyStateView: {
      type: Object
    },
    errorStateText: {
      type: String,
      default: () => Y("SOMETHING_WRONG")
    },
    emptyStateText: {
      type: String,
      default: () => Y("NO_CHATS_FOUND")
    },
    onItemClick: {
      type: Function
    },
    onError: {
      type: Function,
      default: (e) => console.log(e)
    },
    avatarStyle: {
      type: Object
    },
    receiptStyle: {
      type: Object,
      default: () => ({})
    },
    badgeStyle: {
      type: Object
    },
    deleteConversationDialogStyle: {
      type: Object
    },
    listItemStyle: {
      type: Object
    },
    dateStyle: {
      type: Object
    },
    statusIndicatorStyle: {
      type: null
    },
    conversationsStyle: {
      type: Object,
      default: () => ({})
    },
    loadingIconURL: {
      type: String,
      default: nn
    },
    loadingStateView: {
      type: Object
    },
    errorStateView: {
      type: Object
    },
    backdropStyle: {
      type: Object,
      default: () => ({})
    },
    disableMentions: {
      type: Boolean,
      default: !1
    },
    textFormatters: {
      type: Array,
      default: () => []
    }
    //To be added in UMC
    // mentionsIconUrl: {
    //   type: String,
    //   default: mentions,
    // },
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    });
    const n = j([]), o = j(null), i = j(
      /* @__PURE__ */ new Map()
    );
    j(
      "conversation__LISTENER" + (/* @__PURE__ */ new Date()).getTime()
    );
    const l = j(ge.loading), r = j(!1);
    let u = null, s = j(), c, d = 30, N = Y("IN_A_THREAD"), T = j(e.avatarStyle), m = j(e.badgeStyle), A = j(
      e.deleteConversationDialogStyle
    ), D = j(e.activeConversation), z, k = j({}), R = j(e.listItemStyle), Q = j(e.conversationsStyle), h = j(e.dateStyle), O = j(e.statusIndicatorStyle), x = j(e.options);
    const _ = j("chatlist_user_" + (/* @__PURE__ */ new Date()).getTime()), oe = j(
      "connection_" + (/* @__PURE__ */ new Date()).getTime()
    ), ie = j(
      "chatlist_group_" + (/* @__PURE__ */ new Date()).getTime()
    ), re = j();
    j();
    const Ae = j(), se = j();
    j();
    const X = j(), B = j(), F = j(), G = j(), J = j(), ee = j(), V = j(), ne = j(), K = j(), Ie = j(), Te = j(!1);
    let H, Ee, L, b, v, U, Se, Ue, Re, _e, Z, ke, q, ye, Oe;
    const he = j({
      online: "",
      private: "",
      password: "",
      public: ""
    }), Pe = j({
      iconTint: "lightgrey",
      height: "12px",
      width: "12px"
    });
    let lt = j({
      width: "",
      height: "",
      border: "none",
      borderRadius: "8px",
      background: "transparent",
      textFont: "",
      textColor: "black",
      iconTint: "grey",
      iconBackground: "transparent",
      iconBorder: "none",
      iconBorderRadius: "0",
      submenuWidth: "70px",
      submenuHeight: "20px",
      submenuBorder: "1px solid #e8e8e8",
      submenuBorderRadius: "8px",
      submenuBackground: "white"
    });
    function It(S) {
      return S instanceof y.TextMessage || S instanceof y.MediaMessage || S instanceof y.CustomMessage || S instanceof y.InteractiveMessage || S instanceof y.Action || S instanceof y.Call;
    }
    const Gt = () => {
      Xt();
    }, de = () => {
      et();
    }, Le = (S) => O.value;
    async function Fe() {
      try {
        return s.value && s.value.pagination && (s.value.pagination.current_page == 0 || s.value.pagination.current_page != s.value.pagination.total_pages) ? s.value.fetchNext() : [];
      } catch (S) {
        return e.onError && e.onError(S), [];
      }
    }
    function tt(S) {
      n.value.findIndex(
        (P) => P.getLastMessage() && P.getLastMessage().getId() == (S == null ? void 0 : S.getId())
      ) >= 0 && ln(S);
    }
    function st(S) {
      let f = n.value.findIndex(
        (P) => P.getConversationType() == I.MessageReceiverType.user && P.getConversationWith().getUid() == S.getUid()
      );
      return f >= 0 ? n.value[f] : null;
    }
    function ct(S) {
      let f = n.value.findIndex(
        (P) => P.getConversationType() == I.MessageReceiverType.group && P.getConversationWith().getGuid() == S.getGuid()
      );
      return f >= 0 ? n.value[f] : null;
    }
    function wt() {
      se.value = He.ccGroupMemberScopeChanged.subscribe(
        (S) => {
          let f = ct(S.group);
          f && (f.setLastMessage(S.message), en(f));
        }
      ), re.value = He.ccGroupMemberAdded.subscribe(
        (S) => {
          let f = S.userAddedIn, P = S.messages, Me = ct(S.userAddedIn);
          Me && (Me == null || Me.setConversationWith(f), Me == null || Me.setLastMessage(
            P[(P == null ? void 0 : P.length) - 1]
          ), en(Me));
        }
      ), Ae.value = He.ccGroupMemberKicked.subscribe(
        (S) => {
          let f = ct(S.kickedFrom);
          if (f) {
            const P = Ce.clone(f);
            P.setConversationWith(S.kickedFrom), P.setLastMessage(S.message), en(P);
          }
        }
      ), Ie.value = He.ccGroupMemberBanned.subscribe(
        (S) => {
          let f = ct(S.kickedFrom);
          if (f) {
            const P = Ce.clone(f);
            P.setConversationWith(S.kickedFrom), P.setLastMessage(S.message), en(P);
          }
        }
      ), J.value = He.ccGroupDeleted.subscribe(
        (S) => {
          let f = ct(S);
          f && at(f);
        }
      ), ee.value = He.ccGroupLeft.subscribe(
        (S) => {
          let f = ct(S.leftGroup);
          for (let P = 0; P < n.value.length; P++)
            (f == null ? void 0 : f.getConversationId()) == n.value[P].getConversationId() && n.value.splice(P, 1);
        }
      ), ne.value = En.ccUserBlocked.subscribe(
        (S) => {
          var P;
          let f = st(S);
          f && !((P = s == null ? void 0 : s.value) != null && P.isIncludeBlockedUsers()) && at(f);
        }
      ), K.value = En.ccUserUnblocked.subscribe(
        (S) => {
          var P;
          st(S) && !((P = s == null ? void 0 : s.value) != null && P.isIncludeBlockedUsers()) && Pt(S);
        }
      ), X.value = ae.ccMessageEdited.subscribe(
        (S) => {
          let f = S.message;
          S.status == Xe.success && tt(f);
        }
      ), B.value = ae.ccMessageSent.subscribe(
        (S) => {
          let f = S.message;
          if (Ut(f) && S.status == Xe.success) {
            const P = f.getConversationId(), Me = n.value.findIndex(
              (ze) => ze.getConversationId() === P
            );
            if (Me > -1) {
              const ze = Ce.clone(
                n.value[Me]
              );
              ze.setLastMessage(f), ze.setUnreadMessageCount(0);
              const Qe = n.value.filter(
                (Ye, At) => At !== Me
              );
              n.value = [
                ze,
                ...Qe
              ];
            } else
              y.CometChatHelper.getConversationFromMessage(
                f
              ).then((ze) => {
                ze.setUnreadMessageCount(0);
                let Qe = n.value;
                Qe.unshift(ze), n.value = [...Qe];
              });
          }
        }
      ), G.value = ae.ccMessageDeleted.subscribe(
        (S) => {
          const f = S.getId(), P = n.value.findIndex((Me) => {
            const ze = Me.getLastMessage();
            return It(ze) && ze.getId() === f;
          });
          P > -1 && (n.value = n.value.map((Me, ze) => {
            if (ze === P) {
              const Qe = Ce.clone(Me);
              return Qe.setLastMessage(S), Qe;
            }
            return Me;
          }));
        }
      ), V.value = ae.ccMessageRead.subscribe(
        (S) => {
          if (!S)
            return;
          const f = n.value.findIndex((P) => Object(P.getConversationId()) === Object(S.getConversationId()));
          if (f >= 0) {
            const P = n.value[f];
            P.setUnreadMessageCount(0);
            const Me = S.getReadAt() || Date.now();
            P.setUnreadMessageCount(0), P.getLastMessage().setReadAt(Me);
            let ze = n.value;
            ze.splice(f, 1, P), n.value = [...ze];
          } else
            y.CometChatHelper.getConversationFromMessage(
              S
            ).then((P) => {
              P.setUnreadMessageCount(0);
              const Me = S.getReadAt() || Date.now();
              P.setUnreadMessageCount(0), P.getLastMessage().setReadAt(Me);
              let ze = n.value.findIndex(
                (Qe) => Qe.getLastMessage() && Qe.getLastMessage().getId() == (S == null ? void 0 : S.getId())
              );
              if (ze >= 0) {
                let Qe = n.value;
                Qe.splice(ze, 1, P), n.value = [...Qe];
              }
            });
        }
      ), H = ae.onTextMessageReceived.subscribe(
        (S) => {
          yt(
            I.messages.TEXT_MESSAGE_RECEIVED,
            null,
            S
          );
        }
      ), Ee = ae.onMediaMessageReceived.subscribe(
        (S) => {
          yt(
            I.messages.MEDIA_MESSAGE_RECEIVED,
            null,
            S
          );
        }
      ), L = ae.onCustomMessageReceived.subscribe(
        (S) => {
          yt(
            I.messages.CUSTOM_MESSAGE_RECEIVED,
            null,
            S
          );
        }
      ), b = ae.onFormMessageReceived.subscribe(
        (S) => {
          S = va.fromJSON(S), yt(
            I.messages.INTERACTIVE_MESSAGE_RECEIVED,
            null,
            S
          );
        }
      ), v = ae.onCardMessageReceived.subscribe(
        (S) => {
          S = ma.fromJSON(S), yt(
            I.messages.INTERACTIVE_MESSAGE_RECEIVED,
            null,
            S
          );
        }
      ), U = ae.onSchedulerMessageReceived.subscribe(
        (S) => {
          S = Oa.fromJSON(S), yt(
            I.messages.INTERACTIVE_MESSAGE_RECEIVED,
            null,
            S
          );
        }
      ), Se = ae.onCustomInteractiveMessageReceived.subscribe(
        (S) => {
          S = xa.fromJSON(S), yt(
            I.messages.INTERACTIVE_MESSAGE_RECEIVED,
            null,
            S
          );
        }
      ), Ue = ae.onMessagesRead.subscribe(
        (S) => {
          !e.disableReceipt && S.getReceiverType() === I.MessageReceiverType.user && (!c || c === S.getReceiverType()) && Tt(S);
        }
      ), _e = ae.onMessagesReadByAll.subscribe(
        (S) => {
          !e.disableReceipt && S.getReceiverType() === I.MessageReceiverType.group && (!c || c === S.getReceiverType()) && Tt(S);
        }
      ), Z = ae.onMessagesDeliveredToAll.subscribe(
        (S) => {
          !e.disableReceipt && S.getReceiverType() == I.MessageReceiverType.group && (!c || c == (S == null ? void 0 : S.getReceiverType())) && gn(S);
        }
      ), Re = ae.onMessageDeleted.subscribe(
        (S) => {
          yt(
            I.messages.MESSAGE_DELETED,
            null,
            S
          );
        }
      ), ke = ae.onMessageEdited.subscribe(
        (S) => {
          yt(
            I.messages.MESSAGE_EDITED,
            null,
            S
          );
        }
      ), q = ae.onMessagesDelivered.subscribe(
        (S) => {
          !e.disableReceipt && S.getReceiverType() === I.MessageReceiverType.user && (!c || c === (S == null ? void 0 : S.getReceiverType())) && gn(S);
        }
      ), ye = ae.onTypingStarted.subscribe(
        (S) => {
          if (!e.disableTyping) {
            const f = S.getSender().getUid(), P = S.getReceiverType() === I.MessageReceiverType.group, Me = S.getReceiverId();
            let ze;
            for (let Qe = 0; Qe < n.value.length; Qe++) {
              let Ye = n.value[Qe].getConversationWith();
              if (P) {
                if (Ye instanceof y.Group && Ye.getGuid() === Me) {
                  ze = Ye.getGuid();
                  break;
                }
              } else if (Ye instanceof y.User && Ye.getUid() === f) {
                ze = Ye.getUid();
                break;
              }
            }
            if (ze != null) {
              const Qe = new Map(i.value);
              Qe.set(ze, S), i.value = Qe;
            }
          }
        }
      ), Oe = ae.onTypingEnded.subscribe(
        (S) => {
          var ze;
          const f = S.getSender().getUid(), P = S.getReceiverId();
          let Me;
          if (S.getReceiverType() === I.MessageReceiverType.user ? i.value.has(f) && (Me = f) : ((ze = i.value.get(P)) == null ? void 0 : ze.getSender().getUid()) === f && (Me = P), Me !== void 0) {
            const Qe = new Map(i.value);
            Qe.delete(Me), i.value = Qe;
          }
        }
      );
    }
    function Lt() {
      var S, f, P, Me, ze, Qe, Ye, At, $t, Ln, wn, St;
      (S = re.value) == null || S.unsubscribe(), (f = Ae.value) == null || f.unsubscribe(), (P = Ie.value) == null || P.unsubscribe(), (Me = X.value) == null || Me.unsubscribe(), (ze = B.value) == null || ze.unsubscribe(), (Qe = F.value) == null || Qe.unsubscribe(), (Ye = G.value) == null || Ye.unsubscribe(), (At = J.value) == null || At.unsubscribe(), ($t = ee.value) == null || $t.unsubscribe(), (Ln = ne.value) == null || Ln.unsubscribe(), (wn = K.value) == null || wn.unsubscribe(), (St = V.value) == null || St.unsubscribe(), H == null || H.unsubscribe(), Ee == null || Ee.unsubscribe(), L == null || L.unsubscribe(), b == null || b.unsubscribe(), v == null || v.unsubscribe(), U == null || U.unsubscribe(), Se == null || Se.unsubscribe(), Ue == null || Ue.unsubscribe(), Re == null || Re.unsubscribe(), Z == null || Z.unsubscribe(), _e == null || _e.unsubscribe(), ke == null || ke.unsubscribe(), q == null || q.unsubscribe(), ye == null || ye.unsubscribe(), Oe == null || Oe.unsubscribe();
    }
    function jt(S) {
      try {
        e.disableUsersPresence || y.addUserListener(
          _.value,
          new y.UserListener({
            onUserOnline: (f) => {
              S(
                I.userStatusType.online,
                f
              );
            },
            onUserOffline: (f) => {
              S(
                I.userStatusType.offline,
                f
              );
            }
          })
        ), y.addGroupListener(
          ie.value,
          new y.GroupListener({
            onGroupMemberScopeChanged: (f, P, Me, ze, Qe) => {
              Yt(f);
            },
            onGroupMemberKicked: (f, P, Me, ze) => {
              if ((u == null ? void 0 : u.getUid()) == P.getUid()) {
                for (let Qe = 0; Qe < n.value.length; Qe++)
                  if (n.value[Qe].getConversationWith() instanceof y.Group) {
                    let Ye = n.value[Qe].getConversationWith();
                    ze.getGuid() == Ye.getGuid() && n.value.splice(Qe, 1);
                  }
              } else
                Yt(f);
            },
            onGroupMemberBanned: (f, P, Me, ze) => {
              if ((u == null ? void 0 : u.getUid()) == P.getUid()) {
                for (let Qe = 0; Qe < n.value.length; Qe++)
                  if (n.value[Qe].getConversationWith() instanceof y.Group) {
                    let Ye = n.value[Qe].getConversationWith();
                    ze.getGuid() == Ye.getGuid() && n.value.splice(Qe, 1);
                  }
              } else
                Yt(f);
            },
            onGroupMemberUnbanned: (f, P, Me, ze) => {
              Yt(f);
            },
            onMemberAddedToGroup: (f, P, Me, ze) => {
              Yt(f);
            },
            onGroupMemberLeft: (f, P, Me) => {
              if ((u == null ? void 0 : u.getUid()) == P.getUid()) {
                for (let ze = 0; ze < n.value.length; ze++)
                  if (n.value[ze].getConversationWith() instanceof y.Group) {
                    let Qe = n.value[ze].getConversationWith();
                    Me.getGuid() == Qe.getGuid() && n.value.splice(ze, 1);
                  }
              } else
                Yt(f);
            },
            onGroupMemberJoined: (f, P, Me) => {
              Yt(f);
            }
          })
        ), y.addConnectionListener(
          oe.value,
          new y.ConnectionListener({
            onConnected: () => {
              var f;
              try {
                Te.value ? (e.conversationsRequestBuilder ? s.value = (f = e.conversationsRequestBuilder) == null ? void 0 : f.build() : s.value = new y.ConversationsRequestBuilder().setLimit(d).build(), n.value = [], ot().then()) : Te.value = !0;
              } catch (P) {
                e.onError && e.onError(P), l.value = ge.loading;
                try {
                  l.value = ge.loading, n.value = [], ot().then();
                } catch (Me) {
                  e.onError && e.onError(Me);
                }
              }
            }
          })
        );
      } catch (f) {
        e.onError && e.onError(f);
      }
    }
    function Wt() {
      try {
        y.removeUserListener(_.value), y.removeGroupListener(ie.value), y.removeConnectionListener(oe.value);
      } catch (S) {
        e.onError && e.onError(S);
      }
    }
    bn(
      n,
      () => {
        var S, f;
        ((S = n.value) == null ? void 0 : S.length) === 0 ? l.value = ge.empty : ((f = n.value) == null ? void 0 : f.length) > 0 && (l.value = ge.loaded);
      },
      { deep: !0 }
    );
    async function ot() {
      var S, f;
      if (s.value) {
        l.value = ge.loading;
        try {
          const P = await Fe();
          P.forEach((Me) => {
            e.activeConversation && e.activeConversation !== null && e.activeConversation.getConversationType() === Me.getConversationType() && e.activeConversation.getConversationId() == Me.getConversationId() && Me.setUnreadMessageCount(0);
          }), n.value = [...n.value, ...P], P.length <= 0 && ((S = n.value) == null ? void 0 : S.length) <= 0 ? l.value = ge.empty : l.value = ge.loaded;
        } catch (P) {
          e.onError && e.onError(P), n.value && ((f = n.value) == null ? void 0 : f.length) > 0 ? l.value = ge.loaded : l.value = ge.error;
        }
      } else
        l.value = ge.loaded;
    }
    function zt(S) {
      const f = S.getLastMessage(), P = S.getConversationWith(), Me = P instanceof y.User ? P.getUid() : P.getGuid();
      return f && !(f != null && f.getDeletedAt()) && !(e.disableReceipt || e.hideReceipt) && It(f) && f.getCategory() !== I.MessageCategory.action && f.getSender().getUid() === (u == null ? void 0 : u.getUid()) && i.value.get(Me) === void 0;
    }
    const yt = (S, f = null, P, Me = null) => {
      try {
        switch (S) {
          case I.userStatusType.offline:
          case I.userStatusType.online: {
            Pt(f);
            break;
          }
          case I.messages.MESSAGE_READ: {
            Yt(P, !1);
            break;
          }
          case I.messages.MESSAGE_DELIVERED: {
            Yt(P, !1);
            break;
          }
          case I.messages.TEXT_MESSAGE_RECEIVED:
          case I.messages.MEDIA_MESSAGE_RECEIVED:
          case I.messages.CUSTOM_MESSAGE_RECEIVED:
          case I.messages.INTERACTIVE_MESSAGE_RECEIVED:
            e.disableReceipt || ft(P), Yt(P);
            break;
          case I.groupMemberAction.ADDED:
          case I.groupMemberAction.BANNED:
          case I.groupMemberAction.JOINED:
          case I.groupMemberAction.KICKED:
          case I.groupMemberAction.LEFT:
          case I.groupMemberAction.UNBANNED:
          case I.groupMemberAction.SCOPE_CHANGE:
            Yt(P);
            break;
          case I.messages.MESSAGE_EDITED:
          case I.messages.MESSAGE_DELETED:
            ln(P);
            break;
        }
      } catch (ze) {
        e.onError && e.onError(ze);
      }
    }, on = (S) => {
      const f = "getMetadata", P = "incrementUnreadCount";
      let Me;
      return f in S && typeof S[f] == "function" && (Me = S[f]()) && typeof Me == "object" && P in Me && !!Me.incrementUnreadCount || S instanceof y.CustomMessage && S.willUpdateConversation();
    }, ft = async (S) => {
      var f, P, Me, ze, Qe, Ye;
      if (S.getSender().getUid() !== (u == null ? void 0 : u.getUid()) && !e.disableReceipt && !S.getDeliveredAt())
        try {
          await y.markAsDelivered(S);
        } catch (At) {
          e.onError && e.onError(At);
        }
      if (!e.disableSoundForMessages && !(S.getCategory() === I.MessageCategory.custom && !on(S) || e.activeConversation && e.activeConversation.getConversationId() === S.getConversationId()) && Tn(), ((f = e.activeConversation) == null ? void 0 : f.getConversationType()) == I.MessageReceiverType.user) {
        if ((!e.activeConversation || ((Me = (P = e.activeConversation) == null ? void 0 : P.getConversationWith()) == null ? void 0 : Me.getUid()) !== ((ze = S == null ? void 0 : S.getSender()) == null ? void 0 : ze.getUid())) && Object.prototype.hasOwnProperty.call(S, "deliveredAt"))
          try {
            y.markAsDelivered(S);
          } catch (At) {
            e.onError && e.onError(At);
          }
      } else if ((!e.activeConversation || ((Ye = (Qe = e.activeConversation) == null ? void 0 : Qe.getConversationWith()) == null ? void 0 : Ye.getGuid()) !== (S == null ? void 0 : S.getReceiverId())) && Object.prototype.hasOwnProperty.call(S, "deliveredAt"))
        try {
          y.markAsDelivered(S);
        } catch (At) {
          e.onError && e.onError(At);
        }
    }, rt = () => String(Math.round(+/* @__PURE__ */ new Date() / 1e3));
    function Tt(S) {
      let f = [...n.value];
      const P = f.findIndex(
        (Me) => {
          var ze;
          return ((ze = Me.getLastMessage()) == null ? void 0 : ze.getId()) == Number(S.getMessageId()) && Me.getLastMessage().getSender().getUid() == (u == null ? void 0 : u.getUid());
        }
      );
      if (P > -1) {
        let Me;
        f[P].getLastMessage().getReadAt() || (Me = f[P], Me.getLastMessage().setReadAt(S.getReadAt()), Me.setUnreadMessageCount(0), Me.getLastMessage().setMuid(rt()), f.splice(P, 1, Me), n.value = [...f]);
      }
    }
    function Pt(S) {
      try {
        const f = [
          ...n.value
        ], P = f.findIndex(
          (Me) => Me.getConversationType() === I.MessageReceiverType.user && Me.getConversationWith().getUid() === S.getUid()
        );
        if (P > -1) {
          let Me = f[P], ze = Me.getConversationWith();
          ze.setStatus(S.getStatus());
          let Qe = Me;
          Qe.setConversationWith(ze), Qe.getLastMessage().setMuid(rt()), f.splice(P, 1, Qe), n.value = f;
        }
      } catch (f) {
        e.onError && e.onError(f);
      }
    }
    function Rt(S) {
      return S;
    }
    function Yt(S, f = !0) {
      try {
        if (!Ut(S))
          return;
        rn(S).then((P) => {
          const Me = P.conversationKey, ze = P.conversationObj, Qe = P.conversationList;
          if (Me > -1) {
            let Ye = S, At = ze;
            At.setLastMessage(Ye), bt(ze), At.getLastMessage().setMuid(rt());
          } else {
            let Ye = S;
            ze.setLastMessage(Ye), bt(ze), Qe.unshift(ze), n.value = Qe;
          }
        }).catch((P) => {
          e.onError && e.onError(P);
        });
      } catch (P) {
        e.onError && e.onError(P);
      }
    }
    function en(S) {
      if (!(S.getLastMessage() && Ut(S.getLastMessage())))
        return;
      let f = n.value.findIndex(
        (P) => P.getConversationId() == S.getConversationId()
      );
      n.value.splice(f, 1), n.value.unshift(S);
    }
    function gn(S) {
      let f = [...n.value], P = f.findIndex(
        (ze) => ze.getLastMessage().getId() == Number(S.getMessageId()) && ze.getLastMessage().getSender().getUid() == (u == null ? void 0 : u.getUid())
      ), Me;
      P > -1 && (Me = f[P], Me.getLastMessage().getDeliveredAt() || (Me.getLastMessage().setDeliveredAt(S.getDeliveredAt()), Me.getLastMessage().setMuid(
        rt()
      ), f.splice(P, 1, Me), n.value = [...f]));
    }
    function bt(S) {
      const f = S.getLastMessage();
      if (!It(f))
        return;
      const P = Ut(f), Me = S.getConversationId();
      let ze = n.value.findIndex(
        (Ye) => Ye.getConversationId() === Me
      );
      if (ze !== -1) {
        const Ye = n.value[ze];
        Ye.setUnreadMessageCount(
          Ye.getUnreadMessageCount() + Number(P)
        ), n.value.splice(ze, 1), n.value = [Ye, ...n.value];
      } else
        S.setUnreadMessageCount(
          S.getUnreadMessageCount() + Number(P)
        ), n.value = [S, ...n.value];
      const Qe = n.value.find(
        (Ye) => Ye.getConversationId() === Me
      );
      return Qe ? Qe.getUnreadMessageCount() : 0;
    }
    function Ut(S) {
      const f = An.getConversationSettings();
      if (c && c != S.getReceiverType())
        return !1;
      let P = S.getCategory() === I.MessageCategory.custom;
      return S != null && S.getParentMessageId() && !(f != null && f.shouldUpdateOnMessageReplies()) ? !1 : P ? S != null && S.getParentMessageId() && (f != null && f.shouldUpdateOnMessageReplies()) && cn(S) ? !0 : cn(S) : S.getCategory() === I.MessageCategory.action ? S.getType() === I.MessageTypes.groupMember ? f == null ? void 0 : f.shouldUpdateOnGroupActions() : !0 : S.getCategory() === I.MessageCategory.call && (S.getType() === I.MessageTypes.audio || S.getType() === I.MessageTypes.video) ? f == null ? void 0 : f.shouldUpdateOnCallActivities() : !0;
    }
    function cn(S) {
      var P;
      const f = S.getMetadata();
      return S.willUpdateConversation() || f && f.hasOwnProperty("incrementUnreadCount") && f.incrementUnreadCount || ((P = An.conversationUpdateSettings) == null ? void 0 : P.shouldUpdateOnCustomMessages());
    }
    function rn(S) {
      return new Promise((P, Me) => {
        y.CometChatHelper.getConversationFromMessage(S).then((ze) => {
          let Qe = [
            ...n.value
          ], Ye = Qe.findIndex(
            ($t) => ($t == null ? void 0 : $t.getConversationId()) === ze.getConversationId()
          ), At = ze;
          Ye > -1 && (At = Qe[Ye]), P({
            conversationKey: Ye,
            conversationObj: At,
            conversationList: Qe
          });
        }).catch((ze) => Me(ze));
      });
    }
    function ln(S) {
      try {
        rn(S).then((f) => {
          const P = f.conversationKey, Me = f.conversationObj, ze = f.conversationList;
          P > -1 && Me.getLastMessage().getId() === S.getId() && (Me.setLastMessage(S), Me.getLastMessage().setMuid(rt()), ze.splice(P, 1, Me), n.value = [...ze]);
        }).catch((f) => {
          e.onError && e.onError(f);
        });
      } catch (f) {
        e.onError && e.onError(f);
      }
    }
    function Tn() {
      try {
        if (!e.disableSoundForMessages)
          e.customSoundForMessages ? Ot.play(e.customSoundForMessages) : Ot.play(
            Ot.Sound.incomingMessageFromOther
          );
        else
          return;
      } catch (S) {
        e.onError && e.onError(S);
      }
    }
    function Vt(S) {
      let f = n.value.findIndex(
        (P) => (P == null ? void 0 : P.getConversationId()) == (S == null ? void 0 : S.getConversationId())
      );
      n.value.splice(f, 1);
    }
    const Xt = (S) => {
      r.value = !0;
    };
    function sn(S, f) {
      var Me, ze;
      let P = (Me = S == null ? void 0 : S.detail) == null ? void 0 : Me.data;
      P.id == I.ConversationOptions.delete && (o.value = f), P && ((ze = P.onClick) == null || ze.call(P));
    }
    function te(S) {
      var f;
      return e.selectionMode == xt.none || !e.selectionMode ? (S == null ? void 0 : S.getConversationId()) == ((f = e.activeConversation) == null ? void 0 : f.getConversationId()) : !1;
    }
    function et() {
      if (o.value) {
        e.activeConversation && e.activeConversation.getConversationId() == o.value.getConversationId() && (D.value = null);
        let S, f = o.value.getConversationType();
        f === I.MessageReceiverType.user ? S = o.value.getConversationWith().getUid() : S = o.value.getConversationWith().getGuid(), y.deleteConversation(S, f).then((P) => {
          ka.ccConversationDeleted.next(
            o.value
          ), Vt(o.value), o.value = null, r.value = !1;
        }).catch((P) => {
          e.onError && e.onError(P);
        });
      }
    }
    function Ze(S, f) {
      var Me;
      const P = (Me = S.detail) == null ? void 0 : Me.checked;
      e.onSelect && e.onSelect(f, P);
    }
    function at(S) {
      const f = S.getConversationId(), P = n.value.findIndex(
        (Me) => Me.getConversationId() === f
      );
      if (P > -1) {
        const Me = n.value[P].getConversationWith(), ze = Me instanceof y.User ? Me.getUid() : Me.getGuid();
        let Qe;
        i.value.has(ze) ? (Qe = new Map(i.value), Qe.delete(ze)) : Qe = i.value;
      }
      Vt(S);
    }
    function Bt(S) {
      let f;
      return e.options ? f = e.options(S) : f = zo.getDefaultOptions(), f.forEach((P) => {
        !P.onClick && P.id == I.ConversationOptions.delete && (P.onClick = Gt, P.iconTint = "red");
      }), f;
    }
    tn(() => {
      var S;
      l.value = ge.loading, Hn(), wt(), y.getLoggedinUser().then((f) => {
        u = f;
      }).catch((f) => {
        e.onError && e.onError(f);
      }), e.conversationsRequestBuilder ? (s.value = (S = e.conversationsRequestBuilder) == null ? void 0 : S.build(), s.value.getConversationType() && (c = s.value.getConversationType())) : s.value = new y.ConversationsRequestBuilder().setLimit(d).build();
      try {
        ot().then(() => {
          jt(yt);
        });
      } catch (f) {
        e.onError && e.onError(f);
      }
    }), Ko(() => {
      (!z && e.activeConversation || z && !e.activeConversation || z && e.activeConversation && z.getConversationId() != e.activeConversation.getConversationId()) && (z = e.activeConversation, no());
    }), un(() => {
      try {
        Wt(), Lt();
      } catch (S) {
        e.onError && e.onError(S);
      }
    });
    function vn(S) {
      e.onItemClick && e.onItemClick(S);
    }
    function Pn(S) {
      let f = S.getConversationWith();
      return f instanceof y.User ? new co().getUserStatusVisibility(f) || e.disableUsersPresence ? null : he.value[f == null ? void 0 : f.getStatus()] : he.value[f == null ? void 0 : f.getType()];
    }
    function to(S) {
      let f = "";
      const P = S.getConversationWith();
      if (P instanceof y.Group)
        switch (P.getType()) {
          case I.GroupTypes.password:
            f = e.protectedGroupIcon || Yo;
            break;
          case I.GroupTypes.private:
            f = e.privateGroupIcon || Vo;
            break;
        }
      return f;
    }
    const Un = () => {
      r.value = !1, o.value = null;
    }, Fn = () => {
      var S;
      return {
        height: e.conversationsStyle.height || "100%",
        width: e.conversationsStyle.width || "100%",
        border: e.conversationsStyle.border || `1px solid ${t.value.palette.getAccent100()}`,
        borderRadius: e.conversationsStyle.borderRadius || "0",
        background: e.conversationsStyle.background || t.value.palette.getBackground(),
        position: "relative",
        boxShadow: ((S = e.conversationsStyle) == null ? void 0 : S.boxShadow) || "",
        boxSizing: "border-box"
      };
    };
    function no() {
      var S;
      if (e.activeConversation) {
        const f = [
          ...n.value
        ], P = f.findIndex(
          (Me) => {
            var ze;
            return (Me == null ? void 0 : Me.getConversationId()) === ((ze = e.activeConversation) == null ? void 0 : ze.getConversationId());
          }
        );
        if (P > -1) {
          let ze = f[P];
          ze.setUnreadMessageCount(0), (S = ze.getLastMessage()) == null || S.setMuid(rt()), f.splice(P, 1, ze), n.value = [...f];
        }
      }
    }
    function Hn() {
      var S, f, P;
      oo(), io(), ao(), Wn(), Zn(), ro(), lo(), he.value.private = ((S = e.conversationsStyle) == null ? void 0 : S.privateGroupIconBackground) || t.value.palette.getSuccess() || "rgb(0, 200, 111)", he.value.password = ((f = e.conversationsStyle) == null ? void 0 : f.passwordGroupIconBackground) || "rgb(247, 165, 0)", he.value.online = ((P = e.conversationsStyle) == null ? void 0 : P.onlineStatusColor) ?? t.value.palette.getSuccess(), k.value = {
        height: "100%",
        titleTextFont: Q.value.titleTextFont,
        titleTextColor: Q.value.titleTextColor,
        emptyStateTextFont: Q.value.emptyStateTextFont,
        emptyStateTextColor: Q.value.emptyStateTextColor,
        errorStateTextFont: Q.value.errorStateTextFont,
        errorStateTextColor: Q.value.errorStateTextColor,
        loadingIconTint: Q.value.loadingIconTint,
        separatorColor: Q.value.separatorColor,
        background: Q.value.background
      }, Pe.value.iconTint = t.value.palette.getAccent400();
    }
    function Zn() {
      let S = new Rr({
        lastMessageTextFont: w(t.value.typography.subtitle2),
        lastMessageTextColor: t.value.palette.getAccent600(),
        background: t.value.palette.getBackground(),
        border: `1px solid ${t.value.palette.getAccent50()}`,
        titleTextFont: w(t.value.typography.title1),
        titleTextColor: t.value.palette.getAccent(),
        emptyStateTextFont: w(t.value.typography.title1),
        emptyStateTextColor: t.value.palette.getAccent600(),
        errorStateTextFont: w(t.value.typography.title1),
        errorStateTextColor: t.value.palette.getAccent600(),
        loadingIconTint: t.value.palette.getAccent600(),
        separatorColor: t.value.palette.getAccent400(),
        onlineStatusColor: t.value.palette.getSuccess(),
        privateGroupIconBackground: t.value.palette.getSuccess(),
        passwordGroupIconBackground: "RGB(247, 165, 0)",
        typingIndictorTextColor: t.value.palette.getPrimary(),
        typingIndictorTextFont: w(t.value.typography.subtitle2),
        threadIndicatorTextFont: w(t.value.typography.caption2),
        threadIndicatorTextColor: t.value.palette.getAccent600()
      });
      Q.value = {
        ...S,
        ...Q.value
      };
    }
    function oo() {
      let S = new Kt({
        borderRadius: "24px",
        width: "28px",
        height: "28px",
        border: "none",
        backgroundColor: t.value.palette.getAccent700(),
        nameTextColor: t.value.palette.getAccent900(),
        backgroundSize: "cover",
        nameTextFont: w(t.value.typography.subtitle1),
        outerViewBorderWidth: "",
        outerViewBorderSpacing: ""
      });
      T.value = { ...S, ...T.value };
    }
    function io() {
      let S = new Ll({
        textFont: w(t.value.typography.subtitle2),
        textColor: t.value.palette.getAccent("dark"),
        background: t.value.palette.getPrimary(),
        borderRadius: "16px",
        height: "16px",
        width: "20px"
      });
      m.value = { ...S, ...m.value };
    }
    function Wn() {
      let S = new Ti({
        confirmButtonBackground: t.value.palette.getError(),
        cancelButtonBackground: t.value.palette.getSecondary(),
        confirmButtonTextColor: t.value.palette.getAccent900("light"),
        confirmButtonTextFont: w(t.value.typography.text2),
        cancelButtonTextColor: t.value.palette.getAccent900("dark"),
        cancelButtonTextFont: w(t.value.typography.text2),
        titleFont: w(t.value.typography.title1),
        titleColor: t.value.palette.getAccent(),
        messageTextFont: w(t.value.typography.subtitle2),
        messageTextColor: t.value.palette.getAccent600(),
        background: t.value.palette.getBackground(),
        height: "100%",
        width: "100%",
        borderRadius: "16px"
      });
      A.value = {
        ...S,
        ...A.value
      };
    }
    function ao() {
      let S = new _t({
        height: "50px",
        width: "100%",
        background: t.value.palette.getBackground(),
        activeBackground: t.value.palette.getAccent100(),
        borderRadius: "0",
        titleFont: w(t.value.typography.title2),
        titleColor: t.value.palette.getAccent(),
        border: "none",
        separatorColor: t.value.palette.getAccent200(),
        hoverBackground: t.value.palette.getAccent50()
      });
      R.value = { ...S, ...R.value };
    }
    function ro() {
      let S = new po({
        textFont: w(t.value.typography.caption2),
        textColor: t.value.palette.getAccent600(),
        background: "transparent"
      });
      h.value = { ...S, ...h.value };
    }
    function lo() {
      let S = {
        height: "12px",
        width: "12px",
        border: "none",
        borderRadius: "24px"
      };
      O.value = { ...S, ...O.value };
    }
    const Bn = Ht(() => {
      const S = e.receiptStyle || {};
      return new Jo({
        waitIconTint: S.waitIconTint || t.value.palette.getAccent700(),
        sentIconTint: S.sentIconTint || t.value.palette.getAccent600(),
        deliveredIconTint: S.deliveredIconTint || t.value.palette.getAccent600(),
        readIconTint: S.readIconTint || t.value.palette.getPrimary(),
        errorIconTint: S.errorIconTint || t.value.palette.getError(),
        height: S.height || "15px",
        width: S.width || "15px",
        background: S.background || "transparent",
        border: S.border || "none",
        borderRadius: S.borderRadius || "0"
      });
    }), Qn = (S) => {
      var P, Me, ze, Qe, Ye, At, $t;
      let f;
      return S.getConversationType() == "group" ? f = (P = S == null ? void 0 : S.conversationWith) == null ? void 0 : P.guid : S.getConversationType() == "user" && (f = (Me = S == null ? void 0 : S.conversationWith) == null ? void 0 : Me.uid), i.value.get(f) && (((ze = i.value.get(f)) == null ? void 0 : ze.getReceiverType()) == I.MessageReceiverType.user && ((Qe = i.value.get(f)) == null ? void 0 : Qe.getSender().getUid()) == ((Ye = S.conversationWith) == null ? void 0 : Ye.uid) || ((At = i.value.get(f)) == null ? void 0 : At.getReceiverId()) == (($t = S.conversationWith) == null ? void 0 : $t.guid)) ? {
        font: Q.value.typingIndictorTextColor,
        color: Q.value.typingIndictorTextColor
      } : {
        font: Q.value.lastMessageTextFont,
        color: Q.value.lastMessageTextColor
      };
    }, Dn = () => ({
      textFont: e.conversationsStyle.threadIndicatorTextFont || w(t.value.typography.caption2),
      textColor: e.conversationsStyle.threadIndicatorTextColor || t.value.palette.getAccent400()
    }), so = (S) => ja.getReceiptStatus(
      S.getLastMessage()
    ), Rn = (S) => {
      var Qe, Ye, At, $t, Ln, wn, St, Et, $n, Mo;
      let f = S.getLastMessage(), P = Ne.getDataSource().getLastConversationMessage(
        S,
        u,
        {
          disableMentions: e.disableMentions,
          theme: t.value,
          mentionsTargetElement: Ai.conversation,
          textFormatters: e.textFormatters
        }
      ), Me;
      if (S.getConversationType() == "group" ? Me = (Qe = S == null ? void 0 : S.conversationWith) == null ? void 0 : Qe.guid : S.getConversationType() == "user" && (Me = (Ye = S == null ? void 0 : S.conversationWith) == null ? void 0 : Ye.uid), i.value.get(Me)) {
        if (((At = S == null ? void 0 : S.conversationWith) == null ? void 0 : At.guid) == (($t = i.value.get(Me)) == null ? void 0 : $t.getReceiverId()))
          return P = `${(Ln = i.value.get(Me)) == null ? void 0 : Ln.getSender().getName()} ${Y("IS_TYPING")}`, P;
        if (((wn = S == null ? void 0 : S.conversationWith) == null ? void 0 : wn.uid) == ((St = i.value.get(Me)) == null ? void 0 : St.getSender().getUid()) && ((Et = i.value.get(Me)) == null ? void 0 : Et.getReceiverType()) !== I.MessageReceiverType.group)
          return P = Y("IS_TYPING"), P;
      }
      let ze = (($n = S == null ? void 0 : S.getLastMessage()) == null ? void 0 : $n.getType()) == I.MessageTypes.audio ? "📞 " : "📹 ";
      return f && !(f != null && f.getDeletedAt()) && (f == null ? void 0 : f.getType()) == "meeting" || ((Mo = S == null ? void 0 : S.getLastMessage()) == null ? void 0 : Mo.getCategory()) == I.MessageCategory.call ? ze + P : P;
    };
    function qt() {
      const S = e.backdropStyle || {};
      return new Di({
        height: S.height || "100%",
        width: S.width || "100%",
        background: S.background || "rgba(0, 0, 0, 0.5)",
        position: S.position || "absolute",
        border: S.border || "",
        borderRadius: S.borderRadius || ""
      });
    }
    return {
      Conversations: n,
      onClick: vn,
      getActiveConversation: te,
      checkGroupType: to,
      isDialogOpen: r,
      onConfirmClick: de,
      onCancelClick: Un,
      myavatarStyle: T,
      myListItemStyle: R,
      mydeleteConversationDialogStyle: A,
      receiptStyleComputed: Bn,
      listStyle: k,
      iconStyle: Pe,
      setSubtitle: Rn,
      setStatusIndicatorStyle: Le,
      checkStatusType: Pn,
      itemThreadIndicatorStyle: Dn,
      subtitleStyle: Qn,
      threadText: N,
      isReceiptDisable: zt,
      getMessageReceipt: so,
      SelectionMode: xt,
      menustyle: lt,
      ConversationUtils: zo,
      DatePatterns: yn,
      onOptionClick: sn,
      getConversation: ot,
      state: l,
      myoptions: x,
      mydateStyle: h,
      mybadgeStyle: m,
      wrapperStyle: Fn,
      ThreadIcon: $a,
      openThreadArrow: Ms,
      getbackdropStyle: qt,
      setConversationOptions: Bt,
      handleSelection: Ze,
      //mentionIconStyle,
      mentions: us
      //getUnreadMentionsIconStyle
    };
  }
});
const Zu = ["backdropStyle"], Wu = ["title", "messageText", "cancelButtonText", "confirmButtonText", "confirmDialogStyle"], $u = {
  key: 1,
  class: "cc-conversations__menus"
}, Ju = ["v-slot", "v-html"], Ku = ["innerHTML"], Xu = { key: 0 }, qu = ["innerHTML"], _u = ["v-slot", "v-html"], eg = ["title", "avatarURL", "avatarName", "hideSeparator", "id", "avatarStyle", "listItemStyle", "statusIndicatorStyle", "isActive", "onCcListitemClicked", "statusIndicatorColor", "statusIndicatorIcon"], tg = {
  slot: "subtitleView",
  class: "cc-conversations__subtitle-view"
}, ng = { key: 0 }, og = ["innerHTML"], ig = ["v-slot", "v-html"], ag = {
  key: 1,
  class: "cc-conversations__default-subtitle-view"
}, rg = {
  key: 0,
  class: "cc-conversations__thread-view"
}, lg = ["labelStyle", "text"], sg = ["URL", "iconStyle"], Mg = { class: "cc-conversations__subtitle" }, ug = {
  key: 0,
  class: "cc-conversations__read-receipt"
}, gg = ["receipt", "waitIcon", "sentIcon", "errorIcon", "deliveredIcon", "readIcon", "receiptStyle"], cg = ["innerHTML"], dg = {
  key: 0,
  slot: "menuView",
  class: "cc-conversations__options-view"
}, Ig = { key: 0 }, Ng = ["menuListStyle", "data", "onCcMenuClicked"], Tg = {
  slot: "tailView",
  class: "cc-conversations__tail-view"
}, Dg = {
  key: 0,
  class: "tail__view"
}, yg = { class: "cc-conversations__date" }, Cg = ["dateStyle", "timestamp", "pattern"], wg = { class: "cc-conversations__badge" }, jg = ["count", "badgeStyle"], Ag = {
  key: 1,
  slot: "tailView"
}, Lg = ["onCcRadioButtonChanged"], zg = {
  key: 2,
  slot: "tailView"
}, Sg = ["onCcCheckboxChanged"];
function pg(e, t, n, o, i, l) {
  var u;
  const r = Je("CometChatList");
  return M(), g("div", {
    class: "cc-conversations",
    style: ce(e.wrapperStyle())
  }, [
    e.isDialogOpen ? (M(), g("cometchat-backdrop", {
      key: 0,
      backdropStyle: e.getbackdropStyle()
    }, [
      p("cometchat-confirm-dialog", {
        title: e.confirmDialogTitle,
        messageText: e.confirmDialogMessage,
        cancelButtonText: e.cancelButtonText,
        confirmButtonText: e.confirmButtonText,
        onCcConfirmClicked: t[0] || (t[0] = (s) => e.onConfirmClick()),
        onCcCancelClicked: t[1] || (t[1] = (s) => e.onCancelClick()),
        confirmDialogStyle: e.mydeleteConversationDialogStyle
      }, null, 40, Wu)
    ], 8, Zu)) : $("", !0),
    e.menu ? (M(), g("div", $u, [
      e.menu.componentName ? (M(), je(fe(e.menu.componentName), me({ key: 0 }, xe((u = e.menu) == null ? void 0 : u.listeners), { ...e.menu.props }), {
        default: be(() => {
          var s;
          return [
            (M(!0), g(we, null, pe((s = e.menu.slots) == null ? void 0 : s.slots, (c, d) => (M(), g("div", {
              key: d,
              "v-slot": [d],
              "v-html": c
            }, null, 8, Ju))), 128))
          ];
        }),
        _: 1
      }, 16)) : (M(), g("div", {
        key: 1,
        innerHTML: e.menu.html
      }, null, 8, Ku))
    ])) : $("", !0),
    Nt(r, {
      title: e.title,
      titleAlignment: e.titleAlignment,
      list: e.Conversations,
      onScrolledToBottom: e.getConversation,
      state: e.state,
      loadingIconURL: e.loadingIconURL,
      hideSearch: !0,
      hideError: e.hideError,
      errorStateText: e.errorStateText,
      emptyStateText: e.emptyStateText,
      scrollToBottom: !1,
      listStyle: e.listStyle,
      listItemKey: "getConversationId",
      onError: e.onError,
      errorStateView: e.errorStateView,
      emptyStateView: e.emptyStateView,
      loadingStateView: e.loadingStateView
    }, {
      listItem: be(({ item: s }) => {
        var c, d, N, T, m, A, D, z, k, R, Q, h, O, x, _, oe, ie, re, Ae, se, X;
        return [
          e.listItemView ? (M(), g("div", Xu, [
            (c = e.listItemView(s)) != null && c.html ? (M(), g("div", {
              key: 0,
              innerHTML: (d = e.listItemView(s)) == null ? void 0 : d.html
            }, null, 8, qu)) : (M(), je(fe((N = e.listItemView(s)) == null ? void 0 : N.componentName), me({ key: 1 }, xe(
              (m = (T = e.listItemView) == null ? void 0 : T.call(e, s)) != null && m.listeners ? (A = e.listItemView(s)) == null ? void 0 : A.listeners : {}
            ), { ...(D = e.listItemView(s)) == null ? void 0 : D.props }), {
              default: be(() => {
                var B;
                return [
                  (M(!0), g(we, null, pe((B = e.listItemView(s)) == null ? void 0 : B.slots, (F, G) => (M(), g("div", {
                    key: G,
                    "v-slot": [G],
                    "v-html": s
                  }, null, 8, _u))), 128))
                ];
              }),
              _: 2
            }, 1040))
          ])) : (M(), g("cometchat-list-item", {
            key: 1,
            title: (z = s == null ? void 0 : s.conversationWith) == null ? void 0 : z.name,
            avatarURL: ((k = s == null ? void 0 : s.conversationWith) == null ? void 0 : k.avatar) || ((R = s == null ? void 0 : s.conversationWith) == null ? void 0 : R.icon),
            avatarName: (Q = s == null ? void 0 : s.conversationWith) == null ? void 0 : Q.name,
            hideSeparator: e.hideSeparator,
            id: s == null ? void 0 : s.conversationId,
            avatarStyle: e.myavatarStyle,
            listItemStyle: e.myListItemStyle,
            statusIndicatorStyle: e.setStatusIndicatorStyle(s),
            isActive: e.getActiveConversation(s),
            onCcListitemClicked: (B) => e.onClick(s),
            statusIndicatorColor: e.checkStatusType(s),
            statusIndicatorIcon: e.checkGroupType(s)
          }, [
            p("div", tg, [
              e.subtitleView ? (M(), g("div", ng, [
                (h = e.subtitleView(s)) != null && h.html ? (M(), g("div", {
                  key: 0,
                  innerHTML: (O = e.subtitleView(s)) == null ? void 0 : O.html
                }, null, 8, og)) : (M(), je(fe((x = e.subtitleView(s)) == null ? void 0 : x.componentName), me({ key: 1 }, xe(
                  (oe = (_ = e.subtitleView) == null ? void 0 : _.call(e, s)) != null && oe.listeners ? (ie = e.subtitleView(s)) == null ? void 0 : ie.listeners : {}
                ), { ...(re = e.subtitleView(s)) == null ? void 0 : re.props }), {
                  default: be(() => {
                    var B;
                    return [
                      (M(!0), g(we, null, pe((B = e.subtitleView(s)) == null ? void 0 : B.slots, (F, G) => (M(), g("div", {
                        key: G,
                        "v-slot": [G],
                        "v-html": F
                      }, null, 8, ig))), 128))
                    ];
                  }),
                  _: 2
                }, 1040))
              ])) : (M(), g("div", ag, [
                (Ae = s == null ? void 0 : s.lastMessage) != null && Ae.parentMessageId ? (M(), g("div", rg, [
                  p("cometchat-label", {
                    labelStyle: e.itemThreadIndicatorStyle(),
                    text: e.threadText
                  }, null, 8, lg),
                  p("cometchat-icon", {
                    URL: e.openThreadArrow,
                    iconStyle: e.iconStyle
                  }, null, 8, sg)
                ])) : $("", !0),
                p("div", Mg, [
                  e.isReceiptDisable(s) ? (M(), g("div", ug, [
                    p("cometchat-receipt", {
                      receipt: e.getMessageReceipt(s),
                      waitIcon: e.waitIcon,
                      sentIcon: e.sentIcon,
                      errorIcon: e.errorIcon,
                      deliveredIcon: e.deliveredIcon,
                      readIcon: e.readIcon,
                      receiptStyle: e.receiptStyleComputed
                    }, null, 8, gg)
                  ])) : $("", !0),
                  p("div", {
                    style: ce(e.subtitleStyle(s)),
                    class: "cc-conversations__subtitle-text",
                    innerHTML: e.setSubtitle(s)
                  }, null, 12, cg)
                ])
              ]))
            ]),
            e.selectionMode === e.SelectionMode.none ? (M(), g("div", dg, [
              e.setConversationOptions(s) ? (M(), g("div", Ig, [
                p("cometchat-menu-list", {
                  menuListStyle: e.menustyle,
                  data: e.setConversationOptions(s),
                  onCcMenuClicked: (B) => e.onOptionClick(B, s)
                }, null, 40, Ng)
              ])) : $("", !0)
            ])) : $("", !0),
            p("div", Tg, [
              e.selectionMode == e.SelectionMode.none ? (M(), g("div", Dg, [
                p("div", yg, [
                  (se = s == null ? void 0 : s.getLastMessage()) != null && se.sentAt ? (M(), g("cometchat-date", {
                    key: 0,
                    dateStyle: e.mydateStyle,
                    timestamp: (X = s == null ? void 0 : s.getLastMessage()) == null ? void 0 : X.sentAt,
                    pattern: e.datePattern
                  }, null, 8, Cg)) : $("", !0)
                ]),
                p("div", wg, [
                  p("cometchat-badge", {
                    count: s == null ? void 0 : s.getUnreadMessageCount(),
                    badgeStyle: e.mybadgeStyle
                  }, null, 8, jg)
                ])
              ])) : $("", !0)
            ]),
            e.selectionMode == e.SelectionMode.single ? (M(), g("div", Ag, [
              p("cometchat-radio-button", {
                onCcRadioButtonChanged: (B) => {
                  e.handleSelection(B, s);
                }
              }, null, 40, Lg)
            ])) : $("", !0),
            e.selectionMode == e.SelectionMode.multiple ? (M(), g("div", zg, [
              p("cometchat-checkbox", {
                onCcCheckboxChanged: (B) => {
                  e.handleSelection(B, s);
                }
              }, null, 40, Sg)
            ])) : $("", !0)
          ], 40, eg))
        ];
      }),
      _: 1
    }, 8, ["title", "titleAlignment", "list", "onScrolledToBottom", "state", "loadingIconURL", "hideError", "errorStateText", "emptyStateText", "listStyle", "onError", "errorStateView", "emptyStateView", "loadingStateView"])
  ], 4);
}
const bg = /* @__PURE__ */ $e(Hu, [["render", pg], ["__scopeId", "data-v-79a92230"]]), Eg = We({
  name: "CometChatSmartReplyBubble",
  components: {},
  props: {
    smartReplyStyle: { default: null },
    replies: { type: null },
    listeners: { type: null }
  },
  setup(e, t) {
    return {};
  }
}), hg = ["smartReplyStyle", "replies"];
function vg(e, t, n, o, i, l) {
  return M(), g("smart-replies", me({
    smartReplyStyle: e.smartReplyStyle,
    replies: e.replies
  }, xe(e.listeners ? e.listeners : {}, !0)), null, 16, hg);
}
const mg = /* @__PURE__ */ $e(Eg, [["render", vg]]), Og = (e) => ({
  display: "flex",
  overflow: "hidden",
  width: (e == null ? void 0 : e.width) || "100%",
  height: (e == null ? void 0 : e.height) || "100%",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "50px"
}), xg = (e, t) => ({
  replyTextFont: (t == null ? void 0 : t.textFont) || w(e.typography.caption1),
  replyTextColor: (t == null ? void 0 : t.textColor) || (e == null ? void 0 : e.palette.getAccent()),
  replyBackground: (t == null ? void 0 : t.textBackground) || "inherit",
  boxShadow: `0px 0px 1px ${e == null ? void 0 : e.palette.getAccent600()}`,
  background: (t == null ? void 0 : t.background) || "inherit",
  width: (t == null ? void 0 : t.width) || "100%",
  height: (t == null ? void 0 : t.height) || "100%",
  border: (t == null ? void 0 : t.textBorder) || "none",
  borderRadius: (t == null ? void 0 : t.textBorderRadius) || "8px",
  display: "flex",
  justifyContent: "flex-start"
}), kg = We({
  name: "ConversationStarterView",
  props: {
    getConversationStarterCallback: {
      type: Function,
      required: !0
    },
    configuration: {
      type: Object,
      default: () => ({})
    },
    editReplyCallback: {
      type: Function
    },
    closeCallback: {
      type: Function
    }
  },
  setup(e) {
    const t = j(ge.loading), n = j(null), o = j([]), i = Y("SOMETHING_WRONG"), l = Y("NO_MESSAGES_FOUND"), r = e.configuration.conversationStarterStyle || {}, u = Y("GENERATING_ICEBREAKERS");
    let { theme: s } = dt("theme", {
      theme: j(new Ke({}))
    });
    const c = () => {
      t.value = ge.loading, e.getConversationStarterCallback && e.getConversationStarterCallback(s.value).then((N) => {
        N ? (t.value = ge.loaded, n.value = d(N)) : t.value = ge.empty;
      }).catch((N) => {
        t.value = ge.error;
      });
    }, d = (N) => {
      var T;
      if ((T = e.configuration) != null && T.customView)
        return e.configuration.customView(N, e.closeCallback);
      o.value = N;
    };
    return c(), {
      starterViewStyle: r,
      errorStateText: i,
      loadingStateText: u,
      emptyStateText: l,
      fetchButtonContent: c,
      getConversationStarterStyle: xg,
      theme: s,
      States: ge,
      getContainerStyle: Og,
      localize: Y,
      messageListState: t,
      loadingIconURL: nn,
      errorIconURL: bo,
      emptyIconURL: bo,
      activeView: n,
      replies: o
    };
  }
}), fg = { key: 0 }, Ug = { key: 0 }, Bg = ["innerHTML"], Qg = ["v-slot", "v-html"], Rg = { key: 1 }, Yg = ["smartReplyStyle", "replies"], Vg = {
  key: 1,
  class: "cc__loading-state"
}, Gg = ["state", "loadingIconURL", "loadingStateText"], Pg = {
  key: 0,
  class: "cc-list__custom-view-loading"
}, Fg = ["innerHTML"], Hg = ["v-slot", "v-html"], Zg = {
  key: 2,
  class: "cc__error-state"
}, Wg = ["state", "errorIconURL", "errorStateText"], $g = {
  key: 0,
  class: "cc-list__custom-view-error"
}, Jg = ["innerHTML"], Kg = ["v-slot", "v-html"], Xg = {
  key: 3,
  class: "cc__empty-state"
}, qg = ["state", "emptyIconURL", "emptyStateText"], _g = {
  key: 0,
  class: "cc-list__custom-view-empty"
}, ec = ["innerHTML"], tc = ["v-slot", "v-html"];
function nc(e, t, n, o, i, l) {
  var r, u, s, c, d, N, T, m, A, D, z, k, R, Q, h, O, x, _, oe, ie, re, Ae, se, X, B, F;
  return M(), g("div", {
    class: "slideable-container",
    style: ce(e.getContainerStyle(e.starterViewStyle))
  }, [
    e.messageListState === e.States.loaded ? (M(), g("div", fg, [
      e.activeView ? (M(), g("div", Ug, [
        e.activeView && e.activeView.html ? (M(), g("div", {
          key: 0,
          innerHTML: e.activeView.html
        }, null, 8, Bg)) : e.activeView && e.activeView.componentName ? (M(), je(fe(e.activeView.componentName), me({ key: 1 }, { ...e.activeView.props }, xe((r = e.activeView) == null ? void 0 : r.listeners)), {
          default: be(() => [
            (M(!0), g(we, null, pe(e.activeView.slots, (G, J) => (M(), g("div", {
              key: J,
              "v-slot": [J],
              "v-html": G
            }, null, 8, Qg))), 128))
          ]),
          _: 1
        }, 16)) : $("", !0)
      ])) : $("", !0),
      e.replies ? (M(), g("div", Rg, [
        p("smart-replies", {
          smartReplyStyle: e.getConversationStarterStyle(e.theme, (u = e.configuration) == null ? void 0 : u.conversationStarterStyle),
          replies: e.replies,
          onCcReplyClicked: t[0] || (t[0] = (G) => {
            var J;
            e.editReplyCallback && e.editReplyCallback((J = G == null ? void 0 : G.detail) == null ? void 0 : J.reply), e.closeCallback();
          }),
          key: "conversation-starter",
          closeIconURL: ""
        }, null, 40, Yg)
      ])) : $("", !0)
    ])) : e.messageListState === e.States.loading ? (M(), g("div", Vg, [
      p("cometchat-ai-card", {
        state: e.States.loading,
        style: ce(e.starterViewStyle),
        loadingIconURL: ((s = e.configuration) == null ? void 0 : s.loadingIconURL) || e.loadingIconURL,
        loadingStateText: e.loadingStateText
      }, [
        (c = e.configuration) != null && c.loadingStateView ? (M(), g("div", Pg, [
          (d = e.configuration) != null && d.loadingStateView.html ? (M(), g("div", {
            key: 0,
            innerHTML: (N = e.configuration) == null ? void 0 : N.loadingStateView.html
          }, null, 8, Fg)) : (M(), je(fe((T = e.configuration) == null ? void 0 : T.loadingStateView.componentName), me({ key: 1 }, xe((A = (m = e.configuration) == null ? void 0 : m.loadingStateView) == null ? void 0 : A.listeners), { ...(D = e.configuration) == null ? void 0 : D.loadingStateView.props }), {
            default: be(() => {
              var G;
              return [
                (M(!0), g(we, null, pe((G = e.configuration) == null ? void 0 : G.loadingStateView.slots, (J, ee) => (M(), g("div", {
                  key: ee,
                  "v-slot": [ee],
                  "v-html": J
                }, null, 8, Hg))), 128))
              ];
            }),
            _: 1
          }, 16))
        ])) : $("", !0)
      ], 12, Gg)
    ])) : e.messageListState === e.States.error ? (M(), g("div", Zg, [
      p("cometchat-ai-card", {
        state: e.States.error,
        style: ce(e.starterViewStyle),
        errorIconURL: ((z = e.configuration) == null ? void 0 : z.errorIconURL) || e.errorIconURL,
        errorStateText: e.errorStateText
      }, [
        (k = e.configuration) != null && k.errorStateView ? (M(), g("div", $g, [
          (R = e.configuration) != null && R.errorStateView.html ? (M(), g("div", {
            key: 0,
            innerHTML: (Q = e.configuration) == null ? void 0 : Q.errorStateView.html
          }, null, 8, Jg)) : (M(), je(fe((h = e.configuration) == null ? void 0 : h.errorStateView.componentName), me({ key: 1 }, xe((x = (O = e.configuration) == null ? void 0 : O.errorStateView) == null ? void 0 : x.listeners), { ...(_ = e.configuration) == null ? void 0 : _.errorStateView.props }), {
            default: be(() => {
              var G;
              return [
                (M(!0), g(we, null, pe((G = e.configuration) == null ? void 0 : G.errorStateView.slots, (J, ee) => (M(), g("div", {
                  key: ee,
                  "v-slot": [ee],
                  "v-html": J
                }, null, 8, Kg))), 128))
              ];
            }),
            _: 1
          }, 16))
        ])) : $("", !0)
      ], 12, Wg)
    ])) : e.messageListState === e.States.empty ? (M(), g("div", Xg, [
      p("cometchat-ai-card", {
        state: e.States.empty,
        style: ce(e.starterViewStyle),
        emptyIconURL: ((oe = e.configuration) == null ? void 0 : oe.emptyIconURL) || e.emptyIconURL,
        emptyStateText: e.emptyStateText
      }, [
        (ie = e.configuration) != null && ie.emptyStateView ? (M(), g("div", _g, [
          (re = e.configuration) != null && re.emptyStateView.html ? (M(), g("div", {
            key: 0,
            innerHTML: (Ae = e.configuration) == null ? void 0 : Ae.emptyStateView.html
          }, null, 8, ec)) : (M(), je(fe((se = e.configuration) == null ? void 0 : se.emptyStateView.componentName), me({ key: 1 }, xe((B = (X = e.configuration) == null ? void 0 : X.emptyStateView) == null ? void 0 : B.listeners), { ...(F = e.configuration) == null ? void 0 : F.emptyStateView.props }), {
            default: be(() => {
              var G;
              return [
                (M(!0), g(we, null, pe((G = e.configuration) == null ? void 0 : G.emptyStateView.slots, (J, ee) => (M(), g("div", {
                  key: ee,
                  "v-slot": [ee],
                  "v-html": J
                }, null, 8, tc))), 128))
              ];
            }),
            _: 1
          }, 16))
        ])) : $("", !0)
      ], 12, qg)
    ])) : $("", !0)
  ], 4);
}
const oc = /* @__PURE__ */ $e(kg, [["render", nc]]), ic = (e) => ({
  display: "flex",
  overflow: "hidden",
  width: (e == null ? void 0 : e.width) || "100%",
  height: (e == null ? void 0 : e.height) || "100%",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "50px"
}), ac = (e, t) => new zl({
  width: "100%",
  height: "fit-content",
  border: `1px solid ${e.palette.getPrimary()}`,
  borderRadius: "8px",
  background: e.palette.getBackground(),
  textColor: (t == null ? void 0 : t.textColor) || e.palette.getAccent600(),
  titleColor: (t == null ? void 0 : t.titleTextColor) || e.palette.getAccent(),
  textFont: (t == null ? void 0 : t.textFont) || w(e.typography.text2),
  titleFont: (t == null ? void 0 : t.titleTextFont) || w(e.typography.text1)
}), rc = We({
  name: "ConversationSummaryView",
  props: {
    getConversationSummaryCallback: {
      type: Function,
      required: !0
    },
    configuration: {
      type: Object,
      default: () => ({})
    },
    closeCallback: {
      type: Function,
      default: null
    }
  },
  setup(e) {
    const t = j(ge.loading), n = j(null), o = Y("SOMETHING_WRONG"), i = Y("NO_MESSAGES_FOUND"), l = Y("GENERATING_SUMMARY"), r = Y("CONVERSATION_SUMMARY"), u = j(null), s = e.configuration.conversationSummaryStyle || {};
    let { theme: c } = dt("theme", {
      theme: j(new Ke({}))
    });
    const d = () => {
      t.value = ge.loading, e.getConversationSummaryCallback && e.getConversationSummaryCallback(c.value).then((T) => {
        T ? (t.value = ge.loaded, n.value = N(T)) : t.value = ge.empty;
      }).catch((T) => {
        t.value = ge.error;
      });
    }, N = (T) => {
      var m;
      if ((m = e.configuration) != null && m.customView)
        return e.configuration.customView(T, e.closeCallback);
      u.value = T;
    };
    return d(), {
      summaryViewStyle: s,
      errorStateText: o,
      loadingStateText: l,
      emptyStateText: i,
      titleText: r,
      fetchButtonContent: d,
      theme: c,
      States: ge,
      getContainerStyle: ic,
      localize: Y,
      getPanelStyle: ac,
      messageListState: t,
      loadingIconURL: nn,
      errorIconURL: bo,
      emptyIconURL: bo,
      activeView: n,
      summary: u
    };
  }
}), lc = {
  key: 0,
  style: { width: "100%" }
}, sc = { key: 0 }, Mc = ["innerHTML"], uc = ["v-slot", "v-html"], gc = { key: 1 }, cc = ["title", "text", "panelStyle"], dc = {
  key: 1,
  class: "cc__loading-state"
}, Ic = ["state", "loadingIconURL", "loadingStateText"], Nc = {
  key: 0,
  class: "cc-list__custom-view-loading"
}, Tc = ["innerHTML"], Dc = ["v-slot", "v-html"], yc = {
  key: 2,
  class: "cc__error-state"
}, Cc = ["state", "errorIconURL", "errorStateText"], wc = {
  key: 0,
  class: "cc-list__custom-view-error"
}, jc = ["innerHTML"], Ac = ["v-slot", "v-html"], Lc = {
  key: 3,
  class: "cc__empty-state"
}, zc = ["state", "emptyIconURL", "emptyStateText"], Sc = {
  key: 0,
  class: "cc-list__custom-view-empty"
}, pc = ["innerHTML"], bc = ["v-slot", "v-html"];
function Ec(e, t, n, o, i, l) {
  var r, u, s, c, d, N, T, m, A, D, z, k, R, Q, h, O, x, _, oe, ie, re, Ae, se, X, B;
  return M(), g("div", {
    class: "slideable-container",
    style: ce(e.getContainerStyle(e.summaryViewStyle))
  }, [
    e.messageListState === e.States.loaded ? (M(), g("div", lc, [
      e.activeView ? (M(), g("div", sc, [
        e.activeView && e.activeView.html ? (M(), g("div", {
          key: 0,
          innerHTML: e.activeView.html
        }, null, 8, Mc)) : e.activeView && e.activeView.componentName ? (M(), je(fe(e.activeView.componentName), me({ key: 1 }, { ...e.activeView.props }, xe((r = e.activeView) == null ? void 0 : r.listeners)), {
          default: be(() => [
            (M(!0), g(we, null, pe(e.activeView.slots, (F, G) => (M(), g("div", {
              key: G,
              "v-slot": [G],
              "v-html": F
            }, null, 8, uc))), 128))
          ]),
          _: 1
        }, 16)) : $("", !0)
      ])) : $("", !0),
      e.summary ? (M(), g("div", gc, [
        p("cometchat-panel", {
          style: { display: "block", margin: "0px 15px" },
          title: e.titleText,
          text: e.summary,
          panelStyle: e.getPanelStyle(e.theme, e.summaryViewStyle),
          onCcCloseClicked: t[0] || (t[0] = () => e.closeCallback ? e.closeCallback() : null)
        }, null, 40, cc)
      ])) : $("", !0)
    ])) : e.messageListState === e.States.loading ? (M(), g("div", dc, [
      p("cometchat-ai-card", {
        state: e.States.loading,
        style: ce(e.summaryViewStyle),
        loadingIconURL: ((u = e.configuration) == null ? void 0 : u.loadingIconURL) || e.loadingIconURL,
        loadingStateText: e.loadingStateText
      }, [
        (s = e.configuration) != null && s.loadingStateView ? (M(), g("div", Nc, [
          (c = e.configuration) != null && c.loadingStateView.html ? (M(), g("div", {
            key: 0,
            innerHTML: (d = e.configuration) == null ? void 0 : d.loadingStateView.html
          }, null, 8, Tc)) : (M(), je(fe((N = e.configuration) == null ? void 0 : N.loadingStateView.componentName), me({ key: 1 }, xe((m = (T = e.configuration) == null ? void 0 : T.loadingStateView) == null ? void 0 : m.listeners), { ...(A = e.configuration) == null ? void 0 : A.loadingStateView.props }), {
            default: be(() => {
              var F;
              return [
                (M(!0), g(we, null, pe((F = e.configuration) == null ? void 0 : F.loadingStateView.slots, (G, J) => (M(), g("div", {
                  key: J,
                  "v-slot": [J],
                  "v-html": G
                }, null, 8, Dc))), 128))
              ];
            }),
            _: 1
          }, 16))
        ])) : $("", !0)
      ], 12, Ic)
    ])) : e.messageListState === e.States.error ? (M(), g("div", yc, [
      p("cometchat-ai-card", {
        state: e.States.error,
        style: ce(e.summaryViewStyle),
        errorIconURL: ((D = e.configuration) == null ? void 0 : D.errorIconURL) || e.errorIconURL,
        errorStateText: e.errorStateText
      }, [
        (z = e.configuration) != null && z.errorStateView ? (M(), g("div", wc, [
          (k = e.configuration) != null && k.errorStateView.html ? (M(), g("div", {
            key: 0,
            innerHTML: (R = e.configuration) == null ? void 0 : R.errorStateView.html
          }, null, 8, jc)) : (M(), je(fe((Q = e.configuration) == null ? void 0 : Q.errorStateView.componentName), me({ key: 1 }, xe((O = (h = e.configuration) == null ? void 0 : h.errorStateView) == null ? void 0 : O.listeners), { ...(x = e.configuration) == null ? void 0 : x.errorStateView.props }), {
            default: be(() => {
              var F;
              return [
                (M(!0), g(we, null, pe((F = e.configuration) == null ? void 0 : F.errorStateView.slots, (G, J) => (M(), g("div", {
                  key: J,
                  "v-slot": [J],
                  "v-html": G
                }, null, 8, Ac))), 128))
              ];
            }),
            _: 1
          }, 16))
        ])) : $("", !0)
      ], 12, Cc)
    ])) : e.messageListState === e.States.empty ? (M(), g("div", Lc, [
      p("cometchat-ai-card", {
        state: e.States.empty,
        style: ce(e.summaryViewStyle),
        emptyIconURL: ((_ = e.configuration) == null ? void 0 : _.emptyIconURL) || e.emptyIconURL,
        emptyStateText: e.emptyStateText
      }, [
        (oe = e.configuration) != null && oe.emptyStateView ? (M(), g("div", Sc, [
          (ie = e.configuration) != null && ie.emptyStateView.html ? (M(), g("div", {
            key: 0,
            innerHTML: (re = e.configuration) == null ? void 0 : re.emptyStateView.html
          }, null, 8, pc)) : (M(), je(fe((Ae = e.configuration) == null ? void 0 : Ae.emptyStateView.componentName), me({ key: 1 }, xe((X = (se = e.configuration) == null ? void 0 : se.emptyStateView) == null ? void 0 : X.listeners), { ...(B = e.configuration) == null ? void 0 : B.emptyStateView.props }), {
            default: be(() => {
              var F;
              return [
                (M(!0), g(we, null, pe((F = e.configuration) == null ? void 0 : F.emptyStateView.slots, (G, J) => (M(), g("div", {
                  key: J,
                  "v-slot": [J],
                  "v-html": G
                }, null, 8, bc))), 128))
              ];
            }),
            _: 1
          }, 16))
        ])) : $("", !0)
      ], 12, zc)
    ])) : $("", !0)
  ], 4);
}
const hc = /* @__PURE__ */ $e(rc, [["render", Ec]]), vc = We({
  name: "CometChatConfirmDialogView",
  components: {},
  props: {
    backdropStyle: { type: y.User },
    title: { type: y.Group },
    warningText: { type: String },
    cancelText: { type: String },
    confirmText: { type: String },
    confirmDialogStyle: { type: String },
    listeners: {
      type: null
    }
  },
  setup(e, t) {
    return {};
  }
}), mc = ["backdropStyle"], Oc = ["messageText", "cancelButtonText", "confirmButtonText", "confirmDialogStyle"];
function xc(e, t, n, o, i, l) {
  return M(), g("cometchat-backdrop", { backdropStyle: e.backdropStyle }, [
    p("cometchat-confirm-dialog", me({
      title: "",
      messageText: e.warningText,
      cancelButtonText: e.cancelText,
      confirmButtonText: e.confirmText,
      confirmDialogStyle: e.confirmDialogStyle
    }, xe(e.listeners ? e.listeners : {}, !0)), null, 16, Oc)
  ], 8, mc);
}
const kc = /* @__PURE__ */ $e(vc, [["render", xc]]), fc = We({
  name: "CometChatTextBubble",
  components: {},
  props: {
    text: { type: String, default: null },
    textStyle: { type: Object },
    textFormatters: { type: Array }
  },
  setup(e, t) {
    return {};
  }
}), Uc = ["text", "textStyle", "textFormatters"];
function Bc(e, t, n, o, i, l) {
  return M(), g("cometchat-text-bubble", {
    text: e.text,
    textStyle: e.textStyle,
    textFormatters: e.textFormatters
  }, null, 8, Uc);
}
const Qc = /* @__PURE__ */ $e(fc, [["render", Bc]]), Rc = We({
  name: "CometChatFormBubble",
  components: {},
  props: {
    formBubbleStyle: { type: Object },
    message: { type: Object },
    submitClicked: { type: Function },
    hasCustomCallback: { type: Boolean, default: !1 }
  },
  setup() {
    return {};
  }
}), Yc = ["formBubbleStyle", "message", "hasCustomCallback"];
function Vc(e, t, n, o, i, l) {
  return M(), g("cometchat-form-bubble", {
    formBubbleStyle: e.formBubbleStyle,
    message: e.message,
    onCcSubmitClicked: t[0] || (t[0] = (...r) => e.submitClicked && e.submitClicked(...r)),
    hasCustomCallback: e.hasCustomCallback
  }, null, 40, Yc);
}
const Gc = /* @__PURE__ */ $e(Rc, [["render", Vc]]), Pc = We({
  name: "CometChatCardBubble",
  components: {},
  props: {
    cardBubbleStyle: { type: Object },
    message: { type: Object }
  },
  setup() {
    return {};
  }
}), Fc = ["cardBubbleStyle", "message"];
function Hc(e, t, n, o, i, l) {
  return M(), g("cometchat-card-bubble", {
    cardBubbleStyle: e.cardBubbleStyle,
    message: e.message
  }, null, 8, Fc);
}
const Zc = /* @__PURE__ */ $e(Pc, [["render", Hc]]), Wc = We({
  name: "CometChatAudioBubble",
  components: {},
  props: {
    audioUrl: { type: String, default: null },
    audioStyle: { type: null }
  },
  setup(e, t) {
    return {};
  }
}), $c = ["src", "audioStyle"];
function Jc(e, t, n, o, i, l) {
  return M(), g("cometchat-audio-bubble", {
    src: e.audioUrl,
    audioStyle: e.audioStyle
  }, null, 8, $c);
}
const Kc = /* @__PURE__ */ $e(Wc, [["render", Jc]]), Xc = We({
  name: "CometChatFileBubble",
  components: {},
  props: {
    downloadIconURL: { type: String, default: null },
    subtitle: { type: String },
    title: { type: String },
    fileURL: { type: String },
    fileStyle: {
      type: Object
    }
  },
  setup(e, t) {
    return {};
  }
}), qc = ["downloadIconURL", "subtitle", "title", "fileURL", "fileStyle"];
function _c(e, t, n, o, i, l) {
  return M(), g("cometchat-file-bubble", {
    downloadIconURL: e.downloadIconURL,
    subtitle: e.subtitle,
    title: e.title,
    fileURL: e.fileURL,
    fileStyle: e.fileStyle
  }, null, 8, qc);
}
const ed = /* @__PURE__ */ $e(Xc, [["render", _c]]), td = We({
  name: "CometChatImageBubble",
  components: {},
  props: {
    src: { type: String, default: null },
    placeholderImage: { type: null },
    imageStyle: { type: null },
    message: { type: null }
  },
  setup(e, t) {
    let n = j(!1), o = j("");
    return {
      openImageInFullScreen: (u) => {
        var s, c;
        o.value = ((c = (s = e.message) == null ? void 0 : s.getAttachments()[0]) == null ? void 0 : c.getUrl()) ?? u.detail.url, n.value = !0;
      },
      openFullscreenView: n,
      imageurlToOpen: o,
      Close2xIcon: Cn,
      fullScreenViewerStyle: {
        closeIconTint: "white"
      },
      closeImageInFullScreen: () => {
        o.value = "", n.value = !1;
      }
    };
  }
}), nd = ["src", "placeholderImage", "imageStyle"], od = ["URL", "closeIconURL", "fullScreenViewerStyle"];
function id(e, t, n, o, i, l) {
  return M(), g(we, null, [
    p("cometchat-image-bubble", {
      src: e.src,
      placeholderImage: e.placeholderImage,
      imageStyle: { height: "auto", maxHeight: "500px", maxWidth: "400px", borderRadius: "8px", ...e.imageStyle },
      onCcImageClicked: t[0] || (t[0] = (...r) => e.openImageInFullScreen && e.openImageInFullScreen(...r))
    }, null, 40, nd),
    e.openFullscreenView ? (M(), g("cometchat-full-screen-viewer", {
      key: 0,
      onCcCloseClicked: t[1] || (t[1] = (...r) => e.closeImageInFullScreen && e.closeImageInFullScreen(...r)),
      URL: e.imageurlToOpen,
      closeIconURL: e.Close2xIcon,
      fullScreenViewerStyle: e.fullScreenViewerStyle
    }, null, 40, od)) : $("", !0)
  ], 64);
}
const nr = /* @__PURE__ */ $e(td, [["render", id]]), ad = We({
  name: "CometChatVideoBubble",
  components: {},
  props: {
    videoStyle: { type: null },
    src: { type: String, default: null },
    poster: { type: null }
  },
  setup(e, t) {
    return {};
  }
}), rd = ["src", "videoStyle", "poster"];
function ld(e, t, n, o, i, l) {
  return M(), g("cometchat-video-bubble", {
    src: e.src,
    videoStyle: e.videoStyle,
    poster: e.poster
  }, null, 8, rd);
}
const sd = /* @__PURE__ */ $e(ad, [["render", ld]]), Md = We({
  name: "CometChatDocumentExtensionBubble",
  components: {},
  props: {
    iconURL: { type: String },
    title: { type: String },
    URL: { type: String },
    subtitle: { type: String },
    buttonText: { type: String },
    documentStyle: { type: null },
    hideSeparator: { type: Boolean, default: !1 },
    iconAlignment: { type: Number },
    listeners: { type: null },
    ccClicked: { type: null }
  },
  setup(e, t) {
    return {};
  }
}), ud = ["iconURL", "title", "URL", "subtitle", "buttonText", "documentStyle", "hideSeparator", "iconAlignment", "ccClicked"];
function gd(e, t, n, o, i, l) {
  return M(), g("cometchat-document-bubble", {
    iconURL: e.iconURL,
    title: e.title,
    URL: e.URL,
    subtitle: e.subtitle,
    buttonText: e.buttonText,
    documentStyle: e.documentStyle,
    hideSeparator: e.hideSeparator,
    iconAlignment: e.iconAlignment,
    ccClicked: e.ccClicked
  }, null, 8, ud);
}
const cd = /* @__PURE__ */ $e(Md, [["render", gd]]), dd = We({
  name: "CometChatPollsBubble",
  components: {},
  props: {
    pollStyle: { type: Object },
    pollQuestion: { type: null },
    pollId: { type: null },
    senderUid: { type: null },
    loggedInUser: { type: y.User },
    metadata: { type: null }
  },
  setup(e, t) {
    return {};
  }
}), Id = ["pollStyle", "pollQuestion", "pollId", "senderUid", "loggedInUser", "metadata"];
function Nd(e, t, n, o, i, l) {
  return M(), g("polls-bubble", {
    pollStyle: e.pollStyle,
    pollQuestion: e.pollQuestion,
    pollId: e.pollId,
    senderUid: e.senderUid,
    loggedInUser: e.loggedInUser,
    metadata: e.metadata
  }, null, 8, Id);
}
const Td = /* @__PURE__ */ $e(dd, [["render", Nd]]), Dd = We({
  name: "CometChatLinkPreviewBubble",
  components: {},
  props: {
    title: { type: String },
    description: { type: String },
    URL: { type: String },
    image: { type: String },
    favIconURL: { type: String },
    linkPreviewStyle: { type: Object },
    textStyle: { type: Object },
    text: { type: String },
    listeners: {
      type: null
    },
    textFormatters: { type: Array }
  },
  setup(e, t) {
    return {};
  }
}), yd = ["title", "description", "URL", "image", "favIconURL", "linkPreviewStyle"], Cd = ["text", "textStyle", "textFormatters"];
function wd(e, t, n, o, i, l) {
  return M(), g("link-preview", me({
    title: e.title,
    description: e.description,
    URL: e.URL,
    image: e.image,
    favIconURL: e.favIconURL,
    linkPreviewStyle: e.linkPreviewStyle
  }, xe(e.listeners ? e.listeners : {}, !0)), [
    p("cometchat-text-bubble", {
      text: e.text,
      textStyle: e.textStyle,
      textFormatters: e.textFormatters
    }, null, 8, Cd)
  ], 16, yd);
}
const jd = /* @__PURE__ */ $e(Dd, [["render", wd]]), Ad = We({
  name: "CometChatImageModerationBubble",
  components: { CometChatImageBubble: nr },
  props: {
    message: { type: null },
    imageModerationStyle: { type: null },
    src: { type: null },
    placeholderImage: { type: null },
    listeners: { type: null }
  },
  setup(e, t) {
    return {};
  }
}), Ld = ["message", "imageModerationStyle"];
function zd(e, t, n, o, i, l) {
  const r = Je("CometChatImageBubble");
  return M(), g("image-moderation", me({
    message: e.message,
    imageModerationStyle: e.imageModerationStyle
  }, xe(e.listeners ? e.listeners : {}, !0)), [
    Nt(r, {
      src: e.src,
      placeholderImage: e.placeholderImage
    }, null, 8, ["src", "placeholderImage"])
  ], 16, Ld);
}
const Sd = /* @__PURE__ */ $e(Ad, [["render", zd]]), pd = We({
  name: "CometChatMessageTranslationBubble",
  components: {},
  props: {
    translatedText: { type: String },
    alignment: { type: Object },
    messageTranslationStyle: { type: di },
    textStyle: { type: null },
    text: { type: String },
    textFormatters: { type: Array }
  },
  setup(e, t) {
    return {};
  }
}), bd = ["textStyle", "text", "textFormatters"];
function Ed(e, t, n, o, i, l) {
  const r = Je("message-translation-bubble");
  return M(), je(r, {
    translatedText: e.translatedText,
    alignment: e.alignment,
    messageTranslationStyle: e.messageTranslationStyle,
    textFormatters: e.textFormatters
  }, {
    default: be(() => [
      p("cometchat-text-bubble", {
        textStyle: e.textStyle,
        text: e.text,
        textFormatters: e.textFormatters
      }, null, 8, bd)
    ]),
    _: 1
  }, 8, ["translatedText", "alignment", "messageTranslationStyle", "textFormatters"]);
}
const hd = /* @__PURE__ */ $e(pd, [["render", Ed]]), vd = We({
  name: "CometChatContextMenu",
  components: {},
  props: {
    data: {
      type: Object
    },
    topMenuSize: { type: Number },
    moreIconURL: { type: String },
    moreIconHoverText: { type: String },
    ContextMenuStyle: {
      type: Object,
      default: new Sl({})
    },
    onOptionClicked: { type: null },
    placement: { type: String }
  },
  setup(e, t) {
    var Q;
    let { theme: n, switchThemeMode: o } = dt(
      "theme",
      new Ke({})
    ), i = j(!1), l = j(null), r = j(null);
    const u = e.data.slice(0, e.topMenuSize - 1), s = e.data.slice(e.topMenuSize - 1), c = {
      width: "300px",
      height: "300px"
    }, d = {
      background: "transparent",
      border: "none",
      borderRadius: "inherit"
    }, N = (h, O = !1) => ({
      ...d,
      background: (h == null ? void 0 : h.backgroundColor) || "transparent",
      border: "none",
      borderRadius: "0",
      buttonIconTint: h == null ? void 0 : h.iconTint,
      buttonTextFont: h == null ? void 0 : h.titleFont,
      buttonTextColor: h == null ? void 0 : h.titleColor,
      gap: O && (h != null && h.title) && (h != null && h.iconURL) ? "10px" : "0"
    }), T = {
      background: "transparent",
      border: "none",
      borderRadius: "0",
      buttonIconTint: (Q = e.ContextMenuStyle) == null ? void 0 : Q.moreIconTint
    };
    return {
      menuItemStyle: () => ({
        background: "transparent",
        padding: "4px 4px"
      }),
      popoverStyle: c,
      menuButtonStyle: N,
      contextMenuStyle: () => ({
        display: "flex",
        position: "relative"
      }),
      topMenuStyle: () => ({
        listStyleType: "none",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        margin: "0",
        padding: "0",
        border: "1px solid #e8e8e8",
        zIndex: "2",
        borderRadius: "8px"
      }),
      subMenuStyle: (h) => ({
        listStyleType: "none",
        display: h ? "flex" : "none",
        position: "absolute",
        right: "5px",
        top: "0",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        border: "1px solid #e8e8e8",
        width: "100%",
        zIndex: "3",
        background: n.value.palette.getBackground(),
        marginTop: "35px",
        padding: "0",
        borderRadius: "8px"
      }),
      buttonStyle: d,
      handleMenuClick: () => i.value = !i.value,
      showSubMenu: i,
      topMenu: u,
      subMenu: s,
      moreButtonStyle: T,
      getClosePopOverHandler: (h, O = !1) => {
        let x = O ? r.value : l.value;
        return (_) => {
          x[h].openContentView(_);
        };
      },
      topMenuPopOverRef: l,
      subMenuPopOverRef: r
    };
  }
}), md = ["popoverStyle", "placement"], Od = { slot: "children" }, xd = ["buttonStyle", "hoverText", "iconURL"], kd = { slot: "content" }, fd = ["innerHTML"], Ud = ["v-slot", "v-html"], Bd = ["buttonStyle", "hoverText", "iconURL", "onCcButtonClicked"], Qd = ["buttonStyle", "hoverText", "iconURL"], Rd = { key: 0 }, Yd = ["popoverStyle", "placement"], Vd = { slot: "children" }, Gd = ["buttonStyle", "text", "hoverText", "iconURL"], Pd = { slot: "content" }, Fd = ["innerHTML"], Hd = ["v-slot", "v-html"], Zd = { key: 1 }, Wd = ["buttonStyle", "text", "hoverText", "iconURL", "onCcButtonClicked"];
function $d(e, t, n, o, i, l) {
  return M(), g("div", {
    className: "cc-context-menu",
    style: ce(e.contextMenuStyle())
  }, [
    p("ul", {
      className: "cc-context-menu__top-menu",
      style: ce(e.topMenuStyle())
    }, [
      (M(!0), g(we, null, pe(e.topMenu, (r, u) => {
        var s, c, d, N, T, m;
        return M(), g(we, { key: u }, [
          r.customView ? (M(), g("li", {
            key: 0,
            style: ce(e.menuItemStyle()),
            class: "cc-context-menu__menu-item"
          }, [
            p("cometchat-popover", {
              popoverStyle: e.popoverStyle,
              placement: e.placement,
              ref_for: !0,
              ref: "topMenuPopOverRef"
            }, [
              p("div", Od, [
                p("cometchat-button", {
                  buttonStyle: e.menuButtonStyle(r),
                  text: "",
                  hoverText: r.title,
                  iconURL: r.iconURL
                }, null, 8, xd)
              ]),
              p("div", kd, [
                (s = r.customView(e.getClosePopOverHandler(u))) != null && s.html ? (M(), g("div", {
                  key: 0,
                  innerHTML: (c = r.customView(e.getClosePopOverHandler(u))) == null ? void 0 : c.html
                }, null, 8, fd)) : (M(), je(fe((d = r.customView(e.getClosePopOverHandler(u))) == null ? void 0 : d.componentName), me({ key: 1 }, xe(
                  (N = r.customView(e.getClosePopOverHandler(u))) != null && N.listeners ? (T = r.customView(e.getClosePopOverHandler(u))) == null ? void 0 : T.listeners : {}
                ), { ref_for: !0 }, {
                  ...(m = r.customView(e.getClosePopOverHandler(u))) == null ? void 0 : m.props
                }), {
                  default: be(() => {
                    var A;
                    return [
                      (M(!0), g(we, null, pe((A = r.customView(
                        e.getClosePopOverHandler(u)
                      )) == null ? void 0 : A.slots, (D, z) => (M(), g("div", {
                        key: z,
                        "v-slot": [z],
                        "v-html": D
                      }, null, 8, Ud))), 128))
                    ];
                  }),
                  _: 2
                }, 1040))
              ])
            ], 8, md)
          ], 4)) : (M(), g("li", {
            key: 1,
            style: ce(e.menuItemStyle()),
            class: "cc-context-menu__menu-item",
            ref_for: !0,
            ref: "topMenuPopOverRef"
          }, [
            p("cometchat-button", {
              buttonStyle: e.menuButtonStyle(r),
              text: "",
              hoverText: r.title,
              iconURL: r.iconURL,
              onCcButtonClicked: () => {
                e.onOptionClicked(r);
              }
            }, null, 40, Bd)
          ], 4)),
          e.data.length > e.topMenu.length && u === e.topMenu.length - 1 ? (M(), g("li", {
            key: 2,
            style: ce(e.menuItemStyle()),
            class: "cc-context-menu__menu-item"
          }, [
            p("cometchat-button", {
              buttonStyle: e.moreButtonStyle,
              hoverText: e.moreIconHoverText,
              iconURL: e.moreIconURL,
              onCcButtonClicked: t[0] || (t[0] = (...A) => e.handleMenuClick && e.handleMenuClick(...A))
            }, null, 40, Qd)
          ], 4)) : $("", !0)
        ], 64);
      }), 128))
    ], 4),
    e.showSubMenu ? (M(), g("ul", {
      key: 0,
      className: "cc-context-menu__sub-menu",
      style: ce(e.subMenuStyle(!0))
    }, [
      (M(!0), g(we, null, pe(e.subMenu, (r, u) => {
        var s, c, d, N, T, m;
        return M(), g("li", {
          key: u,
          style: ce(e.menuItemStyle()),
          class: "cc-context-menu__menu-item"
        }, [
          r.customView ? (M(), g("div", Rd, [
            p("cometchat-popover", {
              popoverStyle: e.popoverStyle,
              placement: e.placement,
              ref_for: !0,
              ref: "subMenuPopOverRef"
            }, [
              p("div", Vd, [
                p("cometchat-button", {
                  buttonStyle: e.menuButtonStyle(r, !0),
                  text: r.title || "",
                  hoverText: r.title,
                  iconURL: r.iconURL
                }, null, 8, Gd)
              ]),
              p("div", Pd, [
                (s = r.customView(e.getClosePopOverHandler(u, !0))) != null && s.html ? (M(), g("div", {
                  key: 0,
                  innerHTML: (c = r.customView(e.getClosePopOverHandler(u, !0))) == null ? void 0 : c.html
                }, null, 8, Fd)) : (M(), je(fe((d = r.customView(e.getClosePopOverHandler(u, !0))) == null ? void 0 : d.componentName), me({ key: 1 }, xe(
                  (N = r.customView(e.getClosePopOverHandler(u, !0))) != null && N.listeners ? (T = r.customView(
                    e.getClosePopOverHandler(u, !0)
                  )) == null ? void 0 : T.listeners : {}
                ), { ref_for: !0 }, {
                  ...(m = r.customView(e.getClosePopOverHandler(u, !0))) == null ? void 0 : m.props
                }), {
                  default: be(() => {
                    var A;
                    return [
                      (M(!0), g(we, null, pe((A = r.customView(
                        e.getClosePopOverHandler(u, !0)
                      )) == null ? void 0 : A.slots, (D, z) => (M(), g("div", {
                        key: z,
                        "v-slot": [z],
                        "v-html": D
                      }, null, 8, Hd))), 128))
                    ];
                  }),
                  _: 2
                }, 1040))
              ])
            ], 8, Yd)
          ])) : (M(), g("div", Zd, [
            p("li", {
              style: ce(e.menuItemStyle()),
              class: "cc-context-menu__menu-item"
            }, [
              p("cometchat-button", {
                ref_for: !0,
                ref: "subMenuPopOverRef",
                buttonStyle: e.menuButtonStyle(r, !0),
                text: r.title || "",
                hoverText: r.title,
                iconURL: r.iconURL,
                onCcButtonClicked: () => {
                  e.onOptionClicked(r);
                }
              }, null, 40, Wd)
            ], 4)
          ]))
        ], 4);
      }), 128))
    ], 4)) : $("", !0)
  ], 4);
}
const Jd = /* @__PURE__ */ $e(vd, [["render", $d]]), Kd = We({
  name: "CometChatSchedulerBubble",
  components: {},
  props: {
    schedulerMessage: { type: Object },
    loggedInUser: { type: Object },
    goalCompletionText: { type: String, default: Y("MEETING_SCHEDULED") },
    onScheduleClick: { type: Function },
    backButtonIconURL: { type: String, default: null },
    loadingIconURL: { type: String, default: null },
    clockIconURL: { type: String, default: null },
    calendarIconURL: { type: String, default: null },
    timezoneIconURL: { type: String, default: null },
    emptySlotIconURL: { type: String, default: null },
    schedulerBubbleStyle: { type: Object }
  },
  setup() {
    return {};
  }
}), Xd = ["schedulerMessage", "schedulerBubbleStyle", "loggedInUser", "goalCompletionText", "onScheduleClick", "loadingIconURL", "clockIconURL", "calendarIconURL", "timezoneIconURL", "emptySlotIconURL", "backButtonIconURL"];
function qd(e, t, n, o, i, l) {
  return M(), g("cometchat-scheduler-bubble", {
    schedulerMessage: e.schedulerMessage,
    schedulerBubbleStyle: e.schedulerBubbleStyle,
    loggedInUser: e.loggedInUser,
    goalCompletionText: e.goalCompletionText,
    onScheduleClick: e.onScheduleClick,
    loadingIconURL: e.loadingIconURL,
    clockIconURL: e.clockIconURL,
    calendarIconURL: e.calendarIconURL,
    timezoneIconURL: e.timezoneIconURL,
    emptySlotIconURL: e.emptySlotIconURL,
    backButtonIconURL: e.backButtonIconURL
  }, null, 40, Xd);
}
const _d = /* @__PURE__ */ $e(Kd, [["render", qd]]), eI = We({
  name: "CometChatMessageBubble",
  components: {
    CometChatTextBubble: Qc,
    CometChatAudioBubble: Kc,
    CometChatFileBubble: ed,
    CometChatImageBubble: nr,
    CometChatVideoBubble: sd,
    CometChatDocumentExtensionBubble: cd,
    CometChatPollsBubble: Td,
    CometChatLinkPreviewBubble: jd,
    CometChatImageModerationBubble: Sd,
    CometChatMessageTranslationBubble: hd,
    CometChatContextMenu: Jd,
    CometChatFormBubble: Gc,
    CometChatCardBubble: Zc,
    CometChatSchedulerBubble: _d
  },
  props: {
    messageBubbleStyle: {
      type: Object,
      default: () => ({
        width: "100%",
        height: "auto",
        background: "",
        borderRadius: "12px",
        border: "none"
      })
    },
    options: {
      type: Array,
      default: () => []
    },
    alignment: {
      type: Number,
      default: () => gt.right
    },
    id: { type: null, default: void 0 },
    moreIconURL: { type: String, default: Ga },
    topMenuSize: { type: Number, default: 5 },
    leadingView: { type: Object },
    contentView: { type: Object },
    bottomView: { type: Object },
    headerView: { type: Object },
    footerView: { type: Object },
    replyView: { type: Object },
    threadView: { type: Array },
    statusInfoView: { type: Object }
  },
  setup(e) {
    let t = {
      width: "",
      height: "",
      border: "1px solid #e8e8e8",
      borderRadius: "8px",
      submenuWidth: "100%",
      submenuHeight: "100%",
      submenuBorder: "1px solid #e8e8e8",
      submenuBorderRadius: "8px",
      moreIconTint: "grey"
    }, n = j(!1), o = j(), { theme: i } = dt("theme", {
      theme: j(new Ke({}))
    });
    const l = Ht(
      () => !!e.leadingView
    ), r = Ht(
      () => !!e.headerView
    ), u = (Q) => {
      (Q == null ? void 0 : Q.type) === "mouseenter" ? (n.value = !0, o.value && clearTimeout(o.value)) : o.value = setTimeout(() => {
        n.value = !1;
      }, 150);
    }, s = (Q) => {
      const h = Q == null ? void 0 : Q.onClick;
      h && h(e.id);
    };
    Zt(() => {
      t = new Si({
        border: `1px solid ${i.value.palette.getAccent200()}`,
        borderRadius: "8px",
        background: i.value.palette.getBackground(),
        submenuWidth: "100%",
        submenuHeight: "100%",
        submenuBorder: `1px solid ${i.value.palette.getAccent200()}`,
        submenuBorderRadius: "8px",
        submenuBackground: i.value.palette.getBackground(),
        moreIconTint: i.value.palette.getAccent()
      });
    });
    const c = () => {
      switch (e.alignment) {
        case gt.right:
          return {
            display: "flex",
            justifyContent: "flex-end"
          };
        case gt.left:
          return {
            display: "flex",
            justifyContent: "flex-start"
          };
        case gt.center:
          return {
            display: "flex",
            justifyContent: "center"
          };
        default:
          return {
            display: "flex",
            justifyContent: "center"
          };
      }
    }, d = () => ({
      ...e.messageBubbleStyle
    }), N = () => ({
      display: "flex",
      justifyContent: "flex-start",
      alignItems: e.alignment == gt.left ? "flex-start" : "flex-end"
    }), T = () => ({
      justifyContent: e.alignment == gt.left ? "flex-start" : "flex-end",
      top: r.value && e.alignment == gt.left ? "-15px" : "-30px",
      background: i.value.palette.getBackground()
    }), m = () => ({
      display: "flex",
      justifyContent: e.alignment == gt.left ? "flex-start" : "flex-end",
      alignItems: "flex-start"
    }), A = () => t, D = () => k() ? R() : e.alignment == gt.left ? No.right : No.left, z = j(null), k = () => window.innerWidth <= 768, R = () => {
      const Q = z.value;
      if (Q) {
        const h = Q.getBoundingClientRect(), O = h.top < innerHeight / 2, x = h.bottom > window.innerHeight / 2;
        if (O)
          return No.bottom;
        if (x)
          return No.top;
      }
    };
    return {
      isHovering: n,
      getOptionsStyle: A,
      wrapperStyle: c,
      bubbleAlignmentStyle: N,
      titleStyle: m,
      bubbleStyle: d,
      optionsStyles: T,
      onOptionClick: s,
      hasLeadingView: l,
      hasHeaderView: r,
      hideShowMenuOption: u,
      optionsStyle: t,
      Placement: No,
      MessageBubbleAlignment: gt,
      getPlacementAligmnet: D,
      bubbleRef: z
    };
  }
});
const tI = ["innerHTML"], nI = ["v-slot", "v-html"], oI = {
  key: 2,
  innerHTML: ""
}, iI = ["innerHTML"], aI = ["v-slot", "v-html"], rI = {
  key: 2,
  innerHTML: ""
}, lI = { class: "cc-messagebubble-wrapper__content" }, sI = ["innerHTML"], MI = ["v-slot", "v-html"], uI = {
  key: 2,
  innerHTML: ""
}, gI = ["innerHTML"], cI = ["v-slot", "v-html"], dI = {
  key: 5,
  innerHTML: ""
}, II = ["innerHTML"], NI = ["v-slot", "v-html"], TI = ["innerHTML"], DI = ["v-slot", "v-html"], yI = {
  key: 10,
  innerHTML: ""
}, CI = { style: { position: "relative", width: "100%" } }, wI = ["innerHTML"], jI = ["v-slot", "v-html"], AI = {
  key: 2,
  innerHTML: ""
}, LI = {
  key: 3,
  class: "cc__messagelist__threadreplies"
}, zI = ["innerHTML"], SI = ["v-slot", "slot", "v-html", ".innerHTML"];
function pI(e, t, n, o, i, l) {
  var u, s, c, d, N, T, m, A, D, z, k, R, Q, h;
  const r = Je("CometChatContextMenu");
  return M(), g("div", {
    ref: "bubbleRef",
    class: "cc-messagebubble-wrapper",
    style: ce(e.wrapperStyle())
  }, [
    p("div", {
      class: "cc-messagebubble-wrapper__container",
      onMouseenter: t[0] || (t[0] = (...O) => e.hideShowMenuOption && e.hideShowMenuOption(...O)),
      onMouseleave: t[1] || (t[1] = (...O) => e.hideShowMenuOption && e.hideShowMenuOption(...O))
    }, [
      p("div", {
        class: _n(["cc-messagebubble-wrapper__avatar", { hidden: !e.hasLeadingView }])
      }, [
        e.leadingView && e.leadingView.html ? (M(), g("div", {
          key: 0,
          innerHTML: e.leadingView.html
        }, null, 8, tI)) : e.leadingView && e.leadingView.componentName ? (M(), je(fe(e.leadingView.componentName), me({ key: 1 }, { ...e.leadingView.props }, xe((u = e.leadingView) != null && u.listeners ? (s = e.leadingView) == null ? void 0 : s.listeners : {})), {
          default: be(() => [
            (M(!0), g(we, null, pe(e.leadingView.slots, (O, x) => (M(), g("div", {
              key: x,
              "v-slot": [x],
              "v-html": O
            }, null, 8, nI))), 128))
          ]),
          _: 1
        }, 16)) : (M(), g("div", oI))
      ], 2),
      p("div", {
        class: "cc-messagebubble-wrapper__messagebubble",
        style: ce(e.bubbleAlignmentStyle())
      }, [
        p("div", {
          style: ce(e.titleStyle()),
          class: _n({ hidden: !e.hasHeaderView })
        }, [
          e.headerView && e.headerView.html ? (M(), g("div", {
            key: 0,
            innerHTML: e.headerView.html
          }, null, 8, iI)) : e.headerView && e.headerView.componentName ? (M(), je(fe(e.headerView.componentName), me({ key: 1 }, { ...e.headerView.props }, xe((c = e.headerView) != null && c.listeners ? (d = e.headerView) == null ? void 0 : d.listeners : {})), {
            default: be(() => [
              (M(!0), g(we, null, pe(e.headerView.slots, (O, x) => (M(), g("div", {
                key: x,
                "v-slot": [x],
                "v-html": O
              }, null, 8, aI))), 128))
            ]),
            _: 1
          }, 16)) : (M(), g("div", rI))
        ], 6),
        e.options && e.options.length > 0 && e.isHovering ? (M(), g("div", {
          key: 0,
          class: "cc-messagebubble-wrapper__messageoptions",
          style: ce(e.optionsStyles())
        }, [
          Nt(r, {
            moreIconURL: e.moreIconURL,
            topMenuSize: e.topMenuSize,
            ContextMenuStyle: e.getOptionsStyle(),
            data: e.options,
            moreIconHoverText: "",
            onOptionClicked: e.onOptionClick,
            placement: e.getPlacementAligmnet()
          }, null, 8, ["moreIconURL", "topMenuSize", "ContextMenuStyle", "data", "onOptionClicked", "placement"])
        ], 4)) : $("", !0),
        p("div", lI, [
          p("div", {
            style: ce(e.bubbleStyle())
          }, [
            e.replyView && e.replyView.html ? (M(), g("div", {
              key: 0,
              innerHTML: e.replyView.html
            }, null, 8, sI)) : e.replyView && e.replyView.componentName ? (M(), je(fe(e.replyView.componentName), me({ key: 1 }, { ...e.replyView.props }, xe((N = e.replyView) != null && N.listeners ? (T = e.replyView) == null ? void 0 : T.listeners : {})), {
              default: be(() => [
                (M(!0), g(we, null, pe(e.replyView.slots, (O, x) => (M(), g("div", {
                  key: x,
                  "v-slot": [x],
                  "v-html": O
                }, null, 8, MI))), 128))
              ]),
              _: 1
            }, 16)) : (M(), g("div", uI)),
            e.contentView && e.contentView.html ? (M(), g("div", {
              key: 3,
              innerHTML: e.contentView.html
            }, null, 8, gI)) : e.contentView && e.contentView.componentName ? (M(), je(fe(e.contentView.componentName), me({ key: 4 }, { ...e.contentView.props }, xe((m = e.contentView) != null && m.listeners ? (A = e.contentView) == null ? void 0 : A.listeners : {})), {
              default: be(() => [
                (M(!0), g(we, null, pe(e.contentView.slots, (O, x) => (M(), g("div", {
                  key: x,
                  "v-slot": [x],
                  "v-html": O
                }, null, 8, cI))), 128))
              ]),
              _: 1
            }, 16)) : (M(), g("div", dI)),
            e.statusInfoView && e.statusInfoView.html ? (M(), g("div", {
              key: 6,
              innerHTML: e.statusInfoView.html
            }, null, 8, II)) : e.statusInfoView && e.statusInfoView.componentName ? (M(), je(fe(e.statusInfoView.componentName), me({ key: 7 }, { ...e.statusInfoView.props }, xe((D = e.statusInfoView) != null && D.listeners ? (z = e.statusInfoView) == null ? void 0 : z.listeners : {})), {
              default: be(() => [
                (M(!0), g(we, null, pe(e.statusInfoView.slots, (O, x) => (M(), g("div", {
                  key: x,
                  "v-slot": [x],
                  "v-html": O
                }, null, 8, NI))), 128))
              ]),
              _: 1
            }, 16)) : $("", !0),
            e.bottomView && e.bottomView.html ? (M(), g("div", {
              key: 8,
              innerHTML: e.bottomView.html
            }, null, 8, TI)) : e.bottomView && e.bottomView.componentName ? (M(), je(fe(e.bottomView.componentName), me({ key: 9 }, { ...e.bottomView.props }, xe((k = e.bottomView) != null && k.listeners ? (R = e.bottomView) == null ? void 0 : R.listeners : {})), {
              default: be(() => [
                (M(!0), g(we, null, pe(e.bottomView.slots, (O, x) => (M(), g("div", {
                  key: x,
                  "v-slot": [x],
                  "v-html": O
                }, null, 8, DI))), 128))
              ]),
              _: 1
            }, 16)) : (M(), g("div", yI))
          ], 4),
          p("div", CI, [
            e.footerView && e.footerView.html ? (M(), g("div", {
              key: 0,
              innerHTML: e.footerView.html
            }, null, 8, wI)) : e.footerView && e.footerView.componentName ? (M(), je(fe(e.footerView.componentName), me({ key: 1 }, { ...e.footerView.props }, xe((Q = e.footerView) != null && Q.listeners ? (h = e.footerView) == null ? void 0 : h.listeners : {})), {
              default: be(() => [
                (M(!0), g(we, null, pe(e.footerView.slots, (O, x) => (M(), g("div", {
                  key: x,
                  "v-slot": [x],
                  "v-html": O
                }, null, 8, jI))), 128))
              ]),
              _: 1
            }, 16)) : (M(), g("div", AI)),
            e.threadView && e.threadView.length ? (M(), g("div", LI, [
              (M(!0), g(we, null, pe(e.threadView, (O, x) => (M(), g("div", { key: x }, [
                O != null && O.html ? (M(), g("div", {
                  key: 0,
                  innerHTML: O == null ? void 0 : O.html
                }, null, 8, zI)) : (M(), je(fe(O == null ? void 0 : O.componentName), me({ key: 1 }, xe(O != null && O.listeners ? O == null ? void 0 : O.listeners : {}), { ref_for: !0 }, { ...O == null ? void 0 : O.props }), {
                  default: be(() => [
                    (M(!0), g(we, null, pe(O == null ? void 0 : O.slots, (_, oe) => (M(), g("div", {
                      key: oe,
                      "v-slot": [oe],
                      slot: [oe],
                      "v-html": _,
                      ".innerHTML": _
                    }, null, 40, SI))), 128))
                  ]),
                  _: 2
                }, 1040))
              ]))), 128))
            ])) : $("", !0)
          ])
        ])
      ], 4)
    ], 32)
  ], 4);
}
const ti = /* @__PURE__ */ $e(eI, [["render", pI], ["__scopeId", "data-v-6971671a"]]), bI = We({
  name: "CometChatMessageInformation",
  components: { CometChatList: hn, CometChatMessageBubble: ti },
  props: {
    title: {
      type: String,
      default: () => Y("MESSAGE_INFORMATION")
    },
    message: {
      type: Object,
      required: !0
    },
    backButtonIconURL: {
      type: String,
      default: fn
    },
    closeButtonIconURL: {
      type: String,
      default: Cn
    },
    template: {
      type: Object
    },
    bubbleView: {
      type: Function
    },
    listItemView: {
      type: Function
    },
    subtitleView: {
      type: Function
    },
    receiptDatePattern: {
      type: Function
    },
    onClose: {
      type: Function
    },
    onError: {
      type: Function,
      default: (e) => {
        console.log("ON ERROR: ", e.message);
      }
    },
    messageInformationStyle: {
      type: Object,
      default: () => new Yr({
        background: null,
        titleTextFont: null,
        titleTextColor: null,
        subtitleTextFont: null,
        subtitleTextColor: null,
        border: null,
        borderRadius: null,
        captionTextFont: null,
        captionTextColor: null
      })
    },
    readIcon: {
      type: String,
      default: mi
    },
    deliveredIcon: {
      type: String,
      default: Ei
    },
    listItemStyle: {
      type: Object
    },
    emptyStateText: {
      type: String
    },
    emptyStateView: {
      type: Object
    },
    errorStateText: {
      type: String
    },
    errorStateView: {
      type: Object
    },
    loadingIconURL: {
      type: String,
      default: nn
    },
    loadingStateView: {
      type: Object
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    }), n = j(t.value.palette.mode), o = new co(), i = j(), l = bi(e.message), r = j(), u = j(), s = j(), c = j(e.listItemStyle), d = j(ge.loading), N = j({
      textFont: w(t.value.typography.title1),
      textColor: t.value.palette.getAccent400()
    }), T = j(e.template), m, A;
    Zt(() => {
      var V, ne, K;
      if (!T.value) {
        const Ie = (K = An.getDataSource()) == null ? void 0 : K.getMessageTemplate((V = e.message) == null ? void 0 : V.getType(), (ne = e.message) == null ? void 0 : ne.getCategory(), t.value);
        Ie && (T.value = Ie);
      }
      e.message.getReceiverType() === I.MessageReceiverType.group ? (d.value = ge.loading, G(e.message).then((Ie) => {
        r.value = Ie.filter((Te) => {
          var H, Ee;
          return ((H = Te.getSender()) == null ? void 0 : H.getUid()) !== ((Ee = i.value) == null ? void 0 : Ee.getUid());
        }), Ie.length > 0 ? d.value = ge.loaded : d.value = ge.empty;
      })) : (u.value = e.message.getReceiver(), d.value = ge.loaded), i.value || An.getLoggedinUser().then((Ie) => {
        Ie && (i.value = Ie);
      }).catch((Ie) => {
        if (e.onError) {
          let Te = new y.CometChatException({
            message: Ie.message
          });
          e.onError(Te);
        }
      });
      try {
        F();
      } catch (Ie) {
        if (e.onError) {
          let Te = new y.CometChatException({
            message: Ie.message
          });
          e.onError(Te);
        }
      }
    }), tn(() => {
      pn(() => {
        let V = document.getElementById("cc-message-information");
        V.scrollTo({
          top: V.scrollHeight + 150,
          behavior: "smooth"
        });
      }), X();
    }), Xo(() => {
      F();
    });
    const D = () => ({
      height: e.messageInformationStyle.height || "100%",
      width: e.messageInformationStyle.width || "100%",
      border: e.messageInformationStyle.border || `1px solid ${t.value.palette.getAccent100(n.value)}`,
      borderRadius: e.messageInformationStyle.borderRadius || "10px",
      background: e.messageInformationStyle.background || t.value.palette.getBackground(n.value),
      display: "flex",
      position: "relative",
      padding: "20px",
      overflow: "hidden",
      overflowY: "auto",
      boxSizing: "border-box"
    }), z = () => ({
      flexShrink: "0"
    }), k = () => new Kt({
      borderRadius: "24px",
      width: "40px",
      height: "40px",
      border: "none",
      backgroundColor: t.value.palette.getAccent700(n.value),
      nameTextColor: t.value.palette.getAccent900(n.value),
      backgroundSize: "cover",
      nameTextFont: w(t.value.typography.subtitle1),
      outerViewBorderWidth: "",
      outerViewBorderSpacing: ""
    }), R = () => ({ ...new _t({
      height: "60px",
      width: "100%",
      background: t.value.palette.getBackground(n.value),
      activeBackground: t.value.palette.getAccent100(n.value),
      borderRadius: "0",
      titleFont: w(t.value.typography.title2),
      titleColor: t.value.palette.getAccent(n.value),
      border: "none",
      separatorColor: t.value.palette.getAccent200(n.value),
      hoverBackground: t.value.palette.getAccent50(n.value)
    }), ...c.value }), Q = () => new Jo({
      waitIconTint: t.value.palette.getAccent700(n.value),
      sentIconTint: t.value.palette.getAccent600(n.value),
      deliveredIconTint: t.value.palette.getAccent600(n.value),
      readIconTint: t.value.palette.getPrimary(n.value),
      errorIconTint: t.value.palette.getError(n.value),
      height: "24px",
      width: "24px"
    }), h = () => ({
      font: e.messageInformationStyle.subtitleTextFont || w(t.value.typography.subtitle2),
      color: e.messageInformationStyle.subtitleTextColor || t.value.palette.getAccent600(n.value)
    }), O = () => ({
      font: e.messageInformationStyle.titleTextFont || w(t.value.typography.heading),
      color: e.messageInformationStyle.titleTextColor || t.value.palette.getAccent(n.value),
      textAlign: "center"
    });
    s.value = {
      height: "100%",
      titleTextFont: e.messageInformationStyle.subtitleTextFont,
      titleTextColor: e.messageInformationStyle.subtitleTextColor,
      loadingIconTint: e.messageInformationStyle.loadingIconTint,
      background: e.messageInformationStyle.background || t.value.palette.getBackground(n.value)
    };
    const x = () => ({
      height: "24px",
      width: "24px",
      borderRadius: "0",
      border: "none",
      background: "transparent",
      buttonIconTint: t.value.palette.getPrimary(n.value)
    }), _ = () => ({
      height: e.messageInformationStyle.height || "100%",
      width: e.messageInformationStyle.width || "100%",
      position: "relative"
    }), oe = () => ({
      height: "24px",
      width: "24px",
      border: "none",
      borderRadius: "0",
      background: "transparent",
      buttonIconTint: t.value.palette.getPrimary(n.value)
    }), ie = () => ({ ...new po({
      textFont: w(t.value.typography.caption2),
      textColor: t.value.palette.getAccent600(n.value),
      background: "transparent"
    }) }), re = () => ({
      width: "100%",
      height: "1px",
      background: e.messageInformationStyle.dividerTint || t.value.palette.getAccent200(n.value)
    }), Ae = () => ({
      font: e.messageInformationStyle.captionTextFont || w(t.value.typography.caption1),
      color: e.messageInformationStyle.captionTextColor || t.value.palette.getAccent500(),
      marginBottom: "5px",
      marginTop: "5px"
    }), se = () => {
      e.onClose && e.onClose();
    }, X = () => {
      try {
        m = ae.onMessagesDelivered.subscribe((V) => {
          var ne, K;
          ((ne = e.message.getId()) == null ? void 0 : ne.toString()) == ((K = V.getMessageId()) == null ? void 0 : K.toString()) && (V.getReceiverType() === I.MessageReceiverType.group ? (e.message.setDeliveredAt(
            V.getDeliveredAt()
          ), B(V)) : e.message.setDeliveredAt(
            V.getDeliveredAt()
          ));
        }), A = ae.onMessagesRead.subscribe((V) => {
          var ne, K;
          ((ne = e.message.getId()) == null ? void 0 : ne.toString()) == ((K = V.getMessageId()) == null ? void 0 : K.toString()) && (V.getReceiverType() === I.MessageReceiverType.group ? (e.message.setReadAt(V.getReadAt()), B(V)) : e.message.setReadAt(V.getReadAt()));
        });
      } catch (V) {
        if (e.onError) {
          let ne = new y.CometChatException({
            message: V.message
          });
          e.onError(ne);
        }
      }
    };
    function B(V) {
      let ne = r.value.findIndex(
        (K) => K.getSender().getUid() === V.getSender().getUid()
      );
      ne > -1 && (V.getReceiptType() == V.RECEIPT_TYPE.READ_RECEIPT ? r.value[ne].setReadAt(V.getReadAt()) : V.getReceiptType() == V.RECEIPT_TYPE.DELIVERY_RECEIPT && r.value[ne].setDeliveredAt(V.getDeliveredAt()));
    }
    function F() {
      try {
        m == null || m.unsubscribe(), A == null || A.unsubscribe();
      } catch (V) {
        if (e.onError) {
          let ne = new y.CometChatException({
            message: V.message
          });
          e.onError(ne);
        }
      }
    }
    async function G(V) {
      if (V.getReceiverType() === I.MessageReceiverType.group)
        return await y.getMessageReceipts(V.getId());
    }
    return {
      currentMessage: l,
      messageReceipt: r,
      user: u,
      listStyle: s,
      state: d,
      Receipts: Fo,
      emptyLabelStyle: N,
      getTimeFormat: (V) => e.receiptDatePattern ? e.receiptDatePattern(V) : yn.DateTime,
      wrapperStyle: D,
      backButtonStyle: x,
      messageInformationStyles: _,
      closeClicked: se,
      closeButtonStyle: oe,
      headerStyle: z,
      headerTitle: O,
      getDividerStyle: re,
      avatarStyle: k,
      getListItemStyle: R,
      getReceiptStyle: Q,
      subtitleStyle: h,
      dateStyle: ie,
      localize: Y,
      getBubbleView: () => {
        if (e.bubbleView)
          return e.bubbleView(e.message);
        {
          if (!T.value)
            return null;
          const V = o.messageBubbleStyle(e.message, t, gt.right, i.value);
          return o.getMessageBubble(e.message, T.value, V, gt.right);
        }
      },
      captionTextStyle: Ae
    };
  }
});
const EI = { class: "cc-message-information__body" }, hI = { class: "cc_message-information__body_header" }, vI = ["dividerStyle"], mI = {
  key: 0,
  class: "cc_message-information__body_message-bubble"
}, OI = ["innerHTML"], xI = ["dividerStyle"], kI = ["dividerStyle"], fI = { key: 0 }, UI = ["innerHTML"], BI = ["v-slot", "v-html"], QI = ["title", "avatarURL", "avatarName", "id", "avatarStyle", "listItemStyle"], RI = {
  slot: "subtitleView",
  class: "cc-message_information__subtitle-view"
}, YI = { key: 0 }, VI = ["innerHTML"], GI = ["v-slot", "v-html"], PI = {
  key: 1,
  class: "cc-message_information__default-subtitle-view"
}, FI = { class: "cc-message_information__subtitle" }, HI = { class: "cc-message_information__receipt-container" }, ZI = { class: "cc-message_information__delivered-receipt" }, WI = ["receipt", "deliveredIcon", "readIcon", "receiptStyle"], $I = { class: "cc_message-information__date" }, JI = ["dateStyle", "timestamp", "customDateString", "pattern"], KI = {
  key: 0,
  class: "cc-message_information__subtitle"
}, XI = { class: "cc-message_information__receipt-container" }, qI = { class: "cc-message_information__read-receipt" }, _I = ["receipt", "deliveredIcon", "readIcon", "receiptStyle"], eN = { class: "cc_message-information__date" }, tN = ["dateStyle", "timestamp", "customDateString", "pattern"], nN = { key: 1 }, oN = { key: 0 }, iN = ["innerHTML"], aN = ["v-slot", "v-html"], rN = ["title", "avatarURL", "avatarName", "id", "avatarStyle", "listItemStyle"], lN = {
  slot: "subtitleView",
  class: "cc-message_information__subtitle-view"
}, sN = { key: 0 }, MN = ["innerHTML"], uN = ["v-slot", "v-html"], gN = {
  key: 1,
  class: "cc-message_information__default-subtitle-view"
}, cN = { class: "cc-message_information__subtitle" }, dN = { class: "cc-message_information__receipt-container" }, IN = { class: "cc-message_information__delivered-receipt" }, NN = ["receipt", "deliveredIcon", "readIcon", "receiptStyle"], TN = { class: "cc_message-information__date" }, DN = ["dateStyle", "timestamp", "customDateString", "pattern"], yN = { class: "cc-message_information__subtitle" }, CN = { class: "cc-message_information__receipt-container" }, wN = { class: "cc-message_information__read-receipt" }, jN = ["receipt", "deliveredIcon", "readIcon", "receiptStyle"], AN = { class: "cc_message-information__date" }, LN = ["dateStyle", "timestamp", "customDateString", "pattern"], zN = { key: 2 }, SN = ["innerHTML"], pN = ["v-slot", "v-html"], bN = {
  key: 3,
  class: "cc_message-information_empty-state-view"
}, EN = ["text", "labelStyle"], hN = { class: "cc-message-information__close-button" }, vN = ["iconURL", "buttonStyle"];
function mN(e, t, n, o, i, l) {
  var u, s, c, d, N, T, m, A, D, z, k, R, Q, h, O, x, _, oe, ie, re, Ae, se, X;
  const r = Je("CometChatList");
  return M(), g("div", {
    id: "cc-message-information",
    class: "cc-message-information",
    style: ce(e.wrapperStyle())
  }, [
    p("div", {
      class: "cc-message-information__wrapper",
      style: ce(e.messageInformationStyles())
    }, [
      p("div", {
        class: "cc-message-information__header",
        style: ce(e.headerStyle())
      }, [
        e.title ? (M(), g("div", {
          key: 0,
          class: "cc-list__title",
          style: ce(e.headerTitle())
        }, kt(e.title), 5)) : $("", !0)
      ], 4),
      p("div", EI, [
        p("div", hI, [
          p("div", {
            class: "cc_message-information__caption-text",
            style: ce(e.captionTextStyle())
          }, kt(e.localize("MESSAGE")), 5),
          p("cometchat-divider", {
            dividerStyle: e.getDividerStyle()
          }, null, 8, vI),
          e.getBubbleView() ? (M(), g("div", mI, [
            e.getBubbleView().html ? (M(), g("div", {
              key: 0,
              innerHTML: e.getBubbleView().html
            }, null, 8, OI)) : (M(), je(fe(e.getBubbleView().componentName), me({ key: 1 }, { ...e.getBubbleView().props }, xe(e.getBubbleView() ? e.getBubbleView() : {})), null, 16))
          ])) : $("", !0),
          p("cometchat-divider", {
            dividerStyle: e.getDividerStyle()
          }, null, 8, xI)
        ]),
        t[1] || (t[1] = p("br", null, null, -1)),
        p("div", {
          class: "cc_message-information__caption-text",
          style: ce(e.captionTextStyle())
        }, kt(e.localize("RECEIPT_INFORMATION")), 5),
        p("cometchat-divider", {
          dividerStyle: e.getDividerStyle()
        }, null, 8, kI),
        e.messageReceipt ? (M(), je(r, {
          key: 0,
          list: e.messageReceipt,
          hideSearch: !0,
          hideError: !0,
          errorStateText: e.errorStateText,
          emptyStateText: e.emptyStateText || e.localize("NO_RECIPIENTS"),
          scrollToBottom: !1,
          listStyle: e.listStyle,
          state: e.state,
          listItemKey: "getMessageId",
          onError: e.onError,
          loadingIconURL: e.loadingIconURL,
          errorStateView: e.errorStateView,
          emptyStateView: e.emptyStateView,
          loadingStateView: e.loadingStateView
        }, {
          listItem: be(({ item: B }) => {
            var F, G, J, ee, V, ne, K, Ie, Te, H, Ee, L, b, v, U, Se, Ue;
            return [
              e.listItemView ? (M(), g("div", fI, [
                (F = e.listItemView(e.message, B)) != null && F.html ? (M(), g("div", {
                  key: 0,
                  innerHTML: (G = e.listItemView(e.message, B)) == null ? void 0 : G.html
                }, null, 8, UI)) : (M(), je(fe((J = e.listItemView(e.message, B)) == null ? void 0 : J.componentName), me({ key: 1 }, xe(
                  (V = (ee = e.listItemView) == null ? void 0 : ee.call(e, e.message, B)) != null && V.listeners ? (ne = e.listItemView(e.message, B)) == null ? void 0 : ne.listeners : {}
                ), { ...(K = e.listItemView(e.message, B)) == null ? void 0 : K.props }), {
                  default: be(() => {
                    var Re;
                    return [
                      (M(!0), g(we, null, pe((Re = e.listItemView(e.message, B)) == null ? void 0 : Re.slots, (_e, Z) => (M(), g("div", {
                        key: Z,
                        "v-slot": [Z],
                        "v-html": _e
                      }, null, 8, BI))), 128))
                    ];
                  }),
                  _: 2
                }, 1040))
              ])) : (M(), g("cometchat-list-item", {
                key: 1,
                title: (Ie = B.getSender()) == null ? void 0 : Ie.getName(),
                avatarURL: (Te = B.getSender()) == null ? void 0 : Te.getAvatar(),
                avatarName: (H = B.getSender()) == null ? void 0 : H.getName(),
                hideSeparator: !1,
                id: B == null ? void 0 : B.getMessageId(),
                avatarStyle: e.avatarStyle(),
                isActive: !1,
                listItemStyle: e.getListItemStyle()
              }, [
                p("div", RI, [
                  e.subtitleView ? (M(), g("div", YI, [
                    (Ee = e.subtitleView(e.message, B)) != null && Ee.html ? (M(), g("div", {
                      key: 0,
                      innerHTML: (L = e.subtitleView(e.message, B)) == null ? void 0 : L.html
                    }, null, 8, VI)) : (M(), je(fe((b = e.subtitleView(e.message, B)) == null ? void 0 : b.componentName), me({ key: 1 }, xe(
                      (U = (v = e.subtitleView) == null ? void 0 : v.call(e, e.message, B)) != null && U.listeners ? (Se = e.subtitleView(e.message, B)) == null ? void 0 : Se.listeners : {}
                    ), { ...(Ue = e.subtitleView(e.message, B)) == null ? void 0 : Ue.props }), {
                      default: be(() => {
                        var Re;
                        return [
                          (M(!0), g(we, null, pe((Re = e.subtitleView(e.message, B)) == null ? void 0 : Re.slots, (_e, Z) => (M(), g("div", {
                            key: Z,
                            "v-slot": [Z],
                            "v-html": _e
                          }, null, 8, GI))), 128))
                        ];
                      }),
                      _: 2
                    }, 1040))
                  ])) : (M(), g("div", PI, [
                    p("div", FI, [
                      p("div", HI, [
                        p("div", ZI, [
                          p("cometchat-receipt", {
                            receipt: e.Receipts.delivered,
                            deliveredIcon: e.deliveredIcon,
                            readIcon: e.readIcon,
                            receiptStyle: e.getReceiptStyle()
                          }, null, 8, WI)
                        ]),
                        p("div", {
                          style: ce(e.subtitleStyle()),
                          class: "cc-conversations__subtitle-text"
                        }, kt(e.localize("DELIVERED")), 5)
                      ]),
                      Kn(p("div", $I, [
                        p("cometchat-date", {
                          dateStyle: e.dateStyle(),
                          timestamp: B.getDeliveredAt(),
                          customDateString: e.receiptDatePattern ? e.getTimeFormat(B.getDeliveredAt()) : null,
                          pattern: e.receiptDatePattern ? null : e.getTimeFormat(B.getDeliveredAt())
                        }, null, 8, JI)
                      ], 512), [
                        [Xn, B.getDeliveredAt()]
                      ])
                    ]),
                    B.getReadAt() ? (M(), g("div", KI, [
                      p("div", XI, [
                        p("div", qI, [
                          p("cometchat-receipt", {
                            receipt: e.Receipts.read,
                            deliveredIcon: e.deliveredIcon,
                            readIcon: e.readIcon,
                            receiptStyle: e.getReceiptStyle()
                          }, null, 8, _I)
                        ]),
                        p("div", {
                          style: ce(e.subtitleStyle()),
                          class: "cc_message-information__subtitle-text"
                        }, kt(e.localize("READ")), 5)
                      ]),
                      Kn(p("div", eN, [
                        p("cometchat-date", {
                          dateStyle: e.dateStyle(),
                          timestamp: B.getReadAt(),
                          customDateString: e.receiptDatePattern ? e.getTimeFormat(B.getReadAt()) : null,
                          pattern: e.receiptDatePattern ? null : e.getTimeFormat(B.getReadAt())
                        }, null, 8, tN)
                      ], 512), [
                        [Xn, B.getReadAt()]
                      ])
                    ])) : $("", !0)
                  ]))
                ])
              ], 8, QI))
            ];
          }),
          _: 1
        }, 8, ["list", "errorStateText", "emptyStateText", "listStyle", "state", "onError", "loadingIconURL", "errorStateView", "emptyStateView", "loadingStateView"])) : $("", !0),
        e.user ? (M(), g("div", nN, [
          e.message.getDeliveredAt() && e.listItemView ? (M(), g("div", oN, [
            (u = e.listItemView(e.message)) != null && u.html ? (M(), g("div", {
              key: 0,
              innerHTML: (s = e.listItemView(e.message)) == null ? void 0 : s.html
            }, null, 8, iN)) : (M(), je(fe((c = e.listItemView(e.message)) == null ? void 0 : c.componentName), me({ key: 1 }, xe(
              (N = (d = e.listItemView) == null ? void 0 : d.call(e, e.message)) != null && N.listeners ? (T = e.listItemView(e.message)) == null ? void 0 : T.listeners : {}
            ), { ...(m = e.listItemView(e.message)) == null ? void 0 : m.props }), {
              default: be(() => {
                var B;
                return [
                  (M(!0), g(we, null, pe((B = e.listItemView(e.message)) == null ? void 0 : B.slots, (F, G) => (M(), g("div", {
                    key: G,
                    "v-slot": [G],
                    "v-html": F
                  }, null, 8, aN))), 128))
                ];
              }),
              _: 1
            }, 16))
          ])) : e.message.getDeliveredAt() && !e.listItemView ? (M(), g("cometchat-list-item", {
            key: 1,
            title: (A = e.user) == null ? void 0 : A.getName(),
            avatarURL: (D = e.user) == null ? void 0 : D.getAvatar(),
            avatarName: (z = e.user) == null ? void 0 : z.getName(),
            hideSeparator: !1,
            id: e.message.getId(),
            avatarStyle: e.avatarStyle(),
            isActive: !1,
            listItemStyle: e.getListItemStyle()
          }, [
            p("div", lN, [
              e.subtitleView ? (M(), g("div", sN, [
                (k = e.subtitleView(e.message)) != null && k.html ? (M(), g("div", {
                  key: 0,
                  innerHTML: (R = e.subtitleView(e.message)) == null ? void 0 : R.html
                }, null, 8, MN)) : (M(), je(fe((Q = e.subtitleView(e.message)) == null ? void 0 : Q.componentName), me({ key: 1 }, xe(
                  (O = (h = e.subtitleView) == null ? void 0 : h.call(e, e.message)) != null && O.listeners ? (x = e.subtitleView(e.message)) == null ? void 0 : x.listeners : {}
                ), { ...(_ = e.subtitleView(e.message)) == null ? void 0 : _.props }), {
                  default: be(() => {
                    var B;
                    return [
                      (M(!0), g(we, null, pe((B = e.subtitleView(e.message)) == null ? void 0 : B.slots, (F, G) => (M(), g("div", {
                        key: G,
                        "v-slot": [G],
                        "v-html": F
                      }, null, 8, uN))), 128))
                    ];
                  }),
                  _: 1
                }, 16))
              ])) : (M(), g("div", gN, [
                p("div", cN, [
                  p("div", dN, [
                    p("div", IN, [
                      p("cometchat-receipt", {
                        receipt: e.Receipts.delivered,
                        deliveredIcon: e.deliveredIcon,
                        readIcon: e.readIcon,
                        receiptStyle: e.getReceiptStyle()
                      }, null, 8, NN)
                    ]),
                    p("div", {
                      style: ce(e.subtitleStyle()),
                      class: "cc_message-information__subtitle-text"
                    }, kt(e.localize("DELIVERED")), 5)
                  ]),
                  Kn(p("div", TN, [
                    p("cometchat-date", {
                      dateStyle: e.dateStyle(),
                      timestamp: e.message.getDeliveredAt(),
                      customDateString: e.receiptDatePattern ? e.getTimeFormat(e.message.getDeliveredAt()) : null,
                      pattern: e.receiptDatePattern ? null : e.getTimeFormat(e.message.getDeliveredAt())
                    }, null, 8, DN)
                  ], 512), [
                    [Xn, e.message.getDeliveredAt()]
                  ])
                ]),
                p("div", yN, [
                  p("div", CN, [
                    p("div", wN, [
                      p("cometchat-receipt", {
                        receipt: e.Receipts.read,
                        deliveredIcon: e.deliveredIcon,
                        readIcon: e.readIcon,
                        receiptStyle: e.getReceiptStyle()
                      }, null, 8, jN)
                    ]),
                    p("div", {
                      style: ce(e.subtitleStyle()),
                      class: "cc_message-information__subtitle-text"
                    }, kt(e.localize("READ")), 5)
                  ]),
                  Kn(p("div", AN, [
                    p("cometchat-date", {
                      dateStyle: e.dateStyle(),
                      timestamp: e.message.getReadAt(),
                      customDateString: e.receiptDatePattern ? e.getTimeFormat(e.message.getReadAt()) : null,
                      pattern: e.receiptDatePattern ? null : e.getTimeFormat(e.message.getReadAt())
                    }, null, 8, LN)
                  ], 512), [
                    [Xn, e.message.getReadAt()]
                  ])
                ])
              ]))
            ])
          ], 8, rN)) : e.emptyStateView ? (M(), g("div", zN, [
            (oe = e.emptyStateView) != null && oe.html ? (M(), g("div", {
              key: 0,
              innerHTML: (ie = e.emptyStateView) == null ? void 0 : ie.html
            }, null, 8, SN)) : (M(), je(fe((re = e.emptyStateView) == null ? void 0 : re.componentName), me({ key: 1 }, xe(
              (Ae = e.emptyStateView) != null && Ae.listeners ? (se = e.emptyStateView) == null ? void 0 : se.listeners : {}
            ), { ...(X = e.emptyStateView) == null ? void 0 : X.props }), {
              default: be(() => {
                var B;
                return [
                  (M(!0), g(we, null, pe((B = e.emptyStateView) == null ? void 0 : B.slots, (F, G) => (M(), g("div", {
                    key: G,
                    "v-slot": [G],
                    "v-html": F
                  }, null, 8, pN))), 128))
                ];
              }),
              _: 1
            }, 16))
          ])) : (M(), g("div", bN, [
            p("cometchat-label", {
              text: e.emptyStateText || e.localize("NO_RECIPIENT"),
              labelStyle: e.emptyLabelStyle
            }, null, 8, EN)
          ]))
        ])) : $("", !0)
      ])
    ], 4),
    p("div", hN, [
      p("cometchat-button", {
        iconURL: e.closeButtonIconURL,
        buttonStyle: e.closeButtonStyle(),
        onCcButtonClicked: t[0] || (t[0] = (B) => e.closeClicked())
      }, null, 40, vN)
    ])
  ], 4);
}
const ON = /* @__PURE__ */ $e(bI, [["render", mN], ["__scopeId", "data-v-57bb9abb"]]), xN = () => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  width: "100%",
  height: "auto"
}), Na = (e, t) => (e.background = e.background || t.value.palette.getBackground(), { ...new po({
  textFont: w(t.value.typography.subtitle1),
  textColor: t.value.palette.getAccent600(),
  background: t.value.palette.getAccent100(),
  height: "100%",
  width: "100%",
  border: `1px solid ${t.value.palette.getAccent100()}`,
  borderRadius: "8px"
}), ...e }), kN = (e, t) => {
  let n = {
    ...xi(t),
    ...e
  };
  return {
    textFont: n.emptyStateTextFont,
    textColor: n.emptyStateTextColor
  };
}, fN = (e, t) => {
  let n = {
    ...xi(t),
    ...e
  };
  return {
    textFont: n.errorStateTextFont,
    textColor: n.errorStateTextColor
  };
}, xi = (e) => new Wr({
  background: e.value.palette.getBackground(),
  border: "none",
  emptyStateTextFont: w(e.value.typography.title1),
  emptyStateTextColor: e.value.palette.getAccent600(),
  errorStateTextFont: w(e.value.typography.title1),
  errorStateTextColor: e.value.palette.getAccent600(),
  loadingIconTint: e.value.palette.getAccent600(),
  nameTextFont: w(e.value.typography.title2),
  nameTextColor: e.value.palette.getAccent600(),
  threadReplyTextFont: w(e.value.typography.subtitle1),
  threadReplyIconTint: e.value.palette.getAccent600(),
  threadReplyTextColor: e.value.palette.getAccent600(),
  TimestampTextFont: w(e.value.typography.caption2),
  TimestampTextColor: e.value.palette.getAccent600()
}), UN = () => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  width: "100%",
  height: "auto"
}), BN = {
  TimestampTextFont: "",
  TimestampTextColor: "",
  threadReplySeparatorColor: "",
  threadReplyTextFont: "",
  threadReplyIconTint: "",
  threadReplyTextColor: "",
  emptyStateTextFont: "700 22px Inter",
  emptyStateTextColor: "#bcbcbc",
  errorStateTextFont: "700 22px Inter",
  errorStateTextColor: "#bcbcbc",
  loadingIconTint: "grey"
}, QN = (e, t) => {
  const n = (t == null ? void 0 : t.getType()) === I.MessageTypes.text;
  return new Jo({
    waitIconTint: e.value.palette.getAccent700(),
    sentIconTint: e.value.palette.getAccent600(),
    deliveredIconTint: e.value.palette.getAccent600(),
    readIconTint: n ? e.value.palette.getBackground() : e.value.palette.getPrimary(),
    errorIconTint: e.value.palette.getError(),
    height: "11px",
    width: "12px",
    background: "transparent"
  });
}, RN = new po({
  textFont: "500 16px Inter",
  textColor: "rgba(20, 20, 20, 0.58)",
  background: "",
  height: "",
  width: "",
  border: "1px solid grey",
  borderRadius: "8px"
}), YN = () => ({
  height: "100%",
  width: "100%",
  background: "#3399FF",
  display: "flex",
  justifyContent: "center",
  buttonTextFont: "400 13px Inter",
  color: "white",
  border: "none",
  borderRadius: "12px"
}), Ta = (e, t) => ({
  textColor: e.TimestampTextColor || t.value.palette.getAccent600(),
  textFont: e.TimestampTextFont || w(t.value.typography.caption3),
  padding: "0px",
  display: "block"
}), VN = (e, t) => ({
  iconTint: {
    ...xi(t),
    ...e
  }.loadingIconTint
}), GN = We({
  name: "CometChatMessageList",
  components: {
    CometChatList: hn,
    CometChatMessageBubble: ti,
    CometChatSmartReplyBubble: mg,
    CometChatConfirmDialogView: kc,
    CometChatOngoingCall: _o,
    CometChatMessageInformation: ON,
    ConversationStarterView: oc,
    ConversationSummaryView: hc
  },
  props: {
    hideError: {
      type: Boolean,
      default: !1
    },
    scrollToBottomOnNewMessages: {
      type: Boolean,
      default: () => !1
    },
    errorStateView: { type: Object },
    loadingStateView: { type: Object },
    emptyStateView: { type: Object },
    state: {
      type: Number,
      default: () => ge.loading
    },
    thresholdValue: {
      type: Number,
      default: 1e3
    },
    errorStateText: {
      type: String,
      default: () => Y("SOMETHING_WRONG")
    },
    emptyStateText: {
      type: String,
      default: () => Y("NO_MESSAGES_FOUND")
    },
    loadingIconURL: {
      type: String,
      default: nn
    },
    user: { type: Object },
    group: { type: Object },
    /**
     * @deprecated
     * 
     * This property is deprecated as of version 4.3.16 due to newer property 'hideReceipt'. It will be removed in subsequent versions.
     */
    disableReceipt: {
      type: Boolean,
      default: !1
    },
    hideReceipt: {
      type: Boolean,
      default: !1
    },
    onError: {
      type: Function,
      default: (e) => {
        console.log(e);
      }
    },
    disableSoundForMessages: {
      type: Boolean,
      default: !1
    },
    customSoundForMessages: { type: String },
    readIcon: {
      type: String,
      default: mi
    },
    deliveredIcon: {
      type: String,
      default: Ei
    },
    sentIcon: {
      type: String,
      default: Za
    },
    waitIcon: {
      type: String,
      default: Xa
    },
    errorIcon: {
      type: String,
      default: Oi
    },
    alignment: {
      type: Number,
      default: () => fo.standard
    },
    showAvatar: {
      type: Boolean,
      default: !0
    },
    timestampAlignment: {
      type: Number,
      default: () => na.bottom
    },
    DateSeparatorPattern: {
      type: Number,
      default: () => yn.DayDateTime
    },
    templates: {
      type: Array
    },
    messagesRequestBuilder: { type: Object },
    newMessageIndicatorText: {
      type: String,
      default: ""
    },
    onThreadRepliesClick: {
      type: Function,
      default: () => {
      }
    },
    headerView: { type: Object },
    footerView: { type: Object },
    datePattern: {
      type: Number,
      default: () => yn.time
    },
    parentMessageId: { type: Number },
    avatarStyle: {
      type: Object,
      default: () => new Kt({
        borderRadius: "16px",
        width: "28px",
        height: "28px"
      })
    },
    dateSeparatorStyle: {
      type: Object,
      default: () => RN
    },
    messageListStyle: {
      type: Object,
      default: () => BN
    },
    messageInformationConfiguration: {
      type: Object,
      default: () => ({})
    },
    reactionsConfiguration: {
      type: Object,
      default: () => new Vr({})
    },
    disableReactions: {
      type: Boolean,
      default: !0
    },
    emojiKeyboardStyle: {
      type: Object,
      default: () => ({})
    },
    threadIndicatorIcon: {
      type: String,
      default: rs
    },
    disableMentions: {
      type: Boolean,
      default: !1
    },
    textFormatters: {
      type: Array,
      default: () => []
    },
    backdropStyle: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    var Gi, Pi;
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    }), n = j(e.state), o = I.MessageCategory, i = !1, l = j(0), r = !0, u = !1, s = j(!1), c = j(!1), d = j(), N = j([]), T, m = Ne.getDataSource().getAllMessageTypes(), A = Ne.getDataSource().getAllMessageCategories(), D = null, z = j([]), k = I.MessageTypes, R = "group_" + (/* @__PURE__ */ new Date()).getTime(), Q = "call_" + (/* @__PURE__ */ new Date()).getTime();
    const h = j("connection_" + (/* @__PURE__ */ new Date()).getTime());
    let O, x = !1, _ = j(!1), oe = Ha, ie = !0, re = j(!1), Ae = j(void 0), se = Ht(() => {
      var a, C, E;
      if (((a = N.value) == null ? void 0 : a.length) > 0)
        return (E = N.value) == null ? void 0 : E[((C = N.value) == null ? void 0 : C.length) - 1].getId();
    }), X = 30, B = {
      height: "10px",
      width: "100%",
      border: "2px",
      borderRadius: "2px",
      background: "yellow",
      textFont: "",
      textColor: "red"
    }, F = j(!1), G = j(null), J = {
      height: "100%",
      width: "100%",
      background: t.value.palette.getPrimary(),
      display: "flex",
      justifyContent: "center",
      font: "400 13px Inter",
      buttonTextColor: t.value.palette.getSecondary(),
      border: "none",
      borderRadius: "12px",
      padding: "5px"
    };
    const ee = {
      textFont: ((Gi = e == null ? void 0 : e.messageListStyle) == null ? void 0 : Gi.nameTextFont) || w(t.value.typography.caption2),
      textColor: ((Pi = e == null ? void 0 : e.messageListStyle) == null ? void 0 : Pi.nameTextColor) || "grey"
    };
    let V, ne, K = null, Ie = null, Te, H = j(void 0), Ee = 0, L = {}, b = e.templates && e.templates.length > 0 ? e.templates : Ne.getDataSource().getAllMessageTemplates(
      t.value,
      {
        disableMentions: e.disableMentions,
        textFormatters: e.textFormatters,
        theme: t.value
      }
    ), v, U, Se, Ue, Re, _e, Z, ke, q, ye, Oe, he, Pe, lt, It, Gt, de, Le, Fe, tt, st, ct, wt, Lt, jt, Wt, ot, zt, yt, on, ft, rt = na, Tt = gt.left, Pt = !1, Rt = j(!0);
    b.forEach((a) => {
      L[a.category + "_" + a.type] = a;
    }), Zt(() => {
      n.value = ge.loading;
    }), tn(() => {
      e.scrollToBottomOnNewMessages && (u = !0), y.getLoggedinUser().then((a) => {
        a && (T = a, K = e.user, Ie = e.group, Dn(), en());
      }).catch((a) => {
        if (e.onError) {
          let C = new y.CometChatException({
            message: a.message
          });
          e.onError(C);
        }
      });
    }), Xo(async () => {
      rn();
      try {
        y.removeGroupListener(R), y.removeCallListener(Q), y.removeConnectionListener(h.value);
      } catch (a) {
        if (e.onError) {
          let C = new y.CometChatException({
            message: a.message
          });
          e.onError(C);
        }
      }
    }), bn(() => _.value, (a) => {
      var C;
      if (a && !e.scrollToBottomOnNewMessages && z.value.length > 0 && !e.disableReceipt && ((C = N.value) == null ? void 0 : C.length) > 0) {
        z.value = [];
        let E = N.value.slice().reverse().find((ue) => ue.getSender().getUid() !== T.getUid());
        y.markAsRead(E).then(() => {
          ae.ccMessageRead.next(E);
        });
      }
    });
    const Yt = () => ({
      height: "1px",
      width: "100%",
      background: t.value.palette.getAccent100()
    }), en = () => {
      he = it.ccShowOngoingCall.subscribe(
        (a) => {
          s.value = !0, H.value = a.child;
        }
      ), Pe = Jt.ccCallEnded.subscribe(
        (a) => {
          s.value = !1, H.value = void 0, a && bt(a) && mn(a);
        }
      ), lt = Jt.ccCallRejected.subscribe(
        (a) => {
          bt(a) && mn(a);
        }
      ), It = Jt.ccOutgoingCall.subscribe(
        (a) => {
          bt(a) && mn(a);
        }
      ), Gt = Jt.ccCallAccepted.subscribe(
        (a) => {
          bt(a) && mn(a);
        }
      ), ke = it.ccShowPanel.subscribe(
        (a) => {
          var C, E;
          e.parentMessageId && ((C = a == null ? void 0 : a.message) == null ? void 0 : C.getParentMessageId()) != e.parentMessageId || (E = a == null ? void 0 : a.message) != null && E.getParentMessageId() && !e.parentMessageId || (Te = a.child, re.value = !0);
        }
      ), q = it.ccHidePanel.subscribe(() => {
        Te = void 0, re.value = !1;
      }), ye = it.ccShowDialog.subscribe(
        (a) => {
          Rt.value = !1, Ae.value = a.child;
        }
      ), Oe = it.ccHideDialog.subscribe(() => {
        Ae.value = void 0;
      }), Se = He.ccGroupMemberAdded.subscribe(
        (a) => {
          mo(a.messages);
        }
      ), Ue = He.ccGroupMemberBanned.subscribe(
        (a) => {
          bt(a.message) && qt(a.message);
        }
      ), Re = He.ccGroupMemberKicked.subscribe(
        (a) => {
          bt(a.message) && qt(a.message);
        }
      ), _e = He.ccGroupMemberScopeChanged.subscribe(
        (a) => {
          bt(a.message) && qt(a.message);
        }
      ), Z = He.ccGroupLeft.subscribe(
        (a) => {
          bt(a.message) && qt(a.message);
        }
      ), v = ae.ccMessageEdited.subscribe(
        (a) => {
          (a == null ? void 0 : a.status) == Xe.success && bt(a.message) && Ut(a.message, !1);
        }
      ), U = ae.ccMessageSent.subscribe(
        (a) => {
          let C = a.message;
          switch (a.status) {
            case Xe.inprogress: {
              bt(C) && qt(C);
              break;
            }
            case Xe.success: {
              (C.getParentMessageId() || e.parentMessageId) && Rn(C), bt(C) && Ut(C, !0), f();
              break;
            }
            case Xe.error: {
              (!C.getSender() || bt(C)) && Ut(C, !0);
              break;
            }
          }
        }
      ), de = ae.onTextMessageReceived.subscribe(async (a) => {
        (!e.parentMessageId || a.getParentMessageId() == e.parentMessageId) && await Ye(
          I.messages.TEXT_MESSAGE_RECEIVED,
          a
        );
      }), Le = ae.onCustomMessageReceived.subscribe(async (a) => {
        (!e.parentMessageId || a.getParentMessageId() == e.parentMessageId) && await Ye(
          I.messages.CUSTOM_MESSAGE_RECEIVED,
          a
        );
      }), tt = ae.onFormMessageReceived.subscribe(async (a) => {
        a = va.fromJSON(a), (!e.parentMessageId || a.getParentMessageId() == e.parentMessageId) && await Ye(
          I.messages.INTERACTIVE_MESSAGE_RECEIVED,
          a
        );
      }), st = ae.onCardMessageReceived.subscribe(async (a) => {
        a = ma.fromJSON(a), (!e.parentMessageId || a.getParentMessageId() == e.parentMessageId) && await Ye(
          I.messages.INTERACTIVE_MESSAGE_RECEIVED,
          a
        );
      }), ct = ae.onSchedulerMessageReceived.subscribe(async (a) => {
        a = Oa.fromJSON(a), (!e.parentMessageId || a.getParentMessageId() == e.parentMessageId) && await Ye(
          I.messages.INTERACTIVE_MESSAGE_RECEIVED,
          a
        );
      }), wt = ae.onCustomInteractiveMessageReceived.subscribe(async (a) => {
        a = xa.fromJSON(a), (!e.parentMessageId || a.getParentMessageId() == e.parentMessageId) && await Ye(
          I.messages.INTERACTIVE_MESSAGE_RECEIVED,
          a
        );
      }), Fe = ae.onMediaMessageReceived.subscribe((a) => {
        (!e.parentMessageId || a.getParentMessageId() == e.parentMessageId) && Ye(
          I.messages.MEDIA_MESSAGE_RECEIVED,
          a
        );
      }), Lt = ae.onMessagesDelivered.subscribe((a) => {
        const C = Ve(Number(a.getMessageId()));
        (!e.parentMessageId || C && (C == null ? void 0 : C.getParentMessageId()) == e.parentMessageId) && a.getReceiverType() === I.MessageReceiverType.user && Ye(
          I.messages.MESSAGE_DELIVERED,
          a
        );
      }), jt = ae.onMessagesRead.subscribe((a) => {
        const C = Ve(Number(a.getMessageId()));
        (!e.parentMessageId || (C && (C == null ? void 0 : C.getParentMessageId())) == e.parentMessageId) && a.getReceiverType() == I.MessageReceiverType.user && Ye(
          I.messages.MESSAGE_READ,
          a
        );
      }), V = ae.onMessagesReadByAll.subscribe((a) => {
        const C = Ve(Number(a.getMessageId()));
        (!e.parentMessageId || (C && (C == null ? void 0 : C.getParentMessageId())) == e.parentMessageId) && a.getReceiverType() === I.MessageReceiverType.group && Ye(
          I.messages.MESSAGE_READ,
          a
        );
      }), ne = ae.onMessagesDeliveredToAll.subscribe((a) => {
        const C = Ve(Number(a.getMessageId()));
        (!e.parentMessageId || (C && (C == null ? void 0 : C.getParentMessageId())) == e.parentMessageId) && a.getReceiverType() === I.MessageReceiverType.group && Ye(
          I.messages.MESSAGE_DELIVERED,
          a
        );
      }), Wt = ae.onMessageDeleted.subscribe((a) => {
        (!e.parentMessageId || a.getParentMessageId() == e.parentMessageId) && Ye(
          I.messages.MESSAGE_DELETED,
          a
        );
      }), ot = ae.onMessageEdited.subscribe((a) => {
        (!e.parentMessageId || a.getParentMessageId() == e.parentMessageId) && Ye(
          I.messages.MESSAGE_EDITED,
          a
        );
      }), zt = ae.onTransientMessageReceived.subscribe((a) => {
        let C = a.getData();
        if (a.getReceiverType() == I.MessageReceiverType.user && e.user && (a == null ? void 0 : a.getSender().getUid()) == e.user.getUid() && a.getReceiverId() == (T == null ? void 0 : T.getUid()) && C.type == "live_reaction") {
          ae.ccLiveReaction.next(
            C.reaction
          );
          return;
        } else if (a.getReceiverType() == I.MessageReceiverType.group && e.group && a.getReceiverId() == e.group.getGuid() && (a == null ? void 0 : a.getSender().getUid()) != (T == null ? void 0 : T.getUid()) && C.type == "live_reaction") {
          ae.ccLiveReaction.next(
            C.reaction
          );
          return;
        }
      }), yt = ae.onInteractionGoalCompleted.subscribe((a) => {
        T.getUid() === a.getSender().getUid() && Ye(
          I.messages.INTERACTION_GOAL_COMPLETED,
          a
        );
      }), e.disableReactions || (on = ae.onMessageReactionAdded.subscribe((a) => {
        Ye(
          I.messages.MESSAGE_REACTION_ADDED,
          a
        );
      }), ft = ae.onMessageReactionRemoved.subscribe((a) => {
        Ye(
          I.messages.MESSAGE_REACTION_REMOVED,
          a
        );
      }));
    }, gn = (a) => {
      var E;
      const C = Ve(a.getMessageId());
      if (C && String(C == null ? void 0 : C.getId()) == String(a.getMessageId()) && (T == null ? void 0 : T.getUid()) == ((E = a == null ? void 0 : a.getSender()) == null ? void 0 : E.getUid())) {
        const ue = a.getInteractions();
        C.setInteractions(ue), St(To.convertInteractiveMessage(C));
      }
    }, bt = (a) => {
      if (e.parentMessageId) {
        if (String(a.getParentMessageId()) === String(e.parentMessageId))
          return !0;
      } else
        return a.getParentMessageId() ? !1 : !!(K && a.getReceiverType() === I.MessageReceiverType.user && (a == null ? void 0 : a.getReceiverId()) === (K == null ? void 0 : K.getUid()) || Ie && a.getReceiverType() === I.MessageReceiverType.group && (a == null ? void 0 : a.getReceiverId()) === (Ie == null ? void 0 : Ie.getGuid()));
    }, Ut = (a, C = !1) => {
      C ? cn(a) : St(a);
    }, cn = (a) => {
      const C = a, E = [...N.value];
      let ue = E.findIndex(
        (ve) => ve.getMuid() === C.getMuid()
      );
      ue > -1 && E.splice(ue, 1, C), N.value = E, uo();
    }, rn = () => {
      Se == null || Se.unsubscribe(), Ue == null || Ue.unsubscribe(), Re == null || Re.unsubscribe(), Z == null || Z.unsubscribe(), v == null || v.unsubscribe(), U == null || U.unsubscribe(), _e == null || _e.unsubscribe(), he == null || he.unsubscribe(), Gt == null || Gt.unsubscribe(), Pe == null || Pe.unsubscribe(), lt == null || lt.unsubscribe(), It == null || It.unsubscribe(), ke == null || ke.unsubscribe(), q == null || q.unsubscribe(), ye == null || ye.unsubscribe(), Oe == null || Oe.unsubscribe(), de == null || de.unsubscribe(), Fe == null || Fe.unsubscribe(), Le == null || Le.unsubscribe(), tt == null || tt.unsubscribe(), st == null || st.unsubscribe(), ct == null || ct.unsubscribe(), wt == null || wt.unsubscribe(), Lt == null || Lt.unsubscribe(), jt == null || jt.unsubscribe(), ot == null || ot.unsubscribe(), Wt == null || Wt.unsubscribe(), zt == null || zt.unsubscribe(), yt == null || yt.unsubscribe(), on == null || on.unsubscribe(), ft == null || ft.unsubscribe(), V == null || V.unsubscribe(), ne == null || ne.unsubscribe();
    }, ln = () => T;
    tn(async () => {
      $n(), Mo(), Eo();
    }), eo(() => {
      var a, C, E, ue, ve;
      if (e.parentMessageId && e.parentMessageId != e.parentMessageId && (N.value = [], Dn()), Pt = !1, !K && ((a = e.user) != null && a.getUid()) || K && K.getUid() != ((C = e.user) == null ? void 0 : C.getUid()) && !((E = e.group) != null && E.getGuid()) ? (re.value = !1, Pt = !0, ie = !0, K = e.user, Ie = null) : (!Ie && ((ue = e.group) != null && ue.getGuid()) || Ie && Ie.getGuid() != ((ve = e.group) == null ? void 0 : ve.getGuid())) && (re.value = !1, Pt = !0, ie = !0, Ie = e.group, K = null), Pt) {
        e.scrollToBottomOnNewMessages && (u = !0), i = !1, T || y.getLoggedinUser().then((Ge) => {
          Ge && (T = Ge);
        }).catch((Ge) => {
          if (e.onError) {
            let nt = new y.CometChatException({
              message: Ge.message
            });
            e.onError(nt);
          }
        }), N.value = [], K ? Object.keys(K).length > 1 ? Dn() : y.getUser(K).then(
          // eslint-disable-next-line
          (Ge) => {
            Dn();
          }
        ) : Ie && (Object.keys(Ie).length > 1 ? Dn() : y.getGroup(Ie).then(
          // eslint-disable-next-line
          (Ge) => {
            Dn();
          }
        )), rn();
        try {
          y.removeGroupListener(R), y.removeCallListener(Q), y.removeConnectionListener(h.value), R = "group_" + (/* @__PURE__ */ new Date()).getTime(), Q = "call_" + (/* @__PURE__ */ new Date()).getTime(), h.value = "connection_" + (/* @__PURE__ */ new Date()).getTime();
        } catch (Ge) {
          if (e.onError) {
            let nt = new y.CometChatException({
              message: Ge.message
            });
            e.onError(nt);
          }
        }
      }
    }), Ko(() => {
      if (Pt)
        try {
          R = "group_" + (/* @__PURE__ */ new Date()).getTime(), Q = "call_" + (/* @__PURE__ */ new Date()).getTime(), h.value = "connection_" + (/* @__PURE__ */ new Date()).getTime(), $n(), Mo(), Eo(), en(), setTimeout(() => {
            Rt.value = !0;
          }, 100);
        } catch (a) {
          if (e.onError) {
            let C = new y.CometChatException({
              message: a.message
            });
            e.onError(C);
          }
        }
    });
    const Tn = () => e.loadingStateView ? e.loadingStateView : {
      html: ` <div class="cc-messagelist__loadingview">
                <cometchat-loader
                 iconURL="${e.loadingIconURL}"
                 loaderStyle="${JSON.stringify(
        VN(e.messageListStyle, t)
      )}
                 ">
                 </cometchat-loader>
            </div>`
    }, Vt = () => e.errorStateView ? e.errorStateView : {
      html: ` <div class='cc-messagelist__errorview'>
        <cometchat-label
         labelStyle='${JSON.stringify(
        fN(e.messageListStyle, t)
      )}'
          text="${e.errorStateText}"
        ></cometchat-label>
      </div>`
    }, Xt = () => e.emptyStateView ? e.emptyStateView : {
      html: ` <div class='cc-messagelist__emptyview'>
        <cometchat-label
        labelStyle='${JSON.stringify(
        kN(e.messageListStyle, t)
      )}'
          text='${e.emptyStateText}'
        ></cometchat-label>
      </div>`
    }, sn = (a, C, E) => a.getDeletedAt() ? {
      background: "transparent",
      border: `1px dashed ${t.value.palette.getAccent400()}`,
      borderRadius: "12px"
    } : !a.getDeletedAt() && a.getCategory() === I.MessageCategory.message && a.getType() === I.MessageTypes.text && (!a.getSender() || (E == null ? void 0 : E.getUid()) === a.getSender().getUid()) ? {
      background: C === fo.left ? t.value.palette.getSecondary() : t.value.palette.getPrimary(),
      borderRadius: "12px"
    } : !a.getDeletedAt() && a.getCategory() === I.MessageCategory.message && a.getType() === I.MessageTypes.audio ? {
      borderRadius: "",
      background: t.value.palette.getSecondary()
    } : a.getType() === I.MessageTypes.groupMember ? {
      background: "transparent",
      borderRadius: "12px",
      border: `1px solid ${t.value.palette.getSecondary()}`
    } : (a == null ? void 0 : a.getType()) === I.calls.meeting && (!(a != null && a.getSender()) || (a == null ? void 0 : a.getSender().getUid()) == T.getUid()) ? {
      background: t.value.palette.getPrimary(),
      border: "none",
      borderRadius: "12px"
    } : !a.getDeletedAt() && a.getCategory() === I.MessageCategory.interactive ? {
      background: t.value.palette.getSecondary(),
      width: "300px"
    } : (a == null ? void 0 : a.getType()) === On.sticker ? {
      background: "transparent",
      borderRadius: "12px"
    } : a.getSender() && a.getSender().getUid() !== (E == null ? void 0 : E.getUid()) ? {
      background: t.value.palette.getSecondary(),
      borderRadius: "12px"
    } : {
      background: t.value.palette.getSecondary(),
      borderRadius: "12px"
    }, te = () => new Kt({
      borderRadius: "24px",
      width: "28px",
      height: "28px",
      border: "none",
      backgroundColor: t.value.palette.getAccent700(),
      nameTextColor: t.value.palette.getAccent900(),
      backgroundSize: "cover",
      nameTextFont: w(t.value.typography.subtitle1),
      outerViewBorderWidth: "0",
      outerViewBorderRadius: "0",
      outerViewBorderColor: "",
      outerViewBorderSpacing: "0"
    }), et = (a) => Bn(a) ? Bn(a) : a.getCategory() !== I.MessageCategory.action && (a == null ? void 0 : a.getCategory()) !== I.MessageCategory.call ? {
      html: `<div class='cc-messagelist__bubbleheader'>
              ${Hn(a) ? at(a) : ""}
              ${e.timestampAlignment === rt.top ? Bt(a) : ""}
            </div>
          `
    } : null, Ze = (a) => {
      if (a.getReplyCount() && !a.getDeletedAt()) {
        const C = Jn(a), E = e.threadIndicatorIcon;
        return [
          {
            componentName: "cometchat-icon-button",
            props: {
              text: Qi(a),
              iconURL: E,
              mirrorIcon: C === gt.left,
              buttonStyle: Vi(
                a,
                t,
                ln()
              )
            },
            // slots: {
            //   "buttonView": getUnreadCountView(item),
            // },
            listeners: {
              "cc-button-clicked": () => {
                ui(a);
              }
            }
          }
        ];
      } else
        return null;
    }, at = (a) => {
      var C;
      return `<cometchat-label
            text='${(C = a == null ? void 0 : a.getSender()) == null ? void 0 : C.getName()}'
            labelStyle='${JSON.stringify(ee)}'
          ></cometchat-label>`;
    }, Bt = (a) => `<cometchat-date
            timestamp=${a.getSentAt()}
            pattern=${e.datePattern}
            dateStyle='${JSON.stringify(
      Ta(e.messageListStyle, t)
    )}'
          ></cometchat-date>
        </>`, vn = (a) => {
      if (Qn(a))
        return Qn(a);
      {
        const C = (a == null ? void 0 : a.getReactions()) || [], E = Jn(a);
        if (C && C.length > 0 && !e.disableReactions) {
          const ue = oo(t.value);
          return {
            componentName: "cometchat-reactions",
            props: {
              messageObject: a,
              alignment: E,
              reactionsStyle: ue,
              hoverDebounceTime: 500,
              reactionClick: (ve, Ge) => {
                var nt, vt;
                (nt = e.reactionsConfiguration) != null && nt.reactionClick ? (vt = e.reactionsConfiguration) == null || vt.reactionClick(ve, Ge) : W(ve == null ? void 0 : ve.getReaction(), Ge);
              },
              reactionListConfiguration: Pn(),
              reactionInfoConfiguration: to(),
              style: {
                width: "100%",
                padding: "5px 0px",
                boxSizing: "border-box",
                display: "flex",
                marginTop: "-9px",
                justifyContent: E === gt.left ? "flex-start" : "flex-end"
              }
            }
          };
        } else
          return null;
      }
    };
    function Pn() {
      var Ge, nt, vt, mt, Qt, Oo, xo, ko, Fi, Hi, Zi, Wi, $i, Ji;
      const a = new Kt({
        borderRadius: "50%",
        width: "35px",
        height: "35px",
        border: "none",
        backgroundColor: t.value.palette.getAccent700(),
        nameTextColor: t.value.palette.getAccent900(),
        backgroundSize: "cover",
        nameTextFont: w(t.value.typography.subtitle1),
        outerViewBorderWidth: "0",
        outerViewBorderRadius: "0",
        outerViewBorderColor: "",
        outerViewBorderSpacing: "0"
      }), C = new _t({
        background: "transparent",
        activeBackground: "transparent",
        hoverBackground: "transparent",
        titleFont: w(t.value.typography.subtitle1),
        titleColor: t.value.palette.getAccent(),
        separatorColor: t.value.palette.getAccent100()
      }), E = ((nt = (Ge = e.reactionsConfiguration) == null ? void 0 : Ge.reactionListConfiguration) == null ? void 0 : nt.reactionListStyle) || {}, ue = new Gr({
        width: E.width || "320px",
        height: E.height || "300px",
        borderRadius: E.borderRadius || "12px",
        background: E.background || t.value.palette.getBackground(),
        border: E.border || "none",
        errorIconTint: E.errorIconTint || t.value.palette.getAccent400(),
        loadingIconTint: E.loadingIconTint || t.value.palette.getAccent400(),
        sliderEmojiCountFont: E.sliderEmojiCountFont || w(t.value.typography.subtitle2),
        sliderEmojiFont: E.sliderEmojiFont || w(t.value.typography.subtitle1),
        subtitleTextColor: E.subtitleTextColor || t.value.palette.getAccent500(),
        subtitleTextFont: E.subtitleTextFont || w(t.value.typography.subtitle2),
        tailViewFont: E.tailViewFont || w(t.value.typography.title1),
        dividerTint: E.dividerTint || t.value.palette.getAccent100(),
        sliderEmojiCountColor: E.sliderEmojiCountColor || t.value.palette.getAccent500(),
        activeEmojiBackground: E.activeEmojiBackground || t.value.palette.getAccent100()
      }), ve = (jo, Sr) => {
        var Ki;
        ((Ki = jo == null ? void 0 : jo.getReactedBy()) == null ? void 0 : Ki.getUid()) === (T == null ? void 0 : T.getUid()) && W(jo == null ? void 0 : jo.getReaction(), Sr);
      };
      return new Pr({
        avatarStyle: { ...a, ...((mt = (vt = e.reactionsConfiguration) == null ? void 0 : vt.reactionListConfiguration) == null ? void 0 : mt.avatarStyle) || {} },
        errorIconURL: ((Oo = (Qt = e.reactionsConfiguration) == null ? void 0 : Qt.reactionListConfiguration) == null ? void 0 : Oo.errorIconURL) || "",
        listItemStyle: { ...C, ...((ko = (xo = e.reactionsConfiguration) == null ? void 0 : xo.reactionListConfiguration) == null ? void 0 : ko.listItemStyle) || {} },
        loadingIconURL: ((Hi = (Fi = e.reactionsConfiguration) == null ? void 0 : Fi.reactionListConfiguration) == null ? void 0 : Hi.loadingIconURL) || "",
        reactionListStyle: ue,
        reactionItemClicked: ((Wi = (Zi = e.reactionsConfiguration) == null ? void 0 : Zi.reactionListConfiguration) == null ? void 0 : Wi.reactionItemClicked) || ve,
        reactionsRequestBuilder: ((Ji = ($i = e.reactionsConfiguration) == null ? void 0 : $i.reactionListConfiguration) == null ? void 0 : Ji.reactionsRequestBuilder) || null
      });
    }
    function to() {
      var E, ue, ve, Ge, nt, vt, mt, Qt, Oo, xo, ko;
      const a = ((E = e.reactionsConfiguration) == null ? void 0 : E.reactionInfoConfiguration) || {}, C = new Fr({
        background: ((ue = a == null ? void 0 : a.reactionInfoStyle) == null ? void 0 : ue.background) || t.value.palette.getAccent(),
        border: ((ve = a == null ? void 0 : a.reactionInfoStyle) == null ? void 0 : ve.border) || "none",
        borderRadius: ((Ge = a == null ? void 0 : a.reactionInfoStyle) == null ? void 0 : Ge.borderRadius) || "12px",
        errorIconTint: ((nt = a == null ? void 0 : a.reactionInfoStyle) == null ? void 0 : nt.errorIconTint) || t.value.palette.getBackground(),
        loadingIconTint: ((vt = a == null ? void 0 : a.reactionInfoStyle) == null ? void 0 : vt.loadingIconTint) || t.value.palette.getBackground(),
        namesColor: ((mt = a == null ? void 0 : a.reactionInfoStyle) == null ? void 0 : mt.namesColor) || t.value.palette.getBackground(),
        namesFont: ((Qt = a == null ? void 0 : a.reactionInfoStyle) == null ? void 0 : Qt.namesFont) || w(t.value.typography.subtitle2),
        reactedTextColor: ((Oo = a == null ? void 0 : a.reactionInfoStyle) == null ? void 0 : Oo.reactedTextColor) || t.value.palette.getAccent700("dark"),
        reactedTextFont: ((xo = a == null ? void 0 : a.reactionInfoStyle) == null ? void 0 : xo.reactedTextFont) || w(t.value.typography.subtitle2),
        reactionFontSize: ((ko = a == null ? void 0 : a.reactionInfoStyle) == null ? void 0 : ko.reactionFontSize) || "37px"
      });
      return new Hr({
        reactionInfoStyle: C,
        reactionsRequestBuilder: (a == null ? void 0 : a.reactionsRequestBuilder) || null,
        errorIconURL: (a == null ? void 0 : a.errorIconURL) || "",
        loadingIconURL: (a == null ? void 0 : a.loadingIconURL) || ""
      });
    }
    const Un = (a) => e.timestampAlignment === rt.bottom && a.getCategory() !== I.MessageCategory.action && (a == null ? void 0 : a.getCategory()) !== I.MessageCategory.call ? `
          <div class='cc-messagelist__bubbledate' style="display:inline-block;">
            <cometchat-date
              timestamp=${a.getSentAt()}
              dateStyle='${JSON.stringify(
      Ta(e.messageListStyle, t)
    )}'
              pattern=${e.datePattern}
            ></cometchat-date>
          </div>
        ` : null, Fn = (a) => {
      var C;
      return !(e.disableReceipt || e.hideReceipt) && (!(a != null && a.getSender()) || (T == null ? void 0 : T.getUid()) === ((C = a == null ? void 0 : a.getSender()) == null ? void 0 : C.getUid())) && a.getCategory() !== I.MessageCategory.action && (a == null ? void 0 : a.getCategory()) !== I.MessageCategory.call ? `<div class='cc-messagelist__receipt' style="display:inline-block; position: relative; height: fit-content; width: fit-content">
            <cometchat-receipt
              receipt=${no(a)}
              waitIcon=${e.waitIcon}
              sentIcon=${e.sentIcon}
              deliveredIcon=${e.deliveredIcon}
              readIcon=${e.readIcon}
              errorIcon=${e.errorIcon}
              receiptStyle='${JSON.stringify(QN(t, a))}'
            ></cometchat-receipt>
          </div>` : null;
    }, no = (a) => ja.getReceiptStatus(a), Hn = (a) => e.alignment == fo.left ? !0 : !!(e.group && (a == null ? void 0 : a.getCategory()) != I.MessageCategory.action && (a != null && a.getSender()) && (a == null ? void 0 : a.getSender().getUid()) != (T == null ? void 0 : T.getUid()) && e.alignment == fo.standard), Zn = (a) => {
      var E, ue;
      let C;
      return L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())] && ((E = L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())]) != null && E.contentView) ? (C = (ue = L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())]) == null ? void 0 : ue.contentView(a, Jn(a)), typeof C == "string" ? {
        html: C
      } : C) : null;
    };
    function oo(a) {
      var E;
      const C = ((E = e == null ? void 0 : e.reactionsConfiguration) == null ? void 0 : E.reactionsStyle) || {};
      return new Zr({
        height: (C == null ? void 0 : C.height) || "100%",
        width: (C == null ? void 0 : C.width) || "fit-content",
        border: (C == null ? void 0 : C.border) || "none",
        borderRadius: (C == null ? void 0 : C.borderRadius) || "0",
        background: (C == null ? void 0 : C.background) || "transparent",
        activeReactionBackground: (C == null ? void 0 : C.activeReactionBackground) || a.palette.getPrimary150(),
        reactionBackground: (C == null ? void 0 : C.reactionBackground) || a.palette.getAccent100(),
        reactionBorder: (C == null ? void 0 : C.reactionBorder) || "none",
        activeReactionBorder: (C == null ? void 0 : C.activeReactionBorder) || `1px solid ${a.palette.getPrimary500()}`,
        reactionBorderRadius: (C == null ? void 0 : C.reactionBorderRadius) || "20px",
        activeReactionCountTextColor: (C == null ? void 0 : C.activeReactionCountTextColor) || a.palette.getAccent(),
        activeReactionCountTextFont: (C == null ? void 0 : C.activeReactionCountTextFont) || w(a.typography.caption1),
        reactionCountTextFont: (C == null ? void 0 : C.reactionCountTextFont) || w(a.typography.caption1),
        reactionCountTextColor: (C == null ? void 0 : C.reactionCountTextColor) || a.palette.getAccent(),
        reactionBoxShadow: (C == null ? void 0 : C.reactionBoxShadow) || "rgba(0, 0, 0, 0.1) 0px 4px 12px",
        reactionEmojiFont: (C == null ? void 0 : C.reactionEmojiFont) || w(a.typography.subtitle1),
        baseReactionBackground: (C == null ? void 0 : C.baseReactionBackground) || a.palette.getBackground()
      });
    }
    const io = (a) => {
      var E, ue, ve;
      let C;
      return L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())] && ((E = L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())]) != null && E.bottomView) && ((ue = L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())]) != null && ue.bottomView(a, Jn(a))) ? (C = (ve = L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())]) == null ? void 0 : ve.bottomView(a, Jn(a)), typeof C == "string" ? {
        html: C
      } : C) : null;
    };
    function Wn(a) {
      var E, ue, ve;
      let C;
      return L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())] && ((E = L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())]) != null && E.statusInfoView) && ((ue = L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())]) != null && ue.statusInfoView(a, Jn(a))) ? (C = (ve = L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())]) == null ? void 0 : ve.statusInfoView(a, Jn(a)), typeof C == "string" ? {
        html: C
      } : C) : !(a != null && a.getDeletedAt()) && !(a instanceof y.Action) && !(a instanceof y.Call) ? {
        html: `
          <div
          style="position:relative; display: flex; justify-content: flex-end; "
          >
          <div style="${ro(a)}">
            ${Un(a) ? Un(a) : ""}
            ${Fn(a) ? Fn(a) : ""}
          </div>
        </div>
        `
      } : null;
    }
    const ao = (a) => {
      const C = a == null ? void 0 : a.getType();
      return [
        I.MessageTypes.image,
        I.MessageTypes.video
      ].includes(C);
    }, ro = (a) => {
      const C = Jn(a);
      return ao(a) ? `
        display: flex;
    justify-content: center;
    align-items: end;
    height: fit-content;
    border-radius: 22px;
    padding: 3px 5px;
    padding-top: ${C === gt.right ? "2px" : "3px"};
    line-height: 3px;
    position: relative;
    margin-top: -22px;
    margin-right: 12px;
    background: ${t.value.palette.getAccent500("dark")};
    gap: 4px;
        ` : (a == null ? void 0 : a.getType()) === I.MessageTypes.text ? `
        display: flex;
          justify-content: flex-end;
          align-items: end;
          padding: 0px 8px 8px;
          margin-top: ${C === gt.right ? "-6px" : "-5px"};
          gap: 4px;
        ` : `
          display: flex;
          justify-content: flex-end;
          align-items: end;
          padding: 1px 8px 8px 8px;
          gap: 4px;
        `;
    }, lo = () => ({
      ...e.messageListStyle.height ? { height: e.messageListStyle.height } : {},
      width: "100%",
      display: "flex",
      flexDirection: "column",
      top: 0
    }), Bn = (a) => {
      var E, ue;
      let C = "";
      return L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())] && ((E = L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())]) != null && E.headerView) ? (C = (ue = L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())]) == null ? void 0 : ue.headerView(a), C) : null;
    }, Qn = (a) => {
      var E, ue;
      let C = "";
      return L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())] && ((E = L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())]) != null && E.footerView) ? (C = (ue = L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())]) == null ? void 0 : ue.footerView(a), C) : null;
    }, Dn = () => {
      n.value = ge.loading, D = null, (K || Ie) && (e.messagesRequestBuilder ? (D = Ce.clone(e.messagesRequestBuilder), K ? D = D.setUID(K.getUid()).build() : D = D.setGUID(Ie.getGuid()).build()) : (D = new y.MessagesRequestBuilder().setLimit(X).setTypes(m).setCategories(A).hideReplies(!0), K ? D = D.setUID(K.getUid()).build() : D = D.setGUID(Ie.getGuid()).build()), Ri(), _.value = !0);
    }, so = async (a) => {
      var C, E, ue;
      vo(a);
      try {
        e.group && a.getReceiverType() === I.MessageReceiverType.group && a.getReceiverId() === ((C = e.group) == null ? void 0 : C.getGuid()) ? S(
          a,
          I.MessageReceiverType.group
        ) : e.user && a.getReceiverType() === I.MessageReceiverType.user && ((a == null ? void 0 : a.getSender().getUid()) === ((E = e.user) == null ? void 0 : E.getUid()) && (a == null ? void 0 : a.getReceiver().getUid()) === T.getUid() || (a == null ? void 0 : a.getReceiver().getUid()) === ((ue = e.user) == null ? void 0 : ue.getUid()) && (a == null ? void 0 : a.getSender().getUid()) === T.getUid()) && ((!(a != null && a.getReadAt()) && !(a != null && a.getParentMessageId()) && u || !(a != null && a.getReadAt()) && a.getParentMessageId() && e.parentMessageId && u) && (e.disableReceipt ? z.value = [] : y.markAsRead(a).then(() => {
          ae.ccMessageRead.next(a);
        })), await S(
          a,
          I.MessageReceiverType.user
        ));
      } catch (ve) {
        if (e.onError) {
          let Ge = new y.CometChatException({
            message: ve.message
          });
          e.onError(Ge);
        }
      }
    }, Rn = (a) => {
      try {
        const C = a;
        let E = [...N.value], ue = E.findIndex(
          (ve) => ve.getId() === C.getParentMessageId()
        );
        if (ue > -1) {
          const ve = E[ue];
          let Ge = ve.getReplyCount() ? ve.getReplyCount() : 0;
          Ge = Ge + 1, ve.setReplyCount(Ge), E.splice(ue, 1, ve), N.value = [...E];
        }
      } catch (C) {
        if (e.onError) {
          let E = new y.CometChatException({
            message: C.message
          });
          e.onError(E);
        }
      }
    }, qt = (a) => {
      var C;
      N.value.length == 0 && (n.value = ge.loaded), (!(a != null && a.getParentMessageId()) || e.parentMessageId) && (N.value.push(a), (!(a != null && a.getSender()) || (T == null ? void 0 : T.getUid()) == ((C = a == null ? void 0 : a.getSender()) == null ? void 0 : C.getUid()) || _.value) && uo());
    }, S = async (a, C) => {
      if (Rt.value = !1, ++O, a.getParentMessageId())
        Rn(a), qt(a);
      else if (O > e.thresholdValue && (r = !0, wo()), qt(a), e.scrollToBottomOnNewMessages || _.value)
        uo();
      else {
        let E = Y("NEW_MESSAGES");
        e.newMessageIndicatorText && e.newMessageIndicatorText != "" ? E = e.newMessageIndicatorText : E = z.value && z.value.length > 0 ? Y("NEW_MESSAGES") : Y("NEW_MESSAGE"), z.value && z.value.length || (z.value = []), z.value.push(a), l.value = " ↓ " + z.value.length + " " + E;
      }
      f(), Object.prototype.hasOwnProperty.call(a, "parentMessageId") === !1 && e.parentMessageId ? ++O : Object.prototype.hasOwnProperty.call(a, "parentMessageId") === !0 && e.parentMessageId && a.getParentMessageId() === e.parentMessageId && u && (e.disableReceipt ? z.value = [] : y.markAsRead(a).then(() => {
        ae.ccMessageRead.next(a);
      }));
    }, f = () => {
      e.disableSoundForMessages || (e.customSoundForMessages ? Ot.play(
        Ot.Sound.incomingMessage,
        e.customSoundForMessages
      ) : Ot.play(
        Ot.Sound.incomingMessage
      ));
    }, P = (a) => {
      try {
        if (a.getReceiver() == (T == null ? void 0 : T.getUid())) {
          if (a.getReceiptType() == I.messages.DELIVERY) {
            let C = N.value.findIndex(
              (E) => E.getId() == Number(a.getMessageId())
            );
            C > -1 && (N.value[C].setDeliveredAt(
              a.getDeliveredAt()
            ), Me(a, C));
          } else if (a.getReceiptType() == I.messages.READ) {
            let C = N.value.findIndex(
              (E) => E.getId() == Number(a.getMessageId())
            );
            gi(a, C);
          }
        }
      } catch (C) {
        if (e.onError) {
          let E = new y.CometChatException({
            message: C.message
          });
          e.onError(E);
        }
      }
    }, Me = (a, C) => {
      for (let E = C; E >= 0; E--)
        N.value[E].getDeliveredAt() || N.value[E].setDeliveredAt(a.getDeliveredAt());
    }, ze = (a, C) => {
      var E;
      return C === 0 ? `
            <cometchat-date
              timestamp=${a.getSentAt()}
              pattern='${e.DateSeparatorPattern}'
              dateStyle='${JSON.stringify(
        Na(e.dateSeparatorStyle, t)
      )}'
            ></cometchat-date>

      ` : Qe(
        (E = N.value[C - 1]) == null ? void 0 : E.getSentAt(),
        a.getSentAt()
      ) ? `

                <cometchat-date
                  timestamp=${a.getSentAt()}
                  pattern='${e.DateSeparatorPattern}'
                  dateStyle='${JSON.stringify(
        Na(e.dateSeparatorStyle, t)
      )}'
                ></cometchat-date>

            ` : null;
    }, Qe = (a, C) => {
      let E, ue;
      return E = new Date(a * 1e3), ue = new Date(C * 1e3), E.getDate() !== ue.getDate() || E.getMonth() !== ue.getMonth() || E.getFullYear() !== ue.getFullYear();
    }, Ye = async (a = null, C = null, E = null, ue = null) => {
      try {
        switch (a) {
          case I.messages.TEXT_MESSAGE_RECEIVED:
          case I.messages.MEDIA_MESSAGE_RECEIVED:
            await so(C);
            break;
          case I.messages.MESSAGE_DELIVERED:
          case I.messages.MESSAGE_READ:
            P(C);
            break;
          case I.messages.INTERACTION_GOAL_COMPLETED:
            gn(C);
            break;
          case I.messages.MESSAGE_DELETED:
          case I.messages.MESSAGE_EDITED: {
            Et(C);
            break;
          }
          case I.messages.MESSAGE_REACTION_ADDED:
            $t(C, !0);
            break;
          case I.messages.MESSAGE_REACTION_REMOVED:
            $t(C, !1);
            break;
          case I.groupMemberAction.SCOPE_CHANGE:
          case I.groupMemberAction.JOINED:
          case I.groupMemberAction.LEFT:
          case I.groupMemberAction.ADDED:
          case I.groupMemberAction.KICKED:
          case I.groupMemberAction.BANNED:
          case I.groupMemberAction.UNBANNED: {
            E && e.group && E.getGuid() == e.group.getGuid() && qt(C);
            break;
          }
          case I.messages.CUSTOM_MESSAGE_RECEIVED:
          case I.messages.INTERACTIVE_MESSAGE_RECEIVED:
            Ln(C);
            break;
          default:
            return;
        }
      } catch (ve) {
        if (e.onError) {
          let Ge = new y.CometChatException({
            message: ve.message
          });
          e.onError(Ge);
        }
      }
    };
    function At(a) {
      var nt, vt;
      const C = a == null ? void 0 : a.getReceiverId(), E = a == null ? void 0 : a.getReceiverType(), ue = (vt = (nt = a == null ? void 0 : a.getReaction()) == null ? void 0 : nt.getReactedBy()) == null ? void 0 : vt.getUid(), ve = a == null ? void 0 : a.getParentMessageId(), Ge = e.parentMessageId && String(e.parentMessageId);
      if (Ge)
        return ve === Ge;
      if (a.getParentMessageId())
        return !1;
      if (e.user) {
        if (E === I.MessageReceiverType.user && (C === e.user.getUid() || ue === e.user.getUid()))
          return !0;
      } else if (e.group && E === I.MessageReceiverType.group && C === e.group.getGuid())
        return !0;
      return !1;
    }
    function $t(a, C) {
      var vt;
      if (!At(a))
        return !1;
      const E = (vt = a == null ? void 0 : a.getReaction()) == null ? void 0 : vt.getMessageId(), ue = Ve(E);
      if (!ue)
        return !1;
      let ve;
      C ? ve = y.REACTION_ACTION.REACTION_ADDED : ve = y.REACTION_ACTION.REACTION_REMOVED;
      const Ge = y.CometChatHelper.updateMessageWithReactionInfo(
        ue,
        a.getReaction(),
        ve
      ), nt = Ce.clone(Ge);
      Ut(nt);
    }
    const Ln = (a) => {
      var C, E, ue;
      try {
        vo(a), e.group && a.getReceiverType() === I.MessageReceiverType.group && a.getReceiverId() === ((C = e.group) == null ? void 0 : C.getGuid()) ? ((!(a != null && a.getReadAt()) && !(a != null && a.getParentMessageId()) && u || !(a != null && a.getReadAt()) && a.getParentMessageId() && e.parentMessageId && u) && (e.disableReceipt ? z.value = [] : y.markAsRead(a).then(() => {
          ae.ccMessageRead.next(a);
        })), wn(
          a,
          I.MessageReceiverType.group
        )) : e.user && a.getReceiverType() === I.MessageReceiverType.user && ((a == null ? void 0 : a.getSender().getUid()) === ((E = e.user) == null ? void 0 : E.getUid()) && a.getReceiverId() === (T == null ? void 0 : T.getUid()) || (T == null ? void 0 : T.getUid()) === (a == null ? void 0 : a.getSender().getUid()) && a.getReceiverId() === ((ue = e.user) == null ? void 0 : ue.getUid())) && ((!(a != null && a.getReadAt()) && !(a != null && a.getParentMessageId()) && u || !(a != null && a.getReadAt()) && a.getParentMessageId() && e.parentMessageId && u) && (e.disableReceipt ? z.value = [] : y.markAsRead(a).then(() => {
          ae.ccMessageRead.next(a);
        })), wn(
          a,
          I.MessageReceiverType.user
        ));
      } catch (ve) {
        if (e.onError) {
          let Ge = new y.CometChatException({
            message: ve.message
          });
          e.onError(Ge);
        }
      }
      return !0;
    }, wn = (a, C) => {
      if (++O, a.getParentMessageId())
        Rn(a), qt(a);
      else if (O > e.thresholdValue && (r = !0, wo()), qt(a), e.scrollToBottomOnNewMessages && Ee == 0)
        uo();
      else {
        let E = Y("NEW_MESSAGES");
        e.newMessageIndicatorText && e.newMessageIndicatorText != "" ? E = e.newMessageIndicatorText : E = z.value.length > 0 ? Y("NEW_MESSAGES") : Y("NEW_MESSAGE"), z.value.push(a), l.value = " ↓ " + z.value.length + " " + E;
      }
      f(), Object.prototype.hasOwnProperty.call(a, "parentMessageId") === !1 && !e.parentMessageId ? ++O : Object.prototype.hasOwnProperty.call(a, "parentMessageId") === !0 && e.parentMessageId && u && a.getParentMessageId() === e.parentMessageId && (e.disableReceipt ? z.value = [] : y.markAsRead(a).then(() => {
        ae.ccMessageRead.next(a);
      }));
    }, St = (a) => {
      Rt.value = !1;
      const C = [...N.value], E = C.findIndex((ue) => ue.getId() === (a == null ? void 0 : a.getId()));
      E > -1 && (C[E] = a, N.value = C);
    }, Et = (a) => {
      var C, E, ue;
      try {
        (e.group && a.getReceiverType() === I.MessageReceiverType.group && a.getReceiverId() === ((C = e.group) == null ? void 0 : C.getGuid()) || e.user && a.getReceiverType() === I.MessageReceiverType.user && (T == null ? void 0 : T.getUid()) === a.getReceiverId() && (a == null ? void 0 : a.getSender().getUid()) === ((E = e.user) == null ? void 0 : E.getUid()) || e.user && a.getReceiverType() === I.MessageReceiverType.user && (T == null ? void 0 : T.getUid()) === (a == null ? void 0 : a.getSender().getUid()) && a.getReceiverId() === ((ue = e.user) == null ? void 0 : ue.getUid())) && St(a);
      } catch (ve) {
        if (e.onError) {
          let Ge = new y.CometChatException({
            message: ve.message
          });
          e.onError(Ge);
        }
      }
    }, $n = () => {
      try {
        y.addGroupListener(
          R,
          new y.GroupListener({
            onGroupMemberScopeChanged: (a, C, E, ue, ve) => {
              Ye(
                I.groupMemberAction.SCOPE_CHANGE,
                a,
                ve,
                { user: C, scope: E }
              );
            },
            onGroupMemberKicked: (a, C, E, ue) => {
              Ye(
                I.groupMemberAction.KICKED,
                a,
                ue,
                {
                  user: C,
                  hasJoined: !1
                }
              );
            },
            onGroupMemberBanned: (a, C, E, ue) => {
              Ye(
                I.groupMemberAction.BANNED,
                a,
                ue,
                {
                  user: C
                }
              );
            },
            onGroupMemberUnbanned: (a, C, E, ue) => {
              Ye(
                I.groupMemberAction.UNBANNED,
                a,
                ue,
                { user: C }
              );
            },
            onMemberAddedToGroup: (a, C, E, ue) => {
              Ye(
                I.groupMemberAction.ADDED,
                a,
                ue,
                {
                  user: C,
                  hasJoined: !0
                }
              );
            },
            onGroupMemberLeft: (a, C, E) => {
              Ye(
                I.groupMemberAction.LEFT,
                a,
                E,
                {
                  user: C
                }
              );
            },
            onGroupMemberJoined: (a, C, E) => {
              Ye(
                I.groupMemberAction.JOINED,
                a,
                E,
                {
                  user: C
                }
              );
            }
          })
        );
      } catch (a) {
        if (e.onError) {
          let C = new y.CometChatException({
            message: a.message
          });
          e.onError(C);
        }
      }
    }, Mo = () => {
      try {
        y.addConnectionListener(h.value, new y.ConnectionListener({
          onConnected: () => {
            Lr(), i = !0, Rt.value = !1, ho(), i = !1;
          }
        }));
      } catch (a) {
        e.onError && e.onError(a);
      }
    }, Eo = () => {
      try {
        y.addCallListener(
          Q,
          new y.CallListener({
            onIncomingCallReceived: (a) => {
              mn(a);
            },
            onIncomingCallCancelled: (a) => {
              mn(a);
            },
            onOutgoingCallRejected: (a) => {
              mn(a);
            },
            onOutgoingCallAccepted: (a) => {
              mn(a);
            },
            onCallEndedMessageReceived: (a) => {
              mn(a);
            }
          })
        );
      } catch (a) {
        if (e.onError) {
          let C = new y.CometChatException({
            message: a.message
          });
          e.onError(C);
        }
      }
    }, mn = (a) => {
      try {
        oi(a) && Ne.names.includes("calling") && qt(a);
      } catch (C) {
        if (e.onError) {
          let E = new y.CometChatException({
            message: C.message
          });
          e.onError(E);
        }
      }
    }, oi = (a) => {
      const C = a.getReceiverType(), E = a.getReceiverId(), ue = a.getSender().getUid();
      return C === I.MessageReceiverType.user ? E === (K == null ? void 0 : K.getUid()) && ue === (T == null ? void 0 : T.getUid()) || ue === (K == null ? void 0 : K.getUid()) && E === (T == null ? void 0 : T.getUid()) : (Ie == null ? void 0 : Ie.getGuid()) === E;
    }, ho = () => {
      let a = N.value.length - 1;
      if (i) {
        let C;
        e.messagesRequestBuilder ? C = e.messagesRequestBuilder.setMessageId(N.value[a].getId()).build() : e.user ? C = new y.MessagesRequestBuilder().setUID(e.user.getUid()).setLimit(X).setTypes(m).setMessageId(N.value[a].getId()).setCategories(A).hideReplies(!0).build() : C = new y.MessagesRequestBuilder().setGUID(e.group.getGuid()).setLimit(X).setTypes(m).setMessageId(N.value[a].getId()).setCategories(A).hideReplies(!0).build(), C.fetchNext().then(
          (E) => {
            if (E && E.length > 0 && (E = E.map((ue) => ue.getCategory() === I.MessageCategory.interactive ? To.convertInteractiveMessage(ue) : ue)), n.value = ge.loading, E.length === 0 && N.value.length === 0) {
              n.value = ge.loaded;
              return;
            }
            if (Ee = Ee > 0 ? --Ee : 0, E && E.length) {
              let ue = E[E.length - 1];
              ue != null && ue.getReadAt() || (e.disableReceipt ? z.value = [] : y.markAsRead(ue)), n.value = ge.loaded, E.forEach((ve) => {
                var Ge;
                ((Ge = ve == null ? void 0 : ve.getSender()) == null ? void 0 : Ge.getUid()) != (T == null ? void 0 : T.getUid()) && vo(ve);
              }), mo(E);
            } else
              N.value.length && (n.value = ge.loaded);
          },
          (E) => {
            var ue;
            if (N.value && ((ue = N.value) == null ? void 0 : ue.length) > 0 ? n.value = ge.loaded : n.value = ge.error, e.onError) {
              let ve = new y.CometChatException({
                message: E.message
              });
              e.onError(ve);
            }
          }
        ).catch((E) => {
          var ue;
          if (N.value && ((ue = N.value) == null ? void 0 : ue.length) > 0 ? n.value = ge.loaded : n.value = ge.error, e.onError) {
            let ve = new y.CometChatException({
              message: E.message
            });
            e.onError(ve);
          }
        });
      }
    }, vo = (a) => {
      !e.disableReceipt && (a == null ? void 0 : a.getSender().getUid()) !== (T == null ? void 0 : T.getUid()) && Object.prototype.hasOwnProperty.call(a, "deliveredAt") === !1 && y.markAsDelivered(a);
    }, mo = (a) => {
      N.value.push(...a), O = N.value.length, O > e.thresholdValue && (r = !0, wo()), n.value = ge.loaded;
    }, ii = (a, C) => {
      for (let E = C; E >= 0; E--)
        N.value[E].getDeliveredAt() || N.value[E].setDeliveredAt(a.getDeliveredAt());
    }, dn = (a) => {
      var C, E;
      try {
        N.value = [...a, ...N.value], O = N.value.length, O > e.thresholdValue && (r = !1, wo()), n.value = ge.loaded, ie && (it.ccActiveChatChanged.next({
          user: K,
          group: Ie,
          message: N.value[((C = N.value) == null ? void 0 : C.length) - 1]
        }), ie = !1);
      } catch (ue) {
        if (N.value && ((E = N.value) == null ? void 0 : E.length) > 0 ? n.value = ge.loaded : n.value = ge.error, e.onError) {
          let ve = new y.CometChatException({
            message: ue.message
          });
          e.onError(ve);
        }
      }
    }, uo = (a = !0) => {
      var C;
      try {
        if (Rt.value = !0, l.value = null, u = !0, _.value = !0, !a)
          Ee > 0 && (N.value = [], Ee = 0, i = !1, N.value = [], z.value = [], Dn(), pn(() => {
            Rt.value = !0;
          }));
        else {
          let E;
          z.value.length ? (E = z.value[z.value.length - 1], z.value = []) : E = N.value[N.value.length - 1], !e.disableReceipt && E && !E.getReadAt() && ((C = E.getSender()) == null ? void 0 : C.getUid()) !== (T == null ? void 0 : T.getUid()) ? y.markAsRead(E).then((ue) => {
            ae.ccMessageRead.next(E);
            let ve = N.value.findIndex(
              (Ge) => Ge.getId() === Number(ue == null ? void 0 : ue.getMessageId())
            );
            ve > -1 && gi(ue, ve);
          }).catch((ue) => {
          }) : z.value = [];
        }
        pn(() => {
          Rt.value = !1;
        });
      } catch (E) {
        if (e.onError) {
          let ue = new y.CometChatException({
            message: E.message
          });
          e.onError(ue);
        }
      }
    }, wo = () => {
      e.parentMessageId || (O = 0), D = null, y.removeGroupListener(R), y.removeCallListener(Q), y.removeConnectionListener(h.value), ai();
    }, ai = () => {
      i = !0, R = "group_" + (/* @__PURE__ */ new Date()).getTime(), Q = "call_" + (/* @__PURE__ */ new Date()).getTime(), $n(), Mo(), e.messagesRequestBuilder ? (r ? N.value.splice(1, N.value.length - 30) : N.value.splice(30), D = e.messagesRequestBuilder) : r ? (N.value.splice(0, N.value.length - 30), uo(!0)) : N.value.splice(30);
    }, ri = (a) => {
      let C = [];
      if (b && b.length > 0 && !a.getDeletedAt() && a.getType() !== I.MessageTypes.groupMember && (a == null ? void 0 : a.getCategory()) !== I.MessageCategory.call)
        try {
          b.forEach((E) => {
            E.type === a.getType() && (C = si(
              E == null ? void 0 : E.options(T, a, t.value, e.group),
              a == null ? void 0 : a.getId()
            ));
          });
        } catch {
        }
      return C = li(C), C;
    }, li = (a) => e.disableReactions ? a.filter((C) => C.id !== I.MessageOption.reactToMessage) : a, si = (a, C) => (a.forEach((E) => {
      switch (E.id) {
        case I.MessageOption.deleteMessage:
          E.onClick || (E.onClick = De);
          break;
        case I.MessageOption.editMessage:
          E.onClick || (E.onClick = Mt);
          break;
        case I.MessageOption.translateMessage:
          E.onClick;
          break;
        case I.MessageOption.copyMessage:
          E.onClick || (E.onClick = jn);
          break;
        case I.MessageOption.reactToMessage:
          (!E.onClick || !E.customView) && (E.customView = Mi(C));
          break;
        case I.MessageOption.replyInThread:
          E.onClick || (E.onClick = gr);
          break;
        case I.MessageOption.sendMessagePrivately:
          E.onClick || (E.onClick = ur);
          break;
        case I.MessageOption.messageInformation:
          E.onClick || (E.onClick = cr);
          break;
      }
    }), a), Mi = (a) => {
      let C = e == null ? void 0 : e.emojiKeyboardStyle, E = new pl({
        width: (C == null ? void 0 : C.width) || "320px",
        height: (C == null ? void 0 : C.height) || "300px",
        border: (C == null ? void 0 : C.border) || "1px solid #e0e0e0",
        borderRadius: (C == null ? void 0 : C.borderRadius) || "8px",
        activeIconTint: (C == null ? void 0 : C.activeIconTint) || t.value.palette.getPrimary(),
        background: C == null ? void 0 : C.background,
        iconTint: C == null ? void 0 : C.iconTint,
        textColor: C == null ? void 0 : C.textColor,
        textFont: C == null ? void 0 : C.textFont
      });
      const ue = Ve(a);
      return (ve) => ({
        componentName: "cometchat-emoji-keyboard",
        props: {
          emojiKeyboardStyle: E,
          style: {
            zIndex: "100"
          }
        },
        listeners: {
          "cc-emoji-clicked": (Ge) => {
            var nt;
            ve(Ge), W((nt = Ge == null ? void 0 : Ge.detail) == null ? void 0 : nt.id, ue);
          }
        }
      });
    };
    function W(a, C) {
      const E = C == null ? void 0 : C.getId(), ue = Ve(E), ve = (ue == null ? void 0 : ue.getReactions()) || [], Ge = ve == null ? void 0 : ve.find(
        (nt) => (nt == null ? void 0 : nt.reaction) == a
      );
      if (Ge && (Ge != null && Ge.getReactedByMe())) {
        const nt = [];
        ve.forEach((mt) => {
          if ((mt == null ? void 0 : mt.getReaction()) == a) {
            if ((mt == null ? void 0 : mt.getCount()) === 1)
              return;
            mt.setCount((mt == null ? void 0 : mt.getCount()) - 1), mt.setReactedByMe(!1), nt.push(mt);
          } else
            nt.push(mt);
        });
        const vt = Ce.clone(ue);
        vt.setReactions(nt), Ut(vt), y.removeReaction(E, a).then((mt) => {
        }).catch((mt) => {
          Ut(ue), console.log(mt);
        });
      } else {
        const nt = [], vt = ve.find((Qt) => (Qt == null ? void 0 : Qt.getReaction()) == a);
        if (ve.forEach((Qt) => {
          (Qt == null ? void 0 : Qt.getReaction()) == a && (Qt.setCount((Qt == null ? void 0 : Qt.getCount()) + 1), Qt.setReactedByMe(!0)), nt.push(Qt);
        }), !vt) {
          const Qt = new y.ReactionCount(a, 1, !0);
          nt.push(Qt);
        }
        const mt = Ce.clone(ue);
        mt.setReactions(nt), Ut(mt), y.addReaction(E, a).then((Qt) => {
        }).catch((Qt) => {
          console.log(Qt), Ut(ue);
        });
      }
    }
    const De = (a) => {
      let C = Ve(a);
      C && ut(C);
    }, Be = (a) => {
      let C;
      return L && L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())] && L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())].bubbleView ? (C = L[(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())].bubbleView(a), C) : (C = null, C);
    }, Ve = (a) => {
      let C = N.value.findIndex(
        (E) => E.getId() == a
      );
      return C > -1 ? N.value[C] : !1;
    }, ut = (a) => {
      try {
        const C = a.getId();
        y.deleteMessage(C).then((E) => {
          Dt(E), ae.ccMessageDeleted.next(E);
        }).catch((E) => {
          if (e.onError) {
            let ue = new y.CometChatException({
              message: E.message
            });
            e.onError(ue);
          }
        });
      } catch (C) {
        if (e.onError) {
          let E = new y.CometChatException({
            message: C.message
          });
          e.onError(E);
        }
      }
    }, Dt = (a) => {
      try {
        const C = N.value.findIndex(
          (E) => E.getId() === a.getId()
        );
        C > -1 && (N.value.splice(C, 1, a), N.value = [...N.value]);
      } catch (C) {
        if (e.onError) {
          let E = new y.CometChatException({
            message: C.message
          });
          e.onError(E);
        }
      }
    }, Mt = (a) => {
      let C = Ve(a);
      C && ht(C);
    }, ht = (a) => {
      ae.ccMessageEdited.next({
        message: a,
        status: Xe.inprogress
      });
    }, jn = (a) => {
      let C = Ve(a);
      C && sr(C);
    }, sr = (a) => {
      var E;
      navigator.clipboard.writeText(a.getText());
      let C = a.getText();
      !e.disableMentions && a.getMentionedUsers && ((E = a == null ? void 0 : a.getMentionedUsers()) != null && E.length) && (C = Mr(a)), navigator.clipboard.writeText(C);
    }, Mr = (a) => {
      const C = /<@uid:(.*?)>/g;
      let E = a.getText(), ue = a.getText(), ve = C.exec(E), Ge = a == null ? void 0 : a.getMentionedUsers();
      for (; ve !== null; ) {
        let nt;
        for (let vt = 0; vt < Ge.length; vt++)
          ve[1] == Ge[vt].getUid() && (nt = Ge[vt]);
        nt && (ue = ue.replace(
          ve[0],
          "@" + nt.getName()
        )), ve = C.exec(E);
      }
      return ue;
    }, ur = (a) => {
      let E = Ve(a).getSender();
      it.ccOpenChat.next({
        user: E
      });
    }, ui = (a) => {
      e.onThreadRepliesClick && e.onThreadRepliesClick(a, Ir);
    }, gr = (a) => {
      let C = Ve(a);
      ui(C);
    }, cr = (a) => {
      let C = Ve(a);
      dr(C);
    }, dr = (a) => {
      c.value = !0, d.value = a;
    }, Ir = (a) => Be(a) ? Be(a) : {
      componentName: "CometChatMessageBubble",
      props: {
        id: (a == null ? void 0 : a.getId()) || (a == null ? void 0 : a.getMuid()),
        messageBubbleStyle: sn(
          a,
          e.alignment,
          T
        ),
        alignment: Tt,
        replyView: null,
        threadView: null,
        leadingView: Yi(a),
        headerView: et(a),
        contentView: Zn(a),
        statusInfoView: Wn(a)
      }
    }, Qi = (a) => {
      const C = (a == null ? void 0 : a.getReplyCount()) || 0, E = C === 1 ? Y("REPLY") : Y("REPLIES");
      return `${C} ${E}`;
    }, gi = (a, C) => {
      const E = N.value.map(
        (ue, ve) => (ve <= C && ue.getSender().getUid() === (T == null ? void 0 : T.getUid()) && !ue.getReadAt() && ue.setReadAt(a.getReadAt()), ue)
      );
      N.value = E, ae.ccMessageRead.next(N.value[C]);
    }, Nr = async () => {
      _.value = !0, ho();
    }, Tr = async () => {
      Pt || (Rt.value = !1, x = !0, await Ri(), x = !1);
    }, Ri = async () => {
      i && (e.messagesRequestBuilder ? D = e.messagesRequestBuilder.setMessageId(N.value[0].getId()).build() : (D = new y.MessagesRequestBuilder().setLimit(X).setTypes(m).setMessageId(N.value[0].getId()).setCategories(A).hideReplies(!0), K ? D = D.setUID(K.getUid()).build() : D = D.setGUID(Ie.getGuid()).build())), await D.fetchPrevious().then(
        (a) => {
          if (a && a.length > 0 && (a = a.map((C, E) => C.getCategory() === I.MessageCategory.interactive ? To.convertInteractiveMessage(C) : C)), n.value = ge.loading, a.length === 0 && N.value.length === 0) {
            ie && (it.ccActiveChatChanged.next({
              user: K,
              group: Ie,
              message: void 0
            }), ie = !1), n.value = ge.loaded;
            return;
          }
          a && a.length > 0 ? Dr().then((C) => {
            var ue;
            C && it.ccActiveChatChanged.next({
              user: K,
              group: Ie,
              message: void 0,
              unreadMessageCount: C
            }), x && a.length + N.value.length >= e.thresholdValue && (u = !1, ++Ee);
            let E = a[a.length - 1];
            !(E != null && E.getReadAt()) && ((ue = E == null ? void 0 : E.getSender()) == null ? void 0 : ue.getUid()) != (T == null ? void 0 : T.getUid()) && (e.disableReceipt ? z.value = [] : y.markAsRead(E).then((ve) => {
              let Ge = N.value.findIndex(
                (nt) => nt.getId() === Number(ve == null ? void 0 : ve.getMessageId())
              );
              Ge > -1 && gi(ve, Ge), e.parentMessageId && ae.ccMessageRead.next(E);
            }).catch((ve) => {
              if (e.onError) {
                let Ge = new y.CometChatException({
                  message: ve.message
                });
                e.onError(Ge);
              }
            })), n.value = ge.loaded, a.forEach((ve) => {
              var Ge;
              ((Ge = ve == null ? void 0 : ve.getSender()) == null ? void 0 : Ge.getUid()) != (T == null ? void 0 : T.getUid()) && !e.disableReceipt && !ve.getDeliveredAt() && y.markAsDelivered(ve).then(
                (nt) => {
                  let vt = N.value.findIndex(
                    (mt) => mt.getId() === Number(nt == null ? void 0 : nt.getMessageId())
                  );
                  vt > -1 && ii(nt, vt);
                }
              );
            }), dn(a);
          }) : n.value = ge.loaded;
        },
        (a) => {
          var C;
          if (N.value && ((C = N.value) == null ? void 0 : C.length) > 0 ? n.value = ge.loaded : n.value = ge.error, e.onError) {
            let E = new y.CometChatException({
              message: a.message
            });
            e.onError(E);
          }
        }
      ).catch((a) => {
        var C;
        if (N.value && ((C = N.value) == null ? void 0 : C.length) > 0 ? n.value = ge.loaded : n.value = ge.error, e.onError) {
          let E = new y.CometChatException({
            message: a.message
          });
          e.onError(E);
        }
      });
    }, Dr = async () => {
      let a = 0;
      return e.user ? a = (await y.getUnreadMessageCountForUser(
        e.user.getUid()
      ))[e.user.getUid()] : e.group && (a = (await y.getUnreadMessageCountForGroup(e.group.getGuid()))[e.group.getGuid()]), a;
    }, Jn = (a) => {
      let C = gt.center;
      return e.alignment == fo.left ? C = gt.left : (a == null ? void 0 : a.getType()) == I.MessageTypes.groupMember || (a == null ? void 0 : a.getCategory()) == I.MessageCategory.call ? C = gt.center : !(a != null && a.getSender()) || (a == null ? void 0 : a.getSender().getUid()) == T.getUid() && (a == null ? void 0 : a.getType()) != I.MessageTypes.groupMember ? C = gt.right : C = gt.left, C;
    }, Yi = (a) => {
      var C, E;
      if (a.getCategory() !== I.MessageCategory.action && (a == null ? void 0 : a.getCategory()) !== I.MessageCategory.call && e.showAvatar && Hn(a)) {
        const ue = {
          ...te(),
          ...e.avatarStyle
        };
        return {
          html: `              <cometchat-avatar
                  name="${(C = a == null ? void 0 : a.getSender()) == null ? void 0 : C.getName()}"
                  avatarStyle='${JSON.stringify(ue)}'
                  image="${((E = a == null ? void 0 : a.getSender()) == null ? void 0 : E.getAvatar()) || ""}"
                >
                </cometchat-avatar>`
        };
      } else
        return null;
    }, yr = () => Te, Cr = () => H.value, wr = () => new So({
      height: e.messageListStyle.height || "100%",
      width: e.messageListStyle.width || "100%",
      background: e.messageListStyle.background || "transparent"
    }), jr = () => {
      c.value = !1, d.value = null;
    }, Ar = (a) => L[`${(a == null ? void 0 : a.getCategory()) + "_" + (a == null ? void 0 : a.getType())}`];
    function Lr() {
      let a;
      e.user && se ? a = new y.MessagesRequestBuilder().setUID(e.user.getUid()).setType(I.MessageCategory.message).setCategory(I.MessageCategory.action).setMessageId(se.value).setLimit(X).build() : e.group && se && (a = new y.MessagesRequestBuilder().setGUID(e.group.getGuid()).setType(I.MessageCategory.message).setMessageId(se.value).setLimit(X).setCategory(I.MessageCategory.action).build()), a == null || a.fetchNext().then((C) => {
        C && C.length > 0 && (C.forEach((E) => {
          if (E.getActionOn().getCategory() === I.MessageCategory.message) {
            let ve = N.value.findIndex(
              (Ge) => Ge.getId() === E.getActionOn().getId()
            );
            ve >= 0 && (N.value[ve] = E.getActionOn());
          }
        }), N.value = [...N.value]);
      });
    }
    const Vi = (a, C, E) => {
      var ue, ve, Ge, nt;
      return !a.getSender() || a.getSender().getUid() === (E == null ? void 0 : E.getUid()) ? {
        height: "100%",
        width: "100%",
        border: "none",
        borderRadius: "0",
        background: "transparent",
        buttonIconTint: e.messageListStyle.threadReplyIconTint || C.value.palette.getAccent600(),
        display: "flex",
        flexFlow: "row-reverse",
        alignItems: "center",
        buttonTextColor: ((ue = e.messageListStyle) == null ? void 0 : ue.threadReplyTextColor) || C.value.palette.getAccent(),
        buttonTextFont: ((ve = e.messageListStyle) == null ? void 0 : ve.threadReplyTextFont) || w(C.value.typography.text2),
        iconHeight: "15px",
        iconWidth: "15px",
        gap: "5px"
      } : {
        height: "100%",
        width: "100%",
        border: "none",
        borderRadius: "0",
        background: "transparent",
        buttonIconTint: e.messageListStyle.threadReplyIconTint || C.value.palette.getAccent600(),
        display: "flex",
        flexFlow: "row",
        alignItems: "center",
        gap: "5px",
        buttonTextColor: ((Ge = e.messageListStyle) == null ? void 0 : Ge.threadReplyTextColor) || C.value.palette.getAccent(),
        buttonTextFont: ((nt = e.messageListStyle) == null ? void 0 : nt.threadReplyTextFont) || w(C.value.typography.text2),
        iconHeight: "15px",
        iconWidth: "15px"
      };
    }, zr = Ht(() => {
      const a = new Di({
        background: t.value.palette.getAccent400(),
        position: "absolute"
      });
      return new Di({
        ...a,
        ...e.backdropStyle
      });
    });
    return {
      setScrollListToBottom: Rt,
      componentState: n,
      MessageTypesConstant: k,
      textStyle: B,
      MessageBubbleStyle: sn,
      messagesList: N,
      theme: t,
      loggedInUser: T,
      MessageBubbleAlignment: gt,
      getBubbleAlignment: Jn,
      getContentView: Zn,
      getHeaderView: Bn,
      getFooterView: Qn,
      MessageCategory: o,
      showMessageInformation: c,
      selectedMessage: d,
      getBubbleLeadingView: Yi,
      getListStyle: wr,
      getBubbleStatusInfoViewDate: Un,
      getBubbleFooterView: vn,
      getBubbleHeaderView: et,
      newMessageCount: l,
      unreadMessagesStyle: J,
      scrollToBottom: uo,
      UnreadCount: z,
      isOnBottom: u,
      setMessageOptions: ri,
      openThreadView: ui,
      getThreadCount: Qi,
      threadedAlignment: Tt,
      openThreadViewToggle: F,
      currentMessage: G,
      getBubbleWrapper: Be,
      topCallback: Tr,
      bottomCallback: Nr,
      getEmptyHtml: Xt,
      getLoaderHtml: Tn,
      getErrorHtml: Vt,
      getMessageBubbleDate: ze,
      MessageThreadViewStyle: Vi,
      unreadMessageStyle: YN,
      fetchNextMessage: ho,
      getLoggedinUser: ln,
      getMessageListDivStyle: lo,
      getDividerStyle: Yt,
      threadOpenIcon: oe,
      SearchIcon: Yn,
      TitleAlignment: kn,
      getBubbleThreadView: Ze,
      showSmartReplyRef: re,
      getSmartReplyView: yr,
      MessageListFooterStyle: xN,
      MessageListHeaderStyle: UN,
      confirmDialogView: Ae,
      getBottomView: io,
      showOngoingCallRef: s,
      getOngoingCallView: Cr,
      ListStyle: So,
      onInformationClose: jr,
      getMessageTemplate: Ar,
      onBottom: _,
      getStatusInfoView: Wn,
      computedBackdropStyle: zr
    };
  }
});
const PN = ["backdropStyle"], FN = {
  key: 0,
  class: "cc-messagelist__message-information"
}, HN = ["innerHTML"], ZN = ["v-slot", "v-html"], WN = {
  key: 3,
  class: "cc-messagelist__messageindicator"
}, $N = ["text", "buttonStyle"], JN = { key: 0 }, KN = ["innerHTML"], XN = ["v-slot", "v-html"], qN = { class: "cc-messagelist__date__container" }, _N = ["innerHTML"], eT = { key: 0 }, tT = ["innerHTML"], nT = ["v-slot", "v-html"], oT = {
  key: 0,
  style: { height: "100%", width: "100%" }
}, iT = ["innerHTML"], aT = ["v-slot", "v-html"], rT = { key: 1 }, lT = ["innerHTML"], sT = ["v-slot", "v-html"], MT = { key: 2 }, uT = ["innerHTML"], gT = ["v-slot", "v-html"];
function cT(e, t, n, o, i, l) {
  var c;
  const r = Je("CometChatMessageInformation"), u = Je("CometChatMessageBubble"), s = Je("CometChatList");
  return M(), g(we, null, [
    e.showMessageInformation && e.selectedMessage ? (M(), g("cometchat-backdrop", {
      key: 0,
      backdropStyle: e.computedBackdropStyle
    }, [
      e.showMessageInformation && e.selectedMessage ? (M(), g("div", FN, [
        Nt(r, {
          message: e.selectedMessage,
          onClose: e.messageInformationConfiguration.onClose || e.onInformationClose,
          template: e.getMessageTemplate(e.selectedMessage),
          loadingStateView: e.messageInformationConfiguration.loadingStateView,
          errorStateView: e.messageInformationConfiguration.errorStateView,
          listItemStyle: e.messageInformationConfiguration.listItemStyle,
          emptyStateView: e.messageInformationConfiguration.emptyStateView,
          loadingIconURL: e.messageInformationConfiguration.loadingIconURL,
          readIcon: e.messageInformationConfiguration.readIcon,
          deliveredIcon: e.messageInformationConfiguration.deliveredIcon,
          onError: e.messageInformationConfiguration.onError,
          subtitleView: e.messageInformationConfiguration.subtitleView,
          listItemView: e.messageInformationConfiguration.listItemView,
          messageInformationStyle: e.messageInformationConfiguration.messageInformationStyle || {},
          bubbleView: e.messageInformationConfiguration.bubbleView,
          closeIconURL: e.messageInformationConfiguration.closeIconURL,
          receiptDatePattern: e.messageInformationConfiguration.receiptDatePattern
        }, null, 8, ["message", "onClose", "template", "loadingStateView", "errorStateView", "listItemStyle", "emptyStateView", "loadingIconURL", "readIcon", "deliveredIcon", "onError", "subtitleView", "listItemView", "messageInformationStyle", "bubbleView", "closeIconURL", "receiptDatePattern"])
      ])) : $("", !0)
    ], 8, PN)) : $("", !0),
    e.confirmDialogView && e.confirmDialogView.html ? (M(), g("div", {
      key: 1,
      innerHTML: e.confirmDialogView.html
    }, null, 8, HN)) : e.confirmDialogView && e.confirmDialogView.componentName ? (M(), je(fe(e.confirmDialogView.componentName), me({ key: 2 }, { ...e.confirmDialogView.props }, xe((c = e.confirmDialogView) == null ? void 0 : c.listeners)), {
      default: be(() => [
        (M(!0), g(we, null, pe(e.confirmDialogView.slots, (d, N) => (M(), g("div", {
          key: N,
          "v-slot": [N],
          "v-html": d
        }, null, 8, ZN))), 128))
      ]),
      _: 1
    }, 16)) : $("", !0),
    e.UnreadCount && e.UnreadCount.length > 0 && !e.onBottom ? (M(), g("div", WN, [
      p("cometchat-button", {
        text: e.newMessageCount,
        buttonStyle: e.unreadMessagesStyle,
        onCcButtonClicked: t[0] || (t[0] = (d) => e.scrollToBottom())
      }, null, 40, $N)
    ])) : $("", !0),
    p("div", {
      class: "cc__messagelist__headerview",
      style: ce(e.MessageListHeaderStyle())
    }, [
      e.headerView ? (M(), g("div", JN, [
        e.headerView.html ? (M(), g("div", {
          key: 0,
          innerHTML: e.headerView.html
        }, null, 8, KN)) : (M(), je(fe(e.headerView.componentName), me({ key: 1 }, { ...e.headerView.props }, xe(e.headerView ? e.headerView : {})), {
          default: be(() => [
            (M(!0), g(we, null, pe(e.headerView.slots, (d, N) => (M(), g("div", {
              key: N,
              "v-slot": [N],
              "v-html": d
            }, null, 8, XN))), 128))
          ]),
          _: 1
        }, 16))
      ])) : $("", !0)
    ], 4),
    p("div", {
      class: "cc-messagelist",
      style: ce(e.getMessageListDivStyle())
    }, [
      Nt(s, {
        title: "",
        titleAlignment: e.TitleAlignment.center,
        hideSearch: !0,
        sectionHeaderKey: "",
        searchIconURL: e.SearchIcon,
        searchPlaceholderText: "Search for Messages",
        searchText: "",
        onSearch: void 0,
        list: e.messagesList,
        listItemKey: "getId",
        onScrolledToBottom: e.bottomCallback,
        onScrolledToTop: e.topCallback,
        showSectionHeader: !1,
        state: e.componentState,
        loadingIconURL: e.loadingIconURL,
        hideError: e.hideError,
        errorStateText: e.errorStateText,
        emptyStateText: e.emptyStateText,
        theme: e.theme,
        scrollToBottom: e.setScrollListToBottom,
        emptyView: e.getEmptyHtml(),
        loadingView: e.getLoaderHtml(),
        errorView: e.getErrorHtml(),
        listStyle: e.getListStyle(),
        onCcListScrollUp: t[1] || (t[1] = () => {
          e.onBottom = !1;
        })
      }, {
        listItem: be(({ item: d, index: N }) => [
          p("div", qN, [
            p("span", {
              class: "cc-messagelist__date",
              innerHTML: e.getMessageBubbleDate(d, N)
            }, null, 8, _N)
          ]),
          e.getBubbleWrapper(d) ? (M(), g("div", eT, [
            e.getBubbleWrapper(d).html ? (M(), g("div", {
              key: 0,
              innerHTML: e.getBubbleWrapper(d).html
            }, null, 8, tT)) : (M(), je(fe(e.getBubbleWrapper(d).componentName), me({ key: 1 }, { ...e.getBubbleWrapper(d).props }, xe(e.getBubbleWrapper(d) ? e.getBubbleWrapper(d) : {})), {
              default: be(() => [
                (M(!0), g(we, null, pe(e.getBubbleWrapper(d).slots, (T, m) => (M(), g("div", {
                  key: m,
                  "v-slot": [m],
                  "v-html": T
                }, null, 8, nT))), 128))
              ]),
              _: 2
            }, 1040))
          ])) : (M(), je(u, {
            key: 1,
            id: (d == null ? void 0 : d.getId()) || (d == null ? void 0 : d.getMuid()),
            messageBubbleStyle: e.MessageBubbleStyle(d, e.alignment, e.getLoggedinUser()),
            options: e.setMessageOptions(d),
            alignment: e.getBubbleAlignment(d),
            replyView: void 0,
            leadingView: e.getBubbleLeadingView(d),
            contentView: e.getContentView(d),
            bottomView: e.getBottomView(d),
            footerView: e.getBubbleFooterView(d),
            headerView: e.getBubbleHeaderView(d),
            threadView: e.getBubbleThreadView(d),
            statusInfoView: e.getStatusInfoView(d)
          }, null, 8, ["id", "messageBubbleStyle", "options", "alignment", "leadingView", "contentView", "bottomView", "footerView", "headerView", "threadView", "statusInfoView"]))
        ]),
        _: 1
      }, 8, ["titleAlignment", "searchIconURL", "list", "onScrolledToBottom", "onScrolledToTop", "state", "loadingIconURL", "hideError", "errorStateText", "emptyStateText", "theme", "scrollToBottom", "emptyView", "loadingView", "errorView", "listStyle"])
    ], 4),
    p("div", {
      class: "cc__messagelist__footerview",
      style: ce(e.MessageListFooterStyle())
    }, [
      e.showSmartReplyRef && e.getSmartReplyView() ? (M(), g("div", oT, [
        e.getSmartReplyView().html ? (M(), g("div", {
          key: 0,
          innerHTML: e.getSmartReplyView().html
        }, null, 8, iT)) : (M(), je(fe(e.getSmartReplyView().componentName), me({ key: 1 }, { ...e.getSmartReplyView().props }, xe(e.getSmartReplyView().listeners ? e.getSmartReplyView().listeners : {})), {
          default: be(() => [
            (M(!0), g(we, null, pe(e.getSmartReplyView().slots, (d, N) => (M(), g("div", {
              key: N,
              "v-slot": [N],
              "v-html": d
            }, null, 8, aT))), 128))
          ]),
          _: 1
        }, 16))
      ])) : $("", !0),
      e.footerView ? (M(), g("div", rT, [
        e.footerView.html ? (M(), g("div", {
          key: 0,
          innerHTML: e.footerView.html
        }, null, 8, lT)) : (M(), je(fe(e.footerView.componentName), me({ key: 1 }, { ...e.footerView.props }, xe(e.footerView ? e.footerView : {})), {
          default: be(() => [
            (M(!0), g(we, null, pe(e.footerView.slots, (d, N) => (M(), g("div", {
              key: N,
              "v-slot": [N],
              "v-html": d
            }, null, 8, sT))), 128))
          ]),
          _: 1
        }, 16))
      ])) : $("", !0),
      e.showOngoingCallRef && e.getOngoingCallView() ? (M(), g("div", MT, [
        e.getOngoingCallView().html ? (M(), g("div", {
          key: 0,
          innerHTML: e.getOngoingCallView().html
        }, null, 8, uT)) : (M(), je(fe(e.getOngoingCallView().componentName), me({ key: 1 }, { ...e.getOngoingCallView().props }, xe(e.getOngoingCallView().listeners ? e.getOngoingCallView().listeners : {})), {
          default: be(() => [
            (M(!0), g(we, null, pe(e.getOngoingCallView().slots, (d, N) => (M(), g("div", {
              key: N,
              "v-slot": [N],
              "v-html": d
            }, null, 8, gT))), 128))
          ]),
          _: 1
        }, 16))
      ])) : $("", !0)
    ], 4)
  ], 64);
}
const or = /* @__PURE__ */ $e(GN, [["render", cT], ["__scopeId", "data-v-f427ef78"]]), dT = We({
  name: "CometChatCreatePollView",
  components: {},
  props: {
    user: { type: y.User },
    group: { type: y.Group },
    createPollStyle: { type: Object },
    deleteIconURL: { type: String },
    closeIconURL: { type: String },
    addAnswerIconURL: { type: String },
    listeners: {
      type: null
    }
  },
  setup(e, t) {
    return {};
  }
}), IT = ["user", "group", "createPollStyle", "deleteIconURL", "closeIconURL", "addAnswerIconURL"];
function NT(e, t, n, o, i, l) {
  return M(), g("cometchat-backdrop", null, [
    p("create-poll", me({
      user: e.user,
      group: e.group,
      createPollStyle: e.createPollStyle,
      deleteIconURL: e.deleteIconURL,
      closeIconURL: e.closeIconURL,
      addAnswerIconURL: e.addAnswerIconURL
    }, xe(e.listeners ? e.listeners : {}, !0)), null, 16, IT)
  ]);
}
const TT = /* @__PURE__ */ $e(dT, [["render", NT]]), DT = We({
  components: {
    CometChatList: hn
  },
  props: {
    title: {
      type: String,
      default: () => Y("MEMBERS")
    },
    titleAlignment: {
      type: Number,
      default: () => kn.center
    },
    searchPlaceholder: {
      type: String,
      default: () => Y("SEARCH")
    },
    subtitleView: {
      type: Function
    },
    tailView: {
      type: Function
    },
    listItemView: {
      type: Function
    },
    menus: {
      type: Object
    },
    options: {
      type: Function
    },
    groupMembersRequestBuilder: {
      type: Object
    },
    searchRequestBuilder: {
      type: Object
    },
    disableUsersPresence: {
      type: Boolean
    },
    group: {
      type: Object,
      required: !0
    },
    hideSeparator: {
      type: Boolean,
      default: !1
    },
    showBackButton: {
      type: Boolean,
      default: !0
    },
    selectionMode: {
      type: Number,
      default: () => xt.none
    },
    onSelect: {
      type: Function
    },
    searchIconURL: {
      type: String,
      default: Yn
    },
    backButtonIconURL: {
      type: String,
      default: fn
    },
    closeButtonIconURL: {
      type: String,
      default: Cn
    },
    dropdownIconURL: {
      type: String,
      default: Yl
    },
    hideSearch: {
      type: Boolean,
      default: !1
    },
    hideError: {
      type: Boolean,
      default: !1
    },
    emptyStateView: {
      type: Object
    },
    errorStateText: {
      type: String,
      default: () => Y("SOMETHING_WRONG")
    },
    emptyStateText: {
      type: String,
      default: () => Y("NO_USERS_FOUND")
    },
    onItemClick: {
      type: Function
    },
    onError: {
      type: Function
    },
    onBack: {
      type: Function
    },
    onClose: {
      type: Function
    },
    avatarStyle: {
      type: Object,
      default: () => ({})
    },
    groupMembersStyle: {
      type: Object,
      default: () => ({})
    },
    statusIndicatorStyle: {
      type: Object,
      default: () => ({})
    },
    listItemStyle: {
      type: Object,
      default: () => ({})
    },
    groupScopeStyle: {
      type: Object,
      default: () => ({})
    },
    loadingIconURL: {
      type: String,
      default: nn
    },
    loadingStateView: {
      type: Object
    },
    errorStateView: {
      type: Object
    },
    userPresencePlacement: {
      type: Number,
      default: zi.bottom
    },
    searchKeyword: {
      type: String,
      default: void 0
    },
    onEmpty: {
      type: Function
    },
    disableLoadingState: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    });
    const n = j([]), o = j("memberlist_" + (/* @__PURE__ */ new Date()).getTime()), i = j(
      "connection_" + (/* @__PURE__ */ new Date()).getTime()
    ), l = j(null), r = j(ge.loading), u = j(!0);
    let s = null, c = j(null), d = j([]);
    const N = j(30);
    j(null);
    const T = j(""), m = j(!0);
    let A = j(e.avatarStyle), D = j(e.groupMembersStyle), z = j(e.groupScopeStyle), k = j(e.listItemStyle), R = j(e.statusIndicatorStyle), Q = j(e.group), h = j({}), O, x;
    function _() {
      m.value = !m.value;
    }
    const oe = j({
      height: "212px",
      width: "360px",
      background: "white",
      borderRadius: "12px",
      border: "none"
    });
    let ie = j({
      width: "",
      height: "",
      border: "none",
      borderRadius: "8px",
      background: "white",
      submenuWidth: "100%",
      submenuHeight: "100%",
      submenuBorder: "1px solid #e8e8e8",
      submenuBorderRadius: "8px",
      submenuBackground: "white",
      moreIconTint: "rgb(51, 153, 255)"
    });
    function re() {
      e.onClose && e.onClose();
    }
    function Ae() {
      e.onBack && e.onBack();
    }
    const se = (de) => typeof de == "object" && (de == null ? void 0 : de.length) > 0, X = (de) => typeof de == "string", B = (de) => Qo.getViewMemberOptions(
      de,
      e.group,
      s == null ? void 0 : s.getUid(),
      t.value
    ), F = (de, Le) => {
      var tt, st, ct, wt, Lt, jt;
      if ((st = (tt = de == null ? void 0 : de.detail) == null ? void 0 : tt.data) != null && st.onClick) {
        (wt = (ct = de == null ? void 0 : de.detail) == null ? void 0 : ct.data) == null || wt.onClick(Le);
        return;
      }
      let Fe = (jt = (Lt = de == null ? void 0 : de.detail) == null ? void 0 : Lt.data) == null ? void 0 : jt.id;
      c.value = Le, d.value = Qo.allowScopeChange(
        e.group,
        Le
      ), Fe == I.GroupMemberOptions.changeScope ? u.value = !0 : Fe == I.GroupMemberOptions.ban ? (u.value = !1, J(Le)) : Fe == I.GroupMemberOptions.kick && (u.value = !1, G(Le));
    }, G = (de) => {
      y.kickGroupMember(Q.value.getGuid(), de.getUid()).then(() => {
        let Le = Ce.clone(
          Q.value
        );
        Le = Le, Le instanceof y.Group && Le.setMembersCount(
          Q.value.getMembersCount() - 1
        ), Q.value = Le, K(de), He.ccGroupMemberKicked.next({
          kickedBy: s,
          kickedFrom: Le,
          kickedUser: de,
          message: U(
            de,
            I.groupMemberAction.KICKED
          )
        });
      }).catch((Le) => {
        e.onError && e.onError(Le);
      });
    }, J = (de) => {
      y.banGroupMember(Q.value.getGuid(), de.getUid()).then(() => {
        let Le = Ce.clone(e.group);
        Le = Le, Le instanceof y.Group && Le.setMembersCount(
          Q.value.getMembersCount() - 1
        ), Q.value = Le, K(de), He.ccGroupMemberBanned.next({
          kickedBy: s,
          kickedFrom: Le,
          kickedUser: de,
          message: U(
            de,
            I.groupMemberAction.BANNED
          )
        });
      }).catch((Le) => {
        e.onError && e.onError(Le);
      });
    }, ee = (de) => {
      let Le = [...n.value], Fe = Le.findIndex(
        (tt, st) => tt.getUid() == de.getUid()
      );
      if (Fe > -1) {
        let tt = Le[Fe];
        tt.setStatus(de.getStatus()), Le.splice(Fe, 1, tt), n.value = [...Le];
      }
    };
    function V() {
      y.addUserListener(
        o.value,
        new y.UserListener({
          onUserOnline: (de) => {
            ee(de);
          },
          onUserOffline: (de) => {
            ee(de);
          }
        })
      ), y.addGroupListener(
        o.value,
        new y.GroupListener({
          onGroupMemberScopeChanged: (de, Le, Fe, tt, st) => {
            Le.getUid() == (s == null ? void 0 : s.getUid()) && st.setScope(Fe), v(Le);
          },
          onGroupMemberKicked: (de, Le, Fe, tt) => {
            K(Le);
          },
          onGroupMemberBanned: (de, Le, Fe, tt) => {
            K(Le);
          },
          onGroupMemberUnbanned: (de, Le, Fe, tt) => {
            Le.getUid() == (s == null ? void 0 : s.getUid()) && tt.setHasJoined(!1), K(Le);
          },
          onMemberAddedToGroup: (de, Le, Fe, tt) => {
            let st = new y.GroupMember(
              Le.getUid(),
              y.GROUP_MEMBER_SCOPE.PARTICIPANT
            );
            st.setName(Le.getName()), st.setGuid(Q.value.getGuid()), st.setUid(Le.getUid()), Le.getUid() == (s == null ? void 0 : s.getUid()) && tt.setHasJoined(!0), K(st);
          },
          onGroupMemberLeft: (de, Le, Fe) => {
            Le.getUid() == (s == null ? void 0 : s.getUid()) && Fe.setHasJoined(!1), K(Le);
          },
          onGroupMemberJoined: (de, Le, Fe) => {
            K(Le);
          }
        })
      ), y.addConnectionListener(
        i.value,
        new y.ConnectionListener({
          onConnected: () => {
            e.disableLoadingState || (r.value = ge.loading), _(), n.value = [], l.value = Ie.value, L().then();
          }
        })
      );
    }
    function ne() {
      y.removeUserListener(o.value), o.value = "", y.removeConnectionListener(i.value), i.value = "";
    }
    const K = (de) => {
      let Le = [...n.value], Fe = Le.findIndex(
        (tt, st) => tt.getUid() == de.getUid()
      );
      Fe > -1 ? (Le.splice(Fe, 1), n.value = [...Le]) : n.value.push(de);
    }, Ie = Ht(() => {
      if (m.value, e.searchKeyword || (x = void 0), !T.value || T.value && T.value.length == 0)
        return e.groupMembersRequestBuilder ? e.groupMembersRequestBuilder.setSearchKeyword("").build() : new y.GroupMembersRequestBuilder(
          Q.value.getGuid()
        ).setLimit(N.value).build();
      if (T.value && T.value.length > 0)
        return e.searchRequestBuilder ? e.searchRequestBuilder.setSearchKeyword(T.value).build() : e.groupMembersRequestBuilder ? e.groupMembersRequestBuilder.setSearchKeyword(T.value).build() : new y.GroupMembersRequestBuilder(
          Q.value.getGuid()
        ).setSearchKeyword(T.value).setLimit(N.value).build();
    }), Te = (de) => {
      clearTimeout(O), O = setTimeout(() => {
        T.value = de, e.disableLoadingState || (n.value = []), l.value = Ie.value, L();
      }, 500);
    };
    bn(
      () => e.searchKeyword,
      (de, Le) => {
        de !== Le && Te(de);
      },
      { immediate: !0 }
    );
    function H() {
      let de = null;
      const Le = "abort";
      return function(Fe) {
        return new Promise(
          (tt, st) => {
            de == null || de.abort(), de = new AbortController();
            const ct = de;
            let wt = !1;
            const Lt = function jt(Wt) {
              ct.signal.removeEventListener(Le, jt), wt = !0, st(Wt);
            };
            ct.signal.addEventListener(
              Le,
              Lt
            ), Fe.fetchNext().finally(() => {
              wt || ct.signal.removeEventListener(
                Le,
                Lt
              );
            }).then((jt) => {
              tt(jt);
            }).catch(st);
          }
        );
      };
    }
    const Ee = H(), L = async () => {
      var de;
      if (l.value && l.value.pagination && (l.value.pagination.current_page == 0 || l.value.pagination.current_page != l.value.pagination.total_pages)) {
        e.disableLoadingState || (r.value = ge.loading);
        try {
          const Le = await Ee(
            l.value
          );
          Le.length <= 0 && e.onEmpty && (e.onEmpty(), x = void 0), Le.length <= 0 && ((de = n.value) == null ? void 0 : de.length) <= 0 ? r.value = ge.empty : (e.disableLoadingState ? e.searchKeyword != x || [0, 1].includes(l.value.pagination.current_page) ? n.value = Le : n.value = [
            ...n.value,
            ...Le
          ] : n.value = [
            ...n.value,
            ...Le
          ], r.value = ge.loaded), x = e.searchKeyword;
        } catch (Le) {
          Le instanceof Error ? e.onError && (e.onError(Le), r.value = ge.error) : Le instanceof Event && Le.type === "abort" && console.log("Fetch request was aborted by an abort event");
        }
      } else
        r.value = ge.loaded;
    };
    Zt(() => {
      Q.value = e.group;
    }), tn(() => {
      Re(), y.getLoggedinUser().then((de) => {
        s = de, l.value = Ie.value, L().then(() => {
          V();
        });
      }).catch((de) => {
        e.onError && e.onError(de);
      });
    }), un(() => {
      ne();
    });
    function b(de) {
      var Le;
      y.updateGroupMemberScope(
        Q.value.getGuid(),
        c.value.getUid(),
        (Le = de == null ? void 0 : de.detail) == null ? void 0 : Le.value
      ).then((Fe) => {
        var st, ct, wt;
        let tt = (st = de == null ? void 0 : de.detail) == null ? void 0 : st.value;
        u.value = !1, (ct = c.value) == null || ct.setScope(tt), v(c.value), He.ccGroupMemberScopeChanged.next({
          scopeChangedFrom: (wt = c.value) == null ? void 0 : wt.getScope(),
          scopeChangedTo: tt,
          message: U(
            c.value,
            I.groupMemberAction.SCOPE_CHANGE
          ),
          group: e.group,
          updatedUser: c.value
        }), c.value = null, u.value = !1;
      }).catch((Fe) => {
        e.onError && e.onError(Fe), u.value = !1, c.value = null;
      });
    }
    const v = (de) => {
      let Le = [...n.value], Fe = Le.findIndex(
        (tt, st) => tt.getUid() == de.getUid()
      );
      if (Fe > -1) {
        let tt = Le[Fe];
        Le.splice(Fe, 1, tt), n.value = [...Le];
      }
    };
    function U(de, Le) {
      let Fe = new y.Action(
        Q.value.getGuid(),
        I.MessageTypes.groupMember,
        I.MessageReceiverType.group,
        I.MessageCategory.action
      );
      return Fe.setAction(Le), Fe.setActionBy(s), Fe.setActionFor(e.group), Fe.setActionOn(de), Fe.setReceiver(e.group), Fe.setSender(s), Fe.setConversationId("group_" + Q.value.getGuid()), Fe.setMuid(Ce.ID()), Fe.setMessage(
        `${s == null ? void 0 : s.getName()} ${Le} ${de.getUid()}`
      ), Fe.setSentAt(Ce.getUnixTimestamp()), Fe.setReceiverType(
        I.MessageReceiverType.group
      ), Fe.data = {
        extras: {
          scope: {
            new: de.getScope()
          }
        }
      }, Fe;
    }
    function Se(de, Le) {
      var tt;
      const Fe = (tt = de.detail) == null ? void 0 : tt.checked;
      e.onSelect && e.onSelect(Le, Fe);
    }
    const Ue = (de) => new co().getUserStatusVisibility(de) || e.disableUsersPresence ? null : e.groupMembersStyle.onlineStatusColor ?? t.value.palette.getSuccess();
    function Re() {
      _e(), ye(), Z(), ke(), q(), ie.value = new Si({
        border: "none",
        borderRadius: "8px",
        background: "transparent",
        submenuWidth: "100%",
        submenuHeight: "100%",
        submenuBorder: `1px solid ${t.value.palette.getAccent200()}`,
        submenuBorderRadius: "8px",
        submenuBackground: t.value.palette.getBackground(),
        moreIconTint: t.value.palette.getPrimary()
      }), oe.value.boxShadow = `0px 0px 1px ${t.value.palette.getAccent600()}`, oe.value.background = t.value.palette.getBackground();
    }
    function _e() {
      let de = new Aa({
        background: t.value.palette.getBackground(),
        border: `1px solid ${t.value.palette.getAccent50()}`,
        titleTextFont: w(t.value.typography.title1),
        titleTextColor: t.value.palette.getAccent(),
        emptyStateTextFont: w(t.value.typography.title1),
        emptyStateTextColor: t.value.palette.getAccent600(),
        errorStateTextFont: w(t.value.typography.title1),
        errorStateTextColor: t.value.palette.getAccent600(),
        loadingIconTint: t.value.palette.getAccent600(),
        onlineStatusColor: t.value.palette.getSuccess(),
        separatorColor: t.value.palette.getAccent400(),
        width: "100%",
        height: "100%",
        borderRadius: "none",
        searchIconTint: t.value.palette.getAccent600(),
        searchPlaceholderTextColor: t.value.palette.getAccent600(),
        searchBackground: t.value.palette.getAccent100(),
        searchPlaceholderTextFont: w(t.value.typography.text3),
        searchTextColor: t.value.palette.getAccent600(),
        searchTextFont: w(t.value.typography.text3),
        searchBorderRadius: "8px",
        closeButtonIconTint: t.value.palette.getPrimary(),
        backButtonIconTint: t.value.palette.getPrimary(),
        padding: "0px"
      });
      D.value = {
        ...de,
        ...D.value
      }, h.value = {
        height: "100%",
        titleTextFont: D.value.titleTextFont || w(t.value.typography.title1),
        titleTextColor: D.value.titleTextColor || t.value.palette.getAccent(),
        emptyStateTextFont: D.value.emptyStateTextFont,
        emptyStateTextColor: D.value.emptyStateTextColor,
        errorStateTextFont: D.value.errorStateTextFont,
        errorStateTextColor: D.value.errorStateTextColor,
        loadingIconTint: D.value.loadingIconTint,
        separatorColor: D.value.separatorColor,
        searchIconTint: D.value.searchIconTint,
        searchBorder: D.value.searchBorder,
        searchBorderRadius: D.value.searchBorderRadius,
        searchBackground: D.value.searchBackground,
        searchPlaceholderTextFont: D.value.searchPlaceholderTextFont,
        searchPlaceholderTextColor: D.value.searchPlaceholderTextColor,
        searchTextFont: D.value.searchTextFont,
        searchTextColor: D.value.searchTextColor,
        background: D.value.background
      };
    }
    function Z() {
      let de = new _t({
        height: "45px",
        width: "100%",
        background: t.value.palette.getBackground(),
        activeBackground: "",
        borderRadius: "0",
        titleFont: w(t.value.typography.title2),
        titleColor: t.value.palette.getAccent(),
        border: "none",
        separatorColor: t.value.palette.getAccent100(),
        hoverBackground: ""
      });
      k.value = { ...de, ...k.value };
    }
    function ke() {
      let de = new Kt({
        borderRadius: "24px",
        width: "28px",
        height: "28px",
        border: "none",
        backgroundColor: t.value.palette.getAccent700(),
        nameTextColor: t.value.palette.getAccent900(),
        backgroundSize: "cover",
        nameTextFont: w(t.value.typography.subtitle1),
        outerViewBorderWidth: "",
        outerViewBorderSpacing: ""
      });
      A.value = { ...de, ...A.value };
    }
    function q() {
      let de = {
        height: "12px",
        width: "12px",
        border: "none",
        borderRadius: "24px"
      };
      R.value = {
        ...de,
        ...R.value
      };
    }
    function ye() {
      let de = new bl({
        titleTextFont: w(t.value.typography.title1),
        titleTextColor: t.value.palette.getAccent(),
        activeTextFont: w(t.value.typography.subtitle1),
        activeTextColor: t.value.palette.getAccent(),
        activeTextBackground: t.value.palette.getAccent200(),
        arrowIconTint: t.value.palette.getAccent900(),
        textFont: w(t.value.typography.subtitle1),
        textColor: t.value.palette.getAccent600(),
        optionBackground: t.value.palette.getBackground(),
        optionBorder: "none",
        optionBorderRadius: "0",
        hoverTextFont: w(t.value.typography.subtitle1),
        hoverTextColor: t.value.palette.getAccent900(),
        hoverTextBackground: t.value.palette.getAccent100(),
        buttonTextFont: w(t.value.typography.title2),
        buttonTextColor: t.value.palette.getAccent("dark"),
        buttonBackground: t.value.palette.getPrimary(),
        closeIconTint: t.value.palette.getPrimary(),
        background: t.value.palette.getBackground(),
        border: `1px solid ${t.value.palette.getAccent200()}`,
        borderRadius: "8px",
        height: "200px",
        width: "280px"
      });
      z.value = { ...de, ...z.value };
    }
    return {
      GroupMembers: n,
      wrapperStyle: () => ({
        height: D.value.height || "100%",
        width: D.value.width || "100%",
        background: D.value.background || t.value.palette.getBackground(),
        border: D.value.border,
        borderRadius: D.value.borderRadius || "0",
        position: "relative",
        display: "flex"
      }),
      membersStyle: () => ({
        padding: D.value.padding
      }),
      ConversationUtils: zo,
      GroupMemberUtils: Qo,
      handleMenuAction: F,
      closeButtonStyle: () => ({
        height: "24px",
        width: "24px",
        border: "none",
        borderRadius: "0",
        background: "transparent",
        buttonIconTint: e.groupMembersStyle.closeButtonIconTint || t.value.palette.getPrimary()
      }),
      closeClicked: re,
      backClicked: Ae,
      changeScope: u,
      memberScope: d,
      changeMemberScope: b,
      SelectionMode: xt,
      getOptions: B,
      backButtonStyle: () => ({
        height: "24px",
        width: "24px",
        border: "none",
        borderRadius: "0",
        background: "transparent",
        buttonIconTint: e.groupMembersStyle.backButtonIconTint || t.value.palette.getPrimary()
      }),
      MoreIcon: Ga,
      mylistItemStyle: k,
      myavatarStyle: A,
      menuListStyle: ie,
      mystatusIndicatorStyle: R,
      getStatusIndicatorColor: Ue,
      getScopeStyle: () => ({
        textFont: z.value.textFont,
        textColor: z.value.textColor
      }),
      isArray: se,
      isString: X,
      onSearch: Te,
      state: r,
      mygroupMemberStyle: D,
      listStyle: h,
      searchKeywordRef: T,
      fetchNextGroupMembers: L,
      mygroupScopeStyle: z,
      handleSelection: Se,
      onClick: (de) => {
        e.onItemClick && e.onItemClick(de);
      }
    };
  }
});
const yT = { class: "cc-group-members__back" }, CT = ["iconURL", "buttonStyle"], wT = {
  key: 0,
  class: "cc-group-members__menus"
}, jT = ["innerHTML"], AT = ["v-slot", "v-html"], LT = { key: 0 }, zT = ["innerHTML"], ST = ["v-slot", "v-html"], pT = ["title", "avatarURL", "avatarName", "hideSeparator", "listItemStyle", "avatarStyle", "statusIndicatorStyle", "statusIndicatorColor", "onCcListitemClicked", "userPresencePlacement"], bT = {
  key: 0,
  slot: "subtitleView",
  class: "cc-group-members__subtitle-view"
}, ET = ["innerHTML"], hT = ["v-slot", "v-html"], vT = {
  key: 1,
  slot: "menuView",
  class: "cc-group-members__options"
}, mT = ["menuListStyle", "data", "onCcMenuClicked"], OT = {
  slot: "tailView",
  class: "cc-group-members__tail-view"
}, xT = { key: 0 }, kT = ["innerHTML"], fT = ["v-slot", "v-html"], UT = ["innerHTML"], BT = ["v-slot", "v-html"], QT = { key: 1 }, RT = {
  key: 0,
  class: "cc-group-members__selection-single"
}, YT = ["onCcRadioButtonChanged"], VT = {
  key: 1,
  class: "cc-group-members__selection-multiple"
}, GT = ["onCcCheckboxChanged"], PT = { key: 2 }, FT = { class: "cc-group-members__scope-change" }, HT = ["moreIconURL", "menuListStyle", "data", "onCcMenuClicked"], ZT = ["text", "labelStyle"], WT = { class: "cc-group-members__close" }, $T = ["iconURL", "buttonStyle"], JT = { key: 0 }, KT = ["changeScopeStyle", "options", "arrowIconURL"];
function XT(e, t, n, o, i, l) {
  var u, s;
  const r = Je("CometChatList");
  return M(), g("div", {
    class: "cc-group-members",
    style: ce(e.wrapperStyle())
  }, [
    p("div", yT, [
      e.showBackButton ? (M(), g("cometchat-button", {
        key: 0,
        iconURL: e.backButtonIconURL,
        buttonStyle: e.backButtonStyle(),
        onCcButtonClicked: t[0] || (t[0] = (c) => e.backClicked())
      }, null, 40, CT)) : $("", !0)
    ]),
    p("div", {
      class: "cc-group-members__wrapper",
      style: ce(e.membersStyle())
    }, [
      e.menus ? (M(), g("div", wT, [
        e.menus.html ? (M(), g("div", {
          key: 0,
          innerHTML: e.menus.html
        }, null, 8, jT)) : e.menus && e.menus.componentName ? (M(), je(fe(e.menus.componentName), me({ key: 1 }, { ...e.menus.props }, xe((u = e.menus) != null && u.listeners ? (s = e.menus) == null ? void 0 : s.listeners : {})), {
          default: be(() => [
            (M(!0), g(we, null, pe(e.menus.slots, (c, d) => (M(), g("div", {
              key: d,
              "v-slot": [d],
              "v-html": c
            }, null, 8, AT))), 128))
          ]),
          _: 1
        }, 16)) : $("", !0)
      ])) : $("", !0),
      Nt(r, {
        title: e.title,
        titleAlignment: e.titleAlignment,
        hideSearch: e.hideSearch,
        searchIconURL: e.searchIconURL,
        searchPlaceholderText: e.searchPlaceholder,
        list: e.GroupMembers,
        searchText: e.searchKeywordRef,
        state: e.state,
        loadingIconURL: e.loadingIconURL,
        hideError: e.hideError,
        errorStateText: e.errorStateText,
        emptyStateText: e.emptyStateText,
        scrollToBottom: !1,
        onSearch: e.onSearch,
        onScrolledToBottom: e.fetchNextGroupMembers,
        listItemKey: "getUid",
        listStyle: e.listStyle,
        onError: e.onError,
        errorStateView: e.errorStateView,
        emptyStateView: e.emptyStateView,
        loadingStateView: e.loadingStateView,
        sectionHeaderKey: ""
      }, {
        listItem: be(({ item: c }) => {
          var d, N, T, m, A, D, z, k, R, Q, h, O, x, _, oe, ie, re, Ae, se, X, B, F;
          return [
            e.listItemView ? (M(), g("div", LT, [
              (d = e.listItemView(c)) != null && d.html ? (M(), g("div", {
                key: 0,
                innerHTML: (N = e.listItemView(c)) == null ? void 0 : N.html
              }, null, 8, zT)) : (T = e.listItemView(c)) != null && T.componentName ? (M(), je(fe((m = e.listItemView(c)) == null ? void 0 : m.componentName), me({ key: 1 }, { ...(A = e.listItemView(c)) == null ? void 0 : A.props }, xe(
                e.listItemView && ((D = e.listItemView(c)) != null && D.listeners) ? (z = e.listItemView(c)) == null ? void 0 : z.listeners : {}
              )), {
                default: be(() => {
                  var G;
                  return [
                    (M(!0), g(we, null, pe((G = e.listItemView(c)) == null ? void 0 : G.slots, (J, ee) => (M(), g("div", {
                      key: ee,
                      "v-slot": [ee],
                      "v-html": J
                    }, null, 8, ST))), 128))
                  ];
                }),
                _: 2
              }, 1040)) : $("", !0)
            ])) : (M(), g("cometchat-list-item", {
              key: 1,
              title: c.name,
              avatarURL: c == null ? void 0 : c.avatar,
              avatarName: c == null ? void 0 : c.name,
              hideSeparator: e.hideSeparator,
              listItemStyle: e.mylistItemStyle,
              avatarStyle: e.myavatarStyle,
              statusIndicatorStyle: e.mystatusIndicatorStyle,
              statusIndicatorColor: e.getStatusIndicatorColor(c),
              onCcListitemClicked: (G) => e.onClick(c),
              userPresencePlacement: e.userPresencePlacement
            }, [
              e.subtitleView ? (M(), g("div", bT, [
                (k = e.subtitleView(c)) != null && k.html ? (M(), g("div", {
                  key: 0,
                  innerHTML: (R = e.subtitleView(c)) == null ? void 0 : R.html
                }, null, 8, ET)) : (Q = e.subtitleView(c)) != null && Q.componentName ? (M(), je(fe((h = e.subtitleView(c)) == null ? void 0 : h.componentName), me({ key: 1 }, { ...(O = e.subtitleView(c)) == null ? void 0 : O.props }, xe(
                  e.subtitleView && ((x = e.subtitleView(c)) != null && x.listeners) ? (_ = e.subtitleView(c)) == null ? void 0 : _.listeners : {}
                )), {
                  default: be(() => {
                    var G;
                    return [
                      (M(!0), g(we, null, pe((G = e.subtitleView(c)) == null ? void 0 : G.slots, (J, ee) => (M(), g("div", {
                        key: ee,
                        "v-slot": [ee],
                        "v-html": J
                      }, null, 8, hT))), 128))
                    ];
                  }),
                  _: 2
                }, 1040)) : $("", !0)
              ])) : $("", !0),
              !e.tailView && e.options ? (M(), g("div", vT, [
                p("cometchat-menu-list", {
                  menuListStyle: e.menuListStyle,
                  data: (oe = e.options) == null ? void 0 : oe.call(e, e.group, c),
                  onCcMenuClicked: (G) => e.handleMenuAction(G, c)
                }, null, 40, mT)
              ])) : $("", !0),
              p("div", OT, [
                e.tailView && e.tailView(c) ? (M(), g("div", xT, [
                  e.isArray(e.tailView(c)) ? (M(!0), g(we, { key: 1 }, pe(e.tailView(c), (G, J) => (M(), g(we, { key: J }, [
                    G != null && G.html ? (M(), g("span", {
                      key: 0,
                      innerHTML: G == null ? void 0 : G.html
                    }, null, 8, UT)) : G != null && G.componentName ? (M(), je(fe(G.componentName), me({
                      key: 1,
                      ref_for: !0
                    }, { ...G.props }, xe(
                      e.tailView && G.listeners ? G.listeners : {}
                    )), {
                      default: be(() => [
                        (M(!0), g(we, null, pe(G.slots, (ee, V) => (M(), g("div", {
                          key: V,
                          "v-slot": [V],
                          "v-html": ee
                        }, null, 8, BT))), 128))
                      ]),
                      _: 2
                    }, 1040)) : $("", !0)
                  ], 64))), 128)) : (M(), g(we, { key: 0 }, [
                    (ie = e.tailView(c)) != null && ie.html ? (M(), g("div", {
                      key: 0,
                      innerHTML: (re = e.tailView(c)) == null ? void 0 : re.html
                    }, null, 8, kT)) : (Ae = e.tailView(c)) != null && Ae.componentName ? (M(), je(fe((se = e.tailView(c)) == null ? void 0 : se.componentName), me({ key: 1 }, { ...(X = e.tailView(c)) == null ? void 0 : X.props }, xe(
                      e.tailView && ((B = e.tailView(c)) != null && B.listeners) ? (F = e.tailView(c)) == null ? void 0 : F.listeners : {}
                    )), {
                      default: be(() => {
                        var G;
                        return [
                          (M(!0), g(we, null, pe((G = e.tailView(c)) == null ? void 0 : G.slots, (J, ee) => (M(), g("div", {
                            key: ee,
                            "v-slot": [ee],
                            "v-html": J
                          }, null, 8, fT))), 128))
                        ];
                      }),
                      _: 2
                    }, 1040)) : $("", !0)
                  ], 64))
                ])) : $("", !0),
                e.selectionMode !== e.SelectionMode.none ? (M(), g("div", QT, [
                  e.selectionMode == e.SelectionMode.single ? (M(), g("div", RT, [
                    p("cometchat-radio-button", {
                      onCcRadioButtonChanged: (G) => {
                        e.handleSelection(G, c);
                      }
                    }, null, 40, YT)
                  ])) : $("", !0),
                  e.selectionMode == e.SelectionMode.multiple ? (M(), g("div", VT, [
                    p("cometchat-checkbox", {
                      onCcCheckboxChanged: (G) => {
                        e.handleSelection(G, c);
                      }
                    }, null, 40, GT)
                  ])) : $("", !0)
                ])) : $("", !0),
                e.tailView ? $("", !0) : (M(), g("div", PT, [
                  p("div", FT, [
                    e.isArray(e.getOptions(c)) ? (M(), g("cometchat-menu-list", {
                      key: 0,
                      moreIconURL: e.MoreIcon,
                      menuListStyle: e.menuListStyle,
                      data: e.getOptions(c),
                      topMenuSize: 0,
                      onCcMenuClicked: (G) => e.handleMenuAction(G, c)
                    }, null, 40, HT)) : $("", !0),
                    e.isString(e.getOptions(c)) ? (M(), g("cometchat-label", {
                      key: 1,
                      text: e.getOptions(c),
                      labelStyle: e.getScopeStyle()
                    }, null, 8, ZT)) : $("", !0)
                  ])
                ]))
              ])
            ], 40, pT))
          ];
        }),
        _: 1
      }, 8, ["title", "titleAlignment", "hideSearch", "searchIconURL", "searchPlaceholderText", "list", "searchText", "state", "loadingIconURL", "hideError", "errorStateText", "emptyStateText", "onSearch", "onScrolledToBottom", "listStyle", "onError", "errorStateView", "emptyStateView", "loadingStateView"])
    ], 4),
    p("div", WT, [
      p("cometchat-button", {
        iconURL: e.closeButtonIconURL,
        buttonStyle: e.closeButtonStyle(),
        onCcButtonClicked: t[1] || (t[1] = (c) => e.closeClicked())
      }, null, 40, $T)
    ]),
    e.changeScope && e.memberScope.length > 0 ? (M(), g("cometchat-backdrop", JT, [
      p("cometchat-change-scope", {
        changeScopeStyle: e.mygroupScopeStyle,
        options: e.memberScope,
        arrowIconURL: e.dropdownIconURL,
        onCcChangescopeCloseClicked: t[2] || (t[2] = (c) => e.changeScope = !1),
        onCcChangescopeChanged: t[3] || (t[3] = (c) => e.changeMemberScope(c))
      }, null, 40, KT)
    ])) : $("", !0)
  ], 4);
}
const ki = /* @__PURE__ */ $e(DT, [["render", XT], ["__scopeId", "data-v-eb4e1c86"]]), qT = We({
  name: "CometChatUserMemberWrapper",
  components: {
    CometChatUsers: ei,
    CometChatGroupMembers: ki
  },
  props: {
    userMemberListType: {
      type: Number,
      default: Zo.users
    },
    onItemClick: {
      type: Function
    },
    listItemView: {
      type: Function
    },
    avatarStyle: {
      type: Object
    },
    statusIndicatorStyle: {
      type: Object
    },
    searchKeyword: {
      type: String
    },
    group: {
      type: Object
    },
    subtitleView: {
      type: Function
    },
    usersRequestBuilder: {
      type: Object
    },
    disableUsersPresence: {
      type: Boolean,
      default: !1
    },
    hideSeparator: {
      type: Boolean,
      default: !1
    },
    loadingStateView: {
      type: Object
    },
    onEmpty: {
      type: Function
    },
    groupMembersRequestBuilder: {
      type: Object
    },
    loadingIconUrl: {
      type: String,
      default: nn
    },
    userPresencePlacement: {
      type: Number,
      default: zi.right
    },
    disableLoadingState: {
      type: Boolean,
      default: !1
    },
    onError: {
      type: Function
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    });
    return {
      UserMemberListType: Zo,
      listItemStyle: {
        height: "fit-content"
      },
      getUsersStyle: () => ({
        border: "1px solid " + t.value.palette.getAccent300(),
        height: "auto",
        background: t.value.palette.getBackground(),
        minHeight: "45px",
        borderRadius: "12px 12px 12px 12px"
      }),
      getGroupMemebersStyle: () => ({
        border: "1px solid " + t.value.palette.getAccent300(),
        height: "auto",
        padding: "0px",
        background: t.value.palette.getBackground(),
        borderRadius: "12px 12px 12px 12px"
      })
    };
  }
});
function _T(e, t, n, o, i, l) {
  const r = Je("CometChatUsers"), u = Je("CometChatGroupMembers");
  return M(), g(we, null, [
    e.userMemberListType == e.UserMemberListType.users ? (M(), je(r, {
      key: 0,
      class: "cc-user-member-wrapper_component",
      title: "",
      hideSearch: !0,
      showSectionHeader: !1,
      onItemClick: e.onItemClick,
      avatarStyle: e.avatarStyle,
      statusIndicatorStyle: e.statusIndicatorStyle,
      searchKeyword: e.searchKeyword,
      listItemView: e.listItemView,
      usersRequestBuilder: e.usersRequestBuilder,
      subtitleView: e.subtitleView,
      loadingStateView: e.loadingStateView,
      onEmpty: e.onEmpty,
      loadingIconUrl: e.loadingIconUrl,
      userPresencePlacement: e.userPresencePlacement,
      closeButtonIconURL: "",
      disableLoadingState: e.disableLoadingState,
      onError: e.onError,
      hideSeparator: e.hideSeparator,
      listItemStyle: e.listItemStyle,
      usersStyle: e.getUsersStyle(),
      disableUsersPresence: e.disableUsersPresence
    }, null, 8, ["onItemClick", "avatarStyle", "statusIndicatorStyle", "searchKeyword", "listItemView", "usersRequestBuilder", "subtitleView", "loadingStateView", "onEmpty", "loadingIconUrl", "userPresencePlacement", "disableLoadingState", "onError", "hideSeparator", "listItemStyle", "usersStyle", "disableUsersPresence"])) : $("", !0),
    e.userMemberListType == e.UserMemberListType.groupmembers ? (M(), je(u, {
      key: 1,
      class: "cc-user-member-wrapper_component",
      group: e.group,
      title: "",
      hideSearch: !0,
      showBackButton: !1,
      groupMembersRequestBuilder: e.groupMembersRequestBuilder,
      onItemClick: e.onItemClick,
      avatarStyle: e.avatarStyle,
      statusIndicatorStyle: e.statusIndicatorStyle,
      listItemView: e.listItemView,
      subtitleView: e.subtitleView,
      options: null,
      tailView: (s) => null,
      closeButtonIconURL: "",
      searchKeyword: e.searchKeyword,
      onEmpty: e.onEmpty,
      userPresencePlacement: e.userPresencePlacement,
      disableLoadingState: e.disableLoadingState,
      onError: e.onError,
      hideSeparator: e.hideSeparator,
      listItemStyle: e.listItemStyle,
      groupMembersStyle: e.getGroupMemebersStyle(),
      disableUsersPresence: e.disableUsersPresence
    }, null, 8, ["group", "groupMembersRequestBuilder", "onItemClick", "avatarStyle", "statusIndicatorStyle", "listItemView", "subtitleView", "searchKeyword", "onEmpty", "userPresencePlacement", "disableLoadingState", "onError", "hideSeparator", "listItemStyle", "groupMembersStyle", "disableUsersPresence"])) : $("", !0)
  ], 64);
}
const eD = /* @__PURE__ */ $e(qT, [["render", _T], ["__scopeId", "data-v-14014a3f"]]), tD = We({
  name: "CometChatStickersAuxiliaryButton",
  emits: ["component-event"],
  components: {},
  props: {
    openIconURL: { type: String },
    closeIconURL: { type: String },
    placement: { type: String },
    emojiButtonStyle: { type: null },
    popoverStyle: { type: null },
    stickerKeyboardStyle: { type: null },
    stickerKeyboardListeners: { type: null },
    listeners: {
      type: null
    },
    auxiliaryButtonRefs: { type: null },
    componentIndex: { type: Number }
  },
  setup(e, t) {
    let n = j(!0), o = j(null);
    tn(() => {
      t.emit("component-event", {
        name: "register",
        componentIndex: e.componentIndex,
        onClick: i
      });
    });
    const i = () => {
      n.value || o.value.click(), n.value = !0;
    };
    return { toggleIcon: (r) => {
      n.value = !n.value, n.value || t.emit("component-event", {
        name: "open",
        componentIndex: e.componentIndex
      });
    }, showOpenIconRef: n, buttonRef: o, localize: Y };
  }
}), nD = ["placement", "popoverStyle"], oD = { slot: "children" }, iD = ["hoverText", "iconURL", "buttonStyle"], aD = { slot: "content" }, rD = ["stickerStyle"];
function lD(e, t, n, o, i, l) {
  return M(), g("cometchat-popover", {
    placement: e.placement,
    popoverStyle: e.popoverStyle,
    key: "stickers-extension-popover",
    onCcPopoverOutsideClicked: t[1] || (t[1] = (r) => e.showOpenIconRef = !e.showOpenIconRef)
  }, [
    p("div", oD, [
      (M(), g("cometchat-button", {
        key: e.componentIndex,
        ref: "buttonRef",
        hoverText: e.localize("STICKER"),
        iconURL: e.showOpenIconRef ? e.openIconURL : e.closeIconURL,
        buttonStyle: e.emojiButtonStyle,
        onCcButtonClicked: t[0] || (t[0] = (r) => e.toggleIcon(r))
      }, null, 40, iD))
    ]),
    p("div", aD, [
      (M(), g("stickers-keyboard", me({
        key: "keyboard_" + e.componentIndex,
        stickerStyle: e.stickerKeyboardStyle
      }, xe(e.stickerKeyboardListeners ? e.stickerKeyboardListeners : {}, !0)), null, 16, rD))
    ])
  ], 40, nD);
}
const sD = /* @__PURE__ */ $e(tD, [["render", lD]]), MD = (e, t) => ({
  display: "flex",
  overflowY: "auto",
  width: (e == null ? void 0 : e.width) || "100%",
  height: (e == null ? void 0 : e.height) || "100%",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "50px",
  background: (e == null ? void 0 : e.background) || t.palette.getBackground(),
  borderRadius: (e == null ? void 0 : e.borderRadius) || "8px"
}), uD = (e, t) => ({
  replyTextFont: (t == null ? void 0 : t.textFont) || w(e.typography.caption1),
  replyTextColor: (t == null ? void 0 : t.textColor) || (e == null ? void 0 : e.palette.getAccent()),
  replyBackground: (t == null ? void 0 : t.textBackground) || "inherit",
  boxShadow: `0px 0px 1px ${e == null ? void 0 : e.palette.getAccent600()}`,
  background: (t == null ? void 0 : t.background) || "inherit",
  border: (t == null ? void 0 : t.textBorder) || "none",
  borderRadius: (t == null ? void 0 : t.textBorderRadius) || "8px",
  display: "flex",
  justifyContent: "flex-start"
});
function gD(e, t) {
  return {
    height: "24px",
    width: "24px",
    buttonIconTint: (e == null ? void 0 : e.closeIconTint) || (t == null ? void 0 : t.palette.getPrimary()) || "",
    border: "none",
    borderRadius: "8px",
    background: "transparent",
    display: "flex",
    justifyContent: "flex-start"
  };
}
function cD() {
  return {
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    boxSizing: "border-box"
  };
}
function dD(e, t) {
  return {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    font: (e == null ? void 0 : e.titleFont) || w(t == null ? void 0 : t.typography.text2),
    color: (e == null ? void 0 : e.titleColor) || (t == null ? void 0 : t.palette.getAccent())
  };
}
const ID = We({
  name: "SmartRepliesView",
  props: {
    title: {
      type: String,
      default: Y("SUGGEST_A_REPLY")
    },
    getSmartRepliesCallback: {
      type: Function,
      required: !0
    },
    configuration: {
      type: Object,
      default: () => ({})
    },
    editReplyCallback: {
      type: Function
    },
    backCallback: {
      type: Function
    },
    closeCallback: {
      type: Function
    }
  },
  setup(e) {
    const t = j(ge.loading), n = j(null), o = j([]), i = Y("SOMETHING_WRONG"), l = Y("NO_MESSAGES_FOUND"), r = e.configuration.smartRepliesStyle || {}, u = Y("GENERATING_REPLIES");
    let { theme: s } = dt("theme", {
      theme: j(new Ke({}))
    });
    const c = () => {
      t.value = ge.loading, e.getSmartRepliesCallback && e.getSmartRepliesCallback(s.value).then((N) => {
        N ? (t.value = ge.loaded, n.value = d(N)) : t.value = ge.empty;
      }).catch((N) => {
        t.value = ge.error;
      });
    }, d = (N) => {
      var T;
      if ((T = e.configuration) != null && T.customView)
        return e.configuration.customView(N, e.closeCallback, e.backCallback);
      {
        const m = [];
        Object.keys(N).forEach((A) => {
          m.push(N[A]);
        }), o.value = m;
        return;
      }
    };
    return c(), {
      smartReplyViewStyle: r,
      errorStateText: i,
      loadingStateText: u,
      emptyStateText: l,
      fetchButtonContent: c,
      getSmartReplyStyle: uD,
      getBackButtonStyle: gD,
      getSmartRepliesContainerStyle: cD,
      getSmartRepliesTitleStyle: dD,
      theme: s,
      States: ge,
      getContainerStyle: MD,
      localize: Y,
      messageListState: t,
      loadingIconURL: nn,
      errorIconURL: bo,
      emptyIconURL: bo,
      backButtonIconURL: fn,
      activeView: n,
      replies: o
    };
  }
}), ND = {
  key: 0,
  style: { height: "100%" }
}, TD = { key: 0 }, DD = ["innerHTML"], yD = ["v-slot", "v-html"], CD = ["iconURL", "onClick", "buttonStyle"], wD = ["smartReplyStyle", "replies"], jD = {
  key: 1,
  class: "cc__loading-state"
}, AD = ["state", "loadingIconURL", "loadingStateText"], LD = {
  key: 0,
  class: "cc-list__custom-view-loading"
}, zD = ["innerHTML"], SD = ["v-slot", "v-html"], pD = {
  key: 2,
  class: "cc__error-state"
}, bD = ["state", "errorIconURL", "errorStateText"], ED = {
  key: 0,
  class: "cc-list__custom-view-error"
}, hD = ["innerHTML"], vD = ["v-slot", "v-html"], mD = {
  key: 3,
  class: "cc__empty-state"
}, OD = ["state", "emptyIconURL", "emptyStateText"], xD = {
  key: 0,
  class: "cc-list__custom-view-empty"
}, kD = ["innerHTML"], fD = ["v-slot", "v-html"];
function UD(e, t, n, o, i, l) {
  var r, u, s, c, d, N, T, m, A, D, z, k, R, Q, h, O, x, _, oe, ie, re, Ae, se, X, B, F, G, J;
  return M(), g("div", {
    class: "slideable-container",
    style: ce(e.getContainerStyle(e.smartReplyViewStyle, e.theme))
  }, [
    e.messageListState === e.States.loaded ? (M(), g("div", ND, [
      e.activeView ? (M(), g("div", TD, [
        e.activeView && e.activeView.html ? (M(), g("div", {
          key: 0,
          innerHTML: e.activeView.html
        }, null, 8, DD)) : e.activeView && e.activeView.componentName ? (M(), je(fe(e.activeView.componentName), me({ key: 1 }, { ...e.activeView.props }, xe((r = e.activeView) == null ? void 0 : r.listeners)), {
          default: be(() => [
            (M(!0), g(we, null, pe(e.activeView.slots, (ee, V) => (M(), g("div", {
              key: V,
              "v-slot": [V],
              "v-html": ee
            }, null, 8, yD))), 128))
          ]),
          _: 1
        }, 16)) : $("", !0)
      ])) : $("", !0),
      e.replies ? (M(), g("div", {
        key: 1,
        style: ce(e.getSmartRepliesContainerStyle())
      }, [
        p("div", {
          style: ce(e.getSmartRepliesTitleStyle(e.smartReplyViewStyle, e.theme))
        }, [
          p("div", null, [
            p("cometchat-button", {
              iconURL: ((u = e.configuration) == null ? void 0 : u.backIconURL) || e.backButtonIconURL,
              onClick: () => e.backCallback ? e.backCallback() : null,
              buttonStyle: e.getBackButtonStyle((s = e.configuration) == null ? void 0 : s.smartRepliesStyle, e.theme)
            }, null, 8, CD)
          ]),
          p("div", null, kt(e.title), 1),
          t[1] || (t[1] = p("div", { style: { flex: ".2" } }, null, -1))
        ], 4),
        p("smart-replies", {
          smartReplyStyle: e.getSmartReplyStyle(e.theme, (c = e.configuration) == null ? void 0 : c.smartRepliesStyle),
          replies: e.replies,
          onCcReplyClicked: t[0] || (t[0] = (ee) => {
            var V;
            e.editReplyCallback && e.editReplyCallback((V = ee == null ? void 0 : ee.detail) == null ? void 0 : V.reply), e.closeCallback();
          }),
          key: "conversation-starter",
          closeIconURL: ""
        }, null, 40, wD)
      ], 4)) : $("", !0)
    ])) : e.messageListState === e.States.loading ? (M(), g("div", jD, [
      p("cometchat-ai-card", {
        state: e.States.loading,
        style: ce(e.smartReplyViewStyle),
        loadingIconURL: ((d = e.configuration) == null ? void 0 : d.loadingIconURL) || e.loadingIconURL,
        loadingStateText: e.loadingStateText
      }, [
        (N = e.configuration) != null && N.loadingStateView ? (M(), g("div", LD, [
          (T = e.configuration) != null && T.loadingStateView.html ? (M(), g("div", {
            key: 0,
            innerHTML: (m = e.configuration) == null ? void 0 : m.loadingStateView.html
          }, null, 8, zD)) : (M(), je(fe((A = e.configuration) == null ? void 0 : A.loadingStateView.componentName), me({ key: 1 }, xe((z = (D = e.configuration) == null ? void 0 : D.loadingStateView) == null ? void 0 : z.listeners), { ...(k = e.configuration) == null ? void 0 : k.loadingStateView.props }), {
            default: be(() => {
              var ee;
              return [
                (M(!0), g(we, null, pe((ee = e.configuration) == null ? void 0 : ee.loadingStateView.slots, (V, ne) => (M(), g("div", {
                  key: ne,
                  "v-slot": [ne],
                  "v-html": V
                }, null, 8, SD))), 128))
              ];
            }),
            _: 1
          }, 16))
        ])) : $("", !0)
      ], 12, AD)
    ])) : e.messageListState === e.States.error ? (M(), g("div", pD, [
      p("cometchat-ai-card", {
        state: e.States.error,
        style: ce(e.smartReplyViewStyle),
        errorIconURL: ((R = e.configuration) == null ? void 0 : R.errorIconURL) || e.errorIconURL,
        errorStateText: e.errorStateText
      }, [
        (Q = e.configuration) != null && Q.errorStateView ? (M(), g("div", ED, [
          (h = e.configuration) != null && h.errorStateView.html ? (M(), g("div", {
            key: 0,
            innerHTML: (O = e.configuration) == null ? void 0 : O.errorStateView.html
          }, null, 8, hD)) : (M(), je(fe((x = e.configuration) == null ? void 0 : x.errorStateView.componentName), me({ key: 1 }, xe((oe = (_ = e.configuration) == null ? void 0 : _.errorStateView) == null ? void 0 : oe.listeners), { ...(ie = e.configuration) == null ? void 0 : ie.errorStateView.props }), {
            default: be(() => {
              var ee;
              return [
                (M(!0), g(we, null, pe((ee = e.configuration) == null ? void 0 : ee.errorStateView.slots, (V, ne) => (M(), g("div", {
                  key: ne,
                  "v-slot": [ne],
                  "v-html": V
                }, null, 8, vD))), 128))
              ];
            }),
            _: 1
          }, 16))
        ])) : $("", !0)
      ], 12, bD)
    ])) : e.messageListState === e.States.empty ? (M(), g("div", mD, [
      p("cometchat-ai-card", {
        state: e.States.empty,
        style: ce(e.smartReplyViewStyle),
        emptyIconURL: ((re = e.configuration) == null ? void 0 : re.emptyIconURL) || e.emptyIconURL,
        emptyStateText: e.emptyStateText
      }, [
        (Ae = e.configuration) != null && Ae.emptyStateView ? (M(), g("div", xD, [
          (se = e.configuration) != null && se.emptyStateView.html ? (M(), g("div", {
            key: 0,
            innerHTML: (X = e.configuration) == null ? void 0 : X.emptyStateView.html
          }, null, 8, kD)) : (M(), je(fe((B = e.configuration) == null ? void 0 : B.emptyStateView.componentName), me({ key: 1 }, xe((G = (F = e.configuration) == null ? void 0 : F.emptyStateView) == null ? void 0 : G.listeners), { ...(J = e.configuration) == null ? void 0 : J.emptyStateView.props }), {
            default: be(() => {
              var ee;
              return [
                (M(!0), g(we, null, pe((ee = e.configuration) == null ? void 0 : ee.emptyStateView.slots, (V, ne) => (M(), g("div", {
                  key: ne,
                  "v-slot": [ne],
                  "v-html": V
                }, null, 8, fD))), 128))
              ];
            }),
            _: 1
          }, 16))
        ])) : $("", !0)
      ], 12, OD)
    ])) : $("", !0)
  ], 4);
}
const BD = /* @__PURE__ */ $e(ID, [["render", UD]]), QD = (e, t) => ({
  display: "flex",
  width: (e == null ? void 0 : e.width) || "100%",
  height: (e == null ? void 0 : e.height) || "100%",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "50px",
  background: (e == null ? void 0 : e.background) || t.palette.getBackground(),
  borderRadius: (e == null ? void 0 : e.borderRadius) || "8px"
}), RD = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "transparent",
  overflow: "hidden"
};
function YD(e, t) {
  return {
    height: "24px",
    width: "24px",
    buttonIconTint: (e == null ? void 0 : e.backIconTint) || (t == null ? void 0 : t.palette.getPrimary()) || "",
    border: "none",
    borderRadius: "8px",
    background: "transparent",
    display: "flex",
    justifyContent: "flex-start"
  };
}
function VD() {
  return {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    boxSizing: "border-box"
  };
}
function GD(e, t) {
  return {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    font: (e == null ? void 0 : e.optionTitleFont) || w(t == null ? void 0 : t.typography.text2),
    color: (e == null ? void 0 : e.optionTitleColor) || (t == null ? void 0 : t.palette.getAccent())
  };
}
const PD = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  boxSizing: "border-box"
};
function FD(e, t) {
  return new El({
    ActionSheetSeparatorTint: t.palette.getAccent400(),
    background: (e == null ? void 0 : e.buttonBackground) || t.palette.getBackground(),
    titleColor: (e == null ? void 0 : e.buttonTextColor) || t.palette.getAccent(),
    titleFont: (e == null ? void 0 : e.buttonTextFont) || w(t.typography.text2),
    listItemBackground: "transparent",
    height: "100%",
    width: "100%",
    border: "none"
  });
}
function HD(e, t) {
  return {
    display: "flex",
    flexDirection: "column",
    width: "40%",
    minWidth: "350px",
    maxWidth: "100%",
    height: "100%",
    overflow: "hidden",
    boxSizing: "border-box",
    background: (e == null ? void 0 : e.background) || (t == null ? void 0 : t.palette.getBackground())
  };
}
function ZD(e) {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    height: "40px",
    padding: "10px",
    boxSizing: "border-box",
    background: e == null ? void 0 : e.palette.getAccent200()
  };
}
function WD(e, t) {
  return {
    height: "24px",
    width: "24px",
    buttonIconTint: (e == null ? void 0 : e.closeIconTint) || (t == null ? void 0 : t.palette.getPrimary()) || "",
    border: "none",
    borderRadius: "8px",
    background: "transparent",
    display: "flex",
    justifyContent: "flex-start"
  };
}
function $D(e, t) {
  return {
    height: "24px",
    width: "24px",
    buttonIconTint: (e == null ? void 0 : e.sendIconTint) || (t == null ? void 0 : t.palette.getPrimary()) || "",
    border: "none",
    borderRadius: "8px",
    background: "transparent",
    display: "flex",
    justifyContent: "flex-start"
  };
}
function JD(e, t, n, o) {
  if (e.sender.getUid() === n.getUid()) {
    const i = (o == null ? void 0 : o.senderMessageBubbleStyle) || {};
    return {
      background: i.background || t.palette.getPrimary(),
      borderRadius: i.borderRadius || "12px",
      border: i.border || "none"
    };
  } else {
    const i = (o == null ? void 0 : o.botMessageBubbleStyle) || {};
    return o != null && o.botMessageBubbleStyle ? o == null ? void 0 : o.botMessageBubbleStyle : {
      background: i.background || t.palette.getAccent100(),
      borderRadius: i.borderRadius || "12px",
      border: i.border || "none"
    };
  }
}
function KD(e) {
  return e || new Kt({
    borderRadius: "16px",
    width: "28px",
    height: "28px"
  });
}
function XD(e, t) {
  return e || {
    height: "40px",
    width: "100%",
    maxHeight: "40px",
    border: `1px solid ${t.palette.getAccent100()}`,
    borderRadius: "12px",
    background: t.palette.getAccent50(),
    textFont: w(t.typography.text2),
    textColor: t.palette.getAccent(),
    dividerColor: t.palette.getAccent100(),
    inputBorder: "none",
    inputBorderRadius: "0px",
    inputBackground: "transparent"
  };
}
function qD(e) {
  return {
    textColor: e.palette.getAccent600(),
    textFont: w(e.typography.caption2),
    padding: "0px"
  };
}
function _D(e, t) {
  return new Jo({
    waitIconTint: (e == null ? void 0 : e.loadingIconTint) || t.palette.getAccent700(),
    errorIconTint: (e == null ? void 0 : e.errorIconTint) || t.palette.getError()
  });
}
function ey(e) {
  return {
    display: "flex",
    justifyContent: "flex-end",
    height: "100%",
    width: "100%",
    background: e.palette.getAccent600()
  };
}
function ty() {
  return {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "40px",
    padding: "5px",
    boxSizing: "border-box"
  };
}
const ny = We({
  name: "BotOptionView",
  props: {
    title: {
      type: String
    },
    configuration: {
      type: Object,
      default: () => ({})
    },
    bots: {
      type: Array,
      default: () => []
    },
    closeCallback: {
      type: Function
    },
    backCallback: {
      type: Function
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    });
    const n = j(e.configuration.assistBotStyle);
    function o(i) {
      var r;
      const l = (r = i == null ? void 0 : i.detail) == null ? void 0 : r.action;
      l.onClick && l.onClick(), e.closeCallback && e.closeCallback();
    }
    return {
      getContainerStyle: QD,
      contentContainerStyle: RD,
      optionsContainerStyle: PD,
      getBackButtonStyle: YD,
      getBotsContainerStyle: VD,
      getBotTitleStyle: GD,
      getOptionStyle: FD,
      onBotClick: o,
      assistBotStyle: n,
      theme: t,
      backButtonIconURL: fn
    };
  }
}), oy = ["iconURL", "onClick", "buttonStyle"], iy = ["actions", "actionSheetStyle"];
function ay(e, t, n, o, i, l) {
  var r;
  return M(), g("div", {
    class: "slideable-container",
    style: ce(e.getContainerStyle(e.assistBotStyle, e.theme))
  }, [
    p("div", {
      style: ce(e.getBotsContainerStyle())
    }, [
      p("div", {
        style: ce(e.getBotTitleStyle(e.assistBotStyle, e.theme))
      }, [
        p("div", null, [
          p("cometchat-button", {
            iconURL: ((r = e.configuration) == null ? void 0 : r.backIconURL) || e.backButtonIconURL,
            onClick: () => e.backCallback ? e.backCallback() : null,
            buttonStyle: e.getBackButtonStyle(e.assistBotStyle, e.theme)
          }, null, 8, oy)
        ]),
        p("div", null, kt(e.title), 1),
        t[1] || (t[1] = p("div", { style: { flex: ".2" } }, null, -1))
      ], 4),
      p("div", {
        style: ce(e.optionsContainerStyle)
      }, [
        p("cometchat-action-sheet", {
          actions: e.bots,
          hideLayoutMode: !0,
          actionSheetStyle: e.getOptionStyle(e.assistBotStyle, e.theme),
          onCcActionsheetClicked: t[0] || (t[0] = (...u) => e.onBotClick && e.onBotClick(...u))
        }, null, 40, iy)
      ], 4)
    ], 4)
  ], 4);
}
const ry = /* @__PURE__ */ $e(ny, [["render", ay]]), ly = We({
  name: "CometChatMessageComposer",
  components: {
    CometChatUserMemberWrapper: eD,
    CometChatCreatePollView: TT,
    CometChatStickersAuxiliaryButton: sD,
    SmartRepliesView: BD,
    BotOptionView: ry
  },
  props: {
    id: {
      type: String,
      default: null
    },
    user: {
      type: Object
    },
    group: { type: Object },
    text: { type: String, default: "" },
    onTextChange: { type: Function },
    placeHolderText: {
      type: String,
      default: () => Y("ENTER_YOUR_MESSAGE_HERE")
    },
    sendButtonView: { type: Object },
    onSendButtonClick: {
      type: Function
    },
    secondaryButtonView: { type: Object },
    attachmentIconURL: {
      type: String,
      default: Pa
    },
    auxiliaryButtonView: {
      type: Function
    },
    auxiliaryButtonsAlignment: {
      type: Number,
      default: () => Nl.right
    },
    attachmentOptions: {
      type: Function
    },
    parentMessageId: { type: Number, default: null },
    LiveReactionIconURL: {
      type: String,
      default: Va
    },
    hideLiveReaction: { type: Boolean, default: !0 },
    headerView: { type: Object },
    onError: {
      type: Function,
      default: (e) => {
        console.log(e);
      }
    },
    disableSoundForMessages: { type: Boolean, default: !1 },
    customSoundForMessage: { type: String },
    disableTypingEvents: { type: Boolean, default: !1 },
    messageComposerStyle: {
      type: Object,
      default: () => new ea({})
    },
    hideVoiceRecording: { type: Boolean, default: !1 },
    mediaRecorderStyle: {
      type: Object,
      default: () => ({})
    },
    hideLayoutMode: {
      type: Boolean,
      default: () => !1
    },
    actionSheetStyle: {
      type: Object,
      default: () => ({})
    },
    AIOptionsStyle: {
      type: Object,
      default: () => ({})
    },
    AIIconURL: {
      type: String,
      default: fl
    },
    voiceRecordingStartIconURL: {
      type: String,
      default: Jl
    },
    voiceRecordingCloseIconURL: {
      type: String,
      default: Ql
    },
    voiceRecordingStopIconURL: {
      type: String,
      default: as
    },
    voiceRecordingSubmitIconURL: {
      type: String,
      default: yi
    },
    userMemberWrapperConfiguration: {
      type: Object
    },
    textFormatters: {
      type: Array,
      default: () => []
    },
    disableMentions: {
      type: Boolean,
      default: !1
    },
    mentionsWarningText: {
      type: String
    },
    mentionsWarningStyle: {
      type: Object,
      default: () => {
      }
    },
    sendButtonIconURL: {
      type: String,
      default: yi
    },
    emojiIconURL: {
      type: String,
      default: Gl
    }
  },
  setup(e) {
    const t = () => ({
      display: "flex",
      columnGap: "8px"
    });
    let { theme: n } = dt("theme", {
      theme: j(new Ke({}))
    }), o = {
      width: "275px",
      height: "280px",
      border: "",
      background: "transparent",
      borderRadius: "8px",
      boxShadow: "0px 0px 32px rgba(20, 20, 20, 0.2)"
    }, i = j(!1), l = {
      width: "272px",
      height: "244px",
      border: "",
      background: "transparent",
      borderRadius: "8px",
      boxShadow: "0px 0px 32px rgba(20, 20, 20, 0.2)"
    }, r = [], u = j(null), s = {}, c, d, N, T = [], m = !1, A = j(!1), D = j(!1), z = j(), k = j(void 0), R = j([]), Q = j(void 0), h = No.top, O = {
      width: "315px",
      height: "320px",
      border: "none",
      background: "transparent",
      borderRadius: "8px",
      boxShadow: "0px 0px 32px rgba(20, 20, 20, 0.2)"
    }, x = {
      height: "100px",
      width: "250px",
      border: "none",
      background: "transparent",
      borderRadius: "8px",
      boxShadow: "0px 0px 32px rgba(20, 20, 20, 0.2)"
    }, _ = new Bo({}), oe = {
      ...e.mediaRecorderStyle,
      background: e.mediaRecorderStyle.background || n.value.palette.getBackground(),
      border: e.mediaRecorderStyle.border || `1px solid ${n.value.palette.getAccent200()}`,
      borderRadius: "8px",
      closeIconTint: e.mediaRecorderStyle.closeIconTint || n.value.palette.getAccent600(),
      submitIconTint: e.mediaRecorderStyle.submitIconTint || n.value.palette.getAccent600(),
      startIconTint: e.mediaRecorderStyle.startIconTint || n.value.palette.getError(),
      stopIconTint: e.mediaRecorderStyle.stopIconTint || n.value.palette.getError()
    }, ie = j(!1), re = j(!1), Ae = j(!1), se = j(null), X = "", B = j(!1), F = Ne.getDataSource().getMentionsTextFormatter({
      theme: n.value
    });
    c = "composer_" + Date.now();
    let G = j([...e.textFormatters]), J = j(null), ee = j(null), V = j(null), ne = j(null), K = j(!1), Ie = j(null), Te = j(null), H = j(null), Ee = j(null), L = j(!1), b = j({
      height: "24px",
      width: "24px",
      border: "none",
      borderRadius: "0",
      buttonIconTint: "rgba(20, 20, 20, 0.58)",
      background: "transparent"
    }), v = j({
      height: "24px",
      width: "24px",
      border: "none",
      borderRadius: "0",
      buttonIconTint: n.value.palette.getAccent500(),
      background: "transparent"
    }), U, Se, Ue = j(""), Re = j(null), _e = {
      layoutModeIconTint: "rgba(20, 20, 20, 0.04)",
      borderRadius: "inherit",
      background: "rgb(255,255,255)",
      border: "none",
      width: "100%",
      height: "100%",
      titleFont: "500 15px Inter, sans-serif",
      titleColor: "#141414",
      listItemBackground: "",
      ActionSheetSeparatorTint: "1px solid RGBA(20, 20, 20, 0.08)"
    }, Z = j(e.userMemberWrapperConfiguration), ke = j(), q = j(null), ye = j(null), Oe = j(1), he = [];
    const Pe = xl();
    tn(() => {
      document.addEventListener("click", Mi);
    });
    const lt = (W) => {
      var Be;
      if (!(W && W.length)) {
        se.value = null, B.value = !1, Oe.value = 1;
        return;
      }
      let De = W.split("@")[1].toLowerCase() ? W.split("@")[1].toLowerCase() : void 0;
      (!De || !(X && De.startsWith(X.toLowerCase()))) && De !== se.value && (se.value = De && De.length ? De : void 0, B.value = !0, Oe.value++, X = null, (Be = Pe == null ? void 0 : Pe.proxy) == null || Be.$forceUpdate());
    }, It = (W) => {
      try {
        if (!W.target.files[0])
          return !1;
        const De = W.target.files[0], Be = new FileReader();
        Be.addEventListener(
          "load",
          () => {
            const Ve = new File(
              [Be.result],
              De.name,
              De
            );
            sn(Ve, y.MESSAGE_TYPE.IMAGE);
          },
          !1
        ), Be.readAsArrayBuffer(De);
      } catch (De) {
        let Be = new y.CometChatException({
          message: De.message
        });
        e.onError(Be);
      }
      return !0;
    };
    un(() => {
      de(), F.cleanup();
    });
    const Gt = (W) => {
      try {
        if (!W.target.files[0])
          return !1;
        const Be = W.target.files[0];
        var De = new FileReader();
        De.addEventListener(
          "load",
          () => {
            const Ve = new File(
              [De.result],
              Be.name,
              Be
            );
            sn(Ve, y.MESSAGE_TYPE.FILE);
          },
          !1
        ), De.readAsArrayBuffer(Be);
      } catch (Be) {
        let Ve = new y.CometChatException({
          message: Be.message
        });
        e.onError(Ve);
      }
      return !0;
    }, de = () => {
      d == null || d.unsubscribe(), N == null || N.unsubscribe();
    }, Le = (W) => {
      try {
        if (!W.target.files[0])
          return !1;
        const De = W.target.files[0], Be = new FileReader();
        Be.addEventListener(
          "load",
          () => {
            const Ve = new File(
              [Be.result],
              De.name,
              De
            );
            sn(Ve, y.MESSAGE_TYPE.VIDEO);
          },
          !1
        ), Be.readAsArrayBuffer(De);
      } catch (De) {
        let Be = new y.CometChatException({
          message: De.message
        });
        e.onError(Be);
      }
      return !0;
    }, Fe = () => e.auxiliaryButtonsAlignment, tt = (W) => {
      try {
        if (!W.target.files[0])
          return !1;
        const De = W.target.files[0], Be = new FileReader();
        Be.addEventListener(
          "load",
          () => {
            const Ve = new File(
              [Be.result],
              De.name,
              De
            );
            sn(Ve, y.MESSAGE_TYPE.AUDIO);
          },
          !1
        ), Be.readAsArrayBuffer(De);
      } catch (De) {
        let Be = new y.CometChatException({
          message: De.message
        });
        e.onError(Be);
      }
      return !0;
    };
    let st = {
      "image/*": It.bind(this),
      "video/*": Le.bind(this),
      "audio/*": tt.bind(this),
      "file/*": Gt.bind(this)
    }, ct = {
      height: "24px",
      width: "24px",
      border: "none",
      borderRadius: "0",
      buttonIconTint: "grey",
      background: "transparent"
    }, wt = Fa, Lt = {
      height: "24px",
      width: "24px",
      border: "none",
      borderRadius: "0",
      buttonIconTint: "grey",
      background: "transparent"
    }, jt = {
      width: "100%",
      height: "100%",
      border: "none",
      textFont: "500 12px Inter, sans-serif",
      textColor: "",
      background: "",
      borderRadius: "12px"
    }, Wt = Wa, ot = {}, zt = {}, yt, on = {
      height: "80%",
      width: "100%"
    }, ft = j(""), rt, Tt, Pt = !1, Rt = j(null);
    const Yt = "No user or group object provided. Should at least provide one.";
    Zt(() => {
      var W, De;
      en(), bt(), R.value = mo(), Ue.value = e.text, y.getLoggedinUser().then((Be) => {
      }).catch((Be) => {
        if (e.onError) {
          let Ve = new y.CometChatException({
            message: Be.message
          });
          e.onError(Ve);
        }
      }), s.parentMessageId = e.parentMessageId, e.user ? (rt = e.user, s = {
        user: (W = e.user) == null ? void 0 : W.getUid(),
        parentMessageId: e.parentMessageId
      }) : (Tt = e.group, s = {
        group: (De = e.group) == null ? void 0 : De.getGuid(),
        parentMessageId: e.parentMessageId
      }), oo(), Un(), e.attachmentOptions && (rt || Tt) && (T = e.attachmentOptions(
        rt || Tt,
        s
      )), T = T.length ? T : Ne.getDataSource().getAttachmentOptions(
        n.value,
        s
      ), Ut(), Rt.value = Ne.getDataSource().getAuxiliaryOptions(
        s,
        rt,
        Tt,
        n.value
      );
    });
    const en = () => {
      var W;
      if (!e.disableMentions) {
        if (F.setMentionsTextStyle(
          gn()
        ), (W = G.value) != null && W.length) {
          const De = G.value.find((Be) => Be instanceof yo);
          De && (F = De);
        }
        (!F.getKeyUpCallBack() || !F.getKeyDownCallBack()) && (F.setKeyUpCallBack(lt), F.setKeyDownCallBack(lt), F.setId(c)), G.value.push(F);
      }
    }, gn = () => _;
    eo(() => {
      var W, De, Be, Ve;
      e.user && ((W = e.user) == null ? void 0 : W.getUid()) !== (rt == null ? void 0 : rt.getUid()) ? (Pt = !0, s = {
        user: (De = e.user) == null ? void 0 : De.getUid(),
        parentMessageId: e.parentMessageId
      }, rt = e.user, Tt = null) : e.group && ((Be = e.group) == null ? void 0 : Be.getGuid()) !== (Tt == null ? void 0 : Tt.getGuid()) && (s = {
        group: (Ve = e.group) == null ? void 0 : Ve.getGuid(),
        parentMessageId: e.parentMessageId
      }, Pt = !0, Tt = e.group, rt = null), Pt && (bt(), B.value = !1, se.value = "", R.value = mo(), D.value = !1, Ze(), Vt(), dn(), et(), T = [], e.attachmentOptions && (rt || Tt) && (T = e.attachmentOptions(
        rt || Tt,
        s
      )), T = T.length ? T : Ne.getDataSource().getAttachmentOptions(
        n.value,
        s
      ), Ut(), Rt.value = Ne.getDataSource().getAuxiliaryOptions(
        s,
        rt,
        Tt,
        n.value
      )), Pt = !1;
    });
    const bt = () => {
      e.disableMentions || (e.group && (Z.value.userMemberListType == null && (ke.value = Zo.groupmembers), ye.value = e.userMemberWrapperConfiguration.groupMemberRequestBuilder ? Z.value.groupMemberRequestBuilder : new y.GroupMembersRequestBuilder(
        e.group.getGuid()
      ).setLimit(10)), e.user && (Z.value.userMemberListType == null && (ke.value = Zo.users), q.value = e.userMemberWrapperConfiguration.usersRequestBuilder ? e.userMemberWrapperConfiguration.usersRequestBuilder : new y.UsersRequestBuilder().setLimit(10)));
      for (let W = 0; W < G.value.length; W++)
        G.value[W].setComposerConfig(e.user, e.group, s);
    }, Ut = () => {
      T.forEach((W) => {
        let De;
        switch (W.id) {
          case I.MessageTypes.audio:
            W.onClick = Tn;
            break;
          case I.MessageTypes.video:
            W.onClick = ln;
            break;
          case I.MessageTypes.file:
            W.onClick = rn;
            break;
          case I.MessageTypes.image:
            W.onClick = cn;
            break;
          case Io.extension_poll:
            De = W.onClick, W.onClick = () => {
              W.onClick && De([rt, Tt]);
            };
            break;
        }
      });
    }, cn = () => {
      J.value.type = "file", J.value.accept = "image/*", J.value.click(), Vt(), dn();
    }, rn = () => {
      J.value.type = "file", J.value.accept = "file/*", J.value.click(), Vt(), dn();
    }, ln = () => {
      J.value.type = "file", J.value.accept = "video/*", J.value.click(), Vt(), dn();
    }, Tn = () => {
      J.value.type = "file", J.value.accept = "audio/*", J.value.click(), Vt(), dn();
    }, Vt = () => {
      Ae.value && (ne.value.click(), Ae.value = !Ae.value), ie.value && (ee.value.click(), ie.value = !ie.value), K.value && (Ie.value.click(), K.value = !K.value), re.value && (V.value.click(), re.value = !re.value);
    }, Xt = () => {
      if (e.user && e.user.getUid())
        return {
          receiverId: e.user.getUid(),
          receiverType: I.MessageReceiverType.user,
          isBlocked: e.user.getBlockedByMe() || e.user.getHasBlockedMe()
        };
      if (e.group && e.group.getGuid())
        return {
          receiverId: e.group.getGuid(),
          receiverType: I.MessageReceiverType.group,
          isBlocked: !1
        };
      throw new Error(Yt);
    }, sn = (W, De) => {
      try {
        const { receiverId: Be, receiverType: Ve } = Xt();
        let ut = new y.MediaMessage(
          Be,
          W,
          De,
          Ve
        );
        e.parentMessageId && ut.setParentMessageId(e.parentMessageId), ut.setType(De), ut.setMetadata({
          file: W
        }), ut.setSentAt(Ce.getUnixTimestamp()), ut.setMuid(Ce.ID()), Vt(), dn(), e.onSendButtonClick ? e.onSendButtonClick(ut, ci.none) : (ae.ccMessageSent.next({
          message: ut,
          status: Xe.inprogress
        }), e.disableSoundForMessages || Pn(), Ct.getLoggedInUser() && ut.setSender(Ct.getLoggedInUser()), y.sendMessage(ut).then((Dt) => {
          Dt.setMuid(ut.getMuid()), ae.ccMessageSent.next({
            message: Dt,
            status: Xe.success
          });
        }).catch((Dt) => {
          ut.setMetadata({
            error: Dt
          }), ae.ccMessageSent.next({
            message: ut,
            status: Xe.error
          });
          let Mt = new y.CometChatException({
            message: Dt.message
          });
          e.onError && e.onError(Mt);
        }));
      } catch (Be) {
        let Ve = new y.CometChatException({
          message: Be.message
        });
        e.onError && e.onError(Ve);
      }
      return !0;
    }, te = () => {
      var De, Be;
      let W = (De = ft == null ? void 0 : ft.value) == null ? void 0 : De.trim();
      if (A.value && ((Be = z.value) == null ? void 0 : Be.getText()) === ft.value)
        return !1;
      try {
        if (W.length == 0)
          return !1;
        if (z.value)
          return Bt(), !1;
        let { receiverId: Ve, receiverType: ut } = Xt(), Dt;
        W !== null ? Dt = W.trim() : Dt = ft.value.trim();
        let Mt = new y.TextMessage(
          Ve,
          Dt,
          ut
        );
        if (e.parentMessageId && Mt.setParentMessageId(e.parentMessageId), he.length) {
          let ht = [];
          for (let jn = 0; jn < he.length; jn++)
            ht.push(
              new y.User({
                uid: he[jn].getUid(),
                name: he[jn].getName()
              })
            );
          Mt.setMentionedUsers(ht), he = [];
        }
        Mt.setSentAt(Ce.getUnixTimestamp()), Mt.setMuid(Ce.ID()), Ze(), Ue.value = "", b.value = {
          height: "24px",
          width: "24px",
          border: "none",
          borderRadius: "0",
          buttonIconTint: Ue.value ? U.sendIconTint : n.value.palette.getAccent200(),
          background: "transparent"
        }, Vt(), dn(), i.value = !1;
        for (let ht = 0; ht < G.value.length; ht++)
          Mt = G.value[ht].formatMessageForSending(
            Mt
          );
        e.onSendButtonClick ? e.onSendButtonClick(Mt, ci.none) : (ae.ccMessageSent.next({
          message: Mt,
          status: Xe.inprogress
        }), e.disableSoundForMessages || Pn(), Ct.getLoggedInUser() && Mt.setSender(Ct.getLoggedInUser()), y.sendMessage(Mt).then((ht) => {
          let jn = ht;
          ae.ccMessageSent.next({
            message: jn,
            status: Xe.success
          }), setTimeout(() => {
            D.value = !1;
          }, 500);
        }).catch((ht) => {
          Mt.setMetadata({
            error: ht
          }), ae.ccMessageSent.next({
            message: Mt,
            status: Xe.error
          });
        }));
      } catch (Ve) {
        let ut = new y.CometChatException({
          message: Ve.message
        });
        e.onError(ut);
      }
      return !0;
    }, et = () => {
      i.value = !1, B.value = !1, A.value = !1, b.value = {
        height: "24px",
        width: "24px",
        border: "none",
        borderRadius: "0",
        buttonIconTint: n.value.palette.getAccent200(),
        background: "transparent"
      }, D.value = !1, z.value = null, Ze();
    }, Ze = () => {
      var W;
      ft.value = "", Ue.value = "", H.value.text = "", (W = H == null ? void 0 : H.value) == null || W.emptyInputField();
    }, at = (W = null) => {
      if (yt = null, !e.disableTypingEvents)
        try {
          let { receiverId: De, receiverType: Be, isBlocked: Ve } = Xt();
          if (Ve)
            return;
          let ut = W || void 0, Dt = new y.TypingIndicator(
            De,
            Be,
            ut
          );
          y.endTyping(Dt);
        } catch (De) {
          let Be = new y.CometChatException({
            message: De.message
          });
          e.onError(Be);
        }
    }, Bt = () => {
      try {
        const W = z.value;
        z.value = null, Ue.value = "";
        let { receiverId: De, receiverType: Be } = Xt(), Ve = ft.value.trim(), ut = [];
        if (W != null && W.getMentionedUsers()) {
          ut = W == null ? void 0 : W.getMentionedUsers(), Ve = F.getOriginalText(Ve);
          let Mt = [];
          for (let ht = 0; ht < ut.length; ht++)
            Mt.push(ut[ht]);
          F.setCometChatUserGroupMembers(
            Mt
          ), Ve = F.getOriginalText(Ve);
        }
        let Dt = new y.TextMessage(
          De,
          Ve,
          Be
        );
        ut.length && Dt.setMentionedUsers(ut), Dt.setId(W.id), et(), Ze(), Vt(), dn(), i.value = !1;
        for (let Mt = 0; Mt < G.value.length; Mt++)
          Dt = G.value[Mt].formatMessageForSending(
            Dt
          );
        if (e.onSendButtonClick) {
          e.onSendButtonClick(Dt, ci.edit);
          return;
        }
        y.editMessage(Dt).then((Mt) => {
          ae.ccMessageEdited.next({
            message: Mt,
            status: Xe.success
          });
        }).catch((Mt) => {
          if (Dt.setMetadata({
            error: Mt
          }), ae.ccMessageEdited.next({
            message: Dt,
            status: Xe.error
          }), e.onError) {
            let ht = new y.CometChatException({
              message: Mt.message
            });
            e.onError(ht);
          }
        });
      } catch (W) {
        let De = new y.CometChatException({
          message: W.message
        });
        e.onError(De);
      }
    }, vn = (W) => {
      (st[J.value.accept] || Gt.bind(this))(W), J.value.value = "";
    }, Pn = () => {
      e.customSoundForMessage ? Ot.play(
        Ot.Sound.outgoingMessage,
        e.customSoundForMessage
      ) : Ot.play(Ot.Sound.outgoingMessage);
    }, to = (W) => {
      ft.value = W.detail.value, te() && (D.value = !1, i.value = !1, B.value = !1, Ze());
    }, Un = () => {
      d = ae.ccMessageEdited.subscribe(
        (W) => {
          let De = W.message;
          (W == null ? void 0 : W.status) == Xe.inprogress && (Ze(), z.value = W.message, no(De) && Fn()), (W == null ? void 0 : W.status) === Xe.success && W.message instanceof y.TextMessage && et();
        }
      ), it.ccShowModal.subscribe((W) => {
        k.value = W.child;
      }), N = it.ccShowMentionsCountWarning.subscribe(
        (W) => {
          if (W.id == c) {
            if (W.showWarning) {
              i.value = !0;
              return;
            }
            i.value = !1;
          }
        }
      ), it.ccHideModal.subscribe(() => {
        k.value = void 0, Vt(), dn();
      }), it.ccComposeMessage.subscribe(
        (W) => {
          Ze(), Ue.value = W, pn(() => {
            Ue.value = "";
          });
        }
      );
    }, Fn = () => {
      Ze(), pn(() => {
        Ue.value = z.value.getText(), A.value = !0;
      });
    }, no = (W) => !!(rt && W.getReceiverType() === I.MessageReceiverType.user && (W == null ? void 0 : W.getReceiverId()) === (rt == null ? void 0 : rt.getUid()) || Tt && W.getReceiverType() === I.MessageReceiverType.group && (W == null ? void 0 : W.getReceiverId()) === (Tt == null ? void 0 : Tt.getGuid())), Hn = (W) => {
      const De = /<@uid:(.*?)>/g;
      let Be = W.getText(), Ve = Be, ut = De.exec(Be), Dt = [], Mt = W == null ? void 0 : W.getMentionedUsers();
      for (; ut !== null; ) {
        let ht;
        for (let jn = 0; jn < Mt.length; jn++)
          ut[1] == Mt[jn].getUid() && (ht = Mt[jn]);
        ht && (Ve = Ve.replace(
          ut[0],
          "@" + ht.getName() + " "
        ), Dt.push(ht)), ut = De.exec(Be);
      }
      return F.setCometChatUserGroupMembers(
        Dt
      ), F.setLoggedInUser(
        Ct.getLoggedInUser()
      ), Ve;
    }, Zn = () => {
      U = {
        ...new ea({
          background: n.value.palette.getAccent100(),
          border: "none",
          height: "100%",
          width: "100%",
          borderRadius: "12px",
          attachIcontint: n.value.palette.getAccent500(),
          sendIconTint: n.value.palette.getPrimary(),
          emojiIconTint: n.value.palette.getAccent500(),
          inputBackground: "transparent",
          inputBorder: "none",
          dividerTint: n.value.palette.getAccent200(),
          textFont: w(n.value.typography.subtitle1),
          textColor: n.value.palette.getAccent(),
          emojiKeyboardTextFont: w(n.value.typography.subtitle2),
          emojiKeyboardTextColor: n.value.palette.getAccent400(),
          previewTitleFont: w(n.value.typography.subtitle1),
          previewTitleColor: n.value.palette.getAccent(),
          previewSubtitleFont: w(n.value.typography.subtitle2),
          previewSubtitleColor: n.value.palette.getAccent600(),
          closePreviewTint: n.value.palette.getAccent500(),
          maxInputHeight: "70px"
        }),
        ...e.messageComposerStyle
      };
    }, oo = () => {
      var W, De, Be, Ve, ut, Dt, Mt;
      Zn(), _e = {
        layoutModeIconTint: (U == null ? void 0 : U.ActionSheetLayoutModeIconTint) || n.value.palette.getAccent(),
        borderRadius: "inherit",
        background: n.value.palette.getBackground(),
        border: "none",
        width: "100%",
        height: "100%",
        titleFont: (U == null ? void 0 : U.ActionSheetTitleFont) || w(n.value.typography.title2),
        titleColor: (U == null ? void 0 : U.ActionSheetTitleColor) || n.value.palette.getAccent(),
        ActionSheetSeparatorTint: (U == null ? void 0 : U.ActionSheetSeparatorTint) || `${n.value.palette.getAccent400()}`,
        ...e.actionSheetStyle
      }, Se = {
        width: ((W = e.AIOptionsStyle) == null ? void 0 : W.width) || "100%",
        height: ((De = e.AIOptionsStyle) == null ? void 0 : De.height) || "100%",
        border: ((Be = e.AIOptionsStyle) == null ? void 0 : Be.border) || "none",
        borderRadius: ((Ve = e.AIOptionsStyle) == null ? void 0 : Ve.borderRadius) || "0",
        background: ((ut = e.AIOptionsStyle) == null ? void 0 : ut.background) || n.value.palette.getBackground(),
        listItemBackground: ((Dt = e.AIOptionsStyle) == null ? void 0 : Dt.listItemBackground) || "transparent",
        ActionSheetSeparatorTint: ((Mt = e.AIOptionsStyle) == null ? void 0 : Mt.optionsSeparatorTint) || `${n.value.palette.getAccent400()}`
      }, zt = {
        height: "60%",
        width: (U == null ? void 0 : U.width) || "100%",
        maxHeight: (U == null ? void 0 : U.maxInputHeight) || "150px",
        border: (U == null ? void 0 : U.border) || `1px solid ${n.value.palette.getAccent100()}`,
        borderRadius: (U == null ? void 0 : U.borderRadius) || "12px",
        background: (U == null ? void 0 : U.background) || n.value.palette.getAccent50(),
        textFont: (U == null ? void 0 : U.textFont) || w(n.value.typography.text2),
        textColor: (U == null ? void 0 : U.textColor) || n.value.palette.getAccent(),
        dividerColor: (U == null ? void 0 : U.dividerTint) || n.value.palette.getAccent100(),
        inputBorder: (U == null ? void 0 : U.inputBorder) || "none",
        inputBorderRadius: 0,
        inputBackground: (U == null ? void 0 : U.inputBackground) || "transparent"
      }, b.value = {
        height: "24px",
        width: "24px",
        border: "none",
        borderRadius: "0",
        buttonIconTint: U.sendIconTint || n.value.palette.getAccent200(),
        background: "transparent"
      }, v.value = {
        height: "24px",
        width: "24px",
        border: "none",
        borderRadius: "0",
        buttonIconTint: U.voiceRecordingIconTint || n.value.palette.getAccent500(),
        background: "transparent"
      }, on = {
        height: "100%",
        width: "100%",
        border: `1px solid ${n.value.palette.getAccent200()}`,
        background: n.value.palette.getBackground(),
        previewTitleFont: (U == null ? void 0 : U.previewTitleFont) || w(n.value.typography.subtitle1),
        previewTitleColor: (U == null ? void 0 : U.previewTitleColor) || n.value.palette.getAccent400(),
        previewSubtitleColor: (U == null ? void 0 : U.previewSubtitleColor) || n.value.palette.getAccent400(),
        previewSubtitleFont: (U == null ? void 0 : U.previewSubtitleFont) || w(n.value.typography.subtitle2),
        closeButtonIconTint: (U == null ? void 0 : U.closePreviewTint) || n.value.palette.getAccent600(),
        borderRadius: "12px"
      }, Lt = {
        height: "24px",
        width: "24px",
        border: "none",
        borderRadius: "0",
        buttonIconTint: (U == null ? void 0 : U.emojiIconTint) || n.value.palette.getAccent600(),
        background: "transparent"
      }, jt = {
        width: "100%",
        height: "100%",
        border: "none",
        textFont: w(n.value.typography.caption1),
        textColor: n.value.palette.getAccent(),
        background: n.value.palette.getBackground(),
        borderRadius: "12px",
        activeIconTint: "#2196ec"
      }, ot = {
        width: "100%",
        height: "100%",
        border: "none",
        emptyStateTextFont: w(n.value.typography.title1),
        emptyStateTextColor: n.value.palette.getAccent600(),
        errorStateTextFont: w(n.value.typography.title1),
        errorStateTextColor: n.value.palette.getAccent600(),
        loadingIconTint: n.value.palette.getAccent600(),
        background: n.value.palette.getBackground(),
        borderRadius: "12px"
      }, ct = {
        height: "24px",
        width: "24px",
        border: "none",
        borderRadius: "0",
        buttonIconTint: (U == null ? void 0 : U.attachIcontint) || n.value.palette.getAccent600(),
        background: "transparent"
      };
    }, io = () => zt, Wn = () => ct, ao = (W) => {
      if (dn(), K.value = !K.value, Ae.value && (ne.value.click(), Ae.value = !Ae.value), ie.value && (ee.value.click(), ie.value = !ie.value), re.value && (V.value.click(), re.value = !re.value), L.value)
        Te.value.click(), L.value = !L.value;
      else
        return;
    }, ro = () => {
      if (Q.value = void 0, dn(), re.value = !re.value, Ae.value && (ne.value.click(), Ae.value = !Ae.value), ie.value && (ee.value.click(), ie.value = !ie.value), K.value && (Ie.value.click(), K.value = !K.value), L.value)
        Te.value.click(), L.value = !L.value;
      else
        return;
    }, lo = (W) => {
      var Be;
      let De = (Be = W == null ? void 0 : W.detail) == null ? void 0 : Be.action;
      K.value && (Ie.value.click(), K.value = !K.value), De.onClick && De.onClick();
    }, Bn = (W) => {
      var Be;
      let De = (Be = W == null ? void 0 : W.detail) == null ? void 0 : Be.action;
      if (De instanceof xn)
        De.onClick(), re.value && (V.value.click(), re.value = !re.value);
      else {
        const Ve = De.customView({ closeAIOption: Dn, backAIOption: Qn });
        Ve && (Q.value = Ve);
      }
    };
    function Qn() {
      Q.value = void 0;
    }
    function Dn() {
      re.value && (V.value.click(), re.value = !re.value);
    }
    const so = (W) => {
      if (dn(), ie.value = !ie.value, Ae.value && (ne.value.click(), Ae.value = !Ae.value), K.value && (Ie.value.click(), K.value = !K.value), L.value)
        Te.value.click(), L.value = !L.value;
      else
        return;
    }, Rn = () => {
      if (dn(), Ae.value = !Ae.value, ie.value && (ee.value.click(), ie.value = !ie.value), K.value && (Ie.value.click(), K.value = !K.value), re.value && (V.value.click(), re.value = !re.value), L.value)
        Te.value.click(), L.value = !L.value;
      else
        return;
    }, qt = () => {
      Ae.value && (ne.value.click(), Ae.value = !Ae.value);
    }, S = (W) => {
      ft.value = W, te() && (D.value = !1, Ze());
    }, f = () => {
      try {
        const { receiverId: W, receiverType: De } = Xt();
        let Be = {
          type: "live_reaction",
          reaction: "heart"
        }, Ve = new y.TransientMessage(
          W,
          De,
          Be
        );
        y.sendTransientMessage(Ve), ae.ccLiveReaction.next("heart");
      } catch (W) {
        let De = new y.CometChatException({
          message: W.message
        });
        e.onError && e.onError(De);
      }
    }, P = (W) => {
      var Be, Ve;
      const De = (Ve = (Be = W == null ? void 0 : W.detail) == null ? void 0 : Be.value) == null ? void 0 : Ve.trim();
      De || (B.value = !1, i.value = !1), b.value = {
        height: "24px",
        width: "24px",
        border: "none",
        borderRadius: "0",
        buttonIconTint: De ? U.sendIconTint : n.value.palette.getAccent200(),
        background: "transparent"
      }, D.value = !0, e.onTextChange && e.onTextChange(De), ft.value = De, De ? $t() : D.value = !1;
    }, Me = () => O, ze = () => x, Qe = () => oe, Ye = (W) => {
      var Be;
      const De = (Be = W == null ? void 0 : W.detail) == null ? void 0 : Be.file;
      if (De) {
        const Ve = new File(
          [De],
          `${At()}.wav`,
          { type: De.type }
        );
        sn(Ve, y.MESSAGE_TYPE.AUDIO);
      }
      qt();
    };
    function At() {
      const W = /* @__PURE__ */ new Date(), De = "audio-recording-yyyyMMddHHmmss", Be = W.getFullYear().toString(), Ve = (W.getMonth() + 1).toString().padStart(2, "0"), ut = W.getDate().toString().padStart(2, "0"), Dt = W.getHours().toString().padStart(2, "0"), Mt = W.getMinutes().toString().padStart(2, "0"), ht = W.getSeconds().toString().padStart(2, "0");
      return De.replace("yyyyMMdd", `${Be}${Ve}${ut}`).replace("HHmmss", `${Dt}${Mt}${ht}`);
    }
    const $t = (W = null, De = "") => {
      if (!e.disableTypingEvents)
        try {
          let Be = W || 500;
          if (yt)
            clearTimeout(yt), yt = null;
          else {
            let { receiverId: Ve, receiverType: ut, isBlocked: Dt } = Xt();
            if (Dt)
              return;
            let Mt = De || void 0, ht = new y.TypingIndicator(
              Ve,
              ut,
              Mt
            );
            y.startTyping(ht);
          }
          yt = setTimeout(() => {
            at();
          }, Be);
        } catch (Be) {
          let Ve = new y.CometChatException({
            message: Be.message
          });
          e.onError(Ve);
        }
    }, Ln = (W) => {
      Ue.value === (W == null ? void 0 : W.detail.id) && (Ue.value = ""), Ue.value = W == null ? void 0 : W.detail.id, pn(() => {
        Ue.value = "";
      });
    }, wn = () => ({
      height: "24px",
      width: "24px",
      border: "none",
      borderRadius: "0",
      buttonIconTint: (U == null ? void 0 : U.liveReactionIconTint) || "red",
      background: "transparent",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }), St = () => Lt, Et = () => jt, $n = () => _e, Mo = () => Se, Eo = () => o, mn = () => l, oi = () => ot, ho = () => on, vo = () => T, mo = () => Ne.dataSource.getAIOptions(
      e.user,
      e.group,
      n.value,
      s,
      e.AIOptionsStyle
    ), ii = () => ({
      height: (U == null ? void 0 : U.height) || "100%",
      width: (U == null ? void 0 : U.width) || "100%"
    }), dn = () => {
      for (let W = 0; W < r.length; W++)
        r[W].onClick();
    }, uo = (W) => {
      if (W.name == "register" && (r[W.componentIndex] = {}, r[W.componentIndex].onClick = W.onClick), W.name == "open") {
        Vt();
        for (let De = 0; De < r.length; De++)
          De != W.componentIndex && r[De] && r[De].onClick();
      }
    }, wo = () => e.auxiliaryButtonView ? e.auxiliaryButtonView(
      rt || Tt,
      s
    ) : null;
    function ai() {
      return {
        display: "flex"
      };
    }
    const ri = (W) => {
      let De = [W];
      F.setCometChatUserGroupMembers(
        De
      ), he = [
        ...F.getCometChatUserGroupMembers()
      ], F.reRender(), B.value = !1, se.value = "";
    };
    function li() {
      X = se.value, B.value = !1, se.value = "";
    }
    function si() {
      return {
        height: "fit-content",
        width: "fit-content",
        buttonTextFont: w(n.value.typography.subtitle2),
        buttonTextColor: n.value.palette.getAccent600(),
        borderRadius: "8px",
        border: "none",
        buttonIconTint: n.value.palette.getAccent600(),
        padding: "8px",
        iconHeight: "20px",
        iconWidth: "20px",
        iconBackground: "transparent",
        gap: "5px",
        ...e.mentionsWarningStyle
      };
    }
    function Mi(W) {
      if (Ee.value) {
        const De = Ee.value.getBoundingClientRect();
        ((W == null ? void 0 : W.clientX) <= (De == null ? void 0 : De.left) || (W == null ? void 0 : W.clientX) >= (De == null ? void 0 : De.right) || (W == null ? void 0 : W.clientY) >= (De == null ? void 0 : De.top) || (W == null ? void 0 : W.clientY) <= (De == null ? void 0 : De.bottom)) && (B.value = !1, se.value = "");
      }
    }
    return {
      inputElementRef: J,
      sendReaction: f,
      customSendMethod: S,
      emojiButtonRef: ee,
      aiButtonRef: V,
      actionSheetRef: Ie,
      emojiButtonStyle: Lt,
      emojiKeyboardStyle: jt,
      inputRef: H,
      previewStyle: on,
      stickerKeyboardStyle: ot,
      textInputStyle: zt,
      showStickerKeyboard: L,
      showPreview: A,
      messageToBeEdited: z,
      auxiliaryView: Re,
      localize: Y,
      showSendButton: D,
      sendButton: u,
      showEmojiKeyboard: ie,
      showVoiceRecorder: Ae,
      sendButtonStyle: b,
      enableStickerKeyboard: m,
      sendMessageOnEnter: to,
      closeIconURL: wt,
      stickerButtonIconURL: Wt,
      showActionSheetItem: K,
      auxilaryPlacement: h,
      emojiPopover: O,
      inputChangeHandler: vn,
      popoverStyle: o,
      actionsheetStyle: _e,
      attachmentButtonStyle: ct,
      stickerButtonRef: Te,
      closePreview: et,
      openActionSheet: ao,
      handleActions: lo,
      messageText: ft,
      messageInputChanged: P,
      openEmojiKeyboard: so,
      appendEmoji: Ln,
      getMessageInputStyle: io,
      getAuxiliaryButtonAlignment: Fe,
      getAttachmentButtonStyle: Wn,
      getEmojiPopover: Me,
      getLiveReactionStyle: wn,
      getEmojiButtonStyle: St,
      getEmojiKeyboardStyle: Et,
      getActionsheetStyle: $n,
      getPopoverStyle: Eo,
      getStickerKeyboardStyle: oi,
      getPreviewStyle: ho,
      getAttachmentOptions: vo,
      textRef: Ue,
      getWrapperStyle: ii,
      createPollViewRef: k,
      defaultAuxiliaryOptions: Rt,
      handleComponentEvents: uo,
      getAuxiliaryButtonView: wo,
      voiceRecorderRef: ne,
      voiceRecordButtonStyle: v,
      RecordingType: Tl,
      getVoiceRecorderStyle: Qe,
      openVoiceRecorder: Rn,
      getVoiceRecorderStylePopover: ze,
      onVoiceRecordingClose: qt,
      onVoiceRecordingSubmit: Ye,
      getPrimaryViewStyle: ai,
      auxiliaryViewStyle: t,
      showAIButton: re,
      openAIOptions: ro,
      AIOptions: R,
      handleAIOptionClick: Bn,
      aiCardView: Q,
      getAiActionSheetStyle: Mo,
      getAiOptionPopoverStyle: mn,
      mentionsSearchTerm: se,
      showListForMentions: B,
      textFormatters: G,
      defaultMentionsItemClickHandler: ri,
      defaultOnEmptyForMentions: li,
      searchMentions: lt,
      userMemberWrapperConfig: Z,
      mentionsSearchCount: Oe,
      checkForMentions: Hn,
      InfoSimpleIcon: gs,
      getMentionInfoIconStyle: si,
      showMentionsCountWarning: i,
      usersRequestBuilder: q,
      groupMembersRequestBuilder: ye,
      userMemberWrapperRef: Ee,
      userMemberWrapperListType: ke
    };
  }
});
const sy = ["innerHTML"], My = ["v-slot", "v-html"], uy = {
  key: 0,
  class: "cc-messagecomposer__mentions",
  ref: "userMemberWrapperRef"
}, gy = {
  key: 1,
  class: "cc-messagecomposer__mentions-limit-exceeded"
}, cy = ["text", "iconURL", "buttonStyle"], dy = {
  key: 1,
  class: "cc-messagecomposer-wrapper__headerview"
}, Iy = ["innerHTML"], Ny = ["v-slot", "v-html"], Ty = { key: 2 }, Dy = {
  key: 0,
  class: "cc-messagecomposer-wrapper__headerview"
}, yy = ["previewStyle", "previewSubtitle"], Cy = { class: "cc-messagecomposer__input" }, wy = ["text", "textInputStyle", "placeholderText", "auxiliaryButtonAlignment", "textFormatters"], jy = { "data-slot": "secondaryView" }, Ay = ["innerHTML"], Ly = ["v-slot", "v-html"], zy = { key: 2 }, Sy = { class: "cc-messagecomposer__attachbutton" }, py = ["placement", "popoverStyle"], by = ["hideLayoutMode", "actions", "actionSheetStyle", "title"], Ey = ["hoverText", "iconURL", "buttonStyle"], hy = {
  "data-slot": "auxilaryView",
  class: "cc-messagecomposer-wrapper__auxilary"
}, vy = ["innerHTML"], my = ["v-slot", "v-html"], Oy = ["innerHTML"], xy = ["v-slot", "v-html"], ky = { class: "cc-messagecomposer__aioption" }, fy = ["placement", "popoverStyle"], Uy = ["actions", "actionSheetStyle"], By = {
  key: 1,
  slot: "content",
  style: { height: "100%" }
}, Qy = ["innerHTML"], Ry = ["v-slot", "v-html"], Yy = ["hoverText", "iconURL", "buttonStyle"], Vy = { class: "cc-messagecomposer__emojikeyboard" }, Gy = ["placement", "popoverStyle"], Py = ["emojiKeyboardStyle"], Fy = ["hoverText", "iconURL", "buttonStyle"], Hy = {
  key: 0,
  class: "cc-messagecomposer-wrapper__livereaction"
}, Zy = ["placement", "popoverStyle"], Wy = ["mediaPlayerStyle", "recordingType", "closeIconURL", "startIconURL", "stopIconURL", "submitButtonIconURL"], $y = ["iconURL", "buttonStyle", "hoverText"], Jy = {
  key: 1,
  class: "cc-messagecomposer-wrapper__livereaction"
}, Ky = ["iconURL", "hoverText", "buttonStyle"], Xy = { key: 2 }, qy = { key: 0 }, _y = ["innerHTML"], eC = ["v-slot", "v-html"], tC = {
  key: 1,
  class: "cc-messagecomposer-wrapper__sendbutton",
  ref: "sendButton"
}, nC = ["iconURL", "buttonStyle", "hoverText"];
function oC(e, t, n, o, i, l) {
  var u, s, c, d, N, T, m;
  const r = Je("CometChatUserMemberWrapper");
  return M(), g(we, null, [
    e.createPollViewRef && e.createPollViewRef.html ? (M(), g("div", {
      key: 0,
      innerHTML: e.createPollViewRef.html
    }, null, 8, sy)) : e.createPollViewRef && e.createPollViewRef.componentName ? (M(), je(fe(e.createPollViewRef.componentName), me({ key: 1 }, { ...e.createPollViewRef.props }, xe(((u = e.createPollViewRef) == null ? void 0 : u.listeners) || {})), {
      default: be(() => [
        (M(!0), g(we, null, pe(e.createPollViewRef.slots, (A, D) => (M(), g("div", {
          key: D,
          "v-slot": [D],
          "v-html": A
        }, null, 8, My))), 128))
      ]),
      _: 1
    }, 16)) : $("", !0),
    p("div", {
      class: "cc-messagecomposer-wrapper",
      style: ce(e.getWrapperStyle())
    }, [
      e.showListForMentions || e.showMentionsCountWarning ? (M(), g("div", uy, [
        e.showListForMentions ? (M(), je(r, {
          key: 0,
          userMemberListType: e.userMemberWrapperListType,
          onItemClick: e.userMemberWrapperConfig.onItemClick || e.defaultMentionsItemClickHandler,
          usersRequestBuilder: e.usersRequestBuilder,
          searchKeyword: e.mentionsSearchTerm,
          subtitleView: e.userMemberWrapperConfig.subtitleView,
          disableUsersPresence: e.userMemberWrapperConfig.disableUsersPresence,
          avatarStyle: e.userMemberWrapperConfig.avatarStyle,
          listItemView: e.userMemberWrapperConfig.listItemView,
          statusIndicatorStyle: e.userMemberWrapperConfig.statusIndicatorStyle,
          userPresencePlacement: e.userMemberWrapperConfig.userPresencePlacement,
          hideSeparator: e.userMemberWrapperConfig.hideSeparator,
          loadingStateView: e.userMemberWrapperConfig.loadingStateView,
          onEmpty: e.defaultOnEmptyForMentions,
          loadingIconUrl: e.userMemberWrapperConfig.loadingIconURL,
          group: e.group,
          groupMembersRequestBuilder: e.groupMembersRequestBuilder,
          disableLoadingState: !0,
          onError: e.defaultOnEmptyForMentions
        }, null, 8, ["userMemberListType", "onItemClick", "usersRequestBuilder", "searchKeyword", "subtitleView", "disableUsersPresence", "avatarStyle", "listItemView", "statusIndicatorStyle", "userPresencePlacement", "hideSeparator", "loadingStateView", "onEmpty", "loadingIconUrl", "group", "groupMembersRequestBuilder", "onError"])) : $("", !0),
        e.showMentionsCountWarning ? (M(), g("div", gy, [
          p("cometchat-icon-button", {
            text: e.mentionsWarningText || e.localize("MENTIONS_LIMIT_WARNING_MESSAGE"),
            iconURL: e.InfoSimpleIcon,
            buttonStyle: e.getMentionInfoIconStyle()
          }, null, 8, cy)
        ])) : $("", !0)
      ], 512)) : $("", !0),
      e.headerView ? (M(), g("div", dy, [
        e.headerView && e.headerView.html ? (M(), g("div", {
          key: 0,
          innerHTML: e.headerView.html
        }, null, 8, Iy)) : e.headerView && e.headerView.componentName ? (M(), je(fe(e.headerView.componentName), me({ key: 1 }, { ...e.headerView.props }, xe(((s = e.headerView) == null ? void 0 : s.listeners) || {})), {
          default: be(() => [
            (M(!0), g(we, null, pe(e.headerView.slots, (A, D) => (M(), g("div", {
              key: D,
              "v-slot": [D],
              "v-html": A
            }, null, 8, Ny))), 128))
          ]),
          _: 1
        }, 16)) : $("", !0)
      ])) : (M(), g("div", Ty, [
        e.showPreview ? (M(), g("div", Dy, [
          p("cometchat-preview", {
            previewStyle: e.getPreviewStyle(),
            previewSubtitle: e.checkForMentions(e.messageToBeEdited),
            onCcPreviewCloseClicked: t[0] || (t[0] = (A) => e.closePreview())
          }, null, 40, yy)
        ])) : $("", !0)
      ])),
      p("div", Cy, [
        p("cometchat-text-input", {
          onCcTextInputEntered: t[15] || (t[15] = (A) => e.sendMessageOnEnter(A)),
          ref: "inputRef",
          text: e.textRef,
          onCcTextInputChanged: t[16] || (t[16] = (A) => e.messageInputChanged(A)),
          textInputStyle: e.getMessageInputStyle(),
          placeholderText: e.placeHolderText,
          auxiliaryButtonAlignment: e.getAuxiliaryButtonAlignment(),
          textFormatters: e.textFormatters
        }, [
          p("div", jy, [
            e.secondaryButtonView && e.secondaryButtonView.html ? (M(), g("div", {
              key: 0,
              innerHTML: e.secondaryButtonView.html
            }, null, 8, Ay)) : e.secondaryButtonView && e.secondaryButtonView.componentName ? (M(), je(fe(e.secondaryButtonView.componentName), me({ key: 1 }, { ...e.secondaryButtonView.props }, xe(((c = e.secondaryButtonView) == null ? void 0 : c.listeners) || {})), {
              default: be(() => [
                (M(!0), g(we, null, pe(e.secondaryButtonView.slots, (A, D) => (M(), g("div", {
                  key: D,
                  "v-slot": [D],
                  "v-html": A
                }, null, 8, Ly))), 128))
              ]),
              _: 1
            }, 16)) : (M(), g("div", zy, [
              p("div", Sy, [
                p("cometchat-popover", {
                  placement: e.auxilaryPlacement,
                  popoverStyle: e.getPopoverStyle(),
                  onCcPopoverOutsideClicked: t[3] || (t[3] = (A) => e.showActionSheetItem = !e.showActionSheetItem)
                }, [
                  p("cometchat-action-sheet", {
                    slot: "content",
                    hideLayoutMode: e.hideLayoutMode,
                    actions: e.getAttachmentOptions(),
                    actionSheetStyle: e.getActionsheetStyle(),
                    onCcActionsheetClicked: t[1] || (t[1] = (A) => e.handleActions(A)),
                    title: e.localize("ADD_TO_CHAT")
                  }, null, 40, by),
                  p("cometchat-button", {
                    ref: "actionSheetRef",
                    hoverText: e.localize("ATTACH"),
                    slot: "children",
                    onCcButtonClicked: t[2] || (t[2] = (A) => e.openActionSheet(A)),
                    iconURL: e.showActionSheetItem ? e.closeIconURL : e.attachmentIconURL,
                    buttonStyle: e.getAttachmentButtonStyle()
                  }, null, 40, Ey)
                ], 40, py)
              ])
            ]))
          ]),
          p("div", hy, [
            e.auxiliaryButtonView && e.getAuxiliaryButtonView().html ? (M(), g("div", {
              key: 0,
              innerHTML: e.getAuxiliaryButtonView().html
            }, null, 8, vy)) : e.auxiliaryButtonView && e.getAuxiliaryButtonView().componentName ? (M(), je(fe(e.getAuxiliaryButtonView().componentName), me({ key: 1 }, {
              ...e.getAuxiliaryButtonView().props
            }, xe(((d = e.getAuxiliaryButtonView()) == null ? void 0 : d.listeners) || {})), {
              default: be(() => [
                (M(!0), g(we, null, pe(e.getAuxiliaryButtonView().slots, (A, D) => (M(), g("div", {
                  key: D,
                  "v-slot": [D],
                  "v-html": A,
                  style: { display: "flex" }
                }, null, 8, my))), 128))
              ]),
              _: 1
            }, 16)) : $("", !0),
            p("div", {
              ref: "auxiliaryView",
              style: ce(e.auxiliaryViewStyle())
            }, [
              (M(!0), g(we, null, pe(e.defaultAuxiliaryOptions && e.defaultAuxiliaryOptions.length ? e.defaultAuxiliaryOptions : [], (A, D) => (M(), g("div", { key: D }, [
                A != null && A.html ? (M(), g("div", {
                  key: 0,
                  innerHTML: A == null ? void 0 : A.html
                }, null, 8, Oy)) : (M(), je(fe(A == null ? void 0 : A.componentName), me({ key: 1 }, xe(A != null && A.listeners ? A == null ? void 0 : A.listeners : {}), {
                  componentIndex: D,
                  onComponentEvent: e.handleComponentEvents,
                  ref_for: !0
                }, { ...A == null ? void 0 : A.props }), {
                  default: be(() => [
                    (M(!0), g(we, null, pe(A == null ? void 0 : A.slots, (z, k) => (M(), g("div", {
                      key: k,
                      "v-slot": [k],
                      "v-html": z
                    }, null, 8, xy))), 128))
                  ]),
                  _: 2
                }, 1040, ["componentIndex", "onComponentEvent"]))
              ]))), 128))
            ], 4),
            p("div", ky, [
              e.AIOptions && ((N = e.AIOptions) == null ? void 0 : N.length) > 0 ? (M(), g("cometchat-popover", {
                key: 0,
                placement: e.auxilaryPlacement,
                popoverStyle: e.getAiOptionPopoverStyle(),
                onCcPopoverOutsideClicked: t[6] || (t[6] = (A) => e.showAIButton = !e.showAIButton)
              }, [
                e.aiCardView ? $("", !0) : (M(), g("cometchat-action-sheet", {
                  key: 0,
                  slot: "content",
                  hideLayoutMode: !0,
                  actions: e.AIOptions,
                  actionSheetStyle: e.getAiActionSheetStyle(),
                  onCcActionsheetClicked: t[4] || (t[4] = (A) => e.handleAIOptionClick(A))
                }, null, 40, Uy)),
                e.aiCardView ? (M(), g("div", By, [
                  e.aiCardView && e.aiCardView.html ? (M(), g("div", {
                    key: 0,
                    innerHTML: e.aiCardView.html
                  }, null, 8, Qy)) : e.aiCardView && e.aiCardView.componentName ? (M(), je(fe(e.aiCardView.componentName), me({ key: 1 }, { ...e.aiCardView.props }, xe(((T = e.aiCardView) == null ? void 0 : T.listeners) || {})), {
                    default: be(() => [
                      (M(!0), g(we, null, pe(e.aiCardView.slots, (A, D) => (M(), g("div", {
                        key: D,
                        "v-slot": [D],
                        "v-html": A
                      }, null, 8, Ry))), 128))
                    ]),
                    _: 1
                  }, 16)) : $("", !0)
                ])) : $("", !0),
                p("cometchat-button", {
                  ref: "aiButtonRef",
                  hoverText: e.localize("AI"),
                  slot: "children",
                  onCcButtonClicked: t[5] || (t[5] = (A) => e.openAIOptions()),
                  iconURL: e.showAIButton ? e.closeIconURL : e.AIIconURL,
                  buttonStyle: e.getAttachmentButtonStyle()
                }, null, 40, Yy)
              ], 40, fy)) : $("", !0)
            ]),
            p("div", Vy, [
              p("cometchat-popover", {
                placement: e.auxilaryPlacement,
                popoverStyle: e.getEmojiPopover(),
                onCcPopoverOutsideClicked: t[9] || (t[9] = (A) => e.showEmojiKeyboard = !e.showEmojiKeyboard)
              }, [
                p("cometchat-emoji-keyboard", {
                  slot: "content",
                  emojiKeyboardStyle: e.getEmojiKeyboardStyle(),
                  onCcEmojiClicked: t[7] || (t[7] = (A) => e.appendEmoji(A))
                }, null, 40, Py),
                p("cometchat-button", {
                  ref: "emojiButtonRef",
                  hoverText: e.localize("EMOJI"),
                  slot: "children",
                  onCcButtonClicked: t[8] || (t[8] = (A) => e.openEmojiKeyboard(A)),
                  iconURL: e.showEmojiKeyboard ? e.closeIconURL : e.emojiIconURL,
                  buttonStyle: e.getEmojiButtonStyle()
                }, null, 40, Fy)
              ], 40, Gy)
            ])
          ]),
          p("div", {
            "data-slot": "primaryView",
            style: ce(e.getPrimaryViewStyle())
          }, [
            e.hideVoiceRecording ? $("", !0) : (M(), g("div", Hy, [
              p("cometchat-popover", {
                placement: e.auxilaryPlacement,
                popoverStyle: e.getVoiceRecorderStylePopover(),
                closeOnOutsideClick: !1
              }, [
                e.showVoiceRecorder ? (M(), g("cometchat-media-recorder", {
                  key: 0,
                  slot: "content",
                  mediaPlayerStyle: e.getVoiceRecorderStyle(),
                  onCcMediaRecorderClosed: t[10] || (t[10] = (...A) => e.onVoiceRecordingClose && e.onVoiceRecordingClose(...A)),
                  onCcMediaRecorderSubmitted: t[11] || (t[11] = (...A) => e.onVoiceRecordingSubmit && e.onVoiceRecordingSubmit(...A)),
                  autorecording: !0,
                  recordingType: e.RecordingType.audio,
                  closeIconURL: e.voiceRecordingCloseIconURL,
                  startIconURL: e.voiceRecordingStartIconURL,
                  stopIconURL: e.voiceRecordingStopIconURL,
                  submitButtonIconURL: e.voiceRecordingSubmitIconURL,
                  startIconText: "",
                  stopIconText: "",
                  submitButtonIconText: ""
                }, null, 40, Wy)) : $("", !0),
                p("cometchat-button", {
                  ref: "voiceRecorderRef",
                  iconURL: e.showVoiceRecorder ? e.closeIconURL : e.voiceRecordingStartIconURL,
                  slot: "children",
                  buttonStyle: e.voiceRecordButtonStyle,
                  hoverText: e.localize("VOICE_RECORDING"),
                  onCcButtonClicked: t[12] || (t[12] = (A) => e.openVoiceRecorder())
                }, null, 40, $y)
              ], 8, Zy)
            ])),
            !e.hideLiveReaction && !e.showSendButton ? (M(), g("div", Jy, [
              p("cometchat-button", {
                iconURL: e.LiveReactionIconURL,
                hoverText: e.localize("LIVE_REACTION"),
                buttonStyle: e.getLiveReactionStyle(),
                onCcButtonClicked: t[13] || (t[13] = (A) => e.sendReaction())
              }, null, 40, Ky)
            ])) : e.showSendButton || e.hideLiveReaction ? (M(), g("div", Xy, [
              e.sendButtonView ? (M(), g("div", qy, [
                e.sendButtonView.html ? (M(), g("div", {
                  key: 0,
                  innerHTML: e.sendButtonView.html
                }, null, 8, _y)) : e.sendButtonView.componentName ? (M(), je(fe(e.sendButtonView.componentName), me({ key: 1 }, { ...e.sendButtonView.props }, xe(((m = e.sendButtonView) == null ? void 0 : m.listeners) || {})), {
                  default: be(() => [
                    (M(!0), g(we, null, pe(e.sendButtonView.slots, (A, D) => (M(), g("div", {
                      key: D,
                      "v-slot": [D],
                      "v-html": A
                    }, null, 8, eC))), 128))
                  ]),
                  _: 1
                }, 16)) : $("", !0)
              ])) : (M(), g("div", tC, [
                p("cometchat-button", {
                  iconURL: e.sendButtonIconURL,
                  buttonStyle: e.sendButtonStyle,
                  hoverText: e.localize("SEND_MESSAGE"),
                  onCcButtonClicked: t[14] || (t[14] = (A) => e.customSendMethod(e.messageText))
                }, null, 40, nC)
              ], 512))
            ])) : $("", !0)
          ], 4)
        ], 40, wy)
      ])
    ], 4),
    p("input", {
      class: "cc-messagecomposer-mediainput",
      ref: "inputElementRef",
      onChange: t[17] || (t[17] = (A) => e.inputChangeHandler(A))
    }, null, 544)
  ], 64);
}
const ir = /* @__PURE__ */ $e(ly, [["render", oC], ["__scopeId", "data-v-931294ca"]]), iC = We({
  name: "CometChatThreadedMessages",
  components: {
    CometChatMessageList: or,
    CometChatMessageComposer: ir,
    CometChatMessageBubble: ti
  },
  props: {
    onClose: {
      type: Function,
      default: () => {
      }
    },
    onError: {
      type: Object,
      default: (e) => {
        console.log(e);
      }
    },
    parentMessage: { type: Object },
    title: {
      type: String,
      default: () => Y("THREAD")
    },
    closeIconURL: {
      type: String,
      default: Cn
    },
    messageActionView: { type: Object },
    messageListConfiguration: {
      type: Object,
      default: () => new La({
        messageListStyle: {
          height: "100%"
        }
      })
    },
    messageComposerConfiguration: {
      type: Object,
      default: () => new za({})
    },
    threadedMessagesStyle: {
      type: Object,
      default: () => new ta({
        width: "100%",
        height: "100%",
        background: "white",
        borderRadius: "none",
        border: "1px solid rgba(20, 20, 20, 0.1)",
        titleColor: "rgba(20, 20, 20)",
        titleFont: "700 22px Inter",
        closeIconTint: "#3399FF"
      })
    },
    bubbleView: {
      type: Function
    },
    messageComposerView: {
      type: Function
    },
    messageListView: {
      type: Function
    },
    hideMessageComposer: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    }), n = j(
      new y.MessagesRequestBuilder()
    ), o = {
      textFont: e.threadedMessagesStyle.titleFont || w(t.value.typography.heading),
      textColor: e.threadedMessagesStyle.titleColor || t.value.palette.getAccent(),
      background: "transparent"
    }, i = 30, l = j(null), r = j(null), u = {
      height: "24px",
      width: "24px",
      border: "none",
      borderRadius: "0",
      background: "transparent",
      buttonIconTint: "#7dbfff"
    }, s = j({}), c, d, N, T, m, A, D, z, k, R, Q = {
      height: "100%",
      width: "100%",
      border: "none",
      borderRadius: "0",
      background: "transparent",
      buttonTextFont: w(t.value.typography.subtitle1),
      buttonTextColor: t.value.palette.getAccent600(),
      padding: "8px"
    }, h = j(null), O = e.threadedMessagesStyle, x = j(e.parentMessage);
    const _ = Ht(() => e.messageListView && (r.value || l.value) ? e.messageListView(r.value, l.value, e.parentMessage) : null), oe = Ht(() => e.messageComposerView && (r.value || l.value) ? e.messageComposerView(r.value, l.value, e.parentMessage) : null);
    n.value = new y.MessagesRequestBuilder().setCategories(Ne.getDataSource().getAllMessageCategories()).setTypes(Ne.getDataSource().getAllMessageTypes()).hideReplies(!0).setLimit(i).setParentMessageId(x == null ? void 0 : x.value.getId()), Zt(() => {
      y.getLoggedinUser().then((V) => {
        var ne, K, Ie, Te, H, Ee, L, b, v;
        V && (h.value = V, ((ne = x == null ? void 0 : x.value) == null ? void 0 : ne.getSender().getUid()) === ((K = h.value) == null ? void 0 : K.getUid()) ? ((Ie = x == null ? void 0 : x.value) == null ? void 0 : Ie.getReceiverType()) === y.RECEIVER_TYPE.USER ? r.value = (Te = x.value) == null ? void 0 : Te.getReceiver() : l.value = (H = x.value) == null ? void 0 : H.getReceiver() : ((Ee = x == null ? void 0 : x.value) == null ? void 0 : Ee.getReceiverType()) === y.RECEIVER_TYPE.USER ? r.value = (L = x == null ? void 0 : x.value) == null ? void 0 : L.getSender() : ((b = x == null ? void 0 : x.value) == null ? void 0 : b.getReceiverType()) === y.RECEIVER_TYPE.GROUP && (l.value = (v = x == null ? void 0 : x.value) == null ? void 0 : v.getReceiver()), s.value = (e == null ? void 0 : e.bubbleView) && e.bubbleView(x.value), X(), ie(), x.value.getId() != e.parentMessage.getId() && (n.value = new y.MessagesRequestBuilder().setCategories(
          Ne.getDataSource().getAllMessageCategories()
        ).setTypes(Ne.getDataSource().getAllMessageTypes()).hideReplies(!0).setLimit(i).setParentMessageId(x == null ? void 0 : x.value.getId()), x.value = e.parentMessage));
      }).catch((V) => {
        if (e.onError) {
          let ne = new y.CometChatException({
            message: V.message
          });
          e.onError(ne);
        }
      });
    }), eo(() => {
      x.value.getId() != e.parentMessage.getId() && (n.value = new y.MessagesRequestBuilder().setCategories(
        Ne.getDataSource().getAllMessageCategories()
      ).setTypes(Ne.getDataSource().getAllMessageTypes()).hideReplies(!0).setLimit(i).setParentMessageId(e.parentMessage.getId()), x.value = e.parentMessage), X(), ie();
    }), Xo(() => {
      re();
    });
    const ie = () => {
      c = ae.ccMessageSent.subscribe(
        ({ status: V, message: ne }) => {
          var K;
          V === Xe.success && (ne == null ? void 0 : ne.getParentMessageId()) === ((K = x == null ? void 0 : x.value) == null ? void 0 : K.getId()) && (x.value = ne);
        }
      ), d = ae.ccMessageEdited.subscribe(
        ({ status: V, message: ne }) => {
          var K;
          V === Xe.success && (ne == null ? void 0 : ne.getId()) === ((K = x == null ? void 0 : x.value) == null ? void 0 : K.getId()) && (x.value = ne);
        }
      ), N = ae.ccMessageDeleted.subscribe(
        (V) => {
          var ne;
          (V == null ? void 0 : V.getId()) === ((ne = x == null ? void 0 : x.value) == null ? void 0 : ne.getId()) && (x.value = V);
        }
      ), T = ae.ccMessageRead.subscribe(
        (V) => {
          var ne;
          (V == null ? void 0 : V.getId()) === ((ne = x == null ? void 0 : x.value) == null ? void 0 : ne.getId()) && (x.value = V);
        }
      ), m = ae.onMessagesDelivered.subscribe(
        (V) => {
          V.getReceiverType() == I.MessageReceiverType.user && se(V);
        }
      ), A = ae.onMessagesRead.subscribe(
        (V) => {
          V.getReceiverType() == I.MessageReceiverType.user && se(V);
        }
      ), k = ae.onMessagesReadByAll.subscribe(
        (V) => {
          se(V);
        }
      ), R = ae.onMessagesDeliveredToAll.subscribe(
        (V) => {
          se(V);
        }
      ), D = ae.onMessageDeleted.subscribe(
        (V) => {
          Ae(V);
        }
      ), z = ae.onMessageEdited.subscribe(
        (V) => {
          Ae(V);
        }
      );
    }, re = () => {
      c == null || c.unsubscribe(), d == null || d.unsubscribe(), N == null || N.unsubscribe(), T == null || T.unsubscribe(), m == null || m.unsubscribe(), A == null || A.unsubscribe(), D == null || D.unsubscribe(), z == null || z.unsubscribe(), k == null || k.unsubscribe(), R == null || R.unsubscribe();
    }, Ae = (V) => {
      var ne;
      ((ne = x == null ? void 0 : x.value) == null ? void 0 : ne.getId()) == V.getId() && (x.value = V, s.value = e.bubbleView(
        x.value
      ));
    }, se = (V) => {
      var ne;
      Number(V == null ? void 0 : V.getMessageId()) == ((ne = x == null ? void 0 : x.value) == null ? void 0 : ne.getId()) && (V.getReadAt() ? x.value.setReadAt(V.getReadAt()) : V.getDeliveredAt() && x.value.setDeliveredAt(
        V.getDeliveredAt()
      ), s.value = e.bubbleView(
        x.value
      ));
    }, X = () => {
      B(), u.buttonIconTint = O.closeIconTint || t.value.palette.getPrimary(), Q.background = t.value.palette.getBackground(), Q.buttonTextFont = w(
        t.value.typography.subtitle1
      ), Q.buttonTextColor = t.value.palette.getAccent600(), o = {
        textFont: O.titleFont || w(t.value.typography.title1),
        textColor: O.titleColor || t.value.palette.getAccent(),
        background: "transparent"
      };
    }, B = () => {
      O = {
        ...new ta({
          width: "100%",
          height: "100%",
          background: t.value.palette.getBackground(),
          borderRadius: "none",
          border: "none",
          titleColor: t.value.palette.getAccent(),
          titleFont: w(t.value.typography.title1),
          closeIconTint: t.value.palette.getPrimary()
        }),
        ...O
      };
    };
    return {
      getMessageListStyle: () => ({
        ...e.messageListConfiguration.messageListStyle.height ? { height: e.messageListConfiguration.messageListStyle.height } : { height: "100%" },
        ...e.messageListConfiguration
      }),
      titleStyle: o,
      buttonStyle: u,
      actionButtonStyle: Q,
      closeView: () => {
        e.onClose && e.onClose();
      },
      getThreadCount: () => {
        var K;
        const V = ((K = x == null ? void 0 : x.value) == null ? void 0 : K.getReplyCount()) || 0, ne = V === 1 ? Y("REPLY") : Y("REPLIES");
        return `${V} ${ne}`;
      },
      requestBuilder: n,
      group: l,
      user: r,
      wrapperStyle: () => ({
        background: O.background || t.value.palette.getBackground(),
        height: O.height,
        width: O.width,
        border: O.border,
        borderRadius: O.borderRadius
      }),
      componentDefinition: s,
      messageListViewComputed: _,
      messageComposerViewComputed: oe
    };
  }
});
const aC = { class: "cc-threadedmessages-wrapper__header" }, rC = { class: "cc-threadedmessages-wrapper__title" }, lC = ["text", "labelStyle"], sC = { class: "cc-threadedmessages-wrapper__close" }, MC = ["iconURL", "buttonStyle"], uC = { class: "cc-threadedmessages-wrapper__bubbleview" }, gC = ["innerHTML"], cC = ["v-slot", "v-html"], dC = { class: "cc__threadedmessages__actionview" }, IC = ["text", "buttonStyle"], NC = ["innerHTML"], TC = { class: "cc-threadedmessages-wrapper__list" }, DC = { key: 0 }, yC = ["innerHTML"], CC = ["v-slot", "v-html"], wC = {
  key: 0,
  class: "cc-threadedmessages-wrapper__composer"
}, jC = { key: 0 }, AC = ["innerHTML"], LC = ["v-slot", "v-html"];
function zC(e, t, n, o, i, l) {
  var s, c, d, N, T, m, A, D, z, k, R, Q, h, O, x, _, oe, ie, re, Ae, se, X, B, F, G, J, ee, V, ne, K, Ie, Te, H, Ee, L, b, v, U, Se, Ue, Re, _e, Z, ke, q, ye, Oe, he, Pe;
  const r = Je("CometChatMessageList"), u = Je("CometChatMessageComposer");
  return M(), g("div", {
    class: "cc-threadedmessages-wrapper",
    style: ce(e.wrapperStyle())
  }, [
    p("div", aC, [
      p("div", rC, [
        p("cometchat-label", {
          text: e.title,
          labelStyle: e.titleStyle
        }, null, 8, lC)
      ]),
      p("div", sC, [
        p("cometchat-button", {
          iconURL: e.closeIconURL,
          buttonStyle: e.buttonStyle,
          onCcButtonClicked: t[0] || (t[0] = (...lt) => e.closeView && e.closeView(...lt))
        }, null, 40, MC)
      ])
    ]),
    p("div", {
      class: "cc-threaded_message_main_wrapper",
      style: ce("height: calc(100% - " + (e.hideMessageComposer ? 0 : ((c = (s = e.messageComposerConfiguration) == null ? void 0 : s.messageComposerStyle) == null ? void 0 : c.height) || 156) + "px)")
    }, [
      p("div", uC, [
        p("div", null, [
          (d = e.componentDefinition) != null && d.html ? (M(), g("div", {
            key: 0,
            innerHTML: (N = e.componentDefinition) == null ? void 0 : N.html
          }, null, 8, gC)) : (M(), je(fe((T = e.componentDefinition) == null ? void 0 : T.componentName), me({ key: 1 }, { ...(m = e.componentDefinition) == null ? void 0 : m.props }, xe({ ...(A = e.componentDefinition) == null ? void 0 : A.listeners })), {
            default: be(() => [
              (M(!0), g(we, null, pe(e.componentDefinition.slots, (lt, It) => (M(), g("div", {
                key: It,
                "v-slot": [It],
                "v-html": lt
              }, null, 8, cC))), 128))
            ]),
            _: 1
          }, 16))
        ])
      ]),
      p("div", dC, [
        e.messageActionView ? (M(), g("div", {
          key: 1,
          innerHTML: e.messageActionView.html
        }, null, 8, NC)) : (M(), g("cometchat-button", {
          key: 0,
          text: e.getThreadCount(),
          buttonStyle: e.actionButtonStyle
        }, null, 8, IC))
      ]),
      p("div", TC, [
        e.messageListViewComputed ? (M(), g("div", DC, [
          (D = e.messageListViewComputed) != null && D.html ? (M(), g("div", {
            key: 0,
            innerHTML: (z = e.messageListViewComputed) == null ? void 0 : z.html
          }, null, 8, yC)) : (M(), je(fe(e.messageListViewComputed.componentName), me({ key: 1 }, { ...e.messageListViewComputed.props }, xe(e.messageListViewComputed.listeners)), {
            default: be(() => [
              (M(!0), g(we, null, pe(e.messageListViewComputed.slots, (lt, It) => (M(), g("div", {
                key: It,
                "v-slot": [It],
                "v-html": lt
              }, null, 8, CC))), 128))
            ]),
            _: 1
          }, 16))
        ])) : (M(), je(r, {
          key: 1,
          parentMessageId: Number((k = e.parentMessage) == null ? void 0 : k.getId()),
          emptyStateView: e.messageListConfiguration.emptyStateView,
          loadingStateView: e.messageListConfiguration.loadingStateView,
          user: e.user,
          errorStateView: e.messageListConfiguration.errorStateView,
          disableReceipt: e.messageListConfiguration.disableReceipt,
          hideReceipt: e.messageListConfiguration.hideReceipt,
          readIcon: e.messageListConfiguration.readIcon,
          deliveredIcon: e.messageListConfiguration.deliveredIcon,
          sentIcon: e.messageListConfiguration.sentIcon,
          waitIcon: e.messageListConfiguration.waitIcon,
          errorIcon: e.messageListConfiguration.errorIcon,
          alignment: e.messageListConfiguration.alignment,
          showAvatar: e.messageListConfiguration.showAvatar,
          datePattern: e.messageListConfiguration.datePattern,
          timestampAlignment: e.messageListConfiguration.timestampAlignment,
          DateSeparatorPattern: e.messageListConfiguration.DateSeparatorPattern,
          templates: e.messageListConfiguration.templates,
          messagesRequestBuilder: e.messageListConfiguration.messagesRequestBuilder || e.requestBuilder,
          thresholdValue: e.messageListConfiguration.thresholdValue,
          onThreadRepliesClick: e.messageListConfiguration.onThreadRepliesClick,
          headerView: e.messageListConfiguration.headerView,
          footerView: e.messageListConfiguration.footerView,
          avatarStyle: e.messageListConfiguration.avatarStyle,
          dateSeparatorStyle: e.messageListConfiguration.dateSeparatorStyle,
          messageListStyle: e.getMessageListStyle(),
          onError: e.messageListConfiguration.onError,
          group: e.group,
          reactionsConfiguration: (R = e.messageListConfiguration) == null ? void 0 : R.reactionsConfiguration,
          disableReactions: (Q = e.messageListConfiguration) == null ? void 0 : Q.disableReactions,
          emojiKeyboardStyle: (h = e.messageListConfiguration) == null ? void 0 : h.emojiKeyboardStyle,
          threadIndicatorIcon: (O = e.messageListConfiguration) == null ? void 0 : O.threadIndicatorIcon,
          disableMentions: (x = e.messageListConfiguration) == null ? void 0 : x.disableMentions,
          textFormatters: (_ = e.messageListConfiguration) == null ? void 0 : _.textFormatters,
          backdropStyle: (oe = e.messageListConfiguration) == null ? void 0 : oe.backdropStyle,
          loadingIconURL: (ie = e.messageListConfiguration) == null ? void 0 : ie.loadingIconURL
        }, null, 8, ["parentMessageId", "emptyStateView", "loadingStateView", "user", "errorStateView", "disableReceipt", "hideReceipt", "readIcon", "deliveredIcon", "sentIcon", "waitIcon", "errorIcon", "alignment", "showAvatar", "datePattern", "timestampAlignment", "DateSeparatorPattern", "templates", "messagesRequestBuilder", "thresholdValue", "onThreadRepliesClick", "headerView", "footerView", "avatarStyle", "dateSeparatorStyle", "messageListStyle", "onError", "group", "reactionsConfiguration", "disableReactions", "emojiKeyboardStyle", "threadIndicatorIcon", "disableMentions", "textFormatters", "backdropStyle", "loadingIconURL"]))
      ])
    ], 4),
    e.hideMessageComposer ? $("", !0) : (M(), g("div", wC, [
      e.messageComposerViewComputed ? (M(), g("div", jC, [
        e.messageComposerViewComputed.html ? (M(), g("div", {
          key: 0,
          innerHTML: e.messageComposerViewComputed.html
        }, null, 8, AC)) : (M(), je(fe(e.messageComposerViewComputed.componentName), me({ key: 1 }, { ...e.messageComposerViewComputed.props }, xe(e.messageComposerViewComputed.listeners)), {
          default: be(() => [
            (M(!0), g(we, null, pe(e.messageComposerViewComputed.slots, (lt, It) => (M(), g("div", {
              key: It,
              "v-slot": [It],
              "v-html": lt
            }, null, 8, LC))), 128))
          ]),
          _: 1
        }, 16))
      ])) : (M(), je(u, {
        key: 1,
        ref: "messageComposerRef",
        parentMessageId: Number((re = e.parentMessage) == null ? void 0 : re.getId()),
        user: e.user,
        group: e.group,
        text: (Ae = e.messageComposerConfiguration) == null ? void 0 : Ae.text,
        headerView: (se = e.messageComposerConfiguration) == null ? void 0 : se.headerView,
        onTextChange: (X = e.messageComposerConfiguration) == null ? void 0 : X.onTextChange,
        attachmentIconURL: (B = e.messageComposerConfiguration) == null ? void 0 : B.attachmentIconURL,
        attachmentOptions: (F = e.messageComposerConfiguration) == null ? void 0 : F.attachmentOptions,
        secondaryButtonView: (G = e.messageComposerConfiguration) == null ? void 0 : G.secondaryButtonView,
        auxiliaryButtonView: (J = e.messageComposerConfiguration) == null ? void 0 : J.auxilaryButtonView,
        auxiliaryButtonsAlignment: (ee = e.messageComposerConfiguration) == null ? void 0 : ee.auxiliaryButtonsAlignment,
        sendButtonView: (V = e.messageComposerConfiguration) == null ? void 0 : V.sendButtonView,
        hideLiveReaction: (ne = e.messageComposerConfiguration) == null ? void 0 : ne.hideLiveReaction,
        LiveReactionIconURL: (K = e.messageComposerConfiguration) == null ? void 0 : K.LiveReactionIconURL,
        messageComposerStyle: (Ie = e.messageComposerConfiguration) == null ? void 0 : Ie.messageComposerStyle,
        hideLayoutMode: (Te = e.messageComposerConfiguration) == null ? void 0 : Te.hideLayoutMode,
        actionSheetStyle: (H = e.messageComposerConfiguration) == null ? void 0 : H.actionSheetStyle,
        AIOptionsStyle: (Ee = e.messageComposerConfiguration) == null ? void 0 : Ee.AIOptionsStyle,
        AIIconURL: e.messageComposerConfiguration.AIIconURL,
        onSendButtonClick: (L = e.messageComposerConfiguration) == null ? void 0 : L.onSendButtonClick,
        onError: (b = e.messageComposerConfiguration) == null ? void 0 : b.onError,
        hideVoiceRecording: (v = e.messageComposerConfiguration) == null ? void 0 : v.hideVoiceRecording,
        voiceRecordingStartIconURL: (U = e.messageComposerConfiguration) == null ? void 0 : U.voiceRecordingStartIconURL,
        voiceRecordingCloseIconURL: (Se = e.messageComposerConfiguration) == null ? void 0 : Se.voiceRecordingCloseIconURL,
        voiceRecordingStopIconURL: (Ue = e.messageComposerConfiguration) == null ? void 0 : Ue.voiceRecordingStopIconURL,
        voiceRecordingSubmitIconURL: (Re = e.messageComposerConfiguration) == null ? void 0 : Re.voiceRecordingSubmitIconURL,
        userMemberWrapperConfiguration: (_e = e.messageComposerConfiguration) == null ? void 0 : _e.userMemberWrapperConfiguration,
        textFormatters: (Z = e.messageComposerConfiguration) == null ? void 0 : Z.textFormatters,
        disableMentions: (ke = e.messageComposerConfiguration) == null ? void 0 : ke.disableMentions,
        mentionsWarningText: (q = e.messageComposerConfiguration) == null ? void 0 : q.mentionsWarningText,
        mentionsWarningStyle: (ye = e.messageComposerConfiguration) == null ? void 0 : ye.mentionsWarningStyle,
        sendButtonIconURL: (Oe = e.messageComposerConfiguration) == null ? void 0 : Oe.sendButtonIconURL,
        mediaRecorderStyle: (he = e.messageComposerConfiguration) == null ? void 0 : he.mediaRecorderStyle,
        emojiIconURL: (Pe = e.messageComposerConfiguration) == null ? void 0 : Pe.emojiIconURL
      }, null, 8, ["parentMessageId", "user", "group", "text", "headerView", "onTextChange", "attachmentIconURL", "attachmentOptions", "secondaryButtonView", "auxiliaryButtonView", "auxiliaryButtonsAlignment", "sendButtonView", "hideLiveReaction", "LiveReactionIconURL", "messageComposerStyle", "hideLayoutMode", "actionSheetStyle", "AIOptionsStyle", "AIIconURL", "onSendButtonClick", "onError", "hideVoiceRecording", "voiceRecordingStartIconURL", "voiceRecordingCloseIconURL", "voiceRecordingStopIconURL", "voiceRecordingSubmitIconURL", "userMemberWrapperConfiguration", "textFormatters", "disableMentions", "mentionsWarningText", "mentionsWarningStyle", "sendButtonIconURL", "mediaRecorderStyle", "emojiIconURL"]))
    ]))
  ], 4);
}
const SC = /* @__PURE__ */ $e(iC, [["render", zC], ["__scopeId", "data-v-8f8bcec3"]]), pC = () => ({
  width: "fit-content",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: "12px"
}), bC = We({
  name: "CometChatMessageHeader",
  components: { CometChatTextBubble: hl, CometChatCallButtons: tr },
  props: {
    avatarStyle: {
      type: Object,
      default: () => ({})
    },
    statusIndicatorStyle: {
      type: Object,
      default: () => ({})
    },
    messageHeaderStyle: {
      type: Object,
      default: () => new Ni({})
    },
    listItemStyle: { type: Object },
    subtitleView: { type: Function },
    disableUsersPresence: { type: Boolean, default: !1 },
    disableTyping: { type: Boolean, default: !1 },
    protectedGroupIcon: { type: String, default: Yo },
    privateGroupIcon: { type: String, default: Vo },
    menu: { type: Array },
    user: { type: Object },
    group: { type: Object },
    backButtonIconURL: { type: String, default: fn },
    hideBackButton: { type: Boolean, default: !1 },
    listItemView: { type: Object },
    onError: {
      type: Function,
      default: (e) => {
        console.log(e);
      }
    },
    onBack: {
      type: Function,
      default: () => {
      }
    }
  },
  setup(e) {
    let t = j(""), { theme: n } = dt("theme", {
      theme: j(new Ke({}))
    }), o = {
      width: "100%",
      height: "100%",
      borderRadius: "0",
      background: "transparent",
      border: "none",
      onlineStatusColor: n.value.palette.getSuccess(),
      privateGroupIconBackground: n.value.palette.getSuccess(),
      passwordGroupIconBackground: "RGB(247, 165, 0)",
      backButtonIconTint: n.value.palette.getPrimary(),
      subtitleTextColor: n.value.palette.getAccent600(),
      subtitleTextFont: w(n.value.typography.subtitle2),
      typingIndicatorTextColor: n.value.palette.getPrimary(),
      typingIndicatorTextFont: w(n.value.typography.subtitle1)
    }, i = bi({
      online: n.value.palette.getSuccess(),
      offline: n.value.palette.getAccent800(),
      private: "#00f300",
      password: "#F7A500",
      public: ""
    }), l = "groupsList_" + (/* @__PURE__ */ new Date()).getTime(), r = "userlist_" + (/* @__PURE__ */ new Date()).getTime();
    const u = j("connection_" + (/* @__PURE__ */ new Date()).getTime());
    let s = j(e.group), c = j(e.user), d, N = !1, T, m, A, D, z, k, R, Q, h, O, x = j(e.listItemStyle);
    Zt(async () => {
      var L;
      e.user ? (c.value = e.user, s.value = null) : (s.value = e.group, c.value = null), d ? (K(), G()) : await y.getLoggedinUser().then((b) => {
        b && (d = b, K(), G());
      }).catch((b) => {
        if (e.onError) {
          let v = new y.CometChatException({
            message: b.message
          });
          e.onError(v);
        }
      }), K(), i.online = (L = e.messageHeaderStyle) != null && L.onlineStatusColor ? e.messageHeaderStyle.onlineStatusColor : o != null && o.onlineStatusColor ? o == null ? void 0 : o.onlineStatusColor : i.online;
    }), bn(() => e.user, (L) => {
      L && (c.value = L, s.value = null, K());
    }), bn(() => e.group, (L) => {
      L && (s.value = L, c.value = null, K());
    }), eo(async () => {
      var L, b, v, U;
      Ae(), (((L = c == null ? void 0 : c.value) == null ? void 0 : L.getUid()) != ((b = e.user) == null ? void 0 : b.getUid()) || ((v = s.value) == null ? void 0 : v.getGuid()) != ((U = e.group) == null ? void 0 : U.getGuid())) && (J(), d ? (G(), K()) : await y.getLoggedinUser().then((Se) => {
        Se && (d = Se, G(), K());
      }).catch((Se) => {
        if (e.onError) {
          let Ue = new y.CometChatException({
            message: Se.message
          });
          e.onError(Ue);
        }
      }));
    }), un(() => {
    });
    let _ = new _t({
      height: "45px",
      width: "100%",
      background: "transparent",
      activeBackground: "transparent",
      borderRadius: "0",
      titleFont: w(n.value.typography.title2),
      titleColor: n.value.palette.getAccent(),
      border: "none",
      separatorColor: "",
      hoverBackground: "transparent"
    });
    x.value = { ..._, ...x.value };
    const oe = () => {
      let L = {
        borderRadius: "24px",
        width: "36px",
        height: "36px",
        border: "none",
        backgroundColor: n.value.palette.getAccent700(),
        nameTextColor: n.value.palette.getAccent900(),
        backgroundSize: "cover",
        nameTextFont: w(n.value.typography.subtitle1),
        outerViewBorderWidth: "",
        outerViewBorderSpacing: ""
      };
      return { ...e.avatarStyle, ...L };
    }, ie = () => {
      var b;
      let L = {
        height: "12px",
        width: "12px",
        border: "none",
        borderRadius: "24px"
      };
      return ((b = c == null ? void 0 : c.value) == null ? void 0 : b.getStatus()) === "offline" && (L.background = "transparent"), {
        ...L,
        ...e.statusIndicatorStyle
      };
    }, re = () => ({ ...new Ni({
      background: n.value.palette.getBackground(),
      border: "none",
      onlineStatusColor: n.value.palette.getSuccess(),
      privateGroupIconBackground: n.value.palette.getSuccess(),
      passwordGroupIconBackground: "RGB(247, 165, 0)",
      backButtonIconTint: n.value.palette.getPrimary(),
      subtitleTextColor: n.value.palette.getAccent600(),
      subtitleTextFont: w(n.value.typography.subtitle2),
      typingIndicatorTextColor: n.value.palette.getPrimary(),
      typingIndicatorTextFont: w(n.value.typography.subtitle1)
    }), ...e.messageHeaderStyle }), Ae = () => {
      T = He.ccGroupMemberAdded.subscribe(
        (L) => {
          var b;
          s.value && ((b = s.value) == null ? void 0 : b.getGuid()) == (L == null ? void 0 : L.userAddedIn.getGuid()) && (s.value = Ce.clone(
            L == null ? void 0 : L.userAddedIn
          ), K());
        }
      ), z = He.ccGroupMemberBanned.subscribe(
        (L) => {
          var b;
          s.value && ((b = s.value) == null ? void 0 : b.getGuid()) == (L == null ? void 0 : L.kickedFrom.getGuid()) && K(L == null ? void 0 : L.kickedFrom);
        }
      ), A = He.ccGroupMemberJoined.subscribe(
        (L) => {
          var b;
          s.value && ((b = s.value) == null ? void 0 : b.getGuid()) == (L == null ? void 0 : L.joinedGroup.getGuid()) && (s.value = Ce.clone(
            L == null ? void 0 : L.joinedGroup
          ), K());
        }
      ), D = He.ccGroupMemberKicked.subscribe(
        (L) => {
          var b;
          s.value && ((b = s.value) == null ? void 0 : b.getGuid()) == (L == null ? void 0 : L.kickedFrom.getGuid()) && (s.value = Ce.clone(
            L == null ? void 0 : L.kickedFrom
          ), K());
        }
      ), k = He.ccOwnershipChanged.subscribe(
        (L) => {
          var b;
          s.value && ((b = s.value) == null ? void 0 : b.getGuid()) == (L == null ? void 0 : L.group.getGuid()) && (s.value = L == null ? void 0 : L.group, s.value = Ce.clone(
            L == null ? void 0 : L.group
          ), K());
        }
      ), m = He.ccGroupLeft.subscribe(
        (L) => {
          var b, v;
          s.value && ((b = s.value) == null ? void 0 : b.getGuid()) == (L == null ? void 0 : L.leftGroup.getGuid()) && (d == null ? void 0 : d.getUid()) == ((v = L == null ? void 0 : L.userLeft) == null ? void 0 : v.getUid()) && (s.value = Ce.clone(
            L == null ? void 0 : L.leftGroup
          ), K());
        }
      ), e.disableTyping || X();
    }, se = () => {
      T == null || T.unsubscribe(), z == null || z.unsubscribe(), A == null || A.unsubscribe(), D == null || D.unsubscribe(), k == null || k.unsubscribe(), m == null || m.unsubscribe(), R == null || R.unsubscribe(), Q == null || Q.unsubscribe(), h == null || h.unsubscribe(), O == null || O.unsubscribe();
    }, X = () => {
      h = ae.onTypingStarted.subscribe((L) => {
        N = !0, V(L);
      }), O = ae.onTypingEnded.subscribe(() => {
        N = !1, K();
      });
    }, B = () => {
      e.onBack && e.onBack();
    }, F = (L, b, v, U) => {
      L.getGuid() === s.value.getGuid() && (b.getUid() === d.getUid() && (L.setHasJoined(v), U && L.setScope(U)), s.value = L, K());
    }, G = () => {
      try {
        e.disableUsersPresence || y.addUserListener(
          r,
          new y.UserListener({
            onUserOnline: (L) => {
              ee(L);
            },
            onUserOffline: (L) => {
              ee(L);
            }
          })
        ), c.value && (R = En.ccUserBlocked.subscribe(
          (L) => {
            L.getUid() == c.value.getUid() && ee(L);
          }
        ), Q = En.ccUserUnblocked.subscribe(
          (L) => {
            L.getUid() == c.value.getUid() && ee(L);
          }
        )), y.addGroupListener(
          l,
          new y.GroupListener({
            onGroupMemberScopeChanged: (L, b, v, U, Se) => {
              F(Se, b, !0, v);
            },
            onGroupMemberKicked: (L, b, v, U) => {
              F(U, b, !1);
            },
            onMemberAddedToGroup: (L, b, v, U) => {
              F(U, b, !0);
            },
            onGroupMemberBanned: (L, b, v, U) => {
              F(U, b, !0);
            },
            onGroupMemberLeft: (L, b, v) => {
              F(v, b, !1);
            },
            onGroupMemberJoined: (L, b, v) => {
              F(v, b, !0);
            }
          })
        ), y.addConnectionListener(u.value, new y.ConnectionListener({
          onConnected: () => {
            e.user ? y.getUser(e.user.getUid()).then((L) => {
              c.value = L;
            }) : e.group && y.getGroup(e.group.getGuid()).then((L) => {
              s.value = L;
            });
          }
        }));
      } catch (L) {
        if (e.onError) {
          let b = new y.CometChatException({
            message: L.message
          });
          e.onError(b);
        }
      }
    }, J = () => {
      y.removeUserListener(r), y.removeConnectionListener(u.value);
    }, ee = (L) => {
      var b, v, U;
      c.value && ((b = c.value) != null && b.getUid()) && ((v = c.value) == null ? void 0 : v.getUid()) === L.getUid() && ((U = c.value) == null || U.setStatus(L.getStatus()), K());
    }, V = (L) => {
      var Se, Ue, Re, _e;
      const b = L.getSender(), v = L.getReceiverId(), U = d;
      if (c.value && b.getUid() === ((Se = c == null ? void 0 : c.value) == null ? void 0 : Se.getUid()) && (U == null ? void 0 : U.getUid()) === v) {
        if (((Ue = c.value) == null ? void 0 : Ue.getBlockedByMe()) || ((Re = c.value) == null ? void 0 : Re.getHasBlockedMe()))
          return;
        t.value = Y("IS_TYPING");
      }
      s.value && ((_e = s == null ? void 0 : s.value) == null ? void 0 : _e.getGuid()) === v && (t.value = `${b == null ? void 0 : b.getName()} ${Y("IS_TYPING")}`);
    }, ne = () => {
      var L, b;
      return c.value ? new co().getUserStatusVisibility(c.value) || e.disableUsersPresence ? null : i[(L = c == null ? void 0 : c.value) == null ? void 0 : L.getStatus()] : s != null && s.value ? i[(b = s == null ? void 0 : s.value) == null ? void 0 : b.getType()] : void 0;
    }, K = (L) => {
      var U, Se;
      L && (s.value = L);
      const b = (U = s.value) == null ? void 0 : U.getMembersCount(), v = Y(b > 1 ? "MEMBERS" : "MEMBER");
      t.value = c.value ? c.value.getHasBlockedMe() || c.value.getBlockedByMe() ? null : (Se = c == null ? void 0 : c.value) == null ? void 0 : Se.getStatus() : `${b} ${v}`;
    };
    return {
      getBackButtonStyle: () => {
        var b;
        return {
          height: "24px",
          width: "24px",
          border: "none",
          borderRadius: "none",
          background: "transparent",
          buttonIconTint: ((b = e.messageHeaderStyle) == null ? void 0 : b.backButtonIconTint) || (o == null ? void 0 : o.backButtonIconTint)
        };
      },
      checkStatusType: ne,
      checkGroupType: () => {
        var b;
        let L = "";
        if (s.value)
          switch ((b = s.value) == null ? void 0 : b.getType()) {
            case I.GroupTypes.password:
              L = e.protectedGroupIcon;
              break;
            case I.GroupTypes.private:
              L = e.privateGroupIcon;
              break;
            default:
              L = "";
              break;
          }
        return L;
      },
      headerStyle: () => {
        var L, b, v, U, Se;
        return {
          width: ((L = e.messageHeaderStyle) == null ? void 0 : L.width) || o.width,
          height: ((b = e.messageHeaderStyle) == null ? void 0 : b.height) || o.height,
          border: ((v = e.messageHeaderStyle) == null ? void 0 : v.border) || o.border,
          borderRadius: ((U = e.messageHeaderStyle) == null ? void 0 : U.borderRadius) || o.borderRadius,
          background: ((Se = e.messageHeaderStyle) == null ? void 0 : Se.background) || o.background,
          padding: "10px",
          boxSizing: "border-box"
        };
      },
      subtitleText: t,
      subtitleStyle: () => {
        var L, b, v, U, Se;
        return e.user && e.user.getStatus() == I.userStatusType.online ? {
          textFont: ((L = e.messageHeaderStyle) == null ? void 0 : L.subtitleTextFont) || o.subtitleTextFont,
          textColor: n.value.palette.getPrimary()
        } : {
          textFont: N ? ((b = e.messageHeaderStyle) == null ? void 0 : b.typingIndicatorTextFont) || (o == null ? void 0 : o.typingIndicatorTextFont) : ((v = e.messageHeaderStyle) == null ? void 0 : v.subtitleTextFont) || (o == null ? void 0 : o.subtitleTextFont),
          textColor: N ? ((U = e.messageHeaderStyle) == null ? void 0 : U.typingIndicatorTextColor) || (o == null ? void 0 : o.typingIndicatorTextColor) : ((Se = e.messageHeaderStyle) == null ? void 0 : Se.subtitleTextColor) || (o == null ? void 0 : o.subtitleTextColor)
        };
      },
      MessageHeaderMenuStyle: pC,
      onBackClicked: B,
      theme: n,
      fontHelper: w,
      currentUser: c,
      currentGroup: s,
      getHeadersStyle: re,
      getStatusStyle: ie,
      getAvatarStyles: oe,
      listItemStyleRef: x
    };
  }
});
const EC = { class: "cc-messageheader" }, hC = {
  key: 0,
  class: "cc-messageheader__backbutton"
}, vC = ["iconURL", "buttonStyle"], mC = { class: "cc-messageheader__listitem" }, OC = { key: 0 }, xC = ["innerHTML"], kC = ["v-slot", "v-html"], fC = ["avatarName", "avatarURL", "listItemStyle", "statusIndicatorColor", "statusIndicatorIcon", "title", "statusIndicatorStyle", "avatarStyle"], UC = { slot: "subtitleView" }, BC = ["innerHTML"], QC = { key: 1 }, RC = ["text", "labelStyle"], YC = {
  key: 0,
  class: "cc-messageheader__menu"
}, VC = ["innerHTML"];
function GC(e, t, n, o, i, l) {
  var r, u, s, c, d, N, T, m;
  return M(), g("div", {
    class: "cc-messageheader__wrapper",
    style: ce(e.headerStyle())
  }, [
    p("div", EC, [
      e.hideBackButton ? $("", !0) : (M(), g("div", hC, [
        p("cometchat-button", {
          iconURL: e.backButtonIconURL,
          buttonStyle: e.getBackButtonStyle(),
          onCcButtonClicked: t[0] || (t[0] = (A) => e.onBackClicked())
        }, null, 40, vC)
      ])),
      p("div", mC, [
        e.listItemView ? (M(), g("div", OC, [
          e.listItemView.html ? (M(), g("div", {
            key: 0,
            innerHTML: e.listItemView.html
          }, null, 8, xC)) : (M(), je(fe(e.listItemView.componentName), me({ key: 1 }, { ...e.listItemView.props }, xe((r = e.listItemView) != null && r.listeners ? (u = e.listItemView) == null ? void 0 : u.listeners : {})), {
            default: be(() => [
              (M(!0), g(we, null, pe(e.listItemView.slots, (A, D) => (M(), g("div", {
                key: D,
                "v-slot": [D],
                "v-html": A
              }, null, 8, kC))), 128))
            ]),
            _: 1
          }, 16))
        ])) : (M(), g("cometchat-list-item", {
          key: 1,
          avatarName: ((s = e.currentUser) == null ? void 0 : s.getName()) || ((c = e.currentGroup) == null ? void 0 : c.getName()),
          avatarURL: ((d = e.currentUser) == null ? void 0 : d.getAvatar()) || ((N = e.currentGroup) == null ? void 0 : N.getIcon()),
          listItemStyle: e.listItemStyleRef,
          statusIndicatorColor: e.checkStatusType(),
          statusIndicatorIcon: e.checkGroupType(),
          title: ((T = e.currentUser) == null ? void 0 : T.getName()) || ((m = e.currentGroup) == null ? void 0 : m.getName()),
          hideSeparator: !0,
          statusIndicatorStyle: e.getStatusStyle(),
          avatarStyle: e.getAvatarStyles()
        }, [
          p("div", UC, [
            e.subtitleView ? (M(), g("div", {
              key: 0,
              innerHTML: e.subtitleView
            }, null, 8, BC)) : (M(), g("div", QC, [
              p("cometchat-label", {
                text: e.subtitleText,
                labelStyle: e.subtitleStyle()
              }, null, 8, RC)
            ]))
          ])
        ], 8, fC))
      ])
    ]),
    e.menu && e.menu.length ? (M(), g("div", YC, [
      (M(!0), g(we, null, pe(e.menu, (A, D) => (M(), g("div", { key: D }, [
        A.html ? (M(), g("div", {
          key: 0,
          innerHTML: A.html
        }, null, 8, VC)) : (M(), je(fe(A.componentName), me({ key: 1 }, xe(A.listeners ? A.listeners : {}), { ref_for: !0 }, { ...A.props }), null, 16))
      ]))), 128))
    ])) : $("", !0)
  ], 4);
}
const ar = /* @__PURE__ */ $e(bC, [["render", GC], ["__scopeId", "data-v-2156478b"]]), PC = We({
  components: {
    CometChatGroupMembers: ki
  },
  props: {
    group: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      default: () => Y("TRANSFER_OWNERSHIP")
    },
    transferButtonText: {
      type: String,
      default: () => Y("TRANSFER_OWNERSHIP")
    },
    cancelButtonText: {
      type: String,
      default: () => Y("CANCEL")
    },
    titleAlignment: {
      type: Number,
      default: () => kn.center
    },
    subtitleView: {
      type: Function
    },
    options: {
      type: Function
    },
    disableUsersPresence: {
      type: Boolean,
      default: !1
    },
    hideSeparator: {
      type: Boolean,
      default: !1
    },
    searchPlaceholderText: {
      type: String,
      default: () => Y("SEARCH")
    },
    searchIconURL: {
      type: String,
      default: Yn
    },
    hideSearch: {
      type: Boolean,
      default: !1
    },
    listItemStyle: {
      type: Object,
      default: () => ({})
    },
    emptyStateView: {
      type: Object
    },
    errorStateText: {
      type: String,
      default: () => Y("SOMETHING_WRONG")
    },
    loadingStateView: {
      type: Object
    },
    loadingIconURL: {
      type: String,
      default: nn
    },
    groupMembersRequestBuilder: {
      type: Object
    },
    searchRequestBuilder: {
      type: Object
    },
    onError: {
      type: Function,
      default: (e) => console.log(e)
    },
    onClose: {
      type: Function
    },
    errorStateView: {
      type: Object
    },
    emptyStateText: {
      type: String,
      default: () => Y("NO_USERS_FOUND")
    },
    onTransferOwnership: {
      type: Function
    },
    transferOwnershipStyle: {
      type: Object,
      default: () => ({})
    },
    avatarStyle: {
      type: Object,
      default: () => ({})
    },
    groupMemberStyle: {
      type: Object,
      default: () => ({})
    },
    statusIndicatorStyle: {
      type: Object,
      default: () => ({})
    },
    closeButtonIconURL: {
      type: String,
      default: Cn
    },
    listItemView: {
      type: Function
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    }), n = j(null), o = j(e.avatarStyle), i = j(e.groupMemberStyle), l = j(e.statusIndicatorStyle), r = j(e.listItemStyle), u = j(e.transferOwnershipStyle);
    const s = j({
      width: "100%",
      background: "rgb(51, 153, 255)",
      padding: "8px",
      buttonTextColor: "white",
      buttonTextFont: "600 15px Inter, sans-serif",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border: "none",
      borderRadius: "8px",
      flexGrow: "1"
    }), c = j({
      width: "100%",
      background: "white",
      padding: "8px",
      buttonTextColor: "black",
      buttonTextFont: "600 15px Inter, sans-serif",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border: "1px solid #e0e0e0",
      borderRadius: "8px"
    });
    let d = Ht(() => !n.value);
    const N = (_) => {
      n.value = _;
    };
    function T() {
      e.onClose && e.onClose();
    }
    const m = (_) => {
      let oe;
      const ie = e.group.getOwner() === _.getUid() ? I.groupMemberScope.owner : _.getScope();
      return oe = e.group.getOwner() === _.getUid() ? {
        html: `<cometchat-label
            text='${Y(ie.toUpperCase())}'
            labelStyle='${JSON.stringify(x())}'
          ></cometchat-label>`
      } : {
        componentName: "cometchat-radio-button",
        props: {
          labelText: Y(ie.toUpperCase()),
          radioButtonStyle: new Ua(x())
        },
        listeners: {
          "cc-radio-button-changed": () => {
            N(_);
          }
        }
      }, oe;
    }, A = () => {
      var _;
      e.onTransferOwnership ? n.value && (e.onTransferOwnership(n.value), n.value = null) : (n.value && y.transferGroupOwnership(
        e.group.getGuid(),
        (_ = n.value) == null ? void 0 : _.getUid()
      ).then((oe) => {
        var re;
        const ie = Ce.clone(e.group);
        ie instanceof y.Group && ie.setOwner((re = n.value) == null ? void 0 : re.getUid()), He.ccOwnershipChanged.next({
          group: ie,
          newOwner: n.value
        }), n.value = null;
      }).catch((oe) => {
        e.onError && e.onError(oe);
      }), e.onClose && e.onClose());
    };
    function D() {
      k(), z(), R(), h(), Q(), s.value.buttonTextFont = e.transferOwnershipStyle.transferButtonTextFont || w(t.value.typography.subtitle1), s.value.buttonTextColor = e.transferOwnershipStyle.transferButtonTextColor || t.value.palette.getAccent900(), s.value.background = t.value.palette.getPrimary(), c.value.background = t.value.palette.getSecondary(), c.value.buttonTextFont = e.transferOwnershipStyle.cancelButtonTextFont || w(t.value.typography.subtitle1), c.value.buttonTextColor = e.transferOwnershipStyle.cancelButtonTextColor || t.value.palette.getAccent();
    }
    function z() {
      let _ = new _t({
        height: "45px",
        width: "100%",
        background: t.value.palette.getBackground(),
        activeBackground: "transparent",
        borderRadius: "0",
        titleFont: w(t.value.typography.title2),
        titleColor: t.value.palette.getAccent(),
        border: "none",
        separatorColor: t.value.palette.getAccent200(),
        hoverBackground: "transparent"
      });
      r.value = { ..._, ...r.value };
    }
    function k() {
      let _ = new Aa({
        background: t.value.palette.getBackground(),
        border: `1px solid ${t.value.palette.getAccent50()}`,
        titleTextFont: w(t.value.typography.title1),
        titleTextColor: t.value.palette.getAccent(),
        emptyStateTextFont: w(t.value.typography.title1),
        emptyStateTextColor: t.value.palette.getAccent600(),
        errorStateTextFont: w(t.value.typography.title1),
        errorStateTextColor: t.value.palette.getAccent600(),
        loadingIconTint: t.value.palette.getAccent600(),
        onlineStatusColor: t.value.palette.getSuccess(),
        separatorColor: t.value.palette.getAccent400(),
        width: "100%",
        height: "100%",
        borderRadius: "none",
        searchIconTint: t.value.palette.getAccent600(),
        searchPlaceholderTextColor: t.value.palette.getAccent600(),
        searchBackground: t.value.palette.getAccent100(),
        searchPlaceholderTextFont: w(t.value.typography.text3),
        searchTextColor: t.value.palette.getAccent600(),
        searchTextFont: w(t.value.typography.text3),
        searchBorderRadius: "8px",
        closeButtonIconTint: t.value.palette.getPrimary(),
        backButtonIconTint: t.value.palette.getPrimary()
      });
      i.value = {
        ..._,
        ...i.value
      };
    }
    function R() {
      let _ = new Kt({
        borderRadius: "24px",
        width: "28px",
        height: "28px",
        border: "none",
        backgroundColor: t.value.palette.getAccent700(),
        nameTextColor: t.value.palette.getAccent900(),
        backgroundSize: "cover",
        nameTextFont: w(t.value.typography.subtitle1),
        outerViewBorderWidth: "",
        outerViewBorderSpacing: ""
      });
      o.value = { ..._, ...o.value };
    }
    function Q() {
      let _ = {
        height: "10px",
        width: "10px",
        border: "none",
        borderRadius: "24px"
      };
      l.value = {
        ..._,
        ...l.value
      };
    }
    function h() {
      let _ = new $r({
        background: t.value.palette.getBackground(),
        border: `1px solid ${t.value.palette.getAccent50()}`,
        MemberScopeTextFont: w(t.value.typography.subtitle1),
        MemberScopeTextColor: t.value.palette.getAccent600(),
        transferButtonTextFont: w(t.value.typography.title2),
        transferButtonTextColor: t.value.palette.getAccent("dark"),
        cancelButtonTextFont: w(t.value.typography.title2),
        cancelButtonTextColor: t.value.palette.getAccent("light"),
        width: "max(100%, 400px)",
        height: "100%",
        borderRadius: "0"
      });
      u.value = {
        ..._,
        ...u.value
      };
    }
    const O = () => ({
      height: u.value.height,
      width: u.value.width,
      background: u.value.background,
      border: u.value.border,
      borderRadius: u.value.borderRadius,
      overflow: "hidden"
    }), x = () => ({
      height: "16px",
      width: "16px",
      border: "none",
      borderRadius: "4px",
      background: "",
      labelTextFont: u.value.MemberScopeTextFont,
      labelTextColor: u.value.MemberScopeTextColor,
      textFont: u.value.MemberScopeTextFont,
      textColor: u.value.MemberScopeTextColor
    });
    return tn(() => {
      D();
    }), {
      wrapperStyle: O,
      transferButtonStyle: s,
      cancelButtonStyle: c,
      closeClicked: T,
      onTransferClick: A,
      getScopeStyle: x,
      getTailView: m,
      onOwnerSelected: N,
      mygroupMemberStyle: i,
      myavatarStyle: o,
      mystatusIndicatorStyle: l,
      mytransferOwnershipStyle: u,
      SelectionMode: xt,
      isDisabled: d
    };
  }
});
const FC = { class: "cc-transfer-ownership__members" }, HC = { class: "cc-transfer-ownership-buttons" }, ZC = ["text", "buttonStyle", "disabled"], WC = ["text", "buttonStyle"];
function $C(e, t, n, o, i, l) {
  const r = Je("CometChatGroupMembers");
  return M(), g("div", {
    class: "cc-transfer-ownership",
    style: ce(e.wrapperStyle())
  }, [
    p("div", FC, [
      Nt(r, {
        title: e.title,
        titleAlignment: e.titleAlignment,
        searchRequestBuilder: e.searchRequestBuilder,
        listItemView: e.listItemView,
        errorStateText: e.errorStateText,
        errorStateView: e.errorStateView,
        loadingStateView: e.loadingStateView,
        hideSeparator: e.hideSeparator,
        emptyStateText: e.emptyStateText,
        groupMembersRequestBuilder: e.groupMembersRequestBuilder,
        hideSearch: e.hideSearch,
        closeButtonIconURL: e.closeButtonIconURL,
        searchPlaceholderText: e.searchPlaceholderText,
        statusIndicatorStyle: e.mystatusIndicatorStyle,
        avatarStyle: e.myavatarStyle,
        groupMembersStyle: e.mygroupMemberStyle,
        disableUsersPresence: e.disableUsersPresence,
        emptyStateView: e.emptyStateView,
        onClose: e.closeClicked,
        selectionMode: e.SelectionMode.none,
        onError: e.onError,
        subtitleView: e.subtitleView,
        group: e.group,
        tailView: e.getTailView ? e.getTailView : void 0,
        searchIconURL: e.searchIconURL,
        loadingIconURL: e.loadingIconURL,
        listItemStyle: e.listItemStyle,
        onSelect: e.onOwnerSelected,
        options: e.options
      }, null, 8, ["title", "titleAlignment", "searchRequestBuilder", "listItemView", "errorStateText", "errorStateView", "loadingStateView", "hideSeparator", "emptyStateText", "groupMembersRequestBuilder", "hideSearch", "closeButtonIconURL", "searchPlaceholderText", "statusIndicatorStyle", "avatarStyle", "groupMembersStyle", "disableUsersPresence", "emptyStateView", "onClose", "selectionMode", "onError", "subtitleView", "group", "tailView", "searchIconURL", "loadingIconURL", "listItemStyle", "onSelect", "options"])
    ]),
    p("div", HC, [
      p("cometchat-button", {
        class: "cc-transfer-ownership__buttons-confirm",
        text: e.transferButtonText,
        buttonStyle: e.transferButtonStyle,
        disabled: e.isDisabled,
        onCcButtonClicked: t[0] || (t[0] = (u) => e.onTransferClick())
      }, null, 40, ZC),
      p("cometchat-button", {
        class: "cc-transfer-ownership__buttons-cancel",
        text: e.cancelButtonText,
        buttonStyle: e.cancelButtonStyle,
        onCcButtonClicked: t[1] || (t[1] = (u) => e.closeClicked())
      }, null, 40, WC)
    ])
  ], 4);
}
const JC = /* @__PURE__ */ $e(PC, [["render", $C], ["__scopeId", "data-v-dc105c9f"]]), KC = We({
  name: "CometChatDetails",
  components: {
    CometChatAddMembers: Du,
    CometChatGroupMembers: ki,
    CometChatBannedMembers: Fu,
    CometChatTransferOwnership: JC
  },
  props: {
    group: { type: Object },
    user: { type: Object },
    title: { type: String, default: () => Y("DETAILS") },
    closeButtonIconURL: { type: String, default: Cn },
    hideProfile: { type: Boolean, default: !1 },
    subtitleView: {
      type: Function
    },
    customProfileView: {
      type: Function
    },
    data: {
      type: Array
    },
    disableUsersPresence: { type: Boolean, default: !1 },
    privateGroupIcon: { type: String, default: Vo },
    protectedGroupIcon: { type: String, default: Yo },
    onError: {
      type: Function,
      default: (e) => {
        console.log(e);
      }
    },
    onClose: {
      type: Function,
      default: () => {
      }
    },
    leaveButtonText: {
      type: String,
      default: () => Y("LEAVE_GROUP")
    },
    cancelButtonText: { type: String, default: () => Y("CANCEL") },
    addMembersConfiguration: {
      type: Object,
      default: () => new Jr({})
    },
    bannedMembersConfiguration: {
      type: Object,
      default: () => new Kr({})
    },
    groupMembersConfiguration: {
      type: Object,
      default: () => new Xr({})
    },
    transferOwnershipConfiguration: {
      type: Object,
      default: () => new qr({})
    },
    leaveDialogStyle: {
      type: Object,
      default: () => new Ti({
        confirmButtonBackground: "RGB(51, 153, 255)",
        cancelButtonBackground: "RGBA(20, 20, 20, 0.06)",
        confirmButtonTextColor: "white",
        confirmButtonTextFont: "600 15px Inter",
        cancelButtonTextColor: "black",
        cancelButtonTextFont: "600 15px Inter",
        titleFont: "",
        titleColor: "",
        messageTextFont: "400 13px Inter",
        messageTextColor: "RGBA(20, 20, 20, 0.58)",
        background: "white",
        border: "1px solid #F2F2F2",
        height: "220px",
        width: "360px"
      })
    },
    statusIndicatorStyle: {
      type: Object,
      default: () => ({
        height: "10px",
        width: "10px",
        borderRadius: "16px",
        border: ""
      })
    },
    backdropStyle: {
      type: Object,
      default: () => ({
        height: "100%",
        width: "100%",
        background: "rgba(0, 0, 0, 0.5)"
      })
    },
    avatarStyle: {
      type: Object,
      default: () => new Kt({
        borderRadius: "16px",
        width: "28px",
        height: "28px",
        border: "none"
      })
    },
    detailsStyle: {
      type: Object,
      default: () => ({})
    },
    listItemStyle: {
      type: Object,
      default: () => ({})
    },
    leaveConfirmDialogMessage: {
      type: String,
      default: () => Y("LEAVE_CONFIRM")
    },
    transferButtonText: {
      type: String,
      default: () => Y("TRANSFER_OWNERSHIP")
    },
    transferConfirmDialogMessage: {
      type: String,
      default: () => Y("TRANSFER_CONFIRM")
    },
    deleteButtonText: { type: String, default: () => Y("DELETE") },
    deleteConfirmDialogMessage: {
      type: String,
      default: () => Y("DELETE_CONFIRM")
    },
    deleteDialogStyle: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    var rt, Tt, Pt, Rt, Yt, en, gn, bt, Ut, cn, rn, ln, Tn, Vt, Xt, sn;
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    }), n = Y("LEAVE_GROUP"), o = e.leaveConfirmDialogMessage, i = e.transferButtonText, l = e.transferConfirmDialogMessage, r = j(), u = j(), s = j(!1), c = j(!1), d = j(!1), N = j(!1), T = j(!1), m = j(e.backdropStyle), A, D, z, k, R, Q, h, O = {
      private: "",
      password: "#F7A500",
      public: ""
    }, x = {
      height: "24px",
      width: "24px",
      border: "none",
      borderRadius: "0",
      background: "transparent",
      buttonIconTint: e.detailsStyle.closeButtonIconTint || t.value.palette.getPrimary()
    }, _, oe;
    t.value.palette.getPrimary();
    let ie = {
      background: "rgb(222 222 222 / 46%)",
      height: "1px",
      width: "100%"
    }, re = "groupsList_" + (/* @__PURE__ */ new Date()).getTime(), Ae = j(""), se = "userlist_" + (/* @__PURE__ */ new Date()).getTime(), X = j(e.user), B = j(e.group), F, G = j(e.leaveButtonText), J = j(""), ee = !1, V = {
      confirmButtonBackground: ((rt = e.deleteDialogStyle) == null ? void 0 : rt.confirmButtonBackground) || t.value.palette.getPrimary(),
      cancelButtonBackground: ((Tt = e.deleteDialogStyle) == null ? void 0 : Tt.cancelButtonBackground) || t.value.palette.getSecondary(),
      confirmButtonTextColor: ((Pt = e.deleteDialogStyle) == null ? void 0 : Pt.confirmButtonTextColor) || t.value.palette.getAccent900("light"),
      confirmButtonTextFont: ((Rt = e.deleteDialogStyle) == null ? void 0 : Rt.confirmButtonTextFont) || w(t.value.typography.text2),
      cancelButtonTextColor: ((Yt = e.deleteDialogStyle) == null ? void 0 : Yt.cancelButtonTextColor) || t.value.palette.getAccent900("dark"),
      cancelButtonTextFont: ((en = e.deleteDialogStyle) == null ? void 0 : en.cancelButtonTextFont) || w(t.value.typography.text2),
      titleFont: ((gn = e.deleteDialogStyle) == null ? void 0 : gn.titleFont) || w(t.value.typography.title1),
      titleColor: ((bt = e.deleteDialogStyle) == null ? void 0 : bt.titleColor) || t.value.palette.getAccent(),
      messageTextFont: ((Ut = e.deleteDialogStyle) == null ? void 0 : Ut.messageTextFont) || w(t.value.typography.subtitle2),
      messageTextColor: ((cn = e.deleteDialogStyle) == null ? void 0 : cn.messageTextColor) || t.value.palette.getAccent600(),
      background: ((rn = e.deleteDialogStyle) == null ? void 0 : rn.background) || t.value.palette.getBackground(),
      width: ((ln = e.deleteDialogStyle) == null ? void 0 : ln.width) || "320px",
      height: ((Tn = e.deleteDialogStyle) == null ? void 0 : Tn.height) || "100%",
      border: ((Vt = e.deleteDialogStyle) == null ? void 0 : Vt.border) || `1px solid ${t.value.palette.getAccent200()}`,
      borderRadius: ((Xt = e.deleteDialogStyle) == null ? void 0 : Xt.borderRadius) || "8px",
      boxShadow: (sn = e.deleteDialogStyle) == null ? void 0 : sn.boxShadow
    };
    Zt(() => {
      y.getLoggedinUser().then((te) => {
        te && (u.value = te, de());
      }), e.user ? (X.value = e.user, B.value = null) : (X.value = null, B.value = e.group), Ee(), de(), O.online = e.detailsStyle.onlineStatusColor || t.value.palette.getSuccess(), Ie(), ne(), Z();
    }), eo(() => {
      var te, et, Ze, at;
      !X.value && ((te = e.user) != null && te.getUid()) || X.value && e.user && X.value.getUid() != ((et = e.user) == null ? void 0 : et.getUid()) ? (ee = !0, X.value = e.user, B.value = null) : (!B.value && ((Ze = e.group) != null && Ze.getGuid()) || B.value && e.group) && B.value.getGuid() != ((at = e.group) == null ? void 0 : at.getGuid()) && (ee = !0, B.value = e.group, X.value = null), ee && (u.value ? de() : y.getLoggedinUser().then((Bt) => {
        Bt && (u.value = Bt, de());
      })), Z(), ee = !1;
    });
    const ne = () => {
      A = He.ccGroupMemberAdded.subscribe(
        (te) => {
          B.value && B.value.getGuid() == (te == null ? void 0 : te.userAddedIn.getGuid()) && (B.value = Ce.clone(
            te == null ? void 0 : te.userAddedIn
          ));
        }
      ), k = He.ccGroupMemberBanned.subscribe(
        (te) => {
          B.value && B.value.getGuid() == (te == null ? void 0 : te.kickedFrom.getGuid()) && (B.value = Ce.clone(
            te == null ? void 0 : te.kickedFrom
          ));
        }
      ), D = He.ccGroupMemberJoined.subscribe(
        (te) => {
          B.value && B.value.getGuid() == (te == null ? void 0 : te.joinedGroup.getGuid()) && (B.value = Ce.clone(
            te == null ? void 0 : te.joinedGroup
          ));
        }
      ), z = He.ccGroupMemberKicked.subscribe(
        (te) => {
          B.value && B.value.getGuid() == (te == null ? void 0 : te.kickedFrom.getGuid()) && (B.value = Ce.clone(
            te == null ? void 0 : te.kickedFrom
          ));
        }
      ), R = He.ccOwnershipChanged.subscribe(
        (te) => {
          B.value && B.value.getGuid() == (te == null ? void 0 : te.group.getGuid()) && (B.value = Ce.clone(
            te == null ? void 0 : te.group
          ));
        }
      );
    };
    function K() {
      A == null || A.unsubscribe(), D == null || D.unsubscribe(), k == null || k.unsubscribe(), z == null || z.unsubscribe(), R == null || R.unsubscribe();
    }
    un(() => {
      K(), Te();
    });
    const Ie = () => {
      try {
        e.disableUsersPresence || y.addUserListener(
          se,
          new y.UserListener({
            onUserOnline: (te) => {
              H(te);
            },
            onUserOffline: (te) => {
              H(te);
            }
          })
        ), y.addGroupListener(
          re,
          new y.GroupListener({
            onGroupMemberScopeChanged: (te, et, Ze, at, Bt) => {
              var vn;
              (Bt == null ? void 0 : Bt.getGuid()) === ((vn = B.value) == null ? void 0 : vn.getGuid()) && (B.value = Ce.clone(Bt));
            },
            onGroupMemberKicked: (te, et, Ze, at) => {
              var Bt;
              (at == null ? void 0 : at.getGuid()) === ((Bt = B.value) == null ? void 0 : Bt.getGuid()) && (B.value = at);
            },
            onMemberAddedToGroup: (te, et, Ze, at) => {
              var Bt;
              (at == null ? void 0 : at.getGuid()) === ((Bt = B.value) == null ? void 0 : Bt.getGuid()) && (B.value = Ce.clone(at));
            },
            onGroupMemberBanned(te, et, Ze, at) {
              var Bt;
              (at == null ? void 0 : at.getGuid()) === ((Bt = B.value) == null ? void 0 : Bt.getGuid()) && (B.value = at);
            },
            onGroupMemberLeft: (te, et, Ze) => {
              var at;
              (Ze == null ? void 0 : Ze.getGuid()) === ((at = B.value) == null ? void 0 : at.getGuid()) && (B.value = Ce.clone(Ze));
            },
            onGroupMemberJoined: (te, et, Ze) => {
              var at;
              (Ze == null ? void 0 : Ze.getGuid()) === ((at = B.value) == null ? void 0 : at.getGuid()) && (B.value = Ce.clone(Ze));
            }
          })
        );
      } catch (te) {
        console.log(te);
      }
    }, Te = () => {
      y.removeUserListener(se), y.removeGroupListener(re);
    }, H = (te) => {
      X.value && X.value.getUid() && X.value.getUid() === te.getUid() && (X.value.setStatus(te.getStatus()), Z());
    }, Ee = () => {
      Ue(), U(), v(), L(), b(), O.private = e.detailsStyle.privateGroupIconBackground || "#F7A500", O.online = e.detailsStyle.onlineStatusColor, O.password = e.detailsStyle.passwordGroupIconBackground || "#F7A500";
    }, L = () => (oe = { ...new _t({
      height: "45px",
      width: "100%",
      background: t.value.palette.getBackground(),
      activeBackground: "transparent",
      borderRadius: "0",
      titleFont: w(t.value.typography.title2),
      titleColor: t.value.palette.getAccent(),
      border: "none",
      separatorColor: t.value.palette.getAccent200(),
      hoverBackground: "transparent"
    }), ...e.listItemStyle }, oe), b = () => {
      F = { ...new Ti({
        confirmButtonBackground: t.value.palette.getPrimary(),
        cancelButtonBackground: t.value.palette.getSecondary(),
        confirmButtonTextColor: t.value.palette.getAccent900("light"),
        confirmButtonTextFont: w(t.value.typography.text2),
        cancelButtonTextColor: t.value.palette.getAccent900("dark"),
        cancelButtonTextFont: w(t.value.typography.text2),
        titleFont: w(t.value.typography.title1),
        titleColor: t.value.palette.getAccent(),
        messageTextFont: w(t.value.typography.subtitle2),
        messageTextColor: t.value.palette.getAccent600(),
        background: t.value.palette.getBackground(),
        height: "100%",
        width: "350px",
        border: `1px solid ${t.value.palette.getAccent200()}`,
        borderRadius: "8px"
      }), ...e.leaveDialogStyle };
    }, v = () => (Q = {
      ...{
        height: "12px",
        width: "12px",
        border: "none",
        borderRadius: "24px"
      },
      ...e.statusIndicatorStyle
    }, Q), U = () => (h = { ...new Kt({
      borderRadius: "24px",
      width: "36px",
      height: "36px",
      border: "none",
      backgroundColor: t.value.palette.getAccent700(),
      nameTextColor: t.value.palette.getAccent900(),
      backgroundSize: "cover",
      nameTextFont: w(t.value.typography.subtitle1),
      outerViewBorderWidth: "",
      outerViewBorderSpacing: ""
    }), ...e.avatarStyle }, h), Se = (te) => ({
      textFont: te.titleFont,
      textColor: te.titleColor
    }), Ue = () => {
      ({ ...new _r({
        background: t.value.palette.getBackground(),
        border: `1px solid ${t.value.palette.getAccent50()}`,
        titleTextFont: w(t.value.typography.title1),
        titleTextColor: t.value.palette.getAccent(),
        onlineStatusColor: t.value.palette.getSuccess(),
        privateGroupIconBackground: t.value.palette.getSuccess(),
        passwordGroupIconBackground: "RGB(247, 165, 0)",
        closeButtonIconTint: t.value.palette.getPrimary(),
        width: "100%",
        height: "100%",
        borderRadius: "",
        subtitleTextFont: w(t.value.typography.subtitle2),
        subtitleTextColor: t.value.palette.getAccent600()
      }), ...e.detailsStyle });
    }, Re = () => {
      let te = {
        width: "100%",
        height: "100%",
        background: t.value.palette.getBackground(),
        border: "",
        borderRadius: ""
      };
      return {
        width: e.detailsStyle.width || te.width,
        height: e.detailsStyle.height || te.height,
        border: e.detailsStyle.border || te.border,
        borderRadius: e.detailsStyle.borderRadius || te.borderRadius,
        background: e.detailsStyle.background || te.background
      };
    }, _e = () => {
      var te;
      return {
        padding: (te = e.detailsStyle) == null ? void 0 : te.padding
      };
    }, Z = () => {
      var Ze;
      const te = (Ze = B == null ? void 0 : B.value) == null ? void 0 : Ze.getMembersCount(), et = Y(te > 1 ? "MEMBERS" : "MEMBER");
      if (X.value) {
        let at = !e.disableUsersPresence && !X.value.getBlockedByMe() && !X.value.getHasBlockedMe();
        Ae.value = at ? X.value.getStatus() : "";
      } else
        B.value && (Ae.value = `${te} ${et}`);
    }, ke = () => {
      e.onClose && e.onClose();
    }, q = () => {
      var te, et;
      return X.value ? !e.disableUsersPresence && !new co().getUserStatusVisibility(X.value) ? O[(te = X == null ? void 0 : X.value) == null ? void 0 : te.getStatus()] : null : B != null && B.value ? O[(et = B == null ? void 0 : B.value) == null ? void 0 : et.getType()] : null;
    }, ye = () => {
      let te = X.value ? new co().getUserStatusVisibility(X.value) : !0;
      return !e.disableUsersPresence && !te ? {
        textFont: e.detailsStyle.subtitleTextFont || w(t.value.typography.subtitle2),
        textColor: t.value.palette.getPrimary()
      } : {
        textFont: e.detailsStyle.subtitleTextFont || w(t.value.typography.subtitle2),
        textColor: t.value.palette.getAccent()
      };
    }, Oe = () => {
      var et;
      let te = "";
      if (B.value)
        switch ((et = B.value) == null ? void 0 : et.getType()) {
          case I.GroupTypes.password:
            te = e.protectedGroupIcon;
            break;
          case I.GroupTypes.private:
            te = e.privateGroupIcon;
            break;
          default:
            te = "";
            break;
        }
      return te;
    }, he = () => ({
      textFont: e.detailsStyle.titleTextFont || w(t.value.typography.title1),
      textColor: e.detailsStyle.titleTextColor || t.value.palette.getAccent()
    });
    function Pe(te) {
      var Ze;
      const et = te.id ?? "";
      return (Ze = te.options) == null ? void 0 : Ze.call(
        te,
        X.value,
        B.value,
        et
      );
    }
    const lt = (te) => ({
      height: "100%",
      width: "100%",
      border: "none",
      borderRadius: "0",
      buttonTextFont: te == null ? void 0 : te.titleFont,
      buttonTextColor: te == null ? void 0 : te.titleColor,
      background: (te == null ? void 0 : te.backgroundColor) || "transparent"
    }), It = (te) => te == null ? void 0 : te.customView, Gt = (te) => {
      var at;
      const { onClick: et, id: Ze } = te;
      if (et) {
        et(X.value ?? B.value);
        return;
      }
      switch (Ze) {
        case I.UserOptions.viewProfile:
          (at = X.value) != null && at.getLink() && (window.location.href = X.value.getLink());
          break;
        case I.UserOptions.block:
          Fe();
          break;
        case I.UserOptions.unblock:
          Le();
          break;
        case I.GroupOptions.viewMembers:
          wt();
          break;
        case I.GroupOptions.addMembers:
          Lt();
          break;
        case I.GroupOptions.bannedMembers:
          jt();
          break;
        case I.GroupOptions.leave:
          Wt();
          break;
        case I.GroupOptions.delete:
          ot();
          break;
      }
    }, de = () => {
      let te;
      e.data && (te = e.data), te || (te = wa.getDefaultDetailsTemplate(
        u.value,
        X.value,
        B.value,
        t.value
      )), r.value = te;
    }, Le = () => {
      X.value && X.value.getBlockedByMe() && y.unblockUsers([X.value.getUid()]).then(() => {
        X.value.setBlockedByMe(!1), En.ccUserUnblocked.next(
          Ce.clone(X.value)
        ), Z(), de();
      }).catch((te) => {
        if (e.onError) {
          let et = new y.CometChatException({
            message: te.message
          });
          e.onError(et);
        }
      });
    }, Fe = () => {
      X.value && !X.value.getBlockedByMe() && y.blockUsers([X.value.getUid()]).then(() => {
        X.value.setBlockedByMe(!0), En.ccUserBlocked.next(
          Ce.clone(X.value)
        ), Z(), de();
      }).catch((te) => {
        if (e.onError) {
          let et = new y.CometChatException({
            message: te.message
          });
          e.onError(et);
        }
      });
    }, tt = () => {
      var te;
      y.deleteGroup((te = B == null ? void 0 : B.value) == null ? void 0 : te.getGuid()).then(() => {
        He.ccGroupDeleted.next(
          Ce.clone(B.value)
        ), e.onClose && e.onClose();
      }).catch((et) => {
        if (e.onError) {
          let Ze = new y.CometChatException({
            message: et.message
          });
          e.onError(Ze);
        }
      });
    }, st = () => {
      var te;
      B.value.getOwner() == ((te = u.value) == null ? void 0 : te.getUid()) ? (T.value = !0, N.value = !1) : y.leaveGroup(B.value.getGuid()).then((et) => {
        B.value.setMembersCount(
          B.value.getMembersCount() - 1
        ), B.value.setHasJoined(!1), Z(), T.value = !1, N.value = !1, e.onClose && e.onClose(), He.ccGroupLeft.next({
          userLeft: Ce.clone(u.value),
          leftGroup: Ce.clone(B.value),
          message: ct(
            u,
            I.groupMemberAction.LEFT
          )
        });
      }).catch((et) => {
        e.onError && e.onError(et);
      });
    }, ct = (te, et) => {
      var at;
      let Ze = new y.Action(
        B.value.getGuid(),
        I.MessageTypes.groupMember,
        I.MessageReceiverType.group,
        I.MessageCategory.action
      );
      return Ze.setAction(et), Ze.setActionBy(
        Ce.clone(u.value)
      ), Ze.setActionFor(
        Ce.clone(B.value)
      ), Ze.setActionOn(Ce.clone(te)), Ze.setReceiver(
        Ce.clone(B.value)
      ), Ze.setSender(Ce.clone(u.value)), Ze.setConversationId(
        "currentGroup_" + B.value.getGuid()
      ), Ze.setMuid(Ce.ID()), Ze.setMessage(
        `${(at = u.value) == null ? void 0 : at.getName()} ${et} ${te.getUid ? te.getUid() : ""}`
      ), Ze.setSentAt(Ce.getUnixTimestamp()), Ze;
    }, wt = () => {
      s.value = !s.value, c.value = !1, d.value = !1;
    }, Lt = () => {
      d.value = !d.value, c.value = !1, s.value = !1;
    }, jt = () => {
      d.value = !1, s.value = !1, c.value = !c.value;
    }, Wt = () => {
      var te, et;
      _ = st, m.value = F, ((te = B.value) == null ? void 0 : te.getOwner()) == ((et = u.value) == null ? void 0 : et.getUid()) ? (G.value = i, J.value = l) : (G.value = n, J.value = o), N.value = !0;
    }, ot = () => {
      _ = tt, m.value = V, G.value = e.deleteButtonText, J.value = e.deleteConfirmDialogMessage, N.value = !0;
    };
    return {
      getButtonStyle: lt,
      wrapperStyle: Re,
      checkStatusType: q,
      checkGroupType: Oe,
      getTitleStyle: he,
      onCloseDetails: ke,
      closeButtonStyle: x,
      openTransferOwnershipModal: T,
      defaultTemplate: r,
      getSectionHeaderStyle: Se,
      paddingStyle: _e,
      subtitleStyle: ye,
      getTemplateOptions: Pe,
      subtitleText: Ae,
      openAddMembersPage: d,
      dividerStyle: ie,
      getCustomOptionView: It,
      openBannedMembersPage: c,
      openViewMembersPage: s,
      confirmLeaveGroupModal: N,
      currentUser: X,
      currentGroup: B,
      setAvatarStyle: U,
      setStatusStyle: v,
      setListItemStyle: L,
      onOptionClick: Gt,
      SelectionMode: xt,
      onCancelClick: () => {
        N.value = !1;
      },
      bannedMembers: jt,
      viewMembers: wt,
      addMembers: Lt,
      onCloseClick: () => {
        e.onClose && e.onClose();
      },
      getConfirmClickHandler: () => _,
      closeTransferOwnership: () => {
        T.value = !1, N.value = !1;
      },
      leaveButtonTextRef: G,
      confirmDialogMessageRef: J,
      confirmDialogStyleRef: m
    };
  }
});
const XC = { class: "cc-details__header" }, qC = ["text", "labelStyle"], _C = ["iconURL", "buttonStyle"], ew = {
  key: 0,
  class: "cc-details__profile"
}, tw = ["avatarName", "avatarURL", "listItemStyle", "statusIndicatorColor", "statusIndicatorIcon", "title", "statusIndicatorStyle", "avatarStyle"], nw = { slot: "subtitleView" }, ow = { key: 0 }, iw = ["text", "labelStyle"], aw = { key: 1 }, rw = ["innerHTML"], lw = ["v-slot", "v-html"], sw = { key: 1 }, Mw = ["innerHTML"], uw = ["v-slot", "v-html"], gw = {
  key: 1,
  class: "cc-details__section-list"
}, cw = {
  key: 0,
  class: "cc-details__section-separator"
}, dw = ["text", "labelStyle"], Iw = {
  key: 1,
  class: "cc-details__options-wrapper"
}, Nw = ["onClick"], Tw = { class: "cc-details__option-title" }, Dw = ["text", "buttonStyle"], yw = {
  key: 0,
  class: "cc-details__option-tail"
}, Cw = ["innerHTML"], ww = ["dividerStyle"], jw = ["innerHTML"], Aw = {
  key: 1,
  class: "cc-details__view"
}, Lw = {
  key: 2,
  class: "cc-details__view"
}, zw = {
  key: 3,
  class: "cc-details__view"
}, Sw = ["backdropStyle"], pw = ["messageText", "cancelButtonText", "confirmButtonText", "confirmDialogStyle"], bw = ["backdropStyle"];
function Ew(e, t, n, o, i, l) {
  var d, N, T, m, A, D, z, k, R, Q, h, O, x, _, oe, ie, re, Ae, se, X, B, F, G, J, ee, V, ne, K, Ie, Te, H, Ee, L, b, v, U, Se, Ue, Re, _e, Z, ke, q, ye, Oe, he, Pe, lt, It, Gt, de, Le, Fe, tt, st, ct, wt, Lt, jt, Wt, ot, zt, yt, on, ft, rt, Tt, Pt, Rt, Yt, en, gn, bt, Ut, cn, rn, ln, Tn, Vt, Xt, sn, te, et, Ze, at, Bt, vn, Pn, to, Un, Fn, no, Hn, Zn, oo, io, Wn, ao, ro, lo, Bn, Qn, Dn, so, Rn, qt, S, f, P, Me, ze, Qe, Ye, At, $t, Ln, wn;
  const r = Je("CometChatAddMembers"), u = Je("CometChatBannedMembers"), s = Je("CometChatGroupMembers"), c = Je("CometChatTransferOwnership");
  return M(), g(we, null, [
    e.user || e.group ? (M(), g("div", {
      key: 0,
      class: "cc-details__wrapper",
      style: ce(e.wrapperStyle())
    }, [
      p("div", XC, [
        p("cometchat-label", {
          text: e.title,
          labelStyle: e.getTitleStyle()
        }, null, 8, qC),
        p("cometchat-button", {
          iconURL: e.closeButtonIconURL,
          class: "cc-details__close-button",
          buttonStyle: e.closeButtonStyle,
          onCcButtonClicked: t[0] || (t[0] = (St) => e.onCloseDetails())
        }, null, 40, _C)
      ]),
      p("div", {
        class: "cc-details",
        style: ce(e.paddingStyle())
      }, [
        e.hideProfile ? $("", !0) : (M(), g("div", ew, [
          e.customProfileView ? e.customProfileView ? (M(), g("div", sw, [
            e.customProfileView(e.currentUser, e.currentGroup).html ? (M(), g("div", {
              key: 0,
              innerHTML: e.customProfileView(e.currentUser, e.currentGroup).html
            }, null, 8, Mw)) : (M(), je(fe(e.customProfileView(e.currentUser, e.currentGroup).componentName), me({ key: 1 }, { ...e.customProfileView(e.currentUser, e.currentGroup).props }, xe(e.customProfileView(e.currentUser, e.currentGroup).listeners)), {
              default: be(() => [
                (M(!0), g(we, null, pe(e.customProfileView(e.currentUser, e.currentGroup).slots, (St, Et) => (M(), g("div", {
                  key: Et,
                  "v-slot": [Et],
                  "v-html": St
                }, null, 8, uw))), 128))
              ]),
              _: 1
            }, 16))
          ])) : $("", !0) : (M(), g("cometchat-list-item", {
            key: 0,
            avatarName: ((d = e.currentUser) == null ? void 0 : d.getName()) ?? ((N = e.currentGroup) == null ? void 0 : N.getName()),
            avatarURL: ((T = e.currentUser) == null ? void 0 : T.getAvatar()) ?? ((m = e.currentGroup) == null ? void 0 : m.getIcon()),
            listItemStyle: e.setListItemStyle(),
            statusIndicatorColor: e.checkStatusType(),
            statusIndicatorIcon: e.checkGroupType(),
            title: ((A = e.currentUser) == null ? void 0 : A.getName()) ?? ((D = e.currentGroup) == null ? void 0 : D.getName()),
            hideSeparator: !1,
            statusIndicatorStyle: e.setStatusStyle(),
            avatarStyle: e.setAvatarStyle()
          }, [
            p("div", nw, [
              e.subtitleView ? e.subtitleView(e.currentUser, e.currentGroup) ? (M(), g("div", aw, [
                e.subtitleView(e.currentUser, e.currentGroup).html ? (M(), g("div", {
                  key: 0,
                  innerHTML: e.subtitleView(e.currentUser, e.currentGroup).html
                }, null, 8, rw)) : (M(), je(fe(e.subtitleView(e.currentUser, e.currentGroup).componentName), me({ key: 1 }, { ...e.subtitleView(e.currentUser, e.currentGroup).props }, xe((z = e.subtitleView(e.currentUser, e.currentGroup)) == null ? void 0 : z.listeners)), {
                  default: be(() => [
                    (M(!0), g(we, null, pe(e.subtitleView(e.currentUser, e.currentGroup).slots, (St, Et) => (M(), g("div", {
                      key: Et,
                      "v-slot": [Et],
                      "v-html": St
                    }, null, 8, lw))), 128))
                  ]),
                  _: 1
                }, 16))
              ])) : $("", !0) : (M(), g("div", ow, [
                p("cometchat-label", {
                  text: e.subtitleText,
                  labelStyle: e.subtitleStyle()
                }, null, 8, iw)
              ]))
            ])
          ], 8, tw))
        ])),
        e.defaultTemplate && e.defaultTemplate.length > 0 ? (M(), g("div", gw, [
          (M(!0), g(we, null, pe(e.defaultTemplate, (St) => (M(), g("div", {
            class: "cc-details__section",
            key: St.id
          }, [
            St.title ? (M(), g("div", cw, [
              p("cometchat-label", {
                text: St.title,
                labelStyle: e.getSectionHeaderStyle(St)
              }, null, 8, dw)
            ])) : $("", !0),
            e.getTemplateOptions(St) ? (M(), g("div", Iw, [
              (M(!0), g(we, null, pe(e.getTemplateOptions(St), (Et) => (M(), g("div", {
                class: "cc-details__options",
                key: Et.id
              }, [
                e.getCustomOptionView(Et) ? (M(), g("div", {
                  key: 1,
                  innerHTML: e.getCustomOptionView(Et)
                }, null, 8, jw)) : (M(), g("div", {
                  key: 0,
                  class: "cc-details__option",
                  onClick: ($n) => e.onOptionClick(Et)
                }, [
                  p("div", Tw, [
                    p("cometchat-button", {
                      text: Et.title,
                      buttonStyle: e.getButtonStyle(Et)
                    }, null, 8, Dw),
                    Et != null && Et.tail ? (M(), g("div", yw, [
                      p("div", {
                        innerHTML: Et == null ? void 0 : Et.tail
                      }, null, 8, Cw)
                    ])) : $("", !0)
                  ]),
                  p("cometchat-divider", { dividerStyle: e.dividerStyle }, null, 8, ww)
                ], 8, Nw))
              ]))), 128))
            ])) : $("", !0)
          ]))), 128))
        ])) : $("", !0)
      ], 4)
    ], 4)) : $("", !0),
    e.openAddMembersPage ? (M(), g("div", Aw, [
      Nt(r, {
        group: e.currentGroup,
        selectionMode: ((k = e.addMembersConfiguration) == null ? void 0 : k.selectionMode) ?? e.SelectionMode.multiple,
        onClose: ((R = e.addMembersConfiguration) == null ? void 0 : R.onClose) ?? e.onClose ?? void 0,
        onBack: ((Q = e.addMembersConfiguration) == null ? void 0 : Q.onBack) || e.addMembers,
        backButtonIconURL: (h = e.addMembersConfiguration) == null ? void 0 : h.backButtonIconURL,
        showBackButton: (O = e.addMembersConfiguration) == null ? void 0 : O.showBackButton,
        titleAlignment: (x = e.addMembersConfiguration) == null ? void 0 : x.titleAlignment,
        hideSearch: (_ = e.addMembersConfiguration) == null ? void 0 : _.hideSearch,
        searchIconURL: (oe = e.addMembersConfiguration) == null ? void 0 : oe.searchIconURL,
        showSectionHeader: (ie = e.addMembersConfiguration) == null ? void 0 : ie.showSectionHeader,
        sectionHeaderField: (re = e.addMembersConfiguration) == null ? void 0 : re.sectionHeaderField,
        loadingIconURL: (Ae = e.addMembersConfiguration) == null ? void 0 : Ae.loadingIconURL,
        loadingStateView: (se = e.addMembersConfiguration) == null ? void 0 : se.loadingStateView,
        emptyStateView: (X = e.addMembersConfiguration) == null ? void 0 : X.emptyStateView,
        errorStateView: (B = e.addMembersConfiguration) == null ? void 0 : B.errorStateView,
        hideError: (F = e.addMembersConfiguration) == null ? void 0 : F.hideError,
        disableUsersPresence: (G = e.addMembersConfiguration) == null ? void 0 : G.disableUsersPresence,
        hideSeparator: (J = e.addMembersConfiguration) == null ? void 0 : J.hideSeparator,
        onError: ((ee = e.addMembersConfiguration) == null ? void 0 : ee.onError) ?? void 0,
        menus: (V = e.addMembersConfiguration) == null ? void 0 : V.menu,
        options: ((ne = e.addMembersConfiguration) == null ? void 0 : ne.options) ?? void 0,
        onSelect: (K = e.addMembersConfiguration) == null ? void 0 : K.onSelect,
        usersRequestBuilder: (Ie = e.addMembersConfiguration) == null ? void 0 : Ie.usersRequestBuilder,
        searchRequestBuilder: (Te = e.addMembersConfiguration) == null ? void 0 : Te.searchRequestBuilder,
        listItemView: (H = e.addMembersConfiguration) == null ? void 0 : H.listItemView,
        subtitleView: (Ee = e.addMembersConfiguration) == null ? void 0 : Ee.subtitleView,
        onAddMembersButtonClick: ((L = e.addMembersConfiguration) == null ? void 0 : L.onAddMembersButtonClick) ?? void 0,
        closeButtonIconURL: (b = e.addMembersConfiguration) == null ? void 0 : b.closeButtonIconURL,
        listItemStyle: (v = e.addMembersConfiguration) == null ? void 0 : v.listItemStyle,
        statusIndicatorStyle: (U = e.addMembersConfiguration) == null ? void 0 : U.statusIndicatorStyle,
        avatarStyle: (Se = e.addMembersConfiguration) == null ? void 0 : Se.avatarStyle,
        addMembersStyle: (Ue = e.addMembersConfiguration) == null ? void 0 : Ue.addMembersStyle
      }, null, 8, ["group", "selectionMode", "onClose", "onBack", "backButtonIconURL", "showBackButton", "titleAlignment", "hideSearch", "searchIconURL", "showSectionHeader", "sectionHeaderField", "loadingIconURL", "loadingStateView", "emptyStateView", "errorStateView", "hideError", "disableUsersPresence", "hideSeparator", "onError", "menus", "options", "onSelect", "usersRequestBuilder", "searchRequestBuilder", "listItemView", "subtitleView", "onAddMembersButtonClick", "closeButtonIconURL", "listItemStyle", "statusIndicatorStyle", "avatarStyle", "addMembersStyle"])
    ])) : $("", !0),
    e.openBannedMembersPage ? (M(), g("div", Lw, [
      Nt(u, {
        group: e.currentGroup,
        onClose: e.onClose ?? ((Re = e.addMembersConfiguration) == null ? void 0 : Re.onClose) ?? void 0,
        onBack: ((_e = e.bannedMembersConfiguration) == null ? void 0 : _e.onBack) || e.bannedMembers,
        backButtonIconURL: (Z = e.bannedMembersConfiguration) == null ? void 0 : Z.backButtonIconURL,
        showBackButton: (ke = e.bannedMembersConfiguration) == null ? void 0 : ke.showBackButton,
        menus: (q = e.bannedMembersConfiguration) == null ? void 0 : q.menu,
        titleAlignment: (ye = e.bannedMembersConfiguration) == null ? void 0 : ye.titleAlignment,
        hideSearch: (Oe = e.bannedMembersConfiguration) == null ? void 0 : Oe.hideSearch,
        searchIconURL: (he = e.bannedMembersConfiguration) == null ? void 0 : he.searchIconURL,
        bannedMembersRequestBuilder: (Pe = e.bannedMembersConfiguration) == null ? void 0 : Pe.bannedMembersRequestBuilder,
        searchRequestBuilder: (lt = e.bannedMembersConfiguration) == null ? void 0 : lt.searchRequestBuilder,
        listItemView: (It = e.bannedMembersConfiguration) == null ? void 0 : It.listItemView,
        subtitleView: (Gt = e.bannedMembersConfiguration) == null ? void 0 : Gt.subtitleView,
        hideSeparator: (de = e.bannedMembersConfiguration) == null ? void 0 : de.hideSeparator,
        disableUsersPresence: (Le = e.bannedMembersConfiguration) == null ? void 0 : Le.disableUsersPresence,
        options: ((Fe = e.bannedMembersConfiguration) == null ? void 0 : Fe.options) ?? void 0,
        selectionMode: (tt = e.bannedMembersConfiguration) == null ? void 0 : tt.selectionMode,
        closeButtonIconURL: (st = e.bannedMembersConfiguration) == null ? void 0 : st.closeButtonIconURL,
        onError: ((ct = e.bannedMembersConfiguration) == null ? void 0 : ct.onError) ?? void 0,
        onSelect: (wt = e.bannedMembersConfiguration) == null ? void 0 : wt.onSelect,
        emptyStateView: (Lt = e.bannedMembersConfiguration) == null ? void 0 : Lt.emptyStateView,
        errorStateView: (jt = e.bannedMembersConfiguration) == null ? void 0 : jt.errorStateView,
        loadingStateView: (Wt = e.bannedMembersConfiguration) == null ? void 0 : Wt.loadingStateView,
        loadingIconURL: (ot = e.bannedMembersConfiguration) == null ? void 0 : ot.loadingIconURL,
        hideError: (zt = e.bannedMembersConfiguration) == null ? void 0 : zt.hideError,
        statusIndicatorStyle: (yt = e.bannedMembersConfiguration) == null ? void 0 : yt.statusIndicatorStyle,
        avatarStyle: (on = e.bannedMembersConfiguration) == null ? void 0 : on.avatarStyle,
        listItemStyle: (ft = e.bannedMembersConfiguration) == null ? void 0 : ft.listItemStyle,
        bannedMemberStyle: (rt = e.bannedMembersConfiguration) == null ? void 0 : rt.bannedMembersStyle
      }, null, 8, ["group", "onClose", "onBack", "backButtonIconURL", "showBackButton", "menus", "titleAlignment", "hideSearch", "searchIconURL", "bannedMembersRequestBuilder", "searchRequestBuilder", "listItemView", "subtitleView", "hideSeparator", "disableUsersPresence", "options", "selectionMode", "closeButtonIconURL", "onError", "onSelect", "emptyStateView", "errorStateView", "loadingStateView", "loadingIconURL", "hideError", "statusIndicatorStyle", "avatarStyle", "listItemStyle", "bannedMemberStyle"])
    ])) : $("", !0),
    e.openViewMembersPage ? (M(), g("div", zw, [
      Nt(s, {
        group: e.currentGroup,
        onClose: ((Tt = e.groupMembersConfiguration) == null ? void 0 : Tt.onClose) ?? e.onClose ?? void 0,
        onBack: ((Pt = e.groupMembersConfiguration) == null ? void 0 : Pt.onBack) || e.viewMembers,
        groupMembersRequestBuilder: (Rt = e.groupMembersConfiguration) == null ? void 0 : Rt.groupMembersRequestBuilder,
        searchRequestBuilder: (Yt = e.groupMembersConfiguration) == null ? void 0 : Yt.searchRequestBuilder,
        listItemView: (en = e.groupMembersConfiguration) == null ? void 0 : en.listItemView,
        subtitleView: (gn = e.groupMembersConfiguration) == null ? void 0 : gn.subtitleView,
        disableUsersPresence: (bt = e.groupMembersConfiguration) == null ? void 0 : bt.disableUsersPresence,
        menus: (Ut = e.groupMembersConfiguration) == null ? void 0 : Ut.menu,
        options: void 0,
        backButtonIconURL: (cn = e.groupMembersConfiguration) == null ? void 0 : cn.backButtonIconURL,
        closeButtonIconURL: (rn = e.groupMembersConfiguration) == null ? void 0 : rn.closeButtonIconURL,
        showBackButton: (ln = e.groupMembersConfiguration) == null ? void 0 : ln.showBackButton,
        hideSeparator: (Tn = e.groupMembersConfiguration) == null ? void 0 : Tn.hideSeparator,
        selectionMode: (Vt = e.groupMembersConfiguration) == null ? void 0 : Vt.selectionMode,
        hideError: (Xt = e.groupMembersConfiguration) == null ? void 0 : Xt.hideError,
        searchIconURL: (sn = e.groupMembersConfiguration) == null ? void 0 : sn.searchIconURL,
        dropdownIconURL: (te = e.groupMembersConfiguration) == null ? void 0 : te.dropdownIconURL,
        hideSearch: (et = e.groupMembersConfiguration) == null ? void 0 : et.hideSearch,
        onError: ((Ze = e.groupMembersConfiguration) == null ? void 0 : Ze.onError) ?? void 0,
        onSelect: (at = e.groupMembersConfiguration) == null ? void 0 : at.onSelect,
        emptyStateView: (Bt = e.groupMembersConfiguration) == null ? void 0 : Bt.emptyStateView,
        errorStateView: (vn = e.groupMembersConfiguration) == null ? void 0 : vn.errorStateView,
        loadingIconURL: (Pn = e.groupMembersConfiguration) == null ? void 0 : Pn.loadingIconURL,
        loadingStateView: (to = e.groupMembersConfiguration) == null ? void 0 : to.loadingStateView,
        titleAlignment: (Un = e.groupMembersConfiguration) == null ? void 0 : Un.titleAlignment,
        statusIndicatorStyle: (Fn = e.groupMembersConfiguration) == null ? void 0 : Fn.statusIndicatorStyle,
        avatarStyle: (no = e.groupMembersConfiguration) == null ? void 0 : no.avatarStyle,
        groupMembersStyle: (Hn = e.groupMembersConfiguration) == null ? void 0 : Hn.groupMembersStyle,
        groupScopeStyle: (Zn = e.groupMembersConfiguration) == null ? void 0 : Zn.groupScopeStyle,
        listItemStyle: (oo = e.groupMembersConfiguration) == null ? void 0 : oo.listItemStyle
      }, null, 8, ["group", "onClose", "onBack", "groupMembersRequestBuilder", "searchRequestBuilder", "listItemView", "subtitleView", "disableUsersPresence", "menus", "backButtonIconURL", "closeButtonIconURL", "showBackButton", "hideSeparator", "selectionMode", "hideError", "searchIconURL", "dropdownIconURL", "hideSearch", "onError", "onSelect", "emptyStateView", "errorStateView", "loadingIconURL", "loadingStateView", "titleAlignment", "statusIndicatorStyle", "avatarStyle", "groupMembersStyle", "groupScopeStyle", "listItemStyle"])
    ])) : $("", !0),
    e.confirmLeaveGroupModal ? (M(), g("cometchat-backdrop", {
      key: 4,
      backdropStyle: e.backdropStyle
    }, [
      p("cometchat-confirm-dialog", {
        title: "",
        messageText: e.confirmDialogMessageRef,
        cancelButtonText: e.cancelButtonText,
        confirmButtonText: e.leaveButtonTextRef,
        onCcConfirmClicked: t[1] || (t[1] = (St) => e.getConfirmClickHandler()()),
        onCcCancelClicked: t[2] || (t[2] = (St) => e.onCancelClick()),
        confirmDialogStyle: e.confirmDialogStyleRef
      }, null, 40, pw)
    ], 8, Sw)) : $("", !0),
    e.openTransferOwnershipModal ? (M(), g("cometchat-backdrop", {
      key: 5,
      backdropStyle: e.backdropStyle
    }, [
      Nt(c, {
        group: e.currentGroup,
        onTransferOwnership: (io = e.transferOwnershipConfiguration) == null ? void 0 : io.onTransferOwnership,
        titleAlignment: (Wn = e.transferOwnershipConfiguration) == null ? void 0 : Wn.titleAlignment,
        loadingIconURL: (ao = e.transferOwnershipConfiguration) == null ? void 0 : ao.loadingIconURL,
        loadingStateView: (ro = e.transferOwnershipConfiguration) == null ? void 0 : ro.loadingStateView,
        errorStateView: (lo = e.transferOwnershipConfiguration) == null ? void 0 : lo.errorStateView,
        emptyStateView: (Bn = e.transferOwnershipConfiguration) == null ? void 0 : Bn.emptyStateView,
        onError: (Qn = e.transferOwnershipConfiguration) == null ? void 0 : Qn.onError,
        hideSearch: (Dn = e.transferOwnershipConfiguration) == null ? void 0 : Dn.hideSearch,
        searchIconURL: (so = e.transferOwnershipConfiguration) == null ? void 0 : so.searchIconURL,
        hideSeparator: (Rn = e.transferOwnershipConfiguration) == null ? void 0 : Rn.hideSeparator,
        closeButtonIconURL: (qt = e.transferOwnershipConfiguration) == null ? void 0 : qt.closeButtonIconURL,
        disableUsersPresence: (S = e.transferOwnershipConfiguration) == null ? void 0 : S.disableUsersPresence,
        listItemView: (f = e.transferOwnershipConfiguration) == null ? void 0 : f.listItemView,
        subtitleView: (P = e.transferOwnershipConfiguration) == null ? void 0 : P.subtitleView,
        onClose: ((Me = e.transferOwnershipConfiguration) == null ? void 0 : Me.onClose) || e.closeTransferOwnership,
        groupMembersRequestBuilder: (ze = e.transferOwnershipConfiguration) == null ? void 0 : ze.groupMembersRequestBuilder,
        searchRequestBuilder: (Qe = e.transferOwnershipConfiguration) == null ? void 0 : Qe.searchRequestBuilder,
        options: e.transferOwnershipConfiguration.options ? (St, Et) => e.transferOwnershipConfiguration.options(Et) : void 0,
        statusIndicatorStyle: (Ye = e.transferOwnershipConfiguration) == null ? void 0 : Ye.statusIndicatorStyle,
        avatarStyle: (At = e.transferOwnershipConfiguration) == null ? void 0 : At.avatarStyle,
        listItemStyle: ($t = e.transferOwnershipConfiguration) == null ? void 0 : $t.listItemStyle,
        groupMemberStyle: (Ln = e.transferOwnershipConfiguration) == null ? void 0 : Ln.groupMemberStyle,
        transferOwnershipStyle: (wn = e.transferOwnershipConfiguration) == null ? void 0 : wn.transferOwnershipStyle
      }, null, 8, ["group", "onTransferOwnership", "titleAlignment", "loadingIconURL", "loadingStateView", "errorStateView", "emptyStateView", "onError", "hideSearch", "searchIconURL", "hideSeparator", "closeButtonIconURL", "disableUsersPresence", "listItemView", "subtitleView", "onClose", "groupMembersRequestBuilder", "searchRequestBuilder", "options", "statusIndicatorStyle", "avatarStyle", "listItemStyle", "groupMemberStyle", "transferOwnershipStyle"])
    ], 8, bw)) : $("", !0)
  ], 64);
}
const hw = /* @__PURE__ */ $e(KC, [["render", Ew], ["__scopeId", "data-v-9c1bf784"]]);
function rr(e, t) {
  return e.sender.getUid() === t.getUid() ? gt.right : gt.left;
}
function vw(e, t, n, o) {
  let i = {};
  n === gt.right ? i = (o == null ? void 0 : o.senderMessageBubbleStyle) || {} : i = (o == null ? void 0 : o.botMessageBubbleStyle) || {};
  const l = {
    textFont: (i == null ? void 0 : i.textFont) || w(t.typography.text3)
  };
  return n === gt.right ? l.textColor = (i == null ? void 0 : i.textColor) || t.palette.getAccent900() : l.textColor = (i == null ? void 0 : i.textColor) || t.palette.getAccent(), {
    componentName: "CometChatTextBubble",
    props: {
      text: e.getText(),
      textStyle: l
    }
  };
}
function mw(e, t, n, o) {
  let i, l = !1;
  return (e.getStatus() === "send" || e.getStatus() === "wait" || e.getStatus() === "error") && (e.getStatus() === "wait" ? i = Fo.wait : e.getStatus() === "sent" ? i = Fo.sent : e.getStatus() === "error" && (i = Fo.error), l = !0), {
    html: `
    <div style="${`
    display: flex;
    justify-content: ${rr(e, o) === gt.left ? "unset" : "end"};
    align-items: center
    `}">
        <div style="display:inline-block;">
            <cometchat-date
                timestamp=${e.getSentAt()}
                dateStyle='${JSON.stringify(qD(n))}'
                pattern=${yn.time}>
            </cometchat-date>
        </div>
            ${l ? `
                <div style="position: relative; height: 20px; width: 20px">
                    <cometchat-receipt
                        receipt=${i}
                        waitIcon=${t.loadingIconURL}
                        errorIcon=${t.errorIconURL}
                        receiptStyle='${JSON.stringify(
      _D(t == null ? void 0 : t.assistBotStyle, n)
    )}'
                    ></cometchat-receipt>
                </div>
                ` : ""}
    </div>
`
  };
}
const Ow = We({
  name: "AIAssistBotChatView",
  components: { CometChatList: hn, CometChatMessageBubble: ti },
  props: {
    configuration: {
      type: Object,
      default: new el({})
    },
    bot: {
      type: Object,
      default: () => ({})
    },
    sender: {
      type: Object,
      default: () => ({})
    },
    messageSendCallBack: {
      type: Function
    },
    closeCallBack: {
      type: Function
    }
  },
  setup(e) {
    let {
      theme: t
    } = dt("theme", {
      theme: j(new Ke({}))
    });
    const n = j(e.configuration.assistBotStyle), o = j(
      e.configuration.botMessageBubbleStyle
    ), i = j(
      e.configuration.senderMessageBubbleStyle
    ), l = j(Y("COMETCHAT_ASK_BOT_SUBTITLE")), r = j(""), u = j(!0), s = j(null), c = j(""), d = j([]);
    tn(() => {
      e.configuration.botFirstMessageText ? r.value = e.configuration.botFirstMessageText(
        e.bot
      ) : r.value = Y("COMETCHAT_BOT_FIRST_MESSAGE");
      const z = new y.TextMessage(
        e.sender.getUid(),
        r.value,
        I.MessageReceiverType.user
      );
      z.setSentAt(Ce.getUnixTimestamp()), z.setMuid(Ce.ID()), z.setSender(e.bot), d.value.push(z);
    });
    function N(z) {
      c.value = z.detail.value;
    }
    function T() {
      var R;
      if (!c.value)
        return;
      const z = Ce.ID(), k = new y.TextMessage(
        e.bot.getUid(),
        c.value,
        I.MessageReceiverType.user
      );
      k.setSentAt(Ce.getUnixTimestamp()), k.setMuid(z), k.setSender(e.sender), k.setStatus("wait"), d.value.push(k), (R = s == null ? void 0 : s.value) == null || R.emptyInputField(), e.messageSendCallBack && e.messageSendCallBack(c.value, e.bot).then((Q) => {
        const h = new y.TextMessage(
          e.sender.getUid(),
          Q,
          I.MessageReceiverType.user
        );
        h.setSentAt(Ce.getUnixTimestamp()), h.setMuid(Ce.ID()), h.setSender(e.bot), h.setStatus("sent");
        const O = d.value.map((x) => (x.getMuid() === z && x.setStatus("sent"), x));
        O.push(h), d.value = O;
      }).catch(() => {
        d.value = d.value.map((Q) => (Q.getMuid() === z && Q.setStatus("error"), Q));
      });
    }
    function m() {
      e.closeCallBack && e.closeCallBack();
    }
    function A(z = {}, k) {
      return {
        font: z.titleFont || w(k.typography.subtitle1),
        color: z.titleColor || k.palette.getAccent()
      };
    }
    function D(z = {}, k) {
      return {
        font: z.subtitleFont || w(k.typography.caption2),
        color: z.subtitleColor || k.palette.getAccent500()
      };
    }
    return {
      assistBotStyle: n,
      theme: t,
      botMessageBubbleStyle: o,
      senderMessageBubbleStyle: i,
      botFirstMessage: r,
      messages: d,
      subtitleText: l,
      States: ge,
      inputText: c,
      textInputStyle: XD,
      sendIconUrl: yi,
      closeIconURL: Cn,
      onMessageSendClick: T,
      scrollBottom: u,
      messageInputRef: s,
      triggerClose: m,
      getBotChatContainerStyle: HD,
      getBotChatHeaderStyle: ZD,
      getCloseButtonStyle: WD,
      getMessageBubbleStyle: JD,
      getBubbleAlignment: rr,
      getContentView: vw,
      getBubbleFooterView: mw,
      getSendButtonStyle: $D,
      onComposerEditTextChange: N,
      getAvatarStyle: KD,
      getBotBackgroundStyle: ey,
      getMessageListFooterStyle: ty,
      getBotTitleStyle: A,
      getBotSubtitleStyle: D
    };
  }
}), xw = { style: { display: "flex", gap: "10px", "align-items": "center" } }, kw = ["name", "avatarStyle", "image"], fw = ["iconURL", "onClick", "buttonStyle"], Uw = ["textInputStyle"], Bw = ["iconURL", "onClick", "buttonStyle"];
function Qw(e, t, n, o, i, l) {
  var s, c, d, N, T, m, A, D, z;
  const r = Je("CometChatMessageBubble"), u = Je("CometChatList");
  return M(), g("div", {
    style: ce(e.getBotBackgroundStyle(e.theme))
  }, [
    p("div", {
      style: ce(e.getBotChatContainerStyle(e.assistBotStyle, e.theme))
    }, [
      p("div", {
        style: ce(e.getBotChatHeaderStyle(e.theme))
      }, [
        p("div", xw, [
          p("cometchat-avatar", {
            name: (s = e.bot) == null ? void 0 : s.getName(),
            avatarStyle: e.getAvatarStyle((c = e.configuration) == null ? void 0 : c.avatarStyle),
            image: (d = e.bot) == null ? void 0 : d.getAvatar()
          }, null, 8, kw),
          p("div", null, [
            p("div", {
              style: ce(e.getBotTitleStyle(e.assistBotStyle, e.theme))
            }, kt((N = e.bot) == null ? void 0 : N.getName()), 5),
            p("div", {
              style: ce(e.getBotSubtitleStyle(e.assistBotStyle, e.theme))
            }, kt(e.subtitleText), 5)
          ])
        ]),
        p("div", null, [
          p("cometchat-button", {
            iconURL: ((T = e.configuration) == null ? void 0 : T.closeIconURL) || e.closeIconURL,
            onClick: e.triggerClose,
            buttonStyle: e.getCloseButtonStyle((m = e.configuration) == null ? void 0 : m.assistBotStyle, e.theme)
          }, null, 8, fw)
        ])
      ], 4),
      Nt(u, {
        style: { height: "calc(100% - 90px)" },
        list: e.messages,
        "list-item-key": "getMuid",
        state: e.States.loaded,
        "hide-search": !0,
        "scroll-to-bottom": e.scrollBottom
      }, {
        listItem: be(({ item: k }) => [
          Nt(r, {
            id: k == null ? void 0 : k.id,
            messageBubbleStyle: e.getMessageBubbleStyle(k, e.theme, e.sender, e.configuration),
            alignment: e.getBubbleAlignment(k, e.sender),
            contentView: e.getContentView(k, e.theme, e.getBubbleAlignment(k, e.sender), e.configuration),
            footerView: e.getBubbleFooterView(k, e.configuration, e.theme, e.sender)
          }, null, 8, ["id", "messageBubbleStyle", "alignment", "contentView", "footerView"])
        ]),
        _: 1
      }, 8, ["list", "state", "scroll-to-bottom"]),
      p("div", {
        style: ce(e.getMessageListFooterStyle())
      }, [
        p("cometchat-text-input", {
          style: { flex: "0.99" },
          ref: "messageInputRef",
          textInputStyle: e.textInputStyle((A = e.configuration) == null ? void 0 : A.textInputStyle, e.theme),
          onCcTextInputChanged: t[0] || (t[0] = (...k) => e.onComposerEditTextChange && e.onComposerEditTextChange(...k)),
          onCcTextInputEntered: t[1] || (t[1] = (...k) => e.onMessageSendClick && e.onMessageSendClick(...k))
        }, null, 40, Uw),
        p("cometchat-button", {
          iconURL: ((D = e.configuration) == null ? void 0 : D.sendIconURL) || e.sendIconUrl,
          onClick: () => e.onMessageSendClick(),
          buttonStyle: e.getSendButtonStyle((z = e.configuration) == null ? void 0 : z.assistBotStyle, e.theme)
        }, null, 8, Bw)
      ], 4)
    ], 4)
  ], 4);
}
const Rw = /* @__PURE__ */ $e(Ow, [["render", Qw]]), Yw = We({
  name: "DynamicRenderer",
  props: {
    /**
     * The customView prop is used to specify the type of custom view to be rendered.
     *
     * @type {ViewType}
     * @required
     */
    customView: {
      type: Object,
      required: !0
    }
  }
}), Vw = { key: 0 }, Gw = ["innerHTML"], Pw = ["innerHTML"];
function Fw(e, t, n, o, i, l) {
  return e.customView ? (M(), g("div", Vw, [
    e.customView.html ? (M(), g("div", {
      key: 0,
      innerHTML: e.customView.html
    }, null, 8, Gw)) : (M(), je(fe(e.customView.componentName), me({ key: 1 }, e.customView.props || {}, xe(e.customView.listeners || {})), Ho({ _: 2 }, [
      pe(e.customView.slots, (r, u) => ({
        name: r.key,
        fn: be(() => [
          p("div", {
            innerHTML: r == null ? void 0 : r.html
          }, null, 8, Pw)
        ])
      }))
    ]), 1040))
  ])) : $("", !0);
}
const Hw = /* @__PURE__ */ $e(Yw, [["render", Fw]]), Zw = We({
  name: "CometChatMessages",
  components: {
    CometChatMessageList: or,
    CometChatDetails: hw,
    CometChatThreadedMessages: SC,
    CometChatMessageHeader: ar,
    CometChatMessageComposer: ir,
    // eslint-disable-next-line vue/no-unused-components
    AIAssistBotChatView: Rw,
    DynamicRenderer: Hw
  },
  props: {
    user: { type: Object },
    group: { type: Object },
    hideMessageComposer: {
      type: Boolean,
      default: !1
    },
    disableTyping: {
      type: Boolean,
      default: !1
    },
    messageHeaderConfiguration: {
      type: Object,
      default: () => new tl({})
    },
    messageListConfiguration: {
      type: Object,
      default: () => new La({})
    },
    messageComposerConfiguration: {
      type: Object,
      default: () => new za({})
    },
    threadedMessagesConfiguration: {
      type: Object,
      default: () => new nl({})
    },
    detailsConfiguration: {
      type: Object,
      default: () => new ol({})
    },
    customSoundForIncomingMessages: { type: String },
    customSoundForOutgoingMessages: { type: String },
    disableSoundForMessages: {
      type: Boolean,
      default: !1
    },
    messagesStyle: {
      type: Object,
      default: () => ({})
    },
    messageHeaderView: { type: Object },
    messageComposerView: { type: Object },
    messageListView: { type: Object },
    hideMessageHeader: {
      type: Boolean,
      default: !1
    },
    hideDetails: {
      type: Boolean,
      default: !1
    },
    auxiliaryMenu: { type: Object },
    onError: {
      type: Function,
      default: (e) => console.log(e)
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    }), n, o = j(!1), i = j(Fl), l, r = j(!1);
    const u = j(null), s = j(null), c = j({
      position: "absolute",
      display: "flex",
      alignItems: "center",
      height: "100%",
      width: "100%",
      justifyContent: "center",
      zIndex: 1e3,
      overflow: "hidden"
    });
    let d = {
      borderRadius: "16px",
      width: "28px",
      height: "28px",
      border: "none",
      backgroundColor: "white",
      nameTextColor: "rgb(20,20,20)",
      backgroundSize: "cover",
      nameTextFont: "500 16px Inter",
      outerViewBorderWidth: "",
      outerViewBorderSpacing: ""
    }, N = {
      height: "24px",
      width: "24px",
      border: "none",
      borderRadius: "0",
      background: "transparent",
      buttonIconTint: t.value.palette.getPrimary(),
      padding: "0px 8px 0px 14px",
      "margin-right": "10px"
    }, T, m, A, D, z, k, R, Q = j(!1), h = j(e.user), O = j(e.group), x = j(), _ = j(null), oe = j(!1), ie = j({}), re, Ae = !1;
    function se() {
      if (e.detailsConfiguration.data)
        return e.detailsConfiguration.data(e == null ? void 0 : e.user, e == null ? void 0 : e.group);
    }
    const X = () => {
      var L, b;
      return {
        height: "20px",
        width: "25px",
        background: ((b = (L = e == null ? void 0 : e.messageComposerConfiguration) == null ? void 0 : L.messageComposerStyle) == null ? void 0 : b.liveReactionIconTint) || "red"
      };
    };
    function B() {
      const L = u.value;
      s.value = L, c.value = {
        zIndex: 1e3,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        height: (L == null ? void 0 : L.offsetHeight) + "px" || "100%",
        width: (L == null ? void 0 : L.offsetWidth) + "px" || "100%",
        justifyContent: "center",
        overflow: "hidden"
      };
    }
    tn(() => {
      const L = u.value;
      s.value = L, window.addEventListener("resize", B);
    }), Xo(() => {
      window.removeEventListener("resize", B);
    }), Ko(() => {
      const L = u.value;
      s.value = L;
    });
    const F = () => l;
    Zt(async () => {
      G(), ee(), e.user ? (h.value = e.user, O.value = null) : (h.value = null, O.value = e.group), await y.getLoggedinUser().then((L) => {
        L && (n = L);
      }).catch((L) => {
        if (e.onError) {
          let b = new y.CometChatException({
            message: L.message
          });
          e.onError(b);
        }
      });
    }), tn(() => {
      G();
    }), eo(async () => {
      var L, b, v, U, Se;
      !h.value && ((L = e.user) != null && L.getUid()) || h.value && e.user && h.value.getUid() != ((b = e.user) == null ? void 0 : b.getUid()) ? (Ae = !0, h.value = e.user, O.value = null) : (!O.value && ((v = e.group) != null && v.getGuid()) || O.value) && (((U = O.value) == null ? void 0 : U.getGuid()) != ((Se = e.group) == null ? void 0 : Se.getGuid()) && (Ae = !0), O.value = e.group, h.value = null);
      try {
        Ae && (oe.value = !1, Q.value = !1);
      } catch (Ue) {
        if (e.onError) {
          let Re = new y.CometChatException({
            message: Ue.message
          });
          e.onError(Re);
        }
      }
      Ae = !1;
    }), un(() => {
      T.unsubscribe(), oe.value = !1, Q.value = !1, J();
    });
    const G = () => {
      T = ae.ccLiveReaction.subscribe(
        (L) => {
          L && L === "heart" && V(
            e.messageComposerConfiguration.LiveReactionIconURL || Va
          );
        }
      ), m = He.ccGroupDeleted.subscribe(
        (L) => {
          O.value && O.value.getGuid() == L.getGuid() && (Q.value = !1, oe.value = !1, O.value = L);
        }
      ), A = He.ccGroupLeft.subscribe(
        (L) => {
          O.value && O.value.getGuid() == L.leftGroup.getGuid() && ((n == null ? void 0 : n.getUid()) == (L == null ? void 0 : L.userLeft.getUid()) && (Q.value = !1, oe.value = !1), O.value = L.leftGroup);
        }
      ), D = En.ccUserBlocked.subscribe(
        (L) => {
          h.value && h.value.getUid() == L.getUid() && (h.value = L);
        }
      ), z = En.ccUserUnblocked.subscribe(
        (L) => {
          h.value && h.value.getUid() == L.getUid() && (h.value = L);
        }
      ), k = it.ccShowPanel.subscribe((L) => {
        L.position === qn.messages && (l = L.child, r.value = !0);
      }), R = it.ccHidePanel.subscribe((L) => {
        L === qn.messages && (r.value = !1, l = void 0);
      });
    }, J = () => {
      T == null || T.unsubscribe(), m == null || m.unsubscribe(), A == null || A.unsubscribe(), D == null || D.unsubscribe(), z == null || z.unsubscribe(), k == null || k.unsubscribe(), R == null || R.unsubscribe();
    }, ee = () => {
      re = {
        ...new il({
          width: "100%",
          height: "100%",
          background: t.value.palette.getBackground(),
          borderRadius: "none",
          border: "none"
        }),
        ...e.messagesStyle
      };
    }, V = (L) => {
      o.value && (i.value = "", o.value = !1), i.value = L, o.value = !0, setTimeout(() => {
        i.value = "", o.value = !1;
      }, 1500);
    }, ne = (L, b) => {
      x.value = L, ie.value = b, oe.value = !0;
    }, K = () => {
      Q.value = !0;
    };
    return {
      currentTargetUser: h,
      currentTargetGroup: O,
      MessageBubbleAlignment: gt,
      theme: t,
      closeThreadView: () => {
        x.value = null, oe.value = !1;
      },
      threadMessageObject: x,
      child_component: _,
      openThreadedMessages: oe,
      openThreadView: ne,
      bubbleGeneratorFunction: ie,
      chatListStyle: () => ({
        background: re.background || t.value.palette.getBackground(),
        height: re.height,
        width: re.width,
        border: re.border,
        borderRadius: re.borderRadius
      }),
      reactionName: i,
      openDetails: Q,
      getHeaderMenu: () => {
        const L = Ne.getDataSource().getAuxiliaryHeaderMenu ? Ne.getDataSource().getAuxiliaryHeaderMenu(
          h.value,
          O.value
        ) : [];
        let b = [];
        return e.auxiliaryMenu ? b.push(e.auxiliaryMenu) : b.push(
          ...L.map((v) => v.componentName ? v : { html: v })
        ), e.hideDetails || b.push({
          componentName: "cometchat-button",
          listeners: {
            "cc-button-clicked": K
          },
          props: {
            iconURL: hi,
            buttonStyle: N
          }
        }), b;
      },
      liveReaction: o,
      avatarStyle: d,
      closeDetailsPage: () => {
        Q.value = !1;
      },
      showPanelView: r,
      getPanelComponentView: F,
      panelBackgroundRef: u,
      panelDivStyle: c,
      getDetailsTemplate: se,
      getLiveReactionStyle: X
    };
  }
});
const Ww = {
  class: "cc-messages-wrapper",
  ref: "panelBackgroundRef"
}, $w = {
  key: 0,
  class: "cc-messages-wrapper__header"
}, Jw = {
  key: 2,
  class: "cc-messages-wrapper__messages-list"
}, Kw = {
  key: 3,
  class: "cc-messages-wrapper__composer"
}, Xw = { class: "cc__messages__livereaction" }, qw = ["reactionIconURL", "liveReactionStyle"], _w = {
  key: 2,
  class: "cc-messages-wrapper__threadedmessages"
}, ej = {
  key: 3,
  class: "cc-messages-wrapper__details"
};
function tj(e, t, n, o, i, l) {
  var T, m, A, D, z, k, R, Q, h, O, x, _, oe, ie, re, Ae, se, X, B, F, G, J, ee, V, ne, K, Ie, Te, H, Ee, L, b, v, U, Se, Ue, Re, _e, Z, ke, q, ye, Oe, he, Pe, lt, It, Gt, de, Le, Fe, tt, st, ct, wt, Lt, jt, Wt, ot, zt, yt, on, ft, rt, Tt, Pt, Rt, Yt, en, gn, bt, Ut, cn, rn, ln, Tn, Vt, Xt;
  const r = Je("DynamicRenderer"), u = Je("CometChatMessageHeader"), s = Je("CometChatMessageList"), c = Je("CometChatMessageComposer"), d = Je("CometChatThreadedMessages"), N = Je("CometChatDetails");
  return M(), g("div", Ww, [
    e.showPanelView && e.getPanelComponentView() ? (M(), je(r, {
      key: 0,
      customView: e.getPanelComponentView()
    }, null, 8, ["customView"])) : $("", !0),
    e.user || e.group ? (M(), g("div", {
      key: 1,
      class: "cc-messages-wrapper__messages",
      style: ce(e.chatListStyle())
    }, [
      e.hideMessageHeader ? $("", !0) : (M(), g("div", $w, [
        e.messageHeaderView ? (M(), je(r, {
          key: 0,
          customView: e.messageHeaderView
        }, null, 8, ["customView"])) : (M(), je(u, {
          key: 1,
          user: e.currentTargetUser,
          group: e.currentTargetGroup,
          subtitleView: e.messageHeaderConfiguration.subtitleView,
          disableUsersPresence: e.messageHeaderConfiguration.disableUsersPresence,
          protectedGroupIcon: e.messageHeaderConfiguration.protectedGroupIcon,
          privateGroupIcon: e.messageHeaderConfiguration.privateGroupIcon,
          menu: e.messageHeaderConfiguration.menu ? e.messageHeaderConfiguration.menu : e.getHeaderMenu(),
          messageHeaderStyle: (T = e.messageHeaderConfiguration) == null ? void 0 : T.messageHeaderStyle,
          backButtonIconURL: (m = e.messageHeaderConfiguration) == null ? void 0 : m.backButtonIconURL,
          hideBackButton: e.messageHeaderConfiguration.hideBackButton,
          onError: (A = e.messageHeaderConfiguration) == null ? void 0 : A.onError,
          onBack: (D = e.messageHeaderConfiguration) == null ? void 0 : D.onBack,
          listItemStyle: e.messageHeaderConfiguration.listItemStyle,
          statusIndicatorStyle: e.messageHeaderConfiguration.statusIndicatorStyle,
          avatarStyle: e.messageHeaderConfiguration.avatarStyle
        }, null, 8, ["user", "group", "subtitleView", "disableUsersPresence", "protectedGroupIcon", "privateGroupIcon", "menu", "messageHeaderStyle", "backButtonIconURL", "hideBackButton", "onError", "onBack", "listItemStyle", "statusIndicatorStyle", "avatarStyle"]))
      ])),
      e.messageListView ? (M(), je(r, {
        key: 1,
        customView: e.messageListView
      }, null, 8, ["customView"])) : (M(), g("div", Jw, [
        Nt(s, {
          disableSoundForMessages: e.disableSoundForMessages,
          customSoundForMessages: e.customSoundForIncomingMessages,
          emptyStateView: (z = e.messageListConfiguration) == null ? void 0 : z.emptyStateView,
          loadingStateView: (k = e.messageListConfiguration) == null ? void 0 : k.loadingStateView,
          user: e.currentTargetUser,
          group: e.currentTargetGroup,
          errorStateView: (R = e.messageListConfiguration) == null ? void 0 : R.errorStateView,
          disableReceipt: (Q = e.messageListConfiguration) == null ? void 0 : Q.disableReceipt,
          hideReceipt: (h = e.messageListConfiguration) == null ? void 0 : h.hideReceipt,
          readIcon: (O = e.messageListConfiguration) == null ? void 0 : O.readIcon,
          deliveredIcon: (x = e.messageListConfiguration) == null ? void 0 : x.deliveredIcon,
          sentIcon: (_ = e.messageListConfiguration) == null ? void 0 : _.sentIcon,
          waitIcon: (oe = e.messageListConfiguration) == null ? void 0 : oe.waitIcon,
          errorIcon: (ie = e.messageListConfiguration) == null ? void 0 : ie.errorIcon,
          alignment: (re = e.messageListConfiguration) == null ? void 0 : re.alignment,
          showAvatar: (Ae = e.messageListConfiguration) == null ? void 0 : Ae.showAvatar,
          datePattern: (se = e.messageListConfiguration) == null ? void 0 : se.datePattern,
          timestampAlignment: (X = e.messageListConfiguration) == null ? void 0 : X.timestampAlignment,
          DateSeparatorPattern: (B = e.messageListConfiguration) == null ? void 0 : B.DateSeparatorPattern,
          templates: (F = e.messageListConfiguration) == null ? void 0 : F.templates,
          messagesRequestBuilder: e.messageListConfiguration.messagesRequestBuilder,
          thresholdValue: (G = e.messageListConfiguration) == null ? void 0 : G.thresholdValue,
          onThreadRepliesClick: e.openThreadView,
          headerView: (J = e.messageListConfiguration) == null ? void 0 : J.headerView,
          footerView: (ee = e.messageListConfiguration) == null ? void 0 : ee.footerView,
          avatarStyle: (V = e.messageListConfiguration) == null ? void 0 : V.avatarStyle,
          dateSeparatorStyle: (ne = e.messageListConfiguration) == null ? void 0 : ne.dateSeparatorStyle,
          messageListStyle: (K = e.messageListConfiguration) == null ? void 0 : K.messageListStyle,
          onError: (Ie = e.messageListConfiguration) == null ? void 0 : Ie.onError,
          reactionsConfiguration: (Te = e.messageListConfiguration) == null ? void 0 : Te.reactionsConfiguration,
          disableReactions: (H = e.messageListConfiguration) == null ? void 0 : H.disableReactions,
          emojiKeyboardStyle: (Ee = e.messageListConfiguration) == null ? void 0 : Ee.emojiKeyboardStyle,
          threadIndicatorIcon: (L = e.messageListConfiguration) == null ? void 0 : L.threadIndicatorIcon,
          disableMentions: (b = e.messageListConfiguration) == null ? void 0 : b.disableMentions,
          textFormatters: (v = e.messageListConfiguration) == null ? void 0 : v.textFormatters,
          messageInformationConfiguration: (U = e.messageListConfiguration) == null ? void 0 : U.messageInformationConfiguration,
          backdropStyle: (Se = e.messageListConfiguration) == null ? void 0 : Se.backdropStyle,
          loadingIconURL: (Ue = e.messageListConfiguration) == null ? void 0 : Ue.loadingIconURL,
          hideError: (Re = e.messageListConfiguration) == null ? void 0 : Re.hideError
        }, null, 8, ["disableSoundForMessages", "customSoundForMessages", "emptyStateView", "loadingStateView", "user", "group", "errorStateView", "disableReceipt", "hideReceipt", "readIcon", "deliveredIcon", "sentIcon", "waitIcon", "errorIcon", "alignment", "showAvatar", "datePattern", "timestampAlignment", "DateSeparatorPattern", "templates", "messagesRequestBuilder", "thresholdValue", "onThreadRepliesClick", "headerView", "footerView", "avatarStyle", "dateSeparatorStyle", "messageListStyle", "onError", "reactionsConfiguration", "disableReactions", "emojiKeyboardStyle", "threadIndicatorIcon", "disableMentions", "textFormatters", "messageInformationConfiguration", "backdropStyle", "loadingIconURL", "hideError"])
      ])),
      e.hideMessageComposer ? $("", !0) : (M(), g("div", Kw, [
        e.messageComposerView && !e.openThreadedMessages ? (M(), je(r, {
          key: 0,
          customView: e.messageComposerView
        }, null, 8, ["customView"])) : e.openThreadedMessages ? $("", !0) : (M(), je(c, {
          key: 1,
          id: e.currentTargetUser ? e.currentTargetUser.getUid() : e.currentTargetGroup.getGuid(),
          disableSoundForMessages: e.disableSoundForMessages,
          customSoundForMessage: e.customSoundForOutgoingMessages,
          user: e.currentTargetUser,
          group: e.currentTargetGroup,
          text: (_e = e.messageComposerConfiguration) == null ? void 0 : _e.text,
          headerView: (Z = e.messageComposerConfiguration) == null ? void 0 : Z.headerView,
          onTextChange: (ke = e.messageComposerConfiguration) == null ? void 0 : ke.onTextChange,
          attachmentIconURL: (q = e.messageComposerConfiguration) == null ? void 0 : q.attachmentIconURL,
          attachmentOptions: (ye = e.messageComposerConfiguration) == null ? void 0 : ye.attachmentOptions,
          secondaryButtonView: (Oe = e.messageComposerConfiguration) == null ? void 0 : Oe.secondaryButtonView,
          auxiliaryButtonView: (he = e.messageComposerConfiguration) == null ? void 0 : he.auxilaryButtonView,
          auxiliaryButtonsAlignment: (Pe = e.messageComposerConfiguration) == null ? void 0 : Pe.auxiliaryButtonsAlignment,
          sendButtonView: (lt = e.messageComposerConfiguration) == null ? void 0 : lt.sendButtonView,
          hideLiveReaction: (It = e.messageComposerConfiguration) == null ? void 0 : It.hideLiveReaction,
          LiveReactionIconURL: (Gt = e.messageComposerConfiguration) == null ? void 0 : Gt.LiveReactionIconURL,
          messageComposerStyle: (de = e.messageComposerConfiguration) == null ? void 0 : de.messageComposerStyle,
          hideLayoutMode: (Le = e.messageComposerConfiguration) == null ? void 0 : Le.hideLayoutMode,
          actionSheetStyle: (Fe = e.messageComposerConfiguration) == null ? void 0 : Fe.actionSheetStyle,
          AIOptionsStyle: (tt = e.messageComposerConfiguration) == null ? void 0 : tt.AIOptionsStyle,
          AIIconURL: e.messageComposerConfiguration.AIIconURL,
          onSendButtonClick: (st = e.messageComposerConfiguration) == null ? void 0 : st.onSendButtonClick,
          onError: (ct = e.messageComposerConfiguration) == null ? void 0 : ct.onError,
          hideVoiceRecording: (wt = e.messageComposerConfiguration) == null ? void 0 : wt.hideVoiceRecording,
          voiceRecordingStartIconURL: (Lt = e.messageComposerConfiguration) == null ? void 0 : Lt.voiceRecordingStartIconURL,
          voiceRecordingCloseIconURL: (jt = e.messageComposerConfiguration) == null ? void 0 : jt.voiceRecordingCloseIconURL,
          voiceRecordingStopIconURL: (Wt = e.messageComposerConfiguration) == null ? void 0 : Wt.voiceRecordingStopIconURL,
          voiceRecordingSubmitIconURL: (ot = e.messageComposerConfiguration) == null ? void 0 : ot.voiceRecordingSubmitIconURL,
          userMemberWrapperConfiguration: (zt = e.messageComposerConfiguration) == null ? void 0 : zt.userMemberWrapperConfiguration,
          textFormatters: (yt = e.messageComposerConfiguration) == null ? void 0 : yt.textFormatters,
          disableMentions: (on = e.messageComposerConfiguration) == null ? void 0 : on.disableMentions,
          mentionsWarningText: (ft = e.messageComposerConfiguration) == null ? void 0 : ft.mentionsWarningText,
          mentionsWarningStyle: (rt = e.messageComposerConfiguration) == null ? void 0 : rt.mentionsWarningStyle,
          sendButtonIconURL: (Tt = e.messageComposerConfiguration) == null ? void 0 : Tt.sendButtonIconURL,
          mediaRecorderStyle: (Pt = e.messageComposerConfiguration) == null ? void 0 : Pt.mediaRecorderStyle,
          emojiIconURL: (Rt = e.messageComposerConfiguration) == null ? void 0 : Rt.emojiIconURL
        }, null, 8, ["id", "disableSoundForMessages", "customSoundForMessage", "user", "group", "text", "headerView", "onTextChange", "attachmentIconURL", "attachmentOptions", "secondaryButtonView", "auxiliaryButtonView", "auxiliaryButtonsAlignment", "sendButtonView", "hideLiveReaction", "LiveReactionIconURL", "messageComposerStyle", "hideLayoutMode", "actionSheetStyle", "AIOptionsStyle", "AIIconURL", "onSendButtonClick", "onError", "hideVoiceRecording", "voiceRecordingStartIconURL", "voiceRecordingCloseIconURL", "voiceRecordingStopIconURL", "voiceRecordingSubmitIconURL", "userMemberWrapperConfiguration", "textFormatters", "disableMentions", "mentionsWarningText", "mentionsWarningStyle", "sendButtonIconURL", "mediaRecorderStyle", "emojiIconURL"]))
      ])),
      p("div", Xw, [
        e.liveReaction ? (M(), g("cometchat-live-reaction", {
          key: 0,
          reactionIconURL: e.reactionName,
          liveReactionStyle: e.getLiveReactionStyle()
        }, null, 8, qw)) : $("", !0)
      ])
    ], 4)) : $("", !0),
    e.openThreadedMessages ? (M(), g("div", _w, [
      Nt(d, {
        onClose: ((Yt = e.threadedMessagesConfiguration) == null ? void 0 : Yt.onClose) || e.closeThreadView,
        threadedMessagesStyle: (en = e.threadedMessagesConfiguration) == null ? void 0 : en.threadedMessagesStyle,
        messageActionView: (gn = e.threadedMessagesConfiguration) == null ? void 0 : gn.messageActionView,
        messageComposerConfiguration: (bt = e.threadedMessagesConfiguration) == null ? void 0 : bt.messageComposerConfiguration,
        messageListConfiguration: ((Ut = e.threadedMessagesConfiguration) == null ? void 0 : Ut.messageListConfiguration) || e.messageListConfiguration,
        closeIconURL: (cn = e.threadedMessagesConfiguration) == null ? void 0 : cn.closeIconURL,
        onError: (rn = e.threadedMessagesConfiguration) == null ? void 0 : rn.onError,
        parentMessage: e.threadMessageObject,
        user: e.currentTargetUser,
        group: e.currentTargetGroup,
        bubbleView: ((ln = e.threadedMessagesConfiguration) == null ? void 0 : ln.bubbleView) || e.bubbleGeneratorFunction,
        hideMessageComposer: (Tn = e.threadedMessagesConfiguration) == null ? void 0 : Tn.hideMessageComposer,
        messageListView: (Vt = e.threadedMessagesConfiguration) == null ? void 0 : Vt.messageListView,
        messageComposerView: (Xt = e.threadedMessagesConfiguration) == null ? void 0 : Xt.messageComposerView
      }, null, 8, ["onClose", "threadedMessagesStyle", "messageActionView", "messageComposerConfiguration", "messageListConfiguration", "closeIconURL", "onError", "parentMessage", "user", "group", "bubbleView", "hideMessageComposer", "messageListView", "messageComposerView"])
    ])) : $("", !0),
    e.openDetails ? (M(), g("div", ej, [
      Nt(N, {
        transferOwnershipConfiguration: e.detailsConfiguration.transferOwnershipConfiguration,
        groupMembersConfiguration: e.detailsConfiguration.groupMembersConfiguration,
        bannedMembersConfiguration: e.detailsConfiguration.bannedMembersConfiguration,
        addMembersConfiguration: e.detailsConfiguration.addMembersConfiguration,
        onClose: e.detailsConfiguration.onClose || e.closeDetailsPage,
        listItemStyle: e.detailsConfiguration.listItemStyle,
        detailsStyle: e.detailsConfiguration.detailsStyle,
        avatarStyle: e.detailsConfiguration.avatarStyle,
        statusIndicatorStyle: e.detailsConfiguration.statusIndicatorStyle,
        leaveDialogStyle: e.detailsConfiguration.leaveDialogStyle,
        data: e.getDetailsTemplate(),
        customProfileView: e.detailsConfiguration.customProfileView,
        subtitleView: e.detailsConfiguration.subtitleView,
        hideProfile: e.detailsConfiguration.hideProfile,
        onError: e.detailsConfiguration.onError,
        closeButtonIconURL: e.detailsConfiguration.closeButtonIconURL,
        user: e.currentTargetUser,
        group: e.currentTargetGroup
      }, null, 8, ["transferOwnershipConfiguration", "groupMembersConfiguration", "bannedMembersConfiguration", "addMembersConfiguration", "onClose", "listItemStyle", "detailsStyle", "avatarStyle", "statusIndicatorStyle", "leaveDialogStyle", "data", "customProfileView", "subtitleView", "hideProfile", "onError", "closeButtonIconURL", "user", "group"])
    ])) : $("", !0)
  ], 512);
}
const fi = /* @__PURE__ */ $e(Zw, [["render", tj], ["__scopeId", "data-v-0a8e9ef0"]]), nj = We({
  name: "CometChatGroups",
  components: {
    CometChatList: hn
  },
  props: {
    title: {
      type: String,
      default: () => Y("GROUPS")
    },
    titleAlignment: {
      type: Number,
      default: () => kn.left
    },
    searchPlaceholderText: {
      type: String,
      default: () => Y("SEARCH")
    },
    subtitleView: {
      type: Function
    },
    menus: {
      type: Object
    },
    listItemView: {
      type: Function
    },
    options: {
      type: Function
    },
    groupsRequestBuilder: {
      type: Object
    },
    SearchRequestBuilder: {
      type: Object
    },
    disableUsersPresence: {
      type: Boolean,
      default: !1
    },
    hideSeparator: {
      type: Boolean,
      default: !1
    },
    selectionMode: {
      type: Number,
      default: () => xt.none
    },
    onSelect: {
      type: Function
    },
    searchIconURL: {
      type: String,
      default: Yn
    },
    protectedGroupIcon: {
      type: String,
      default: Yo
    },
    privateGroupIcon: {
      type: String,
      default: Vo
    },
    hideSearch: {
      type: Boolean,
      default: !1
    },
    hideError: {
      type: Boolean,
      default: !1
    },
    emptyStateView: {
      type: Object
    },
    errorStateText: {
      type: String,
      default: () => Y("SOMETHING_WRONG")
    },
    emptyStateText: {
      type: String,
      default: () => Y("NO_GROUPS_FOUND")
    },
    activeGroup: {
      type: Object
    },
    onItemClick: {
      type: Function
    },
    onError: {
      type: Function
    },
    avatarStyle: {
      type: Object,
      default: () => ({})
    },
    statusIndicatorStyle: {
      type: Object,
      default: () => ({})
    },
    listItemStyle: {
      type: Object,
      default: () => ({})
    },
    groupsStyle: {
      type: Object,
      default: () => ({})
    },
    loadingIconURL: {
      type: String,
      default: nn
    },
    loadingStateView: {
      type: Object
    },
    errorStateView: {
      type: Object
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    });
    const n = j([]), o = j(30), i = j(null), l = j(ge.loading), r = j("");
    let u = null, s = j(e.avatarStyle), c = j(e.statusIndicatorStyle), d = j({}), N = j(e.listItemStyle), T = j(e.groupsStyle);
    j(null);
    const m = j("userlist_" + (/* @__PURE__ */ new Date()).getTime()), A = j(
      "connection_" + (/* @__PURE__ */ new Date()).getTime()
    ), D = j(), z = j(), k = j(), R = j(), Q = j(), h = j(), O = j();
    let x = j(e.activeGroup);
    const _ = j({
      private: "",
      password: "#F7A500",
      public: ""
    });
    function oe() {
      O.value = He.ccGroupDeleted.subscribe(
        (Z) => {
          ne(Z), x.value && Z.getGuid() == x.value.getGuid() && (x.value = null);
        }
      ), He.ccGroupCreated.subscribe(
        (Z) => {
          K(Z), x.value || (x.value = Z, x.value = Ce.clone(
            Z
          ));
        }
      ), D.value = He.ccGroupMemberAdded.subscribe(
        (Z) => {
          x.value && x.value.getGuid() == (Z == null ? void 0 : Z.userAddedIn.getGuid()) && (x.value = Ce.clone(
            Z == null ? void 0 : Z.userAddedIn
          )), ee(Z == null ? void 0 : Z.userAddedIn);
        }
      ), Q.value = He.ccGroupMemberBanned.subscribe(
        (Z) => {
          x.value && x.value.getGuid() == (Z == null ? void 0 : Z.kickedFrom.getGuid()) && (x.value = Ce.clone(
            Z == null ? void 0 : Z.kickedFrom
          )), ee(Z == null ? void 0 : Z.kickedFrom);
        }
      ), k.value = He.ccGroupMemberJoined.subscribe(
        (Z) => {
          x.value && x.value.getGuid() == (Z == null ? void 0 : Z.joinedGroup.getGuid()) && (x.value = Ce.clone(
            Z == null ? void 0 : Z.joinedGroup
          )), ee(Z == null ? void 0 : Z.joinedGroup);
        }
      ), R.value = He.ccGroupMemberKicked.subscribe(
        (Z) => {
          x.value && x.value.getGuid() == (Z == null ? void 0 : Z.kickedFrom.getGuid()) && (x.value = Ce.clone(
            Z == null ? void 0 : Z.kickedFrom
          )), ee(Z == null ? void 0 : Z.kickedFrom);
        }
      ), h.value = He.ccOwnershipChanged.subscribe(
        (Z) => {
          x.value && x.value.getGuid() == (Z == null ? void 0 : Z.group.getGuid()) && (x.value = Ce.clone(
            Z == null ? void 0 : Z.group
          )), ee(Z == null ? void 0 : Z.group);
        }
      ), z.value = He.ccGroupLeft.subscribe(
        (Z) => {
          Z.leftGroup.getType() == I.GroupTypes.private ? ne(Z.leftGroup) : ee(Z.leftGroup);
        }
      );
    }
    const ie = (Z) => _.value[Z == null ? void 0 : Z.getType()];
    function re() {
      let Z = null;
      const ke = "abort";
      return function(q) {
        return new Promise(
          (ye, Oe) => {
            Z == null || Z.abort(), Z = new AbortController();
            const he = Z;
            let Pe = !1;
            const lt = function It(Gt) {
              he.signal.removeEventListener(ke, It), Pe = !0, Oe(Gt);
            };
            he.signal.addEventListener(
              ke,
              lt
            ), q.fetchNext().finally(() => {
              Pe || he.signal.removeEventListener(
                ke,
                lt
              );
            }).then((It) => {
              ye(It);
            }).catch(Oe);
          }
        );
      };
    }
    const Ae = re(), se = async () => {
      var Z;
      if (i.value && i.value.pagination && (i.value.pagination.current_page == 0 || i.value.pagination.current_page != i.value.pagination.total_pages)) {
        l.value = ge.loading;
        try {
          const ke = await Ae(
            i.value
          );
          ke.length === 0 && n.value.length === 0 ? l.value = ge.empty : (n.value = [...n.value, ...ke], l.value = ge.loaded);
        } catch (ke) {
          e.onError && e.onError(ke), n.value && ((Z = n.value) == null ? void 0 : Z.length) > 0 ? l.value = ge.loaded : l.value = ge.error;
        }
      } else
        l.value = ge.loaded;
    }, X = Ht(() => r.value.length == 0 ? e.groupsRequestBuilder ? e.groupsRequestBuilder.setSearchKeyword("").build() : new y.GroupsRequestBuilder().setLimit(o.value).build() : e.SearchRequestBuilder ? e.SearchRequestBuilder.setSearchKeyword(
      r.value
    ).build() : e.groupsRequestBuilder ? e.groupsRequestBuilder.setSearchKeyword(r.value).build() : new y.GroupsRequestBuilder().setSearchKeyword(r.value).setLimit(o.value).build()), B = (Z) => {
      r.value = Z, l.value = ge.loading, n.value = [], i.value = X.value, se().then();
    }, F = (Z) => {
      e.onItemClick && e.onItemClick(Z);
    }, G = (Z) => {
      let ke;
      switch (Z.getType()) {
        case I.GroupTypes.password:
          ke = e.protectedGroupIcon;
          break;
        case I.GroupTypes.private:
          ke = e.privateGroupIcon;
          break;
        default:
          ke = null;
          break;
      }
      return ke;
    }, J = (Z) => {
      var ke;
      return e.selectionMode == xt.none || !e.selectionMode ? Z.getGuid() == ((ke = e.activeGroup) == null ? void 0 : ke.getGuid()) : !1;
    }, ee = (Z) => {
      if (!Z)
        return;
      let ke = [...n.value], q = ke.findIndex(
        (ye, Oe) => ye.getGuid() === Z.getGuid()
      );
      q > -1 && (ke.splice(q, 1, Z), n.value = [...ke]);
    }, V = (Z) => Z.getMembersCount() > 1 ? Z.getMembersCount() + " " + Y("MEMBERS") : Z.getMembersCount() + " " + Y("MEMBER");
    function ne(Z) {
      let ke = [...n.value], q = ke.findIndex(
        (ye, Oe) => ye.getGuid() === Z.getGuid()
      );
      q > -1 && (ke.splice(q, 1), n.value = ke);
    }
    function K(Z) {
      n.value.unshift(Z);
    }
    const Ie = (Z) => n.value.findIndex((q) => q.getGuid() === Z.getGuid());
    function Te() {
      y.addGroupListener(
        m.value,
        new y.GroupListener({
          onGroupMemberScopeChanged: (Z, ke, q, ye, Oe) => {
            const he = Ie(Oe);
            if (he > -1) {
              let Pe = [...n.value];
              const lt = Pe[he];
              ke.getUid() === (u == null ? void 0 : u.getUid()) && lt.setScope(q), Pe.splice(he, 1, lt), n.value = Pe;
            }
          },
          onGroupMemberKicked: (Z, ke, q, ye) => {
            const Oe = Ie(ye);
            if (Oe > -1) {
              let he = [...n.value];
              const Pe = he[Oe];
              ke.getUid() === (u == null ? void 0 : u.getUid()) && Pe.setHasJoined(!1), Pe.setMembersCount(ye.getMembersCount()), he.splice(Oe, 1, Pe), n.value = he;
            }
          },
          onGroupMemberBanned: (Z, ke, q, ye) => {
            const Oe = Ie(ye);
            if (Oe > -1) {
              let he = [...n.value], Pe = he[Oe];
              if (ke.getUid() === (u == null ? void 0 : u.getUid())) {
                ne(ye);
                return;
              }
              Pe.setMembersCount(ye.getMembersCount()), he.splice(Oe, 1, Pe), n.value = he;
            }
          },
          onGroupMemberUnbanned: (Z, ke, q, ye) => {
            const Oe = Ie(ye);
            if (Oe > -1) {
              let he = [...n.value], Pe = he[Oe];
              ke.getUid() === (u == null ? void 0 : u.getUid()) && Pe.setHasJoined(!1), he.splice(Oe, 1, Pe), n.value = he;
            } else
              K(ye);
          },
          onMemberAddedToGroup: (Z, ke, q, ye) => {
            if (r)
              return;
            const Oe = Ie(ye);
            if (Oe > -1) {
              let he = [...n.value], Pe = he[Oe];
              ke.getUid() === (u == null ? void 0 : u.getUid()) && Pe.setHasJoined(!0), Pe.setMembersCount(ye.getMembersCount()), he.splice(Oe, 1, Pe), n.value = he;
            } else
              ye.setHasJoined(!0), K(ye);
          },
          onGroupMemberLeft: (Z, ke, q) => {
            const ye = Ie(q);
            if (ye > -1) {
              let Oe = [...n.value], he = Oe[ye];
              ke.getUid() === (u == null ? void 0 : u.getUid()) && he.setHasJoined(!1), he.setMembersCount(q.getMembersCount()), Oe.splice(ye, 1, he), n.value = Oe;
            }
          },
          onGroupMemberJoined: (Z, ke, q) => {
            const ye = Ie(q);
            if (ye > -1) {
              let Oe = [...n.value], he = Oe[ye];
              ke.getUid() === (u == null ? void 0 : u.getUid()) && he.setHasJoined(!0), he.setMembersCount(q.getMembersCount()), Oe.splice(ye, 1, he), n.value = Oe;
            }
          }
        })
      ), y.addConnectionListener(
        A.value,
        new y.ConnectionListener({
          onConnected: () => {
            i.value = X.value, l.value = ge.loading, se().then(() => {
              l.value = ge.loaded;
            });
          }
        })
      );
    }
    function H() {
      y.removeUserListener(m.value), y.removeConnectionListener(A.value);
    }
    function Ee() {
      var Z, ke, q, ye, Oe, he;
      (Z = D.value) == null || Z.unsubscribe(), (ke = Q.value) == null || ke.unsubscribe(), (q = k.value) == null || q.unsubscribe(), (ye = R.value) == null || ye.unsubscribe(), (Oe = h.value) == null || Oe.unsubscribe(), (he = z.value) == null || he.unsubscribe();
    }
    tn(() => {
      v(), oe(), y.getLoggedinUser().then((Z) => {
        u = Z;
      }).catch((Z) => {
        e.onError && e.onError(Z);
      }), i.value = X.value, se().then(() => {
        l.value = ge.loaded, Te();
      });
    }), un(() => {
      i.value = null, H(), l.value = ge.loaded, Ee();
    });
    function L(Z, ke) {
      var ye;
      const q = (ye = Z.detail) == null ? void 0 : ye.checked;
      e.onSelect && e.onSelect(ke, q);
    }
    const b = () => ({
      height: T.value.height || "100%",
      width: T.value.width || "100%",
      background: T.value.background,
      border: T.value.border,
      borderRadius: T.value.borderRadius || "0",
      position: "relative"
    });
    function v() {
      U(), Re(), Se(), Ue(), _.value.private = e.groupsStyle.privateGroupIconBackground ?? t.value.palette.getSuccess() ?? "", _.value.password = e.groupsStyle.passwordGroupIconBackground ?? "#F7A500";
    }
    function U() {
      let Z = new Sa({
        subTitleTextFont: w(t.value.typography.subtitle2),
        subTitleTextColor: t.value.palette.getAccent600(),
        background: t.value.palette.getBackground(),
        border: `1px solid ${t.value.palette.getAccent50()}`,
        titleTextFont: w(t.value.typography.title1),
        titleTextColor: t.value.palette.getAccent(),
        emptyStateTextFont: w(t.value.typography.title1),
        emptyStateTextColor: t.value.palette.getAccent600(),
        errorStateTextFont: w(t.value.typography.title1),
        errorStateTextColor: t.value.palette.getAccent600(),
        loadingIconTint: t.value.palette.getAccent600(),
        separatorColor: t.value.palette.getAccent400(),
        privateGroupIconBackground: t.value.palette.getSuccess(),
        passwordGroupIconBackground: "RGB(247, 165, 0)",
        searchIconTint: t.value.palette.getAccent600(),
        searchPlaceholderTextColor: t.value.palette.getAccent600(),
        searchBackground: t.value.palette.getAccent100(),
        searchPlaceholderTextFont: w(t.value.typography.text3),
        searchTextColor: t.value.palette.getAccent600(),
        searchTextFont: w(t.value.typography.text3)
      });
      T.value = { ...Z, ...T.value }, d.value = {
        height: "100%",
        titleTextFont: T.value.titleTextFont,
        titleTextColor: T.value.titleTextColor,
        emptyStateTextFont: T.value.emptyStateTextFont,
        emptyStateTextColor: T.value.emptyStateTextColor,
        errorStateTextFont: T.value.errorStateTextFont,
        errorStateTextColor: T.value.errorStateTextColor,
        loadingIconTint: T.value.loadingIconTint,
        separatorColor: T.value.separatorColor,
        searchIconTint: T.value.searchIconTint,
        searchBorder: T.value.searchBorder,
        searchBorderRadius: T.value.searchBorderRadius,
        searchBackground: T.value.searchBackground,
        searchPlaceholderTextFont: T.value.searchPlaceholderTextFont,
        searchPlaceholderTextColor: T.value.searchPlaceholderTextColor,
        searchTextFont: T.value.searchTextFont,
        searchTextColor: T.value.searchTextColor,
        background: T.value.background
      };
    }
    function Se() {
      let Z = new Kt({
        borderRadius: "24px",
        width: "28px",
        height: "28px",
        border: "none",
        backgroundColor: t.value.palette.getAccent700(),
        nameTextColor: t.value.palette.getAccent900(),
        backgroundSize: "cover",
        nameTextFont: w(t.value.typography.subtitle1),
        outerViewBorderWidth: "",
        outerViewBorderSpacing: ""
      });
      s.value = { ...Z, ...s.value };
    }
    function Ue() {
      let Z = {
        height: "12px",
        width: "12px",
        border: "none",
        borderRadius: "24px"
      };
      c.value = {
        ...Z,
        ...c.value
      };
    }
    function Re() {
      let Z = new _t({
        height: "45px",
        width: "100%",
        background: t.value.palette.getBackground(),
        activeBackground: t.value.palette.getAccent100(),
        borderRadius: "0",
        titleFont: w(t.value.typography.title2),
        titleColor: t.value.palette.getAccent(),
        border: "none",
        separatorColor: t.value.palette.getAccent200(),
        hoverBackground: t.value.palette.getAccent50()
      });
      N.value = { ...Z, ...N.value };
    }
    return {
      fetchNextGroupsList: se,
      Groups: n,
      myavatarStyle: s,
      myListItemStyle: N,
      myStatusIndicatorStyle: c,
      onSearch: B,
      onClick: F,
      getStatusIndicatorColor: ie,
      getGroupIcon: G,
      getActiveGroup: J,
      listStyle: d,
      groupStyle: b,
      subtitleStyle: () => ({
        font: T.value.subTitleTextFont || "12px",
        color: T.value.subTitleTextColor || t.value.palette.getAccent600()
      }),
      getMemberCount: V,
      SelectionMode: xt,
      state: l,
      States: ge,
      searchKeyword: r,
      handleSelection: L
    };
  }
});
const oj = {
  key: 0,
  class: "cc-groups__menus"
}, ij = ["innerHTML"], aj = ["v-slot", "v-html"], rj = { key: 0 }, lj = ["innerHTML"], sj = ["v-slot", "v-html"], Mj = ["title", "avatarURL", "avatarName", "hideSeparator", "avatarStyle", "statusIndicatorStyle", "onCcListitemClicked", "listItemStyle", "statusIndicatorColor", "statusIndicatorIcon", "isActive"], uj = {
  slot: "subtitleView",
  class: "cc-groups__subtitle-view"
}, gj = ["innerHTML"], cj = ["v-slot", "v-html"], dj = {
  key: 0,
  slot: "menuView",
  class: "cc-groups__options-view"
}, Ij = ["data"], Nj = {
  key: 1,
  slot: "tailView",
  class: "cc-groups__selection-single"
}, Tj = ["onCcRadioButtonChanged"], Dj = {
  key: 2,
  slot: "tailView",
  class: "cc-groups__selection-multiple"
}, yj = ["onCcCheckboxChanged"];
function Cj(e, t, n, o, i, l) {
  var u;
  const r = Je("CometChatList");
  return M(), g("div", {
    class: "cc-groups",
    style: ce(e.groupStyle())
  }, [
    e.menus ? (M(), g("div", oj, [
      e.menus.html ? (M(), g("div", {
        key: 0,
        innerHTML: e.menus.html
      }, null, 8, ij)) : (M(), je(fe(e.menus.componentName), me({ key: 1 }, xe((u = e.menus) == null ? void 0 : u.listeners), { ...e.menus.props }), {
        default: be(() => {
          var s;
          return [
            (M(!0), g(we, null, pe((s = e.menus) == null ? void 0 : s.slots, (c, d) => (M(), g("div", {
              key: d,
              "v-slot": [d],
              "v-html": c
            }, null, 8, aj))), 128))
          ];
        }),
        _: 1
      }, 16))
    ])) : $("", !0),
    Nt(r, {
      title: e.title,
      titleAlignment: e.titleAlignment,
      hideSearch: e.hideSearch,
      searchIconURL: e.searchIconURL,
      searchPlaceholderText: e.searchPlaceholderText,
      searchText: e.searchKeyword,
      onSearch: e.onSearch,
      list: e.Groups,
      onScrolledToBottom: e.fetchNextGroupsList,
      state: e.state,
      loadingIconURL: e.loadingIconURL,
      hideError: e.hideError,
      errorStateText: e.errorStateText,
      emptyStateText: e.emptyStateText,
      errorStateView: e.errorStateView,
      emptyStateView: e.emptyStateView,
      loadingStateView: e.loadingStateView,
      scrollToBottom: !1,
      listStyle: e.listStyle,
      listItemKey: "getGuid",
      onError: e.onError
    }, {
      listItem: be(({ item: s }) => {
        var c, d, N, T, m, A, D, z, k;
        return [
          e.listItemView ? (M(), g("div", rj, [
            (c = e.listItemView(s)) != null && c.html ? (M(), g("div", {
              key: 0,
              innerHTML: (d = e.listItemView(s)) == null ? void 0 : d.html
            }, null, 8, lj)) : (M(), je(fe((N = e.listItemView(s)) == null ? void 0 : N.componentName), me({ key: 1 }, xe(s == null ? void 0 : s.listeners), { ...(T = e.listItemView(s)) == null ? void 0 : T.props }), {
              default: be(() => {
                var R;
                return [
                  (M(!0), g(we, null, pe((R = e.listItemView(s)) == null ? void 0 : R.slots, (Q, h) => (M(), g("div", {
                    key: h,
                    "v-slot": [h],
                    "v-html": Q
                  }, null, 8, sj))), 128))
                ];
              }),
              _: 2
            }, 1040))
          ])) : (M(), g("cometchat-list-item", {
            key: 1,
            title: s == null ? void 0 : s.name,
            avatarURL: s == null ? void 0 : s.icon,
            avatarName: s == null ? void 0 : s.name,
            hideSeparator: e.hideSeparator,
            avatarStyle: e.myavatarStyle,
            statusIndicatorStyle: e.myStatusIndicatorStyle,
            onCcListitemClicked: (R) => e.onClick(s),
            listItemStyle: e.myListItemStyle,
            statusIndicatorColor: e.getStatusIndicatorColor(s),
            statusIndicatorIcon: e.getGroupIcon(s),
            isActive: e.getActiveGroup(s)
          }, [
            p("div", uj, [
              e.subtitleView ? (M(), g("div", {
                key: 0,
                style: ce(e.subtitleStyle())
              }, [
                (m = e.subtitleView(s)) != null && m.html ? (M(), g("div", {
                  key: 0,
                  innerHTML: (A = e.subtitleView(s)) == null ? void 0 : A.html
                }, null, 8, gj)) : (M(), je(fe((D = e.subtitleView(s)) == null ? void 0 : D.componentName), me({ key: 1 }, xe(s == null ? void 0 : s.listeners), { ...(z = e.subtitleView(s)) == null ? void 0 : z.props }), {
                  default: be(() => {
                    var R;
                    return [
                      (M(!0), g(we, null, pe((R = e.subtitleView(s)) == null ? void 0 : R.slots, (Q, h) => (M(), g("div", {
                        key: h,
                        "v-slot": [h],
                        "v-html": Q
                      }, null, 8, cj))), 128))
                    ];
                  }),
                  _: 2
                }, 1040))
              ], 4)) : (M(), g("div", {
                key: 1,
                class: "cc-groups__subtitle-view",
                style: ce(e.subtitleStyle())
              }, kt(e.getMemberCount(s)), 5))
            ]),
            e.options ? (M(), g("div", dj, [
              p("cometchat-menu-list", {
                data: (k = e.options) == null ? void 0 : k.call(e, s)
              }, null, 8, Ij)
            ])) : $("", !0),
            e.selectionMode == e.SelectionMode.single ? (M(), g("div", Nj, [
              p("cometchat-radio-button", {
                onCcRadioButtonChanged: (R) => {
                  e.handleSelection(R, s);
                }
              }, null, 40, Tj)
            ])) : $("", !0),
            e.selectionMode == e.SelectionMode.multiple ? (M(), g("div", Dj, [
              p("cometchat-checkbox", {
                onCcCheckboxChanged: (R) => {
                  e.handleSelection(R, s);
                }
              }, null, 40, yj)
            ])) : $("", !0)
          ], 40, Mj))
        ];
      }),
      _: 1
    }, 8, ["title", "titleAlignment", "hideSearch", "searchIconURL", "searchPlaceholderText", "searchText", "onSearch", "list", "onScrolledToBottom", "state", "loadingIconURL", "hideError", "errorStateText", "emptyStateText", "errorStateView", "emptyStateView", "loadingStateView", "listStyle", "onError"])
  ], 4);
}
const lr = /* @__PURE__ */ $e(nj, [["render", Cj], ["__scopeId", "data-v-3beadb69"]]), wj = We({
  name: "CometChatTabs",
  components: { CometChatUsers: ei, CometChatGroups: lr },
  props: {
    tabAlignment: { type: Number },
    tabsStyle: {
      type: Object,
      default: new al({})
    },
    tabs: { type: Object },
    disableDraggable: { type: Boolean, default: !1 }
  },
  setup(e, t) {
    let n = j(), o = j(void 0), { theme: i, switchThemeMode: l } = dt("theme");
    tn(() => {
      var D;
      const A = (D = e.tabs) == null ? void 0 : D.find(
        (z) => z.isActive
      );
      A && r(A);
    });
    const r = (A) => {
      o.value = void 0;
      let D = e.tabs.findIndex(
        (z) => z.id === A.id
      );
      D > -1 && (n.value = A, o.value = e.tabs[D].childView);
    };
    return {
      childViewRef: o,
      getTabsStyle: () => {
        const A = (() => {
          switch (e.tabAlignment) {
            case Lo.top:
            case Lo.left:
              return {
                top: "0",
                left: "0"
              };
            case Lo.bottom:
              return {
                bottom: "0",
                left: "0"
              };
            default:
              return {
                top: "0",
                right: "0"
              };
          }
        })(), { background: D, height: z, width: k } = e.tabsStyle ?? {};
        return {
          background: D,
          "z-index": 10,
          ...A,
          height: z || "fit-content",
          width: k || "fit-content",
          position: "absolute"
        };
      },
      getTabsPlacement: () => ({
        display: "flex",
        flexDirection: e.tabAlignment == Lo.top || e.tabAlignment == Lo.bottom ? "row" : "column",
        height: "100%"
      }),
      IconButtonAlignment: ha,
      getButtonStyle: (A) => {
        const { style: D } = A || {}, { id: z } = n.value || {}, k = z === (A == null ? void 0 : A.id);
        return {
          background: k ? (D == null ? void 0 : D.activeBackground) ?? (D == null ? void 0 : D.background) : D == null ? void 0 : D.background,
          buttonTextFont: k ? (D == null ? void 0 : D.activeTitleTextFont) ?? (D == null ? void 0 : D.titleTextFont) : D == null ? void 0 : D.titleTextFont,
          buttonTextColor: k ? (D == null ? void 0 : D.activeTitleTextColor) ?? (D == null ? void 0 : D.titleTextColor) : D == null ? void 0 : D.titleTextColor,
          buttonIconTint: k ? (D == null ? void 0 : D.activeIconTint) ?? (D == null ? void 0 : D.iconTint) : D == null ? void 0 : D.iconTint,
          height: D == null ? void 0 : D.height,
          width: D == null ? void 0 : D.width,
          border: D == null ? void 0 : D.border,
          borderRadius: D == null ? void 0 : D.borderRadius,
          gap: "0",
          padding: "0"
        };
      },
      openViewOnCLick: r,
      getButtonDivStyle: (A) => {
        const { id: D } = n.value || {}, z = D === (A == null ? void 0 : A.id);
        return {
          width: 100 / e.tabs.length + "%",
          color: i.value.palette.getAccent(),
          background: z ? i.value.palette.getBackground() : "transparent",
          boxShadow: z ? "0 3px 8px #ececec, 0 3px 1px #ececec" : "none",
          borderRadius: z ? "8px" : "none",
          padding: "6px",
          margin: "3px"
        };
      },
      getTabsStyleFixed: () => {
        const { background: A, height: D, width: z, borderRadius: k } = e.tabsStyle ?? {};
        return {
          background: A,
          width: z || "100%",
          height: D,
          borderRadius: k
        };
      },
      getButtonStyleFixed: (A) => {
        const { style: D } = A || {}, { id: z } = n.value || {}, k = z === (A == null ? void 0 : A.id);
        return {
          background: k ? (D == null ? void 0 : D.activeBackground) ?? (D == null ? void 0 : D.background) : D == null ? void 0 : D.background,
          buttonTextFont: k ? (D == null ? void 0 : D.activeTitleTextFont) ?? (D == null ? void 0 : D.titleTextFont) : D == null ? void 0 : D.titleTextFont,
          buttonTextColor: k ? (D == null ? void 0 : D.activeTitleTextColor) ?? (D == null ? void 0 : D.titleTextColor) : D == null ? void 0 : D.titleTextColor,
          buttonIconTint: k ? (D == null ? void 0 : D.activeIconTint) ?? (D == null ? void 0 : D.iconTint) : D == null ? void 0 : D.iconTint,
          height: D == null ? void 0 : D.height,
          width: D == null ? void 0 : D.width,
          border: (D == null ? void 0 : D.border) || "none",
          borderRadius: D == null ? void 0 : D.borderRadius,
          gap: "0",
          padding: "0",
          "justify-content": "center"
        };
      },
      getKeepAliveTabs: () => {
        let A = [];
        for (let D = 0; D < e.tabs.length; D++)
          A.push(e.tabs[D].childView.componentName);
        return A;
      }
    };
  }
});
const jj = {
  key: 0,
  class: "cc-tabs-wrapper"
}, Aj = { class: "cc-tabs-wrapper_inner-div" }, Lj = ["innerHTML"], zj = ["v-slot", "v-html"], Sj = ["draggableStyle"], pj = ["alignment", "iconURL", "text", "buttonStyle", "onCcButtonClicked"], bj = {
  key: 1,
  class: "cc-tabs-wrapper-fixed"
}, Ej = { class: "cc-tabs-wrapper-fixed-inner" }, hj = ["alignment", "text", "buttonStyle", "onCcButtonClicked"], vj = { class: "cc-tabs-wrapper-fixed_inner-div" }, mj = ["innerHTML"], Oj = ["v-slot", "v-html"];
function xj(e, t, n, o, i, l) {
  var r, u, s, c;
  return e.disableDraggable ? (M(), g("div", bj, [
    p("div", Ej, [
      p("div", {
        class: "cc-tabs-fixed",
        style: ce(e.getTabsStyleFixed())
      }, [
        p("div", {
          class: "cc-tab-item-fixed",
          style: ce(e.getTabsPlacement())
        }, [
          (M(!0), g(we, null, pe(e.tabs, (d) => (M(), g("div", {
            key: d.id,
            style: ce(e.getButtonDivStyle(d))
          }, [
            p("cometchat-button", {
              alignment: e.IconButtonAlignment.top,
              text: d.title,
              buttonStyle: e.getButtonStyleFixed(d),
              onCcButtonClicked: (N) => e.openViewOnCLick(d)
            }, null, 40, hj)
          ], 4))), 128))
        ], 4)
      ], 4),
      p("div", vj, [
        (M(), je(kl, {
          include: e.getKeepAliveTabs()
        }, [
          e.childViewRef && e.childViewRef.html ? (M(), g("div", {
            key: 0,
            innerHTML: e.childViewRef.html
          }, null, 8, mj)) : e.childViewRef && e.childViewRef.componentName ? (M(), je(fe(e.childViewRef.componentName), me({ key: 1 }, { ...e.childViewRef.props }, xe((s = e.childViewRef) != null && s.listeners ? (c = e.childViewRef) == null ? void 0 : c.listeners : {}), {
            key: e.childViewRef.componentName
          }), {
            default: be(() => [
              (M(!0), g(we, null, pe(e.childViewRef.slots, (d, N) => (M(), g("div", {
                key: N,
                "v-slot": [N],
                "v-html": d
              }, null, 8, Oj))), 128))
            ]),
            _: 1
          }, 16)) : $("", !0)
        ], 1032, ["include"]))
      ])
    ])
  ])) : (M(), g("div", jj, [
    p("div", Aj, [
      e.childViewRef && e.childViewRef.html ? (M(), g("div", {
        key: 0,
        innerHTML: e.childViewRef.html
      }, null, 8, Lj)) : e.childViewRef && e.childViewRef.componentName ? (M(), je(fe(e.childViewRef.componentName), me({ key: 1 }, { ...e.childViewRef.props }, xe((r = e.childViewRef) != null && r.listeners ? (u = e.childViewRef) == null ? void 0 : u.listeners : {})), {
        default: be(() => [
          (M(!0), g(we, null, pe(e.childViewRef.slots, (d, N) => (M(), g("div", {
            key: N,
            "v-slot": [N],
            "v-html": d
          }, null, 8, zj))), 128))
        ]),
        _: 1
      }, 16)) : $("", !0)
    ]),
    p("div", {
      class: "cc-tabs",
      style: ce(e.getTabsStyle())
    }, [
      p("cometchat-draggable", { draggableStyle: e.tabsStyle }, [
        p("div", {
          class: "cc__tab-item",
          style: ce(e.getTabsPlacement())
        }, [
          (M(!0), g(we, null, pe(e.tabs, (d) => (M(), g("cometchat-icon-button", {
            key: d.id,
            alignment: e.IconButtonAlignment.top,
            iconURL: d.iconURL,
            text: d.title,
            buttonStyle: e.getButtonStyle(d),
            onCcButtonClicked: (N) => e.openViewOnCLick(d)
          }, null, 40, pj))), 128))
        ], 4)
      ], 8, Sj)
    ], 4)
  ]));
}
const kj = /* @__PURE__ */ $e(wj, [["render", xj], ["__scopeId", "data-v-6172e2d3"]]), fj = We({
  name: "CometChatContacts",
  components: {
    CometChatTabs: kj
  },
  props: {
    title: { type: String },
    usersTabTitle: { type: String },
    groupsTabTitle: { type: String },
    usersConfiguration: { type: Object },
    groupsConfiguration: { type: Object },
    /**
    * @deprecated
    * 
    * This property is deprecated as of version 4.3.18 due to newer property 'onSubmitButtonClick'. It will be removed in subsequent versions.
    */
    onSubmitIconClick: {
      type: Function
    },
    closeIconURL: {
      type: String,
      default: Cn
    },
    onItemClick: {
      type: Function
    },
    contactsStyle: {
      type: Object,
      default: () => ({})
    },
    onClose: {
      type: Function
    },
    tabVisibility: {
      type: Number,
      default: () => Po.usersAndGroups
    },
    selectionLimit: {
      type: Number,
      default: 5
    },
    hideSubmitButton: {
      type: Boolean,
      default: () => !0
    },
    submitButtonText: {
      type: String,
      default: () => Y("SUBMIT") || "Submit"
    },
    selectionMode: {
      type: Number,
      default: () => xt.none
    },
    onSubmitButtonClick: {
      type: Function,
      default: null
    }
  },
  setup(e) {
    var O, x, _, oe, ie, re, Ae, se, X, B, F, G, J, ee, V, ne, K, Ie, Te, H, Ee, L, b, v, U, Se, Ue, Re, _e, Z, ke, q, ye, Oe, he, Pe, lt, It, Gt, de, Le, Fe, tt, st, ct, wt, Lt, jt, Wt;
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    }), n = Cn, o = !1, i = !1, l = [], r = bi({
      userArray: [],
      groupArray: []
    }), u = new rl({
      height: ((O = e.contactsStyle) == null ? void 0 : O.tabHeight) || "100%",
      width: ((x = e.contactsStyle) == null ? void 0 : x.tabWidth) || "100%",
      background: ((_ = e.contactsStyle) == null ? void 0 : _.tabBackground) || "transparent",
      activeBackground: ((oe = e.contactsStyle) == null ? void 0 : oe.activeTabBackground) || "transparent",
      titleTextColor: ((ie = e.contactsStyle) == null ? void 0 : ie.tabTitleTextColor) || t.value.palette.getAccent(),
      titleTextFont: ((re = e.contactsStyle) == null ? void 0 : re.tabTitleTextFont) || w(t.value.typography.text2),
      activeIconTint: ((Ae = e.contactsStyle) == null ? void 0 : Ae.selectionIconTint) || t.value.palette.getPrimary(),
      activeTitleTextColor: ((se = e.contactsStyle) == null ? void 0 : se.activeTabTitleTextColor) || t.value.palette.getAccent(),
      activeTitleTextFont: ((X = e.contactsStyle) == null ? void 0 : X.activeTabTitleTextFont) || w(t.value.typography.text2),
      borderRadius: ((B = e.contactsStyle) == null ? void 0 : B.tabBorderRadius) || "8px"
    }), s = {
      background: t.value.palette.getAccent100(),
      borderRadius: "10px",
      border: `1px solid ${t.value.palette.getAccent50()}`
    };
    e.tabVisibility == Po.users ? o = !0 : e.tabVisibility == Po.groups ? i = !0 : e.tabVisibility == Po.usersAndGroups && (o = !0, i = !0);
    const c = () => {
      var ot;
      return ((ot = e.usersConfiguration) == null ? void 0 : ot.onItemClick) || ((zt) => {
        e.onItemClick && e.onItemClick(zt, null);
      });
    }, d = () => {
      const ot = e.onSubmitButtonClick || e.onSubmitIconClick;
      ot && ot(r.userArray, r.groupArray);
    }, N = () => {
      var ot;
      return ((ot = e.groupsConfiguration) == null ? void 0 : ot.onItemClick) || ((zt) => {
        e.onItemClick && e.onItemClick(null, zt);
      });
    }, T = (ot) => {
      e.selectionMode == xt.single ? r.userArray = [ot] : r.userArray.includes(ot) ? r.userArray = r.userArray.filter(
        (zt) => zt.getUid() !== ot.getUid()
      ) : r.userArray = [...r.userArray, ot];
    }, m = Ht(() => e.selectionLimit ? r.userArray.length + r.groupArray.length > e.selectionLimit : !1), A = (ot) => {
      e.selectionMode == xt.single ? r.groupArray = [ot] : r.groupArray.includes(ot) ? r.groupArray = r.groupArray.filter(
        (zt) => zt.getGuid() !== ot.getGuid()
      ) : r.groupArray = [...r.groupArray, ot];
    };
    o && l.push({
      id: "CometChatUsers",
      title: e.usersTabTitle ?? Y("USERS"),
      childView: {
        componentName: "CometChatUsers",
        props: {
          title: "",
          selectionMode: e.selectionMode,
          hideSearch: (F = e.usersConfiguration) == null ? void 0 : F.hideSearch,
          searchIconURL: (G = e.usersConfiguration) == null ? void 0 : G.searchIconURL,
          searchRequestBuilder: (J = e.usersConfiguration) == null ? void 0 : J.searchRequestBuilder,
          onItemClick: c(),
          subtitleView: (ee = e.usersConfiguration) == null ? void 0 : ee.subtitleView,
          usersRequestBuilder: (V = e.usersConfiguration) == null ? void 0 : V.usersRequestBuilder,
          emptyStateView: (ne = e.usersConfiguration) == null ? void 0 : ne.emptyStateView,
          onSelect: T,
          loadingIconURL: (K = e.usersConfiguration) == null ? void 0 : K.loadingIconURL,
          errorStateView: (Ie = e.usersConfiguration) == null ? void 0 : Ie.errorStateView,
          loadingStateView: (Te = e.usersConfiguration) == null ? void 0 : Te.loadingStateView,
          titleAlignment: (H = e.usersConfiguration) == null ? void 0 : H.titleAlignment,
          showSectionHeader: (Ee = e.usersConfiguration) == null ? void 0 : Ee.showSectionHeader,
          listItemView: (L = e.usersConfiguration) == null ? void 0 : L.listItemView,
          hideSeparator: (b = e.usersConfiguration) == null ? void 0 : b.hideSeparator,
          hideError: (v = e.usersConfiguration) == null ? void 0 : v.hideError,
          listItemStyle: (U = e.usersConfiguration) == null ? void 0 : U.listItemStyle,
          options: (Se = e.usersConfiguration) != null && Se.options ? (Ue = e.usersConfiguration) == null ? void 0 : Ue.options : void 0,
          usersStyle: (Re = e.usersConfiguration) != null && Re.usersStyle && Object.keys((_e = e.usersConfiguration) == null ? void 0 : _e.usersStyle).length ? (Z = e.usersConfiguration) == null ? void 0 : Z.usersStyle : D()
        }
      },
      style: u,
      isActive: !0
    }), i && l.push({
      id: "CometChatGroups",
      title: e.groupsTabTitle ?? Y("GROUPS"),
      childView: {
        componentName: "CometChatGroups",
        props: {
          title: "",
          selectionMode: e.selectionMode,
          onItemClick: N(),
          hideSearch: (ke = e.groupsConfiguration) == null ? void 0 : ke.hideSearch,
          searchIconURL: (q = e.groupsConfiguration) == null ? void 0 : q.searchIconURL,
          searchRequestBuilder: (ye = e.groupsConfiguration) == null ? void 0 : ye.searchRequestBuilder,
          subtitleView: (Oe = e.groupsConfiguration) == null ? void 0 : Oe.subtitleView,
          privateGroupIcon: (he = e.groupsConfiguration) == null ? void 0 : he.privateGroupIcon,
          protectedGroupIcon: (Pe = e.groupsConfiguration) == null ? void 0 : Pe.protectedGroupIcon,
          groupsRequestBuilder: (lt = e.groupsConfiguration) == null ? void 0 : lt.groupsRequestBuilder,
          emptyStateView: (It = e.groupsConfiguration) == null ? void 0 : It.emptyStateView,
          onSelect: A,
          loadingIconURL: (Gt = e.groupsConfiguration) == null ? void 0 : Gt.loadingIconURL,
          errorStateView: (de = e.groupsConfiguration) == null ? void 0 : de.errorStateView,
          loadingStateView: (Le = e.groupsConfiguration) == null ? void 0 : Le.loadingStateView,
          titleAlignment: (Fe = e.groupsConfiguration) == null ? void 0 : Fe.titleAlignment,
          listItemView: (tt = e.groupsConfiguration) == null ? void 0 : tt.listItemView,
          hideSeparator: (st = e.groupsConfiguration) == null ? void 0 : st.hideSeparator,
          hideError: (ct = e.groupsConfiguration) == null ? void 0 : ct.hideError,
          listItemStyle: (wt = e.groupsConfiguration) == null ? void 0 : wt.listItemStyle,
          groupsStyle: (Lt = e.groupsConfiguration) != null && Lt.groupsStyle && Object.keys((jt = e.groupsConfiguration) == null ? void 0 : jt.groupsStyle).length ? (Wt = e.groupsConfiguration) == null ? void 0 : Wt.groupsStyle : z()
        }
      },
      style: u
    });
    function D() {
      return new Ci({
        border: "none",
        titleTextFont: w(t.value.typography.title1),
        emptyStateTextFont: w(t.value.typography.title1),
        errorStateTextFont: w(t.value.typography.title1),
        sectionHeaderTextFont: w(t.value.typography.subtitle2),
        searchTextFont: w(t.value.typography.text3)
      });
    }
    function z() {
      return new Sa({
        border: "none",
        subTitleTextFont: w(t.value.typography.subtitle2),
        subTitleTextColor: t.value.palette.getAccent700(),
        titleTextFont: w(t.value.typography.title1),
        emptyStateTextFont: w(t.value.typography.title1),
        errorStateTextFont: w(t.value.typography.title1),
        searchPlaceholderTextFont: w(t.value.typography.text3),
        searchTextFont: w(t.value.typography.text3)
      });
    }
    return {
      TabAlignment: Lo,
      tabsToShow: l,
      getCloseButtonStyle: () => ({
        height: "24px",
        width: "24px",
        border: "none",
        borderRadius: "0",
        background: "transparent",
        buttonIconTint: t.value.palette.getPrimary()
      }),
      getTitleStyle: () => ({
        textFont: e.contactsStyle.titleTextFont || w(t.value.typography.title1),
        textColor: e.contactsStyle.titleTextColor || t.value.palette.getAccent()
      }),
      tabsStyle: s,
      closeIconUrl: n,
      getWrapperStyle: () => ({
        background: e.contactsStyle.background || t.value.palette.getBackground()
      }),
      selectionLimitReached: m,
      localize: Y,
      getSubmitButtonStyle: () => {
        var ot, zt, yt;
        return {
          background: ((ot = e == null ? void 0 : e.contactsStyle) == null ? void 0 : ot.submitButtonBackground) || t.value.palette.getPrimary(),
          borderRadius: "8px",
          height: "40px",
          padding: "8px",
          width: "80%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "none",
          buttonTextFont: ((zt = e == null ? void 0 : e.contactsStyle) == null ? void 0 : zt.submitButtonTextFont) || w(t.value.typography.text2),
          buttonTextColor: ((yt = e == null ? void 0 : e.contactsStyle) == null ? void 0 : yt.submitButtonTextColor) || t.value.palette.getAccent("dark")
        };
      },
      selectionArray: r,
      submitClicked: d
    };
  }
});
const Uj = { class: "cc-contacts__header" }, Bj = ["text", "labelStyle"], Qj = ["iconURL", "buttonStyle"], Rj = { class: "cc-contacts__content" }, Yj = ["text", "buttonStyle", "disabled"];
function Vj(e, t, n, o, i, l) {
  const r = Je("CometChatTabs");
  return M(), g("div", {
    class: "cc-contacts__wrapper",
    style: ce(e.getWrapperStyle())
  }, [
    p("div", Uj, [
      p("cometchat-label", {
        text: e.title,
        labelStyle: e.getTitleStyle()
      }, null, 8, Bj),
      p("cometchat-button", {
        class: "cc-contacts__close-button",
        onCcButtonClicked: t[0] || (t[0] = (...u) => e.onClose && e.onClose(...u)),
        iconURL: e.closeIconUrl,
        buttonStyle: e.getCloseButtonStyle()
      }, null, 40, Qj)
    ]),
    p("div", Rj, [
      Nt(r, {
        tabs: e.tabsToShow,
        tabAlignment: e.TabAlignment.top,
        disableDraggable: !0,
        tabsStyle: e.tabsStyle
      }, null, 8, ["tabs", "tabAlignment", "tabsStyle"])
    ]),
    e.hideSubmitButton ? $("", !0) : (M(), g("cometchat-button", {
      key: 0,
      class: "cc-contacts__submit-button",
      text: e.submitButtonText,
      buttonStyle: e.getSubmitButtonStyle(),
      disabled: e.selectionLimitReached,
      onCcButtonClicked: t[1] || (t[1] = (...u) => e.submitClicked && e.submitClicked(...u))
    }, null, 40, Yj))
  ], 4);
}
const Gj = /* @__PURE__ */ $e(fj, [["render", Vj], ["__scopeId", "data-v-48dc5692"]]), Pj = We({
  name: "CometChatConversationsWithMessages",
  components: { CometChatMessages: fi, CometChatConversations: bg, CometChatContacts: Gj },
  props: {
    user: { type: Object },
    group: { type: Object },
    isMobileView: { type: Boolean, default: !1 },
    messageText: { type: String, default: () => Y("NO_CHATS_SELECTED") },
    conversationsWithMessagesStyle: {
      type: Object,
      default: () => ({})
    },
    messagesConfiguration: {
      type: Object,
      default: () => new wi({})
    },
    conversationConfiguration: {
      type: Object,
      default: () => new ll({})
    },
    onError: {
      type: Function,
      default: (e) => {
        console.log(e);
      }
    },
    startConversationConfiguration: {
      type: Object,
      default: () => new sl({})
    },
    startConversationIconUrl: {
      type: String,
      default: is
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    }), n = j({}), o = {
      background: "transparent",
      textFont: "700 22px Inter",
      textColor: t.value.palette.getAccent()
    }, i = j(e.messagesConfiguration), l = j(e.user), r = j(e.group), u = "groupsList_" + (/* @__PURE__ */ new Date()).getTime(), s, c, d, N, T, m, A, D, z, k = j(null), R = j(!1);
    const Q = Ht(() => !e.isMobileView || !l.value && !r.value && !R.value);
    let h = j(
      e.conversationsWithMessagesStyle
    );
    Zt(() => {
      var H, Ee;
      re(), (Ee = (H = e.messagesConfiguration) == null ? void 0 : H.messageHeaderConfiguration) != null && Ee.onBack || (i.value.messageHeaderConfiguration.onBack = Ae), x(), oe(), y.getLoggedinUser().then((L) => {
        L && (n.value = L);
      }).catch((L) => {
        let b = new y.CometChatException({
          message: L.message
        });
        e.onError(b);
      }), O();
    }), eo(() => {
      O();
    }), un(() => {
      _(), ie();
    });
    const O = () => {
      e.isMobileView ? (e.messagesConfiguration.messageHeaderConfiguration.hideBackButton = !1, e.messagesConfiguration.messageHeaderConfiguration = {
        ...e.messagesConfiguration.messageHeaderConfiguration
      }, i.value = { ...e.messagesConfiguration }) : e.isMobileView || (e.messagesConfiguration.messageHeaderConfiguration.hideBackButton = !0, e.messagesConfiguration.messageHeaderConfiguration = {
        ...e.messagesConfiguration.messageHeaderConfiguration
      }, i.value = { ...e.messagesConfiguration });
    }, x = () => {
      z = ka.ccConversationDeleted.subscribe(
        (H) => {
          X(H);
        }
      ), D = He.ccGroupDeleted.subscribe(
        (H) => {
          r.value && H.getGuid() == r.value.getGuid() && (r.value = null, k.value = null);
        }
      ), s = He.ccGroupMemberAdded.subscribe(
        (H) => {
          r.value && r.value.getGuid() == (H == null ? void 0 : H.userAddedIn.getGuid()) && (r.value = Ce.clone(
            H == null ? void 0 : H.userAddedIn
          ));
        }
      ), m = He.ccGroupMemberBanned.subscribe(
        (H) => {
          r.value && r.value.getGuid() == (H == null ? void 0 : H.kickedFrom.getGuid()) && (r.value = Ce.clone(
            H == null ? void 0 : H.kickedFrom
          ));
        }
      ), N = He.ccGroupMemberJoined.subscribe(
        (H) => {
          r.value && r.value.getGuid() == (H == null ? void 0 : H.joinedGroup.getGuid()) && (r.value = Ce.clone(
            H == null ? void 0 : H.joinedGroup
          ));
        }
      ), T = He.ccGroupMemberKicked.subscribe(
        (H) => {
          r.value && r.value.getGuid() == (H == null ? void 0 : H.kickedFrom.getGuid()) && (r.value = Ce.clone(
            H == null ? void 0 : H.kickedFrom
          ));
        }
      ), A = He.ccOwnershipChanged.subscribe(
        (H) => {
          var Ee;
          r.value && r.value.getGuid() == (H == null ? void 0 : H.group.getGuid()) && (r.value = Ce.clone(
            H == null ? void 0 : H.group
          ), (Ee = k == null ? void 0 : k.value) == null || Ee.setConversationWith(r.value));
        }
      ), d = He.ccGroupLeft.subscribe(
        (H) => {
          var Ee;
          r.value && r.value.getGuid() == (H == null ? void 0 : H.leftGroup.getGuid()) && (n == null ? void 0 : n.value.getUid()) == ((Ee = H == null ? void 0 : H.userLeft) == null ? void 0 : Ee.getUid()) && (r.value = null, k.value = null);
        }
      ), c = it.ccOpenChat.subscribe((H) => {
        var L;
        const Ee = (L = H.user) == null ? void 0 : L.getUid();
        Ee && y.getConversation(
          Ee,
          I.MessageReceiverType.user
        ).then((b) => {
          se(b);
        });
      });
    }, _ = () => {
      z == null || z.unsubscribe(), D == null || D.unsubscribe(), s == null || s.unsubscribe(), m == null || m.unsubscribe(), N == null || N.unsubscribe(), T == null || T.unsubscribe(), A == null || A.unsubscribe(), d == null || d.unsubscribe(), c == null || c.unsubscribe();
    }, oe = () => {
      y.addGroupListener(
        u,
        new y.GroupListener({
          onGroupMemberScopeChanged: (H, Ee, L, b, v) => {
            var U;
            (v == null ? void 0 : v.getGuid()) === ((U = r.value) == null ? void 0 : U.getGuid()) && (r.value = Ce.clone(v));
          },
          onGroupMemberKicked: (H, Ee, L, b) => {
            var v;
            (b == null ? void 0 : b.getGuid()) === ((v = r.value) == null ? void 0 : v.getGuid()) && (r.value = Ce.clone(b));
          },
          onMemberAddedToGroup: (H, Ee, L, b) => {
            var v;
            (b == null ? void 0 : b.getGuid()) === ((v = r.value) == null ? void 0 : v.getGuid()) && (r.value = Ce.clone(b));
          },
          onGroupMemberBanned(H, Ee, L, b) {
            var v;
            (b == null ? void 0 : b.getGuid()) === ((v = r.value) == null ? void 0 : v.getGuid()) && (r.value = Ce.clone(b));
          },
          onGroupMemberLeft: (H, Ee, L) => {
            var b;
            (L == null ? void 0 : L.getGuid()) === ((b = r.value) == null ? void 0 : b.getGuid()) && (r.value = Ce.clone(L));
          },
          onGroupMemberJoined: (H, Ee, L) => {
            var b;
            (L == null ? void 0 : L.getGuid()) === ((b = r.value) == null ? void 0 : b.getGuid()) && (r.value = Ce.clone(L));
          }
        })
      );
    }, ie = () => {
      y.removeGroupListener(u);
    }, re = () => {
      let H = new ji({
        width: "100%",
        height: "100%",
        background: t.value.palette.getBackground(),
        borderRadius: "none",
        border: "none",
        messageTextColor: t.value.palette.getAccent600(),
        messageTextFont: w(t.value.typography.title1)
      });
      h.value = {
        ...H,
        ...e.conversationsWithMessagesStyle
      }, o.textFont = h.value.messageTextFont, o.textColor = h.value.messageTextColor;
    }, Ae = () => {
      l.value = null, r.value = null, k.value = null;
    }, se = (H) => {
      k.value = H, H.getConversationType() && H.getConversationType() == I.MessageReceiverType.user ? (r.value = null, l.value = H.getConversationWith()) : H.getConversationType() && H.getConversationType() == I.MessageReceiverType.group && (l.value = null, r.value = H.getConversationWith());
    }, X = (H) => {
      const Ee = H.getConversationType(), L = H.getConversationWith();
      if (Ee === I.MessageReceiverType.user && l.value && l.value.getUid() === L.getUid())
        l.value = null;
      else if (Ee === I.MessageReceiverType.group && r.value && r.value.getGuid() === L.getGuid())
        r.value = null;
      else
        return;
    }, B = () => e.conversationConfiguration.menu ? typeof e.conversationConfiguration.menu == "string" ? {
      html: e.conversationConfiguration.menu
    } : e.conversationConfiguration.menu : ee(), F = () => ({
      background: e.conversationsWithMessagesStyle.background || t.value.palette.getBackground(),
      height: e.conversationsWithMessagesStyle.height,
      width: `calc(${e.conversationsWithMessagesStyle.width} - 280px)`,
      border: e.conversationsWithMessagesStyle.border,
      borderRadius: e.conversationsWithMessagesStyle.borderRadius
    }), G = () => ({
      height: e.conversationsWithMessagesStyle.height,
      width: e.conversationsWithMessagesStyle.width,
      border: e.conversationsWithMessagesStyle.border,
      borderRadius: e.conversationsWithMessagesStyle.borderRadius,
      background: e.conversationsWithMessagesStyle.background || t.value.palette.getBackground()
    }), J = () => ({
      ...{
        height: "100%"
      },
      ...e.conversationConfiguration.conversationsStyle
    }), ee = () => ({
      componentName: "cometchat-button",
      props: {
        buttonStyle: {
          height: "24px",
          width: "24px",
          border: "none",
          borderRadius: "0",
          background: "transparent",
          buttonIconTint: t.value.palette.getPrimary(),
          marginTop: "10px"
        },
        iconURL: e.startConversationIconUrl
      },
      listeners: {
        "cc-button-clicked": () => {
          V();
        }
      }
    }), V = () => {
      R.value = !0;
    };
    return {
      labelStyle: o,
      onItemClick: se,
      emptyMessageStyle: F,
      chatsWrapperStyles: G,
      messagesConfig: i,
      currentUser: l,
      currentGroup: r,
      activeConversation: k,
      getMenu: B,
      getConversationStyle: J,
      getStartConversationButton: ee,
      showContacts: R,
      onContactsItemClick: (H, Ee) => {
        H ? (r.value = null, l.value = H) : Ee && (l.value = null, r.value = Ee), R.value = !1;
      },
      closeContacts: () => {
        R.value = !1;
      },
      localize: Y,
      getUsersConfiguration: () => {
        var Ee;
        let H;
        return H = ((Ee = e == null ? void 0 : e.startConversationConfiguration) == null ? void 0 : Ee.usersConfiguration) || new pa({}), H.selectionMode = H.selectionMode ?? xt.none, H.usersRequestBuilder = H.usersRequestBuilder ?? new y.UsersRequestBuilder().hideBlockedUsers(!0).setLimit(30), H;
      },
      getGroupsConfiguration: () => {
        var Ee;
        let H;
        return H = ((Ee = e == null ? void 0 : e.startConversationConfiguration) == null ? void 0 : Ee.groupsConfiguration) || new ba({}), H.selectionMode = H.selectionMode ?? xt.none, H.groupsRequestBuilder = H.groupsRequestBuilder ?? new y.GroupsRequestBuilder().joinedOnly(!0).setLimit(30), H;
      },
      shouldShowSidebar: Q
    };
  }
});
const Fj = ["text", "labelStyle"];
function Hj(e, t, n, o, i, l) {
  var c, d;
  const r = Je("CometChatConversations"), u = Je("CometChatContacts"), s = Je("CometChatMessages");
  return M(), g("div", {
    class: "cc-withmessages__wrapper",
    style: ce(e.chatsWrapperStyles())
  }, [
    Kn(p("div", {
      class: _n(["cc-withmessages__sidebar", { mobile: e.isMobileView }])
    }, [
      Nt(r, {
        ref: "conversationRef",
        activeConversation: e.activeConversation,
        onItemClick: e.conversationConfiguration.onItemClick || e.onItemClick,
        conversationsStyle: e.getConversationStyle(),
        subtitleView: e.conversationConfiguration.subtitleView,
        options: e.conversationConfiguration.options ? e.conversationConfiguration.options : void 0,
        disableUsersPresence: e.conversationConfiguration.disableUsersPresence,
        disableReceipt: e.conversationConfiguration.disableReceipt,
        hideReceipt: e.conversationConfiguration.hideReceipt,
        disableTyping: e.conversationConfiguration.disableTyping,
        deliveredIcon: e.conversationConfiguration.deliveredIcon,
        readIcon: e.conversationConfiguration.readIcon,
        waitIcon: e.conversationConfiguration.waitIcon,
        errorIcon: e.conversationConfiguration.errorIcon,
        datePattern: e.conversationConfiguration.datePattern,
        receiptStyle: e.conversationConfiguration.receiptStyle,
        sentIcon: e.conversationConfiguration.sentIcon,
        privateGroupIcon: e.conversationConfiguration.privateGroupIcon,
        protectedGroupIcon: e.conversationConfiguration.protectedGroupIcon,
        customSoundForMessages: e.conversationConfiguration.customSoundForMessages,
        conversationsRequestBuilder: e.conversationConfiguration.conversationsRequestBuilder,
        emptyStateView: e.conversationConfiguration.emptyStateView,
        onSelect: e.conversationConfiguration.onSelect,
        loadingIconURL: e.conversationConfiguration.loadingIconURL,
        errorStateView: e.conversationConfiguration.errorStateView,
        loadingStateView: e.conversationConfiguration.loadingStateView,
        titleAlignment: e.conversationConfiguration.titleAlignment,
        listItemView: e.conversationConfiguration.listItemView,
        menu: e.getMenu(),
        hideSeparator: e.conversationConfiguration.hideSeparator,
        hideError: e.conversationConfiguration.hideError,
        selectionMode: e.conversationConfiguration.selectionMode,
        disableSoundForMessages: e.conversationConfiguration.disableSoundForMessages,
        deleteConversationDialogStyle: e.conversationConfiguration.deleteConversationDialogStyle,
        badgeStyle: e.conversationConfiguration.badgeStyle,
        dateStyle: e.conversationConfiguration.dateStyle,
        listItemStyle: e.conversationConfiguration.listItemStyle,
        backdropStyle: e.conversationConfiguration.backdropStyle,
        disableMentions: e.conversationConfiguration.disableMentions,
        avatarStyle: e.conversationConfiguration.avatarStyle,
        textFormatters: (c = e.conversationConfiguration) == null ? void 0 : c.textFormatters,
        statusIndicatorStyle: e.conversationConfiguration.statusIndicatorStyle
      }, null, 8, ["activeConversation", "onItemClick", "conversationsStyle", "subtitleView", "options", "disableUsersPresence", "disableReceipt", "hideReceipt", "disableTyping", "deliveredIcon", "readIcon", "waitIcon", "errorIcon", "datePattern", "receiptStyle", "sentIcon", "privateGroupIcon", "protectedGroupIcon", "customSoundForMessages", "conversationsRequestBuilder", "emptyStateView", "onSelect", "loadingIconURL", "errorStateView", "loadingStateView", "titleAlignment", "listItemView", "menu", "hideSeparator", "hideError", "selectionMode", "disableSoundForMessages", "deleteConversationDialogStyle", "badgeStyle", "dateStyle", "listItemStyle", "backdropStyle", "disableMentions", "avatarStyle", "textFormatters", "statusIndicatorStyle"])
    ], 2), [
      [Xn, e.shouldShowSidebar]
    ]),
    e.showContacts ? (M(), je(u, {
      key: 0,
      title: e.localize("NEW_CHAT"),
      usersTabTitle: e.localize("USERS"),
      groupsTabTitle: e.localize("GROUPS"),
      usersConfiguration: e.getUsersConfiguration(),
      groupsConfiguration: e.getGroupsConfiguration(),
      closeIconURL: e.startConversationConfiguration.closeIconURL,
      onItemClick: e.onContactsItemClick,
      onClose: e.startConversationConfiguration.onClose ? e.startConversationConfiguration.onClose : e.closeContacts,
      tabVisibility: e.startConversationConfiguration.tabVisibility,
      contactsStyle: e.startConversationConfiguration.contactsStyle,
      hideSubmitButton: e.startConversationConfiguration.hideSubmitButton,
      selectionMode: e.startConversationConfiguration.selectionMode,
      selectionLimit: e.startConversationConfiguration.selectionLimit,
      onSubmitButtonClick: e.startConversationConfiguration.onSubmitButtonClick
    }, null, 8, ["title", "usersTabTitle", "groupsTabTitle", "usersConfiguration", "groupsConfiguration", "closeIconURL", "onItemClick", "onClose", "tabVisibility", "contactsStyle", "hideSubmitButton", "selectionMode", "selectionLimit", "onSubmitButtonClick"])) : e.currentUser || e.currentGroup ? (M(), g("div", {
      key: 1,
      class: _n(["cc-withmessages__main", { mobile: e.isMobileView }])
    }, [
      Nt(s, {
        ref: "messagesRef",
        user: e.currentUser,
        group: e.currentGroup,
        messageHeaderConfiguration: e.messagesConfiguration.messageHeaderConfiguration,
        messageListConfiguration: e.messagesConfiguration.messageListConfiguration,
        messageComposerConfiguration: e.messagesConfiguration.messageComposerConfiguration,
        messagesStyle: e.messagesConfiguration.messagesStyle,
        customSoundForIncomingMessages: e.messagesConfiguration.customSoundForIncomingMessages,
        customSoundForOutgoingMessages: e.messagesConfiguration.customSoundForOutgoingMessages,
        detailsConfiguration: e.messagesConfiguration.detailsConfiguration,
        disableSoundForMessages: e.messagesConfiguration.disableSoundForMessages,
        disableTyping: e.messagesConfiguration.disableTyping,
        hideMessageComposer: e.messagesConfiguration.hideMessageComposer,
        hideMessageHeader: e.messagesConfiguration.hideMessageHeader,
        messageComposerView: e.messagesConfiguration.messageComposerView,
        messageHeaderView: e.messagesConfiguration.messageHeaderView,
        messageListView: e.messagesConfiguration.messageListView,
        hideDetails: (d = e.messagesConfiguration) == null ? void 0 : d.hideDetails,
        threadedMessagesConfiguration: e.messagesConfiguration.threadedMessageConfiguration
      }, null, 8, ["user", "group", "messageHeaderConfiguration", "messageListConfiguration", "messageComposerConfiguration", "messagesStyle", "customSoundForIncomingMessages", "customSoundForOutgoingMessages", "detailsConfiguration", "disableSoundForMessages", "disableTyping", "hideMessageComposer", "hideMessageHeader", "messageComposerView", "messageHeaderView", "messageListView", "hideDetails", "threadedMessagesConfiguration"])
    ], 2)) : $("", !0),
    !e.currentUser && !e.currentGroup && !e.showContacts && !e.isMobileView ? (M(), g("div", {
      key: 2,
      class: "cc-decorator__message-empty",
      style: ce(e.emptyMessageStyle())
    }, [
      p("cometchat-label", {
        text: e.messageText,
        labelStyle: e.labelStyle
      }, null, 8, Fj)
    ], 4)) : $("", !0)
  ], 4);
}
const Kz = /* @__PURE__ */ $e(Pj, [["render", Hj], ["__scopeId", "data-v-9185fa2c"]]), Zj = We({
  name: "CometChatGroupsWithMessages",
  components: { CometChatMessages: fi, CometChatGroups: lr, CometChatMessageHeader: ar },
  props: {
    group: { type: Object },
    hideCreateGroup: { type: Boolean, default: !1 },
    isMobileView: { type: Boolean, default: !1 },
    messageText: { type: String, default: () => Y("SELECT__GROUP") },
    groupsWithMessagesStyle: {
      type: Object,
      default: () => ({})
    },
    messagesConfiguration: {
      type: Object,
      default: () => new wi({})
    },
    groupsConfiguration: {
      type: Object,
      default: () => new ba({})
    },
    createGroupConfiguration: {
      type: Object,
      default: () => new Ml({})
    },
    joinGroupConfiguration: {
      type: Object,
      default: () => new ul({})
    },
    onError: {
      type: Function,
      default: (e) => {
        console.log(e);
      }
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    }), n = j({}), o = {
      background: "transparent",
      textFont: "700 22px Inter",
      textColor: t.value.palette.getAccent600()
    }, i = j(e.messagesConfiguration), l = j(e.group), r = j(), u = j(e.joinGroupConfiguration), s = "groupsList_" + (/* @__PURE__ */ new Date()).getTime(), c = j(!1), d = j(!1), N = {}, T = {}, m = {}, A = {}, D = {}, z, k, R, Q, h, O, x, _, oe = {}, ie = j(null), re = {
      height: "24px",
      width: "24px",
      border: "none",
      borderRadius: "0",
      background: "transparent",
      buttonIconTint: "RGB(51, 153, 255)"
    };
    Zt(() => {
      var q, ye;
      l.value = e.group, se(), F(), G(), J(), X(), (ye = (q = e.messagesConfiguration) == null ? void 0 : q.messageHeaderConfiguration) != null && ye.onBack || (i.value.messageHeaderConfiguration.onBack = Ae), ee(), Ie(), y.getLoggedinUser().then((Oe) => {
        Oe && (n.value = Oe);
      }).catch((Oe) => {
        let he = new y.CometChatException({
          message: Oe.message
        });
        e.onError(he);
      }), B();
    }), eo(() => {
      B();
    }), un(() => {
      H(), Te();
    });
    const Ae = () => {
      l.value = null, r.value = null;
    }, se = () => {
      N = {
        ...new ji({
          width: "100%",
          height: "100%",
          background: t.value.palette.getBackground(),
          borderRadius: "none",
          border: "none",
          messageTextColor: t.value.palette.getAccent600(),
          messageTextFont: w(t.value.typography.title1)
        }),
        ...e.groupsWithMessagesStyle
      }, o.textFont = e.groupsWithMessagesStyle.messageTextFont || o.textFont, o.textColor = e.groupsWithMessagesStyle.messageTextColor || o.textColor;
    }, X = () => {
      A = {
        ...new Ni({
          background: t.value.palette.getBackground(),
          border: "none",
          onlineStatusColor: t.value.palette.getSuccess(),
          privateGroupIconBackground: t.value.palette.getSuccess(),
          passwordGroupIconBackground: "RGB(247, 165, 0)",
          backButtonIconTint: t.value.palette.getPrimary(),
          subtitleTextColor: t.value.palette.getAccent600(),
          subtitleTextFont: w(t.value.typography.subtitle2),
          typingIndicatorTextColor: t.value.palette.getPrimary(),
          typingIndicatorTextFont: w(t.value.typography.subtitle1)
        }),
        ...e.joinGroupConfiguration.messageHeaderConfiguration.messageHeaderStyle
      };
    }, B = () => {
      let q = e.messagesConfiguration, ye = e.joinGroupConfiguration;
      e.isMobileView ? (q.messageHeaderConfiguration.hideBackButton = !1, q.messageHeaderConfiguration = {
        ...e.messagesConfiguration.messageHeaderConfiguration
      }, i.value = { ...q }, ye.messageHeaderConfiguration.hideBackButton = !1, ye.messageHeaderConfiguration = {
        ...e.joinGroupConfiguration.messageHeaderConfiguration
      }, u.value = { ...ye }) : e.isMobileView || (q.messageHeaderConfiguration.hideBackButton = !0, q.messageHeaderConfiguration = {
        ...e.messagesConfiguration.messageHeaderConfiguration
      }, i.value = { ...q }, ye.messageHeaderConfiguration.hideBackButton = !0, ye.messageHeaderConfiguration = {
        ...e.joinGroupConfiguration.messageHeaderConfiguration
      }, u.value = { ...ye });
    }, F = () => {
      var ye;
      T = {
        ...new vl({
          boxShadow: `${t.value.palette.getAccent100()} 4px 16px 32px 4px`,
          groupTypeTextFont: w(t.value.typography.subtitle2),
          groupTypeBorder: `1px solid ${t.value.palette.getAccent600()}`,
          groupTypeBorderRadius: "0",
          groupTypeTextColor: t.value.palette.getAccent(),
          groupTypeTextBackground: "transparent",
          groupTypeBackground: t.value.palette.getAccent100(),
          groupTypeBoxShadow: "",
          activeGroupTypeTextFont: w(t.value.typography.subtitle2),
          activeGroupTypeTextColor: t.value.palette.getAccent(),
          activeGroupTypeBackground: t.value.palette.getAccent900(),
          activeGroupTypeBoxShadow: `${t.value.palette.getAccent200()} 0 3px 8px 0`,
          activeGroupTypeBorderRadius: "8px",
          activeGroupTypeBorder: "none",
          groupTypeTextBoxShadow: "none",
          groupTypeTextBorderRadius: "0",
          closeIconTint: t.value.palette.getPrimary(),
          titleTextFont: w(t.value.typography.title1),
          titleTextColor: t.value.palette.getAccent(),
          errorTextFont: w(t.value.typography.subtitle1),
          errorTextBackground: t.value.palette.getError(),
          errorTextBorderRadius: "8px",
          errorTextBorder: "none",
          errorTextColor: t.value.palette.getError(),
          nameInputPlaceholderTextFont: w(
            t.value.typography.subtitle1
          ),
          nameInputPlaceholderTextColor: t.value.palette.getAccent600(),
          nameInputBackground: t.value.palette.getAccent100(),
          nameInputTextFont: w(t.value.typography.subtitle1),
          nameInputTextColor: t.value.palette.getAccent(),
          nameInputBorder: "none",
          nameInputBorderRadius: "8px",
          nameInputBoxShadow: `${t.value.palette.getAccent100()} 0 0 0 1px`,
          passwordInputPlaceholderTextFont: w(
            t.value.typography.subtitle1
          ),
          passwordInputPlaceholderTextColor: t.value.palette.getAccent600(),
          passwordInputBackground: t.value.palette.getAccent100(),
          passwordInputBorder: "none",
          passwordInputBorderRadius: "8px",
          passwordInputBoxShadow: `${t.value.palette.getAccent100()} 0 0 0 1px`,
          passwordInputTextFont: w(t.value.typography.subtitle1),
          passwordInputTextColor: t.value.palette.getAccent(),
          createGroupButtonTextFont: w(t.value.typography.text2),
          createGroupButtonTextColor: t.value.palette.getAccent900("light"),
          createGroupButtonBackground: t.value.palette.getPrimary(),
          createGroupButtonBorderRadius: "8px",
          createGroupButtonBorder: "none",
          height: "620px",
          width: "360px",
          borderRadius: "8px",
          background: t.value.palette.getBackground()
        }),
        ...(ye = e.createGroupConfiguration) == null ? void 0 : ye.createGroupStyle
      };
    }, G = () => {
      var ye;
      D = {
        ...new _t({
          height: "45px",
          width: "100%",
          background: t.value.palette.getBackground(),
          activeBackground: "transparent",
          borderRadius: "0",
          titleFont: w(t.value.typography.title2),
          titleColor: t.value.palette.getAccent(),
          border: "none",
          separatorColor: "",
          hoverBackground: "transparent"
        }),
        ...(ye = e.joinGroupConfiguration) == null ? void 0 : ye.messageHeaderConfiguration.listItemStyle
      };
    }, J = () => {
      var ye;
      m = {
        ...new ml({
          boxShadow: `${t.value.palette.getAccent100()} 0px 16px 32px 0px`,
          titleTextFont: w(t.value.typography.title1),
          titleTextColor: t.value.palette.getAccent(),
          passwordInputPlaceholderTextFont: w(
            t.value.typography.subtitle1
          ),
          passwordInputPlaceholderTextColor: t.value.palette.getAccent600(),
          passwordInputBackground: t.value.palette.getAccent100(),
          passwordInputBorder: "none",
          passwordInputBorderRadius: "8px",
          passwordInputBoxShadow: `${t.value.palette.getAccent100()} 0 0 0 1px`,
          passwordInputTextFont: w(t.value.typography.subtitle1),
          passwordInputTextColor: t.value.palette.getAccent(),
          height: "100vh",
          width: "100%",
          joinButtonTextFont: w(t.value.typography.subtitle1),
          joinButtonTextColor: t.value.palette.getAccent("dark"),
          joinButtonBackground: t.value.palette.getPrimary(),
          joinButtonBorderRadius: "8px",
          joinButtonBorder: "none",
          background: t.value.palette.getBackground()
        }),
        ...(ye = e.joinGroupConfiguration) == null ? void 0 : ye.joinGroupStyle
      };
    }, ee = () => {
      _ = He.ccGroupDeleted.subscribe(
        (q) => {
          l.value && q.getGuid() == l.value.getGuid() && (l.value = null);
        }
      ), He.ccGroupCreated.subscribe(
        (q) => {
          q && (l.value = Ce.clone(
            q
          ), d.value = !1);
        }
      ), z = He.ccGroupMemberAdded.subscribe(
        (q) => {
          l.value && l.value.getGuid() == (q == null ? void 0 : q.userAddedIn.getGuid()) && (l.value = Ce.clone(
            q == null ? void 0 : q.userAddedIn
          ));
        }
      ), O = He.ccGroupMemberBanned.subscribe(
        (q) => {
          l.value && l.value.getGuid() == (q == null ? void 0 : q.kickedFrom.getGuid()) && (l.value = Ce.clone(
            q == null ? void 0 : q.kickedFrom
          ));
        }
      ), Q = He.ccGroupMemberJoined.subscribe(
        (q) => {
          ie.value && ie.value.getGuid() == (q == null ? void 0 : q.joinedGroup.getGuid()) && (c.value = !1, ie.value = null, l.value = Ce.clone(
            q == null ? void 0 : q.joinedGroup
          ));
        }
      ), h = He.ccGroupMemberKicked.subscribe(
        (q) => {
          l.value && l.value.getGuid() == (q == null ? void 0 : q.kickedFrom.getGuid()) && (l.value = Ce.clone(
            q == null ? void 0 : q.kickedFrom
          ));
        }
      ), x = He.ccOwnershipChanged.subscribe(
        (q) => {
          l.value && l.value.getGuid() == (q == null ? void 0 : q.group.getGuid()) && (l.value = Ce.clone(
            q == null ? void 0 : q.group
          ));
        }
      ), k = He.ccGroupLeft.subscribe(
        (q) => {
          var ye;
          l.value && l.value.getGuid() == (q == null ? void 0 : q.leftGroup.getGuid()) && (n == null ? void 0 : n.value.getUid()) == ((ye = q == null ? void 0 : q.userLeft) == null ? void 0 : ye.getUid()) && (l.value = void 0);
        }
      ), R = it.ccOpenChat.subscribe((q) => {
        const ye = q.user;
        ye && (r.value = ye, l.value = null);
      });
    }, V = () => {
      d.value = !0;
    }, ne = () => {
      d.value = !1;
    }, K = () => {
      c.value = !1;
    }, Ie = () => {
      y.addGroupListener(
        s,
        new y.GroupListener({
          onGroupMemberScopeChanged: (q, ye, Oe, he, Pe) => {
            var lt;
            (Pe == null ? void 0 : Pe.getGuid()) === ((lt = l.value) == null ? void 0 : lt.getGuid()) && (l.value = Ce.clone(Pe));
          },
          onGroupMemberKicked: (q, ye, Oe, he) => {
            var Pe;
            (he == null ? void 0 : he.getGuid()) === ((Pe = l.value) == null ? void 0 : Pe.getGuid()) && (l.value = Ce.clone(he));
          },
          onMemberAddedToGroup: (q, ye, Oe, he) => {
            var Pe;
            (he == null ? void 0 : he.getGuid()) === ((Pe = l.value) == null ? void 0 : Pe.getGuid()) && (l.value = Ce.clone(he));
          },
          onGroupMemberBanned(q, ye, Oe, he) {
            var Pe;
            (he == null ? void 0 : he.getGuid()) === ((Pe = l.value) == null ? void 0 : Pe.getGuid()) && (l.value = Ce.clone(he));
          },
          onGroupMemberLeft: (q, ye, Oe) => {
            var he;
            (Oe == null ? void 0 : Oe.getGuid()) === ((he = l.value) == null ? void 0 : he.getGuid()) && (l.value = Ce.clone(Oe));
          },
          onGroupMemberJoined: (q, ye, Oe) => {
            var he;
            (Oe == null ? void 0 : Oe.getGuid()) === ((he = l.value) == null ? void 0 : he.getGuid()) && (l.value = Ce.clone(Oe));
          }
        })
      );
    }, Te = () => {
      y.removeGroupListener(s);
    }, H = () => {
      _ == null || _.unsubscribe(), z == null || z.unsubscribe(), O == null || O.unsubscribe(), Q == null || Q.unsubscribe(), h == null || h.unsubscribe(), x == null || x.unsubscribe(), k == null || k.unsubscribe(), R == null || R.unsubscribe();
    };
    return {
      labelStyle: o,
      onItemClick: (q) => {
        if (c.value = !1, q.getHasJoined()) {
          l.value = q;
          return;
        }
        if (q.getType() == I.GroupTypes.password) {
          l.value = null, ie.value = q, c.value = !0;
          return;
        }
        y.joinGroup(q).then(() => {
          q.setHasJoined(!0), q.setMembersCount(q.getMembersCount() + 1), l.value = q;
        }).catch((ye) => {
          e.onError && e.onError(ye);
        });
      },
      emptyMessageStyle: () => ({
        background: N.background || t.value.palette.getBackground(),
        height: N.height,
        width: `calc(${N.width} - 280px)`,
        border: N.border,
        borderRadius: N.borderRadius
      }),
      groupsWrapperStyles: () => ({
        height: N.height,
        width: N.width,
        border: N.border,
        borderRadius: N.borderRadius,
        background: N.background || t.value.palette.getBackground()
      }),
      messagesConfig: i,
      currentGroup: l,
      currentUser: r,
      openPasswordModal: c,
      openCreateGroup: V,
      closeCreateGroup: ne,
      closeJoinGroup: K,
      onGroupJoined: (q) => {
        var Oe;
        let ye = (Oe = q == null ? void 0 : q.detail) == null ? void 0 : Oe.response;
        c.value = !1, ie.value = null, ye && (l.value = ye);
      },
      CreateIcon: ra,
      updatedCreatedGroup: (q) => {
        var Oe;
        let ye = (Oe = q == null ? void 0 : q.detail) == null ? void 0 : Oe.group;
        ye && (l.value = ye, d.value = !1, He.ccGroupCreated.next(ye));
      },
      getCreateGroupButton: () => ({
        componentName: "cometchat-button",
        props: {
          buttonStyle: re,
          iconURL: ra
        },
        listeners: {
          "cc-button-clicked": () => {
            V();
          }
        }
      }),
      openCreateGroupPage: d,
      backdropStyle: oe,
      getCreateGroupStyle: () => T,
      protectedGroup: ie,
      getJoinGroupStyle: () => m,
      getMessageHeaderStyle: () => A,
      getListItemStyle: () => D,
      getGroupsStyle: () => ({
        ...{
          height: "100vh"
        },
        ...e.groupsConfiguration.groupsStyle
      })
    };
  }
});
const Wj = ["text", "labelStyle"], $j = ["group", "joinGroupStyle", "errorCallback", "joinClick"], Jj = { slot: "headerView" }, Kj = { key: 0 }, Xj = ["createGroupStyle", "hideCloseButton", "closeButtonIconURL", "createClick", "closeCallback"];
function qj(e, t, n, o, i, l) {
  var c, d, N, T, m, A, D, z, k, R, Q, h, O, x, _, oe, ie, re, Ae, se, X, B, F, G, J, ee, V, ne, K, Ie, Te, H, Ee, L, b;
  const r = Je("CometChatGroups"), u = Je("CometChatMessages"), s = Je("CometChatMessageHeader");
  return M(), g(we, null, [
    p("div", {
      class: "cc-withmessages-wrapper",
      style: ce(e.groupsWrapperStyles())
    }, [
      Kn(p("div", {
        class: _n(["cc-withmessages__sidebar", { mobile: e.isMobileView }])
      }, [
        Nt(r, {
          activeGroup: e.currentGroup,
          hideSearch: (c = e.groupsConfiguration) == null ? void 0 : c.hideSearch,
          searchIconURL: (d = e.groupsConfiguration) == null ? void 0 : d.searchIconURL,
          searchRequestBuilder: (N = e.groupsConfiguration) == null ? void 0 : N.searchRequestBuilder,
          onItemClick: ((T = e.groupsConfiguration) == null ? void 0 : T.onItemClick) || e.onItemClick,
          groupsStyle: e.getGroupsStyle(),
          options: e.groupsConfiguration.options ? e.groupsConfiguration.options : void 0,
          subtitleView: (m = e.groupsConfiguration) == null ? void 0 : m.subtitleView,
          privateGroupIcon: (A = e.groupsConfiguration) == null ? void 0 : A.privateGroupIcon,
          protectedGroupIcon: (D = e.groupsConfiguration) == null ? void 0 : D.protectedGroupIcon,
          groupsRequestBuilder: (z = e.groupsConfiguration) == null ? void 0 : z.groupsRequestBuilder,
          emptyStateView: (k = e.groupsConfiguration) == null ? void 0 : k.emptyStateView,
          onSelect: (R = e.groupsConfiguration) == null ? void 0 : R.onSelect,
          loadingIconURL: (Q = e.groupsConfiguration) == null ? void 0 : Q.loadingIconURL,
          errorStateView: (h = e.groupsConfiguration) == null ? void 0 : h.errorStateView,
          loadingStateView: (O = e.groupsConfiguration) == null ? void 0 : O.loadingStateView,
          titleAlignment: (x = e.groupsConfiguration) == null ? void 0 : x.titleAlignment,
          listItemView: (_ = e.groupsConfiguration) == null ? void 0 : _.listItemView,
          menus: (oe = e.groupsConfiguration) != null && oe.menu || !e.hideCreateGroup ? e.getCreateGroupButton() : void 0,
          hideSeparator: (ie = e.groupsConfiguration) == null ? void 0 : ie.hideSeparator,
          hideError: (re = e.groupsConfiguration) == null ? void 0 : re.hideError,
          selectionMode: (Ae = e.groupsConfiguration) == null ? void 0 : Ae.selectionMode,
          listItemStyle: (se = e.groupsConfiguration) == null ? void 0 : se.listItemStyle
        }, null, 8, ["activeGroup", "hideSearch", "searchIconURL", "searchRequestBuilder", "onItemClick", "groupsStyle", "options", "subtitleView", "privateGroupIcon", "protectedGroupIcon", "groupsRequestBuilder", "emptyStateView", "onSelect", "loadingIconURL", "errorStateView", "loadingStateView", "titleAlignment", "listItemView", "menus", "hideSeparator", "hideError", "selectionMode", "listItemStyle"])
      ], 2), [
        [Xn, !e.isMobileView || !e.currentGroup]
      ]),
      (e.currentUser || e.currentGroup) && !e.openPasswordModal ? (M(), g("div", {
        key: 0,
        class: _n(["cc-withmessages__main", { mobile: e.isMobileView }])
      }, [
        Nt(u, {
          "v-show": !e.isMobileView,
          user: e.currentUser,
          group: e.currentGroup,
          messageHeaderConfiguration: (X = e.messagesConfig) == null ? void 0 : X.messageHeaderConfiguration,
          messageListConfiguration: (B = e.messagesConfig) == null ? void 0 : B.messageListConfiguration,
          messageComposerConfiguration: (F = e.messagesConfig) == null ? void 0 : F.messageComposerConfiguration,
          messagesStyle: (G = e.messagesConfig) == null ? void 0 : G.messagesStyle,
          customSoundForIncomingMessages: (J = e.messagesConfig) == null ? void 0 : J.customSoundForIncomingMessages,
          customSoundForOutgoingMessages: (ee = e.messagesConfig) == null ? void 0 : ee.customSoundForOutgoingMessages,
          detailsConfiguration: (V = e.messagesConfig) == null ? void 0 : V.detailsConfiguration,
          disableSoundForMessages: (ne = e.messagesConfig) == null ? void 0 : ne.disableSoundForMessages,
          disableTyping: (K = e.messagesConfig) == null ? void 0 : K.disableTyping,
          hideMessageComposer: (Ie = e.messagesConfig) == null ? void 0 : Ie.hideMessageComposer,
          hideMessageHeader: (Te = e.messagesConfig) == null ? void 0 : Te.hideMessageHeader,
          messageComposerView: (H = e.messagesConfig) == null ? void 0 : H.messageComposerView,
          messageHeaderView: (Ee = e.messagesConfig) == null ? void 0 : Ee.messageHeaderView,
          messageListView: (L = e.messagesConfig) == null ? void 0 : L.messageListView,
          hideDetails: (b = e.messagesConfig) == null ? void 0 : b.hideDetails,
          threadedMessagesConfiguration: e.messagesConfiguration.threadedMessageConfiguration
        }, null, 8, ["v-show", "user", "group", "messageHeaderConfiguration", "messageListConfiguration", "messageComposerConfiguration", "messagesStyle", "customSoundForIncomingMessages", "customSoundForOutgoingMessages", "detailsConfiguration", "disableSoundForMessages", "disableTyping", "hideMessageComposer", "hideMessageHeader", "messageComposerView", "messageHeaderView", "messageListView", "hideDetails", "threadedMessagesConfiguration"])
      ], 2)) : $("", !0),
      !e.currentGroup && !e.openPasswordModal && !e.currentUser && !e.isMobileView ? (M(), g("div", {
        key: 1,
        class: "cc-decorator-message-empty",
        style: ce(e.emptyMessageStyle())
      }, [
        p("cometchat-label", {
          text: e.messageText,
          labelStyle: e.labelStyle
        }, null, 8, Wj)
      ], 4)) : $("", !0),
      e.openPasswordModal && !e.currentGroup ? (M(), g("div", {
        key: 2,
        class: _n(["cc-withmessages__joingroup", { mobile: e.isMobileView }]),
        style: ce(e.emptyMessageStyle())
      }, [
        p("cometchat-join-group", {
          group: e.protectedGroup,
          joinGroupStyle: e.getJoinGroupStyle(),
          onCcJoingroupJoined: t[0] || (t[0] = (...v) => e.onGroupJoined && e.onGroupJoined(...v)),
          errorCallback: e.joinGroupConfiguration.onError,
          joinClick: e.joinGroupConfiguration.joinClick
        }, [
          p("div", Jj, [
            Nt(s, {
              group: e.protectedGroup,
              subtitleView: e.joinGroupConfiguration.messageHeaderConfiguration.subtitleView,
              disableUsersPresence: e.joinGroupConfiguration.messageHeaderConfiguration.disableUsersPresence,
              protectedGroupIcon: e.joinGroupConfiguration.messageHeaderConfiguration.protectedGroupIcon,
              privateGroupIcon: e.joinGroupConfiguration.messageHeaderConfiguration.privateGroupIcon,
              menu: e.joinGroupConfiguration.messageHeaderConfiguration.menu,
              messageHeaderStyle: e.getMessageHeaderStyle(),
              backButtonIconURL: e.joinGroupConfiguration.messageHeaderConfiguration.backButtonIconURL,
              hideBackButton: e.joinGroupConfiguration.messageHeaderConfiguration.hideBackButton,
              onError: e.joinGroupConfiguration.messageHeaderConfiguration.onError,
              onBack: e.joinGroupConfiguration.messageHeaderConfiguration.onBack || e.closeJoinGroup,
              listItemStyle: e.getListItemStyle(),
              statusIndicatorStyle: e.joinGroupConfiguration.messageHeaderConfiguration.statusIndicatorStyle,
              avatarStyle: e.joinGroupConfiguration.messageHeaderConfiguration.avatarStyle
            }, null, 8, ["group", "subtitleView", "disableUsersPresence", "protectedGroupIcon", "privateGroupIcon", "menu", "messageHeaderStyle", "backButtonIconURL", "hideBackButton", "onError", "onBack", "listItemStyle", "statusIndicatorStyle", "avatarStyle"])
          ])
        ], 40, $j)
      ], 6)) : $("", !0)
    ], 4),
    e.openCreateGroupPage ? (M(), g("cometchat-backdrop", Kj, [
      p("cometchat-create-group", {
        createGroupStyle: e.getCreateGroupStyle(),
        hideCloseButton: e.createGroupConfiguration.hideCloseButton,
        closeButtonIconURL: e.createGroupConfiguration.closeButtonIconURL,
        createClick: e.createGroupConfiguration.createClick,
        closeCallback: e.closeCreateGroup
      }, null, 8, Xj)
    ])) : $("", !0)
  ], 64);
}
const Xz = /* @__PURE__ */ $e(Zj, [["render", qj], ["__scopeId", "data-v-84c0352a"]]), _j = We({
  name: "CometChatUsersWithMessages",
  components: { CometChatMessages: fi, CometChatUsers: ei },
  props: {
    user: { type: Object },
    isMobileView: { type: Boolean, default: !1 },
    messageText: {
      type: String,
      default: () => Y("NO_CHATS_SELECTED")
    },
    usersWithMessagesStyle: {
      type: Object,
      default: () => ({})
    },
    messagesConfiguration: {
      type: Object,
      default: () => new wi({})
    },
    usersConfiguration: {
      type: Object,
      default: () => new pa({})
    },
    onError: {
      type: Function,
      default: (e) => {
        console.log("ON ERROR: ", e);
      }
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    }), n = j({}), o = {
      background: "transparent",
      textFont: "700 22px Inter",
      textColor: t.value.palette.getAccent600()
    }, i, l, r = j(e.messagesConfiguration), u = j(e.user), s = {};
    Zt(() => {
      var R, Q;
      T(), (Q = (R = e.messagesConfiguration) == null ? void 0 : R.messageHeaderConfiguration) != null && Q.onBack || (r.value.messageHeaderConfiguration.onBack = m), d(), y.getLoggedinUser().then((h) => {
        h && (n.value = h);
      }).catch((h) => {
        let O = new y.CometChatException({
          message: h.message
        });
        e.onError(O);
      }), c();
    }), eo(() => {
      c();
    }), un(() => {
      N();
    });
    const c = () => {
      const { messagesConfiguration: R, isMobileView: Q } = e, { messageHeaderConfiguration: h } = R;
      h.hideBackButton = !Q, r.value = { ...R };
    }, d = () => {
      i = En.ccUserBlocked.subscribe(
        (R) => {
          u.value && R.getUid() == u.value.getUid() && (u.value = R);
        }
      ), l = En.ccUserUnblocked.subscribe(
        (R) => {
          u.value && R.getUid() == u.value.getUid() && (u.value = R);
        }
      );
    }, N = () => {
      i == null || i.unsubscribe(), l == null || l.unsubscribe();
    }, T = () => {
      var Q, h;
      s = {
        ...new ji({
          width: "100%",
          height: "100%",
          background: t.value.palette.getBackground(),
          borderRadius: "none",
          border: "none",
          messageTextColor: t.value.palette.getAccent600(),
          messageTextFont: w(t.value.typography.title1)
        }),
        ...e.usersWithMessagesStyle
      }, o.textFont = ((Q = e.usersWithMessagesStyle) == null ? void 0 : Q.messageTextFont) || o.textFont, o.textColor = ((h = e.usersWithMessagesStyle) == null ? void 0 : h.messageTextColor) || o.textColor;
    }, m = () => {
      u.value = null;
    };
    return {
      labelStyle: o,
      onItemClick: (R) => {
        u.value = R;
      },
      emptyMessageStyle: () => {
        var Q, h, O, x, _;
        let R = {
          width: "100%",
          borderRadius: "none",
          border: "none"
        };
        return {
          background: ((Q = e.usersWithMessagesStyle) == null ? void 0 : Q.background) || t.value.palette.getBackground(),
          height: (h = e.usersWithMessagesStyle) == null ? void 0 : h.height,
          width: `calc(${(O = e.usersWithMessagesStyle) == null ? void 0 : O.width} - 280px)` || R.width,
          border: ((x = e.usersWithMessagesStyle) == null ? void 0 : x.border) || R.border,
          borderRadius: ((_ = e.usersWithMessagesStyle) == null ? void 0 : _.borderRadius) || R.borderRadius
        };
      },
      usersWrapperStyles: () => ({
        height: s == null ? void 0 : s.height,
        width: s == null ? void 0 : s.width,
        border: s == null ? void 0 : s.border,
        borderRadius: s == null ? void 0 : s.borderRadius,
        background: (s == null ? void 0 : s.background) || t.value.palette.getBackground()
      }),
      messagesConfig: r,
      currentUser: u,
      getMenu: () => {
        if (e.usersConfiguration.menu)
          return typeof e.usersConfiguration.menu == "string" ? {
            html: e.usersConfiguration.menu
          } : e.usersConfiguration.menu;
      }
    };
  }
});
const eA = ["text", "labelStyle"];
function tA(e, t, n, o, i, l) {
  var s, c, d, N, T, m, A, D, z, k, R, Q, h, O, x, _, oe, ie, re, Ae, se, X, B, F, G, J, ee, V, ne, K, Ie, Te, H;
  const r = Je("CometChatUsers"), u = Je("CometChatMessages");
  return M(), g("div", {
    class: "cc-withmessages-wrapper",
    style: ce(e.usersWrapperStyles())
  }, [
    Kn(p("div", {
      class: _n(["cc-withmessages__sidebar", { mobile: e.isMobileView }])
    }, [
      Nt(r, {
        activeUser: e.currentUser,
        hideSearch: (s = e.usersConfiguration) == null ? void 0 : s.hideSearch,
        searchIconURL: (c = e.usersConfiguration) == null ? void 0 : c.searchIconURL,
        searchRequestBuilder: (d = e.usersConfiguration) == null ? void 0 : d.searchRequestBuilder,
        onItemClick: ((N = e.usersConfiguration) == null ? void 0 : N.onItemClick) || e.onItemClick,
        subtitleView: (T = e.usersConfiguration) == null ? void 0 : T.subtitleView,
        usersRequestBuilder: (m = e.usersConfiguration) == null ? void 0 : m.usersRequestBuilder,
        emptyStateView: (A = e.usersConfiguration) == null ? void 0 : A.emptyStateView,
        onSelect: (D = e.usersConfiguration) == null ? void 0 : D.onSelect,
        loadingIconURL: (z = e.usersConfiguration) == null ? void 0 : z.loadingIconURL,
        errorStateView: (k = e.usersConfiguration) == null ? void 0 : k.errorStateView,
        loadingStateView: (R = e.usersConfiguration) == null ? void 0 : R.loadingStateView,
        titleAlignment: (Q = e.usersConfiguration) == null ? void 0 : Q.titleAlignment,
        showSectionHeader: (h = e.usersConfiguration) == null ? void 0 : h.showSectionHeader,
        listItemView: (O = e.usersConfiguration) == null ? void 0 : O.listItemView,
        menu: e.getMenu(),
        hideSeparator: (x = e.usersConfiguration) == null ? void 0 : x.hideSeparator,
        hideError: (_ = e.usersConfiguration) == null ? void 0 : _.hideError,
        selectionMode: (oe = e.usersConfiguration) == null ? void 0 : oe.selectionMode,
        listItemStyle: (ie = e.usersConfiguration) == null ? void 0 : ie.listItemStyle,
        options: e.usersConfiguration.options ? e.usersConfiguration.options : void 0,
        usersStyle: e.usersConfiguration.usersStyle
      }, null, 8, ["activeUser", "hideSearch", "searchIconURL", "searchRequestBuilder", "onItemClick", "subtitleView", "usersRequestBuilder", "emptyStateView", "onSelect", "loadingIconURL", "errorStateView", "loadingStateView", "titleAlignment", "showSectionHeader", "listItemView", "menu", "hideSeparator", "hideError", "selectionMode", "listItemStyle", "options", "usersStyle"])
    ], 2), [
      [Xn, !e.isMobileView || !e.currentUser]
    ]),
    e.currentUser ? Kn((M(), g("div", {
      key: 0,
      class: _n(["cc-withmessages__main", { mobile: e.isMobileView }])
    }, [
      Nt(u, {
        user: e.currentUser,
        messageHeaderConfiguration: (re = e.messagesConfig) == null ? void 0 : re.messageHeaderConfiguration,
        messageListConfiguration: (Ae = e.messagesConfig) == null ? void 0 : Ae.messageListConfiguration,
        messageComposerConfiguration: (se = e.messagesConfig) == null ? void 0 : se.messageComposerConfiguration,
        messagesStyle: (X = e.messagesConfig) == null ? void 0 : X.messagesStyle,
        customSoundForIncomingMessages: (B = e.messagesConfig) == null ? void 0 : B.customSoundForIncomingMessages,
        customSoundForOutgoingMessages: (F = e.messagesConfig) == null ? void 0 : F.customSoundForOutgoingMessages,
        detailsConfiguration: (G = e.messagesConfig) == null ? void 0 : G.detailsConfiguration,
        disableSoundForMessages: (J = e.messagesConfig) == null ? void 0 : J.disableSoundForMessages,
        disableTyping: (ee = e.messagesConfig) == null ? void 0 : ee.disableTyping,
        hideMessageComposer: (V = e.messagesConfig) == null ? void 0 : V.hideMessageComposer,
        hideMessageHeader: (ne = e.messagesConfig) == null ? void 0 : ne.hideMessageHeader,
        messageComposerView: (K = e.messagesConfig) == null ? void 0 : K.messageComposerView,
        messageHeaderView: (Ie = e.messagesConfig) == null ? void 0 : Ie.messageHeaderView,
        messageListView: (Te = e.messagesConfig) == null ? void 0 : Te.messageListView,
        hideDetails: (H = e.messagesConfig) == null ? void 0 : H.hideDetails,
        threadedMessagesConfiguration: e.messagesConfiguration.threadedMessageConfiguration
      }, null, 8, ["user", "messageHeaderConfiguration", "messageListConfiguration", "messageComposerConfiguration", "messagesStyle", "customSoundForIncomingMessages", "customSoundForOutgoingMessages", "detailsConfiguration", "disableSoundForMessages", "disableTyping", "hideMessageComposer", "hideMessageHeader", "messageComposerView", "messageHeaderView", "messageListView", "hideDetails", "threadedMessagesConfiguration"])
    ], 2)), [
      [Xn, !e.isMobileView || e.currentUser]
    ]) : $("", !0),
    !e.currentUser && !e.isMobileView ? (M(), g("div", {
      key: 1,
      class: "cc-decorator-message-empty",
      style: ce(e.emptyMessageStyle())
    }, [
      p("cometchat-label", {
        text: e.messageText,
        labelStyle: e.labelStyle
      }, null, 8, eA)
    ], 4)) : $("", !0)
  ], 4);
}
const qz = /* @__PURE__ */ $e(_j, [["render", tA], ["__scopeId", "data-v-198b5352"]]);
function Ui(e, t) {
  var o;
  const n = (o = e.getInitiator()) == null ? void 0 : o.getUid();
  return !n || n === (t == null ? void 0 : t.getUid());
}
function ni(e, t) {
  const n = e.getStatus(), o = Ui(e, t);
  if (o && n === I.calls.unanswered)
    return !1;
  const i = [
    I.calls.unanswered,
    I.calls.cancelled,
    I.calls.busy,
    I.calls.rejected
  ];
  return !o && i.includes(n);
}
function Bi(e, t, n = !1) {
  if (!e || !t)
    return "";
  let o = "";
  const i = e.getStatus(), l = Ui(e, t), r = ni(e, t), u = "_";
  if (r)
    o = `MISSED${u}CALL`;
  else
    switch (i) {
      case I.calls.initiated:
        o = l ? `OUTGOING${u}CALL` : `INCOMING${u}CALL`;
        break;
      case I.calls.ongoing:
        o = l ? `ONGOING${u}CALL` : `ONGOING${u}CALL`;
        break;
      case I.calls.ended:
        o = l ? `OUTGOING${u}CALL` : `INCOMING${u}CALL`;
        break;
      case I.calls.unanswered:
        o = l ? `UNANSWERED${u}CALL` : `MISSED${u}CALL`;
        break;
      case I.calls.cancelled:
        o = l ? `CANCELLED${u}CALL` : `MISSED${u}CALL`;
        break;
      case I.calls.rejected:
        o = l ? `REJECTED${u}CALL` : `MISSED${u}CALL`;
        break;
      case I.calls.busy:
        o = l ? `UNANSWERED${u}CALL` : `MISSED${u}CALL`;
        break;
      default:
        o = `INCOMING${u}CALL`;
    }
  return Y(o);
}
function Do(e, t) {
  return e.getInitiator().getUid() === t.getUid() ? e.getReceiver() : e.getInitiator();
}
function Wo(e) {
  const t = Math.floor(e / 60), n = Math.floor(e % 60), o = Math.floor((e - Math.floor(e)) * 60);
  let i = "", l = "", r = "";
  return t > 0 && (i = `${t}h`), n > 0 && (l = `${n}m`), o >= 0 && (r = `${o}s`), `${i} ${l} ${r}`;
}
function nA(e) {
  const t = Math.floor(e / 3600), n = Math.floor(e % 3600 / 60), o = Math.floor(e % 3600 % 60);
  let i = "", l = "", r = "";
  return t > 0 && (i = `${t}h`), n > 0 && (l = `${n}m`), o >= 0 && (r = `${o}s`), `${i} ${l} ${r}`;
}
function oA(e) {
  fetch(e).then((t) => t.blob()).then((t) => {
    const n = URL.createObjectURL(t), o = document.createElement("a");
    o.href = n, o.download = "recording.mp4", document.body.appendChild(o), o.click();
  }).catch((t) => console.error(t));
}
function iA(e, t) {
  return {
    display: "flex",
    color: (t == null ? void 0 : t.callStatusTextColor) || e.palette.getAccent600(),
    font: (t == null ? void 0 : t.callStatusTextFont) || w(e.typography.caption1),
    alignItems: "center",
    gap: "4px"
  };
}
function aA(e, t) {
  return new Kt({
    borderRadius: (t == null ? void 0 : t.borderRadius) || "24px",
    width: (t == null ? void 0 : t.width) || "36px",
    height: (t == null ? void 0 : t.height) || "36px",
    border: (t == null ? void 0 : t.border) || "none",
    backgroundColor: (t == null ? void 0 : t.backgroundColor) || e.palette.getAccent700(),
    nameTextColor: (t == null ? void 0 : t.nameTextColor) || e.palette.getAccent900(),
    backgroundSize: (t == null ? void 0 : t.backgroundSize) || "cover",
    nameTextFont: (t == null ? void 0 : t.nameTextFont) || w(e.typography.subtitle1),
    outerViewBorderWidth: (t == null ? void 0 : t.outerViewBorderWidth) || "",
    outerViewBorderSpacing: (t == null ? void 0 : t.outerViewBorderSpacing) || "",
    outerViewBorderColor: (t == null ? void 0 : t.outerViewBorderColor) || "",
    outerViewBorderRadius: (t == null ? void 0 : t.outerViewBorderRadius) || ""
  });
}
function rA(e, t, n, o) {
  const l = ni(e, o) ? t.palette.getError() : t.palette.getAccent();
  return new _t({
    height: (n == null ? void 0 : n.height) || "50px",
    width: (n == null ? void 0 : n.width) || "100%",
    background: (n == null ? void 0 : n.background) || t.palette.getBackground(),
    activeBackground: (n == null ? void 0 : n.activeBackground) || t.palette.getAccent100(),
    borderRadius: (n == null ? void 0 : n.borderRadius) || "0",
    titleFont: (n == null ? void 0 : n.titleFont) || w(t.typography.title2),
    titleColor: (n == null ? void 0 : n.titleColor) || l,
    border: (n == null ? void 0 : n.border) || "none",
    separatorColor: (n == null ? void 0 : n.separatorColor) || t.palette.getAccent200(),
    hoverBackground: (n == null ? void 0 : n.hoverBackground) || t.palette.getAccent50(),
    padding: (n == null ? void 0 : n.padding) || "0 5px"
  });
}
function lA(e, t) {
  return {
    height: (t == null ? void 0 : t.height) || "100%",
    width: (t == null ? void 0 : t.width) || "100%",
    background: (t == null ? void 0 : t.background) || e.palette.getBackground(),
    borderRadius: (t == null ? void 0 : t.borderRadius) || "0",
    border: (t == null ? void 0 : t.border) || "none"
  };
}
function sA(e, t) {
  return new So({
    height: "100%",
    titleTextFont: t.titleFont || w(e.typography.title1),
    titleTextColor: t.titleColor || e.palette.getAccent(),
    emptyStateTextColor: t.emptyStateTextColor || e.palette.getAccent600(),
    emptyStateTextFont: t.emptyStateTextFont || w(e.typography.caption1),
    errorStateTextColor: t.errorStateTextColor || e.palette.getAccent600(),
    errorStateTextFont: t.errorStateTextFont || w(e.typography.caption1),
    loadingIconTint: t.loadingIconTint || e.palette.getAccent600()
  });
}
function MA(e, t) {
  return {
    textColor: (t == null ? void 0 : t.dateTextColor) || e.palette.getAccent500(),
    textFont: (t == null ? void 0 : t.dateTextFont) || w(e.typography.caption1),
    background: "transparent",
    padding: "0"
  };
}
function uA() {
  return {
    position: "absolute",
    top: "7px",
    right: "12px"
  };
}
function gA(e, t, n, o) {
  let i;
  return ni(e, o) ? i = n.missedCallIconTint || t.palette.getAccent600() : e.getInitiator().getUid() === o.getUid() ? i = n.outgoingCallIconTint || t.palette.getAccent600() : i = n.incomingCallIconTint || t.palette.getAccent600(), {
    height: "18px",
    width: "18px",
    border: "none",
    borderRadius: "0",
    background: "transparent",
    iconTint: i
  };
}
function cA(e, t) {
  return {
    height: "20px",
    width: "20px",
    border: "none",
    borderRadius: "0",
    background: "transparent",
    buttonIconTint: (t == null ? void 0 : t.infoIconTint) || e.palette.getPrimary()
  };
}
function Da(e, t) {
  return {
    textFont: (t == null ? void 0 : t.dateSeparatorTextFont) || w(e.typography.text2),
    textColor: (t == null ? void 0 : t.dateSeparatorTextColor) || e.palette.getAccent700(),
    background: "transparent",
    padding: "0"
  };
}
const dA = We({
  name: "CometChatCallLogs",
  components: { CometChatList: hn, CometChatOutgoingCall: er, CometChatOngoingCall: _o },
  props: {
    title: {
      type: String,
      default: Y("CALLS")
    },
    titleAlignment: {
      type: Number,
      default: kn.left
    },
    listItemView: {
      type: Function
    },
    subtitleView: {
      type: Function
    },
    tailView: {
      type: Function
    },
    emptyStateView: {
      type: Object
    },
    emptyStateText: {
      type: String,
      default: Y("NO_CALLS_FOUND")
    },
    errorStateText: {
      type: String,
      default: () => Y("SOMETHING_WRONG")
    },
    errorStateView: {
      type: Object
    },
    loadingIconURL: {
      type: String,
      default: nn
    },
    loadingStateView: {
      type: Object
    },
    callLogRequestBuilder: {
      type: Object
    },
    onItemClick: {
      type: Function
    },
    onError: {
      type: Function,
      default: () => {
      }
    },
    listItemStyle: {
      type: Object,
      default: () => ({})
    },
    activeCall: {
      type: Object,
      default: null
    },
    infoIconUrl: {
      type: String,
      default: hi
    },
    onInfoClick: {
      type: Function
    },
    datePattern: {
      type: Number,
      default: yn.time
    },
    dateSeparatorPattern: {
      type: Number,
      default: yn.DayDate
    },
    incomingAudioCallIconUrl: {
      type: String,
      default: Zl
    },
    incomingVideoCallIconUrl: {
      type: String,
      default: Wl
    },
    outgoingAudioCallIconUrl: {
      type: String,
      default: ql
    },
    outgoingVideoCallIconUrl: {
      type: String,
      default: _l
    },
    missedAudioCallIconUrl: {
      type: String,
      default: Kl
    },
    missedVideoCallIconUrl: {
      type: String,
      default: Xl
    },
    callLogsStyle: {
      type: Object,
      default: () => ({})
    },
    avatarStyle: {
      type: Object,
      default: () => ({})
    },
    hideSeparator: {
      type: Boolean,
      default: !0
    },
    outgoingCallConfiguration: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    });
    const n = j([]), o = j(null), i = j(null), l = j(ge.loading), r = j(!1), u = j(null), s = j(null), c = j(!1), d = j(null);
    Zt(() => {
      var F;
      (F = An.getLoggedinUser()) == null || F.then((G) => {
        G ? (o.value = G, i.value = N(), T(), re(), se()) : A(new Error("User not logged in"));
      }).catch((G) => {
        A(G);
      });
    }), un(() => {
      X(), B();
    });
    function N() {
      var F;
      if (e.callLogRequestBuilder)
        return e.callLogRequestBuilder;
      {
        const G = ((F = o.value) == null ? void 0 : F.getAuthToken()) || "";
        return new Ft.CallLogRequestBuilder().setLimit(30).setCallCategory("call").setAuthToken(G).build();
      }
    }
    async function T() {
      try {
        const F = await m();
        F && F.length ? (n.value = [...n.value, ...F], l.value = ge.loaded) : n.value.length === 0 && (l.value = ge.empty);
      } catch (F) {
        n.value.length === 0 && (l.value = ge.error), A(F);
      }
    }
    async function m() {
      try {
        return await i.value.fetchNext();
      } catch (F) {
        return A(F), [];
      }
    }
    function A(F) {
      const G = new y.CometChatException({
        code: "ERROR",
        message: F.message,
        details: F.stack
      });
      e.onError(G);
    }
    const D = () => {
      y.rejectCall(
        u.value.getSessionId(),
        I.calls.cancelled
      ).then(() => {
        r.value = !1, ae.ccMessageSent.next({
          message: u.value,
          status: Xe.success
        }), u.value = void 0;
      }).catch((F) => {
        e.onError && e.onError(F);
      }), r.value = !1;
    }, z = (F, G) => {
      const J = I.MessageReceiverType.user, ee = G;
      let V = "";
      F === y.CALL_TYPE.AUDIO ? V = y.CALL_TYPE.AUDIO : V = y.CALL_TYPE.VIDEO;
      const ne = new y.Call(
        ee,
        V,
        J
      );
      y.initiateCall(ne).then((K) => {
        u.value = K, r.value = !0, ae.ccMessageSent.next({
          message: K,
          status: Xe.inprogress
        });
      }).catch((K) => {
        e.onError && e.onError(K);
      });
    };
    function k(F) {
      if (e.onItemClick)
        e.onItemClick(F);
      else {
        const G = Do(F, o.value);
        G.uid && z(F == null ? void 0 : F.type, G.uid);
      }
    }
    function R(F) {
      e.onInfoClick && e.onInfoClick(F);
    }
    function Q(F) {
      return !!(e.activeCall && e.activeCall.getSessionID() === F.getSessionID());
    }
    function h(F) {
      const G = ni(F, o.value);
      let J = F.getType();
      F.getType() === y.CALL_TYPE.AUDIO ? J = y.CALL_TYPE.AUDIO : J = y.CALL_TYPE.VIDEO;
      let ee;
      return G ? ee = J === y.CALL_TYPE.AUDIO ? e.missedAudioCallIconUrl : e.missedVideoCallIconUrl : Ui(F, o.value) ? ee = J === y.CALL_TYPE.AUDIO ? e.outgoingAudioCallIconUrl : e.outgoingVideoCallIconUrl : ee = J === y.CALL_TYPE.AUDIO ? e.incomingAudioCallIconUrl : e.incomingVideoCallIconUrl, ee;
    }
    const O = (F, G) => {
      var J;
      return G === 0 ? `
            <div
            style=" margin: 5px 0;"
            >
              <cometchat-date
              timestamp=${F.getInitiatedAt()}
              pattern='${e.dateSeparatorPattern}'
              dateStyle='${JSON.stringify(
        Da(t.value, e.callLogsStyle)
      )}''
            ></cometchat-date>
              </div>

      ` : _(
        (J = n.value[G - 1]) == null ? void 0 : J.getInitiatedAt(),
        F.getInitiatedAt()
      ) ? `
          <div
            style=" margin: 5px 0;"
            >
              <cometchat-date
              timestamp=${F.getInitiatedAt()}
              pattern='${e.dateSeparatorPattern}'
              dateStyle='${JSON.stringify(
        Da(t.value, e.callLogsStyle)
      )}''
            ></cometchat-date>
              </div>
            ` : null;
    };
    function x() {
      var F, G, J, ee, V, ne, K, Ie, Te, H, Ee, L, b, v, U, Se, Ue, Re, _e, Z, ke, q, ye, Oe, he, Pe;
      return new Ii({
        background: ((G = (F = e.outgoingCallConfiguration) == null ? void 0 : F.outgoingCallStyle) == null ? void 0 : G.background) || t.value.palette.getBackground(),
        border: ((ee = (J = e.outgoingCallConfiguration) == null ? void 0 : J.outgoingCallStyle) == null ? void 0 : ee.border) || "none",
        borderRadius: ((ne = (V = e.outgoingCallConfiguration) == null ? void 0 : V.outgoingCallStyle) == null ? void 0 : ne.borderRadius) || "8px",
        declineButtonIconBackground: ((Ie = (K = e.outgoingCallConfiguration) == null ? void 0 : K.outgoingCallStyle) == null ? void 0 : Ie.declineButtonIconBackground) || t.value.palette.getError(),
        declineButtonIconTint: ((H = (Te = e.outgoingCallConfiguration) == null ? void 0 : Te.outgoingCallStyle) == null ? void 0 : H.declineButtonIconTint) || t.value.palette.getBackground(),
        declineButtonTextColor: ((L = (Ee = e.outgoingCallConfiguration) == null ? void 0 : Ee.outgoingCallStyle) == null ? void 0 : L.declineButtonTextColor) || t.value.palette.getAccent600(),
        declineButtonTextFont: ((v = (b = e.outgoingCallConfiguration) == null ? void 0 : b.outgoingCallStyle) == null ? void 0 : v.declineButtonTextFont) || w(t.value.typography.caption2),
        height: ((Se = (U = e.outgoingCallConfiguration) == null ? void 0 : U.outgoingCallStyle) == null ? void 0 : Se.height) || "580px",
        width: ((Re = (Ue = e.outgoingCallConfiguration) == null ? void 0 : Ue.outgoingCallStyle) == null ? void 0 : Re.width) || "320px",
        subtitleTextColor: ((Z = (_e = e.outgoingCallConfiguration) == null ? void 0 : _e.outgoingCallStyle) == null ? void 0 : Z.subtitleTextColor) || t.value.palette.getAccent600(),
        subtitleTextFont: ((q = (ke = e.outgoingCallConfiguration) == null ? void 0 : ke.outgoingCallStyle) == null ? void 0 : q.subtitleTextFont) || w(t.value.typography.subtitle1),
        titleTextColor: ((Oe = (ye = e.outgoingCallConfiguration) == null ? void 0 : ye.outgoingCallStyle) == null ? void 0 : Oe.titleTextColor) || t.value.palette.getAccent(),
        titleTextFont: ((Pe = (he = e.outgoingCallConfiguration) == null ? void 0 : he.outgoingCallStyle) == null ? void 0 : Pe.titleTextFont) || w(t.value.typography.heading)
      });
    }
    const _ = (F, G) => {
      let J, ee;
      return J = new Date(F * 1e3), ee = new Date(G * 1e3), J.getDate() !== ee.getDate() || J.getMonth() !== ee.getMonth() || J.getFullYear() !== ee.getFullYear();
    }, oe = (F) => {
      r.value = !1, u.value = u, s.value = F == null ? void 0 : F.getSessionId(), c.value = !0;
    }, ie = j("callLogsScreen_" + (/* @__PURE__ */ new Date()).getTime()), re = () => {
      y.addCallListener(
        ie.value,
        new y.CallListener({
          onOutgoingCallRejected: () => {
            u.value = void 0, r.value = !1;
          },
          onOutgoingCallAccepted: (F) => {
            oe(F);
          }
        })
      );
    }, Ae = () => {
      c.value = !1, s.value = null, u.value = null;
    }, se = () => {
      d.value = Jt.ccCallEnded.subscribe(() => {
        Ae();
      });
    }, X = () => {
      var F;
      (F = d.value) == null || F.unsubscribe();
    }, B = () => {
      y.removeCallListener(ie.value), ie.value = "callLogsScreen_" + (/* @__PURE__ */ new Date()).getTime();
    };
    return {
      callList: n,
      state: l,
      SelectionMode: xt,
      getListItemStyle: rA,
      getAvatarStyle: aA,
      getCallStatusWithType: Bi,
      getSubtitleStyle: iA,
      handleItemClick: k,
      theme: t,
      getCallList: T,
      loggedInUser: o,
      verifyCallUser: Do,
      getButtonContainerStyle: uA,
      handleInfoClick: R,
      getInfoButtonStyle: cA,
      getActiveCall: Q,
      getCallDirectionIcon: h,
      getDirectionIconStyle: gA,
      getContainerStyle: lA,
      getListStyle: sA,
      getCallDateStyle: MA,
      getMessageBubbleDate: O,
      call: u,
      showOutgoingCallscreen: r,
      cancelOutgoingCall: D,
      getOutGoingCallStyle: x,
      showOngoingCall: c,
      sessionId: s,
      CallWorkflow: Ro
    };
  }
}), IA = { key: 0 }, NA = ["v-slot", "v-html"], TA = ["innerHTML"], DA = { key: 2 }, yA = ["innerHTML"], CA = ["title", "avatarURL", "avatarName", "listItemStyle", "avatarStyle", "hideSeparator", "loadingIconURL", "isActive", "onCcListitemClicked"], wA = { slot: "subtitleView" }, jA = ["v-slot", "v-html"], AA = ["innerHTML"], LA = ["iconStyle", "URL"], zA = { slot: "tailView" }, SA = { key: 0 }, pA = ["v-slot", "v-html"], bA = {
  key: 1,
  style: { display: "flex", "align-items": "center", gap: "5px", "margin-right": "5px" }
}, EA = ["dateStyle", "pattern", "timestamp"], hA = ["iconURL", "buttonStyle", "onCcButtonClicked"];
function vA(e, t, n, o, i, l) {
  var c, d, N, T, m, A, D;
  const r = Je("CometChatOutgoingCall"), u = Je("CometChatOngoingCall"), s = Je("CometChatList");
  return M(), g("div", {
    style: ce(e.getContainerStyle(e.theme, e.callLogsStyle))
  }, [
    e.showOutgoingCallscreen ? (M(), g("cometchat-backdrop", IA, [
      Nt(r, {
        onCloseClicked: ((c = e.outgoingCallConfiguration) == null ? void 0 : c.onDeclineButtonClicked) || e.cancelOutgoingCall,
        outgoingCallStyle: e.getOutGoingCallStyle(),
        call: e.call,
        avatarStyle: (d = e.outgoingCallConfiguration) == null ? void 0 : d.avatarStyle,
        customSoundForCalls: (N = e.outgoingCallConfiguration) == null ? void 0 : N.customSoundForCalls,
        customView: (T = e.outgoingCallConfiguration) == null ? void 0 : T.customView,
        declineButtonIconURL: (m = e.outgoingCallConfiguration) == null ? void 0 : m.declineButtonIconURL,
        disableSoundForCalls: (A = e.outgoingCallConfiguration) == null ? void 0 : A.disableSoundForCalls,
        onError: (D = e.outgoingCallConfiguration) == null ? void 0 : D.onError
      }, null, 8, ["onCloseClicked", "outgoingCallStyle", "call", "avatarStyle", "customSoundForCalls", "customView", "declineButtonIconURL", "disableSoundForCalls", "onError"])
    ])) : $("", !0),
    e.showOngoingCall && !e.activeCall ? (M(), je(u, {
      key: 1,
      sessionID: e.sessionId,
      callWorkflow: e.CallWorkflow.defaultCalling
    }, null, 8, ["sessionID", "callWorkflow"])) : $("", !0),
    Nt(s, {
      hideSearch: !0,
      list: e.callList,
      onScrolledToBottom: e.getCallList,
      listItemKey: "getSessionID",
      title: e.title,
      loadingIconURL: e.loadingIconURL,
      titleAlignment: e.titleAlignment,
      loadingStateView: e.loadingStateView,
      emptyStateText: e.emptyStateText,
      emptyStateView: e.emptyStateView,
      errorStateText: e.errorStateText,
      errorStateView: e.errorStateView,
      listStyle: e.getListStyle(e.theme, e.callLogsStyle),
      state: e.state,
      sectionHeaderKey: ""
    }, {
      listItem: be(({ item: z, index: k }) => {
        var R, Q, h, O, x, _, oe, ie, re, Ae, se, X, B, F, G, J, ee, V, ne;
        return [
          e.listItemView && ((R = e.listItemView(z)) != null && R.componentName) ? (M(), je(fe(e.listItemView && ((Q = e.listItemView(z)) == null ? void 0 : Q.componentName)), me({ key: 0 }, xe(e.listItemView && ((h = e.listItemView(z)) == null ? void 0 : h.listeners)), { ...e.listItemView && ((O = e.listItemView(z)) == null ? void 0 : O.props) }), {
            default: be(() => {
              var K, Ie;
              return [
                (M(!0), g(we, null, pe(e.listItemView && ((Ie = (K = e.listItemView(z)) == null ? void 0 : K.slots) == null ? void 0 : Ie.slots), (Te, H) => (M(), g("div", {
                  key: H,
                  "v-slot": [H],
                  "v-html": Te
                }, null, 8, NA))), 128))
              ];
            }),
            _: 2
          }, 1040)) : e.listItemView && ((x = e.listItemView(z)) != null && x.html) ? (M(), g("div", {
            key: 1,
            innerHTML: e.listItemView && ((_ = e.listItemView(z)) == null ? void 0 : _.html)
          }, null, 8, TA)) : (M(), g("div", DA, [
            p("div", null, [
              p("span", {
                innerHTML: e.getMessageBubbleDate(z, k)
              }, null, 8, yA)
            ]),
            p("cometchat-list-item", {
              title: (oe = e.verifyCallUser(z, e.loggedInUser)) == null ? void 0 : oe.getName(),
              avatarURL: ((ie = e.verifyCallUser(z, e.loggedInUser)) == null ? void 0 : ie.avatar) || ((re = e.verifyCallUser(z, e.loggedInUser)) == null ? void 0 : re.icon),
              avatarName: (Ae = e.verifyCallUser(z, e.loggedInUser)) == null ? void 0 : Ae.getName(),
              listItemStyle: e.getListItemStyle(z, e.theme, e.listItemStyle, e.loggedInUser),
              avatarStyle: e.getAvatarStyle(e.theme, e.avatarStyle),
              hideSeparator: e.hideSeparator,
              loadingIconURL: e.loadingIconURL,
              isActive: e.getActiveCall(z),
              onCcListitemClicked: (K) => e.handleItemClick(z)
            }, [
              p("div", wA, [
                e.subtitleView && ((se = e.subtitleView(z)) != null && se.componentName) ? (M(), je(fe(e.subtitleView && ((X = e.subtitleView(z)) == null ? void 0 : X.componentName)), me({ key: 0 }, xe(e.subtitleView && ((B = e.subtitleView(z)) == null ? void 0 : B.listeners)), { ...e.subtitleView && ((F = e.subtitleView(z)) == null ? void 0 : F.props) }), {
                  default: be(() => {
                    var K, Ie;
                    return [
                      (M(!0), g(we, null, pe(e.subtitleView && ((Ie = (K = e.subtitleView(z)) == null ? void 0 : K.slots) == null ? void 0 : Ie.slots), (Te, H) => (M(), g("div", {
                        key: H,
                        "v-slot": [H],
                        "v-html": Te
                      }, null, 8, jA))), 128))
                    ];
                  }),
                  _: 2
                }, 1040)) : e.subtitleView && ((G = e.subtitleView(z)) != null && G.html) ? (M(), g("div", {
                  key: 1,
                  innerHTML: e.subtitleView && ((J = e.subtitleView(z)) == null ? void 0 : J.html)
                }, null, 8, AA)) : (M(), g("div", {
                  key: 2,
                  style: ce(e.getSubtitleStyle(e.theme, e.callLogsStyle))
                }, [
                  p("cometchat-icon", {
                    iconStyle: e.getDirectionIconStyle(z, e.theme, e.callLogsStyle, e.loggedInUser),
                    URL: e.getCallDirectionIcon(z)
                  }, null, 8, LA),
                  pi(" " + kt(e.getCallStatusWithType(z, e.loggedInUser)), 1)
                ], 4))
              ]),
              p("div", zA, [
                e.tailView ? (M(), g("div", SA, [
                  (M(), je(fe(e.tailView && ((ee = e.tailView(z)) == null ? void 0 : ee.componentName)), me(xe(e.tailView && ((V = e.tailView(z)) == null ? void 0 : V.listeners)), { ...e.tailView && ((ne = e.tailView(z)) == null ? void 0 : ne.props) }), {
                    default: be(() => {
                      var K, Ie;
                      return [
                        (M(!0), g(we, null, pe(e.tailView && ((Ie = (K = e.tailView(z)) == null ? void 0 : K.slots) == null ? void 0 : Ie.slots), (Te, H) => (M(), g("div", {
                          key: H,
                          "v-slot": [H],
                          "v-html": Te
                        }, null, 8, pA))), 128))
                      ];
                    }),
                    _: 2
                  }, 1040))
                ])) : (M(), g("div", bA, [
                  p("cometchat-date", {
                    dateStyle: e.getCallDateStyle(e.theme, e.callLogsStyle),
                    pattern: e.datePattern,
                    timestamp: z == null ? void 0 : z.getInitiatedAt()
                  }, null, 8, EA),
                  e.onInfoClick ? (M(), g("cometchat-button", {
                    key: 0,
                    iconURL: e.infoIconUrl,
                    buttonStyle: e.getInfoButtonStyle(e.theme, e.callLogsStyle),
                    onCcButtonClicked: () => e.handleInfoClick(z)
                  }, null, 40, hA)) : $("", !0)
                ]))
              ])
            ], 40, CA)
          ]))
        ];
      }),
      _: 1
    }, 8, ["list", "onScrolledToBottom", "title", "loadingIconURL", "titleAlignment", "loadingStateView", "emptyStateText", "emptyStateView", "errorStateText", "errorStateView", "listStyle", "state"])
  ], 4);
}
const mA = /* @__PURE__ */ $e(dA, [["render", vA]]);
function OA() {
  return {
    marginRight: "15px"
  };
}
function xA(e, t) {
  return {
    height: "24px",
    width: "24px",
    border: "none",
    borderRadius: "0",
    background: "transparent",
    buttonIconTint: (t == null ? void 0 : t.backIconTint) || e.palette.getPrimary()
  };
}
function kA(e, t) {
  return new So({
    height: "90%",
    titleTextFont: (t == null ? void 0 : t.titleFont) || w(e.typography.title1),
    titleTextColor: (t == null ? void 0 : t.titleColor) || e.palette.getAccent()
  });
}
function fA(e, t) {
  return new Kt({
    borderRadius: (t == null ? void 0 : t.borderRadius) || "24px",
    width: (t == null ? void 0 : t.width) || "36px",
    height: (t == null ? void 0 : t.height) || "36px",
    border: (t == null ? void 0 : t.border) || "none",
    backgroundColor: (t == null ? void 0 : t.backgroundColor) || e.palette.getAccent700(),
    nameTextColor: (t == null ? void 0 : t.nameTextColor) || e.palette.getAccent900(),
    backgroundSize: (t == null ? void 0 : t.backgroundSize) || "cover",
    nameTextFont: (t == null ? void 0 : t.nameTextFont) || w(e.typography.subtitle1),
    outerViewBorderWidth: (t == null ? void 0 : t.outerViewBorderWidth) || "",
    outerViewBorderSpacing: (t == null ? void 0 : t.outerViewBorderSpacing) || "",
    outerViewBorderColor: (t == null ? void 0 : t.outerViewBorderColor) || "",
    outerViewBorderRadius: (t == null ? void 0 : t.outerViewBorderRadius) || ""
  });
}
function UA(e, t) {
  return new _t({
    height: (t == null ? void 0 : t.height) || "45px",
    width: (t == null ? void 0 : t.width) || "100%",
    background: (t == null ? void 0 : t.background) || e.palette.getBackground(),
    activeBackground: (t == null ? void 0 : t.activeBackground) || e.palette.getAccent100(),
    borderRadius: (t == null ? void 0 : t.borderRadius) || "0",
    titleFont: (t == null ? void 0 : t.titleFont) || w(e.typography.title2),
    titleColor: (t == null ? void 0 : t.titleColor) || e.palette.getAccent(),
    border: (t == null ? void 0 : t.border) || "none",
    separatorColor: (t == null ? void 0 : t.separatorColor) || e.palette.getAccent200(),
    hoverBackground: (t == null ? void 0 : t.hoverBackground) || e.palette.getAccent50(),
    padding: (t == null ? void 0 : t.padding) || "0"
  });
}
function BA(e, t) {
  return {
    display: "flex",
    color: (t == null ? void 0 : t.callStatusColor) || e.palette.getAccent600(),
    font: (t == null ? void 0 : t.callStatusFont) || w(e.typography.caption1)
  };
}
function QA(e, t) {
  return {
    textColor: (t == null ? void 0 : t.dateTextColor) || e.palette.getAccent500(),
    textFont: (t == null ? void 0 : t.dateTextFont) || w(e.typography.caption1),
    font: (t == null ? void 0 : t.dateTextFont) || w(e.typography.caption1),
    color: (t == null ? void 0 : t.dateTextColor) || e.palette.getAccent500(),
    background: "transparent",
    padding: "3px 10px"
  };
}
function RA(e, t) {
  return {
    height: (t == null ? void 0 : t.height) || "100%",
    width: (t == null ? void 0 : t.width) || "100%",
    background: (t == null ? void 0 : t.background) || e.palette.getBackground(),
    borderRadius: (t == null ? void 0 : t.borderRadius) || "0",
    border: (t == null ? void 0 : t.border) || "none"
  };
}
function YA(e, t) {
  return {
    font: (t == null ? void 0 : t.titleFont) || w(e.typography.text1),
    color: (t == null ? void 0 : t.titleColor) || e.palette.getAccent(),
    background: "transparent"
  };
}
const VA = We({
  name: "CometChatCallLogParticipants",
  components: { CometChatList: hn },
  props: {
    title: {
      type: String,
      default: () => Y("PARTICIPANTS")
    },
    call: {
      type: Object,
      required: !0
    },
    backIconUrl: {
      type: String,
      default: fn
    },
    onBackClick: {
      type: Function
    },
    avatarStyle: {
      type: Object,
      default: () => ({})
    },
    onItemClick: {
      type: Function
    },
    datePattern: {
      type: Number,
      default: yn.time
    },
    listItemStyle: {
      type: Object,
      default: () => ({})
    },
    callLogParticipantsStyle: {
      type: Object,
      default: () => ({})
    },
    listItemView: {
      type: Function
    },
    subtitleView: {
      type: Function
    },
    tailView: {
      type: Function
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    });
    const n = j(null);
    Zt(() => {
      var s;
      (s = An.getLoggedinUser()) == null || s.then((c) => {
        c && (n.value = c);
      }).catch(() => {
      });
    });
    function o() {
      e.onBackClick && e.onBackClick();
    }
    function i(s) {
      e.onItemClick && e.onItemClick(s);
    }
    function l() {
      var s;
      return (s = e.call) == null ? void 0 : s.getParticipants();
    }
    function r() {
      var s;
      return (s = e.call) == null ? void 0 : s.getInitiatedAt();
    }
    function u(s) {
      return s != null && s.getHasJoined() || s != null && s.getJoinedAt() ? Wo(
        s == null ? void 0 : s.getTotalDurationInMinutes()
      ) : Wo(0);
    }
    return {
      theme: t,
      States: ge,
      handleBackClick: o,
      getButtonContainerStyle: OA,
      getBackButtonStyle: xA,
      getTitleStyle: YA,
      getListStyle: kA,
      getAvatarStyle: fA,
      getListItemStyle: UA,
      handleItemClick: i,
      getSubtitleStyle: BA,
      getCallDateStyle: QA,
      getCallParticipants: l,
      loggedInUser: n,
      getCallInitiatedAt: r,
      getDurationOfCall: u,
      getContainerStyle: RA
    };
  }
}), GA = { style: { display: "flex", padding: "10px 20px", "align-items": "center", "margin-bottom": "10px" } }, PA = ["iconURL", "buttonStyle"], FA = ["v-slot", "v-html"], HA = ["innerHTML"], ZA = ["title", "avatarURL", "avatarName", "listItemStyle", "avatarStyle", "onCcListitemClicked"], WA = { slot: "subtitleView" }, $A = ["v-slot", "v-html"], JA = ["innerHTML"], KA = { slot: "tailView" }, XA = { key: 0 }, qA = ["v-slot", "v-html"], _A = { key: 1 }, eL = { style: { display: "flex", "align-items": "center", gap: "5px" } }, tL = ["dateStyle", "pattern", "timestamp"];
function nL(e, t, n, o, i, l) {
  const r = Je("CometChatList");
  return M(), g("div", {
    style: ce(e.getContainerStyle(e.theme, e.callLogParticipantsStyle))
  }, [
    p("div", GA, [
      e.onBackClick ? (M(), g("div", {
        key: 0,
        style: ce(e.getButtonContainerStyle())
      }, [
        p("cometchat-button", {
          iconURL: e.backIconUrl,
          buttonStyle: e.getBackButtonStyle(e.theme, e.callLogParticipantsStyle),
          onCcButtonClicked: t[0] || (t[0] = (...u) => e.handleBackClick && e.handleBackClick(...u))
        }, null, 40, PA)
      ], 4)) : $("", !0),
      p("div", {
        style: ce(e.getTitleStyle(e.theme, e.callLogParticipantsStyle))
      }, kt(e.title), 5)
    ]),
    Nt(r, {
      hideSearch: !0,
      list: e.getCallParticipants(),
      listItemKey: "getUid",
      listStyle: e.getListStyle(e.theme, e.callLogParticipantsStyle),
      state: e.States.loaded,
      sectionHeaderKey: ""
    }, {
      listItem: be(({ item: u }) => {
        var s, c, d, N, T, m, A, D, z, k, R, Q, h, O, x;
        return [
          e.listItemView && ((s = e.listItemView(u)) != null && s.componentName) ? (M(), je(fe(e.listItemView && ((c = e.listItemView(u)) == null ? void 0 : c.componentName)), me({ key: 0 }, xe(e.listItemView && ((d = e.listItemView(u)) == null ? void 0 : d.listeners)), { ...e.listItemView && ((N = e.listItemView(u)) == null ? void 0 : N.props) }), {
            default: be(() => {
              var _, oe;
              return [
                (M(!0), g(we, null, pe(e.listItemView && ((oe = (_ = e.listItemView(u)) == null ? void 0 : _.slots) == null ? void 0 : oe.slots), (ie, re) => (M(), g("div", {
                  key: re,
                  "v-slot": [re],
                  "v-html": ie
                }, null, 8, FA))), 128))
              ];
            }),
            _: 2
          }, 1040)) : e.listItemView && ((T = e.listItemView(u)) != null && T.html) ? (M(), g("div", {
            key: 1,
            innerHTML: e.listItemView && ((m = e.listItemView(u)) == null ? void 0 : m.html)
          }, null, 8, HA)) : (M(), g("cometchat-list-item", {
            key: 2,
            title: u == null ? void 0 : u.getName(),
            avatarURL: u == null ? void 0 : u.getAvatar(),
            avatarName: u == null ? void 0 : u.getName(),
            listItemStyle: e.getListItemStyle(e.theme, e.listItemStyle),
            avatarStyle: e.getAvatarStyle(e.theme, e.avatarStyle),
            hideSeparator: !0,
            onCcListitemClicked: (_) => e.handleItemClick(u)
          }, [
            p("div", WA, [
              e.subtitleView && ((A = e.subtitleView(u)) != null && A.componentName) ? (M(), je(fe(e.subtitleView && ((D = e.subtitleView(u)) == null ? void 0 : D.componentName)), me({ key: 0 }, xe(e.subtitleView && ((z = e.subtitleView(u)) == null ? void 0 : z.listeners)), { ...e.subtitleView && ((k = e.subtitleView(u)) == null ? void 0 : k.props) }), {
                default: be(() => {
                  var _, oe;
                  return [
                    (M(!0), g(we, null, pe(e.subtitleView && ((oe = (_ = e.subtitleView(u)) == null ? void 0 : _.slots) == null ? void 0 : oe.slots), (ie, re) => (M(), g("div", {
                      key: re,
                      "v-slot": [re],
                      "v-html": ie
                    }, null, 8, $A))), 128))
                  ];
                }),
                _: 2
              }, 1040)) : e.subtitleView && ((R = e.subtitleView(u)) != null && R.html) ? (M(), g("div", {
                key: 1,
                innerHTML: e.subtitleView && ((Q = e.subtitleView(u)) == null ? void 0 : Q.html)
              }, null, 8, JA)) : (M(), g("div", {
                key: 2,
                style: ce(e.getSubtitleStyle(e.theme, e.callLogParticipantsStyle))
              }, kt(e.getDurationOfCall(u)), 5))
            ]),
            p("div", KA, [
              e.tailView ? (M(), g("div", XA, [
                (M(), je(fe(e.tailView && ((h = e.tailView(u)) == null ? void 0 : h.componentName)), me(xe(e.tailView && ((O = e.tailView(u)) == null ? void 0 : O.listeners)), { ...e.tailView && ((x = e.tailView(u)) == null ? void 0 : x.props) }), {
                  default: be(() => {
                    var _, oe;
                    return [
                      (M(!0), g(we, null, pe(e.tailView && ((oe = (_ = e.tailView(u)) == null ? void 0 : _.slots) == null ? void 0 : oe.slots), (ie, re) => (M(), g("div", {
                        key: re,
                        "v-slot": [re],
                        "v-html": ie
                      }, null, 8, qA))), 128))
                    ];
                  }),
                  _: 2
                }, 1040))
              ])) : (M(), g("div", _A, [
                p("div", eL, [
                  p("cometchat-date", {
                    dateStyle: e.getCallDateStyle(e.theme, e.callLogParticipantsStyle),
                    pattern: e.datePattern,
                    timestamp: e.getCallInitiatedAt()
                  }, null, 8, tL)
                ])
              ]))
            ])
          ], 40, ZA))
        ];
      }),
      _: 1
    }, 8, ["list", "listStyle", "state"])
  ], 4);
}
const oL = /* @__PURE__ */ $e(VA, [["render", nL]]);
function iL() {
  return {
    marginRight: "15px"
  };
}
function aL(e, t) {
  return new So({
    height: "90%",
    titleTextFont: (t == null ? void 0 : t.titleFont) || w(e.typography.title1),
    titleTextColor: (t == null ? void 0 : t.titleColor) || e.palette.getAccent()
  });
}
function rL(e, t) {
  return new _t({
    height: (t == null ? void 0 : t.height) || "45px",
    width: (t == null ? void 0 : t.width) || "100%",
    background: (t == null ? void 0 : t.background) || e.palette.getBackground(),
    activeBackground: (t == null ? void 0 : t.activeBackground) || e.palette.getAccent100(),
    borderRadius: (t == null ? void 0 : t.borderRadius) || "0",
    titleFont: (t == null ? void 0 : t.titleFont) || w(e.typography.title2),
    titleColor: (t == null ? void 0 : t.titleColor) || e.palette.getAccent(),
    border: (t == null ? void 0 : t.border) || "none",
    separatorColor: (t == null ? void 0 : t.separatorColor) || e.palette.getAccent200(),
    hoverBackground: (t == null ? void 0 : t.hoverBackground) || e.palette.getAccent50(),
    padding: (t == null ? void 0 : t.padding) || "0"
  });
}
function lL(e, t) {
  return {
    display: "flex",
    color: (t == null ? void 0 : t.recordingDurationColor) || e.palette.getAccent600(),
    font: (t == null ? void 0 : t.recordingDurationFont) || w(e.typography.caption1)
  };
}
function sL(e, t) {
  return {
    textColor: (t == null ? void 0 : t.dateTextColor) || e.palette.getAccent500(),
    textFont: (t == null ? void 0 : t.dateTextFont) || w(e.typography.caption1),
    background: "transparent"
  };
}
function ML(e, t) {
  return {
    height: "24px",
    width: "24px",
    border: "none",
    borderRadius: "0",
    background: "transparent",
    buttonIconTint: (t == null ? void 0 : t.backIconTint) || e.palette.getPrimary()
  };
}
function uL(e, t) {
  return {
    height: "24px",
    width: "24px",
    border: "none",
    borderRadius: "0",
    background: "transparent",
    buttonIconTint: (t == null ? void 0 : t.downloadIconTint) || e.palette.getPrimary()
  };
}
function gL(e, t) {
  return {
    height: (t == null ? void 0 : t.height) || "100%",
    width: (t == null ? void 0 : t.width) || "100%",
    background: (t == null ? void 0 : t.background) || e.palette.getBackground(),
    borderRadius: (t == null ? void 0 : t.borderRadius) || "0",
    border: (t == null ? void 0 : t.border) || "none"
  };
}
function cL(e, t) {
  return {
    font: (t == null ? void 0 : t.titleFont) || w(e.typography.text1),
    color: (t == null ? void 0 : t.titleColor) || e.palette.getAccent(),
    background: "transparent"
  };
}
const dL = We({
  name: "CometChatCallLogRecordings",
  components: { CometChatList: hn },
  props: {
    title: {
      type: String,
      default: () => Y("RECORDING")
    },
    call: {
      type: Object,
      required: !0
    },
    backIconUrl: {
      type: String,
      default: fn
    },
    onBackClick: {
      type: Function
    },
    onItemClick: {
      type: Function
    },
    datePattern: {
      type: Number,
      default: yn.time
    },
    listItemStyle: {
      type: Object,
      default: () => ({})
    },
    callLogRecordingsStyle: {
      type: Object,
      default: () => ({})
    },
    downloadIconUrl: {
      type: String,
      default: Ya
    },
    hideDownloadButton: {
      type: Boolean,
      default: !1
    },
    onDownloadClick: {
      type: Function
    },
    listItemView: {
      type: Function
    },
    subtitleView: {
      type: Function
    },
    tailView: {
      type: Function
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    });
    const n = j(null), o = j(ge.loading);
    Zt(() => {
      var d;
      (d = An.getLoggedinUser()) == null || d.then((N) => {
        N && (n.value = N);
      }).catch(() => {
      });
    });
    function i() {
      e.onBackClick && e.onBackClick();
    }
    function l(d) {
      e.onItemClick && e.onItemClick(d);
    }
    function r() {
      var N;
      const d = (N = e.call) == null ? void 0 : N.getRecordings();
      return d ? (o.value = ge.loaded, d) : (o.value = ge.empty, []);
    }
    function u(d) {
      return d == null ? void 0 : d.getStartTime();
    }
    function s(d) {
      return nA(d == null ? void 0 : d.getDuration());
    }
    function c(d) {
      e.onDownloadClick ? e.onDownloadClick(d) : oA(d == null ? void 0 : d.getRecordingURL());
    }
    return {
      theme: t,
      state: o,
      handleBackClick: i,
      getButtonContainerStyle: iL,
      getBackButtonStyle: ML,
      getTitleStyle: cL,
      getListStyle: aL,
      getListItemStyle: rL,
      handleItemClick: l,
      getSubtitleStyle: lL,
      getCallDateStyle: sL,
      getRecordings: r,
      loggedInUser: n,
      getRecordingStartTime: u,
      getRecordingDuration: s,
      getContainerStyle: gL,
      handleDownloadClick: c,
      getDownloadButtonStyle: uL
    };
  }
}), IL = { style: { display: "flex", padding: "10px 20px", "align-items": "center", "margin-bottom": "10px" } }, NL = ["iconURL", "buttonStyle"], TL = ["v-slot", "v-html"], DL = ["innerHTML"], yL = ["title", "listItemStyle", "onCcListitemClicked"], CL = { slot: "subtitleView" }, wL = ["v-slot", "v-html"], jL = ["innerHTML"], AL = { slot: "tailView" }, LL = { key: 0 }, zL = ["v-slot", "v-html"], SL = {
  key: 1,
  style: { display: "flex", "align-items": "center", gap: "5px" }
}, pL = ["dateStyle", "pattern", "timestamp"], bL = ["iconURL", "buttonStyle", "onCcButtonClicked"];
function EL(e, t, n, o, i, l) {
  const r = Je("CometChatList");
  return M(), g("div", {
    style: ce(e.getContainerStyle(e.theme, e.callLogRecordingsStyle))
  }, [
    p("div", IL, [
      e.onBackClick ? (M(), g("div", {
        key: 0,
        style: ce(e.getButtonContainerStyle())
      }, [
        p("cometchat-button", {
          iconURL: e.backIconUrl,
          buttonStyle: e.getBackButtonStyle(e.theme, e.callLogRecordingsStyle),
          onCcButtonClicked: t[0] || (t[0] = (...u) => e.handleBackClick && e.handleBackClick(...u))
        }, null, 40, NL)
      ], 4)) : $("", !0),
      p("div", {
        style: ce(e.getTitleStyle(e.theme, e.callLogRecordingsStyle))
      }, kt(e.title), 5)
    ]),
    Nt(r, {
      hideSearch: !0,
      list: e.getRecordings(),
      listItemKey: "getUid",
      listStyle: e.getListStyle(e.theme, e.callLogRecordingsStyle),
      state: e.state,
      sectionHeaderKey: ""
    }, {
      listItem: be(({ item: u }) => {
        var s, c, d, N, T, m, A, D, z, k, R, Q, h, O, x;
        return [
          e.listItemView && ((s = e.listItemView(u)) != null && s.componentName) ? (M(), je(fe(e.listItemView && ((c = e.listItemView(u)) == null ? void 0 : c.componentName)), me({ key: 0 }, xe(e.listItemView && ((d = e.listItemView(u)) == null ? void 0 : d.listeners)), { ...e.listItemView && ((N = e.listItemView(u)) == null ? void 0 : N.props) }), {
            default: be(() => {
              var _, oe;
              return [
                (M(!0), g(we, null, pe(e.listItemView && ((oe = (_ = e.listItemView(u)) == null ? void 0 : _.slots) == null ? void 0 : oe.slots), (ie, re) => (M(), g("div", {
                  key: re,
                  "v-slot": [re],
                  "v-html": ie
                }, null, 8, TL))), 128))
              ];
            }),
            _: 2
          }, 1040)) : e.listItemView && ((T = e.listItemView(u)) != null && T.html) ? (M(), g("div", {
            key: 1,
            innerHTML: e.listItemView && ((m = e.listItemView(u)) == null ? void 0 : m.html)
          }, null, 8, DL)) : (M(), g("cometchat-list-item", {
            key: 2,
            title: u == null ? void 0 : u.getRid(),
            listItemStyle: e.getListItemStyle(e.theme, e.listItemStyle),
            hideSeparator: !0,
            onCcListitemClicked: (_) => e.handleItemClick(u)
          }, [
            p("div", CL, [
              e.subtitleView && ((A = e.subtitleView(u)) != null && A.componentName) ? (M(), je(fe(e.subtitleView && ((D = e.subtitleView(u)) == null ? void 0 : D.componentName)), me({ key: 0 }, xe(e.subtitleView && ((z = e.subtitleView(u)) == null ? void 0 : z.listeners)), { ...e.subtitleView && ((k = e.subtitleView(u)) == null ? void 0 : k.props) }), {
                default: be(() => {
                  var _, oe;
                  return [
                    (M(!0), g(we, null, pe(e.subtitleView && ((oe = (_ = e.subtitleView(u)) == null ? void 0 : _.slots) == null ? void 0 : oe.slots), (ie, re) => (M(), g("div", {
                      key: re,
                      "v-slot": [re],
                      "v-html": ie
                    }, null, 8, wL))), 128))
                  ];
                }),
                _: 2
              }, 1040)) : e.subtitleView && ((R = e.subtitleView(u)) != null && R.html) ? (M(), g("div", {
                key: 1,
                innerHTML: e.subtitleView && ((Q = e.subtitleView(u)) == null ? void 0 : Q.html)
              }, null, 8, jL)) : (M(), g("div", {
                key: 2,
                style: ce(e.getSubtitleStyle(e.theme, e.callLogRecordingsStyle))
              }, kt(e.getRecordingDuration(u)), 5))
            ]),
            p("div", AL, [
              e.tailView ? (M(), g("div", LL, [
                (M(), je(fe(e.tailView && ((h = e.tailView(u)) == null ? void 0 : h.componentName)), me(xe(e.tailView && ((O = e.tailView(u)) == null ? void 0 : O.listeners)), { ...e.tailView && ((x = e.tailView(u)) == null ? void 0 : x.props) }), {
                  default: be(() => {
                    var _, oe;
                    return [
                      (M(!0), g(we, null, pe(e.tailView && ((oe = (_ = e.tailView(u)) == null ? void 0 : _.slots) == null ? void 0 : oe.slots), (ie, re) => (M(), g("div", {
                        key: re,
                        "v-slot": [re],
                        "v-html": ie
                      }, null, 8, zL))), 128))
                    ];
                  }),
                  _: 2
                }, 1040))
              ])) : (M(), g("div", SL, [
                p("cometchat-date", {
                  dateStyle: e.getCallDateStyle(e.theme, e.callLogRecordingsStyle),
                  pattern: e.datePattern,
                  timestamp: e.getRecordingStartTime(u)
                }, null, 8, pL),
                e.hideDownloadButton ? $("", !0) : (M(), g("cometchat-button", {
                  key: 0,
                  iconURL: e.downloadIconUrl,
                  buttonStyle: e.getDownloadButtonStyle(e.theme, e.callLogRecordingsStyle),
                  onCcButtonClicked: () => e.handleDownloadClick(u)
                }, null, 40, bL))
              ]))
            ])
          ], 40, yL))
        ];
      }),
      _: 1
    }, 8, ["list", "listStyle", "state"])
  ], 4);
}
const hL = /* @__PURE__ */ $e(dL, [["render", EL]]);
function vL(e, t) {
  return {
    background: "transparent",
    textColor: (t == null ? void 0 : t.dateTextColor) || e.palette.getAccent600(),
    textFont: (t == null ? void 0 : t.dateTextFont) || w(e.typography.subtitle2)
  };
}
function mL(e, t) {
  return new Kt({
    borderRadius: (t == null ? void 0 : t.borderRadius) || "24px",
    width: (t == null ? void 0 : t.width) || "36px",
    height: (t == null ? void 0 : t.height) || "36px",
    border: (t == null ? void 0 : t.border) || "none",
    backgroundColor: (t == null ? void 0 : t.backgroundColor) || e.palette.getAccent700(),
    nameTextColor: (t == null ? void 0 : t.nameTextColor) || e.palette.getAccent900(),
    backgroundSize: (t == null ? void 0 : t.backgroundSize) || "cover",
    nameTextFont: (t == null ? void 0 : t.nameTextFont) || w(e.typography.subtitle1),
    outerViewBorderWidth: (t == null ? void 0 : t.outerViewBorderWidth) || "",
    outerViewBorderSpacing: (t == null ? void 0 : t.outerViewBorderSpacing) || "",
    outerViewBorderColor: (t == null ? void 0 : t.outerViewBorderColor) || "",
    outerViewBorderRadius: (t == null ? void 0 : t.outerViewBorderRadius) || ""
  });
}
function OL(e, t) {
  return new _t({
    height: (t == null ? void 0 : t.height) || "45px",
    width: (t == null ? void 0 : t.width) || "100%",
    background: (t == null ? void 0 : t.background) || e.palette.getBackground(),
    activeBackground: (t == null ? void 0 : t.activeBackground) || e.palette.getAccent100(),
    borderRadius: (t == null ? void 0 : t.borderRadius) || "0",
    border: (t == null ? void 0 : t.border) || "none",
    separatorColor: (t == null ? void 0 : t.separatorColor) || e.palette.getAccent200(),
    hoverBackground: (t == null ? void 0 : t.hoverBackground) || e.palette.getAccent50(),
    padding: (t == null ? void 0 : t.padding) || "0"
  });
}
function xL(e, t) {
  return {
    font: (t == null ? void 0 : t.callStatusTextFont) || w(e.typography.text2),
    color: (t == null ? void 0 : t.callStatusTextColor) || e.palette.getAccent()
  };
}
function kL(e, t) {
  return {
    height: (t == null ? void 0 : t.height) || "100%",
    width: (t == null ? void 0 : t.width) || "100%",
    background: (t == null ? void 0 : t.background) || e.palette.getBackground(),
    borderRadius: (t == null ? void 0 : t.borderRadius) || "0",
    border: (t == null ? void 0 : t.border) || "none"
  };
}
function fL(e, t) {
  return new So({
    height: "90%",
    emptyStateTextColor: (t == null ? void 0 : t.emptyStateTextColor) || e.palette.getAccent600(),
    emptyStateTextFont: (t == null ? void 0 : t.emptyStateTextFont) || w(e.typography.caption1),
    errorStateTextColor: (t == null ? void 0 : t.errorStateTextColor) || e.palette.getAccent600(),
    errorStateTextFont: (t == null ? void 0 : t.errorStateTextFont) || w(e.typography.caption1),
    loadingIconTint: (t == null ? void 0 : t.loadingIconTint) || e.palette.getAccent600()
  });
}
function UL(e, t) {
  return {
    font: (t == null ? void 0 : t.callDurationTextColor) || w(e.typography.caption1),
    color: (t == null ? void 0 : t.callDurationTextColor) || e.palette.getAccent500()
  };
}
function BL() {
  return {
    marginRight: "15px"
  };
}
function QL(e, t) {
  return {
    height: "24px",
    width: "24px",
    border: "none",
    borderRadius: "0",
    background: "transparent",
    buttonIconTint: (t == null ? void 0 : t.backIconTint) || e.palette.getPrimary()
  };
}
function ya(e, t) {
  return {
    textFont: (t == null ? void 0 : t.dateSeparatorTextFont) || w(e.typography.text3),
    textColor: (t == null ? void 0 : t.dateSeparatorTextColor) || e.palette.getAccent700(),
    background: "transparent"
  };
}
function RL(e, t) {
  return {
    height: "1px",
    width: "100%",
    background: (t == null ? void 0 : t.dividerColor) || e.palette.getAccent200()
  };
}
function YL(e, t) {
  return {
    font: (t == null ? void 0 : t.titleFont) || w(e.typography.text1),
    color: (t == null ? void 0 : t.titleColor) || e.palette.getAccent(),
    background: "transparent"
  };
}
const VL = We({
  name: "CometChatCallLogHistory",
  components: { CometChatList: hn },
  props: {
    callUser: {
      type: Object
    },
    callGroup: {
      type: Object
    },
    title: {
      type: String,
      default: () => Y("CALL_HISTORY")
    },
    emptyStateView: {
      type: Object
    },
    emptyStateText: {
      type: String,
      default: () => Y("NO_CALLS_FOUND")
    },
    errorStateText: {
      type: String,
      default: () => Y("SOMETHING_WRONG")
    },
    errorStateView: {
      type: Object
    },
    loadingIconURL: {
      type: String,
      default: nn
    },
    loadingStateView: {
      type: Function
    },
    subtitleView: {
      type: Function
    },
    tailView: {
      type: Function
    },
    callLogRequestBuilder: {
      type: Object
    },
    onItemClick: {
      type: Function
    },
    backIconUrl: {
      type: String,
      default: fn
    },
    onBackClick: {
      type: Function
    },
    listItemStyle: {
      type: Object,
      default: () => ({})
    },
    datePattern: {
      type: Number,
      default: yn.time
    },
    dateSeparatorPattern: {
      type: Number,
      default: yn.DayDate
    },
    callLogHistoryStyle: {
      type: Object,
      default: () => ({})
    },
    onError: {
      type: Function
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    });
    const n = j([]), o = j(null), i = j(null), l = j(ge.loading);
    Zt(() => {
      var D;
      (D = An.getLoggedinUser()) == null || D.then((z) => {
        z ? (o.value = z, i.value = r(), u()) : c(new Error("User not logged in"));
      }).catch((z) => {
        c(z);
      });
    });
    function r() {
      var z, k, R;
      let D;
      if (e.callLogRequestBuilder)
        D = e.callLogRequestBuilder;
      else {
        const Q = ((z = o.value) == null ? void 0 : z.getAuthToken()) || "";
        D = new Ft.CallLogRequestBuilder().setLimit(30).setCallCategory("call").setAuthToken(Q);
      }
      return e.callGroup ? D = D.setGuid((k = e.callGroup) == null ? void 0 : k.getGuid()) : e.callUser && (D = D.setUid((R = e.callUser) == null ? void 0 : R.getUid())), D == null ? void 0 : D.build();
    }
    async function u() {
      try {
        const D = await s();
        D && D.length ? (n.value = [...n.value, ...D], l.value = ge.loaded) : n.value.length === 0 && (l.value = ge.empty);
      } catch (D) {
        n.value.length === 0 && (l.value = ge.error), c(D);
      }
    }
    async function s() {
      try {
        return await i.value.fetchNext();
      } catch (D) {
        return c(D), [];
      }
    }
    function c(D) {
      const z = new y.CometChatException({
        code: "ERROR",
        message: D.message,
        details: D.stack
      });
      e.onError && e.onError(z);
    }
    function d(D) {
      e.onItemClick && e.onItemClick(D);
    }
    function N() {
      e.onBackClick && e.onBackClick();
    }
    const T = (D, z) => {
      var k;
      return z === 0 ? `
                <div
                style="margin: 4px 0 0 8px;"
                >
              <cometchat-date
                timestamp=${D.getInitiatedAt()}
                pattern='${e.dateSeparatorPattern}'
                dateStyle='${JSON.stringify(
        ya(t.value, e.callLogHistoryStyle)
      )}''
              ></cometchat-date>
              </div>
  
        ` : m(
        (k = n.value[z - 1]) == null ? void 0 : k.getInitiatedAt(),
        D.getInitiatedAt()
      ) ? `
                    <cometchat-divider 
                    dividerStyle='${JSON.stringify(
        RL(t.value, e.callLogHistoryStyle)
      )}'
                    ></cometchat-divider> 
                    <div
                    style="margin: 4px 0 0 8px;"
                    >

                  <cometchat-date
                    timestamp=${D.getInitiatedAt()}
                    pattern='${e.dateSeparatorPattern}'
                    dateStyle='${JSON.stringify(
        ya(t.value, e.callLogHistoryStyle)
      )}''
                  ></cometchat-date>
                </div>
              ` : null;
    }, m = (D, z) => {
      let k, R;
      return k = new Date(D * 1e3), R = new Date(z * 1e3), k.getDate() !== R.getDate() || k.getMonth() !== R.getMonth() || k.getFullYear() !== R.getFullYear();
    };
    function A(D) {
      return D != null && D.getTotalDurationInMinutes() ? Wo(
        D == null ? void 0 : D.getTotalDurationInMinutes()
      ) : !1;
    }
    return {
      callList: n,
      state: l,
      SelectionMode: xt,
      getListItemStyle: OL,
      getAvatarStyle: mL,
      getCallStatusWithType: Bi,
      getSubtitleStyle: vL,
      handleItemClick: d,
      theme: t,
      getCallList: u,
      loggedInUser: o,
      verifyCallUser: Do,
      getBackButtonStyle: QL,
      getButtonContainerStyle: BL,
      handleBackClick: N,
      getContainerStyle: kL,
      getListStyle: fL,
      getCallDurationStyle: UL,
      getMessageBubbleDate: T,
      getCallDuration: A,
      getCallStatusStyle: xL,
      getTitleStyle: YL
    };
  }
}), GL = { style: { display: "flex", padding: "10px 30px", "align-items": "center", "margin-bottom": "10px" } }, PL = ["iconURL", "buttonStyle"], FL = ["innerHTML"], HL = ["listItemStyle", "loadingIconURL", "onCcListitemClicked"], ZL = { slot: "subtitleView" }, WL = ["v-slot", "v-html"], $L = ["innerHTML"], JL = {
  key: 2,
  style: { display: "flex" }
}, KL = ["dateStyle", "pattern", "timestamp"], XL = { key: 0 }, qL = ["v-slot", "v-html"], _L = { key: 1 }, ez = { key: 0 }, tz = { key: 1 };
function nz(e, t, n, o, i, l) {
  const r = Je("CometChatList");
  return M(), g("div", {
    style: ce(e.getContainerStyle(e.theme, e.callLogHistoryStyle))
  }, [
    p("div", GL, [
      e.onBackClick ? (M(), g("div", {
        key: 0,
        style: ce(e.getButtonContainerStyle())
      }, [
        p("cometchat-button", {
          iconURL: e.backIconUrl,
          buttonStyle: e.getBackButtonStyle(e.theme, e.callLogHistoryStyle),
          onCcButtonClicked: t[0] || (t[0] = (...u) => e.handleBackClick && e.handleBackClick(...u))
        }, null, 40, PL)
      ], 4)) : $("", !0),
      p("div", {
        style: ce(e.getTitleStyle(e.theme, e.callLogHistoryStyle))
      }, kt(e.title), 5)
    ]),
    Nt(r, {
      hideSearch: !0,
      list: e.callList,
      onScrolledToBottom: e.getCallList,
      listItemKey: "getSessionID",
      loadingIconURL: e.loadingIconURL,
      loadingStateView: e.loadingStateView,
      emptyStateText: e.emptyStateText,
      emptyStateView: e.emptyStateView,
      errorStateText: e.errorStateText,
      errorStateView: e.errorStateView,
      listStyle: e.getListStyle(e.theme, e.callLogHistoryStyle),
      state: e.state,
      sectionHeaderKey: ""
    }, {
      listItem: be(({ item: u, index: s }) => {
        var c, d, N, T, m, A, D, z, k;
        return [
          p("div", null, [
            p("div", null, [
              p("span", {
                innerHTML: e.getMessageBubbleDate(u, s)
              }, null, 8, FL)
            ]),
            p("cometchat-list-item", {
              listItemStyle: e.getListItemStyle(e.theme, e.listItemStyle),
              hideSeparator: !0,
              loadingIconURL: e.loadingIconURL,
              onCcListitemClicked: (R) => e.handleItemClick(u)
            }, [
              p("div", ZL, [
                e.subtitleView && ((c = e.subtitleView(u)) != null && c.componentName) ? (M(), je(fe(e.subtitleView && ((d = e.subtitleView(u)) == null ? void 0 : d.componentName)), me({ key: 0 }, xe(e.subtitleView && ((N = e.subtitleView(u)) == null ? void 0 : N.listeners)), { ...e.subtitleView && ((T = e.subtitleView(u)) == null ? void 0 : T.props) }), {
                  default: be(() => {
                    var R, Q;
                    return [
                      (M(!0), g(we, null, pe(e.subtitleView && ((Q = (R = e.subtitleView(u)) == null ? void 0 : R.slots) == null ? void 0 : Q.slots), (h, O) => (M(), g("div", {
                        key: O,
                        "v-slot": [O],
                        "v-html": h
                      }, null, 8, WL))), 128))
                    ];
                  }),
                  _: 2
                }, 1040)) : e.subtitleView && ((m = e.subtitleView(u)) != null && m.html) ? (M(), g("div", {
                  key: 1,
                  innerHTML: e.subtitleView && ((A = e.subtitleView(u)) == null ? void 0 : A.html)
                }, null, 8, $L)) : (M(), g("div", JL, [
                  p("cometchat-date", {
                    dateStyle: e.getSubtitleStyle(e.theme, e.callLogHistoryStyle),
                    pattern: e.datePattern,
                    timestamp: u == null ? void 0 : u.getInitiatedAt()
                  }, null, 8, KL),
                  p("div", {
                    style: ce(e.getCallStatusStyle(e.theme, e.callLogHistoryStyle))
                  }, kt(e.getCallStatusWithType(u, e.loggedInUser, !0)), 5)
                ]))
              ]),
              p("div", {
                slot: "tailView",
                style: ce(e.getCallDurationStyle(e.theme, e.callLogHistoryStyle))
              }, [
                e.tailView ? (M(), g("div", XL, [
                  (M(), je(fe(e.tailView && ((D = e.tailView(u)) == null ? void 0 : D.componentName)), me(xe(e.tailView && ((z = e.tailView(u)) == null ? void 0 : z.listeners)), { ...e.tailView && ((k = e.tailView(u)) == null ? void 0 : k.props) }), {
                    default: be(() => {
                      var R, Q;
                      return [
                        (M(!0), g(we, null, pe(e.tailView && ((Q = (R = e.tailView(u)) == null ? void 0 : R.slots) == null ? void 0 : Q.slots), (h, O) => (M(), g("div", {
                          key: O,
                          "v-slot": [O],
                          "v-html": h
                        }, null, 8, qL))), 128))
                      ];
                    }),
                    _: 2
                  }, 1040))
                ])) : (M(), g("div", _L, [
                  e.getCallDuration(u) ? (M(), g("div", ez, kt(e.getCallDuration(u)), 1)) : (M(), g("div", tz, "00:00"))
                ]))
              ], 4)
            ], 40, HL)
          ])
        ];
      }),
      _: 1
    }, 8, ["list", "onScrolledToBottom", "loadingIconURL", "loadingStateView", "emptyStateText", "emptyStateView", "errorStateText", "errorStateView", "listStyle", "state"])
  ], 4);
}
const oz = /* @__PURE__ */ $e(VL, [["render", nz]]);
class iz {
  static getDefaultCallTemplate(t, n, o) {
    return [
      this.getPrimaryDetailsTemplate(t, n, o),
      this.getSecondaryDetailsTemplate(t, n, o)
    ];
  }
  static getCallButtons(t, n) {
    return {
      componentName: "CometChatCallButtons",
      props: {
        user: t,
        group: n,
        callButtonsStyle: {
          width: "max-content",
          height: "100%",
          border: "none",
          borderRadius: "0",
          background: "transparent",
          buttonPadding: "8px 32px",
          buttonBackground: "RGBA(20, 20, 20, 0.04)",
          buttonBorder: "0 4px",
          buttonBorderRadius: "10px"
        },
        voiceCallIconText: Y("AUDIO_CALL"),
        videoCallIconText: Y("VIDEO_CALL"),
        key: "callbuttons"
      }
    };
  }
  static getPrimaryDetailsTemplate(t, n, o) {
    return new oa({
      id: "callControls",
      hideSectionSeparator: !0,
      options: (l, r) => this.getPrimaryOptions(
        l ?? void 0,
        r ?? void 0,
        t ?? void 0,
        n ?? void 0,
        o ?? void 0
      )
    });
  }
  static getPrimaryOptions(t, n, o, i, l) {
    const r = [];
    return t && r.push(
      new Uo({
        id: "callControls",
        customView: this.getCallButtons(t, n)
      })
    ), r.push(
      new Uo({
        id: "callStatus",
        customView: {
          html: this.generateCallDetailsHTML(
            o,
            o == null ? void 0 : o.getInitiatedAt(),
            i,
            l
          )
        }
      })
    ), r;
  }
  static getSecondaryDetailsTemplate(t, n, o) {
    return new oa({
      id: "callOptions",
      hideSectionSeparator: !0,
      options: () => this.getSecondaryOptions(
        t ?? void 0,
        o ?? void 0
      )
    });
  }
  static getSecondaryOptions(t, n) {
    var u, s;
    const o = [], i = "Participants", l = "Recordings", r = "History";
    if (t != null && t.participants && (t == null ? void 0 : t.participants.length) > 0) {
      const c = (u = (t == null ? void 0 : t.participants) || []) == null ? void 0 : u.length;
      o.push(
        new Uo({
          id: "participants",
          customView: {
            html: this.generateCallOptionsHTML(
              i,
              c,
              n
            )
          }
        })
      );
    }
    if (t != null && t.hasRecording) {
      const c = (s = (t == null ? void 0 : t.getRecordings()) || []) == null ? void 0 : s.length;
      o.push(
        new Uo({
          id: "recordings",
          customView: {
            html: this.generateCallOptionsHTML(
              l,
              c,
              n
            )
          }
        })
      );
    }
    return o.push(
      new Uo({
        id: "callHistory",
        customView: {
          html: this.generateCallOptionsHTML(r, 0, n)
        }
      })
    ), o;
  }
  static generateCallDetailsHTML(t, n, o, i) {
    var d, N, T, m, A, D, z, k, R;
    const l = new _t({
      height: "auto",
      width: "100%",
      background: (d = i == null ? void 0 : i.palette) == null ? void 0 : d.getAccent100(),
      hoverBackground: (N = i == null ? void 0 : i.palette) == null ? void 0 : N.getAccent100(),
      borderRadius: "8px",
      border: "none",
      padding: "10px"
    }), r = new po({
      textColor: (T = i == null ? void 0 : i.palette) == null ? void 0 : T.getAccent600(),
      textFont: w((m = i == null ? void 0 : i.typography) == null ? void 0 : m.text3),
      padding: "0px",
      background: "transparent"
    }), u = new po({
      textColor: (A = i == null ? void 0 : i.palette) == null ? void 0 : A.getAccent600(),
      textFont: w((D = i == null ? void 0 : i.typography) == null ? void 0 : D.subtitle2),
      padding: "0px",
      background: "transparent"
    }), s = Bi(t, o, !0);
    return `
        <div style="margin-top: 25px; margin-bottom: 25px; width: 100%; padding-left: 10px; padding-right: 10px; box-sizing: border-box;">
            <cometchat-list-item hideSeparator="true" listItemStyle='${JSON.stringify(
      l
    )}'>

                <div slot="subtitleView">
                    <div style="display: flex; flex-direction: column; gap: 10px">
                        <cometchat-date 
                            dateStyle='${JSON.stringify(r)}'
                            pattern="${yn.DayDate}" 
                            timestamp="${n}"
                        ></cometchat-date>
                        <div style="display: flex; gap: 5px;">
                            <cometchat-date 
                                dateStyle='${JSON.stringify(u)}'
                                pattern="${yn.time}" 
                                timestamp="${n}"
                            ></cometchat-date>

                            <div style='font:${w(
      (z = i == null ? void 0 : i.typography) == null ? void 0 : z.text2
    )}; color:${i.palette.getAccent()}'>
                                ${s}
                            </div>
                        </div>
                    </div>
                </div>

                <div slot="tailView">
                    <div style='font:${w((k = i == null ? void 0 : i.typography) == null ? void 0 : k.text3)};
                                color: ${(R = i == null ? void 0 : i.palette) == null ? void 0 : R.getAccent600()};margin-right: 15px;
                                margin-top: 15px;'>
                        ${Wo(
      t == null ? void 0 : t.getTotalDurationInMinutes()
    )}
                    </div>
                </div>
            </cometchat-list-item>
        </div>`;
  }
  static generateCallOptionsHTML(t, n, o) {
    var l, r, u, s, c;
    const i = {
      iconHeight: "18px",
      iconWidth: "18px",
      border: "none",
      borderRadius: "0",
      background: "transparent",
      buttonIconTint: o.palette.getAccent600()
    };
    return `
  <div
  style="margin:10px; margin-bottom: 5px; padding: 10px; box-sizing: border-box; background: ${(l = o == null ? void 0 : o.palette) == null ? void 0 : l.getAccent100()}; border-radius: 8px; display: flex; justify-content: space-between; align-items: center; box-sizing: border-box; cursor: pointer"
  >
  <span
  style="font:${w(
      (r = o == null ? void 0 : o.typography) == null ? void 0 : r.text2
    )}; color: ${(u = o == null ? void 0 : o.palette) == null ? void 0 : u.getAccent()};"
  >
  ${t}
  </span>
  <span style="display: flex; align-items: center; gap: 5px; font:${w(
      (s = o == null ? void 0 : o.typography) == null ? void 0 : s.text3
    )}; color: ${(c = o == null ? void 0 : o.palette) == null ? void 0 : c.getAccent600()};">
  ${n > 0 ? n : ""}
  <cometchat-button iconURL="${Ha}" buttonStyle='${JSON.stringify(
      i
    )}'></cometchat-button>
  </span>
  </div>
  `;
  }
}
function az() {
  return {
    height: "auto",
    width: "100%",
    minHeight: "150px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    boxSizing: "border-box",
    gap: "8px"
  };
}
function rz() {
  return {
    position: "absolute",
    top: "15px",
    left: "15px",
    display: "flex",
    gap: "8px",
    justifyContent: "center"
  };
}
function lz(e, t) {
  return {
    height: "24px",
    width: "24px",
    border: "none",
    borderRadius: "0",
    background: "transparent",
    buttonIconTint: (t == null ? void 0 : t.backIconTint) || e.palette.getPrimary()
  };
}
function sz(e, t) {
  return {
    height: (t == null ? void 0 : t.height) || "100%",
    width: (t == null ? void 0 : t.width) || "100%",
    background: (t == null ? void 0 : t.background) || e.palette.getBackground(),
    borderRadius: (t == null ? void 0 : t.borderRadius) || "0",
    border: (t == null ? void 0 : t.border) || "none",
    position: "relative"
  };
}
function Mz(e, t) {
  return {
    font: (t == null ? void 0 : t.titleFont) || w(e.typography.text1),
    color: (t == null ? void 0 : t.titleColor) || e.palette.getAccent(),
    background: "transparent"
  };
}
const uz = We({
  name: "CometChatCallLogDetails",
  components: {
    CometChatCallButtons: tr,
    CometChatCallLogRecordings: hL,
    CometChatCallLogParticipants: oL,
    CometChatCallLogHistory: oz
  },
  props: {
    call: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      default: Y("CALL_DETAIL”")
    },
    backIconUrl: {
      type: String,
      default: fn
    },
    avatarStyle: {
      type: Object,
      default: () => ({})
    },
    onBackClick: {
      type: Function
    },
    data: {
      type: Function
    },
    callLogHistoryConfiguration: {
      type: Object,
      default: () => ({})
    },
    callLogParticipantsConfiguration: {
      type: Object,
      default: () => ({})
    },
    callLogRecordingsConfiguration: {
      type: Object,
      default: () => ({})
    },
    callLogDetailsStyle: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    });
    const n = j(e.call), o = j(null), i = j([]), l = j(!1), r = j(!1), u = j(!1);
    Zt(() => {
      var h;
      (h = An.getLoggedinUser()) == null || h.then((O) => {
        O && (o.value = O, d());
      }).catch(() => {
        console.log("error getting details:");
      });
    }), bn(
      () => e.call,
      (h, O) => {
        h !== O && (d(), u.value = !1, l.value = !1, r.value = !1), n.value = { ...h };
      },
      { deep: !0 }
    );
    function s(h, O) {
      return new Kt({
        height: (O == null ? void 0 : O.height) || "50px",
        width: (O == null ? void 0 : O.width) || "50px"
      });
    }
    function c(h, O) {
      return {
        color: (O == null ? void 0 : O.nameTextColor) || h.palette.getAccent(),
        font: (O == null ? void 0 : O.nameTextFont) || w(h.typography.title1)
      };
    }
    const d = () => {
      var h;
      i.value = (h = e.data) == null ? void 0 : h.call(
        e,
        e.call,
        o.value,
        t.value
      ), (!i.value || !i.value.length) && (i.value = iz.getDefaultCallTemplate(
        e.call,
        o.value,
        t.value
      ));
    }, N = (h) => {
      const { options: O, id: x } = h;
      let _ = [];
      if (O && x != null) {
        const oe = Do(e.call, o.value);
        oe != null && oe.getUid ? _ = O(oe, void 0, x) : _ = O(void 0, oe, x);
      }
      return _;
    };
    function T(h) {
      if (h != null && h.onClick)
        h.onClick(e.call);
      else
        switch (h.id) {
          case "participants":
            l.value = !0;
            break;
          case "recordings":
            r.value = !0;
            break;
          case "callHistory":
            u.value = !0;
            break;
        }
    }
    const m = Ht(() => o.value && !l.value && !r.value && !u.value), A = Ht(() => o.value && l.value && !r.value && !u.value), D = Ht(() => o.value && !l.value && r.value && !u.value), z = Ht(() => o.value && !l.value && !r.value && u.value);
    return {
      theme: t,
      verifyCallUser: Do,
      loggedInUser: o,
      getAvatarStyle: s,
      getAvatarTitleStyle: c,
      templates: i,
      getOptionsForTemplate: N,
      getProfileContainerStyle: az,
      getBackButtonStyle: lz,
      getButtonContainerStyle: rz,
      handleOptionClick: T,
      showDetailsPage: m,
      showParticipantsPage: A,
      showRecordingsPage: D,
      showCallHistoryPage: z,
      handlePageOnBackClick: () => {
        l.value = !1, r.value = !1, u.value = !1;
      },
      getCallUser: () => {
        const h = Do(e.call, o.value);
        if (h != null && h.getUid)
          return h;
      },
      getCallGroup: () => {
        const h = Do(e.call, o.value);
        if (h != null && h.getGuid)
          return h;
      },
      getContainerStyle: sz,
      getTitleStyle: Mz,
      localize: Y
    };
  }
}), gz = { key: 0 }, cz = ["iconURL", "buttonStyle"], dz = ["avatarStyle", "image", "name"], Iz = {
  key: 0,
  class: "cc-call-details__option-content",
  style: { display: "flex", "justify-content": "center", "align-items": "center", width: "100%" }
}, Nz = ["innerHTML", "onClick"], Tz = ["v-slot", "v-html"];
function Dz(e, t, n, o, i, l) {
  var c, d, N;
  const r = Je("CometChatCallLogParticipants"), u = Je("CometChatCallLogRecordings"), s = Je("CometChatCallLogHistory");
  return M(), g("div", {
    style: ce(e.getContainerStyle(e.theme, e.callLogDetailsStyle))
  }, [
    e.showDetailsPage ? (M(), g("div", gz, [
      e.onBackClick ? (M(), g("div", {
        key: 0,
        style: ce(e.getButtonContainerStyle())
      }, [
        p("cometchat-button", {
          iconURL: e.backIconUrl,
          buttonStyle: e.getBackButtonStyle(e.theme, e.callLogDetailsStyle),
          onCcButtonClicked: t[0] || (t[0] = () => e.onBackClick())
        }, null, 40, cz),
        p("div", {
          style: ce(e.getTitleStyle(e.theme, e.callLogDetailsStyle))
        }, kt(e.title), 5)
      ], 4)) : $("", !0),
      p("div", {
        style: ce(e.getProfileContainerStyle())
      }, [
        p("cometchat-avatar", {
          avatarStyle: e.getAvatarStyle(e.theme, e.avatarStyle),
          image: (c = e.verifyCallUser(e.call, e.loggedInUser)) == null ? void 0 : c.avatar,
          name: (d = e.verifyCallUser(e.call, e.loggedInUser)) == null ? void 0 : d.getName()
        }, null, 8, dz),
        p("span", {
          style: ce(e.getAvatarTitleStyle(e.theme, e.callLogDetailsStyle))
        }, kt((N = e.verifyCallUser(e.call, e.loggedInUser)) == null ? void 0 : N.getName()), 5)
      ], 4),
      (M(!0), g(we, null, pe(e.templates, (T, m) => (M(), g("div", { key: m }, [
        (M(!0), g(we, null, pe(e.getOptionsForTemplate(T), (A) => {
          var D;
          return M(), g("div", {
            key: A.id
          }, [
            (M(), g("div", {
              key: A.id,
              style: { width: "100%" },
              class: "cc-call-details__option"
            }, [
              A.customView ? (M(), g("div", Iz, [
                A.customView.html ? (M(), g("div", {
                  key: 0,
                  style: { width: "100%" },
                  innerHTML: A.customView.html,
                  onClick: (z) => e.handleOptionClick(A)
                }, null, 8, Nz)) : (M(), je(fe(A.customView.componentName), me({
                  key: 1,
                  ref_for: !0
                }, { ...A.customView.props }, xe((D = A.customView) == null ? void 0 : D.listeners)), {
                  default: be(() => [
                    (M(!0), g(we, null, pe(A.customView.slots, (z, k) => (M(), g("div", {
                      key: k,
                      "v-slot": [k],
                      "v-html": z
                    }, null, 8, Tz))), 128))
                  ]),
                  _: 2
                }, 1040))
              ])) : $("", !0)
            ]))
          ]);
        }), 128)),
        pi(" " + kt(T.title), 1)
      ]))), 128))
    ])) : $("", !0),
    e.showParticipantsPage ? (M(), je(r, {
      key: 1,
      call: e.call,
      title: e.localize("PARTICIPANTS"),
      backIconUrl: e.callLogParticipantsConfiguration.backIconUrl || e.backIconUrl,
      onBackClick: e.callLogParticipantsConfiguration.onBackClick || e.handlePageOnBackClick,
      avatarStyle: e.callLogParticipantsConfiguration.avatarStyle,
      onItemClick: e.callLogParticipantsConfiguration.onItemClick || null,
      datePattern: e.callLogParticipantsConfiguration.datePattern || null,
      listItemStyle: e.callLogParticipantsConfiguration.listItemStyle || null,
      callLogParticipantsStyle: e.callLogParticipantsConfiguration.callLogParticipantsStyle || null,
      listItemView: e.callLogParticipantsConfiguration.listItemView || null,
      subtitleView: e.callLogParticipantsConfiguration.subtitleView || null,
      tailView: e.callLogParticipantsConfiguration.tailView || null
    }, null, 8, ["call", "title", "backIconUrl", "onBackClick", "avatarStyle", "onItemClick", "datePattern", "listItemStyle", "callLogParticipantsStyle", "listItemView", "subtitleView", "tailView"])) : $("", !0),
    e.showRecordingsPage ? (M(), je(u, {
      key: 2,
      call: e.call,
      title: e.localize("RECORDING"),
      backIconUrl: e.callLogRecordingsConfiguration.backIconUrl || e.backIconUrl,
      onBackClick: e.callLogRecordingsConfiguration.onBackClick || e.handlePageOnBackClick,
      onItemClick: e.callLogRecordingsConfiguration.onItemClick || null,
      datePattern: e.callLogRecordingsConfiguration.datePattern || null,
      listItemStyle: e.callLogRecordingsConfiguration.listItemStyle || null,
      callLogRecordingsStyle: e.callLogRecordingsConfiguration.callLogRecordingsStyle || null,
      downloadIconUrl: e.callLogRecordingsConfiguration.downloadIconUrl || null,
      hideDownloadButton: e.callLogRecordingsConfiguration.hideDownloadButton || !1,
      onDownloadClick: e.callLogRecordingsConfiguration.onDownloadClick || null,
      listItemView: e.callLogRecordingsConfiguration.listItemView || null,
      subtitleView: e.callLogRecordingsConfiguration.subtitleView || null,
      tailView: e.callLogRecordingsConfiguration.tailView || null
    }, null, 8, ["call", "title", "backIconUrl", "onBackClick", "onItemClick", "datePattern", "listItemStyle", "callLogRecordingsStyle", "downloadIconUrl", "hideDownloadButton", "onDownloadClick", "listItemView", "subtitleView", "tailView"])) : $("", !0),
    e.showCallHistoryPage ? (M(), je(s, {
      key: 3,
      callUser: e.getCallUser(),
      callGroup: e.getCallGroup(),
      title: e.localize("CALL_HISTORY"),
      backIconUrl: e.callLogHistoryConfiguration.backIconUrl || e.backIconUrl,
      emptyStateView: e.callLogHistoryConfiguration.emptyStateView || null,
      errorStateView: e.callLogHistoryConfiguration.errorStateView || null,
      loadingIconURL: e.callLogHistoryConfiguration.loadingIconURL || null,
      loadingStateView: e.callLogHistoryConfiguration.loadingStateView || null,
      subtitleView: e.callLogHistoryConfiguration.subtitleView || null,
      tailView: e.callLogHistoryConfiguration.tailView || null,
      callLogRequestBuilder: e.callLogHistoryConfiguration.callLogRequestBuilder || null,
      onItemClick: e.callLogHistoryConfiguration.onItemClick || null,
      onBackClick: e.callLogHistoryConfiguration.onBackClick || e.handlePageOnBackClick,
      listItemStyle: e.callLogHistoryConfiguration.listItemStyle || null,
      datePattern: e.callLogHistoryConfiguration.datePattern || null,
      dateSeparatorPattern: e.callLogHistoryConfiguration.dateSeparatorPattern || null,
      callLogHistoryStyle: e.callLogHistoryConfiguration.callLogHistoryStyle || null,
      onError: e.callLogHistoryConfiguration.onError || null
    }, null, 8, ["callUser", "callGroup", "title", "backIconUrl", "emptyStateView", "errorStateView", "loadingIconURL", "loadingStateView", "subtitleView", "tailView", "callLogRequestBuilder", "onItemClick", "onBackClick", "listItemStyle", "datePattern", "dateSeparatorPattern", "callLogHistoryStyle", "onError"])) : $("", !0)
  ], 4);
}
const yz = /* @__PURE__ */ $e(uz, [["render", Dz]]);
function Cz(e, t) {
  return {
    height: (t == null ? void 0 : t.height) || "100%",
    width: (t == null ? void 0 : t.width) || "100%",
    border: (t == null ? void 0 : t.border) || "none",
    borderRadius: (t == null ? void 0 : t.borderRadius) || "0px",
    background: (t == null ? void 0 : t.background) || e.palette.getBackground(),
    display: "flex",
    boxSizing: "border-box",
    position: "relative"
  };
}
function wz(e, t) {
  return new fa({
    background: "transparent",
    textFont: (t == null ? void 0 : t.messageTextFont) || w(e.typography.heading),
    textColor: (t == null ? void 0 : t.messageTextColor) || e.palette.getAccent700()
  });
}
function jz() {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%"
  };
}
const Az = We({
  name: "CometChatCallLogsWithDetails",
  components: { CometChatCallLogs: mA, CometChatCallLogDetails: yz },
  props: {
    isMobileView: {
      type: Boolean,
      default: !1
    },
    messageText: {
      type: String,
      default: () => Y("NO_CALLS_SELECTED")
    },
    withDetailsStyle: {
      type: Object,
      default: () => ({})
    },
    callLogDetailsConfiguration: {
      type: Object,
      default: () => ({})
    },
    callLogConfiguration: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    let { theme: t } = dt("theme", {
      theme: j(new Ke({}))
    });
    const n = j(null), o = Ht(() => {
      var c, d;
      const s = new gl({});
      return Object.assign(s, e.callLogDetailsConfiguration), s.callLogHistoryConfiguration.onItemClick || (s.callLogHistoryConfiguration.onItemClick = (N) => {
        n.value = N;
      }), s.callLogDetailsStyle = {
        ...s.callLogDetailsStyle,
        border: `1px solid ${(d = (c = t.value) == null ? void 0 : c.palette) == null ? void 0 : d.getAccent100()}`
      }, e.isMobileView && (s.onBackClick = () => {
        n.value = null;
      }), s;
    }), i = Ht(() => {
      var c, d;
      const s = new cl({});
      return Object.assign(s, e.callLogConfiguration), s.callLogsStyle = {
        ...s.callLogsStyle,
        border: `1px solid ${(d = (c = t.value) == null ? void 0 : c.palette) == null ? void 0 : d.getAccent100()}`
      }, s;
    }), l = (s) => {
      n.value = s;
    };
    function r() {
      return e.isMobileView ? {
        width: "100%",
        display: n.value ? "none" : "block"
      } : {
        width: "280px",
        minWidth: "25%"
      };
    }
    function u() {
      return e.isMobileView ? {
        width: "100%",
        display: n.value ? "block" : "none"
      } : {
        width: "calc(100% - 280px)"
      };
    }
    return {
      activeCall: n,
      handleInfoClick: l,
      getCallLogStyle: r,
      getCallDetailStyle: u,
      getContainerStyle: Cz,
      getLabelStyle: wz,
      getEmptyContainerStyle: jz,
      theme: t,
      localize: Y,
      computedCallLogDetailsConfiguration: o,
      computedCallLogConfiguration: i
    };
  }
}), Lz = ["text", "labelStyle"];
function zz(e, t, n, o, i, l) {
  const r = Je("CometChatCallLogs"), u = Je("CometChatCallLogDetails");
  return M(), g("div", {
    style: ce(e.getContainerStyle(e.theme, e.withDetailsStyle))
  }, [
    p("div", {
      style: ce(e.getCallLogStyle())
    }, [
      Nt(r, {
        title: e.localize("CALLS"),
        activeCall: e.activeCall,
        titleAlignment: e.computedCallLogConfiguration.titleAlignment,
        listItemView: e.computedCallLogConfiguration.listItemView,
        subtitleView: e.computedCallLogConfiguration.subtitleView,
        tailView: e.computedCallLogConfiguration.tailView,
        emptyStateView: e.computedCallLogConfiguration.emptyStateView,
        errorStateView: e.computedCallLogConfiguration.errorStateView,
        loadingIconURL: e.computedCallLogConfiguration.loadingIconURL,
        loadingStateView: e.computedCallLogConfiguration.loadingStateView,
        callLogRequestBuilder: e.computedCallLogConfiguration.callLogRequestBuilder,
        onItemClick: e.computedCallLogConfiguration.onItemClick,
        onError: e.computedCallLogConfiguration.onError,
        listItemStyle: e.computedCallLogConfiguration.listItemStyle,
        infoIconUrl: e.computedCallLogConfiguration.infoIconUrl,
        onInfoClick: e.computedCallLogConfiguration.onInfoClick || e.handleInfoClick,
        datePattern: e.computedCallLogConfiguration.datePattern,
        dateSeparatorPattern: e.computedCallLogConfiguration.dateSeparatorPattern,
        incomingAudioCallIconUrl: e.computedCallLogConfiguration.incomingAudioCallIconUrl,
        incomingVideoCallIconUrl: e.computedCallLogConfiguration.incomingVideoCallIconUrl,
        outgoingAudioCallIconUrl: e.computedCallLogConfiguration.outgoingAudioCallIconUrl,
        outgoingVideoCallIconUrl: e.computedCallLogConfiguration.outgoingVideoCallIconUrl,
        missedAudioCallIconUrl: e.computedCallLogConfiguration.missedAudioCallIconUrl,
        missedVideoCallIconUrl: e.computedCallLogConfiguration.missedVideoCallIconUrl,
        callLogsStyle: e.computedCallLogConfiguration.callLogsStyle,
        avatarStyle: e.computedCallLogConfiguration.avatarStyle,
        hideSeparator: e.computedCallLogConfiguration.hideSeparator,
        outgoingCallConfiguration: e.computedCallLogConfiguration.outgoingCallConfiguration
      }, null, 8, ["title", "activeCall", "titleAlignment", "listItemView", "subtitleView", "tailView", "emptyStateView", "errorStateView", "loadingIconURL", "loadingStateView", "callLogRequestBuilder", "onItemClick", "onError", "listItemStyle", "infoIconUrl", "onInfoClick", "datePattern", "dateSeparatorPattern", "incomingAudioCallIconUrl", "incomingVideoCallIconUrl", "outgoingAudioCallIconUrl", "outgoingVideoCallIconUrl", "missedAudioCallIconUrl", "missedVideoCallIconUrl", "callLogsStyle", "avatarStyle", "hideSeparator", "outgoingCallConfiguration"])
    ], 4),
    p("div", {
      style: ce(e.getCallDetailStyle())
    }, [
      e.activeCall ? (M(), je(u, {
        key: 0,
        title: e.localize("CALL_DETAIL"),
        call: e.activeCall,
        "call-details-style": { border: "1px solid #ebebeb" },
        backIconUrl: e.computedCallLogDetailsConfiguration.backIconUrl,
        avatarStyle: e.computedCallLogDetailsConfiguration.avatarStyle,
        onBackClick: e.computedCallLogDetailsConfiguration.onBackClick,
        data: e.computedCallLogDetailsConfiguration.data,
        callLogHistoryConfiguration: e.computedCallLogDetailsConfiguration.callLogHistoryConfiguration,
        callLogParticipantsConfiguration: e.computedCallLogDetailsConfiguration.callLogParticipantsConfiguration,
        callLogRecordingsConfiguration: e.computedCallLogDetailsConfiguration.callLogRecordingsConfiguration,
        callLogDetailsStyle: e.computedCallLogDetailsConfiguration.callLogDetailsStyle
      }, null, 8, ["title", "call", "backIconUrl", "avatarStyle", "onBackClick", "data", "callLogHistoryConfiguration", "callLogParticipantsConfiguration", "callLogRecordingsConfiguration", "callLogDetailsStyle"])) : (M(), g("div", {
        key: 1,
        style: ce(e.getEmptyContainerStyle())
      }, [
        p("cometchat-label", {
          text: e.messageText,
          labelStyle: e.getLabelStyle(e.theme, e.withDetailsStyle)
        }, null, 8, Lz)
      ], 4))
    ], 4)
  ], 4);
}
const _z = /* @__PURE__ */ $e(Az, [["render", zz]]);
export {
  cs as AIAssistBotDecorator,
  ds as AIAssistBotExtension,
  Is as AIConversationStarterDecorator,
  Ns as AIConversationStarterExtension,
  Ts as AIConversationSummaryDecorator,
  Ds as AIConversationSummaryExtension,
  qo as AIExtensionDataSource,
  ys as AISmartRepliesDecorator,
  Cs as AISmartRepliesExtension,
  iS as ActionSheetStyle,
  mz as ActivityIcon,
  fl as AiBotIcon,
  bo as AiEmptyIcon,
  bo as AiErrorIcon,
  Oz as AnimalsIcon,
  Ul as AudioCall2xIcon,
  Ba as AudioCallIcon,
  Bl as AudioIcon,
  aS as AvatarStyle,
  fn as BackIcon,
  rS as BackdropStyle,
  lS as BadgeStyle,
  sS as ButtonGroupStyle,
  ws as CallingExtension,
  Ma as CallingExtensionDecorator,
  MS as CallscreenStyle,
  uS as CardStyle,
  gS as ChangeScopeStyle,
  xz as Chat,
  Ne as ChatConfigurator,
  kz as CheckIcon,
  cS as CheckboxStyle,
  Cn as Close2xIcon,
  Ql as CloseIcon,
  As as CollaborativeDocumentExtension,
  js as CollaborativeDocumentExtensionDecorator,
  zs as CollaborativeWhiteBoardExtension,
  Ls as CollaborativeWhiteBoardExtensionDecorator,
  dS as CometChatActionItem,
  IS as CometChatActionSheet,
  Du as CometChatAddMembers,
  Kc as CometChatAudioBubble,
  NS as CometChatAvatar,
  TS as CometChatBackdrop,
  DS as CometChatBadge,
  Fu as CometChatBannedMembers,
  yS as CometChatButton,
  CS as CometChatButtonGroup,
  tr as CometChatCallButtons,
  yz as CometChatCallLogDetails,
  oz as CometChatCallLogHistory,
  oL as CometChatCallLogParticipants,
  hL as CometChatCallLogRecordings,
  mA as CometChatCallLogs,
  _z as CometChatCallLogsWithDetails,
  wS as CometChatCallscreenWrapper,
  jS as CometChatCard,
  Zc as CometChatCardBubble,
  AS as CometChatChangeScope,
  LS as CometChatCheckbox,
  zS as CometChatConfirmDialog,
  Gj as CometChatContacts,
  SS as CometChatContextMenu,
  bg as CometChatConversations,
  Kz as CometChatConversationsWithMessages,
  pS as CometChatCreateGroup,
  bS as CometChatDate,
  hw as CometChatDetails,
  ES as CometChatDivider,
  hS as CometChatDocumentBubble,
  vS as CometChatDraggable,
  mS as CometChatDropdown,
  OS as CometChatEmoji,
  xS as CometChatEmojiKeyboard,
  ed as CometChatFileBubble,
  Gc as CometChatFormBubble,
  kS as CometChatFullScreenViewer,
  ki as CometChatGroupMembers,
  lr as CometChatGroups,
  Xz as CometChatGroupsWithMessages,
  fS as CometChatIcon,
  US as CometChatIconButton,
  nr as CometChatImageBubble,
  Jz as CometChatIncomingCall,
  BS as CometChatInput,
  QS as CometChatJoinGroup,
  RS as CometChatLabel,
  hn as CometChatList,
  YS as CometChatListItem,
  VS as CometChatLiveReaction,
  GS as CometChatLoader,
  PS as CometChatMediaRecorder,
  FS as CometChatMenuList,
  ti as CometChatMessageBubble,
  ir as CometChatMessageComposer,
  ar as CometChatMessageHeader,
  ON as CometChatMessageInformation,
  HS as CometChatMessageInput,
  or as CometChatMessageList,
  fi as CometChatMessages,
  ZS as CometChatModal,
  _o as CometChatOngoingCall,
  er as CometChatOutgoingCall,
  WS as CometChatPopover,
  $S as CometChatPreview,
  JS as CometChatQuickView,
  KS as CometChatRadioButton,
  XS as CometChatReceipt,
  _d as CometChatSchedulerBubble,
  qS as CometChatSearchInput,
  _S as CometChatSingleSelect,
  ep as CometChatStatusIndicator,
  kj as CometChatTabs,
  Qc as CometChatTextBubble,
  SC as CometChatThreadedMessages,
  JC as CometChatTransferOwnership,
  An as CometChatUIKit,
  ei as CometChatUsers,
  qz as CometChatUsersWithMessages,
  sd as CometChatVideoBubble,
  tp as ConfirmDialogStyle,
  np as ContextMenuStyle,
  Rl as CopyIcon,
  op as CreateGroupStyle,
  ra as CreateIcon,
  $z as DataSource,
  Nn as DataSourceDecorator,
  ip as DateStyle,
  Qa as DeleteIcon,
  Ei as DeliveredIcon,
  ap as DocumentBubbleStyle,
  Ra as DocumentIcon,
  Yl as DownArrowIcon,
  Ya as DownloadIcon,
  rp as DropdownStyle,
  Vl as EditIcon,
  Gl as EmojiIcon,
  lp as EmojiKeyboardStyle,
  sp as Emojis,
  Gn as ExtensionsDataSource,
  Mp as FileBubbleStyle,
  Pl as FileIcon,
  fz as FlagsIcon,
  Uz as FoodIcon,
  up as FullScreenViewerStyle,
  Bz as GridLayoutIcon,
  Qz as Group,
  Fl as HeartIcon,
  gp as IconStyle,
  cp as ImageBubbleStyle,
  Hl as ImageIcon,
  ps as ImageModerationExtension,
  Ss as ImageModerationExtensionDecorator,
  Rz as ImageModerationIcon,
  Zl as IncomingAudioCallIcon,
  Wl as IncomingVideoCallIcon,
  $l as IncreaseSizeIcon,
  hi as InfoIcon,
  gs as InfoSimpleIcon,
  dp as InputStyle,
  Ip as JoinGroupStyle,
  Np as LabelStyle,
  Es as LinkPreviewExtension,
  bs as LinkPreviewExtensionDecorator,
  Tp as ListItemStyle,
  Va as LiveReactionIcon,
  Dp as LoaderStyle,
  nn as LoadingIcon,
  yp as MediaRecorderStyle,
  Cp as MenuListStyle,
  wp as MessageInputStyle,
  vs as MessageTranslationExtension,
  hs as MessageTranslationExtensionDecorator,
  Jl as MicIcon,
  Kl as MissedAudioCallIcon,
  Xl as MissedVideoCallIcon,
  jp as ModalStyle,
  Ga as MoreIcon,
  Yz as MoreIconSmall,
  Vz as ObjectsIcon,
  ql as OutgoingAudioCallIcon,
  _l as OutgoingVideoCallIcon,
  Yo as PasswordGroupIcon,
  vi as PlaceholderImage,
  Pa as PlusIcon,
  Fa as PlusRotatedIcon,
  xs as PollsExtension,
  Os as PollsExtensionDecorator,
  es as PollsIcon,
  Ap as PopoverStyle,
  Lp as PreviewStyle,
  Vo as PrivateGroupIcon,
  zp as QuickViewStyle,
  Sp as RadioButtonStyle,
  ts as ReactionIcon,
  Gz as ReactionOptionIcon,
  mi as ReadIcon,
  pp as ReceiptStyle,
  ns as ReduceSizeIcon,
  Ha as RightArrowIcon,
  Yn as SearchIcon,
  bp as SearchInputStyle,
  yi as SendIcon,
  os as SendMessagePrivatelyIcon,
  Za as SentIcon,
  Ep as SingleSelectStyle,
  fs as SmartReplyExtension,
  ks as SmartReplyExtensionDecorator,
  Pz as SmileysIcon,
  is as StartConversation,
  Wa as StickerIcon,
  Bs as StickersExtension,
  Us as StickersExtensionDecorator,
  as as StopIcon,
  Fz as SymbolsIcon,
  hp as TextBubbleStyle,
  vp as TextInputStyle,
  Rs as TextModeratorExtension,
  Qs as TextModeratorExtensionDecorator,
  $a as ThreadIcon,
  rs as ThreadIndicatorIcon,
  Vs as ThumbnailGenerationExtension,
  Ys as ThumbnailGenerationExtensionDecorator,
  ls as TranslateIcon,
  Hz as TravelIcon,
  Zz as UnsafeIcon,
  Wz as User,
  Ja as VideoCall2xIcon,
  Ka as VideoCallIcon,
  ss as VideoIcon,
  Xa as WaitIcon,
  Oi as WarningIcon,
  la as WhiteboardIcon,
  mp as auxiliaryButtonAlignmentEnum,
  Op as layoutType,
  us as mentions,
  Ms as openThreadArrow
};
